/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 425);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(433);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(459)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(60)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(257);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(488), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(122);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(514);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(518);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(122);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(390);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throws = throws;
exports.assert = assert;
exports.assertDefined = assertDefined;
exports.assertNumber = assertNumber;
exports.validate = validate;

// Throw an error inline, as an expression
function throws(message) {
  for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    data[_key - 1] = arguments[_key];
  }

  if (data.length > 0) {
    if (data.length === 1) {
      data = data[0];
    }
    message += "\n" + JSON.stringify(data, null, 2);
  }
  throw new Error(message || "assertion error");
}
function assert(cond, message) {
  for (var _len2 = arguments.length, data = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    data[_key2 - 2] = arguments[_key2];
  }

  if (!cond) return throws.apply(undefined, [message].concat(data));
  return cond;
}
function assertDefined(value, message) {
  for (var _len3 = arguments.length, data = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    data[_key3 - 2] = arguments[_key3];
  }

  if (value == null) return throws.apply(undefined, [message].concat(data));
  return value;
}
function assertNumber(value0, message) {
  for (var _len4 = arguments.length, data = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    data[_key4 - 2] = arguments[_key4];
  }

  var value = assertDefined.apply(undefined, [value0, message].concat(data));
  if (isNaN(value)) return throws.apply(undefined, [message + " (NaN)"].concat(data));
  return value;
}

/**
 * Similar functionality to assertions, but the intent is different:
 * Assertions are programmer error; if they ever fire, there's a bug.
 * Validation could be bad user input, not necessarily a bug.
 */
function validate(cond, message) {
  assert(!!message, "validation requires an error message");

  for (var _len5 = arguments.length, data = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    data[_key5 - 2] = arguments[_key5];
  }

  return assert.apply(undefined, [cond, message].concat(data));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJ0aHJvd3MiLCJhc3NlcnQiLCJhc3NlcnREZWZpbmVkIiwiYXNzZXJ0TnVtYmVyIiwidmFsaWRhdGUiLCJtZXNzYWdlIiwiZGF0YSIsImxlbmd0aCIsIkpTT04iLCJzdHJpbmdpZnkiLCJFcnJvciIsImNvbmQiLCJ2YWx1ZSIsInZhbHVlMCIsImlzTmFOIl0sIm1hcHBpbmdzIjoiOzs7OztRQUVnQkEsTSxHQUFBQSxNO1FBU0FDLE0sR0FBQUEsTTtRQUlBQyxhLEdBQUFBLGE7UUFRQUMsWSxHQUFBQSxZO1FBZUFDLFEsR0FBQUEsUTs7QUFyQ2hCO0FBQ08sU0FBU0osTUFBVCxDQUFtQkssT0FBbkIsRUFBMEQ7QUFBQSxvQ0FBbkJDLElBQW1CO0FBQW5CQSxRQUFtQjtBQUFBOztBQUMvRCxNQUFJQSxLQUFLQyxNQUFMLEdBQWMsQ0FBbEIsRUFBcUI7QUFDbkIsUUFBSUQsS0FBS0MsTUFBTCxLQUFnQixDQUFwQixFQUF1QjtBQUNyQkQsYUFBT0EsS0FBSyxDQUFMLENBQVA7QUFDRDtBQUNERCxlQUFXLE9BQU9HLEtBQUtDLFNBQUwsQ0FBZUgsSUFBZixFQUFxQixJQUFyQixFQUEyQixDQUEzQixDQUFsQjtBQUNEO0FBQ0QsUUFBTSxJQUFJSSxLQUFKLENBQVVMLFdBQVcsaUJBQXJCLENBQU47QUFDRDtBQUNNLFNBQVNKLE1BQVQsQ0FBbUJVLElBQW5CLEVBQTRCTixPQUE1QixFQUFtRTtBQUFBLHFDQUFuQkMsSUFBbUI7QUFBbkJBLFFBQW1CO0FBQUE7O0FBQ3hFLE1BQUksQ0FBQ0ssSUFBTCxFQUFXLE9BQU9YLHlCQUFPSyxPQUFQLFNBQW1CQyxJQUFuQixFQUFQO0FBQ1gsU0FBT0ssSUFBUDtBQUNEO0FBQ00sU0FBU1QsYUFBVCxDQUNMVSxLQURLLEVBRUxQLE9BRkssRUFJRjtBQUFBLHFDQURBQyxJQUNBO0FBREFBLFFBQ0E7QUFBQTs7QUFDSCxNQUFJTSxTQUFTLElBQWIsRUFBbUIsT0FBT1oseUJBQU9LLE9BQVAsU0FBbUJDLElBQW5CLEVBQVA7QUFDbkIsU0FBT00sS0FBUDtBQUNEO0FBQ00sU0FBU1QsWUFBVCxDQUNMVSxNQURLLEVBRUxSLE9BRkssRUFJRjtBQUFBLHFDQURBQyxJQUNBO0FBREFBLFFBQ0E7QUFBQTs7QUFDSCxNQUFNTSxRQUFRVixnQ0FBY1csTUFBZCxFQUFzQlIsT0FBdEIsU0FBa0NDLElBQWxDLEVBQWQ7QUFDQSxNQUFJUSxNQUFNRixLQUFOLENBQUosRUFBa0IsT0FBT1oseUJBQU9LLFVBQVUsUUFBakIsU0FBOEJDLElBQTlCLEVBQVA7QUFDbEIsU0FBT00sS0FBUDtBQUNEOztBQUVEOzs7OztBQUtPLFNBQVNSLFFBQVQsQ0FBcUJPLElBQXJCLEVBQThCTixPQUE5QixFQUFxRTtBQUMxRUosU0FBTyxDQUFDLENBQUNJLE9BQVQsRUFBa0Isc0NBQWxCOztBQUQwRSxxQ0FBbkJDLElBQW1CO0FBQW5CQSxRQUFtQjtBQUFBOztBQUUxRSxTQUFPTCx5QkFBT1UsSUFBUCxFQUFhTixPQUFiLFNBQXlCQyxJQUF6QixFQUFQO0FBQ0QiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLy8gVGhyb3cgYW4gZXJyb3IgaW5saW5lLCBhcyBhbiBleHByZXNzaW9uXG5leHBvcnQgZnVuY3Rpb24gdGhyb3dzPFQ+KG1lc3NhZ2U6IHN0cmluZywgLi4uZGF0YTogQXJyYXk8Kj4pOiBUIHtcbiAgaWYgKGRhdGEubGVuZ3RoID4gMCkge1xuICAgIGlmIChkYXRhLmxlbmd0aCA9PT0gMSkge1xuICAgICAgZGF0YSA9IGRhdGFbMF1cbiAgICB9XG4gICAgbWVzc2FnZSArPSBcIlxcblwiICsgSlNPTi5zdHJpbmdpZnkoZGF0YSwgbnVsbCwgMilcbiAgfVxuICB0aHJvdyBuZXcgRXJyb3IobWVzc2FnZSB8fCBcImFzc2VydGlvbiBlcnJvclwiKVxufVxuZXhwb3J0IGZ1bmN0aW9uIGFzc2VydDxUPihjb25kOiBULCBtZXNzYWdlOiBzdHJpbmcsIC4uLmRhdGE6IEFycmF5PCo+KTogVCB7XG4gIGlmICghY29uZCkgcmV0dXJuIHRocm93cyhtZXNzYWdlLCAuLi5kYXRhKVxuICByZXR1cm4gY29uZFxufVxuZXhwb3J0IGZ1bmN0aW9uIGFzc2VydERlZmluZWQ8VD4oXG4gIHZhbHVlOiA/VCxcbiAgbWVzc2FnZTogc3RyaW5nLFxuICAuLi5kYXRhOiBBcnJheTwqPlxuKTogVCB7XG4gIGlmICh2YWx1ZSA9PSBudWxsKSByZXR1cm4gdGhyb3dzKG1lc3NhZ2UsIC4uLmRhdGEpXG4gIHJldHVybiB2YWx1ZVxufVxuZXhwb3J0IGZ1bmN0aW9uIGFzc2VydE51bWJlcjxUPihcbiAgdmFsdWUwOiA/VCxcbiAgbWVzc2FnZTogc3RyaW5nLFxuICAuLi5kYXRhOiBBcnJheTwqPlxuKTogVCB7XG4gIGNvbnN0IHZhbHVlID0gYXNzZXJ0RGVmaW5lZCh2YWx1ZTAsIG1lc3NhZ2UsIC4uLmRhdGEpXG4gIGlmIChpc05hTih2YWx1ZSkpIHJldHVybiB0aHJvd3MobWVzc2FnZSArIFwiIChOYU4pXCIsIC4uLmRhdGEpXG4gIHJldHVybiB2YWx1ZVxufVxuXG4vKipcbiAqIFNpbWlsYXIgZnVuY3Rpb25hbGl0eSB0byBhc3NlcnRpb25zLCBidXQgdGhlIGludGVudCBpcyBkaWZmZXJlbnQ6XG4gKiBBc3NlcnRpb25zIGFyZSBwcm9ncmFtbWVyIGVycm9yOyBpZiB0aGV5IGV2ZXIgZmlyZSwgdGhlcmUncyBhIGJ1Zy5cbiAqIFZhbGlkYXRpb24gY291bGQgYmUgYmFkIHVzZXIgaW5wdXQsIG5vdCBuZWNlc3NhcmlseSBhIGJ1Zy5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHZhbGlkYXRlPFQ+KGNvbmQ6IFQsIG1lc3NhZ2U6IHN0cmluZywgLi4uZGF0YTogQXJyYXk8Kj4pOiBUIHtcbiAgYXNzZXJ0KCEhbWVzc2FnZSwgXCJ2YWxpZGF0aW9uIHJlcXVpcmVzIGFuIGVycm9yIG1lc3NhZ2VcIilcbiAgcmV0dXJuIGFzc2VydChjb25kLCBtZXNzYWdlLCAuLi5kYXRhKVxufVxuIl19

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = __webpack_require__(582);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _timestamp = __webpack_require__(583);

Object.keys(_timestamp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _timestamp[key];
    }
  });
});

var _dispatchPromise = __webpack_require__(584);

Object.defineProperty(exports, "dispatchPromise", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dispatchPromise).default;
  }
});
exports.logged = logged;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectWithProps = exports.selectWithProps = function selectWithProps(selector, extraProps) {
  return function (state, props) {
    return selector(state, _extends({}, props, extraProps));
  };
};
function logged() {
  for (var _len = arguments.length, mess = Array(_len), _key = 0; _key < _len; _key++) {
    mess[_key] = arguments[_key];
  }

  // a `=>` function here messes up atom's syntax highlighting for some reason
  return function (val) {
    var _console;

    (_console = console).log.apply(_console, mess.concat([val]));
    return val;
  };
}

// quickly disable a log-wrapper with an x, like with unittests
var xlogged = exports.xlogged = function xlogged() {
  return function (val) {
    return val;
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvdXRpbC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0IiwibG9nZ2VkIiwic2VsZWN0V2l0aFByb3BzIiwic2VsZWN0b3IiLCJleHRyYVByb3BzIiwic3RhdGUiLCJwcm9wcyIsIm1lc3MiLCJ2YWwiLCJsb2ciLCJ4bG9nZ2VkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7Ozs7O29EQUNRQSxPOzs7UUFVUUMsTSxHQUFBQSxNOzs7O0FBUlQsSUFBTUMsNENBQWtCLFNBQWxCQSxlQUFrQixDQUM3QkMsUUFENkIsRUFFN0JDLFVBRjZCLEVBRzFCO0FBQ0gsU0FBTyxVQUFDQyxLQUFELEVBQVdDLEtBQVgsRUFBMkI7QUFDaEMsV0FBT0gsU0FBU0UsS0FBVCxlQUFvQkMsS0FBcEIsRUFBOEJGLFVBQTlCLEVBQVA7QUFDRCxHQUZEO0FBR0QsQ0FQTTtBQVFBLFNBQVNILE1BQVQsR0FBcUM7QUFBQSxvQ0FBbEJNLElBQWtCO0FBQWxCQSxRQUFrQjtBQUFBOztBQUMxQztBQUNBLFNBQU8sVUFBWUMsR0FBWixFQUF1QjtBQUFBOztBQUM1Qix5QkFBUUMsR0FBUixpQkFBZUYsSUFBZixTQUFxQkMsR0FBckI7QUFDQSxXQUFPQSxHQUFQO0FBQ0QsR0FIRDtBQUlEOztBQUVEO0FBQ08sSUFBTUUsNEJBQXlCLFNBQXpCQSxPQUF5QjtBQUFBLFNBQWE7QUFBQSxXQUFPRixHQUFQO0FBQUEsR0FBYjtBQUFBLENBQS9CIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmV4cG9ydCAqIGZyb20gXCIuL3R5cGVzXCJcbmV4cG9ydCAqIGZyb20gXCIuL3RpbWVzdGFtcFwiXG5leHBvcnQge2RlZmF1bHQgYXMgZGlzcGF0Y2hQcm9taXNlfSBmcm9tIFwiLi9kaXNwYXRjaC1wcm9taXNlXCJcblxuZXhwb3J0IGNvbnN0IHNlbGVjdFdpdGhQcm9wcyA9IDxTLCBQOiB7fSwgUDI6IHt9LCBPPihcbiAgc2VsZWN0b3I6IChTLCBQICYgUDIpID0+IE8sXG4gIGV4dHJhUHJvcHM6IFAyLFxuKSA9PiB7XG4gIHJldHVybiAoc3RhdGU6IFMsIHByb3BzOiBQKTogTyA9PiB7XG4gICAgcmV0dXJuIHNlbGVjdG9yKHN0YXRlLCB7Li4ucHJvcHMsIC4uLmV4dHJhUHJvcHN9KVxuICB9XG59XG5leHBvcnQgZnVuY3Rpb24gbG9nZ2VkKC4uLm1lc3M6IEFycmF5PGFueT4pIHtcbiAgLy8gYSBgPT5gIGZ1bmN0aW9uIGhlcmUgbWVzc2VzIHVwIGF0b20ncyBzeW50YXggaGlnaGxpZ2h0aW5nIGZvciBzb21lIHJlYXNvblxuICByZXR1cm4gZnVuY3Rpb248ST4odmFsOiBJKTogSSB7XG4gICAgY29uc29sZS5sb2coLi4ubWVzcywgdmFsKVxuICAgIHJldHVybiB2YWxcbiAgfVxufVxuXG4vLyBxdWlja2x5IGRpc2FibGUgYSBsb2ctd3JhcHBlciB3aXRoIGFuIHgsIGxpa2Ugd2l0aCB1bml0dGVzdHNcbmV4cG9ydCBjb25zdCB4bG9nZ2VkOiB0eXBlb2YgbG9nZ2VkID0gKC4uLm1lc3MpID0+IHZhbCA9PiB2YWxcbiJdfQ==

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirebaseConnectRouter = exports.redux = exports.containers = exports.selectors = exports.createOfflineReducer = exports.createReducer = undefined;

var _selectors = __webpack_require__(22);

Object.defineProperty(exports, "createReducer", {
  enumerable: true,
  get: function get() {
    return _selectors.createReducer;
  }
});
Object.defineProperty(exports, "createOfflineReducer", {
  enumerable: true,
  get: function get() {
    return _selectors.createOfflineReducer;
  }
});

var _selectors2 = _interopRequireDefault(_selectors);

var _containers = __webpack_require__(830);

var containers = _interopRequireWildcard(_containers);

var _firebaseConnect = __webpack_require__(853);

var _redux = __webpack_require__(46);

var redux = _interopRequireWildcard(_redux);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.selectors = _selectors2.default;
exports.containers = containers;
exports.redux = redux;
exports.FirebaseConnectRouter = _firebaseConnect.router;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJjcmVhdGVSZWR1Y2VyIiwiY3JlYXRlT2ZmbGluZVJlZHVjZXIiLCJjb250YWluZXJzIiwicmVkdXgiLCJzZWxlY3RvcnMiLCJGaXJlYmFzZUNvbm5lY3RSb3V0ZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7Ozs7c0JBSVFBLGE7Ozs7OztzQkFBZUMsb0I7Ozs7OztBQUh2Qjs7SUFBWUMsVTs7QUFDWjs7QUFDQTs7SUFBWUMsSzs7Ozs7O1FBRUpDLFM7UUFBV0YsVSxHQUFBQSxVO1FBQVlDLEssR0FBQUEsSztRQUFPRSxxQiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgc2VsZWN0b3JzIGZyb20gXCIuL3NlbGVjdG9yc1wiXG5pbXBvcnQgKiBhcyBjb250YWluZXJzIGZyb20gXCIuL2NvbnRhaW5lcnNcIlxuaW1wb3J0IHtyb3V0ZXIgYXMgRmlyZWJhc2VDb25uZWN0Um91dGVyfSBmcm9tIFwiLi9maXJlYmFzZS1jb25uZWN0XCJcbmltcG9ydCAqIGFzIHJlZHV4IGZyb20gXCIuL3JlZHV4XCJcbmV4cG9ydCB7Y3JlYXRlUmVkdWNlciwgY3JlYXRlT2ZmbGluZVJlZHVjZXJ9IGZyb20gXCIuL3NlbGVjdG9yc1wiXG5leHBvcnQge3NlbGVjdG9ycywgY29udGFpbmVycywgcmVkdXgsIEZpcmViYXNlQ29ubmVjdFJvdXRlcn1cbiJdfQ==

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoadingSpinner__ = __webpack_require__(400);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__LoadingSpinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateTime__ = __webpack_require__(901);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__DateTime__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__DateTime__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlainLink__ = __webpack_require__(903);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__PlainLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Number__ = __webpack_require__(904);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__Number__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__Number__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFoundView__ = __webpack_require__(403);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__NotFoundView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intlMessages__ = __webpack_require__(905);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__intlMessages__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tooltip__ = __webpack_require__(906);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__Tooltip__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__Tooltip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Error__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DumpProps__ = __webpack_require__(907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__DumpProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withAllowed__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_9__withAllowed__["a"]; });


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(562);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(566);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(571);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(185);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(577);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(579);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfflineReducer = exports.createReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// The root reducer and selector. This wires all the other local selectors/
// reducers together so they operate on the root state object. No game logic
// here, just wiring things together.

//import * as CharsByUser from "./firebase/characters-by-user" // see users/root and auth/root


var _appInfo = __webpack_require__(581);

var AppInfo = _interopRequireWildcard(_appInfo);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _authLoaded = __webpack_require__(218);

var AuthLoaded = _interopRequireWildcard(_authLoaded);

var _beta = __webpack_require__(767);

var Beta = _interopRequireWildcard(_beta);

var _characters = __webpack_require__(358);

var Chars2 = _interopRequireWildcard(_characters);

var _clientNow = __webpack_require__(350);

var ClientNow = _interopRequireWildcard(_clientNow);

var _entities = __webpack_require__(813);

var Entities = _interopRequireWildcard(_entities);

var _forms = __webpack_require__(815);

var Forms = _interopRequireWildcard(_forms);

var _flags = __webpack_require__(363);

var Flags = _interopRequireWildcard(_flags);

var _loading = __webpack_require__(819);

var FirebaseLoading = _interopRequireWildcard(_loading);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _options = __webpack_require__(365);

var Options = _interopRequireWildcard(_options);

var _rankings = __webpack_require__(820);

var Rankings = _interopRequireWildcard(_rankings);

var _users = __webpack_require__(217);

var Users = _interopRequireWildcard(_users);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

var _reactReduxFirebase = __webpack_require__(130);

var _redux = __webpack_require__(59);

var _redux2 = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import {entities as legacyEntities} from "../redux/Reducers"

var createReducer = exports.createReducer = function createReducer(extraReducers) {
  return (0, _redux.combineReducers)(_extends({
    firebase: _reactReduxFirebase.firebaseStateReducer,
    firebaseAuthLoaded: AuthLoaded.reducer,
    // TODO: now that legacy's gone, rename me to `entities` (without the 2)
    entities2: Entities.reducer,
    forms: Forms.reducer,
    clientNow: ClientNow.reducer
  }, extraReducers)
  // dammit flowtype, work with me here
  );
};

var createOfflineReducer = exports.createOfflineReducer = function createOfflineReducer(extraReducers) {
  return createReducer(_extends({}, extraReducers, _redux2.offlineReducers));
};

exports.default = {
  achievementTypes: Entities.AchievementTypes,
  appInfo: AppInfo,
  auth: Auth,
  authLoaded: AuthLoaded,
  beta: Beta,
  buyN: Forms.BuyN,
  chars2: Chars2,
  envConfig: Entities.EnvConfig,
  flags: Flags,
  loading: FirebaseLoading,
  now: Now,
  clientNow: ClientNow,
  options: Options,
  rankings: Rankings,
  unitTypes: Entities.UnitTypes,
  users: Users,
  zoneTypes: Entities.ZoneTypes,

  Util: Util,
  dispatchPromise: Util.dispatchPromise,
  Decimal: _decimal2.default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;

var _Toolbar2 = __webpack_require__(879);

var _Toolbar3 = _interopRequireDefault(_Toolbar2);

var _ToolbarGroup2 = __webpack_require__(880);

var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);

var _ToolbarSeparator2 = __webpack_require__(881);

var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);

var _ToolbarTitle2 = __webpack_require__(882);

var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Toolbar = _Toolbar3.default;
exports.ToolbarGroup = _ToolbarGroup3.default;
exports.ToolbarSeparator = _ToolbarSeparator3.default;
exports.ToolbarTitle = _ToolbarTitle3.default;
exports.default = _Toolbar3.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(887);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(398);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(399);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(890);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _Card2 = __webpack_require__(908);

var _Card3 = _interopRequireDefault(_Card2);

var _CardHeader2 = __webpack_require__(911);

var _CardHeader3 = _interopRequireDefault(_CardHeader2);

var _CardTitle2 = __webpack_require__(914);

var _CardTitle3 = _interopRequireDefault(_CardTitle2);

var _CardMedia2 = __webpack_require__(915);

var _CardMedia3 = _interopRequireDefault(_CardMedia2);

var _CardText2 = __webpack_require__(916);

var _CardText3 = _interopRequireDefault(_CardText2);

var _CardActions2 = __webpack_require__(917);

var _CardActions3 = _interopRequireDefault(_CardActions2);

var _CardExpandable2 = __webpack_require__(404);

var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Card = _Card3.default;
exports.CardHeader = _CardHeader3.default;
exports.CardTitle = _CardTitle3.default;
exports.CardMedia = _CardMedia3.default;
exports.CardText = _CardText3.default;
exports.CardActions = _CardActions3.default;
exports.CardExpandable = _CardExpandable3.default;
exports.default = _Card3.default;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__(159);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinceLoaded = exports.lockNow = exports.loaded = exports.now = exports.serverTimeOffset = exports.isEmpty = exports.localState = undefined;
exports.since = since;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _clientNow = __webpack_require__(350);

var ClientNow = _interopRequireWildcard(_clientNow);

var _reselect = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ClientTimestamp = ClientNow.ClientTimestamp;


var path = paths.serverTimeOffset.data;
var localState = exports.localState = (0, _queryStatus.selectPath)(path);
var isEmpty = exports.isEmpty = _queryStatus.selectPath.isEmpty(path);

var serverTimeOffset = exports.serverTimeOffset = (0, _reselect.createSelector)(localState, Util.Duration.wrap);
var clientNow = ClientNow.ofResolution(1000 / 5);

var fixedNow = function fixedNow(state, props) {
  return props.fixedNow != null ? props.fixedNow : undefined;
};
var serverNow = (0, _reselect.createSelector)(clientNow, serverTimeOffset, ClientTimestamp.toServer);

var now = exports.now = function now(s, p) {
  // action uses a fake root-state that's missing serverNow's ingredients.
  // (This improves caching.) That means that here, we have to be careful not to
  // select serverNow until we're sure that fixedNow is missing.
  // So, this won't work: `createSelector(fixedNow, serverNow, ...)`
  var f = fixedNow(s, p);
  return f != null ? f : serverNow(s, p);
};
function since(before) {
  return (0, _reselect.createSelector)(now, before, Util.Duration.since);
}

var loaded = exports.loaded = (0, _reselect.createSelector)(ClientNow.loaded, serverTimeOffset, ClientTimestamp.toServer);
var lockNow = exports.lockNow = function lockNow() {
  return (0, _reselect.createSelector)(ClientNow.lockNow(), serverTimeOffset, ClientTimestamp.toServer);
};
var sinceLoaded = exports.sinceLoaded = (0, _reselect.createSelector)(now, loaded, Util.Duration.since);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2Uvbm93LmpzIl0sIm5hbWVzIjpbInNpbmNlIiwiVXRpbCIsInBhdGhzIiwiQ2xpZW50Tm93IiwiQ2xpZW50VGltZXN0YW1wIiwicGF0aCIsInNlcnZlclRpbWVPZmZzZXQiLCJkYXRhIiwibG9jYWxTdGF0ZSIsImlzRW1wdHkiLCJEdXJhdGlvbiIsIndyYXAiLCJjbGllbnROb3ciLCJvZlJlc29sdXRpb24iLCJmaXhlZE5vdyIsInN0YXRlIiwicHJvcHMiLCJ1bmRlZmluZWQiLCJzZXJ2ZXJOb3ciLCJ0b1NlcnZlciIsIm5vdyIsInMiLCJwIiwiZiIsImJlZm9yZSIsImxvYWRlZCIsImxvY2tOb3ciLCJzaW5jZUxvYWRlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O1FBa0NnQkEsSyxHQUFBQSxLOztBQWpDaEI7O0lBQVlDLEk7O0FBQ1o7O0lBQVlDLEs7O0FBQ1o7O0FBQ0E7O0lBQVlDLFM7O0FBQ1o7Ozs7QUFDQSxJQUFNQyxrQkFBa0JELFVBQVVDLGVBQWxDOzs7QUFFQSxJQUFNQyxPQUFPSCxNQUFNSSxnQkFBTixDQUF1QkMsSUFBcEM7QUFDTyxJQUFNQyxrQ0FBYSw2QkFBV0gsSUFBWCxDQUFuQjtBQUNBLElBQU1JLDRCQUFVLHdCQUFXQSxPQUFYLENBQW1CSixJQUFuQixDQUFoQjs7QUFFQSxJQUFNQyw4Q0FBbUIsOEJBQWVFLFVBQWYsRUFBMkJQLEtBQUtTLFFBQUwsQ0FBY0MsSUFBekMsQ0FBekI7QUFDUCxJQUFNQyxZQUFZVCxVQUFVVSxZQUFWLENBQXVCLE9BQU8sQ0FBOUIsQ0FBbEI7O0FBRUEsSUFBTUMsV0FBVyxTQUFYQSxRQUFXLENBQUNDLEtBQUQsRUFBYUMsS0FBYjtBQUFBLFNBQ2ZBLE1BQU1GLFFBQU4sSUFBa0IsSUFBbEIsR0FBeUJFLE1BQU1GLFFBQS9CLEdBQTBDRyxTQUQzQjtBQUFBLENBQWpCO0FBRUEsSUFBTUMsWUFBWSw4QkFDaEJOLFNBRGdCLEVBRWhCTixnQkFGZ0IsRUFHaEJGLGdCQUFnQmUsUUFIQSxDQUFsQjs7QUFNTyxJQUFNQyxvQkFHUyxTQUhUQSxHQUdTLENBQUNDLENBQUQsRUFBSUMsQ0FBSixFQUFVO0FBQzlCO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsTUFBTUMsSUFBSVQsU0FBU08sQ0FBVCxFQUFZQyxDQUFaLENBQVY7QUFDQSxTQUFPQyxLQUFLLElBQUwsR0FBWUEsQ0FBWixHQUFnQkwsVUFBVUcsQ0FBVixFQUFhQyxDQUFiLENBQXZCO0FBQ0QsQ0FWTTtBQVdBLFNBQVN0QixLQUFULENBQ0x3QixNQURLLEVBRWlDO0FBQ3RDLFNBQU8sOEJBQWVKLEdBQWYsRUFBb0JJLE1BQXBCLEVBQTRCdkIsS0FBS1MsUUFBTCxDQUFjVixLQUExQyxDQUFQO0FBQ0Q7O0FBRU0sSUFBTXlCLDBCQUFTLDhCQUNwQnRCLFVBQVVzQixNQURVLEVBRXBCbkIsZ0JBRm9CLEVBR3BCRixnQkFBZ0JlLFFBSEksQ0FBZjtBQUtBLElBQU1PLDRCQUFVLFNBQVZBLE9BQVU7QUFBQSxTQUNyQiw4QkFDRXZCLFVBQVV1QixPQUFWLEVBREYsRUFFRXBCLGdCQUZGLEVBR0VGLGdCQUFnQmUsUUFIbEIsQ0FEcUI7QUFBQSxDQUFoQjtBQU1BLElBQU1RLG9DQUFjLDhCQUFlUCxHQUFmLEVBQW9CSyxNQUFwQixFQUE0QnhCLEtBQUtTLFFBQUwsQ0FBY1YsS0FBMUMsQ0FBcEIiLCJmaWxlIjoibm93LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCAqIGFzIFV0aWwgZnJvbSBcIi4uL3V0aWxcIlxuaW1wb3J0ICogYXMgcGF0aHMgZnJvbSBcIi4uLy4uL2ZpcmViYXNlLWNvbm5lY3QvcGF0aHNcIlxuaW1wb3J0IHtzZWxlY3RQYXRofSBmcm9tIFwiLi4vLi4vZmlyZWJhc2UtY29ubmVjdC9xdWVyeS1zdGF0dXNcIlxuaW1wb3J0ICogYXMgQ2xpZW50Tm93IGZyb20gXCIuLi9jbGllbnQtbm93XCJcbmltcG9ydCB7Y3JlYXRlU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5jb25zdCBDbGllbnRUaW1lc3RhbXAgPSBDbGllbnROb3cuQ2xpZW50VGltZXN0YW1wXG5cbmNvbnN0IHBhdGggPSBwYXRocy5zZXJ2ZXJUaW1lT2Zmc2V0LmRhdGFcbmV4cG9ydCBjb25zdCBsb2NhbFN0YXRlID0gc2VsZWN0UGF0aChwYXRoKVxuZXhwb3J0IGNvbnN0IGlzRW1wdHkgPSBzZWxlY3RQYXRoLmlzRW1wdHkocGF0aClcblxuZXhwb3J0IGNvbnN0IHNlcnZlclRpbWVPZmZzZXQgPSBjcmVhdGVTZWxlY3Rvcihsb2NhbFN0YXRlLCBVdGlsLkR1cmF0aW9uLndyYXApXG5jb25zdCBjbGllbnROb3cgPSBDbGllbnROb3cub2ZSZXNvbHV0aW9uKDEwMDAgLyA1KVxuXG5jb25zdCBmaXhlZE5vdyA9IChzdGF0ZTogYW55LCBwcm9wczoge2ZpeGVkTm93PzogVXRpbC5UaW1lc3RhbXB9KSA9PlxuICBwcm9wcy5maXhlZE5vdyAhPSBudWxsID8gcHJvcHMuZml4ZWROb3cgOiB1bmRlZmluZWRcbmNvbnN0IHNlcnZlck5vdyA9IGNyZWF0ZVNlbGVjdG9yKFxuICBjbGllbnROb3csXG4gIHNlcnZlclRpbWVPZmZzZXQsXG4gIENsaWVudFRpbWVzdGFtcC50b1NlcnZlcixcbilcblxuZXhwb3J0IGNvbnN0IG5vdzogKFxuICBVdGlsLlJvb3RTdGF0ZSxcbiAge2ZpeGVkTm93PzogVXRpbC5UaW1lc3RhbXB9LFxuKSA9PiBVdGlsLlRpbWVzdGFtcCA9IChzLCBwKSA9PiB7XG4gIC8vIGFjdGlvbiB1c2VzIGEgZmFrZSByb290LXN0YXRlIHRoYXQncyBtaXNzaW5nIHNlcnZlck5vdydzIGluZ3JlZGllbnRzLlxuICAvLyAoVGhpcyBpbXByb3ZlcyBjYWNoaW5nLikgVGhhdCBtZWFucyB0aGF0IGhlcmUsIHdlIGhhdmUgdG8gYmUgY2FyZWZ1bCBub3QgdG9cbiAgLy8gc2VsZWN0IHNlcnZlck5vdyB1bnRpbCB3ZSdyZSBzdXJlIHRoYXQgZml4ZWROb3cgaXMgbWlzc2luZy5cbiAgLy8gU28sIHRoaXMgd29uJ3Qgd29yazogYGNyZWF0ZVNlbGVjdG9yKGZpeGVkTm93LCBzZXJ2ZXJOb3csIC4uLilgXG4gIGNvbnN0IGYgPSBmaXhlZE5vdyhzLCBwKVxuICByZXR1cm4gZiAhPSBudWxsID8gZiA6IHNlcnZlck5vdyhzLCBwKVxufVxuZXhwb3J0IGZ1bmN0aW9uIHNpbmNlPFA6IHt9PihcbiAgYmVmb3JlOiAoVXRpbC5Sb290U3RhdGUsIFApID0+IFV0aWwuVGltZXN0YW1wLFxuKTogKFV0aWwuUm9vdFN0YXRlLCBQKSA9PiBVdGlsLkR1cmF0aW9uIHtcbiAgcmV0dXJuIGNyZWF0ZVNlbGVjdG9yKG5vdywgYmVmb3JlLCBVdGlsLkR1cmF0aW9uLnNpbmNlKVxufVxuXG5leHBvcnQgY29uc3QgbG9hZGVkID0gY3JlYXRlU2VsZWN0b3IoXG4gIENsaWVudE5vdy5sb2FkZWQsXG4gIHNlcnZlclRpbWVPZmZzZXQsXG4gIENsaWVudFRpbWVzdGFtcC50b1NlcnZlcixcbilcbmV4cG9ydCBjb25zdCBsb2NrTm93ID0gKCkgPT5cbiAgY3JlYXRlU2VsZWN0b3IoXG4gICAgQ2xpZW50Tm93LmxvY2tOb3coKSxcbiAgICBzZXJ2ZXJUaW1lT2Zmc2V0LFxuICAgIENsaWVudFRpbWVzdGFtcC50b1NlcnZlcixcbiAgKVxuZXhwb3J0IGNvbnN0IHNpbmNlTG9hZGVkID0gY3JlYXRlU2VsZWN0b3Iobm93LCBsb2FkZWQsIFV0aWwuRHVyYXRpb24uc2luY2UpXG4iXX0=

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = exports.isEmpty = undefined;
exports.localState = localState;

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var charId = function charId(state, props) {
  return props.charId;
};

var path = (0, _reselect.createSelector)(charId, paths.character.data);
var _localState = (0, _queryStatus.selectPath)(path);
var _isPropEmpty = function _isPropEmpty(s, p) {
  return !p.character;
};
var _isEmpty = _queryStatus.selectPath.isEmpty(path);
var isEmpty = exports.isEmpty = (0, _reselect.createSelector)(_isEmpty, _isPropEmpty, function (e, p) {
  return e && p;
});
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);

// TODO: an intersection type would be ideal here:
// ((any, {character: State})=>State) & ((Util.RootState, {charId:string}) => State)
// but flow was surprisingly uncooperative, the syntax is poorly supported, and
// I don't want to spend the time to figure out why I get a million errors.
function localState(state, props) {
  var isId = props.charId != null;
  var isOverride = props.character != null;
  if (isId === isOverride) {
    return (0, _assert.throws)("character selectors must pass exactly one of {charId, character}", props);
  }
  return isId ? _localState(state, props) : props.character;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(434);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(291);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var WithState = function (_Component) {
      _inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return WithState;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

exports.default = withState;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(945);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBase = function IconBase(_ref, _ref2) {
  var children = _ref.children;
  var color = _ref.color;
  var size = _ref.size;
  var style = _ref.style;

  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style']);

  var _ref2$reactIconBase = _ref2.reactIconBase;
  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var computedSize = size || reactIconBase.size || '1em';
  return _react2.default.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: computedSize,
    width: computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
};

IconBase.contextTypes = {
  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
};

exports.default = IconBase;
module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var user = exports.user = {
  query: function query(userId) {
    return "/users/" + userId;
  },
  data: function data(userId) {
    return "data/users/" + userId;
  }
};
var charactersByUser = exports.charactersByUser = {
  data: function data(userId) {
    return "data/characters-by-user/" + userId;
  },
  query: function query(userId) {
    return {
      path: "/characters",
      storeAs: "/characters-by-user/" + userId,
      queryParams: ["orderByChild=user", "limitToFirst=5", "equalTo=" + userId]
    };
  }
};
var character = exports.character = {
  query: function query(charId) {
    return "/characters/" + charId;
  },
  data: function data(charId) {
    return "data/characters/" + charId;
  }
};
var options = exports.options = {
  query: function query(userId) {
    return "/options/" + userId;
  },
  data: function data(userId) {
    return "data/options/" + userId;
  }
};
var betaUsers = exports.betaUsers = {
  query: function query(userId) {
    return "/betaUsers/" + userId;
  },
  data: function data(userId) {
    return "data/betaUsers/" + userId;
  }
};
var betaKeyToUser = exports.betaKeyToUser = {
  query: function query(betaKey) {
    return "/betaKeyUsers/" + betaKey;
  },
  data: function data(betaKey) {
    return "data/betaKeyUsers/" + betaKey;
  }
};
var betaValidKeys = exports.betaValidKeys = {
  query: function query(betaKey) {
    return "/betaKeys/" + betaKey;
  },
  data: function data(betaKey) {
    return "data/betaKeys/" + betaKey;
  }
};
var appInfo = exports.appInfo = {
  query: function query() {
    return "/appInfo";
  },
  data: function data() {
    return "data/appInfo";
  }
};
var roles = exports.roles = {
  betaUsers: {
    query: function query(userId) {
      return "/userRoles/betaKeys/" + userId;
    },
    data: function data(userId) {
      return "data/userRoles/betaKeys/" + userId;
    }
  },
  prereleaseFlags: {
    query: function query(userId) {
      return "/userRoles/prereleaseFlags/" + userId;
    },
    data: function data(userId) {
      return "data/userRoles/prereleaseFlags/" + userId;
    }
  }
};
var connected = exports.connected = {
  query: function query() {
    return ".info/connected";
  },
  data: function data() {
    return "data//info/connected";
  }
};
var serverTimeOffset = exports.serverTimeOffset = {
  query: function query() {
    return ".info/serverTimeOffset";
  },
  data: function data() {
    return "data//info/serverTimeOffset";
  }
};
var rankings = exports.rankings = {
  query: function query(_ref) {
    var league = _ref.league,
        rankName = _ref.rankName;
    return {
      path: "/rankings/" + league + "/" + rankName,
      // Server-side sorting doesn't survive the trip to the client - dataToJS()
      // doesn't preserve sorting - and it won't matter once we switch to redis.
      // Need to for limit to work though.
      queryParams: ["orderByChild=value", "limitToFirst=100"]
    };
  },
  data: function data(_ref2) {
    var league = _ref2.league,
        rankName = _ref2.rankName;
    return "data/rankings/" + league + "/" + rankName;
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RaisedButton = __webpack_require__(862);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RaisedButton2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(167)('wks');
var uid = __webpack_require__(121);
var Symbol = __webpack_require__(61).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isObject = __webpack_require__(28);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(379);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReqLoaded = undefined;
exports.getPath = getPath;
exports.selectPath = selectPath;
exports.reqToData = reqToData;

var _reactReduxFirebase = __webpack_require__(130);

var RRF = _interopRequireWildcard(_reactReduxFirebase);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fixPath(path) {
  // special case: RRF stores /.info/x as 'data: {"": {info: {x}}}'
  path = path.replace(/^\/?.info/, "//info");
  return _lodash2.default.startsWith(path, "/") ? path.substr(1) : path;
}
function isEmpty(val) {
  // RRF.isEmpty seems intended for lists - it breaks for lots of values
  //return RRF.isEmpty(val) && val !== 0 && val !== "" && val !== true && i give up
  return _lodash2.default.isArray(val) ? RRF.isEmpty(val) : val == null;
}
function _getPath(firebase, fixedPath) {
  return _lodash2.default.get(firebase, fixedPath.split("/"));
}

function getPath(firebase, path) {
  // No empty check (like in the original getPath(), RIP) - each container defines 'empty'.
  var fixedPath = fixPath(path);
  var val = _getPath(firebase, fixedPath);
  return RRF.isLoaded(val) ? val : (0, _assert.throws)("redux-firebase: path not ready", { path: path, fixedPath: fixedPath });
}
var fireState = function fireState(root) {
  return root.firebase;
};
function selectPath(pathSelector) {
  return (0, _reselect.createSelector)(fireState, pathSelector, getPath);
}
var selectIsLoaded = function selectIsLoaded(firebase, path) {
  return RRF.isLoaded(_getPath(firebase, fixPath(path)));
};
selectPath.isLoaded = function selectPathIsLoaded(pathSelector) {
  return (0, _reselect.createSelector)(fireState, pathSelector, selectIsLoaded);
};
var selectIsEmpty = function selectIsEmpty(firebase, path) {
  return isEmpty(_getPath(firebase, fixPath(path)));
};
selectPath.isEmpty = function selectPathIsEmpty(pathSelector) {
  return (0, _reselect.createSelector)(fireState, pathSelector, selectIsEmpty);
};
selectPath.isNotEmpty = function (pathSel) {
  return _lodash2.default.negate(selectPath.isEmpty(pathSel));
};
var all = function all() {
  for (var _len = arguments.length, as = Array(_len), _key = 0; _key < _len; _key++) {
    as[_key] = arguments[_key];
  }

  return _lodash2.default.every(as);
};
selectPath.isReady = function selectPathIsReady(pathSelector) {
  return (0, _reselect.createSelector)(selectPath.isLoaded(pathSelector), _lodash2.default.negate(selectPath.isEmpty(pathSelector)), all);
};
// convert a path used in root.firebase.requesting to one used for selectPath
function reqToData(path) {
  return "data/" + fixPath(path);
}
var isReqLoaded = exports.isReqLoaded = function isReqLoaded(firebase, reqpath) {
  return RRF.isLoaded(_getPath(firebase, reqToData(reqpath)));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEvent = exports.get = exports.getInitEvent = exports.getInitState = exports.getFullState = exports.isNotEmpty = exports.isEmpty = undefined;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions within combat. Unware of/uncoupled from the character.

// One round every 5 seconds or so; units clash.

// Game over, you took too long: draw.


// Character-action that starts combat.

// Also used as an initialization combat event
var _maybeGetFullState = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return s.combat || null;
});

function maybeGetFullState(state, props) {
  var isOverride = props.combat != null;
  var isChar = RawChar.isNotEmpty(state, props);
  if (isChar === isOverride) {
    return (0, _assert.throws)("combat selectors must pass exactly one of {charId, character, combat}", props);
  }
  return isOverride ? props.combat : _maybeGetFullState(state, props);
}
var isEmpty = exports.isEmpty = _lodash2.default.negate(maybeGetFullState);
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);
var getFullState = exports.getFullState = (0, _reselect.createSelector)(maybeGetFullState, function (s) {
  return s || (0, _assert.throws)("combat is empty", s);
});

// Child states.
var getInitState = exports.getInitState = (0, _reselect.createSelector)(getFullState, function (s) {
  return s.init;
});
var getInitEvent = exports.getInitEvent = (0, _reselect.createSelector)(getInitState, function (s) {
  return s.event;
});
var getStrictLastState = (0, _reselect.createSelector)(getFullState, function (s) {
  return s.last || null;
});
var get = exports.get = (0, _reselect.createSelector)(getInitState, getStrictLastState, function (i, l) {
  return l || i;
});
var getEvent = exports.getEvent = (0, _reselect.createSelector)(get, function (s) {
  return s.event;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebaseConnect = __webpack_require__(821);

Object.defineProperty(exports, "firebaseConnect", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_firebaseConnect).default;
  }
});

var _Firebase = __webpack_require__(827);

Object.keys(_Firebase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Firebase[key];
    }
  });
});

var _Offline = __webpack_require__(380);

Object.keys(_Offline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Offline[key];
    }
  });
});

var _Store = __webpack_require__(828);

Object.keys(_Store).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Store[key];
    }
  });
});

var _EnvConfig = __webpack_require__(155);

Object.defineProperty(exports, "envConfig", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EnvConfig).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1eC9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztvREFBUUEsTzs7Ozs7O0FBQ1I7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7Ozs7OzhDQUNRQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHtkZWZhdWx0IGFzIGZpcmViYXNlQ29ubmVjdH0gZnJvbSBcIi4vZmlyZWJhc2VDb25uZWN0XCJcbmV4cG9ydCAqIGZyb20gXCIuL0ZpcmViYXNlXCJcbmV4cG9ydCAqIGZyb20gXCIuL09mZmxpbmVcIlxuZXhwb3J0ICogZnJvbSBcIi4vU3RvcmVcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIGVudkNvbmZpZ30gZnJvbSBcIi4vRW52Q29uZmlnXCJcbiJdfQ==

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(823);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.betaKey = exports.leagueRank = exports.unitName = exports.maybeCharId = exports.charId = exports.userId = undefined;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _assert = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function maybeUrlParam(props, key) {
  return _lodash2.default.get(props, "match.params." + key);
}
function urlParam(props, key) {
  return (0, _assert.assertDefined)(maybeUrlParam(props, key), key);
}
function urlProp(key) {
  return (0, _withProps2.default)(function (props) {
    return _defineProperty({}, key, urlParam(props, key));
  });
}
function maybeUrlProp(key) {
  return (0, _withProps2.default)(function (props) {
    return _defineProperty({}, key, maybeUrlParam(props, key));
  });
}

var userId = exports.userId = urlProp("userId");
var charId = exports.charId = urlProp("charId");
var maybeCharId = exports.maybeCharId = maybeUrlProp("charId");
var unitName = exports.unitName = urlProp("unitName");
var rankName = urlProp("rankName");
var league = urlProp("league");
var leagueRank = exports.leagueRank = (0, _compose2.default)(league, rankName);
var betaKey = exports.betaKey = urlProp("betaKey");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = __webpack_require__(871);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);

exports.default = {

  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  horizontal: horizontal,

  vertical: vertical,

  origin: _propTypes2.default.shape({
    horizontal: horizontal,
    vertical: vertical
  }),

  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(591).runInContext();
module.exports = __webpack_require__(287)(_, _);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actionsPrefix = exports.actionsPrefix = '@@reactReduxFirebase';

var actionTypes = exports.actionTypes = {
  START: actionsPrefix + '/START',
  SET: actionsPrefix + '/SET',
  REMOVE: actionsPrefix + '/REMOVE',
  MERGE: actionsPrefix + '/MERGE',
  SET_PROFILE: actionsPrefix + '/SET_PROFILE',
  LOGIN: actionsPrefix + '/LOGIN',
  LOGOUT: actionsPrefix + '/LOGOUT',
  LOGIN_ERROR: actionsPrefix + '/LOGIN_ERROR',
  NO_VALUE: actionsPrefix + '/NO_VALUE',
  UNAUTHORIZED_ERROR: actionsPrefix + '/UNAUTHORIZED_ERROR',
  ERROR: actionsPrefix + '/ERROR',
  SET_LISTENER: actionsPrefix + '/SET_LISTENER',
  UNSET_LISTENER: actionsPrefix + '/UNSET_LISTENER',
  AUTHENTICATION_INIT_STARTED: actionsPrefix + '/AUTHENTICATION_INIT_STARTED',
  AUTHENTICATION_INIT_FINISHED: actionsPrefix + '/AUTHENTICATION_INIT_FINISHED',
  SESSION_START: actionsPrefix + '/SESSION_START',
  SESSION_END: actionsPrefix + '/SESSION_END',
  FILE_UPLOAD_START: actionsPrefix + '/FILE_UPLOAD_START',
  FILE_UPLOAD_ERROR: actionsPrefix + '/FILE_UPLOAD_ERROR',
  FILE_UPLOAD_PROGRESS: actionsPrefix + '/FILE_UPLOAD_PROGRESS',
  FILE_UPLOAD_COMPLETE: actionsPrefix + '/FILE_UPLOAD_COMPLETE',
  FILE_DELETE_START: actionsPrefix + '/FILE_DELETE_START',
  FILE_DELETE_ERROR: actionsPrefix + '/FILE_DELETE_ERROR',
  FILE_DELETE_COMPLETE: actionsPrefix + '/FILE_DELETE_COMPLETE',
  AUTH_UPDATE_START: actionsPrefix + '/AUTH_UPDATE_START',
  AUTH_UPDATE_SUCCESS: actionsPrefix + '/AUTH_UPDATE_SUCCESS',
  AUTH_UPDATE_ERROR: actionsPrefix + '/AUTH_UPDATE_ERROR',
  PROFILE_UPDATE_START: actionsPrefix + '/PROFILE_UPDATE_START',
  PROFILE_UPDATE_SUCCESS: actionsPrefix + '/PROFILE_UPDATE_SUCCESS',
  PROFILE_UPDATE_ERROR: actionsPrefix + '/PROFILE_UPDATE_ERROR',
  EMAIL_UPDATE_START: actionsPrefix + '/EMAIL_UPDATE_START',
  EMAIL_UPDATE_SUCCESS: actionsPrefix + '/EMAIL_UPDATE_SUCCESS',
  EMAIL_UPDATE_ERROR: actionsPrefix + '/EMAIL_UPDATE_ERROR',
  AUTH_RELOAD_START: actionsPrefix + '/AUTH_RELOAD_START',
  AUTH_RELOAD_ERROR: actionsPrefix + '/AUTH_RELOAD_ERROR',
  AUTH_RELOAD_SUCCESS: actionsPrefix + '/AUTH_RELOAD_SUCCESS',
  AUTH_LINK_START: actionsPrefix + '/AUTH_LINK_START',
  AUTH_LINK_ERROR: actionsPrefix + '/AUTH_LINK_ERROR',
  AUTH_LINK_SUCCESS: actionsPrefix + '/AUTH_LINK_SUCCESS',
  AUTH_EMPTY_CHANGE: actionsPrefix + '/AUTH_EMPTY_CHANGE'
};

var defaultConfig = exports.defaultConfig = {
  userProfile: null,
  presence: null,
  sessions: 'sessions',
  enableLogging: false,
  resetBeforeLogin: true,
  updateProfileOnLogin: true,
  enableRedirectHandling: true,
  autoPopulateProfile: false,
  setProfilePopulateResults: false,
  dispatchOnUnsetListener: true,
  dispatchRemoveAction: true,
  enableEmptyAuthChanges: false,
  firebaseStateName: 'firebase',
  includeFirestore: true,
  firestoreNamespace: 'firestoreHelpers',
  attachAuthIsReady: false
};

var supportedAuthProviders = exports.supportedAuthProviders = ['google', 'github', 'twitter', 'facebook'];

var topLevelPaths = exports.topLevelPaths = ['auth', 'profile', 'ordered', 'data'];

exports.default = {
  actionTypes: actionTypes,
  defaultConfig: defaultConfig
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(353);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});

var _actions = __webpack_require__(766);

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

var _types = __webpack_require__(216);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvYXV0aC9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5leHBvcnQgKiBmcm9tIFwiLi9yb290XCJcbmV4cG9ydCAqIGZyb20gXCIuL2FjdGlvbnNcIlxuZXhwb3J0ICogZnJvbSBcIi4vdHlwZXNcIlxuIl19

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rawCounts = exports.grown = exports.initCount = exports.isZero = exports.rawCountSelector = exports.rawCount = exports.looted = exports.spent = exports.bought = exports.firstElapsed = exports.sinceFirst = exports.firstAt = exports.clicks = exports.localState = exports.init = exports.isNotEmpty = exports.isEmpty = exports.rawState = exports.Decimal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buyAction = buyAction;
exports.spendAction = spendAction;
exports.lootAction = lootAction;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(220);

var RawUnit = _interopRequireWildcard(_raw);

var _lastActionAt = __webpack_require__(109);

var LastActionAt = _interopRequireWildcard(_lastActionAt);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Decimal = _decimal2.default;

var unitName = function unitName(state, props) {
  return props.unitName;
};
var rawState = exports.rawState = (0, _reselect.createSelector)(RawUnit.get, unitName, function (s, n) {
  return s[n];
});
var isEmpty = exports.isEmpty = _lodash2.default.negate(rawState);
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);

var init = exports.init = function init(count) {
  return { count: count + "" };
};
var initCounts = UnitTypes.initCounts;
var initStates = (0, _reselect.createSelector)(initCounts, function (counts) {
  return _lodash2.default.mapValues(counts, function (count, unitName) {
    return init(count || "0");
  });
});
var initState = (0, _reselect.createSelector)(initStates, unitName, function (s, k) {
  return s[k] || (0, _assert.throws)("characters2/units/stats: no such unit", {
    validNames: _lodash2.default.keys(s),
    unitName: k
  });
});
var localState = exports.localState = (0, _reselect.createSelector)(rawState, initState, function (raw, init) {
  return raw || init;
});
var localStateSelector = _lodash2.default.memoize(function (unitName) {
  return function (state, props) {
    return localState(state, _extends({}, props, { unitName: unitName }));
  };
});

var _clicks = function _clicks(s) {
  return s.clicks || 0;
};
var clicks = exports.clicks = (0, _reselect.createSelector)(localState, _clicks);
var _firstAtNum = function _firstAtNum(s) {
  return s.firstAt || null;
};
var _firstAt = (0, _reselect.createSelector)(_firstAtNum, function (ts) {
  return ts != null ? Util.Timestamp.wrap(ts) : null;
});
var firstAt = exports.firstAt = (0, _reselect.createSelector)(localState, _firstAt);
var sinceFirst = exports.sinceFirst = (0, _reselect.createSelector)(Now.now, firstAt, function (now, firstAt) {
  return firstAt != null ? Util.Duration.since(now, firstAt) : null;
});
var firstElapsed = exports.firstElapsed = (0, _reselect.createSelector)(firstAt, LastActionAt.createdAt, function (firstAt, createdAt) {
  return firstAt != null ? Util.Duration.since(firstAt, createdAt) : null;
});
var _bought = function _bought(s) {
  return (0, _decimal2.default)(s.bought || 0);
};
var bought = exports.bought = (0, _reselect.createSelector)(localState, _bought);
var _spent = function _spent(s) {
  return (0, _decimal2.default)(s.spent || 0);
};
var spent = exports.spent = (0, _reselect.createSelector)(localState, _spent);
var _looted = function _looted(s) {
  return (0, _decimal2.default)(s.looted || 0);
};
var looted = exports.looted = (0, _reselect.createSelector)(localState, _looted);
// named to avoid confusion with reified-count, even though this file is unaware of reify
var _rawCount = function _rawCount(s) {
  return (0, _decimal2.default)(s.count);
};
var rawCount = exports.rawCount = (0, _reselect.createSelector)(localState, _rawCount);
var rawCountSelector = exports.rawCountSelector = _lodash2.default.memoize(function (unitName) {
  return (0, _reselect.createSelector)(localStateSelector(unitName), _rawCount);
});
var isZero = exports.isZero = (0, _reselect.createSelector)(rawCount, function (c) {
  return c.isZero();
});

// All counted units not accounted for with bought/spent/looted. Includes
// initial value, and units grown by other units over time. We can't tell the
// difference here, with no unittype.
var initCount = exports.initCount = (0, _reselect.createSelector)(initState, _rawCount);
var grown = exports.grown = (0, _reselect.createSelector)(rawCount, initCount, bought, looted, spent, function (count, init, bought, looted, spent) {
  return count.plus(spent).minus(init).minus(bought).minus(looted);
});

var _rawCounts = (0, _reselect.createSelector)(RawUnit.get, function (stats) {
  return _lodash2.default.mapValues(stats, _rawCount);
});
var rawCounts = exports.rawCounts = (0, _reselect.createSelector)(initCounts, _rawCounts, function (i, r) {
  return _extends({}, i, r);
});

// These actions are used only within stats.
function buyAction(payload, createdAt) {
  return { type: "unit-stats/buy", payload: payload, createdAt: createdAt };
}
function spendAction(payload) {
  return { type: "unit-stats/spend", payload: payload };
}
function lootAction(payload, createdAt) {
  return { type: "unit-stats/loot", payload: payload, createdAt: createdAt };
}

function reducer(state, action) {
  switch (action.type) {
    // braces{} around each case statement allow us to destructure the action in
    // each one. Without them, it complains that we've created the same vars twice
    case "unit-stats/buy":
      {
        var _payload = action.payload,
            _createdAt = action.createdAt;

        return _extends({}, state, {
          clicks: _clicks(state) + 1,
          firstAt: _firstAtNum(state) || _createdAt,
          bought: _bought(state).plus(_payload).toString(),
          count: _rawCount(state).plus(_payload).toString()
        });
      }
    case "unit-stats/loot":
      {
        var _payload2 = action.payload,
            _createdAt2 = action.createdAt;

        return _extends({}, state, {
          firstAt: _firstAtNum(state) || _createdAt2,
          looted: _looted(state).plus(_payload2).toString(),
          count: _rawCount(state).plus(_payload2).toString()
        });
      }
    case "unit-stats/spend":
      {
        var _payload3 = action.payload;

        var _count = _rawCount(state).minus(_payload3);
        if (_count.lessThan(0)) {
          (0, _assert.throws)("not enough resources", { state: state, payload: _payload3 });
        }
        return _extends({}, state, {
          count: _count.toString(),
          spent: _spent(state).plus(_payload3).toString()
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(824);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(825);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestError = exports.handleInputs = exports.handleInput = exports.propnames = exports.propname = exports.required = undefined;
exports.handleForm = handleForm;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//export {dataToJS, pathToJS} from 'react-redux-firebase' // for testing/comparison

var required = exports.required = function required(fn) {
  return function (state, props) {
    return (0, _assert.assert)(fn(state, props));
  };
};

// <form> stuff
// Select helpers.
var propname = exports.propname = function propname(name) {
  return function (state, props) {
    return props[name];
  };
};
var propnames = exports.propnames = function propnames() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return names.map(propname);
};

var handleInput = exports.handleInput = function handleInput(name) {
  return (0, _reselect.createSelector)(function (state, props) {
    return props[name];
  }, function (setter) {
    return function (event) {
      return setter(event.target.value);
    };
  });
};
var handleInputs = exports.handleInputs = function handleInputs() {
  for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    names[_key2] = arguments[_key2];
  }

  return (0, _reselect.createStructuredSelector)((0, _lodash2.default)(names).keyBy().mapValues(handleInput).value());
};

var requestError = exports.requestError = (0, _reselect.createSelector)(propname("request"), function (req) {
  return req.state === "ERROR" ? req.error : null;
});

function handleForm(setRequest, handler) {
  return function (event) {
    setRequest({ state: "PENDING" });
    try {
      if (event) event.preventDefault();
      handler().then(function (result) {
        setRequest({ state: "SUCCESS", result: result });
      }, function (error) {
        setRequest({ state: "ERROR", error: error });
      });
    } catch (error) {
      setRequest({ state: "ERROR", error: error.message, source: "catch" });
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextField = __webpack_require__(872);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextField2.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;

var _List2 = __webpack_require__(233);

var _List3 = _interopRequireDefault(_List2);

var _ListItem2 = __webpack_require__(406);

var _ListItem3 = _interopRequireDefault(_ListItem2);

var _makeSelectable2 = __webpack_require__(928);

var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.List = _List3.default;
exports.ListItem = _ListItem3.default;
exports.makeSelectable = _makeSelectable3.default;
exports.default = _List3.default;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(61);
var core = __webpack_require__(33);
var ctx = __webpack_require__(168);
var hide = __webpack_require__(78);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(69);
var IE8_DOM_DEFINE = __webpack_require__(255);
var toPrimitive = __webpack_require__(169);
var dP = Object.defineProperty;

exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85),
    getRawTag = __webpack_require__(606),
    objectToString = __webpack_require__(607);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(41),
    isLength = __webpack_require__(194);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(668),
    baseMatchesProperty = __webpack_require__(678),
    identity = __webpack_require__(107),
    isArray = __webpack_require__(21),
    property = __webpack_require__(680);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = __webpack_require__(883);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(79)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(605),
    getValue = __webpack_require__(610);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(138),
    baseAssignValue = __webpack_require__(139);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(106);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(777);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3VuaXQtdHlwZXMvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0ICogZnJvbSBcIi4vcm9vdFwiXG4iXX0=

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */


var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      _inherits(Lifecycle, _Component);

      function Lifecycle() {
        _classCallCheck(this, Lifecycle);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(_react.Component);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

exports.default = lifecycle;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(120);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addLocaleData */
/* unused harmony export intlShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return injectIntl; });
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63);
var createDesc = __webpack_require__(100);
module.exports = __webpack_require__(70) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(261);
var defined = __webpack_require__(165);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actionsPrefix = exports.actionsPrefix = '@@reduxFirestore';

var actionTypes = exports.actionTypes = {
  START: actionsPrefix + '/START',
  SET: actionsPrefix + '/SET',
  ERROR: actionsPrefix + '/ERROR',
  SET_LISTENER: actionsPrefix + '/SET_LISTENER',
  UNSET_LISTENER: actionsPrefix + '/UNSET_LISTENER',
  GET_REQUEST: actionsPrefix + '/GET_REQUEST',
  GET_SUCCESS: actionsPrefix + '/GET_SUCCESS',
  GET_FAILURE: actionsPrefix + '/GET_FAILURE',
  SET_REQUEST: actionsPrefix + '/SET_REQUEST',
  SET_SUCCESS: actionsPrefix + '/SET_SUCCESS',
  SET_FAILURE: actionsPrefix + '/SET_FAILURE',
  ADD_REQUEST: actionsPrefix + '/ADD_REQUEST',
  ADD_SUCCESS: actionsPrefix + '/ADD_SUCCESS',
  ADD_FAILURE: actionsPrefix + '/ADD_FAILURE',
  UPDATE_REQUEST: actionsPrefix + '/UPDATE_REQUEST',
  UPDATE_SUCCESS: actionsPrefix + '/UPDATE_SUCCESS',
  UPDATE_FAILURE: actionsPrefix + '/UPDATE_FAILURE',
  ATTACH_LISTENER: actionsPrefix + '/ATTACH_LISTENER',
  LISTENER_RESPONSE: actionsPrefix + '/LISTENER_RESPONSE',
  LISTENER_ERROR: actionsPrefix + '/LISTENER_ERROR',
  ON_SNAPSHOT_REQUEST: actionsPrefix + '/ON_SNAPSHOT_REQUEST',
  ON_SNAPSHOT_SUCCESS: actionsPrefix + '/ON_SNAPSHOT_SUCCESS',
  ON_SNAPSHOT_FAILURE: actionsPrefix + '/ON_SNAPSHOT_FAILURE'
};

var defaultConfig = exports.defaultConfig = {
  userProfile: null,
  presence: null,
  sessions: 'sessions',
  enableLogging: false,
  resetBeforeLogin: true,
  updateProfileOnLogin: true,
  enableRedirectHandling: true,
  autoPopulateProfile: false,
  setProfilePopulateResults: false,
  dispatchOnUnsetListener: true,
  enableEmptyAuthChanges: false,
  stateName: 'firestore',
  attachAuthIsReady: false
};

var supportedAuthProviders = exports.supportedAuthProviders = ['google', 'github', 'twitter', 'facebook'];

var topLevelPaths = exports.topLevelPaths = ['auth', 'profile', 'ordered', 'data'];

exports.default = {
  actionTypes: actionTypes,
  defaultConfig: defaultConfig
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(34);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(295),
    baseKeys = __webpack_require__(195),
    isArrayLike = __webpack_require__(65);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isKey = __webpack_require__(202),
    stringToPath = __webpack_require__(311),
    toString = __webpack_require__(145);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(318),
    createBaseEach = __webpack_require__(657);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Id = exports.Timestamp = undefined;

var _flowClassyTypeWrapper = __webpack_require__(188);

var _util = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.Timestamp = _util.Timestamp;

var Id = exports.Id = function (_TypeWrapper) {
  _inherits(Id, _TypeWrapper);

  function Id() {
    _classCallCheck(this, Id);

    return _possibleConstructorReturn(this, (Id.__proto__ || Object.getPrototypeOf(Id)).apply(this, arguments));
  }

  return Id;
}(_flowClassyTypeWrapper.TypeWrapper);
// State is a single user, the result of one query. Most redux examples operate
// on a list as state, which is great when you have everything in memory - it's
// what we do for unittypes. For the result of a query where we won't ever
// have all users in memory, it makes less sense
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvdXNlcnMvdHlwZXMuanMiXSwibmFtZXMiOlsiVGltZXN0YW1wIiwiSWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFDQTs7Ozs7Ozs7UUFDUUEsUzs7SUFFS0MsRSxXQUFBQSxFOzs7Ozs7Ozs7OztBQUNiO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6InR5cGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7VHlwZVdyYXBwZXJ9IGZyb20gXCJmbG93LWNsYXNzeS10eXBlLXdyYXBwZXJcIlxuaW1wb3J0IHtUaW1lc3RhbXB9IGZyb20gXCIuLi8uLi91dGlsXCJcbmV4cG9ydCB7VGltZXN0YW1wfVxuXG5leHBvcnQgY2xhc3MgSWQgZXh0ZW5kcyBUeXBlV3JhcHBlcjxzdHJpbmc+IHt9XG4vLyBTdGF0ZSBpcyBhIHNpbmdsZSB1c2VyLCB0aGUgcmVzdWx0IG9mIG9uZSBxdWVyeS4gTW9zdCByZWR1eCBleGFtcGxlcyBvcGVyYXRlXG4vLyBvbiBhIGxpc3QgYXMgc3RhdGUsIHdoaWNoIGlzIGdyZWF0IHdoZW4geW91IGhhdmUgZXZlcnl0aGluZyBpbiBtZW1vcnkgLSBpdCdzXG4vLyB3aGF0IHdlIGRvIGZvciB1bml0dHlwZXMuIEZvciB0aGUgcmVzdWx0IG9mIGEgcXVlcnkgd2hlcmUgd2Ugd29uJ3QgZXZlclxuLy8gaGF2ZSBhbGwgdXNlcnMgaW4gbWVtb3J5LCBpdCBtYWtlcyBsZXNzIHNlbnNlXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHtcbiAgK3VzZXJuYW1lOiA/c3RyaW5nLCAvLyBUT0RPIHJlbmFtZVxuICArY3JlYXRlZEF0OiBudW1iZXIsXG59XG5cbmV4cG9ydCB0eXBlIFByb3BzID0ge3VzZXJJZDogSWR9XG5leHBvcnQgdHlwZSBTZWxlY3Q8VD4gPSAoU3RhdGUsIGFueSkgPT4gVFxuIl19

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinceUpdated = exports.updatedAt = exports.zone = exports.sinceCreated = exports.createdAt = undefined;

var _reselect = __webpack_require__(2);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import _ from "lodash"
var createdAt = exports.createdAt = (0, _reselect.createSelector)(Raw.getInitEvent, function (s) {
  return s.createdAt;
});
var sinceCreated = exports.sinceCreated = Now.since(createdAt);
var zone = exports.zone = (0, _reselect.createSelector)(Raw.getInitEvent, function (s) {
  return s.zone;
});
var updatedAt = exports.updatedAt = (0, _reselect.createSelector)(Raw.getEvent, function (s) {
  return s.createdAt;
});
var sinceUpdated = exports.sinceUpdated = Now.since(updatedAt);
//export const isDone = () => false // TODO
//export const isRunning = _.negate(isDone)
//export const doneAt = () => 0 // TODO
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY29tYmF0L2NvbWJhdC5qcyJdLCJuYW1lcyI6WyJOb3ciLCJSYXciLCJjcmVhdGVkQXQiLCJnZXRJbml0RXZlbnQiLCJzIiwic2luY2VDcmVhdGVkIiwic2luY2UiLCJ6b25lIiwidXBkYXRlZEF0IiwiZ2V0RXZlbnQiLCJzaW5jZVVwZGF0ZWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFFQTs7SUFBWUEsRzs7QUFDWjs7SUFBWUMsRzs7OztBQUZaO0FBSU8sSUFBTUMsZ0NBQVksOEJBQWVELElBQUlFLFlBQW5CLEVBQWlDO0FBQUEsU0FBS0MsRUFBRUYsU0FBUDtBQUFBLENBQWpDLENBQWxCO0FBQ0EsSUFBTUcsc0NBQWVMLElBQUlNLEtBQUosQ0FBVUosU0FBVixDQUFyQjtBQUNBLElBQU1LLHNCQUFPLDhCQUFlTixJQUFJRSxZQUFuQixFQUFpQztBQUFBLFNBQUtDLEVBQUVHLElBQVA7QUFBQSxDQUFqQyxDQUFiO0FBQ0EsSUFBTUMsZ0NBQVksOEJBQWVQLElBQUlRLFFBQW5CLEVBQTZCO0FBQUEsU0FBS0wsRUFBRUYsU0FBUDtBQUFBLENBQTdCLENBQWxCO0FBQ0EsSUFBTVEsc0NBQWVWLElBQUlNLEtBQUosQ0FBVUUsU0FBVixDQUFyQjtBQUNQO0FBQ0E7QUFDQSIsImZpbGUiOiJjb21iYXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbi8vaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgKiBhcyBOb3cgZnJvbSBcIi4uLy4uL25vd1wiXG5pbXBvcnQgKiBhcyBSYXcgZnJvbSBcIi4vcmF3XCJcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZWRBdCA9IGNyZWF0ZVNlbGVjdG9yKFJhdy5nZXRJbml0RXZlbnQsIHMgPT4gcy5jcmVhdGVkQXQpXG5leHBvcnQgY29uc3Qgc2luY2VDcmVhdGVkID0gTm93LnNpbmNlKGNyZWF0ZWRBdClcbmV4cG9ydCBjb25zdCB6b25lID0gY3JlYXRlU2VsZWN0b3IoUmF3LmdldEluaXRFdmVudCwgcyA9PiBzLnpvbmUpXG5leHBvcnQgY29uc3QgdXBkYXRlZEF0ID0gY3JlYXRlU2VsZWN0b3IoUmF3LmdldEV2ZW50LCBzID0+IHMuY3JlYXRlZEF0KVxuZXhwb3J0IGNvbnN0IHNpbmNlVXBkYXRlZCA9IE5vdy5zaW5jZSh1cGRhdGVkQXQpXG4vL2V4cG9ydCBjb25zdCBpc0RvbmUgPSAoKSA9PiBmYWxzZSAvLyBUT0RPXG4vL2V4cG9ydCBjb25zdCBpc1J1bm5pbmcgPSBfLm5lZ2F0ZShpc0RvbmUpXG4vL2V4cG9ydCBjb25zdCBkb25lQXQgPSAoKSA9PiAwIC8vIFRPRE9cbiJdfQ==

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
global.Decimal = global.Decimal || __webpack_require__(118).default;
exports.default = global.Decimal;
//console.log("core/decimal", Decimal)
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWNpbWFsLmpzIl0sIm5hbWVzIjpbImdsb2JhbCIsIkRlY2ltYWwiLCJyZXF1aXJlIiwiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQkQsT0FBT0MsT0FBUCxJQUFrQkMsUUFBUSxZQUFSLEVBQXNCQyxPQUF6RDtrQkFDZUgsT0FBT0MsTztBQUN0QiIsImZpbGUiOiJkZWNpbWFsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZ2xvYmFsLkRlY2ltYWwgPSBnbG9iYWwuRGVjaW1hbCB8fCByZXF1aXJlKFwiZGVjaW1hbC5qc1wiKS5kZWZhdWx0XG5leHBvcnQgZGVmYXVsdCBnbG9iYWwuRGVjaW1hbFxuLy9jb25zb2xlLmxvZyhcImNvcmUvZGVjaW1hbFwiLCBEZWNpbWFsKVxuIl19
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entryFights = exports.entryDraws = exports.entryLosses = exports.entryWins = exports.isEntryCleared = exports.isEmpty = exports.selectIsCleared = exports.isCleared = exports.visibleNames = exports.clearedNames = exports.totalFights = exports.totalDraws = exports.totalLosses = exports.totalWins = exports.totalClears = exports.byName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _zoneTypes = __webpack_require__(156);

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

var _leagues = __webpack_require__(221);

var Leagues = _interopRequireWildcard(_leagues);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var byName = exports.byName = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.zones || {};
});
var list = (0, _reselect.createSelector)(byName, _lodash2.default.values);

var _isEntryCleared = function _isEntryCleared(entry) {
  return entry.wins > 0;
};
var listCleared = (0, _reselect.createSelector)(list, function (list) {
  return _lodash2.default.filter(list, _isEntryCleared);
});

var totalClears = exports.totalClears = (0, _reselect.createSelector)(listCleared, _lodash2.default.size);
var totalWins = exports.totalWins = (0, _reselect.createSelector)(list, function (list) {
  return _lodash2.default.sum(_lodash2.default.map(list, "wins"));
});
var totalLosses = exports.totalLosses = (0, _reselect.createSelector)(list, function (list) {
  return _lodash2.default.sum(_lodash2.default.map(list, "losses"));
});
var totalDraws = exports.totalDraws = (0, _reselect.createSelector)(list, function (list) {
  return _lodash2.default.sum(_lodash2.default.map(list, "draws"));
});
var sum = function sum() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _lodash2.default.sum(args);
};
var totalFights = exports.totalFights = (0, _reselect.createSelector)(totalWins, totalLosses, totalDraws, sum);

var clearedByName = (0, _reselect.createSelector)(byName, function (ns) {
  return _lodash2.default.pickBy(_lodash2.default.mapValues(ns, _isEntryCleared));
});
var clearedNames = exports.clearedNames = (0, _reselect.createSelector)(clearedByName, _lodash2.default.keys);
var listLevelsCleared = (0, _reselect.createSelector)(clearedNames, ZoneTypes.levelsByName, function (names, levels) {
  return _lodash2.default.map(names, function (name) {
    return levels[name];
  });
});
var highestLevelCleared = (0, _reselect.createSelector)(listLevelsCleared, function (levels) {
  return _lodash2.default.max([0].concat(levels));
});
var maxZone = (0, _reselect.createSelector)(Leagues.unlockZone6, function (unlock) {
  return unlock ? Number.MAX_VALUE : 5;
});
var highestLevelVisible = (0, _reselect.createSelector)(highestLevelCleared, maxZone, function (level, maxZone) {
  return Math.min(level + 2, maxZone);
});
var visibleNames = exports.visibleNames = (0, _reselect.createSelector)(ZoneTypes.names, ZoneTypes.levelsByName, highestLevelVisible, function (names, levels, maxLevel) {
  return _lodash2.default.filter(names, function (name) {
    return levels[name] <= maxLevel;
  });
});

var zoneProp = function zoneProp(state, props) {
  return props.zone;
};
var isCleared = exports.isCleared = (0, _reselect.createSelector)(clearedByName, zoneProp, function (zs, n) {
  return n in zs;
});
var selectIsCleared = exports.selectIsCleared = function selectIsCleared(name) {
  return _lodash2.default.memoize((0, _reselect.createSelector)(clearedByName, function (zs) {
    return name in zs;
  }));
};
var visibleByName = (0, _reselect.createSelector)(visibleNames, _lodash2.default.keyBy);
var isZoneVisible = (0, _reselect.createSelector)(visibleByName, zoneProp, function (zs, n) {
  return n in zs;
});
var init = { wins: 0, losses: 0, draws: 0 };
var isEmpty = exports.isEmpty = _lodash2.default.negate(isZoneVisible);
var getEntry = (0, _reselect.createSelector)(byName, zoneProp, isZoneVisible, function (zones, name, isVisible) {
  return isVisible ? zones[name] || init : (0, _assert.throws)("zone not visible", { name: name, isVisible: isVisible });
});
var isEntryCleared = exports.isEntryCleared = (0, _reselect.createSelector)(getEntry, _isEntryCleared);
var entryWins = exports.entryWins = (0, _reselect.createSelector)(getEntry, function (entry) {
  return entry.wins;
});
var entryLosses = exports.entryLosses = (0, _reselect.createSelector)(getEntry, function (entry) {
  return entry.losses;
});
var entryDraws = exports.entryDraws = (0, _reselect.createSelector)(getEntry, function (entry) {
  return entry.draws;
});
var entryFights = exports.entryFights = (0, _reselect.createSelector)(entryWins, entryLosses, entryDraws, sum);

function reduceEntry(state, action) {
  switch (action.type) {
    case "__COMBAT_RESULT":
      {
        var createdAt = action.createdAt,
            status = action.status,
            isFirstZoneWin = action.isFirstZoneWin;

        switch (status) {
          case "win":
            var _firstWinAt = action.isFirstZoneWin ? createdAt : state.firstWinAt;
            (0, _assert.assert)(isFirstZoneWin === !state.firstWinAt, "isFirstZoneWin doesn't match expected firstWinAt", {
              firstWinAt: _firstWinAt,
              isFirstZoneWin: isFirstZoneWin,
              action: _lodash2.default.omit(action, ["root", "character"]),
              state: state
            });
            return _extends({}, state, { wins: state.wins + 1, firstWinAt: _firstWinAt });
          case "lose":
            return _extends({}, state, { losses: state.losses + 1 });
          case "draw":
            return _extends({}, state, { draws: state.draws + 1 });
          default:
            return (0, _assert.throws)("invalid combat result status", { state: state, action: action });
        }
      }
    default:
      return state;
  }
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "__COMBAT_RESULT":
      {
        var _zone = action.zone,
            root = action.root,
            fixedNow = action.createdAt;
        var _character = action.character;

        _character = _extends({}, _character, { zones: state });
        var entry0 = getEntry(root, { zone: _zone, character: _character, fixedNow: fixedNow });
        return _extends({}, state, _defineProperty({}, _zone, reduceEntry(entry0, action)));
      }
    default:
      return state;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchLocalPromise = dispatchLocalPromise;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _mapProps = __webpack_require__(159);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _withReducer = __webpack_require__(382);

var _withReducer2 = _interopRequireDefault(_withReducer);

var _reselect = __webpack_require__(2);

var _reactRedux = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function dispatchLocalPromise(actionProp, requestProp, promiseFn) {
  var dispatchProp = "__dispatch:" + requestProp;
  var dispatchType = requestProp + "=" + actionProp + "()";
  return (0, _compose2.default)((0, _withReducer2.default)(requestProp, dispatchProp, function (s, a) {
    return a;
  }, {}), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)(_defineProperty({}, actionProp, (0, _reselect.createSelector)(function (s, p) {
    return p[dispatchProp];
  }, promiseFn, function (dispatch, promiseFn) {
    return function () {
      return _selectors2.default.dispatchPromise(dispatchType, dispatch, promiseFn.apply(undefined, arguments));
    };
  })))), (0, _mapProps2.default)(function (props) {
    return _lodash2.default.omit(props, [dispatchProp]);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(165);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(260);
var enumBugKeys = __webpack_require__(174);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase=function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=void 0;if(void 0!==e)r=e;else if("undefined"!=typeof self)r=self;else try{r=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var i=r.Promise||n(8);t.local={Promise:i,GoogPromise:i}}).call(t,n(1))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(5),i=(0,r.createFirebaseNamespace)();t.default=i,e.exports=t.default},function(e,t,n){"use strict";function r(e){return i(void 0,e)}function i(e,t){if(!(t instanceof Object))return t;switch(t.constructor){case Date:return new Date(t.getTime());case Object:void 0===e&&(e={});break;case Array:e=[];break;default:return t}for(var n in t)t.hasOwnProperty(n)&&(e[n]=i(e[n],t[n]));return e}function o(e,t,n){e[t]=n}Object.defineProperty(t,"__esModule",{value:!0}),t.deepCopy=r,t.deepExtend=i,t.patchProperty=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e){var t=a;return a=e,t}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.patchCapture=i;var a=Error.captureStackTrace,c=function e(t,n){if(r(this,e),this.code=t,this.message=n,a)a(this,s.prototype.create);else{var i=Error.apply(this,arguments);this.name="FirebaseError",Object.defineProperty(this,"stack",{get:function(){return i.stack}})}};c.prototype=Object.create(Error.prototype),c.prototype.constructor=c,c.prototype.name="FirebaseError";var s=t.ErrorFactory=function(){function e(t,n,i){r(this,e),this.service=t,this.serviceName=n,this.errors=i,this.pattern=/\{\$([^}]+)}/g}return o(e,[{key:"create",value:function(e,t){void 0===t&&(t={});var n=this.errors[e],r=this.service+"/"+e,i=void 0;i=void 0===n?"Error":n.replace(this.pattern,function(e,n){var r=t[n];return void 0!==r?r.toString():"<"+n+"?>"}),i=this.serviceName+": "+i+" ("+r+").";var o=new c(r,i);for(var a in t)t.hasOwnProperty(a)&&"_"!==a.slice(-1)&&(o[a]=t[a]);return o}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){function e(e){e=e||d;var t=r[e];return void 0===t&&o("no-app",{name:e}),t}function t(e,t){Object.keys(a).forEach(function(r){var i=n(e,r);null!==i&&h[i]&&h[i](t,e)})}function n(e,t){if("serverAuth"===t)return null;var n=t,r=e.options;return"auth"===t&&(r.serviceAccount||r.credential)&&(n="serverAuth","serverAuth"in a||o("sa-not-supported")),n}var r={},a={},h={},v={__esModule:!0,initializeApp:function(e,n){void 0===n?n=d:"string"==typeof n&&""!==n||o("bad-app-name",{name:n+""}),void 0!==r[n]&&o("duplicate-app",{name:n});var i=new p(e,n,v);return r[n]=i,t(i,"create"),void 0!=i.INTERNAL&&void 0!=i.INTERNAL.getToken||(0,c.deepExtend)(i,{INTERNAL:{getUid:function(){return null},getToken:function(){return l.resolve(null)},addAuthTokenListener:function(){},removeAuthTokenListener:function(){}}}),i},app:e,apps:null,Promise:l,SDK_VERSION:"3.9.0",INTERNAL:{registerService:function(t,n,r,i,s){a[t]&&o("duplicate-service",{name:t}),a[t]=s?n:function(e,t){return n(e,t,d)},i&&(h[t]=i);var u=void 0;return u=function(n){return void 0===n&&(n=e()),"function"!=typeof n[t]&&o("invalid-app-argument",{name:t}),n[t]()},void 0!==r&&(0,c.deepExtend)(u,r),v[t]=u,u},createFirebaseNamespace:i,extendNamespace:function(e){(0,c.deepExtend)(v,e)},createSubscribe:s.createSubscribe,ErrorFactory:u.ErrorFactory,removeApp:function(e){t(r[e],"delete"),delete r[e]},factories:a,useAsService:n,Promise:f.local.GoogPromise,deepExtend:c.deepExtend}};return(0,c.patchProperty)(v,"default",v),Object.defineProperty(v,"apps",{get:function(){return Object.keys(r).map(function(e){return r[e]})}}),(0,c.patchProperty)(e,"App",p),v}function o(e,t){throw v.create(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createFirebaseNamespace=i;var c=n(3),s=n(6),u=n(4),f=n(0),l=f.local.Promise,d="[DEFAULT]",p=function(){function e(t,n,i){var o=this;r(this,e),this.firebase_=i,this.isDeleted_=!1,this.services_={},this.name_=n,this.options_=(0,c.deepCopy)(t);var a="credential"in this.options_,s="serviceAccount"in this.options_;if(a||s){var u=s?"serviceAccount":"credential";"undefined"!=typeof console&&console.log("The '"+u+"' property specified in the first argument to initializeApp() is deprecated and will be removed in the next major version. You should instead use the 'firebase-admin' package. See https://firebase.google.com/docs/admin/setup for details on how to get started.")}Object.keys(i.INTERNAL.factories).forEach(function(e){var t=i.INTERNAL.useAsService(o,e);if(null!==t){var n=o.getService.bind(o,t);(0,c.patchProperty)(o,e,n)}})}return a(e,[{key:"delete",value:function(){var e=this;return new l(function(t){e.checkDestroyed_(),t()}).then(function(){e.firebase_.INTERNAL.removeApp(e.name_);var t=[];return Object.keys(e.services_).forEach(function(n){Object.keys(e.services_[n]).forEach(function(r){t.push(e.services_[n][r])})}),l.all(t.map(function(e){return e.INTERNAL.delete()}))}).then(function(){e.isDeleted_=!0,e.services_={}})}},{key:"getService",value:function(e,t){this.checkDestroyed_(),void 0===this.services_[e]&&(this.services_[e]={});var n=t||d;if(void 0===this.services_[e][n]){var r=this.firebase_.INTERNAL.factories[e](this,this.extendApp.bind(this),t);return this.services_[e][n]=r,r}return this.services_[e][n]}},{key:"extendApp",value:function(e){(0,c.deepExtend)(this,e)}},{key:"checkDestroyed_",value:function(){this.isDeleted_&&o("app-deleted",{name:this.name_})}},{key:"name",get:function(){return this.checkDestroyed_(),this.name_}},{key:"options",get:function(){return this.checkDestroyed_(),this.options_}}]),e}();p.prototype.name&&p.prototype.options||p.prototype.delete||console.log("dc");var h={"no-app":"No Firebase App '{$name}' has been created - call Firebase App.initializeApp()","bad-app-name":"Illegal App name: '{$name}","duplicate-app":"Firebase App named '{$name}' already exists","app-deleted":"Firebase App named '{$name}' already deleted","duplicate-service":"Firebase service named '{$name}' already registered","sa-not-supported":"Initializing the Firebase SDK with a service account is only allowed in a Node.js environment. On client devices, you should instead initialize the SDK with an api key and auth domain","invalid-app-argument":"firebase.{$name}() takes either no argument or a Firebase App instance."},v=new u.ErrorFactory("app","Firebase",h)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){var n=new d(e,t);return n.subscribe.bind(n)}function o(e,t){return function(){for(var n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];l.resolve(!0).then(function(){e.apply(void 0,r)}).catch(function(e){t&&t(e)})}}function a(e,t){if("object"!==(void 0===e?"undefined":s(e))||null===e)return!1;var n=!0,r=!1,i=void 0;try{for(var o,a=t[Symbol.iterator]();!(n=(o=a.next()).done);n=!0){var c=o.value;if(c in e&&"function"==typeof e[c])return!0}}catch(e){r=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(r)throw i}}return!1}function c(){}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createSubscribe=i,t.async=o;var f=n(0),l=f.local.Promise,d=function(){function e(t,n){var i=this;r(this,e),this.observers=[],this.unsubscribes=[],this.observerCount=0,this.task=l.resolve(),this.finalized=!1,this.onNoObservers=n,this.task.then(function(){t(i)}).catch(function(e){i.error(e)})}return u(e,[{key:"next",value:function(e){this.forEachObserver(function(t){t.next(e)})}},{key:"error",value:function(e){this.forEachObserver(function(t){t.error(e)}),this.close(e)}},{key:"complete",value:function(){this.forEachObserver(function(e){e.complete()}),this.close()}},{key:"subscribe",value:function(e,t,n){var r=this,i=void 0;if(void 0===e&&void 0===t&&void 0===n)throw new Error("Missing Observer.");i=a(e,["next","error","complete"])?e:{next:e,error:t,complete:n},void 0===i.next&&(i.next=c),void 0===i.error&&(i.error=c),void 0===i.complete&&(i.complete=c);var o=this.unsubscribeOne.bind(this,this.observers.length);return this.finalized&&this.task.then(function(){try{r.finalError?i.error(r.finalError):i.complete()}catch(e){}}),this.observers.push(i),o}},{key:"unsubscribeOne",value:function(e){void 0!==this.observers&&void 0!==this.observers[e]&&(delete this.observers[e],this.observerCount-=1,0===this.observerCount&&void 0!==this.onNoObservers&&this.onNoObservers(this))}},{key:"forEachObserver",value:function(e){if(!this.finalized)for(var t=0;t<this.observers.length;t++)this.sendOne(t,e)}},{key:"sendOne",value:function(e,t){var n=this;this.task.then(function(){if(void 0!==n.observers&&void 0!==n.observers[e])try{t(n.observers[e])}catch(e){"undefined"!=typeof console&&console.error&&console.error(e)}})}},{key:"close",value:function(e){var t=this;this.finalized||(this.finalized=!0,void 0!==e&&(this.finalError=e),this.task.then(function(){t.observers=void 0,t.onNoObservers=void 0}))}}]),e}()},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function o(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function a(){v&&p&&(v=!1,p.length?h=p.concat(h):m=-1,h.length&&c())}function c(){if(!v){var e=i(a);v=!0;for(var t=h.length;t;){for(p=h,h=[];++m<t;)p&&p[m].run();m=-1,t=h.length}p=null,v=!1,o(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var f,l,d=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var p,h=[],v=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||v||i(c)},s.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){!function(n){function r(){}function i(e,t){return function(){e.apply(t,arguments)}}function o(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(e,this)}function a(e,t){for(;3===e._state;)e=e._value;if(0===e._state)return void e._deferreds.push(t);e._handled=!0,o._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null===n)return void(1===e._state?c:s)(t.promise,e._value);var r;try{r=n(e._value)}catch(e){return void s(t.promise,e)}c(t.promise,r)})}function c(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof o)return e._state=3,e._value=t,void u(e);if("function"==typeof n)return void l(i(n,t),e)}e._state=1,e._value=t,u(e)}catch(t){s(e,t)}}function s(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;t<n;t++)a(e,e._deferreds[t]);e._deferreds=null}function f(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,c(t,e))},function(e){n||(n=!0,s(t,e))})}catch(e){if(n)return;n=!0,s(t,e)}}var d=setTimeout;o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var n=new this.constructor(r);return a(this,new f(e,t,n)),n},o.all=function(e){var t=Array.prototype.slice.call(e);return new o(function(e,n){function r(o,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void c.call(a,function(e){r(o,e)},n)}t[o]=a,0==--i&&e(t)}catch(e){n(e)}}if(0===t.length)return e([]);for(var i=t.length,o=0;o<t.length;o++)r(o,t[o])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(t){t(e)})},o.reject=function(e){return new o(function(t,n){n(e)})},o.race=function(e){return new o(function(t,n){for(var r=0,i=e.length;r<i;r++)e[r].then(t,n)})},o._immediateFn="function"==typeof t&&function(e){t(e)}||function(e){d(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},o._setImmediateFn=function(e){o._immediateFn=e},o._setUnhandledRejectionFn=function(e){o._unhandledRejectionFn=e},void 0!==e&&e.exports?e.exports=o:n.Promise||(n.Promise=o)}(this)}).call(t,n(10).setImmediate)},function(e,t,n){(function(e,t){!function(e,n){"use strict";function r(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var r={callback:e,args:t};return u[s]=r,c(s),s++}function i(e){delete u[e]}function o(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}function a(e){if(f)setTimeout(a,0,e);else{var t=u[e];if(t){f=!0;try{o(t)}finally{i(e),f=!1}}}}if(!e.setImmediate){var c,s=1,u={},f=!1,l=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?function(){c=function(e){t.nextTick(function(){a(e)})}}():function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&a(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),c=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){a(e.data)},c=function(t){e.port2.postMessage(t)}}():l&&"onreadystatechange"in l.createElement("script")?function(){var e=l.documentElement;c=function(t){var n=l.createElement("script");n.onreadystatechange=function(){a(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){c=function(e){setTimeout(a,0,e)}}(),d.setImmediate=r,d.clearImmediate=i}}("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(1),n(7))},function(e,t,n){function r(e,t){this._id=e,this._clearFn=t}var i=Function.prototype.apply;t.setTimeout=function(){return new r(i.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(i.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(9),t.setImmediate=setImmediate,t.clearImmediate=clearImmediate},function(e,t,n){e.exports=n(2)}]);module.exports=firebase;
//# sourceMappingURL=app.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(355).setImmediate, __webpack_require__(355).clearImmediate))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = exports.createdAt = undefined;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createdAt = exports.createdAt = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return Util.Timestamp.wrap(s.createdAt);
});

var _get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.lastActionAt || s.createdAt;
});
var get = exports.get = _lodash2.default.flow(_get, Util.Timestamp.wrap);

function reducer(state, action) {
  // null/undefined is only valid as an initial state, and I prefer to have undefined as the flowtype.
  if (/^(@@redux\/|__)/.test(action.type)) return state || null;
  if (action.createdAt == null) return (0, _assert.throws)("action.createdAt required", { action: action });
  state = state || _get(action.root, { character: action.character });
  if (state > action.createdAt) return (0, _assert.throws)("action.createdAt is earlier than lastActionAt; can't run an action in the past", { state: state, action: action });
  return action.createdAt;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGFzdC1hY3Rpb24tYXQuanMiXSwibmFtZXMiOlsicmVkdWNlciIsIlV0aWwiLCJSYXciLCJjcmVhdGVkQXQiLCJsb2NhbFN0YXRlIiwiVGltZXN0YW1wIiwid3JhcCIsInMiLCJfZ2V0IiwibGFzdEFjdGlvbkF0IiwiZ2V0IiwiZmxvdyIsInN0YXRlIiwiYWN0aW9uIiwidGVzdCIsInR5cGUiLCJyb290IiwiY2hhcmFjdGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7UUFjZ0JBLE8sR0FBQUEsTzs7QUFiaEI7O0FBQ0E7O0FBQ0E7Ozs7QUFFQTs7SUFBWUMsSTs7QUFDWjs7SUFBWUMsRzs7Ozs7O0FBRUwsSUFBTUMsZ0NBQVksOEJBQWVELElBQUlFLFVBQW5CLEVBQStCO0FBQUEsU0FDdERILEtBQUtJLFNBQUwsQ0FBZUMsSUFBZixDQUFvQkMsRUFBRUosU0FBdEIsQ0FEc0Q7QUFBQSxDQUEvQixDQUFsQjs7QUFHUCxJQUFNSyxPQUFPLDhCQUFlTixJQUFJRSxVQUFuQixFQUErQjtBQUFBLFNBQUtHLEVBQUVFLFlBQUYsSUFBa0JGLEVBQUVKLFNBQXpCO0FBQUEsQ0FBL0IsQ0FBYjtBQUNPLElBQU1PLG9CQUFNLGlCQUFFQyxJQUFGLENBQU9ILElBQVAsRUFBYVAsS0FBS0ksU0FBTCxDQUFlQyxJQUE1QixDQUFaOztBQUVBLFNBQVNOLE9BQVQsQ0FBaUJZLEtBQWpCLEVBQWlDQyxNQUFqQyxFQUE4RDtBQUNuRTtBQUNBLE1BQUksa0JBQWtCQyxJQUFsQixDQUF1QkQsT0FBT0UsSUFBOUIsQ0FBSixFQUF5QyxPQUFRSCxTQUFTLElBQWpCO0FBQ3pDLE1BQUlDLE9BQU9WLFNBQVAsSUFBb0IsSUFBeEIsRUFDRSxPQUFPLG9CQUFPLDJCQUFQLEVBQW9DLEVBQUNVLGNBQUQsRUFBcEMsQ0FBUDtBQUNGRCxVQUFRQSxTQUFTSixLQUFLSyxPQUFPRyxJQUFaLEVBQWtCLEVBQUNDLFdBQVdKLE9BQU9JLFNBQW5CLEVBQWxCLENBQWpCO0FBQ0EsTUFBSUwsUUFBUUMsT0FBT1YsU0FBbkIsRUFDRSxPQUFPLG9CQUNMLGdGQURLLEVBRUwsRUFBQ1MsWUFBRCxFQUFRQyxjQUFSLEVBRkssQ0FBUDtBQUlGLFNBQU9BLE9BQU9WLFNBQWQ7QUFDRCIsImZpbGUiOiJsYXN0LWFjdGlvbi1hdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IHt0aHJvd3N9IGZyb20gXCJAc3dhcm0yL2Fzc2VydFwiXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoXCJcbmltcG9ydCB0eXBlIHtGYW5jeUFjdGlvbn0gZnJvbSBcIi4vYWN0aW9uLWJhc2VcIlxuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5pbXBvcnQgKiBhcyBSYXcgZnJvbSBcIi4vcmF3XCJcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZWRBdCA9IGNyZWF0ZVNlbGVjdG9yKFJhdy5sb2NhbFN0YXRlLCBzID0+XG4gIFV0aWwuVGltZXN0YW1wLndyYXAocy5jcmVhdGVkQXQpLFxuKVxuY29uc3QgX2dldCA9IGNyZWF0ZVNlbGVjdG9yKFJhdy5sb2NhbFN0YXRlLCBzID0+IHMubGFzdEFjdGlvbkF0IHx8IHMuY3JlYXRlZEF0KVxuZXhwb3J0IGNvbnN0IGdldCA9IF8uZmxvdyhfZ2V0LCBVdGlsLlRpbWVzdGFtcC53cmFwKVxuXG5leHBvcnQgZnVuY3Rpb24gcmVkdWNlcihzdGF0ZTogP251bWJlciwgYWN0aW9uOiBGYW5jeUFjdGlvbik6IG51bWJlciB7XG4gIC8vIG51bGwvdW5kZWZpbmVkIGlzIG9ubHkgdmFsaWQgYXMgYW4gaW5pdGlhbCBzdGF0ZSwgYW5kIEkgcHJlZmVyIHRvIGhhdmUgdW5kZWZpbmVkIGFzIHRoZSBmbG93dHlwZS5cbiAgaWYgKC9eKEBAcmVkdXhcXC98X18pLy50ZXN0KGFjdGlvbi50eXBlKSkgcmV0dXJuIChzdGF0ZSB8fCBudWxsOiBhbnkpXG4gIGlmIChhY3Rpb24uY3JlYXRlZEF0ID09IG51bGwpXG4gICAgcmV0dXJuIHRocm93cyhcImFjdGlvbi5jcmVhdGVkQXQgcmVxdWlyZWRcIiwge2FjdGlvbn0pXG4gIHN0YXRlID0gc3RhdGUgfHwgX2dldChhY3Rpb24ucm9vdCwge2NoYXJhY3RlcjogYWN0aW9uLmNoYXJhY3Rlcn0pXG4gIGlmIChzdGF0ZSA+IGFjdGlvbi5jcmVhdGVkQXQpXG4gICAgcmV0dXJuIHRocm93cyhcbiAgICAgIFwiYWN0aW9uLmNyZWF0ZWRBdCBpcyBlYXJsaWVyIHRoYW4gbGFzdEFjdGlvbkF0OyBjYW4ndCBydW4gYW4gYWN0aW9uIGluIHRoZSBwYXN0XCIsXG4gICAgICB7c3RhdGUsIGFjdGlvbn0sXG4gICAgKVxuICByZXR1cm4gYWN0aW9uLmNyZWF0ZWRBdFxufVxuIl19

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reify = exports.reifiedByName = exports.prodTotal = exports.prodEach = exports.velocity = exports.count = exports.velocities = exports.counts = exports.prodsEach = exports.Decimal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _growth = __webpack_require__(793);

var Growth = _interopRequireWildcard(_growth);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _stats = __webpack_require__(54);

var UnitStats = _interopRequireWildcard(_stats);

var _raw = __webpack_require__(220);

var RawUnit = _interopRequireWildcard(_raw);

var _updatedAt = __webpack_require__(219);

var UnitsUpdatedAt = _interopRequireWildcard(_updatedAt);

var _prodMultis = __webpack_require__(372);

var ProdMultis = _interopRequireWildcard(_prodMultis);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Decimal = exports.Decimal = UnitStats.Decimal;

var prodsEach = exports.prodsEach = (0, _reselect.createSelector)(UnitTypes.prods, ProdMultis.all, function (prodsEach, multis) {
  return _lodash2.default.mapValues(prodsEach, function (children, parent) {
    var multi = multis[parent] || 1;
    return _lodash2.default.mapValues(children, function (each, child) {
      return each.times(multi);
    });
  });
});

var growthCalc = (0, _reselect.createSelector)(prodsEach, UnitStats.rawCounts, function (prods, counts) {
  return new Growth.Production(prods, counts);
});

var counts = exports.counts = (0, _reselect.createSelector)(growthCalc, UnitsUpdatedAt.sinceUpdated, function (calc, dt) {
  return calc.countAt(Util.Duration.seconds.to(dt));
});
var velocities = exports.velocities = (0, _reselect.createSelector)(growthCalc, UnitsUpdatedAt.sinceUpdated, function (calc, dt) {
  return calc.velocityAt(Util.Duration.seconds.to(dt));
});

var unitName = function unitName(state, props) {
  return props.unitName;
};
var _countEach = function _countEach(counts, name) {
  return counts[name] || (0, _assert.throws)("no such unit", { counts: counts, name: name });
};
var count = exports.count = (0, _reselect.createSelector)(counts, unitName, _countEach);
var velocity = exports.velocity = (0, _reselect.createSelector)(velocities, unitName, _countEach);

var prodEach = exports.prodEach = (0, _reselect.createSelector)(prodsEach, unitName, _countEach);
var prodTotal = exports.prodTotal = (0, _reselect.createSelector)(prodEach, count, function (eaches, count) {
  return _lodash2.default.mapValues(eaches, function (each) {
    return count.times(each);
  });
});

// be careful about what keys we reify - don't save stats-entries needlessly,
// but don't omit any. Save anything with an entry already, or anything with
// an active parent - that's close enough to "anything with nonzero velocity".
var _nonzeros = function _nonzeros(cs) {
  return _lodash2.default.pickBy(cs, function (val) {
    return !val.isZero();
  });
};
//const nonzeroCounts = createSelector(counts, _nonzeros)
var nonzeroVelocities = (0, _reselect.createSelector)(velocities, _nonzeros);
var reifiedCounts = (0, _reselect.createSelector)(counts, nonzeroVelocities, RawUnit.get, function (counts, vs, stats0) {
  return _lodash2.default.pickBy(counts, function (c, unitName) {
    return unitName in vs || unitName in stats0;
  });
});
var reifiedByName = exports.reifiedByName = (0, _reselect.createSelector)(reifiedCounts, function (cs) {
  return _lodash2.default.mapValues(cs, function (c) {
    return !!c;
  });
});
var reify = exports.reify = (0, _reselect.createSelector)(RawUnit.get, reifiedCounts, function (stats0, counts) {
  return _lodash2.default.mapValues(counts, function (count, unitName) {
    var unitStats = stats0[unitName];
    return unitStats ? _extends({}, unitStats, { count: "" + count }) : UnitStats.init(count);
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = function identity(Component) {
  return Component;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || (0, _createEagerFactory2.default)(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || (0, _createEagerFactory2.default)(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

exports.default = branch;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(232);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(113);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(391);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(393);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
          _this.handleTouchTap(event);
        }
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
          _this.handleTouchTap(event);
        }
      }
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleTouchTap = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity,
          key: 'touchRipple'
        },
        children
      ) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleTouchTap,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(122);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(182);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(390);

var _assign2 = _interopRequireDefault(_assign);

exports.withOptions = withOptions;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(120);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _supports = __webpack_require__(874);

var supports = _interopRequireWildcard(_supports);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEventOptions = {
  capture: false,
  passive: false
};
/* eslint-disable prefer-spread */

function mergeDefaultEventOptions(options) {
  return (0, _assign2.default)({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(supports.passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  if (supports.addEventListener) {
    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.attachEvent) {
    // IE8+ Support
    target.attachEvent('on' + eventName, function () {
      callback.call(target);
    });
  }
}

function off(target, eventName, callback, options) {
  if (supports.removeEventListener) {
    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.detachEvent) {
    // IE8+ Support
    target.detachEvent('on' + eventName, callback);
  }
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);


  (0, _keys2.default)(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];
    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
    }
  });
}

function withOptions(handler, options) {
   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;

  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener = function (_Component) {
  (0, _inherits3.default)(EventListener, _Component);

  function EventListener() {
    (0, _classCallCheck3.default)(this, EventListener);
    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: 'applyListeners',
    value: function applyListeners(onOrOff) {
      var target = this.props.target;


      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return EventListener;
}(_react.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: _propTypes2.default.element,
  /**
   * The DOM target to listen to.
   */
  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
} : {};
exports.default = EventListener;

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
function Error(EM){return function Error(_ref){var error=_ref.error;// My handwritten error keys
if(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(error)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EM,{id:error});}// Errors returned from the Firebase server
if(error.code&&error.message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EM,{id:error.code,defaultMessage:error.message});}// Who knows?
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("pre",null,JSON.stringify(error,null,2));};}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*
 *
 *  decimal.js v7.2.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2017 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 *  https://github.com/MikeMcl/decimal.js/LICENCE
 *
 */


// -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


  // The maximum exponent magnitude.
  // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
var EXP_LIMIT = 9e15,                      // 0 to 9e15

  // The limit on the value of `precision`, and on the value of the first argument to
  // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
  MAX_DIGITS = 1e9,                        // 0 to 1e9

  // Base conversion alphabet.
  NUMERALS = '0123456789abcdef',

  // The natural logarithm of 10 (1025 digits).
  ln10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058',

  // Pi (1025 digits).
  pi = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789',


  // The initial configuration properties of the Decimal constructor.
  defaults = {

    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed at run-time using the `Decimal.config` method.

    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,                         // 1 to MAX_DIGITS

    // The rounding mode used when rounding to `precision`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,                           // 0 to 8

    // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP         0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
    // FLOOR      3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN  6 The IEEE 754 remainder function.
    // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
    //
    // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
    // division (9) are commonly used for the modulus operation. The other rounding modes can also
    // be used, but they may not give useful results.
    modulo: 1,                             // 0 to 9

    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,                          // 0 to -EXP_LIMIT

    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos:  21,                         // 0 to EXP_LIMIT

    // The minimum exponent value, beneath which underflow to zero occurs.
    // JavaScript numbers: -324  (5e-324)
    minE: -EXP_LIMIT,                      // -1 to -EXP_LIMIT

    // The maximum exponent value, above which overflow to Infinity occurs.
    // JavaScript numbers: 308  (1.7976931348623157e+308)
    maxE: EXP_LIMIT,                       // 1 to EXP_LIMIT

    // Whether to use cryptographically-secure random number generation, if available.
    crypto: false                          // true/false
  },


// ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


  Decimal, LN10, PI, inexact, quadrant,
  external = true,

  decimalError = '[DecimalError] ',
  invalidArgument = decimalError + 'Invalid argument: ',
  precisionLimitExceeded = decimalError + 'Precision limit exceeded',
  cryptoUnavailable = decimalError + 'crypto unavailable',

  mathfloor = Math.floor,
  mathpow = Math.pow,

  isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
  isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
  isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
  isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

  BASE = 1e7,
  LOG_BASE = 7,
  MAX_SAFE_INTEGER = 9007199254740991,

  LN10_PRECISION = ln10.length - 1,
  PI_PRECISION = pi.length - 1,

  // Decimal.prototype object
  P = {};


// Decimal prototype methods


/*
 *  absoluteValue             abs
 *  ceil
 *  comparedTo                cmp
 *  cosine                    cos
 *  cubeRoot                  cbrt
 *  decimalPlaces             dp
 *  dividedBy                 div
 *  dividedToIntegerBy        divToInt
 *  equals                    eq
 *  floor
 *  greaterThan               gt
 *  greaterThanOrEqualTo      gte
 *  hyperbolicCosine          cosh
 *  hyperbolicSine            sinh
 *  hyperbolicTangent         tanh
 *  inverseCosine             acos
 *  inverseHyperbolicCosine   acosh
 *  inverseHyperbolicSine     asinh
 *  inverseHyperbolicTangent  atanh
 *  inverseSine               asin
 *  inverseTangent            atan
 *  isFinite
 *  isInteger                 isInt
 *  isNaN
 *  isNegative                isNeg
 *  isPositive                isPos
 *  isZero
 *  lessThan                  lt
 *  lessThanOrEqualTo         lte
 *  logarithm                 log
 *  [maximum]                 [max]
 *  [minimum]                 [min]
 *  minus                     sub
 *  modulo                    mod
 *  naturalExponential        exp
 *  naturalLogarithm          ln
 *  negated                   neg
 *  plus                      add
 *  precision                 sd
 *  round
 *  sine                      sin
 *  squareRoot                sqrt
 *  tangent                   tan
 *  times                     mul
 *  toBinary
 *  toDecimalPlaces           toDP
 *  toExponential
 *  toFixed
 *  toFraction
 *  toHexadecimal             toHex
 *  toNearest
 *  toNumber
 *  toOctal
 *  toPower                   pow
 *  toPrecision
 *  toSignificantDigits       toSD
 *  toString
 *  truncated                 trunc
 *  valueOf                   toJSON
 */


/*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */
P.absoluteValue = P.abs = function () {
  var x = new this.constructor(this);
  if (x.s < 0) x.s = 1;
  return finalise(x);
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
 * direction of positive Infinity.
 *
 */
P.ceil = function () {
  return finalise(new this.constructor(this), this.e + 1, 2);
};


/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value,
 *   NaN  if the value of either Decimal is NaN.
 *
 */
P.comparedTo = P.cmp = function (y) {
  var i, j, xdL, ydL,
    x = this,
    xd = x.d,
    yd = (y = new x.constructor(y)).d,
    xs = x.s,
    ys = y.s;

  // Either NaN or ±Infinity?
  if (!xd || !yd) {
    return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
  }

  // Either zero?
  if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;

  // Signs differ?
  if (xs !== ys) return xs;

  // Compare exponents.
  if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;

  xdL = xd.length;
  ydL = yd.length;

  // Compare digit by digit.
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
  }

  // Compare lengths.
  return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
};


/*
 * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * cos(0)         = 1
 * cos(-0)        = 1
 * cos(Infinity)  = NaN
 * cos(-Infinity) = NaN
 * cos(NaN)       = NaN
 *
 */
P.cosine = P.cos = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (!x.d) return new Ctor(NaN);

  // cos(0) = cos(-0) = 1
  if (!x.d[0]) return new Ctor(1);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;

  x = cosine(Ctor, toLessThanHalfPi(Ctor, x));

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
};


/*
 *
 * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 *  cbrt(0)  =  0
 *  cbrt(-0) = -0
 *  cbrt(1)  =  1
 *  cbrt(-1) = -1
 *  cbrt(N)  =  N
 *  cbrt(-I) = -I
 *  cbrt(I)  =  I
 *
 * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
 *
 */
P.cubeRoot = P.cbrt = function () {
  var e, m, n, r, rep, s, sd, t, t3, t3plusx,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  external = false;

  // Initial estimate.
  s = x.s * Math.pow(x.s * x, 1 / 3);

   // Math.cbrt underflow/overflow?
   // Pass x to Math.pow as integer, then adjust the exponent of the result.
  if (!s || Math.abs(s) == 1 / 0) {
    n = digitsToString(x.d);
    e = x.e;

    // Adjust n exponent so it is a multiple of 3 away from x exponent.
    if (s = (e - n.length + 1) % 3) n += (s == 1 || s == -2 ? '0' : '00');
    s = Math.pow(n, 1 / 3);

    // Rarely, e may be one less than the result exponent value.
    e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));

    if (s == 1 / 0) {
      n = '5e' + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf('e') + 1) + e;
    }

    r = new Ctor(n);
    r.s = x.s;
  } else {
    r = new Ctor(s.toString());
  }

  sd = (e = Ctor.precision) + 3;

  // Halley's method.
  // TODO? Compare Newton's method.
  for (;;) {
    t = r;
    t3 = t.times(t).times(t);
    t3plusx = t3.plus(x);
    r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);

    // TODO? Replace with for-loop and checkRoundingDigits.
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);

      // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
      // , i.e. approaching a rounding boundary, continue the iteration.
      if (n == '9999' || !rep && n == '4999') {

        // On the first iteration only, check to see if rounding up gives the exact result as the
        // nines may infinitely repeat.
        if (!rep) {
          finalise(t, e + 1, 0);

          if (t.times(t).times(t).eq(x)) {
            r = t;
            break;
          }
        }

        sd += 4;
        rep = 1;
      } else {

        // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
        // If not, then there are further digits and m will be truthy.
        if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

          // Truncate to the first rounding digit.
          finalise(r, e + 1, 1);
          m = !r.times(r).times(r).eq(x);
        }

        break;
      }
    }
  }

  external = true;

  return finalise(r, e, Ctor.rounding, m);
};


/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */
P.decimalPlaces = P.dp = function () {
  var w,
    d = this.d,
    n = NaN;

  if (d) {
    w = d.length - 1;
    n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;

    // Subtract the number of trailing zeros of the last word.
    w = d[w];
    if (w) for (; w % 10 == 0; w /= 10) n--;
    if (n < 0) n = 0;
  }

  return n;
};


/*
 *  n / 0 = I
 *  n / N = N
 *  n / I = 0
 *  0 / n = 0
 *  0 / 0 = N
 *  0 / N = N
 *  0 / I = 0
 *  N / n = N
 *  N / 0 = N
 *  N / N = N
 *  N / I = N
 *  I / n = I
 *  I / 0 = I
 *  I / N = N
 *  I / I = N
 *
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 */
P.dividedBy = P.div = function (y) {
  return divide(this, new this.constructor(y));
};


/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
 *
 */
P.dividedToIntegerBy = P.divToInt = function (y) {
  var x = this,
    Ctor = x.constructor;
  return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
};


/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */
P.equals = P.eq = function (y) {
  return this.cmp(y) === 0;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
 * direction of negative Infinity.
 *
 */
P.floor = function () {
  return finalise(new this.constructor(this), this.e + 1, 3);
};


/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */
P.greaterThan = P.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */
P.greaterThanOrEqualTo = P.gte = function (y) {
  var k = this.cmp(y);
  return k == 1 || k === 0;
};


/*
 * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [1, Infinity]
 *
 * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
 *
 * cosh(0)         = 1
 * cosh(-0)        = 1
 * cosh(Infinity)  = Infinity
 * cosh(-Infinity) = Infinity
 * cosh(NaN)       = NaN
 *
 *  x        time taken (ms)   result
 * 1000      9                 9.8503555700852349694e+433
 * 10000     25                4.4034091128314607936e+4342
 * 100000    171               1.4033316802130615897e+43429
 * 1000000   3817              1.5166076984010437725e+434294
 * 10000000  abandoned after 2 minute wait
 *
 * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
 *
 */
P.hyperbolicCosine = P.cosh = function () {
  var k, n, pr, rm, len,
    x = this,
    Ctor = x.constructor,
    one = new Ctor(1);

  if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
  if (x.isZero()) return one;

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;

  // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
  // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))

  // Estimate the optimum number of times to use the argument reduction.
  // TODO? Estimation reused from cosine() and may not be optimal here.
  if (len < 32) {
    k = Math.ceil(len / 3);
    n = Math.pow(4, -k).toString();
  } else {
    k = 16;
    n = '2.3283064365386962890625e-10';
  }

  x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);

  // Reverse argument reduction
  var cosh2_x,
    i = k,
    d8 = new Ctor(8);
  for (; i--;) {
    cosh2_x = x.times(x);
    x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
  }

  return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
};


/*
 * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
 *
 * sinh(0)         = 0
 * sinh(-0)        = -0
 * sinh(Infinity)  = Infinity
 * sinh(-Infinity) = -Infinity
 * sinh(NaN)       = NaN
 *
 * x        time taken (ms)
 * 10       2 ms
 * 100      5 ms
 * 1000     14 ms
 * 10000    82 ms
 * 100000   886 ms            1.4033316802130615897e+43429
 * 200000   2613 ms
 * 300000   5407 ms
 * 400000   8824 ms
 * 500000   13026 ms          8.7080643612718084129e+217146
 * 1000000  48543 ms
 *
 * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
 *
 */
P.hyperbolicSine = P.sinh = function () {
  var k, pr, rm, len,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite() || x.isZero()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;

  if (len < 3) {
    x = taylorSeries(Ctor, 2, x, x, true);
  } else {

    // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
    // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
    // 3 multiplications and 1 addition

    // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
    // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
    // 4 multiplications and 2 additions

    // Estimate the optimum number of times to use the argument reduction.
    k = 1.4 * Math.sqrt(len);
    k = k > 16 ? 16 : k | 0;

    x = x.times(Math.pow(5, -k));

    x = taylorSeries(Ctor, 2, x, x, true);

    // Reverse argument reduction
    var sinh2_x,
      d5 = new Ctor(5),
      d16 = new Ctor(16),
      d20 = new Ctor(20);
    for (; k--;) {
      sinh2_x = x.times(x);
      x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
    }
  }

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return finalise(x, pr, rm, true);
};


/*
 * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * tanh(x) = sinh(x) / cosh(x)
 *
 * tanh(0)         = 0
 * tanh(-0)        = -0
 * tanh(Infinity)  = 1
 * tanh(-Infinity) = -1
 * tanh(NaN)       = NaN
 *
 */
P.hyperbolicTangent = P.tanh = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite()) return new Ctor(x.s);
  if (x.isZero()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 7;
  Ctor.rounding = 1;

  return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
};


/*
 * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
 * this Decimal.
 *
 * Domain: [-1, 1]
 * Range: [0, pi]
 *
 * acos(x) = pi/2 - asin(x)
 *
 * acos(0)       = pi/2
 * acos(-0)      = pi/2
 * acos(1)       = 0
 * acos(-1)      = pi
 * acos(1/2)     = pi/3
 * acos(-1/2)    = 2*pi/3
 * acos(|x| > 1) = NaN
 * acos(NaN)     = NaN
 *
 */
P.inverseCosine = P.acos = function () {
  var halfPi,
    x = this,
    Ctor = x.constructor,
    k = x.abs().cmp(1),
    pr = Ctor.precision,
    rm = Ctor.rounding;

  if (k !== -1) {
    return k === 0
      // |x| is 1
      ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0)
      // |x| > 1 or x is NaN
      : new Ctor(NaN);
  }

  if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);

  // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3

  Ctor.precision = pr + 6;
  Ctor.rounding = 1;

  x = x.asin();
  halfPi = getPi(Ctor, pr + 4, rm).times(0.5);

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return halfPi.minus(x);
};


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
 * value of this Decimal.
 *
 * Domain: [1, Infinity]
 * Range: [0, Infinity]
 *
 * acosh(x) = ln(x + sqrt(x^2 - 1))
 *
 * acosh(x < 1)     = NaN
 * acosh(NaN)       = NaN
 * acosh(Infinity)  = Infinity
 * acosh(-Infinity) = NaN
 * acosh(0)         = NaN
 * acosh(-0)        = NaN
 * acosh(1)         = 0
 * acosh(-1)        = NaN
 *
 */
P.inverseHyperbolicCosine = P.acosh = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
  if (!x.isFinite()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
  Ctor.rounding = 1;
  external = false;

  x = x.times(x).minus(1).sqrt().plus(x);

  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;

  return x.ln();
};


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
 * of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * asinh(x) = ln(x + sqrt(x^2 + 1))
 *
 * asinh(NaN)       = NaN
 * asinh(Infinity)  = Infinity
 * asinh(-Infinity) = -Infinity
 * asinh(0)         = 0
 * asinh(-0)        = -0
 *
 */
P.inverseHyperbolicSine = P.asinh = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite() || x.isZero()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
  Ctor.rounding = 1;
  external = false;

  x = x.times(x).plus(1).sqrt().plus(x);

  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;

  return x.ln();
};


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
 * value of this Decimal.
 *
 * Domain: [-1, 1]
 * Range: [-Infinity, Infinity]
 *
 * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
 *
 * atanh(|x| > 1)   = NaN
 * atanh(NaN)       = NaN
 * atanh(Infinity)  = NaN
 * atanh(-Infinity) = NaN
 * atanh(0)         = 0
 * atanh(-0)        = -0
 * atanh(1)         = Infinity
 * atanh(-1)        = -Infinity
 *
 */
P.inverseHyperbolicTangent = P.atanh = function () {
  var pr, rm, wpr, xsd,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite()) return new Ctor(NaN);
  if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  xsd = x.sd();

  if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);

  Ctor.precision = wpr = xsd - x.e;

  x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);

  Ctor.precision = pr + 4;
  Ctor.rounding = 1;

  x = x.ln();

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return x.times(0.5);
};


/*
 * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
 * Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi/2, pi/2]
 *
 * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
 *
 * asin(0)       = 0
 * asin(-0)      = -0
 * asin(1/2)     = pi/6
 * asin(-1/2)    = -pi/6
 * asin(1)       = pi/2
 * asin(-1)      = -pi/2
 * asin(|x| > 1) = NaN
 * asin(NaN)     = NaN
 *
 * TODO? Compare performance of Taylor series.
 *
 */
P.inverseSine = P.asin = function () {
  var halfPi, k,
    pr, rm,
    x = this,
    Ctor = x.constructor;

  if (x.isZero()) return new Ctor(x);

  k = x.abs().cmp(1);
  pr = Ctor.precision;
  rm = Ctor.rounding;

  if (k !== -1) {

    // |x| is 1
    if (k === 0) {
      halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
      halfPi.s = x.s;
      return halfPi;
    }

    // |x| > 1 or x is NaN
    return new Ctor(NaN);
  }

  // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6

  Ctor.precision = pr + 6;
  Ctor.rounding = 1;

  x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return x.times(2);
};


/*
 * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
 * of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi/2, pi/2]
 *
 * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
 *
 * atan(0)         = 0
 * atan(-0)        = -0
 * atan(1)         = pi/4
 * atan(-1)        = -pi/4
 * atan(Infinity)  = pi/2
 * atan(-Infinity) = -pi/2
 * atan(NaN)       = NaN
 *
 */
P.inverseTangent = P.atan = function () {
  var i, j, k, n, px, t, r, wpr, x2,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision,
    rm = Ctor.rounding;

  if (!x.isFinite()) {
    if (!x.s) return new Ctor(NaN);
    if (pr + 4 <= PI_PRECISION) {
      r = getPi(Ctor, pr + 4, rm).times(0.5);
      r.s = x.s;
      return r;
    }
  } else if (x.isZero()) {
    return new Ctor(x);
  } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
    r = getPi(Ctor, pr + 4, rm).times(0.25);
    r.s = x.s;
    return r;
  }

  Ctor.precision = wpr = pr + 10;
  Ctor.rounding = 1;

  // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);

  // Argument reduction
  // Ensure |x| < 0.42
  // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))

  k = Math.min(28, wpr / LOG_BASE + 2 | 0);

  for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));

  external = false;

  j = Math.ceil(wpr / LOG_BASE);
  n = 1;
  x2 = x.times(x);
  r = new Ctor(x);
  px = x;

  // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
  for (; i !== -1;) {
    px = px.times(x2);
    t = r.minus(px.div(n += 2));

    px = px.times(x2);
    r = t.plus(px.div(n += 2));

    if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--;);
  }

  if (k) r = r.times(2 << (k - 1));

  external = true;

  return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
};


/*
 * Return true if the value of this Decimal is a finite number, otherwise return false.
 *
 */
P.isFinite = function () {
  return !!this.d;
};


/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */
P.isInteger = P.isInt = function () {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};


/*
 * Return true if the value of this Decimal is NaN, otherwise return false.
 *
 */
P.isNaN = function () {
  return !this.s;
};


/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */
P.isNegative = P.isNeg = function () {
  return this.s < 0;
};


/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */
P.isPositive = P.isPos = function () {
  return this.s > 0;
};


/*
 * Return true if the value of this Decimal is 0 or -0, otherwise return false.
 *
 */
P.isZero = function () {
  return !!this.d && this.d[0] === 0;
};


/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */
P.lessThan = P.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */
P.lessThanOrEqualTo = P.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * If no base is specified, return log[10](arg).
 *
 * log[base](arg) = ln(arg) / ln(base)
 *
 * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
 * otherwise:
 *
 * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
 * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
 * between the result and the correctly rounded result will be one ulp (unit in the last place).
 *
 * log[-b](a)       = NaN
 * log[0](a)        = NaN
 * log[1](a)        = NaN
 * log[NaN](a)      = NaN
 * log[Infinity](a) = NaN
 * log[b](0)        = -Infinity
 * log[b](-0)       = -Infinity
 * log[b](-a)       = NaN
 * log[b](1)        = 0
 * log[b](Infinity) = Infinity
 * log[b](NaN)      = NaN
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */
P.logarithm = P.log = function (base) {
  var isBase10, d, denominator, k, inf, num, sd, r,
    arg = this,
    Ctor = arg.constructor,
    pr = Ctor.precision,
    rm = Ctor.rounding,
    guard = 5;

  // Default base is 10.
  if (base == null) {
    base = new Ctor(10);
    isBase10 = true;
  } else {
    base = new Ctor(base);
    d = base.d;

    // Return NaN if base is negative, or non-finite, or is 0 or 1.
    if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);

    isBase10 = base.eq(10);
  }

  d = arg.d;

  // Is arg negative, non-finite, 0 or 1?
  if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
    return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
  }

  // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
  // integer power of 10.
  if (isBase10) {
    if (d.length > 1) {
      inf = true;
    } else {
      for (k = d[0]; k % 10 === 0;) k /= 10;
      inf = k !== 1;
    }
  }

  external = false;
  sd = pr + guard;
  num = naturalLogarithm(arg, sd);
  denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);

  // The result will have 5 rounding digits.
  r = divide(num, denominator, sd, 1);

  // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
  // calculate 10 further digits.
  //
  // If the result is known to have an infinite decimal expansion, repeat this until it is clear
  // that the result is above or below the boundary. Otherwise, if after calculating the 10
  // further digits, the last 14 are nines, round up and assume the result is exact.
  // Also assume the result is exact if the last 14 are zero.
  //
  // Example of a result that will be incorrectly rounded:
  // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
  // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
  // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
  // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
  // place is still 2.6.
  if (checkRoundingDigits(r.d, k = pr, rm)) {

    do {
      sd += 10;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
      r = divide(num, denominator, sd, 1);

      if (!inf) {

        // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
        if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
          r = finalise(r, pr + 1, 0);
        }

        break;
      }
    } while (checkRoundingDigits(r.d, k += 10, rm));
  }

  external = true;

  return finalise(r, pr, rm);
};


/*
 * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
 *
 * arguments {number|string|Decimal}
 *
P.max = function () {
  Array.prototype.push.call(arguments, this);
  return maxOrMin(this.constructor, arguments, 'lt');
};
 */


/*
 * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
 *
 * arguments {number|string|Decimal}
 *
P.min = function () {
  Array.prototype.push.call(arguments, this);
  return maxOrMin(this.constructor, arguments, 'gt');
};
 */


/*
 *  n - 0 = n
 *  n - N = N
 *  n - I = -I
 *  0 - n = -n
 *  0 - 0 = 0
 *  0 - N = N
 *  0 - I = -I
 *  N - n = N
 *  N - 0 = N
 *  N - N = N
 *  N - I = N
 *  I - n = I
 *  I - 0 = I
 *  I - N = N
 *  I - I = N
 *
 * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */
P.minus = P.sub = function (y) {
  var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd,
    x = this,
    Ctor = x.constructor;

  y = new Ctor(y);

  // If either is not finite...
  if (!x.d || !y.d) {

    // Return NaN if either is NaN.
    if (!x.s || !y.s) y = new Ctor(NaN);

    // Return y negated if x is finite and y is ±Infinity.
    else if (x.d) y.s = -y.s;

    // Return x if y is finite and x is ±Infinity.
    // Return x if both are ±Infinity with different signs.
    // Return NaN if both are ±Infinity with the same sign.
    else y = new Ctor(y.d || x.s !== y.s ? x : NaN);

    return y;
  }

  // If signs differ...
  if (x.s != y.s) {
    y.s = -y.s;
    return x.plus(y);
  }

  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;

  // If either is zero...
  if (!xd[0] || !yd[0]) {

    // Return y negated if x is zero and y is non-zero.
    if (yd[0]) y.s = -y.s;

    // Return x if y is zero and x is non-zero.
    else if (xd[0]) y = new Ctor(x);

    // Return zero if both are zero.
    // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
    else return new Ctor(rm === 3 ? -0 : 0);

    return external ? finalise(y, pr, rm) : y;
  }

  // x and y are finite, non-zero numbers with the same sign.

  // Calculate base 1e7 exponents.
  e = mathfloor(y.e / LOG_BASE);
  xe = mathfloor(x.e / LOG_BASE);

  xd = xd.slice();
  k = xe - e;

  // If base 1e7 exponents differ...
  if (k) {
    xLTy = k < 0;

    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }

    // Numbers with massively different exponents would result in a very high number of
    // zeros needing to be prepended, but this can be avoided while still ensuring correct
    // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

    if (k > i) {
      k = i;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents.
    d.reverse();
    for (i = k; i--;) d.push(0);
    d.reverse();

  // Base 1e7 exponents equal.
  } else {

    // Check digits to determine which is the bigger number.

    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;

    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }

    k = 0;
  }

  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }

  len = xd.length;

  // Append zeros to `xd` if shorter.
  // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

  // Subtract yd from xd.
  for (i = yd.length; i > k;) {

    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }

    xd[i] -= yd[i];
  }

  // Remove trailing zeros.
  for (; xd[--len] === 0;) xd.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xd[0] === 0; xd.shift()) --e;

  // Zero?
  if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);

  y.d = xd;
  y.e = getBase10Exponent(xd, e);

  return external ? finalise(y, pr, rm) : y;
};


/*
 *   n % 0 =  N
 *   n % N =  N
 *   n % I =  n
 *   0 % n =  0
 *  -0 % n = -0
 *   0 % 0 =  N
 *   0 % N =  N
 *   0 % I =  0
 *   N % n =  N
 *   N % 0 =  N
 *   N % N =  N
 *   N % I =  N
 *   I % n =  N
 *   I % 0 =  N
 *   I % N =  N
 *   I % I =  N
 *
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * The result depends on the modulo mode.
 *
 */
P.modulo = P.mod = function (y) {
  var q,
    x = this,
    Ctor = x.constructor;

  y = new Ctor(y);

  // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
  if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);

  // Return x if y is ±Infinity or x is ±0.
  if (!y.d || x.d && !x.d[0]) {
    return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
  }

  // Prevent rounding of intermediate calculations.
  external = false;

  if (Ctor.modulo == 9) {

    // Euclidian division: q = sign(y) * floor(x / abs(y))
    // result = x - q * y    where  0 <= result < abs(y)
    q = divide(x, y.abs(), 0, 3, 1);
    q.s *= y.s;
  } else {
    q = divide(x, y, 0, Ctor.modulo, 1);
  }

  q = q.times(y);

  external = true;

  return x.minus(q);
};


/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */
P.naturalExponential = P.exp = function () {
  return naturalExponential(this);
};


/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * rounded to `precision` significant digits using rounding mode `rounding`.
 *
 */
P.naturalLogarithm = P.ln = function () {
  return naturalLogarithm(this);
};


/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */
P.negated = P.neg = function () {
  var x = new this.constructor(this);
  x.s = -x.s;
  return finalise(x);
};


/*
 *  n + 0 = n
 *  n + N = N
 *  n + I = I
 *  0 + n = n
 *  0 + 0 = 0
 *  0 + N = N
 *  0 + I = I
 *  N + n = N
 *  N + 0 = N
 *  N + N = N
 *  N + I = N
 *  I + n = I
 *  I + 0 = I
 *  I + N = N
 *  I + I = I
 *
 * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 */
P.plus = P.add = function (y) {
  var carry, d, e, i, k, len, pr, rm, xd, yd,
    x = this,
    Ctor = x.constructor;

  y = new Ctor(y);

  // If either is not finite...
  if (!x.d || !y.d) {

    // Return NaN if either is NaN.
    if (!x.s || !y.s) y = new Ctor(NaN);

    // Return x if y is finite and x is ±Infinity.
    // Return x if both are ±Infinity with the same sign.
    // Return NaN if both are ±Infinity with different signs.
    // Return y if x is finite and y is ±Infinity.
    else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);

    return y;
  }

   // If signs differ...
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }

  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;

  // If either is zero...
  if (!xd[0] || !yd[0]) {

    // Return x if y is zero.
    // Return y if y is non-zero.
    if (!yd[0]) y = new Ctor(x);

    return external ? finalise(y, pr, rm) : y;
  }

  // x and y are finite, non-zero numbers with the same sign.

  // Calculate base 1e7 exponents.
  k = mathfloor(x.e / LOG_BASE);
  e = mathfloor(y.e / LOG_BASE);

  xd = xd.slice();
  i = k - e;

  // If base 1e7 exponents differ...
  if (i) {

    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }

    // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;

    if (i > len) {
      i = len;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
    d.reverse();
    for (; i--;) d.push(0);
    d.reverse();
  }

  len = xd.length;
  i = yd.length;

  // If yd is longer than xd, swap xd and yd so xd points to the longer array.
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }

  // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
  for (carry = 0; i;) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }

  if (carry) {
    xd.unshift(carry);
    ++e;
  }

  // Remove trailing zeros.
  // No need to check for zero, as +x + +y != 0 && -x + -y != 0
  for (len = xd.length; xd[--len] == 0;) xd.pop();

  y.d = xd;
  y.e = getBase10Exponent(xd, e);

  return external ? finalise(y, pr, rm) : y;
};


/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */
P.precision = P.sd = function (z) {
  var k,
    x = this;

  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

  if (x.d) {
    k = getPrecision(x.d);
    if (z && x.e + 1 > k) k = x.e + 1;
  } else {
    k = NaN;
  }

  return k;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */
P.round = function () {
  var x = this,
    Ctor = x.constructor;

  return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
};


/*
 * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-1, 1]
 *
 * sin(x) = x - x^3/3! + x^5/5! - ...
 *
 * sin(0)         = 0
 * sin(-0)        = -0
 * sin(Infinity)  = NaN
 * sin(-Infinity) = NaN
 * sin(NaN)       = NaN
 *
 */
P.sine = P.sin = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;

  x = sine(Ctor, toLessThanHalfPi(Ctor, x));

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
};


/*
 * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 *  sqrt(-n) =  N
 *  sqrt(N)  =  N
 *  sqrt(-I) =  N
 *  sqrt(I)  =  I
 *  sqrt(0)  =  0
 *  sqrt(-0) = -0
 *
 */
P.squareRoot = P.sqrt = function () {
  var m, n, sd, r, rep, t,
    x = this,
    d = x.d,
    e = x.e,
    s = x.s,
    Ctor = x.constructor;

  // Negative/NaN/Infinity/zero?
  if (s !== 1 || !d || !d[0]) {
    return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
  }

  external = false;

  // Initial estimate.
  s = Math.sqrt(+x);

  // Math.sqrt underflow/overflow?
  // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(d);

    if ((n.length + e) % 2 == 0) n += '0';
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

    if (s == 1 / 0) {
      n = '1e' + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf('e') + 1) + e;
    }

    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }

  sd = (e = Ctor.precision) + 3;

  // Newton-Raphson iteration.
  for (;;) {
    t = r;
    r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);

    // TODO? Replace with for-loop and checkRoundingDigits.
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);

      // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
      // 4999, i.e. approaching a rounding boundary, continue the iteration.
      if (n == '9999' || !rep && n == '4999') {

        // On the first iteration only, check to see if rounding up gives the exact result as the
        // nines may infinitely repeat.
        if (!rep) {
          finalise(t, e + 1, 0);

          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        }

        sd += 4;
        rep = 1;
      } else {

        // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
        // If not, then there are further digits and m will be truthy.
        if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

          // Truncate to the first rounding digit.
          finalise(r, e + 1, 1);
          m = !r.times(r).eq(x);
        }

        break;
      }
    }
  }

  external = true;

  return finalise(r, e, Ctor.rounding, m);
};


/*
 * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-Infinity, Infinity]
 *
 * tan(0)         = 0
 * tan(-0)        = -0
 * tan(Infinity)  = NaN
 * tan(-Infinity) = NaN
 * tan(NaN)       = NaN
 *
 */
P.tangent = P.tan = function () {
  var pr, rm,
    x = this,
    Ctor = x.constructor;

  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);

  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 10;
  Ctor.rounding = 1;

  x = x.sin();
  x.s = 1;
  x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);

  Ctor.precision = pr;
  Ctor.rounding = rm;

  return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
};


/*
 *  n * 0 = 0
 *  n * N = N
 *  n * I = I
 *  0 * n = 0
 *  0 * 0 = 0
 *  0 * N = N
 *  0 * I = N
 *  N * n = N
 *  N * 0 = N
 *  N * N = N
 *  N * I = N
 *  I * n = I
 *  I * 0 = N
 *  I * N = N
 *  I * I = I
 *
 * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 */
P.times = P.mul = function (y) {
  var carry, e, i, k, r, rL, t, xdL, ydL,
    x = this,
    Ctor = x.constructor,
    xd = x.d,
    yd = (y = new Ctor(y)).d;

  y.s *= x.s;

   // If either is NaN, ±Infinity or ±0...
  if (!xd || !xd[0] || !yd || !yd[0]) {

    return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd

      // Return NaN if either is NaN.
      // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
      ? NaN

      // Return ±Infinity if either is ±Infinity.
      // Return ±0 if either is ±0.
      : !xd || !yd ? y.s / 0 : y.s * 0);
  }

  e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
  xdL = xd.length;
  ydL = yd.length;

  // Ensure xd points to the longer array.
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }

  // Initialise the result array with zeros.
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--;) r.push(0);

  // Multiply!
  for (i = ydL; --i >= 0;) {
    carry = 0;
    for (k = xdL + i; k > i;) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = t / BASE | 0;
    }

    r[k] = (r[k] + carry) % BASE | 0;
  }

  // Remove trailing zeros.
  for (; !r[--rL];) r.pop();

  if (carry) ++e;
  else r.shift();

  y.d = r;
  y.e = getBase10Exponent(r, e);

  return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
};


/*
 * Return a string representing the value of this Decimal in base 2, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toBinary = function (sd, rm) {
  return toStringBinary(this, 2, sd, rm);
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toDecimalPlaces = P.toDP = function (dp, rm) {
  var x = this,
    Ctor = x.constructor;

  x = new Ctor(x);
  if (dp === void 0) return x;

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  return finalise(x, dp + x.e + 1, rm);
};


/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toExponential = function (dp, rm) {
  var str,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) {
    str = finiteToString(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = finalise(new Ctor(x), dp + 1, rm);
    str = finiteToString(x, true, dp + 1);
  }

  return x.isNeg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */
P.toFixed = function (dp, rm) {
  var str, y,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) {
    str = finiteToString(x);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    y = finalise(new Ctor(x), dp + x.e + 1, rm);
    str = finiteToString(y, false, dp + y.e + 1);
  }

  // To determine whether to add the minus sign look at the value before it was rounded,
  // i.e. look at `x` rather than `y`.
  return x.isNeg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return an array representing the value of this Decimal as a simple fraction with an integer
 * numerator and an integer denominator.
 *
 * The denominator will be a positive non-zero value less than or equal to the specified maximum
 * denominator. If a maximum denominator is not specified, the denominator will be the lowest
 * value necessary to represent the number exactly.
 *
 * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
 *
 */
P.toFraction = function (maxD) {
  var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r,
    x = this,
    xd = x.d,
    Ctor = x.constructor;

  if (!xd) return new Ctor(x);

  n1 = d0 = new Ctor(1);
  d1 = n0 = new Ctor(0);

  d = new Ctor(d1);
  e = d.e = getPrecision(xd) - x.e - 1;
  k = e % LOG_BASE;
  d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);

  if (maxD == null) {

    // d is 10**e, the minimum max-denominator needed.
    maxD = e > 0 ? d : n1;
  } else {
    n = new Ctor(maxD);
    if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
    maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
  }

  external = false;
  n = new Ctor(digitsToString(xd));
  pr = Ctor.precision;
  Ctor.precision = e = xd.length * LOG_BASE * 2;

  for (;;)  {
    q = divide(n, d, 0, 1, 1);
    d2 = d0.plus(q.times(d1));
    if (d2.cmp(maxD) == 1) break;
    d0 = d1;
    d1 = d2;
    d2 = n1;
    n1 = n0.plus(q.times(d2));
    n0 = d2;
    d2 = d;
    d = n.minus(q.times(d2));
    n = d2;
  }

  d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
  n0 = n0.plus(d2.times(n1));
  d0 = d0.plus(d2.times(d1));
  n0.s = n1.s = x.s;

  // Determine which fraction is closer to x, n0/d0 or n1/d1?
  r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
      ? [n1, d1] : [n0, d0];

  Ctor.precision = pr;
  external = true;

  return r;
};


/*
 * Return a string representing the value of this Decimal in base 16, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toHexadecimal = P.toHex = function (sd, rm) {
  return toStringBinary(this, 16, sd, rm);
};



/*
 * Returns a new Decimal whose value is the nearest multiple of the magnitude of `y` to the value
 * of this Decimal.
 *
 * If the value of this Decimal is equidistant from two multiples of `y`, the rounding mode `rm`,
 * or `Decimal.rounding` if `rm` is omitted, determines the direction of the nearest multiple.
 *
 * In the context of this method, rounding mode 4 (ROUND_HALF_UP) is the same as rounding mode 0
 * (ROUND_UP), and so on.
 *
 * The return value will always have the same sign as this Decimal, unless either this Decimal
 * or `y` is NaN, in which case the return value will be also be NaN.
 *
 * The return value is not affected by the value of `precision`.
 *
 * y {number|string|Decimal} The magnitude to round to a multiple of.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * 'toNearest() rounding mode not an integer: {rm}'
 * 'toNearest() rounding mode out of range: {rm}'
 *
 */
P.toNearest = function (y, rm) {
  var x = this,
    Ctor = x.constructor;

  x = new Ctor(x);

  if (y == null) {

    // If x is not finite, return x.
    if (!x.d) return x;

    y = new Ctor(1);
    rm = Ctor.rounding;
  } else {
    y = new Ctor(y);
    if (rm !== void 0) checkInt32(rm, 0, 8);

    // If x is not finite, return x if y is not NaN, else NaN.
    if (!x.d) return y.s ? x : y;

    // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
    if (!y.d) {
      if (y.s) y.s = x.s;
      return y;
    }
  }

  // If y is not zero, calculate the nearest multiple of y to x.
  if (y.d[0]) {
    external = false;
    if (rm < 4) rm = [4, 5, 7, 8][rm];
    x = divide(x, y, 0, rm, 1).times(y);
    external = true;
    finalise(x);

  // If y is zero, return zero with the sign of x.
  } else {
    y.s = x.s;
    x = y;
  }

  return x;
};


/*
 * Return the value of this Decimal converted to a number primitive.
 * Zero keeps its sign.
 *
 */
P.toNumber = function () {
  return +this;
};


/*
 * Return a string representing the value of this Decimal in base 8, round to `sd` significant
 * digits using rounding mode `rm`.
 *
 * If the optional `sd` argument is present then return binary exponential notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toOctal = function (sd, rm) {
  return toStringBinary(this, 8, sd, rm);
};


/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
 * to `precision` significant digits using rounding mode `rounding`.
 *
 * ECMAScript compliant.
 *
 *   pow(x, NaN)                           = NaN
 *   pow(x, ±0)                            = 1

 *   pow(NaN, non-zero)                    = NaN
 *   pow(abs(x) > 1, +Infinity)            = +Infinity
 *   pow(abs(x) > 1, -Infinity)            = +0
 *   pow(abs(x) == 1, ±Infinity)           = NaN
 *   pow(abs(x) < 1, +Infinity)            = +0
 *   pow(abs(x) < 1, -Infinity)            = +Infinity
 *   pow(+Infinity, y > 0)                 = +Infinity
 *   pow(+Infinity, y < 0)                 = +0
 *   pow(-Infinity, odd integer > 0)       = -Infinity
 *   pow(-Infinity, even integer > 0)      = +Infinity
 *   pow(-Infinity, odd integer < 0)       = -0
 *   pow(-Infinity, even integer < 0)      = +0
 *   pow(+0, y > 0)                        = +0
 *   pow(+0, y < 0)                        = +Infinity
 *   pow(-0, odd integer > 0)              = -0
 *   pow(-0, even integer > 0)             = +0
 *   pow(-0, odd integer < 0)              = -Infinity
 *   pow(-0, even integer < 0)             = +Infinity
 *   pow(finite x < 0, finite non-integer) = NaN
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
 * probability of an incorrectly rounded result
 * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
 * i.e. 1 in 250,000,000,000,000
 *
 * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */
P.toPower = P.pow = function (y) {
  var e, k, pr, r, rm, sign, yIsInt,
    x = this,
    Ctor = x.constructor,
    yn = +(y = new Ctor(y));

  // Either ±Infinity, NaN or ±0?
  if (!x.d || !y.d || !x.d[0] || !y.d[0]) return  new Ctor(mathpow(+x, yn));

  x = new Ctor(x);

  if (x.eq(1)) return x;

  pr = Ctor.precision;
  rm = Ctor.rounding;

  if (y.eq(1)) return finalise(x, pr, rm);

  e = mathfloor(y.e / LOG_BASE);
  k = y.d.length - 1;
  yIsInt = e >= k;
  sign = x.s;

  if (!yIsInt) {
    if (sign < 0) return new Ctor(NaN);

  // If y is a small integer use the 'exponentiation by squaring' algorithm.
  } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r = intPow(Ctor, x, k, pr);
    return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
  }

  // Result is negative if x is negative and the last digit of integer y is odd.
  sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

  // Estimate result exponent.
  // x^y = 10^e,  where e = y * log10(x)
  // log10(x) = log10(x_significand) + x_exponent
  // log10(x_significand) = ln(x_significand) / ln(10)
  k = mathpow(+x, yn);
  e = k == 0 || !isFinite(k)
    ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1))
    : new Ctor(k + '').e;

  // Estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.

  // Overflow/underflow?
  if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? sign / 0 : 0);

  external = false;
  Ctor.rounding = x.s = 1;

  // Estimate the extra guard digits needed to ensure five correct rounding digits from
  // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
  // new Decimal(2.32456).pow('2087987436534566.46411')
  // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
  k = Math.min(12, (e + '').length);

  // r = x^y = exp(y*ln(x))
  r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);

  // Truncate to the required precision plus five rounding digits.
  r = finalise(r, pr + 5, 1);

  // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
  // the result.
  if (checkRoundingDigits(r.d, pr, rm)) {
    e = pr + 10;

    // Truncate to the increased precision plus five rounding digits.
    r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);

    // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
    if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
      r = finalise(r, pr + 1, 0);
    }
  }

  r.s = sign;
  external = true;
  Ctor.rounding = rm;

  return finalise(r, pr, rm);
};


/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toPrecision = function (sd, rm) {
  var str,
    x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = finalise(new Ctor(x), sd, rm);
    str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
  }

  return x.isNeg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * 'toSD() digits out of range: {sd}'
 * 'toSD() digits not an integer: {sd}'
 * 'toSD() rounding mode not an integer: {rm}'
 * 'toSD() rounding mode out of range: {rm}'
 *
 */
P.toSignificantDigits = P.toSD = function (sd, rm) {
  var x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }

  return finalise(new Ctor(x), sd, rm);
};


/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */
P.toString = function () {
  var x = this,
    Ctor = x.constructor,
    str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

  return x.isNeg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
 *
 */
P.truncated = P.trunc = function () {
  return finalise(new this.constructor(this), this.e + 1, 1);
};


/*
 * Return a string representing the value of this Decimal.
 * Unlike `toString`, negative zero will include the minus sign.
 *
 */
P.valueOf = P.toJSON = function () {
  var x = this,
    Ctor = x.constructor,
    str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

  return x.isNeg() ? '-' + str : str;
};


/*
// Add aliases to match BigDecimal method names.
// P.add = P.plus;
P.subtract = P.minus;
P.multiply = P.times;
P.divide = P.div;
P.remainder = P.mod;
P.compareTo = P.cmp;
P.negate = P.neg;
 */


// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


/*
 *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
 *                           finiteToString, naturalExponential, naturalLogarithm
 *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
 *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
 *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
 *  convertBase              toStringBinary, parseOther
 *  cos                      P.cos
 *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
 *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
 *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
 *                           taylorSeries, atan2, parseOther
 *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
 *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
 *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
 *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
 *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
 *                           P.truncated, divide, getLn10, getPi, naturalExponential,
 *                           naturalLogarithm, ceil, floor, round, trunc
 *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
 *                           toStringBinary
 *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
 *  getLn10                  P.logarithm, naturalLogarithm
 *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
 *  getPrecision             P.precision, P.toFraction
 *  getZeroString            digitsToString, finiteToString
 *  intPow                   P.toPower, parseOther
 *  isOdd                    toLessThanHalfPi
 *  maxOrMin                 max, min
 *  naturalExponential       P.naturalExponential, P.toPower
 *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
 *                           P.toPower, naturalExponential
 *  nonFiniteToString        finiteToString, toStringBinary
 *  parseDecimal             Decimal
 *  parseOther               Decimal
 *  sin                      P.sin
 *  taylorSeries             P.cosh, P.sinh, cos, sin
 *  toLessThanHalfPi         P.cos, P.sin
 *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
 *  truncate                 intPow
 *
 *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
 *                           naturalLogarithm, config, parseOther, random, Decimal
 */


function digitsToString(d) {
  var i, k, ws,
    indexOfLastWord = d.length - 1,
    str = '',
    w = d[0];

  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }

    w = d[i];
    ws = w + '';
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return '0';
  }

  // Remove trailing zeros of last w.
  for (; w % 10 === 0;) w /= 10;

  return str + w;
}


function checkInt32(i, min, max) {
  if (i !== ~~i || i < min || i > max) {
    throw Error(invalidArgument + i);
  }
}


/*
 * Check 5 rounding digits if `repeating` is null, 4 otherwise.
 * `repeating == null` if caller is `log` or `pow`,
 * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
 */
function checkRoundingDigits(d, i, rm, repeating) {
  var di, k, r, rd;

  // Get the length of the first word of the array d.
  for (k = d[0]; k >= 10; k /= 10) --i;

  // Is the rounding digit in the first word of d?
  if (--i < 0) {
    i += LOG_BASE;
    di = 0;
  } else {
    di = Math.ceil((i + 1) / LOG_BASE);
    i %= LOG_BASE;
  }

  // i is the index (0 - 6) of the rounding digit.
  // E.g. if within the word 3487563 the first rounding digit is 5,
  // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
  k = mathpow(10, LOG_BASE - i);
  rd = d[di] % k | 0;

  if (repeating == null) {
    if (i < 3) {
      if (i == 0) rd = rd / 100 | 0;
      else if (i == 1) rd = rd / 10 | 0;
      r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
    } else {
      r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) &&
        (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 ||
          (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
    }
  } else {
    if (i < 4) {
      if (i == 0) rd = rd / 1000 | 0;
      else if (i == 1) rd = rd / 100 | 0;
      else if (i == 2) rd = rd / 10 | 0;
      r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
    } else {
      r = ((repeating || rm < 4) && rd + 1 == k ||
      (!repeating && rm > 3) && rd + 1 == k / 2) &&
        (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
    }
  }

  return r;
}


// Convert string of `baseIn` to an array of numbers of `baseOut`.
// Eg. convertBase('255', 10, 16) returns [15, 15].
// Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
function convertBase(str, baseIn, baseOut) {
  var j,
    arr = [0],
    arrL,
    i = 0,
    strL = str.length;

  for (; i < strL;) {
    for (arrL = arr.length; arrL--;) arr[arrL] *= baseIn;
    arr[0] += NUMERALS.indexOf(str.charAt(i++));
    for (j = 0; j < arr.length; j++) {
      if (arr[j] > baseOut - 1) {
        if (arr[j + 1] === void 0) arr[j + 1] = 0;
        arr[j + 1] += arr[j] / baseOut | 0;
        arr[j] %= baseOut;
      }
    }
  }

  return arr.reverse();
}


/*
 * cos(x) = 1 - x^2/2! + x^4/4! - ...
 * |x| < pi/2
 *
 */
function cosine(Ctor, x) {
  var k, y,
    len = x.d.length;

  // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
  // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1

  // Estimate the optimum number of times to use the argument reduction.
  if (len < 32) {
    k = Math.ceil(len / 3);
    y = Math.pow(4, -k).toString();
  } else {
    k = 16;
    y = '2.3283064365386962890625e-10';
  }

  Ctor.precision += k;

  x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));

  // Reverse argument reduction
  for (var i = k; i--;) {
    var cos2x = x.times(x);
    x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
  }

  Ctor.precision -= k;

  return x;
}


/*
 * Perform division in the specified base.
 */
var divide = (function () {

  // Assumes non-zero x and k, and hence non-zero result.
  function multiplyInteger(x, k, base) {
    var temp,
      carry = 0,
      i = x.length;

    for (x = x.slice(); i--;) {
      temp = x[i] * k + carry;
      x[i] = temp % base | 0;
      carry = temp / base | 0;
    }

    if (carry) x.unshift(carry);

    return x;
  }

  function compare(a, b, aL, bL) {
    var i, r;

    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }

    return r;
  }

  function subtract(a, b, aL, base) {
    var i = 0;

    // Subtract b from a.
    for (; aL--;) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * base + a[aL] - b[aL];
    }

    // Remove leading zeros.
    for (; !a[0] && a.length > 1;) a.shift();
  }

  return function (x, y, pr, rm, dp, base) {
    var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0,
      yL, yz,
      Ctor = x.constructor,
      sign = x.s == y.s ? 1 : -1,
      xd = x.d,
      yd = y.d;

    // Either NaN, Infinity or 0?
    if (!xd || !xd[0] || !yd || !yd[0]) {

      return new Ctor(// Return NaN if either NaN, or both Infinity or 0.
        !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN :

        // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
        xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
    }

    if (base) {
      logBase = 1;
      e = x.e - y.e;
    } else {
      base = BASE;
      logBase = LOG_BASE;
      e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
    }

    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign);
    qd = q.d = [];

    // Result exponent may be one less than e.
    // The digit array of a Decimal from toStringBinary may have trailing zeros.
    for (i = 0; yd[i] == (xd[i] || 0); i++);

    if (yd[i] > (xd[i] || 0)) e--;

    if (pr == null) {
      sd = pr = Ctor.precision;
      rm = Ctor.rounding;
    } else if (dp) {
      sd = pr + (x.e - y.e) + 1;
    } else {
      sd = pr;
    }

    if (sd < 0) {
      qd.push(1);
      more = true;
    } else {

      // Convert precision in number of base 10 digits to base 1e7 digits.
      sd = sd / logBase + 2 | 0;
      i = 0;

      // divisor < 1e7
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;

        // k is the carry.
        for (; (i < xL || k) && sd--; i++) {
          t = k * base + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }

        more = k || i < xL;

      // divisor >= 1e7
      } else {

        // Normalise xd and yd so highest order digit of yd is >= base/2
        k = base / (yd[0] + 1) | 0;

        if (k > 1) {
          yd = multiplyInteger(yd, k, base);
          xd = multiplyInteger(xd, k, base);
          yL = yd.length;
          xL = xd.length;
        }

        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL;) rem[remL++] = 0;

        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];

        if (yd[1] >= base / 2) ++yd0;

        do {
          k = 0;

          // Compare divisor and remainder.
          cmp = compare(yd, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, k.
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

            // k will be how many times the divisor goes into the current remainder.
            k = rem0 / yd0 | 0;

            //  Algorithm:
            //  1. product = divisor * trial digit (k)
            //  2. if product > remainder: product -= divisor, k--
            //  3. remainder -= product
            //  4. if product was < remainder at 2:
            //    5. compare new remainder and divisor
            //    6. If remainder > divisor: remainder -= divisor, k++

            if (k > 1) {
              if (k >= base) k = base - 1;

              // product = divisor * trial digit.
              prod = multiplyInteger(yd, k, base);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              cmp = compare(prod, rem, prodL, remL);

              // product > remainder.
              if (cmp == 1) {
                k--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yd, prodL, base);
              }
            } else {

              // cmp is -1.
              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }

            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);

            // Subtract product from remainder.
            subtract(rem, prod, remL, base);

            // If product was < previous remainder.
            if (cmp == -1) {
              remL = rem.length;

              // Compare divisor and new remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < new remainder, subtract divisor from remainder.
              if (cmp < 1) {
                k++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yd, remL, base);
              }
            }

            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }    // if cmp === 1, k will be 0

          // Add the next digit, k, to the result array.
          qd[i++] = k;

          // Update the remainder.
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }

        } while ((xi++ < xL || rem[0] !== void 0) && sd--);

        more = rem[0] !== void 0;
      }

      // Leading zero?
      if (!qd[0]) qd.shift();
    }

    // logBase is 1 when divide is being used for base conversion.
    if (logBase == 1) {
      q.e = e;
      inexact = more;
    } else {

      // To calculate q.e, first get the number of digits of qd[0].
      for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
      q.e = i + e * logBase - 1;

      finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
    }

    return q;
  };
})();


/*
 * Round `x` to `sd` significant digits using rounding mode `rm`.
 * Check for over/under-flow.
 */
 function finalise(x, sd, rm, isTruncated) {
  var digits, i, j, k, rd, roundUp, w, xd, xdi,
    Ctor = x.constructor;

  // Don't round if sd is null or undefined.
  out: if (sd != null) {
    xd = x.d;

    // Infinity/NaN.
    if (!xd) return x;

    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd containing rd, a base 1e7 number.
    // xdi: the index of w within xd.
    // digits: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

    // Get the length of the first word of the digits array xd.
    for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
    i = sd - digits;

    // Is the rounding digit in the first word of xd?
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];

      // Get the rounding digit at index j of w.
      rd = w / mathpow(10, digits - j - 1) % 10 | 0;
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) {
        if (isTruncated) {

          // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
          for (; k++ <= xdi;) xd.push(0);
          w = rd = 0;
          digits = 1;
          i %= LOG_BASE;
          j = i - LOG_BASE + 1;
        } else {
          break out;
        }
      } else {
        w = k = xd[xdi];

        // Get the number of digits of w.
        for (digits = 1; k >= 10; k /= 10) digits++;

        // Get the index of rd within w.
        i %= LOG_BASE;

        // Get the index of rd within w, adjusted for leading zeros.
        // The number of leading zeros of w is given by LOG_BASE - digits.
        j = i - LOG_BASE + digits;

        // Get the rounding digit at index j of w.
        rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
      }
    }

    // Are there any non-zero digits after the rounding digit?
    isTruncated = isTruncated || sd < 0 ||
      xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));

    // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
    // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
    // will give 714.

    roundUp = rm < 4
      ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
      : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 &&

        // Check whether the digit to the left of the rounding digit is odd.
        ((i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
          rm == (x.s < 0 ? 8 : 7));

    if (sd < 1 || !xd[0]) {
      xd.length = 0;
      if (roundUp) {

        // Convert sd to decimal places.
        sd -= x.e + 1;

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = -sd || 0;
      } else {

        // Zero.
        xd[0] = x.e = 0;
      }

      return x;
    }

    // Remove excess digits.
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);

      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
      // j > 0 means i > number of leading zeros of w.
      xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
    }

    if (roundUp) {
      for (;;) {

        // Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {

          // i will be the length of xd[0] before k is added.
          for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
          j = xd[0] += k;
          for (k = 1; j >= 10; j /= 10) k++;

          // if i != k the length has increased.
          if (i != k) {
            x.e++;
            if (xd[0] == BASE) xd[0] = 1;
          }

          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }

    // Remove trailing zeros.
    for (i = xd.length; xd[--i] === 0;) xd.pop();
  }

  if (external) {

    // Overflow?
    if (x.e > Ctor.maxE) {

      // Infinity.
      x.d = null;
      x.e = NaN;

    // Underflow?
    } else if (x.e < Ctor.minE) {

      // Zero.
      x.e = 0;
      x.d = [0];
      // Ctor.underflow = true;
    } // else Ctor.underflow = false;
  }

  return x;
}


function finiteToString(x, isExp, sd) {
  if (!x.isFinite()) return nonFiniteToString(x);
  var k,
    e = x.e,
    str = digitsToString(x.d),
    len = str.length;

  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + '.' + str.slice(1);
    }

    str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
  } else if (e < 0) {
    str = '0.' + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += '.';
      str += getZeroString(k);
    }
  }

  return str;
}


// Calculate the base 10 exponent from the base 1e7 exponent.
function getBase10Exponent(digits, e) {
  var w = digits[0];

  // Add the number of digits of the first word of the digits array.
  for ( e *= LOG_BASE; w >= 10; w /= 10) e++;
  return e;
}


function getLn10(Ctor, sd, pr) {
  if (sd > LN10_PRECISION) {

    // Reset global state in case the exception is caught.
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(precisionLimitExceeded);
  }
  return finalise(new Ctor(LN10), sd, 1, true);
}


function getPi(Ctor, sd, rm) {
  if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new Ctor(PI), sd, rm, true);
}


function getPrecision(digits) {
  var w = digits.length - 1,
    len = w * LOG_BASE + 1;

  w = digits[w];

  // If non-zero...
  if (w) {

    // Subtract the number of trailing zeros of the last word.
    for (; w % 10 == 0; w /= 10) len--;

    // Add the number of digits of the first word.
    for (w = digits[0]; w >= 10; w /= 10) len++;
  }

  return len;
}


function getZeroString(k) {
  var zs = '';
  for (; k--;) zs += '0';
  return zs;
}


/*
 * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
 * integer of type number.
 *
 * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
 *
 */
function intPow(Ctor, x, n, pr) {
  var isTruncated,
    r = new Ctor(1),

    // Max n of 9007199254740991 takes 53 loop iterations.
    // Maximum digits array length; leaves [28, 34] guard digits.
    k = Math.ceil(pr / LOG_BASE + 4);

  external = false;

  for (;;) {
    if (n % 2) {
      r = r.times(x);
      if (truncate(r.d, k)) isTruncated = true;
    }

    n = mathfloor(n / 2);
    if (n === 0) {

      // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
      n = r.d.length - 1;
      if (isTruncated && r.d[n] === 0) ++r.d[n];
      break;
    }

    x = x.times(x);
    truncate(x.d, k);
  }

  external = true;

  return r;
}


function isOdd(n) {
  return n.d[n.d.length - 1] & 1;
}


/*
 * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
 */
function maxOrMin(Ctor, args, ltgt) {
  var y,
    x = new Ctor(args[0]),
    i = 0;

  for (; ++i < args.length;) {
    y = new Ctor(args[i]);
    if (!y.s) {
      x = y;
      break;
    } else if (x[ltgt](y)) {
      x = y;
    }
  }

  return x;
}


/*
 * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
 * digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
 * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(Infinity)  = Infinity
 *  exp(-Infinity) = 0
 *  exp(NaN)       = NaN
 *  exp(±0)        = 1
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 *  The result will always be correctly rounded.
 *
 */
function naturalExponential(x, sd) {
  var denominator, guard, j, pow, sum, t, wpr,
    rep = 0,
    i = 0,
    k = 0,
    Ctor = x.constructor,
    rm = Ctor.rounding,
    pr = Ctor.precision;

  // 0/NaN/Infinity?
  if (!x.d || !x.d[0] || x.e > 17) {

    return new Ctor(x.d
      ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0
      : x.s ? x.s < 0 ? 0 : x : 0 / 0);
  }

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  t = new Ctor(0.03125);

  // while abs(x) >= 0.1
  while (x.e > -2) {

    // x = x / 2^5
    x = x.times(t);
    k += 5;
  }

  // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
  // necessary to ensure the first 4 rounding digits are correct.
  guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow = sum = new Ctor(1);
  Ctor.precision = wpr;

  for (;;) {
    pow = finalise(pow.times(x), wpr, 1);
    denominator = denominator.times(++i);
    t = sum.plus(divide(pow, denominator, wpr, 1));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      j = k;
      while (j--) sum = finalise(sum.times(sum), wpr, 1);

      // Check to see if the first 4 rounding digits are [49]999.
      // If so, repeat the summation with a higher precision, otherwise
      // e.g. with precision: 18, rounding: 1
      // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
      // `wpr - guard` is the index of first rounding digit.
      if (sd == null) {

        if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += 10;
          denominator = pow = t = new Ctor(1);
          i = 0;
          rep++;
        } else {
          return finalise(sum, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum;
      }
    }

    sum = t;
  }
}


/*
 * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
 * digits.
 *
 *  ln(-n)        = NaN
 *  ln(0)         = -Infinity
 *  ln(-0)        = -Infinity
 *  ln(1)         = 0
 *  ln(Infinity)  = Infinity
 *  ln(-Infinity) = NaN
 *  ln(NaN)       = NaN
 *
 *  ln(n) (n != 1) is non-terminating.
 *
 */
function naturalLogarithm(y, sd) {
  var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2,
    n = 1,
    guard = 10,
    x = y,
    xd = x.d,
    Ctor = x.constructor,
    rm = Ctor.rounding,
    pr = Ctor.precision;

  // Is x negative or Infinity, NaN, 0 or 1?
  if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
    return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
  }

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  Ctor.precision = wpr += guard;
  c = digitsToString(xd);
  c0 = c.charAt(0);

  if (Math.abs(e = x.e) < 1.5e15) {

    // Argument reduction.
    // The series converges faster the closer the argument is to 1, so using
    // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
    // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
    // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
    // later be divided by this number, then separate out the power of 10 using
    // ln(a*10^b) = ln(a) + b*ln(10).

    // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
    //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
    // max n is 6 (gives 0.7 - 1.3)
    while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }

    e = x.e;

    if (c0 > 1) {
      x = new Ctor('0.' + c);
      e++;
    } else {
      x = new Ctor(c0 + '.' + c.slice(1));
    }
  } else {

    // The argument reduction method above may result in overflow if the argument y is a massive
    // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
    // function using ln(x*10^e) = ln(x) + e*ln(10).
    t = getLn10(Ctor, wpr + 2, pr).times(e + '');
    x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
    Ctor.precision = pr;

    return sd == null ? finalise(x, pr, rm, external = true) : x;
  }

  // x1 is x reduced to a value near 1.
  x1 = x;

  // Taylor series.
  // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
  // where x = (y - 1)/(y + 1)    (|x| < 1)
  sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
  x2 = finalise(x.times(x), wpr, 1);
  denominator = 3;

  for (;;) {
    numerator = finalise(numerator.times(x2), wpr, 1);
    t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      sum = sum.times(2);

      // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
      // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
      if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
      sum = divide(sum, new Ctor(n), wpr, 1);

      // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
      // been repeated previously) and the first 4 rounding digits 9999?
      // If so, restart the summation with a higher precision, otherwise
      // e.g. with precision: 12, rounding: 1
      // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
      // `wpr - guard` is the index of first rounding digit.
      if (sd == null) {
        if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += guard;
          t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
          x2 = finalise(x.times(x), wpr, 1);
          denominator = rep = 1;
        } else {
          return finalise(sum, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum;
      }
    }

    sum = t;
    denominator += 2;
  }
}


// ±Infinity, NaN.
function nonFiniteToString(x) {
  // Unsigned.
  return String(x.s * x.s / 0);
}


/*
 * Parse the value of a new Decimal `x` from string `str`.
 */
function parseDecimal(x, str) {
  var e, i, len;

  // Decimal point?
  if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

  // Exponential form?
  if ((i = str.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = str.length;
  }

  // Determine leading zeros.
  for (i = 0; str.charCodeAt(i) === 48; i++);

  // Determine trailing zeros.
  for (len = str.length; str.charCodeAt(len - 1) === 48; --len);
  str = str.slice(i, len);

  if (str) {
    len -= i;
    x.e = e = e - i - 1;
    x.d = [];

    // Transform base

    // e is the base 10 exponent.
    // i is where to slice str to get the first word of the digits array.
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;

    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }

    for (; i--;) str += '0';
    x.d.push(+str);

    if (external) {

      // Overflow?
      if (x.e > x.constructor.maxE) {

        // Infinity.
        x.d = null;
        x.e = NaN;

      // Underflow?
      } else if (x.e < x.constructor.minE) {

        // Zero.
        x.e = 0;
        x.d = [0];
        // x.constructor.underflow = true;
      } // else x.constructor.underflow = false;
    }
  } else {

    // Zero.
    x.e = 0;
    x.d = [0];
  }

  return x;
}


/*
 * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
 */
function parseOther(x, str) {
  var base, Ctor, divisor, i, isFloat, len, p, xd, xe;

  if (str === 'Infinity' || str === 'NaN') {
    if (!+str) x.s = NaN;
    x.e = NaN;
    x.d = null;
    return x;
  }

  if (isHex.test(str))  {
    base = 16;
    str = str.toLowerCase();
  } else if (isBinary.test(str))  {
    base = 2;
  } else if (isOctal.test(str))  {
    base = 8;
  } else {
    throw Error(invalidArgument + str);
  }

  // Is there a binary exponent part?
  i = str.search(/p/i);

  if (i > 0) {
    p = +str.slice(i + 1);
    str = str.substring(2, i);
  } else {
    str = str.slice(2);
  }

  // Convert `str` as an integer then divide the result by `base` raised to a power such that the
  // fraction part will be restored.
  i = str.indexOf('.');
  isFloat = i >= 0;
  Ctor = x.constructor;

  if (isFloat) {
    str = str.replace('.', '');
    len = str.length;
    i = len - i;

    // log[10](16) = 1.2041... , log[10](88) = 1.9444....
    divisor = intPow(Ctor, new Ctor(base), i, i * 2);
  }

  xd = convertBase(str, base, BASE);
  xe = xd.length - 1;

  // Remove trailing zeros.
  for (i = xe; xd[i] === 0; --i) xd.pop();
  if (i < 0) return new Ctor(x.s * 0);
  x.e = getBase10Exponent(xd, xe);
  x.d = xd;
  external = false;

  // At what precision to perform the division to ensure exact conversion?
  // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
  // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
  // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
  // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
  // Therefore using 4 * the number of digits of str will always be enough.
  if (isFloat) x = divide(x, divisor, len * 4);

  // Multiply by the binary exponent part if present.
  if (p) x = x.times(Math.abs(p) < 54 ? Math.pow(2, p) : Decimal.pow(2, p));
  external = true;

  return x;
}


/*
 * sin(x) = x - x^3/3! + x^5/5! - ...
 * |x| < pi/2
 *
 */
function sine(Ctor, x) {
  var k,
    len = x.d.length;

  if (len < 3) return taylorSeries(Ctor, 2, x, x);

  // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
  // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
  // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))

  // Estimate the optimum number of times to use the argument reduction.
  k = 1.4 * Math.sqrt(len);
  k = k > 16 ? 16 : k | 0;

  // Max k before Math.pow precision loss is 22
  x = x.times(Math.pow(5, -k));
  x = taylorSeries(Ctor, 2, x, x);

  // Reverse argument reduction
  var sin2_x,
    d5 = new Ctor(5),
    d16 = new Ctor(16),
    d20 = new Ctor(20);
  for (; k--;) {
    sin2_x = x.times(x);
    x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
  }

  return x;
}


// Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
function taylorSeries(Ctor, n, x, y, isHyperbolic) {
  var j, t, u, x2,
    i = 1,
    pr = Ctor.precision,
    k = Math.ceil(pr / LOG_BASE);

  external = false;
  x2 = x.times(x);
  u = new Ctor(y);

  for (;;) {
    t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
    u = isHyperbolic ? y.plus(t) : y.minus(t);
    y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
    t = u.plus(y);

    if (t.d[k] !== void 0) {
      for (j = k; t.d[j] === u.d[j] && j--;);
      if (j == -1) break;
    }

    j = u;
    u = y;
    y = t;
    t = j;
    i++;
  }

  external = true;
  t.d.length = k + 1;

  return t;
}


// Return the absolute value of `x` reduced to less than or equal to half pi.
function toLessThanHalfPi(Ctor, x) {
  var t,
    isNeg = x.s < 0,
    pi = getPi(Ctor, Ctor.precision, 1),
    halfPi = pi.times(0.5);

  x = x.abs();

  if (x.lte(halfPi)) {
    quadrant = isNeg ? 4 : 1;
    return x;
  }

  t = x.divToInt(pi);

  if (t.isZero()) {
    quadrant = isNeg ? 3 : 2;
  } else {
    x = x.minus(t.times(pi));

    // 0 <= x < pi
    if (x.lte(halfPi)) {
      quadrant = isOdd(t) ? (isNeg ? 2 : 3) : (isNeg ? 4 : 1);
      return x;
    }

    quadrant = isOdd(t) ? (isNeg ? 1 : 4) : (isNeg ? 3 : 2);
  }

  return x.minus(pi).abs();
}


/*
 * Return the value of Decimal `x` as a string in base `baseOut`.
 *
 * If the optional `sd` argument is present include a binary exponent suffix.
 */
function toStringBinary(x, baseOut, sd, rm) {
  var base, e, i, k, len, roundUp, str, xd, y,
    Ctor = x.constructor,
    isExp = sd !== void 0;

  if (isExp) {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  } else {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  }

  if (!x.isFinite()) {
    str = nonFiniteToString(x);
  } else {
    str = finiteToString(x);
    i = str.indexOf('.');

    // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
    // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
    // minBinaryExponent = floor(decimalExponent * log[2](10))
    // log[2](10) = 3.321928094887362347870319429489390175864

    if (isExp) {
      base = 2;
      if (baseOut == 16) {
        sd = sd * 4 - 3;
      } else if (baseOut == 8) {
        sd = sd * 3 - 2;
      }
    } else {
      base = baseOut;
    }

    // Convert the number as an integer then divide the result by its base raised to a power such
    // that the fraction part will be restored.

    // Non-integer.
    if (i >= 0) {
      str = str.replace('.', '');
      y = new Ctor(1);
      y.e = str.length - i;
      y.d = convertBase(finiteToString(y), 10, base);
      y.e = y.d.length;
    }

    xd = convertBase(str, 10, base);
    e = len = xd.length;

    // Remove trailing zeros.
    for (; xd[--len] == 0;) xd.pop();

    if (!xd[0]) {
      str = isExp ? '0p+0' : '0';
    } else {
      if (i < 0) {
        e--;
      } else {
        x = new Ctor(x);
        x.d = xd;
        x.e = e;
        x = divide(x, y, sd, rm, 0, base);
        xd = x.d;
        e = x.e;
        roundUp = inexact;
      }

      // The rounding digit, i.e. the digit after the digit that may be rounded up.
      i = xd[sd];
      k = base / 2;
      roundUp = roundUp || xd[sd + 1] !== void 0;

      roundUp = rm < 4
        ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2))
        : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 ||
          rm === (x.s < 0 ? 8 : 7));

      xd.length = sd;

      if (roundUp) {

        // Rounding up may mean the previous digit has to be rounded up and so on.
        for (; ++xd[--sd] > base - 1;) {
          xd[sd] = 0;
          if (!sd) {
            ++e;
            xd.unshift(1);
          }
        }
      }

      // Determine trailing zeros.
      for (len = xd.length; !xd[len - 1]; --len);

      // E.g. [4, 11, 15] becomes 4bf.
      for (i = 0, str = ''; i < len; i++) str += NUMERALS.charAt(xd[i]);

      // Add binary exponent suffix?
      if (isExp) {
        if (len > 1) {
          if (baseOut == 16 || baseOut == 8) {
            i = baseOut == 16 ? 4 : 3;
            for (--len; len % i; len++) str += '0';
            xd = convertBase(str, base, baseOut);
            for (len = xd.length; !xd[len - 1]; --len);

            // xd[0] will always be be 1
            for (i = 1, str = '1.'; i < len; i++) str += NUMERALS.charAt(xd[i]);
          } else {
            str = str.charAt(0) + '.' + str.slice(1);
          }
        }

        str =  str + (e < 0 ? 'p' : 'p+') + e;
      } else if (e < 0) {
        for (; ++e;) str = '0' + str;
        str = '0.' + str;
      } else {
        if (++e > len) for (e -= len; e-- ;) str += '0';
        else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
      }
    }

    str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
  }

  return x.s < 0 ? '-' + str : str;
}


// Does not strip trailing zeros.
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}


// Decimal methods


/*
 *  abs
 *  acos
 *  acosh
 *  add
 *  asin
 *  asinh
 *  atan
 *  atanh
 *  atan2
 *  cbrt
 *  ceil
 *  clone
 *  config
 *  cos
 *  cosh
 *  div
 *  exp
 *  floor
 *  hypot
 *  ln
 *  log
 *  log2
 *  log10
 *  max
 *  min
 *  mod
 *  mul
 *  pow
 *  random
 *  round
 *  set
 *  sign
 *  sin
 *  sinh
 *  sqrt
 *  sub
 *  tan
 *  tanh
 *  trunc
 */


/*
 * Return a new Decimal whose value is the absolute value of `x`.
 *
 * x {number|string|Decimal}
 *
 */
function abs(x) {
  return new this(x).abs();
}


/*
 * Return a new Decimal whose value is the arccosine in radians of `x`.
 *
 * x {number|string|Decimal}
 *
 */
function acos(x) {
  return new this(x).acos();
}


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function acosh(x) {
  return new this(x).acosh();
}


/*
 * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 * y {number|string|Decimal}
 *
 */
function add(x, y) {
  return new this(x).plus(y);
}


/*
 * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function asin(x) {
  return new this(x).asin();
}


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function asinh(x) {
  return new this(x).asinh();
}


/*
 * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function atan(x) {
  return new this(x).atan();
}


/*
 * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
 * `precision` significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function atanh(x) {
  return new this(x).atanh();
}


/*
 * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
 * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * Domain: [-Infinity, Infinity]
 * Range: [-pi, pi]
 *
 * y {number|string|Decimal} The y-coordinate.
 * x {number|string|Decimal} The x-coordinate.
 *
 * atan2(±0, -0)               = ±pi
 * atan2(±0, +0)               = ±0
 * atan2(±0, -x)               = ±pi for x > 0
 * atan2(±0, x)                = ±0 for x > 0
 * atan2(-y, ±0)               = -pi/2 for y > 0
 * atan2(y, ±0)                = pi/2 for y > 0
 * atan2(±y, -Infinity)        = ±pi for finite y > 0
 * atan2(±y, +Infinity)        = ±0 for finite y > 0
 * atan2(±Infinity, x)         = ±pi/2 for finite x
 * atan2(±Infinity, -Infinity) = ±3*pi/4
 * atan2(±Infinity, +Infinity) = ±pi/4
 * atan2(NaN, x) = NaN
 * atan2(y, NaN) = NaN
 *
 */
function atan2(y, x) {
  y = new this(y);
  x = new this(x);
  var r,
    pr = this.precision,
    rm = this.rounding,
    wpr = pr + 4;

  // Either NaN
  if (!y.s || !x.s) {
    r = new this(NaN);

  // Both ±Infinity
  } else if (!y.d && !x.d) {
    r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
    r.s = y.s;

  // x is ±Infinity or y is ±0
  } else if (!x.d || y.isZero()) {
    r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
    r.s = y.s;

  // y is ±Infinity or x is ±0
  } else if (!y.d || x.isZero()) {
    r = getPi(this, wpr, 1).times(0.5);
    r.s = y.s;

  // Both non-zero and finite
  } else if (x.s < 0) {
    this.precision = wpr;
    this.rounding = 1;
    r = this.atan(divide(y, x, wpr, 1));
    x = getPi(this, wpr, 1);
    this.precision = pr;
    this.rounding = rm;
    r = y.s < 0 ? r.minus(x) : r.plus(x);
  } else {
    r = this.atan(divide(y, x, wpr, 1));
  }

  return r;
}


/*
 * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function cbrt(x) {
  return new this(x).cbrt();
}


/*
 * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
 *
 * x {number|string|Decimal}
 *
 */
function ceil(x) {
  return finalise(x = new this(x), x.e + 1, 2);
}


/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *   maxE       {number}
 *   minE       {number}
 *   modulo     {number}
 *   crypto     {boolean|number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */
function config(obj) {
  if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
  var i, p, v,
    ps = [
      'precision', 1, MAX_DIGITS,
      'rounding', 0, 8,
      'toExpNeg', -EXP_LIMIT, 0,
      'toExpPos', 0, EXP_LIMIT,
      'maxE', 0, EXP_LIMIT,
      'minE', -EXP_LIMIT, 0,
      'modulo', 0, 9
    ];

  for (i = 0; i < ps.length; i += 3) {
    if ((v = obj[p = ps[i]]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ': ' + v);
    }
  }

  if ((v = obj[p = 'crypto']) !== void 0) {
    if (v === true || v === false || v === 0 || v === 1) {
      if (v) {
        if (typeof crypto != 'undefined' && crypto &&
          (crypto.getRandomValues || crypto.randomBytes)) {
          this[p] = true;
        } else {
          throw Error(cryptoUnavailable);
        }
      } else {
        this[p] = false;
      }
    } else {
      throw Error(invalidArgument + p + ': ' + v);
    }
  }

  return this;
}


/*
 * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function cos(x) {
  return new this(x).cos();
}


/*
 * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function cosh(x) {
  return new this(x).cosh();
}


/*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */
function clone(obj) {
  var i, p, ps;

  /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * v {number|string|Decimal} A numeric value.
   *
   */
  function Decimal(v) {
    var e, i, t,
      x = this;

    // Decimal called without new.
    if (!(x instanceof Decimal)) return new Decimal(v);

    // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
    // which points to Object.
    x.constructor = Decimal;

    // Duplicate.
    if (v instanceof Decimal) {
      x.s = v.s;
      x.e = v.e;
      x.d = (v = v.d) ? v.slice() : v;
      return;
    }

    t = typeof v;

    if (t === 'number') {
      if (v === 0) {
        x.s = 1 / v < 0 ? -1 : 1;
        x.e = 0;
        x.d = [0];
        return;
      }

      if (v < 0) {
        v = -v;
        x.s = -1;
      } else {
        x.s = 1;
      }

      // Fast path for small integers.
      if (v === ~~v && v < 1e7) {
        for (e = 0, i = v; i >= 10; i /= 10) e++;
        x.e = e;
        x.d = [v];
        return;

      // Infinity, NaN.
      } else if (v * 0 !== 0) {
        if (!v) x.s = NaN;
        x.e = NaN;
        x.d = null;
        return;
      }

      return parseDecimal(x, v.toString());

    } else if (t !== 'string') {
      throw Error(invalidArgument + v);
    }

    // Minus sign?
    if (v.charCodeAt(0) === 45) {
      v = v.slice(1);
      x.s = -1;
    } else {
      x.s = 1;
    }

    return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
  }

  Decimal.prototype = P;

  Decimal.ROUND_UP = 0;
  Decimal.ROUND_DOWN = 1;
  Decimal.ROUND_CEIL = 2;
  Decimal.ROUND_FLOOR = 3;
  Decimal.ROUND_HALF_UP = 4;
  Decimal.ROUND_HALF_DOWN = 5;
  Decimal.ROUND_HALF_EVEN = 6;
  Decimal.ROUND_HALF_CEIL = 7;
  Decimal.ROUND_HALF_FLOOR = 8;
  Decimal.EUCLID = 9;

  Decimal.config = Decimal.set = config;
  Decimal.clone = clone;

  Decimal.abs = abs;
  Decimal.acos = acos;
  Decimal.acosh = acosh;        // ES6
  Decimal.add = add;
  Decimal.asin = asin;
  Decimal.asinh = asinh;        // ES6
  Decimal.atan = atan;
  Decimal.atanh = atanh;        // ES6
  Decimal.atan2 = atan2;
  Decimal.cbrt = cbrt;          // ES6
  Decimal.ceil = ceil;
  Decimal.cos = cos;
  Decimal.cosh = cosh;          // ES6
  Decimal.div = div;
  Decimal.exp = exp;
  Decimal.floor = floor;
  Decimal.hypot = hypot;        // ES6
  Decimal.ln = ln;
  Decimal.log = log;
  Decimal.log10 = log10;        // ES6
  Decimal.log2 = log2;          // ES6
  Decimal.max = max;
  Decimal.min = min;
  Decimal.mod = mod;
  Decimal.mul = mul;
  Decimal.pow = pow;
  Decimal.random = random;
  Decimal.round = round;
  Decimal.sign = sign;          // ES6
  Decimal.sin = sin;
  Decimal.sinh = sinh;          // ES6
  Decimal.sqrt = sqrt;
  Decimal.sub = sub;
  Decimal.tan = tan;
  Decimal.tanh = tanh;          // ES6
  Decimal.trunc = trunc;        // ES6

  if (obj === void 0) obj = {};
  if (obj) {
    ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'maxE', 'minE', 'modulo', 'crypto'];
    for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
  }

  Decimal.config(obj);

  return Decimal;
}


/*
 * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 * y {number|string|Decimal}
 *
 */
function div(x, y) {
  return new this(x).div(y);
}


/*
 * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} The power to which to raise the base of the natural log.
 *
 */
function exp(x) {
  return new this(x).exp();
}


/*
 * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
 *
 * x {number|string|Decimal}
 *
 */
function floor(x) {
  return finalise(x = new this(x), x.e + 1, 3);
}


/*
 * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
 * rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
 *
 */
function hypot() {
  var i, n,
    t = new this(0);

  external = false;

  for (i = 0; i < arguments.length;) {
    n = new this(arguments[i++]);
    if (!n.d) {
      if (n.s) {
        external = true;
        return new this(1 / 0);
      }
      t = n;
    } else if (t.d) {
      t = t.plus(n.times(n));
    }
  }

  external = true;

  return t.sqrt();
}


/*
 * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function ln(x) {
  return new this(x).ln();
}


/*
 * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
 * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
 *
 * log[y](x)
 *
 * x {number|string|Decimal} The argument of the logarithm.
 * y {number|string|Decimal} The base of the logarithm.
 *
 */
function log(x, y) {
  return new this(x).log(y);
}


/*
 * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function log2(x) {
  return new this(x).log(2);
}


/*
 * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function log10(x) {
  return new this(x).log(10);
}


/*
 * Return a new Decimal whose value is the maximum of the arguments.
 *
 * arguments {number|string|Decimal}
 *
 */
function max() {
  return maxOrMin(this, arguments, 'lt');
}


/*
 * Return a new Decimal whose value is the minimum of the arguments.
 *
 * arguments {number|string|Decimal}
 *
 */
function min() {
  return maxOrMin(this, arguments, 'gt');
}


/*
 * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 * y {number|string|Decimal}
 *
 */
function mod(x, y) {
  return new this(x).mod(y);
}


/*
 * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 * y {number|string|Decimal}
 *
 */
function mul(x, y) {
  return new this(x).mul(y);
}


/*
 * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} The base.
 * y {number|string|Decimal} The exponent.
 *
 */
function pow(x, y) {
  return new this(x).pow(y);
}


/*
 * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
 * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
 * are produced).
 *
 * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
 *
 */
function random(sd) {
  var d, e, k, n,
    i = 0,
    r = new this(1),
    rd = [];

  if (sd === void 0) sd = this.precision;
  else checkInt32(sd, 1, MAX_DIGITS);

  k = Math.ceil(sd / LOG_BASE);

  if (!this.crypto) {
    for (; i < k;) rd[i++] = Math.random() * 1e7 | 0;

  // Browsers supporting crypto.getRandomValues.
  } else if (crypto.getRandomValues) {
    d = crypto.getRandomValues(new Uint32Array(k));

    for (; i < k;) {
      n = d[i];

      // 0 <= n < 4294967296
      // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
      if (n >= 4.29e9) {
        d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
      } else {

        // 0 <= n <= 4289999999
        // 0 <= (n % 1e7) <= 9999999
        rd[i++] = n % 1e7;
      }
    }

  // Node.js supporting crypto.randomBytes.
  } else if (crypto.randomBytes) {

    // buffer
    d = crypto.randomBytes(k *= 4);

    for (; i < k;) {

      // 0 <= n < 2147483648
      n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);

      // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
      if (n >= 2.14e9) {
        crypto.randomBytes(4).copy(d, i);
      } else {

        // 0 <= n <= 2139999999
        // 0 <= (n % 1e7) <= 9999999
        rd.push(n % 1e7);
        i += 4;
      }
    }

    i = k / 4;
  } else {
    throw Error(cryptoUnavailable);
  }

  k = rd[--i];
  sd %= LOG_BASE;

  // Convert trailing digits to zeros according to sd.
  if (k && sd) {
    n = mathpow(10, LOG_BASE - sd);
    rd[i] = (k / n | 0) * n;
  }

  // Remove trailing words which are zero.
  for (; rd[i] === 0; i--) rd.pop();

  // Zero?
  if (i < 0) {
    e = 0;
    rd = [0];
  } else {
    e = -1;

    // Remove leading words which are zero and adjust exponent accordingly.
    for (; rd[0] === 0; e -= LOG_BASE) rd.shift();

    // Count the digits of the first word of rd to determine leading zeros.
    for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;

    // Adjust the exponent for leading zeros of the first word of rd.
    if (k < LOG_BASE) e -= LOG_BASE - k;
  }

  r.e = e;
  r.d = rd;

  return r;
}


/*
 * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
 *
 * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
 *
 * x {number|string|Decimal}
 *
 */
function round(x) {
  return finalise(x = new this(x), x.e + 1, this.rounding);
}


/*
 * Return
 *   1    if x > 0,
 *  -1    if x < 0,
 *   0    if x is 0,
 *  -0    if x is -0,
 *   NaN  otherwise
 *
 */
function sign(x) {
  x = new this(x);
  return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
}


/*
 * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function sin(x) {
  return new this(x).sin();
}


/*
 * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function sinh(x) {
  return new this(x).sinh();
}


/*
 * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 *
 */
function sqrt(x) {
  return new this(x).sqrt();
}


/*
 * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
 * using rounding mode `rounding`.
 *
 * x {number|string|Decimal}
 * y {number|string|Decimal}
 *
 */
function sub(x, y) {
  return new this(x).sub(y);
}


/*
 * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
 * digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function tan(x) {
  return new this(x).tan();
}


/*
 * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
 * significant digits using rounding mode `rounding`.
 *
 * x {number|string|Decimal} A value in radians.
 *
 */
function tanh(x) {
  return new this(x).tanh();
}


/*
 * Return a new Decimal whose value is `x` truncated to an integer.
 *
 * x {number|string|Decimal}
 *
 */
function trunc(x) {
  return finalise(x = new this(x), x.e + 1, 1);
}


// Create and configure initial Decimal constructor.
Decimal = clone(defaults);

// Create the internal constants from their string values.
LN10 = new Decimal(ln10);
PI = new Decimal(pi);

/* harmony default export */ __webpack_exports__["default"] = (Decimal);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(493);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(504);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(495)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(258)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 124 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(266);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxFirestore = __webpack_require__(285);

var _createFirebaseInstance = __webpack_require__(288);

var _firebaseConnect = __webpack_require__(694);

var _firebaseConnect2 = _interopRequireDefault(_firebaseConnect);

var _firestoreConnect = __webpack_require__(700);

var _firestoreConnect2 = _interopRequireDefault(_firestoreConnect);

var _withFirebase = __webpack_require__(701);

var _withFirebase2 = _interopRequireDefault(_withFirebase);

var _enhancer = __webpack_require__(702);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _reducer = __webpack_require__(703);

var _reducer2 = _interopRequireDefault(_reducer);

var _constants = __webpack_require__(52);

var _constants2 = _interopRequireDefault(_constants);

var _auth = __webpack_require__(206);

var _helpers = __webpack_require__(740);

var helpers = _interopRequireWildcard(_helpers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  firebase: _firebaseConnect2.default,
  createFirebaseInstance: _createFirebaseInstance.createFirebaseInstance,
  firebaseConnect: _firebaseConnect2.default,
  createFirebaseConnect: _firebaseConnect.createFirebaseConnect,
  firestoreConnect: _firestoreConnect2.default,
  createFirestoreConnect: _firestoreConnect.createFirestoreConnect,
  withFirebase: _withFirebase2.default,
  createWithFirebase: _withFirebase.createWithFirebase,
  firestoreReducer: _reduxFirestore.reducer,
  firebaseReducer: _reducer2.default,
  firebaseStateReducer: _reducer2.default,
  reduxReactFirebase: _enhancer2.default,
  reactReduxFirebase: _enhancer2.default,
  reduxFirebase: _enhancer2.default,
  constants: _constants2.default,
  actionTypes: _constants.actionTypes,
  getFirebase: _enhancer.getFirebase,
  authIsReady: _auth.authIsReady,
  helpers: helpers
}, helpers);
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(133),
    stackClear = __webpack_require__(600),
    stackDelete = __webpack_require__(601),
    stackGet = __webpack_require__(602),
    stackHas = __webpack_require__(603),
    stackSet = __webpack_require__(604);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(595),
    listCacheDelete = __webpack_require__(596),
    listCacheGet = __webpack_require__(597),
    listCacheHas = __webpack_require__(598),
    listCacheSet = __webpack_require__(599);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(104);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(619);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(139),
    eq = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(293);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(624),
    isObjectLike = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(34),
    stubFalse = __webpack_require__(625);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 142 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(295),
    baseKeysIn = __webpack_require__(631),
    isArrayLike = __webpack_require__(65);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(649);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(88),
    toKey = __webpack_require__(73);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisesForPopulate = exports.populateList = exports.getPopulateChild = exports.getPopulates = exports.getPopulateObjs = exports.getChildType = exports.getPopulateObj = undefined;

var _every2 = __webpack_require__(320);

var _every3 = _interopRequireDefault(_every2);

var _has2 = __webpack_require__(328);

var _has3 = _interopRequireDefault(_has2);

var _set2 = __webpack_require__(329);

var _set3 = _interopRequireDefault(_set2);

var _forEach2 = __webpack_require__(205);

var _forEach3 = _interopRequireDefault(_forEach2);

var _get2 = __webpack_require__(149);

var _get3 = _interopRequireDefault(_get2);

var _map2 = __webpack_require__(150);

var _map3 = _interopRequireDefault(_map2);

var _isObject2 = __webpack_require__(28);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isArray2 = __webpack_require__(21);

var _isArray3 = _interopRequireDefault(_isArray2);

var _isString2 = __webpack_require__(90);

var _isString3 = _interopRequireDefault(_isString2);

var _filter2 = __webpack_require__(684);

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPopulateObj = exports.getPopulateObj = function getPopulateObj(str) {
  if (!(0, _isString3.default)(str)) {
    return str;
  }
  var strArray = str.split(':');

  return { child: strArray[0], root: strArray[1] };
};
var getChildType = exports.getChildType = function getChildType(child) {
  if ((0, _isString3.default)(child)) {
    return 'string';
  }
  if ((0, _isArray3.default)(child)) {
    return 'array';
  }
  if ((0, _isObject3.default)(child)) {
    return 'object';
  }
  return 'other';
};

var getPopulateObjs = exports.getPopulateObjs = function getPopulateObjs(arr) {
  if (!(0, _isArray3.default)(arr)) {
    return arr;
  }
  return arr.map(function (o) {
    return (0, _isObject3.default)(o) ? o : getPopulateObj(o);
  });
};

var getPopulates = exports.getPopulates = function getPopulates(params) {
  var populates = (0, _filter3.default)(params, function (param) {
    return param.indexOf('populate') !== -1 || (0, _isObject3.default)(param) && param.populates;
  }).map(function (p) {
    return p.split('=')[1];
  });

  if (!populates.length) {
    return null;
  }
  return populates.map(getPopulateObj);
};

var getPopulateChild = exports.getPopulateChild = function getPopulateChild(firebase, populate, id) {
  return firebase.database().ref().child(populate.root + '/' + id).once('value').then(function (snap) {
    return snap.val();
  });
};

var populateList = exports.populateList = function populateList(firebase, list, p, results) {
  if (!results[p.root]) {
    (0, _set3.default)(results, p.root, {});
  }
  return Promise.all((0, _map3.default)(list, function (id, childKey) {
    var populateKey = id === true ? childKey : id;
    return getPopulateChild(firebase, p, populateKey).then(function (pc) {
      if (pc) {
        return (0, _set3.default)(results, p.root + '.' + populateKey, pc);
      }
      return results;
    });
  }));
};

var promisesForPopulate = exports.promisesForPopulate = function promisesForPopulate(firebase, dataKey, originalData, populatesIn) {
  var promisesArray = [];
  var results = {};

  var populatesForData = getPopulateObjs((0, _isFunction3.default)(populatesIn) ? populatesIn(dataKey, originalData) : populatesIn);

  var dataHasPopulateChilds = (0, _every3.default)(populatesForData, function (populate) {
    return (0, _has3.default)(originalData, populate.child);
  });

  if (dataHasPopulateChilds) {
    (0, _forEach3.default)(populatesForData, function (p) {
      if ((0, _isString3.default)((0, _get3.default)(originalData, p.child))) {
        return promisesArray.push(getPopulateChild(firebase, p, (0, _get3.default)(originalData, p.child)).then(function (v) {
          if (v) {
            (0, _set3.default)(results, p.root + '.' + (0, _get3.default)(originalData, p.child), v);
          }
        }));
      }

      return promisesArray.push(populateList(firebase, (0, _get3.default)(originalData, p.child), p, results));
    });
  } else {
    (0, _forEach3.default)(originalData, function (d, key) {
      var populatesForDataItem = getPopulateObj((0, _isFunction3.default)(populatesIn) ? populatesIn(key, d) : populatesIn);

      (0, _forEach3.default)(populatesForDataItem, function (p) {
        var idOrList = (0, _get3.default)(d, p.child);

        if (!idOrList) {
          return;
        }

        if ((0, _isString3.default)(idOrList)) {
          return promisesArray.push(getPopulateChild(firebase, p, idOrList).then(function (v) {
            if (v) {
              (0, _set3.default)(results, p.root + '.' + idOrList, v);
            }
            return results;
          }));
        }

        if ((0, _isArray3.default)(idOrList) || (0, _isObject3.default)(idOrList)) {
          return promisesArray.push(populateList(firebase, idOrList, p, results));
        }
      });
    });
  }

  return Promise.all(promisesArray).then(function () {
    return results;
  });
};

exports.default = { promisesForPopulate: promisesForPopulate };

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(146);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(131),
    baseIteratee = __webpack_require__(66),
    baseMap = __webpack_require__(683),
    isArray = __webpack_require__(21);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    isObject = __webpack_require__(28);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Do = exports.toNothing = exports.first = exports.equals = exports.Nothing = exports.chain = exports.of = exports.map = exports.pempty = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.inj = inj;
exports.prj = prj;
exports.isNothing = isNothing;
exports.isJust = isJust;
exports.empty = empty;
exports.concat = concat;
exports.getSemigroup = getSemigroup;
exports.getMonoid = getMonoid;
exports.ap = ap;
exports.reduce = reduce;
exports.alt = alt;
exports.extend = extend;
exports.traverse = traverse;
exports.throwError = throwError;
exports.catchError = catchError;
exports.getSetoid = getSetoid;
exports.maybe = maybe;
exports.fromMaybe = fromMaybe;
exports.fromJust = fromJust;

var _HKT = __webpack_require__(153);

var _Identity = __webpack_require__(351);

var _Fun = __webpack_require__(352);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsMaybe = function IsMaybe() {
  _classCallCheck(this, IsMaybe);
};

function inj(a) {
  return a;
}

function prj(fa) {
  return fa;
}

function isNothing(x) {
  return x == Nothing;
}

function isJust(x) {
  return x != Nothing;
}

function empty() {
  return Nothing;
}

var pempty = exports.pempty = empty;

function concat(semigroup) {
  return function concat(fx, fy) {
    var x = prj(fx);
    var y = prj(fy);
    if (x == null) {
      return fy;
    }
    if (y == null) {
      return fx;
    }
    return _of(semigroup.concat(x, y));
  };
}

function getSemigroup(semigroup) {
  return {
    concat: concat(semigroup)
  };
}

function getMonoid(semigroup) {
  return {
    empty: empty,
    concat: concat(semigroup)
  };
}

function _map(f, fa) {
  var a = prj(fa);
  return a == null ? Nothing : inj(f(a));
}

exports.map = _map;
function ap(fab, fa) {
  var ab = prj(fab);
  return ab == null ? Nothing : _map(ab, fa);
}

function _of(a) {
  return inj(a);
}

exports.of = _of;
function _chain(f, fa) {
  return maybe(Nothing, f, fa);
}

exports.chain = _chain;
var Nothing = exports.Nothing = inj(null);

function reduce(f, b, fa) {
  var a = prj(fa);
  return a == null ? b : f(b, a);
}

function alt(fx, fy) {
  return fx == Nothing ? fy : fx;
}

function extend(f, ea) {
  return isNothing(ea) ? Nothing : inj(f(ea));
}

function _equals(setoid, fx, fy) {
  var x = prj(fx);
  var y = prj(fy);
  if (x == null || y == null) {
    return true;
  }
  if (x != null || y != null) {
    return setoid.equals(x, y);
  }
  return false;
}

exports.equals = _equals;
function traverse(applicative, f, ta) {
  var a = prj(ta);
  if (a == null) {
    return applicative.of(Nothing);
  }
  return applicative.map(_of, f(a));
}

function throwError(e) {
  // eslint-disable-line no-unused-vars
  return Nothing;
}

function catchError(ma, handler) {
  var a = prj(ma);
  return a == null ? handler() : ma;
}

function getSetoid(setoid) {
  return {
    equals: function equals(fx, fy) {
      return _equals(setoid, fx, fy);
    }
  };
}

function maybe(b, f, fa) {
  return reduce(function (_, a) {
    return f(a);
  }, b, fa);
}

function fromMaybe(a, fa) {
  return maybe(a, _Identity.id, fa);
}

function fromJust(fa) {
  var a = prj(fa);
  if (a == null) {
    throw new Error('fromJust returned a Nothing');
  }
  return a;
}

// Maybe monoid returning the leftmost non-Nothing value.
var first = exports.first = {
  empty: empty,
  concat: alt
};

var toNothing = exports.toNothing = (0, _Fun.constant)(maybe.Nothing);

/*

  Do notation (experimental)

  Example:

  import * as maybe from '../Maybe'

  const x: Maybe<number> = maybe.Do.of(3)
    .map(n => n * 2)
    .chain(n => maybe.of(n - 1))
    .value

*/

var Do = exports.Do = function () {
  _createClass(Do, null, [{
    key: 'of',
    value: function of(a) {
      return new Do(_of(a));
    }
  }]);

  function Do(value) {
    _classCallCheck(this, Do);

    this.value = value;
  }

  _createClass(Do, [{
    key: 'map',
    value: function map(f) {
      return new Do(_map(f, this.value));
    }
  }, {
    key: 'chain',
    value: function chain(f) {
      return new Do(_chain(f, this.value));
    }
  }]);

  return Do;
}();

if (false) {
  // eslint-disable-line
  ({
    map: _map,
    ap: ap,
    of: _of,
    chain: _chain,
    reduce: reduce,
    alt: alt,
    pempty: pempty,
    extend: extend,
    traverse: traverse,
    throwError: throwError,
    catchError: catchError
  });
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HKT = exports.HKT = function HKT() {
  _classCallCheck(this, HKT);
}; // eslint-disable-line no-unused-vars

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
var firebase = __webpack_require__(108);
__webpack_require__(762);
var Storage, XMLHttpRequest;

__webpack_require__(763);
__webpack_require__(764);
var AsyncStorage;

__webpack_require__(765);
exports.default = firebase;
module.exports = exports['default'];
//# sourceMappingURL=firebase.js.map


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reduceEntities = reduceEntities;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configs = _lodash2.default.keyBy([{
  envName: "swarm2-dev",
  authMode: "closedBeta",
  googleAnalyticsId: "UA-101184836-2",
  firebase: {
    // https://console.firebase.google.com/project/swarm2-dev/authentication/users
    apiKey: "AIzaSyAqbbAkIovDo-lGE_jeTAxBRctEwnevwo8",
    authDomain: "swarm2-dev.firebaseapp.com",
    databaseURL: "https://swarm2-dev.firebaseio.com",
    projectId: "swarm2-dev",
    storageBucket: "swarm2-dev.appspot.com",
    messagingSenderId: "1063516296740"
  }
}, {
  envName: "swarm2-integration",
  authMode: "closedBeta",
  googleAnalyticsId: "UA-101184836-3",
  firebase: {
    // https://console.firebase.google.com/project/swarm2-integration/authentication/users
    apiKey: "AIzaSyDGsij0RIn3YiDnHRsZQ1NQsvGJ6c5VN1M",
    authDomain: "swarm2-integration.firebaseapp.com",
    databaseURL: "https://swarm2-integration.firebaseio.com",
    projectId: "swarm2-integration",
    storageBucket: "swarm2-integration.appspot.com",
    messagingSenderId: "249475447643"
  }
},
// https://console.firebase.google.com/project/swarm2-beta/authentication/users
{
  envName: "swarm2-beta",
  authMode: "closedBeta",
  googleAnalyticsId: "UA-101184836-4",
  firebase: {
    apiKey: "AIzaSyDtDlSiJSj2s8uXw5ftRTfJkcUWwzuqkMo",
    authDomain: "swarm2-beta.firebaseapp.com",
    databaseURL: "https://swarm2-beta.firebaseio.com",
    projectId: "swarm2-beta",
    storageBucket: "swarm2-beta.appspot.com",
    messagingSenderId: "154817497270"
  }
},
// https://console.firebase.google.com/project/swarm2-prod/authentication/users
{
  envName: "swarm2-prod",
  authMode: "closedBeta",
  googleAnalyticsId: "UA-101184836-5",
  firebase: {
    apiKey: "AIzaSyCu1ByEkY_Dk4ZQMrtQh0Tgv0-mPXennis",
    authDomain: "swarm2-prod.firebaseapp.com",
    databaseURL: "https://swarm2-prod.firebaseio.com",
    projectId: "swarm2-prod",
    storageBucket: "swarm2-prod.appspot.com",
    messagingSenderId: "382924306159"
  }
}], "envName");
// Tests are expected to mock out firebase calls
configs.__TEST__ = _extends({}, configs["swarm2-dev"], {
  firebase: null
});

var nodeEnvToConfigKey = {
  // no production node-env config, deliberately. firebase-env required in prod.
  development: "swarm2-dev",
  test: "__TEST__"

  // NODE_ENV is limited to 'development', 'production', 'test' - but I want others, like staging/integration.
  // Also, NODE_ENV can have other side effects that shouldn't be coupled to Firebase.
  // While developing though, it's convenient to default to development/test envs, so use NODE_ENV there.
  //
  // The REACT_APP_ prefix is required by create-react-app.
  // https://github.com/facebookincubator/create-react-app/blob/master/packages/react-scripts/template/README.md#adding-custom-environment-variables
};function findConfig() {
  var _process$env = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_FIREBASE_ENV":"swarm2-dev"}),
      REACT_APP_FIREBASE_ENV = _process$env.REACT_APP_FIREBASE_ENV,
      NODE_ENV = _process$env.NODE_ENV,
      GCLOUD_PROJECT = _process$env.GCLOUD_PROJECT;

  var name = REACT_APP_FIREBASE_ENV || GCLOUD_PROJECT || NODE_ENV && nodeEnvToConfigKey[NODE_ENV] || (0, _assert.throws)("no name for environment config", {
    REACT_APP_FIREBASE_ENV: REACT_APP_FIREBASE_ENV,
    NODE_ENV: NODE_ENV,
    GCLOUD_PROJECT: GCLOUD_PROJECT,
    env: Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_FIREBASE_ENV":"swarm2-dev"})
  });
  var config = configs[name];
  // flow doesn't understand `return assert(config, ...)`
  if (config) return config;
  return (0, _assert.throws)("no config for environment", {
    REACT_APP_FIREBASE_ENV: REACT_APP_FIREBASE_ENV,
    NODE_ENV: NODE_ENV,
    GCLOUD_PROJECT: GCLOUD_PROJECT,
    env: Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_FIREBASE_ENV":"swarm2-dev"})
  });
}

var config = exports.config = findConfig();
exports.default = config;
function reduceEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config;

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(779);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3pvbmUtdHlwZXMvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0ICogZnJvbSBcIi4vcm9vdFwiXG4iXX0=

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localState = exports.byName = undefined;
exports.name = name;
exports.resolve = resolve;

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _ = _interopRequireWildcard(_fp);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _list = __webpack_require__(361);

var _list2 = _interopRequireDefault(_list);

var _lifecycle = __webpack_require__(222);

var Lifecycle = _interopRequireWildcard(_lifecycle);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var leagues = function leagues() {
  return _list2.default;
};
var rawName = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return s.league || "standard";
});
function name(root, props) {
  return props.league || rawName(root, props);
}
var byName = exports.byName = (0, _reselect.createSelector)(leagues, _.keyBy("name"));
function resolve(name0, leagues, now) {
  var name = name0;
  for (var i = 0; i < 100; i++) {
    var league = leagues[name] || (0, _assert.throws)("no such league", { name: name, name0: name0, i: i });
    var status = Lifecycle._status(league.lifecycle, now);
    var nextName = Lifecycle._migrateToLeague(league.lifecycle.migrateToLeague, status);
    if (!nextName) return league;
    name = nextName;
  }
  return (0, _assert.throws)("could not resolve league, too many iterations", {
    name: name,
    name0: name0
  });
}
var localState = exports.localState = (0, _reselect.createSelector)(name, byName, Now.now, resolve);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFixedProps = exports.createDeepSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDeepSelector = exports.createDeepSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _lodash2.default.isEqual);
var withFixedProps = exports.withFixedProps = function withFixedProps(props1, selector) {
  return function (state, props0) {
    return selector(state, _extends({}, props0, props1));
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zZWxlY3QtdXRpbHMuanMiXSwibmFtZXMiOlsiY3JlYXRlRGVlcFNlbGVjdG9yIiwiaXNFcXVhbCIsIndpdGhGaXhlZFByb3BzIiwicHJvcHMxIiwic2VsZWN0b3IiLCJzdGF0ZSIsInByb3BzMCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQ0E7O0FBQ0E7Ozs7OztBQUVPLElBQU1BLGtEQUFxQiwrREFFaEMsaUJBQUVDLE9BRjhCLENBQTNCO0FBSUEsSUFBTUMsMENBQWlCLFNBQWpCQSxjQUFpQixDQUM1QkMsTUFENEIsRUFFNUJDLFFBRjRCO0FBQUEsU0FHekIsVUFBQ0MsS0FBRCxFQUFXQyxNQUFYO0FBQUEsV0FBNkJGLFNBQVNDLEtBQVQsZUFBb0JDLE1BQXBCLEVBQStCSCxNQUEvQixFQUE3QjtBQUFBLEdBSHlCO0FBQUEsQ0FBdkIiLCJmaWxlIjoic2VsZWN0LXV0aWxzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7Y3JlYXRlU2VsZWN0b3JDcmVhdG9yLCBkZWZhdWx0TWVtb2l6ZX0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuXG5leHBvcnQgY29uc3QgY3JlYXRlRGVlcFNlbGVjdG9yID0gY3JlYXRlU2VsZWN0b3JDcmVhdG9yKFxuICBkZWZhdWx0TWVtb2l6ZSxcbiAgXy5pc0VxdWFsLFxuKVxuZXhwb3J0IGNvbnN0IHdpdGhGaXhlZFByb3BzID0gPFMsIFAwOiB7fSwgUDE6IHt9LCBPPihcbiAgcHJvcHMxOiBQMSxcbiAgc2VsZWN0b3I6IChTLCBQMCAmIFAxKSA9PiBPLFxuKSA9PiAoc3RhdGU6IFMsIHByb3BzMDogUDApOiBPID0+IHNlbGVjdG9yKHN0YXRlLCB7Li4ucHJvcHMwLCAuLi5wcm9wczF9KVxuIl19

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordsMatchError = exports.anonError = exports.notAnonError = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _reselect = __webpack_require__(2);

var _form = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notAnonError = exports.notAnonError = (0, _reselect.createSelector)(_selectors2.default.auth.isAnonymous, function (isAnon) {
  return isAnon ? "notanonymous" : null;
});
var anonError = exports.anonError = (0, _reselect.createSelector)(_selectors2.default.auth.isAnonymous, function (isAnon) {
  return isAnon ? null : "anonymous";
});
var passwordsMatchError = exports.passwordsMatchError = (0, _reselect.createSelector)((0, _form.propname)("password"), (0, _form.propname)("password2"), function (p1, p2) {
  return p1 && p2 && p1 !== p2 ? "passwordmatch" : null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL2F1dGgtc2lnbmluL3V0aWwuanMiXSwibmFtZXMiOlsibm90QW5vbkVycm9yIiwiYXV0aCIsImlzQW5vbnltb3VzIiwiaXNBbm9uIiwiYW5vbkVycm9yIiwicGFzc3dvcmRzTWF0Y2hFcnJvciIsInAxIiwicDIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBRU8sSUFBTUEsc0NBQWUsOEJBQzFCLG9CQUFFQyxJQUFGLENBQU9DLFdBRG1CLEVBRTFCO0FBQUEsU0FBV0MsU0FBUyxjQUFULEdBQTBCLElBQXJDO0FBQUEsQ0FGMEIsQ0FBckI7QUFJQSxJQUFNQyxnQ0FBWSw4QkFDdkIsb0JBQUVILElBQUYsQ0FBT0MsV0FEZ0IsRUFFdkI7QUFBQSxTQUFXQyxTQUFTLElBQVQsR0FBZ0IsV0FBM0I7QUFBQSxDQUZ1QixDQUFsQjtBQUlBLElBQU1FLG9EQUFzQiw4QkFDakMsb0JBQVMsVUFBVCxDQURpQyxFQUVqQyxvQkFBUyxXQUFULENBRmlDLEVBR2pDLFVBQUNDLEVBQUQsRUFBS0MsRUFBTDtBQUFBLFNBQWFELE1BQU1DLEVBQU4sSUFBWUQsT0FBT0MsRUFBbkIsR0FBd0IsZUFBeEIsR0FBMEMsSUFBdkQ7QUFBQSxDQUhpQyxDQUE1QiIsImZpbGUiOiJ1dGlsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSIGZyb20gXCIuLi8uLi9zZWxlY3RvcnNcIlxuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCB7cHJvcG5hbWV9IGZyb20gXCIuLi91dGlsL2Zvcm1cIlxuXG5leHBvcnQgY29uc3Qgbm90QW5vbkVycm9yID0gY3JlYXRlU2VsZWN0b3IoXG4gIFIuYXV0aC5pc0Fub255bW91cyxcbiAgaXNBbm9uID0+IChpc0Fub24gPyBcIm5vdGFub255bW91c1wiIDogbnVsbCksXG4pXG5leHBvcnQgY29uc3QgYW5vbkVycm9yID0gY3JlYXRlU2VsZWN0b3IoXG4gIFIuYXV0aC5pc0Fub255bW91cyxcbiAgaXNBbm9uID0+IChpc0Fub24gPyBudWxsIDogXCJhbm9ueW1vdXNcIiksXG4pXG5leHBvcnQgY29uc3QgcGFzc3dvcmRzTWF0Y2hFcnJvciA9IGNyZWF0ZVNlbGVjdG9yKFxuICBwcm9wbmFtZShcInBhc3N3b3JkXCIpLFxuICBwcm9wbmFtZShcInBhc3N3b3JkMlwiKSxcbiAgKHAxLCBwMikgPT4gKHAxICYmIHAyICYmIHAxICE9PSBwMiA/IFwicGFzc3dvcmRtYXRjaFwiIDogbnVsbCksXG4pXG4iXX0=

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHelpOutline = function ActionHelpOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
  );
};
ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
ActionHelpOutline.displayName = 'ActionHelpOutline';
ActionHelpOutline.muiName = 'SvgIcon';

exports.default = ActionHelpOutline;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(476);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(167)('keys');
var uid = __webpack_require__(121);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(61);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(490);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(99);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(69);
var dPs = __webpack_require__(497);
var enumBugKeys = __webpack_require__(174);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(256)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(500).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(63).f;
var has = __webpack_require__(68);
var TAG = __webpack_require__(40)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(501);
var global = __webpack_require__(61);
var hide = __webpack_require__(78);
var Iterators = __webpack_require__(80);
var TO_STRING_TAG = __webpack_require__(40)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(40);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(61);
var core = __webpack_require__(33);
var LIBRARY = __webpack_require__(171);
var wksExt = __webpack_require__(177);
var defineProperty = __webpack_require__(63).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(273);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(274);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(127);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TypeWrapper = exports.TypeWrapper = function () {
  // A constructor that can't be called (nothing can satisfy the "empty" type).
  function TypeWrapper(_) {
    _classCallCheck(this, TypeWrapper);
  }

  // Inner -> Wrapped Value


  _createClass(TypeWrapper, null, [{
    key: "wrap",
    value: function wrap(x) {
      return x;
    }

    // Wrapped Value -> Inner

  }, {
    key: "unwrap",
    value: function unwrap(x) {
      return x;
    }
  }]);

  return TypeWrapper;
}();

// eg.
// class UserID extends TypeWrapper<string> {}
//
// const id = UserID.wrap("123-abcd");
// const user = { id: id, name: "Bert" }
// const userSummary = UserID.unwrap(id) + ": " + user.name;

// TODO: ExpectError, see type testing, add gcanti link.

/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(132),
    arrayEach = __webpack_require__(137),
    assignValue = __webpack_require__(138),
    baseAssign = __webpack_require__(294),
    baseAssignIn = __webpack_require__(630),
    cloneBuffer = __webpack_require__(297),
    copyArray = __webpack_require__(105),
    copySymbols = __webpack_require__(633),
    copySymbolsIn = __webpack_require__(634),
    getAllKeys = __webpack_require__(301),
    getAllKeysIn = __webpack_require__(303),
    getTag = __webpack_require__(199),
    initCloneArray = __webpack_require__(638),
    initCloneByTag = __webpack_require__(639),
    initCloneObject = __webpack_require__(309),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(141),
    isObject = __webpack_require__(28),
    keys = __webpack_require__(86);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(34);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(611),
    mapCacheDelete = __webpack_require__(618),
    mapCacheGet = __webpack_require__(620),
    mapCacheHas = __webpack_require__(621),
    mapCacheSet = __webpack_require__(622);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(626),
    baseUnary = __webpack_require__(627),
    nodeUtil = __webpack_require__(628);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(142),
    nativeKeys = __webpack_require__(629);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(298),
    stubArray = __webpack_require__(299);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(296);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(635),
    Map = __webpack_require__(191),
    Promise = __webpack_require__(636),
    Set = __webpack_require__(637),
    WeakMap = __webpack_require__(304),
    baseGetTag = __webpack_require__(64),
    toSource = __webpack_require__(292);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(305);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(106);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(652),
    overRest = __webpack_require__(316),
    setToString = __webpack_require__(204);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(654),
    shortOut = __webpack_require__(317);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(137),
    baseEach = __webpack_require__(89),
    castFunction = __webpack_require__(658),
    isArray = __webpack_require__(21);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAuthIsReady = exports.authIsReady = exports.getLoginMethodAndParams = undefined;

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__(90);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(21);

var _isArray3 = _interopRequireDefault(_isArray2);

var _capitalize2 = __webpack_require__(659);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _constants = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createAuthProvider = function createAuthProvider(firebase, providerName, scopes) {
  var provider = new firebase.auth[(0, _capitalize3.default)(providerName) + 'AuthProvider']();

  var customAuthParameters = firebase._.config.customAuthParameters;

  if (customAuthParameters && customAuthParameters[providerName]) {
    provider.setCustomParameters(customAuthParameters[providerName]);
  }

  if (providerName.toLowerCase() === 'twitter' || !(0, _isFunction3.default)(provider.addScope)) {
    return provider;
  }

  provider.addScope('email');

  if (scopes) {
    if ((0, _isArray3.default)(scopes)) {
      scopes.forEach(function (scope) {
        provider.addScope(scope);
      });
    }
    if ((0, _isString3.default)(scopes)) {
      provider.addScope(scopes);
    }
  }

  return provider;
};

var getLoginMethodAndParams = exports.getLoginMethodAndParams = function getLoginMethodAndParams(firebase, _ref) {
  var email = _ref.email,
      password = _ref.password,
      provider = _ref.provider,
      type = _ref.type,
      token = _ref.token,
      scopes = _ref.scopes,
      credential = _ref.credential;

  if (credential) {
    return { method: 'signInWithCredential', params: [credential] };
  }
  if (provider) {
    if (_constants.supportedAuthProviders.indexOf(provider.toLowerCase()) === -1) {
      throw new Error(provider + ' is not a valid Auth Provider');
    }
    if (token) {
      throw new Error('provider with token no longer supported, use credential parameter instead');
    }
    var authProvider = createAuthProvider(firebase, provider, scopes);
    if (type === 'popup') {
      return { method: 'signInWithPopup', params: [authProvider] };
    }
    return { method: 'signInWithRedirect', params: [authProvider] };
  }
  if (token) {
    return { method: 'signInWithCustomToken', params: [token] };
  }
  return { method: 'signInWithEmailAndPassword', params: [email, password] };
};

var isAuthReady = function isAuthReady(store, stateName) {
  var state = store.getState();
  var firebaseState = stateName ? state[stateName] : state;
  var firebaseAuthState = firebaseState && firebaseState.auth;
  if (!firebaseAuthState) {
    throw new Error('The Firebase auth state could not be found in the store under the attribute \'' + (stateName ? stateName + '.' : '') + 'auth\'. Make sure your react-redux-firebase reducer is correctly set in the store');
  }
  return firebaseState.auth.isLoaded;
};

var authIsReady = exports.authIsReady = function authIsReady(store) {
  var stateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'firebase';
  return new Promise(function (resolve) {
    if (isAuthReady(store, stateName)) {
      resolve();
    } else {
      var unsubscribe = store.subscribe(function () {
        if (isAuthReady(store, stateName)) {
          unsubscribe();
          resolve();
        }
      });
    }
  });
};

var createAuthIsReady = exports.createAuthIsReady = function createAuthIsReady(store, config) {
  return (0, _isFunction3.default)(config.authIsReady) ? config.authIsReady(store, config) : authIsReady(store, config.firebaseStateName);
};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(670),
    isObjectLike = __webpack_require__(44);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(104),
    isArrayLike = __webpack_require__(65),
    isIndex = __webpack_require__(87),
    isObject = __webpack_require__(28);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(138),
    castPath = __webpack_require__(88),
    isIndex = __webpack_require__(87),
    isObject = __webpack_require__(28),
    toKey = __webpack_require__(73);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = exports.createCallable = exports.getEventsFromInput = undefined;

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _events = __webpack_require__(696);

Object.defineProperty(exports, 'getEventsFromInput', {
  enumerable: true,
  get: function get() {
    return _events.getEventsFromInput;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createCallable = exports.createCallable = function createCallable(f) {
  return (0, _isFunction3.default)(f) ? f : function () {
    return f;
  };
};

var getDisplayName = exports.getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(334),
    createBind = __webpack_require__(707),
    createCurry = __webpack_require__(708),
    createHybrid = __webpack_require__(336),
    createPartial = __webpack_require__(725),
    getData = __webpack_require__(340),
    mergeData = __webpack_require__(726),
    setData = __webpack_require__(342),
    setWrapToString = __webpack_require__(343),
    toInteger = __webpack_require__(345);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    baseLodash = __webpack_require__(214);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = __webpack_require__(91);

Object.defineProperty(exports, "Id", {
  enumerable: true,
  get: function get() {
    return _types.Id;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvYXV0aC90eXBlcy5qcyJdLCJuYW1lcyI6WyJJZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7a0JBQ1FBLEUiLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0IHtJZH0gZnJvbSBcIi4uL3VzZXJzL3R5cGVzXCJcbmV4cG9ydCB0eXBlIFN0YXRlID0ge1xuICAraXNBbm9ueW1vdXM6IGJvb2xlYW4sXG4gICtlbWFpbDogP3N0cmluZyxcbiAgK3VpZDogc3RyaW5nLFxufVxuXG5leHBvcnQgdHlwZSBQcm9wcyA9IGFueVxuZXhwb3J0IHR5cGUgU2VsZWN0PFQ+ID0gKFN0YXRlLCBhbnkpID0+IFRcbiJdfQ==

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(759);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});

var _types = __webpack_require__(91);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvdXNlcnMvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0ICogZnJvbSBcIi4vcm9vdFwiXG5leHBvcnQgKiBmcm9tIFwiLi90eXBlc1wiXG4iXX0=

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.isLoaded = isLoaded;
exports.isEmpty = isEmpty;
exports.middleware = middleware;

var _firebase = __webpack_require__(154);

var _firebase2 = _interopRequireDefault(_firebase);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false };
  var action = arguments[1];

  switch (action.type) {
    case "AUTH_STATE_CHANGED":
      return { isLoaded: true, isEmpty: action.isEmpty };
    default:
      return state;
  }
}

function isLoaded(state) {
  return state.firebaseAuthLoaded.isLoaded;
}
function isEmpty(state) {
  return state.firebaseAuthLoaded.isEmpty;
}

// react-redux-firebase doesn't return auth status accurately, so do it manually.
function middleware(store) {
  // react-redux-firebase doesn't correctly report when auth's loaded if the user's not logged in, so do it manually
  _firebase2.default.auth().onAuthStateChanged(function (user) {
    return store.dispatch({ type: "AUTH_STATE_CHANGED", isEmpty: !user });
  });
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinceUpdated = exports.get = undefined;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return Util.Timestamp.wrap(s.updatedAt || s.createdAt);
});
var sinceUpdated = exports.sinceUpdated = Now.since(get);

function reducer(state, action) {
  switch (action.type) {
    case "BUY_UNIT":
    case "__COMBAT_RESULT":
      return action.createdAt;
    default:
      // initial state can be missing, but combineReducers() doesn't support
      // that. Null is close enough. Don't allow it in the typings though -
      // erasing it after init would be bad.
      return state || null;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _reselect = __webpack_require__(2);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(RawChar.localState, function (s) {
  return s.units || {};
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvcmF3LmpzIl0sIm5hbWVzIjpbIlJhd0NoYXIiLCJnZXQiLCJsb2NhbFN0YXRlIiwicyIsInVuaXRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0FBQ0E7O0lBQVlBLE87Ozs7QUFHTCxJQUFNQyxvQkFBTSw4QkFBZUQsUUFBUUUsVUFBdkIsRUFBbUM7QUFBQSxTQUFLQyxFQUFFQyxLQUFGLElBQVcsRUFBaEI7QUFBQSxDQUFuQyxDQUFaIiwiZmlsZSI6InJhdy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0ICogYXMgUmF3Q2hhciBmcm9tIFwiLi4vcmF3XCJcblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7W3VuaXROYW1lOiBzdHJpbmddOiBPYmplY3R9XG5leHBvcnQgY29uc3QgZ2V0ID0gY3JlYXRlU2VsZWN0b3IoUmF3Q2hhci5sb2NhbFN0YXRlLCBzID0+IHMudW5pdHMgfHwge30pXG4iXX0=

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raw = __webpack_require__(157);

Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _raw.name;
  }
});
Object.defineProperty(exports, "byName", {
  enumerable: true,
  get: function get() {
    return _raw.byName;
  }
});

var _lifecycle = __webpack_require__(784);

Object.defineProperty(exports, "status", {
  enumerable: true,
  get: function get() {
    return _lifecycle.status;
  }
});
Object.defineProperty(exports, "migrateToLeague", {
  enumerable: true,
  get: function get() {
    return _lifecycle.migrateToLeague;
  }
});
Object.defineProperty(exports, "isOpen", {
  enumerable: true,
  get: function get() {
    return _lifecycle.isOpen;
  }
});
Object.defineProperty(exports, "untilOpen", {
  enumerable: true,
  get: function get() {
    return _lifecycle.untilOpen;
  }
});

var _visible = __webpack_require__(785);

Object.defineProperty(exports, "visibleNames", {
  enumerable: true,
  get: function get() {
    return _visible.visibleNames;
  }
});

var _rulesets = __webpack_require__(792);

Object.keys(_rulesets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rulesets[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9pbmRleC5qcyJdLCJuYW1lcyI6WyJuYW1lIiwiYnlOYW1lIiwic3RhdHVzIiwibWlncmF0ZVRvTGVhZ3VlIiwiaXNPcGVuIiwidW50aWxPcGVuIiwidmlzaWJsZU5hbWVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztnQkFDUUEsSTs7Ozs7O2dCQUFNQyxNOzs7Ozs7Ozs7c0JBQ05DLE07Ozs7OztzQkFBUUMsZTs7Ozs7O3NCQUFpQkMsTTs7Ozs7O3NCQUFRQyxTOzs7Ozs7Ozs7b0JBQ2pDQyxZOzs7Ozs7QUFDUjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0IHtuYW1lLCBieU5hbWV9IGZyb20gXCIuL3Jhd1wiXG5leHBvcnQge3N0YXR1cywgbWlncmF0ZVRvTGVhZ3VlLCBpc09wZW4sIHVudGlsT3Blbn0gZnJvbSBcIi4vbGlmZWN5Y2xlXCJcbmV4cG9ydCB7dmlzaWJsZU5hbWVzfSBmcm9tIFwiLi92aXNpYmxlXCJcbmV4cG9ydCAqIGZyb20gXCIuL3J1bGVzZXRzXCJcbiJdfQ==

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._status = _status;
exports._migrateToLeague = _migrateToLeague;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _status(lifecycle, now) {
  var visibleAt = lifecycle.visibleAt,
      openAt = lifecycle.openAt,
      closedAt = lifecycle.closedAt;

  if (closedAt != null && !Util.Timestamp.isBefore(now, closedAt)) return "closed";
  if (!Util.Timestamp.isBefore(now, openAt)) return "open";
  if (!Util.Timestamp.isBefore(now, visibleAt)) return "visible";
  return "hidden";
}
// Lifecycle functions independent of the redux state, to avoid circular deps
// when loading from redux.

var DEFAULT_LEAGUE = "void";
function _migrateToLeague(nextLeague, status) {
  if (status !== "closed") return null;
  return nextLeague || DEFAULT_LEAGUE;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(790);
var objectAssign = __webpack_require__(117);
var decodeComponent = __webpack_require__(791);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisible = exports.visibleNames = exports.visibleCombatNames = exports.visibleMeatNames = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _reify = __webpack_require__(110);

var UnitReify = _interopRequireWildcard(_reify);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allNames = UnitTypes.names;
var groupNames = UnitTypes.groupNamesSelector;
var hiddenNames = groupNames("_hidden");
var larvaNames = groupNames("larva");
var meatTreeNames = groupNames("meat");
var meatNames = (0, _reselect.createSelector)(meatTreeNames, larvaNames, _lodash2.default.union);
var combatNames = groupNames("combat");

// A meat unit is visible if:
// * it's nonzero, or
// * it's ever been nonzero, or
// * its costs are all nonzero (ex. drones visible if meat + larva visible)
// Once a unit's visible, it never becomes invisible.
var nonzeroInits = (0, _reselect.createSelector)(UnitTypes.initCounts, function (cs) {
  return _lodash2.default.pickBy(_lodash2.default.mapValues(cs, function (c) {
    return !c.isZero();
  }));
});

var visibleFromReify = (0, _reselect.createSelector)(UnitReify.reifiedByName, nonzeroInits, hiddenNames, function (rs, is, hs) {
  return _lodash2.default.omit(_extends({}, rs, is), hs);
});
var meatCosts = (0, _reselect.createSelector)(UnitTypes.costs, meatNames, _lodash2.default.pick);
var meatCostNames = (0, _reselect.createSelector)(meatCosts, function (cs) {
  return _lodash2.default.mapValues(cs, _lodash2.default.keys);
});
var visibleMeatByName = (0, _reselect.createSelector)(visibleFromReify, meatCostNames, (0, _reselect.createStructuredSelector)({
  // special case: hide queens until 90 drones, to simplify for newbies
  //queen: createSelector(
  //  visibleFromReify,
  //  (s, p) => UnitReify.count(s, {...p, unitName: "drone"}),
  //  (vis, drones) => "queen" in vis || drones.gte(90),
  //),
}), function (vis, costs, specialCases) {
  return _lodash2.default.pickBy(_extends({}, _lodash2.default.mapValues(costs, function (costNames, parent) {
    return parent in vis || _lodash2.default.every(costNames, function (child) {
      return child in vis;
    });
  }), specialCases));
});

// Each soldier has specific unlock criteria. No general algorithm, like meat.
var visibleCombatByName = (0, _reselect.createSelector)((0, _reselect.createStructuredSelector)({
  "swarmling-queen": function swarmlingQueen(s, p) {
    return true;
  },
  tower: function tower() {
    return false;
  },
  "overlord-den": Zones.selectIsCleared("zone6")
}), _lodash2.default.pickBy);

var visibleByName = (0, _reselect.createSelector)(visibleFromReify, visibleMeatByName, visibleCombatByName, function (rs, ms, cs) {
  return _extends({}, rs, ms, cs);
});
// list visible names in a consistent order.
// (XByName.keys() does not have consistent order.)
var _visibleNames = function _visibleNames(names) {
  return (0, _reselect.createSelector)(visibleByName, names, function (vis, ns) {
    return _lodash2.default.filter(ns, function (n) {
      return n in vis;
    });
  });
};
var visibleMeatNames = exports.visibleMeatNames = _visibleNames(meatNames);
var visibleCombatNames = exports.visibleCombatNames = _visibleNames(combatNames);
var visibleNames = exports.visibleNames = _visibleNames(allNames);

// char + unit
var nameProp = function nameProp(s, p) {
  return p.unitName;
};
var isVisible = exports.isVisible = (0, _reselect.createSelector)(visibleByName, nameProp, _lodash2.default.has);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.earnedSinceLock = exports.earnedSince = exports.names = exports.typesList = exports.completedAt = exports.numCompleted = exports.completedNames = exports.byName = undefined;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _achievementTypes = __webpack_require__(226);

var AchievementTypes = _interopRequireWildcard(_achievementTypes);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byName = exports.byName = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.achievements || {};
});
var completedNames = exports.completedNames = (0, _reselect.createSelector)(byName, _lodash2.default.keys);
var numCompleted = exports.numCompleted = (0, _reselect.createSelector)(completedNames, _lodash2.default.size);

var nameProp = function nameProp(s, p) {
  return p.achievementName;
};
var completedAt = exports.completedAt = (0, _reselect.createSelector)(byName, nameProp, function (as, n) {
  return as[n] || null;
});

var typesList = exports.typesList = (0, _reselect.createSelector)(AchievementTypes.localState, function (s) {
  return s.list;
});
var names = exports.names = (0, _reselect.createSelector)(typesList, function (list) {
  return _lodash2.default.map(list, "name");
});
var nameOrdinals = (0, _reselect.createSelector)(names, function (names) {
  return _lodash2.default.fromPairs(_lodash2.default.map(names, function (name, index) {
    return [name, index];
  }));
});
var earnedOrder = (0, _reselect.createSelector)(byName, nameOrdinals, function (dates, ord) {
  return _lodash2.default.sortBy(
  // valid keys only
  _lodash2.default.filter(_lodash2.default.keys(dates), function (name) {
    return name in ord;
  }), function (name) {
    return [dates[name], ord[name]];
  });
});

var afterProp = function afterProp(s, p) {
  return p.after;
};
var _earnedSince = function _earnedSince(names, dates, after) {
  return _lodash2.default.filter(names, function (name) {
    return dates[name] > after;
  });
};
var earnedSince = exports.earnedSince = (0, _reselect.createSelector)(earnedOrder, byName, afterProp, _earnedSince);
// selector-factory. Return all achievements earned since this selector was
// created, probably in a toast or queue component.
var earnedSinceLock = exports.earnedSinceLock = function earnedSinceLock() {
  return (0, _reselect.createSelector)(earnedOrder, byName, _lodash2.default.flow(Now.lockNow(), Util.Timestamp.unwrap), _earnedSince);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(795);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2FjaGlldmVtZW50LXR5cGVzL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmV4cG9ydCAqIGZyb20gXCIuL3Jvb3RcIlxuIl19

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = exports.isEmpty = exports.get = undefined;
exports.renameAction = renameAction;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.displayName;
});
var get = exports.get = (0, _reselect.createSelector)(_get, function (name) {
  return name || "Unnamed swarm";
});
var isEmpty = exports.isEmpty = _lodash2.default.negate(_get);
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);

function renameAction(displayName) {
  return { type: "RENAME", displayName: displayName };
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "RENAME":
      return action.displayName;
    default:
      return state || null;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvZGlzcGxheS1uYW1lLmpzIl0sIm5hbWVzIjpbInJlbmFtZUFjdGlvbiIsInJlZHVjZXIiLCJSYXciLCJfZ2V0IiwibG9jYWxTdGF0ZSIsInMiLCJkaXNwbGF5TmFtZSIsImdldCIsIm5hbWUiLCJpc0VtcHR5IiwibmVnYXRlIiwiaXNOb3RFbXB0eSIsInR5cGUiLCJzdGF0ZSIsImFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O1FBWWdCQSxZLEdBQUFBLFk7UUFHQUMsTyxHQUFBQSxPOztBQWRoQjs7QUFDQTs7OztBQUNBOztJQUFZQyxHOzs7Ozs7QUFHWixJQUFNQyxPQUFPLDhCQUFlRCxJQUFJRSxVQUFuQixFQUErQjtBQUFBLFNBQUtDLEVBQUVDLFdBQVA7QUFBQSxDQUEvQixDQUFiO0FBQ08sSUFBTUMsb0JBQU0sOEJBQWVKLElBQWYsRUFBcUI7QUFBQSxTQUFRSyxRQUFRLGVBQWhCO0FBQUEsQ0FBckIsQ0FBWjtBQUNBLElBQU1DLDRCQUFVLGlCQUFFQyxNQUFGLENBQVNQLElBQVQsQ0FBaEI7QUFDQSxJQUFNUSxrQ0FBYSxpQkFBRUQsTUFBRixDQUFTRCxPQUFULENBQW5COztBQUdBLFNBQVNULFlBQVQsQ0FBc0JNLFdBQXRCLEVBQTBDO0FBQy9DLFNBQU8sRUFBQ00sTUFBTSxRQUFQLEVBQWlCTix3QkFBakIsRUFBUDtBQUNEO0FBQ00sU0FBU0wsT0FBVCxHQUFvRTtBQUFBLE1BQW5EWSxLQUFtRCx1RUFBbkMsSUFBbUM7QUFBQSxNQUE3QkMsTUFBNkI7O0FBQ3pFLFVBQVFBLE9BQU9GLElBQWY7QUFDRSxTQUFLLFFBQUw7QUFDRSxhQUFPRSxPQUFPUixXQUFkO0FBQ0Y7QUFDRSxhQUFPTyxTQUFTLElBQWhCO0FBSko7QUFNRCIsImZpbGUiOiJkaXNwbGF5LW5hbWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuaW1wb3J0ICogYXMgUmF3IGZyb20gXCIuL3Jhd1wiXG5cbnR5cGUgU3RhdGUgPSBzdHJpbmcgfCBudWxsXG5jb25zdCBfZ2V0ID0gY3JlYXRlU2VsZWN0b3IoUmF3LmxvY2FsU3RhdGUsIHMgPT4gcy5kaXNwbGF5TmFtZSlcbmV4cG9ydCBjb25zdCBnZXQgPSBjcmVhdGVTZWxlY3RvcihfZ2V0LCBuYW1lID0+IG5hbWUgfHwgXCJVbm5hbWVkIHN3YXJtXCIpXG5leHBvcnQgY29uc3QgaXNFbXB0eSA9IF8ubmVnYXRlKF9nZXQpXG5leHBvcnQgY29uc3QgaXNOb3RFbXB0eSA9IF8ubmVnYXRlKGlzRW1wdHkpXG5cbmV4cG9ydCB0eXBlIFJlbmFtZUFjdGlvbiA9IHsrdHlwZTogXCJSRU5BTUVcIiwgK2Rpc3BsYXlOYW1lOiBTdGF0ZX1cbmV4cG9ydCBmdW5jdGlvbiByZW5hbWVBY3Rpb24oZGlzcGxheU5hbWU6IFN0YXRlKSB7XG4gIHJldHVybiB7dHlwZTogXCJSRU5BTUVcIiwgZGlzcGxheU5hbWV9XG59XG5leHBvcnQgZnVuY3Rpb24gcmVkdWNlcihzdGF0ZTogP1N0YXRlID0gbnVsbCwgYWN0aW9uOiBSZW5hbWVBY3Rpb24pOiBTdGF0ZSB7XG4gIHN3aXRjaCAoYWN0aW9uLnR5cGUpIHtcbiAgICBjYXNlIFwiUkVOQU1FXCI6XG4gICAgICByZXR1cm4gYWN0aW9uLmRpc3BsYXlOYW1lXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBzdGF0ZSB8fCBudWxsXG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = undefined;

var _select = __webpack_require__(803);

Object.keys(_select).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _select[key];
    }
  });
});

var _types = __webpack_require__(229);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _root = __webpack_require__(805);

var root = _interopRequireWildcard(_root);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.root = root;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3NvbGRpZXItdHlwZXMvaW5kZXguanMiXSwibmFtZXMiOlsicm9vdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOzs7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUhBOztJQUFZQSxJOzs7O1FBQ0pBLEksR0FBQUEsSSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyByb290IGZyb20gXCIuL3Jvb3RcIlxuZXhwb3J0IHtyb290fVxuZXhwb3J0ICogZnJvbSBcIi4vc2VsZWN0XCJcbmV4cG9ydCAqIGZyb20gXCIuL3R5cGVzXCJcbiJdfQ==

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJ0eXBlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decimal = undefined;

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Decimal = _decimal2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvYnV5LW4vdHlwZXMuanMiXSwibmFtZXMiOlsiRGVjaW1hbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOzs7Ozs7UUFDUUEsTyIsImZpbGUiOiJ0eXBlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgRGVjaW1hbCBmcm9tIFwiLi4vLi4vLi4vZGVjaW1hbFwiXG5leHBvcnQge0RlY2ltYWx9XG5cbmV4cG9ydCB0eXBlIFBhcnNlZFR5cGUgPSBcImVtcHR5XCIgfCBcImVycm9yXCIgfCBcInZhbFwiIHwgXCIlXCIgfCBcIj1cIiB8IFwiQFwiXG5leHBvcnQgdHlwZSBQYXJzZWQgPSB7XG4gIHRleHQ6ID9zdHJpbmcsXG4gIHR5cGU6IFBhcnNlZFR5cGUsXG4gIHZhbDogRGVjaW1hbCxcbn1cblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7W3VuaXROYW1lOiBzdHJpbmddOiB7aW5wdXQ6IHN0cmluZ319XG5leHBvcnQgdHlwZSBBY3Rpb24gPSB7XG4gIHR5cGU6IFwiZm9ybS9idXlOXCIsXG4gIHVuaXROYW1lOiBzdHJpbmcsXG4gIGlucHV0OiBzdHJpbmcsXG59XG4iXX0=

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(845);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(384);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _pick = __webpack_require__(385);

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)((0, _pick2.default)(nextProps, propKeys), (0, _pick2.default)(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = onlyUpdateForKeys;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(923);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var hasSubheader = false;

      var firstChild = _react.Children.toArray(children)[0];
      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
        hasSubheader = true;
      }

      var styles = {
        root: {
          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
        }
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return List;
}(_react.Component);

List.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
List.propTypes =  false ? {
  /**
   * These are usually `ListItem`s that are passed to
   * be part of the list.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = List;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Divider = __webpack_require__(929);

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Divider2.default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(232);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  (0, _inherits3.default)(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.element,
  onClickAway: _propTypes2.default.func
} : {};
exports.default = ClickAwayListener;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__(952);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableRowColumn = context.muiTheme.tableRowColumn;


  var styles = {
    root: {
      paddingLeft: tableRowColumn.spacing,
      paddingRight: tableRowColumn.spacing,
      height: tableRowColumn.height,
      textAlign: 'left',
      fontSize: 13,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  };

  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
    styles.textAlign = 'right';
  }

  return styles;
}

var TableRowColumn = function (_Component) {
  (0, _inherits3.default)(TableRowColumn, _Component);

  function TableRowColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableRowColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.columnNumber);
      }
    }, _this.onMouseEnter = function (event) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: true });
        if (_this.props.onHover) {
          _this.props.onHover(event, _this.props.columnNumber);
        }
      }
    }, _this.onMouseLeave = function (event) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: false });
        if (_this.props.onHoverExit) {
          _this.props.onHoverExit(event, _this.props.columnNumber);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableRowColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          columnNumber = _props.columnNumber,
          hoverable = _props.hoverable,
          onClick = _props.onClick,
          onHover = _props.onHover,
          onHoverExit = _props.onHoverExit,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var handlers = {
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      };

      return _react2.default.createElement(
        'td',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, handlers, other),
        children
      );
    }
  }]);
  return TableRowColumn;
}(_react.Component);

TableRowColumn.defaultProps = {
  hoverable: false
};
TableRowColumn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableRowColumn.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Number to identify the header row. This property
   * is automatically populated when used with TableHeader.
   */
  columnNumber: _propTypes2.default.number,
  /**
   * @ignore
   * If true, this column responds to hover events.
   */
  hoverable: _propTypes2.default.bool,
  /** @ignore */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onHover: _propTypes2.default.func,
  /**
   * @ignore
   * Callback function for hover exit event.
   */
  onHoverExit: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableRowColumn;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = __webpack_require__(419);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccountCircle = function ActionAccountCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
  );
};
ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
ActionAccountCircle.displayName = 'ActionAccountCircle';
ActionAccountCircle.muiName = 'SvgIcon';

exports.default = ActionAccountCircle;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(428);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppProvider */
/* harmony export (immutable) */ __webpack_exports__["a"] = app;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Theme__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Router__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_en__ = __webpack_require__(1048);
// mount this separately, so it doesn't mess with the mounting of visual elements
var RootEffects=__WEBPACK_IMPORTED_MODULE_6__swarm2_core__["containers"].app.AppRoot(function(props){return null;});// because <HashRouter> insists on exactly one child, but I'd rather not add a <div> to the dom
var WrapRoot=function WrapRoot(props){return props.children;};function AppProvider(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},store=_ref.store,_ref$messages=_ref.messages,messages=_ref$messages===undefined?__WEBPACK_IMPORTED_MODULE_10__lang_en__["a" /* default */]:_ref$messages;if(!store){// TODO: should probably require this. Need to define store outside to support hot-reloading.
// Existing uses all assume it's created here though.
Object(__WEBPACK_IMPORTED_MODULE_5__swarm2_assert__["assert"])("production"!=="production","production app must define a store outside of appprovider");store=Object(__WEBPACK_IMPORTED_MODULE_7__redux__["a" /* createReduxStore */])();}store=store||Object(__WEBPACK_IMPORTED_MODULE_7__redux__["a" /* createReduxStore */])();return function(Wrapped){return function(props){return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* IntlProvider */],{locale:"en",messages:messages},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default.a,{muiTheme:__WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* theme */]},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](WrapRoot,null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__swarm2_core__["FirebaseConnectRouter"],null),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](RootEffects,null),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Wrapped,props))))));};};}function app(config){return AppProvider(config)(__WEBPACK_IMPORTED_MODULE_9__Router__["a" /* default */]);}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(444)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(451);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(245);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(470);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(252);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(163);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(68);
var toObject = __webpack_require__(98);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(62);
var core = __webpack_require__(33);
var fails = __webpack_require__(79);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(70) && !__webpack_require__(79)(function () {
  return Object.defineProperty(__webpack_require__(256)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
var document = __webpack_require__(61).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(491), __esModule: true };

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(171);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(259);
var hide = __webpack_require__(78);
var has = __webpack_require__(68);
var Iterators = __webpack_require__(80);
var $iterCreate = __webpack_require__(496);
var setToStringTag = __webpack_require__(175);
var getPrototypeOf = __webpack_require__(253);
var ITERATOR = __webpack_require__(40)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(78);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(68);
var toIObject = __webpack_require__(81);
var arrayIndexOf = __webpack_require__(498)(false);
var IE_PROTO = __webpack_require__(166)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(173);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(170);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(260);
var hiddenKeys = __webpack_require__(174).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(124);
var createDesc = __webpack_require__(100);
var toIObject = __webpack_require__(81);
var toPrimitive = __webpack_require__(169);
var has = __webpack_require__(68);
var IE8_DOM_DEFINE = __webpack_require__(255);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__(527);

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__(82);

var _lightBaseTheme = __webpack_require__(528);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(530);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(531);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(556);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(557);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(560);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(561);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(521), __esModule: true };

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(268);
var ITERATOR = __webpack_require__(40)('iterator');
var Iterators = __webpack_require__(80);
module.exports = __webpack_require__(33).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(173);
var TAG = __webpack_require__(40)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(547);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(127);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(186);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(573);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(128);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(186);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enhancer = __webpack_require__(585);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _reducer = __webpack_require__(590);

var _reducer2 = _interopRequireDefault(_reducer);

var _createFirestoreInstance = __webpack_require__(286);

var _createFirestoreInstance2 = _interopRequireDefault(_createFirestoreInstance);

var _constants = __webpack_require__(84);

var _constants2 = _interopRequireDefault(_constants);

var _middleware = __webpack_require__(593);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  firestoreReducer: _reducer2.default,
  reduxFirestore: _enhancer2.default,
  createFirestoreInstance: _createFirestoreInstance2.default,
  reducer: _reducer2.default,
  enhancer: _enhancer2.default,
  constants: _constants2.default,
  actionTypes: _constants.actionTypes,
  middleware: _middleware2.default,
  CALL_FIRESTORE: _middleware.CALL_FIRESTORE
};
module.exports = exports['default'];

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(3);

var _actions = __webpack_require__(586);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createWithFirebaseAndDispatch = function createWithFirebaseAndDispatch(firebase, dispatch) {
  return function (func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return func.apply(firebase, [firebase, dispatch].concat(args));
    };
  };
};

var mapWithFirebaseAndDispatch = function mapWithFirebaseAndDispatch(firebase, dispatch, actions) {
  var withFirebaseAndDispatch = createWithFirebaseAndDispatch(firebase, dispatch);
  return (0, _lodash.mapValues)(actions, withFirebaseAndDispatch);
};

var createFirestoreInstance = function createFirestoreInstance(firebase, configs, dispatch) {
  var defaultInternals = { listeners: {}, config: configs, authUid: null };

  firebase._ = firebase._ ? _extends({}, firebase._, defaultInternals) : defaultInternals;

  var methods = mapWithFirebaseAndDispatch(firebase, dispatch, _actions.firestoreActions);

  if (configs.firestoreNamespace) {
    return _extends(_defineProperty({}, configs.firestoreNamespace, methods), firebase);
  }
  return _extends({}, methods, firebase);
};

exports.default = createFirestoreInstance;
module.exports = exports['default'];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(592),
    fallbackHolder = __webpack_require__(189);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isFunction': util.isFunction,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isFunction = helpers.isFunction,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null) {
        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirebaseInstance = undefined;

var _isObject2 = __webpack_require__(28);

var _isObject3 = _interopRequireDefault(_isObject2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = __webpack_require__(289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createFirebaseInstance = exports.createFirebaseInstance = function createFirebaseInstance(firebase, configs, dispatch) {
  if (configs.enableLogging && firebase.database && typeof firebase.database.enableLogging === 'function') {
    firebase.database.enableLogging(configs.enableLogging);
  }

  var defaultInternals = { watchers: {}, config: configs, authUid: null };
  Object.defineProperty(firebase, '_', {
    value: defaultInternals,
    writable: true,
    enumerable: true,
    configurable: true
  });

  var withMeta = function withMeta(method, path, value, onComplete) {
    if ((0, _isObject3.default)(value)) {
      var prefix = method === 'update' ? 'updated' : 'created';
      var dataWithMeta = _extends({}, value, _defineProperty({}, prefix + 'At', firebase.database.ServerValue.TIMESTAMP));
      if (firebase.auth().currentUser) {
        dataWithMeta[prefix + 'By'] = firebase.auth().currentUser.uid;
      }
      return firebase.database().ref(path)[method](dataWithMeta, onComplete);
    }
    return firebase.database().ref(path)[method](value, onComplete);
  };

  var set = function set(path, value, onComplete) {
    return firebase.database().ref(path).set(value, onComplete);
  };

  var setWithMeta = function setWithMeta(path, value, onComplete) {
    return withMeta('set', path, value, onComplete);
  };

  var push = function push(path, value, onComplete) {
    return firebase.database().ref(path).push(value, onComplete);
  };

  var pushWithMeta = function pushWithMeta(path, value, onComplete) {
    return withMeta('push', path, value, onComplete);
  };

  var update = function update(path, value, onComplete) {
    return firebase.database().ref(path).update(value, onComplete);
  };

  var updateWithMeta = function updateWithMeta(path, value, onComplete) {
    return withMeta('update', path, value, onComplete);
  };

  var remove = function remove(path, onComplete, options) {
    return _actions.queryActions.remove(firebase, dispatch, path, onComplete, options);
  };

  var uniqueSet = function uniqueSet(path, value, onComplete) {
    return firebase.database().ref(path).transaction(function (d) {
      return d === null ? value : undefined;
    }).then(function (_ref) {
      var committed = _ref.committed,
          snapshot = _ref.snapshot;

      if (!committed) {
        var newError = new Error('Path already exists.');
        if (onComplete) onComplete(newError);
        return Promise.reject(newError);
      }
      if (onComplete) onComplete(snapshot);
      return snapshot;
    });
  };

  var uploadFile = function uploadFile(path, file, dbPath, options) {
    return _actions.storageActions.uploadFile(dispatch, firebase, { path: path, file: file, dbPath: dbPath, options: options });
  };

  var uploadFiles = function uploadFiles(path, files, dbPath, options) {
    return _actions.storageActions.uploadFiles(dispatch, firebase, { path: path, files: files, dbPath: dbPath, options: options });
  };

  var deleteFile = function deleteFile(path, dbPath) {
    return _actions.storageActions.deleteFile(dispatch, firebase, { path: path, dbPath: dbPath });
  };

  var watchEvent = function watchEvent(type, path, storeAs) {
    return _actions.queryActions.watchEvent(firebase, dispatch, { type: type, path: path, storeAs: storeAs });
  };

  var unWatchEvent = function unWatchEvent(type, path) {
    var queryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return _actions.queryActions.unWatchEvent(firebase, dispatch, { type: type, path: path, queryId: queryId });
  };

  var login = function login(credentials) {
    return _actions.authActions.login(dispatch, firebase, credentials);
  };

  var logout = function logout() {
    return _actions.authActions.logout(dispatch, firebase);
  };

  var createUser = function createUser(credentials, profile) {
    return _actions.authActions.createUser(dispatch, firebase, credentials, profile);
  };

  var resetPassword = function resetPassword(credentials) {
    return _actions.authActions.resetPassword(dispatch, firebase, credentials);
  };

  var confirmPasswordReset = function confirmPasswordReset(code, password) {
    return _actions.authActions.confirmPasswordReset(dispatch, firebase, code, password);
  };

  var verifyPasswordResetCode = function verifyPasswordResetCode(code) {
    return _actions.authActions.verifyPasswordResetCode(dispatch, firebase, code);
  };

  var updateProfile = function updateProfile(profileUpdate) {
    return _actions.authActions.updateProfile(dispatch, firebase, profileUpdate);
  };

  var updateAuth = function updateAuth(authUpdate, updateInProfile) {
    return _actions.authActions.updateAuth(dispatch, firebase, authUpdate, updateInProfile);
  };

  var updateEmail = function updateEmail(newEmail, updateInProfile) {
    return _actions.authActions.updateEmail(dispatch, firebase, newEmail, updateInProfile);
  };

  var reloadAuth = function reloadAuth() {
    return _actions.authActions.reloadAuth(dispatch, firebase);
  };

  var linkWithCredential = function linkWithCredential(credential) {
    return _actions.authActions.linkWithCredential(dispatch, firebase, credential);
  };

  var helpers = {
    ref: function ref(path) {
      return firebase.database().ref(path);
    },
    set: set,
    setWithMeta: setWithMeta,
    uniqueSet: uniqueSet,
    push: push,
    pushWithMeta: pushWithMeta,
    remove: remove,
    update: update,
    updateWithMeta: updateWithMeta,
    login: login,
    logout: logout,
    updateAuth: updateAuth,
    updateEmail: updateEmail,
    updateProfile: updateProfile,
    uploadFile: uploadFile,
    uploadFiles: uploadFiles,
    deleteFile: deleteFile,
    createUser: createUser,
    resetPassword: resetPassword,
    confirmPasswordReset: confirmPasswordReset,
    verifyPasswordResetCode: verifyPasswordResetCode,
    watchEvent: watchEvent,
    unWatchEvent: unWatchEvent,
    reloadAuth: reloadAuth,
    linkWithCredential: linkWithCredential
  };

  return _extends(firebase, helpers, { helpers: helpers });
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storageActions = exports.queryActions = exports.authActions = undefined;

var _auth = __webpack_require__(594);

var authActions = _interopRequireWildcard(_auth);

var _query = __webpack_require__(330);

var queryActions = _interopRequireWildcard(_query);

var _storage = __webpack_require__(691);

var storageActions = _interopRequireWildcard(_storage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.authActions = authActions;
exports.queryActions = queryActions;
exports.storageActions = storageActions;
exports.default = { authActions: authActions, queryActions: queryActions, storageActions: storageActions };

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(131),
    baseClone = __webpack_require__(190),
    baseUnset = __webpack_require__(310),
    castPath = __webpack_require__(88),
    copyObject = __webpack_require__(72),
    customOmitClone = __webpack_require__(651),
    flatRest = __webpack_require__(203),
    getAllKeysIn = __webpack_require__(303);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 292 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keys = __webpack_require__(86);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(623),
    isArguments = __webpack_require__(140),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(141),
    isIndex = __webpack_require__(87),
    isTypedArray = __webpack_require__(193);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(34);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(197),
    getPrototype = __webpack_require__(198),
    getSymbols = __webpack_require__(196),
    stubArray = __webpack_require__(299);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(302),
    getSymbols = __webpack_require__(196),
    keys = __webpack_require__(86);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(197),
    isArray = __webpack_require__(21);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(302),
    getSymbolsIn = __webpack_require__(300),
    keysIn = __webpack_require__(143);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(34);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(34);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(200);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    getPrototype = __webpack_require__(198),
    isPrototype = __webpack_require__(142);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(88),
    last = __webpack_require__(312),
    parent = __webpack_require__(650),
    toKey = __webpack_require__(73);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(647);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    getPrototype = __webpack_require__(198),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(197),
    isFlattenable = __webpack_require__(653);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(319),
    keys = __webpack_require__(86);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(656);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(666),
    baseEvery = __webpack_require__(667),
    baseIteratee = __webpack_require__(66),
    isArray = __webpack_require__(21),
    isIterateeCall = __webpack_require__(209);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(671),
    arraySome = __webpack_require__(322),
    cacheHas = __webpack_require__(674);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(679),
    hasPath = __webpack_require__(326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(88),
    isArguments = __webpack_require__(140),
    isArray = __webpack_require__(21),
    isIndex = __webpack_require__(87),
    isLength = __webpack_require__(194),
    toKey = __webpack_require__(73);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(682),
    hasPath = __webpack_require__(326);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(210);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.unWatchEvents = exports.watchEvents = exports.unWatchEvent = exports.watchEvent = undefined;

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _constants = __webpack_require__(52);

var _query = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var watchEvent = exports.watchEvent = function watchEvent(firebase, dispatch, options) {
  if (!firebase.database || typeof firebase.database !== 'function') {
    throw new Error('Firebase database is required to create watchers');
  }
  var type = options.type,
      path = options.path,
      populates = options.populates,
      queryParams = options.queryParams,
      queryId = options.queryId,
      isQuery = options.isQuery,
      storeAs = options.storeAs;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  var id = queryId || (0, _query.getQueryIdFromPath)(path);
  var counter = (0, _query.getWatcherCount)(firebase, type, watchPath, id);

  if (counter > 0) {
    if (id) {
      (0, _query.unsetWatcher)(firebase, dispatch, type, path, id);
    } else {
      return;
    }
  }

  (0, _query.setWatcher)(firebase, dispatch, type, watchPath, id);

  if (type === 'first_child') {
    return firebase.database().ref().child(path).orderByKey().limitToFirst(1).once('value').then(function (snapshot) {
      if (snapshot.val() === null) {
        dispatch({
          type: _constants.actionTypes.NO_VALUE,
          path: storeAs || path
        });
      }
      return snapshot;
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.ERROR,
        path: storeAs || path,
        payload: err
      });
    });
  }

  var query = firebase.database().ref().child(path);

  if (isQuery) {
    query = (0, _query.applyParamsToQuery)(queryParams, query);
  }

  dispatch({ type: _constants.actionTypes.START, path: storeAs || path });

  if (type === 'once') {
    return query.once('value').then(function (snapshot) {
      if (snapshot.val() === null) {
        return dispatch({
          type: _constants.actionTypes.NO_VALUE,
          path: storeAs || path
        });
      }

      if (!populates) {
        return dispatch({
          type: _constants.actionTypes.SET,
          path: storeAs || path,
          data: snapshot.val(),
          ordered: (0, _query.orderedFromSnapshot)(snapshot)
        });
      }

      return (0, _query.populateAndDispatch)(firebase, dispatch, {
        path: path,
        storeAs: storeAs,
        snapshot: snapshot,
        data: snapshot.val(),
        populates: populates
      });
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.UNAUTHORIZED_ERROR,
        payload: err
      });
      return Promise.reject(err);
    });
  }

  query.on(type, function (snapshot) {
    var data = type === 'child_removed' ? undefined : snapshot.val();
    var resultPath = storeAs || type === 'value' ? path : path + '/' + snapshot.key;

    if (!populates) {
      var ordered = type === 'child_added' ? [{ key: snapshot.key, value: snapshot.val() }] : (0, _query.orderedFromSnapshot)(snapshot);
      return dispatch({
        type: _constants.actionTypes.SET,
        path: storeAs || resultPath,
        data: data,
        ordered: ordered
      });
    }

    return (0, _query.populateAndDispatch)(firebase, dispatch, {
      path: path,
      storeAs: storeAs,
      snapshot: snapshot,
      data: snapshot.val(),
      populates: populates
    });
  }, function (err) {
    dispatch({ type: _constants.actionTypes.ERROR, payload: err });
  });
};

var unWatchEvent = exports.unWatchEvent = function unWatchEvent(firebase, dispatch, _ref) {
  var type = _ref.type,
      path = _ref.path,
      storeAs = _ref.storeAs,
      queryId = _ref.queryId;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  (0, _query.unsetWatcher)(firebase, dispatch, type, watchPath, queryId);
};

var watchEvents = exports.watchEvents = function watchEvents(firebase, dispatch, events) {
  return events.forEach(function (event) {
    return watchEvent(firebase, dispatch, event);
  });
};

var unWatchEvents = exports.unWatchEvents = function unWatchEvents(firebase, dispatch, events) {
  return events.forEach(function (event) {
    return unWatchEvent(firebase, dispatch, event);
  });
};

var remove = exports.remove = function remove(firebase, dispatch, path, onComplete) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var _options$dispatchActi = options.dispatchAction,
      dispatchAction = _options$dispatchActi === undefined ? true : _options$dispatchActi;
  var dispatchRemoveAction = firebase._.config.dispatchRemoveAction;

  return firebase.database().ref(path).remove().then(function () {
    if (dispatchRemoveAction && dispatchAction) {
      dispatch({ type: _constants.actionTypes.REMOVE, path: path });
    }
    if ((0, _isFunction3.default)(onComplete)) {
      onComplete();
    }
    return path;
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.ERROR, payload: err });
    return Promise.reject(err);
  });
};

exports.default = { watchEvents: watchEvents, unWatchEvents: unWatchEvents, remove: remove };

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populateAndDispatch = exports.orderedFromSnapshot = exports.applyParamsToQuery = exports.unsetWatcher = exports.getWatcherCount = exports.setWatcher = exports.getQueryIdFromPath = exports.getWatchPath = undefined;

var _size2 = __webpack_require__(332);

var _size3 = _interopRequireDefault(_size2);

var _forEach2 = __webpack_require__(205);

var _forEach3 = _interopRequireDefault(_forEach2);

var _isNaN2 = __webpack_require__(689);

var _isNaN3 = _interopRequireDefault(_isNaN2);

var _constants = __webpack_require__(52);

var _populate = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tryParseToNumber = function tryParseToNumber(value) {
  var result = Number(value);
  if ((0, _isNaN3.default)(result)) {
    return value;
  }
  return result;
};

var getWatchPath = exports.getWatchPath = function getWatchPath(event, path) {
  if (!event || event === '' || !path) {
    throw new Error('Event and path are required');
  }
  return event + ':' + (path.substring(0, 1) === '/' ? '' : '/') + path;
};

var getQueryIdFromPath = exports.getQueryIdFromPath = function getQueryIdFromPath(path) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  var origPath = path;
  var pathSplitted = path.split('#');
  path = pathSplitted[0];

  var isQuery = pathSplitted.length > 1;
  var queryParams = isQuery ? pathSplitted[1].split('&') : [];
  var queryId = isQuery ? queryParams.map(function (param) {
    var splittedParam = param.split('=');

    if (splittedParam[0] === 'queryId') {
      return splittedParam[1];
    }
  }).filter(function (q) {
    return q;
  }) : undefined;
  return queryId && queryId.length > 0 ? event ? event + ':/' + queryId : queryId[0] : isQuery ? origPath : undefined;
};

var setWatcher = exports.setWatcher = function setWatcher(firebase, dispatch, event, path) {
  var queryId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);

  if (firebase._.watchers[id]) {
    firebase._.watchers[id]++;
  } else {
    firebase._.watchers[id] = 1;
  }

  dispatch({ type: _constants.actionTypes.SET_LISTENER, path: path, payload: { id: id } });

  return firebase._.watchers[id];
};

var getWatcherCount = exports.getWatcherCount = function getWatcherCount(firebase, event, path) {
  var queryId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);
  return firebase._.watchers[id];
};

var unsetWatcher = exports.unsetWatcher = function unsetWatcher(firebase, dispatch, event, path) {
  var queryId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);
  path = path.split('#')[0];
  var watchers = firebase._.watchers;

  if (watchers[id] <= 1) {
    delete watchers[id];
    if (event !== 'first_child' && event !== 'once') {
      firebase.database().ref().child(path).off(event);
    }
  } else if (watchers[id]) {
    watchers[id]--;
  }

  dispatch({ type: _constants.actionTypes.UNSET_LISTENER, path: path, payload: { id: id } });
};

var applyParamsToQuery = exports.applyParamsToQuery = function applyParamsToQuery(queryParams, query) {
  var doNotParse = false;
  if (queryParams) {
    queryParams.forEach(function (param) {
      param = param.split('=');
      switch (param[0]) {
        case 'orderByValue':
          query = query.orderByValue();
          doNotParse = true;
          break;
        case 'orderByPriority':
          query = query.orderByPriority();
          doNotParse = true;
          break;
        case 'orderByKey':
          query = query.orderByKey();
          doNotParse = true;
          break;
        case 'orderByChild':
          query = query.orderByChild(param[1]);
          break;
        case 'limitToFirst':
          query = query.limitToFirst(parseInt(param[1], 10));
          break;
        case 'limitToLast':
          query = query.limitToLast(parseInt(param[1], 10));
          break;
        case 'notParsed':
          doNotParse = true;
          break;
        case 'equalTo':
          var equalToParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          equalToParam = equalToParam === 'null' ? null : equalToParam;
          equalToParam = equalToParam === 'false' ? false : equalToParam;
          equalToParam = equalToParam === 'true' ? true : equalToParam;
          query = param.length === 3 ? query.equalTo(equalToParam, param[2]) : query.equalTo(equalToParam);
          break;
        case 'startAt':
          var startAtParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          startAtParam = startAtParam === 'null' ? null : startAtParam;
          query = param.length === 3 ? query.startAt(startAtParam, param[2]) : query.startAt(startAtParam);
          break;
        case 'endAt':
          var endAtParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          endAtParam = endAtParam === 'null' ? null : endAtParam;
          query = param.length === 3 ? query.endAt(endAtParam, param[2]) : query.endAt(endAtParam);
          break;
      }
    });
  }

  return query;
};

var orderedFromSnapshot = exports.orderedFromSnapshot = function orderedFromSnapshot(snap) {
  if (snap.hasChildren && !snap.hasChildren()) {
    return null;
  }
  var ordered = [];
  if (snap.forEach) {
    snap.forEach(function (child) {
      ordered.push({ key: child.key, value: child.val() });
    });
  }
  return (0, _size3.default)(ordered) ? ordered : null;
};

var populateAndDispatch = exports.populateAndDispatch = function populateAndDispatch(firebase, dispatch, config) {
  var data = config.data,
      populates = config.populates,
      snapshot = config.snapshot,
      path = config.path,
      storeAs = config.storeAs;

  return (0, _populate.promisesForPopulate)(firebase, snapshot.key, data, populates).then(function (results) {
    (0, _forEach3.default)(results, function (result, path) {
      dispatch({
        type: _constants.actionTypes.MERGE,
        path: path,
        data: result
      });
    });
    dispatch({
      type: _constants.actionTypes.SET,
      path: storeAs || path,
      data: data,
      ordered: orderedFromSnapshot(snapshot)
    });
    return results;
  }).catch(function (err) {
    dispatch({
      type: _constants.actionTypes.ERROR,
      payload: err
    });
    return Promise.reject(err);
  });
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(195),
    getTag = __webpack_require__(199),
    isArrayLike = __webpack_require__(65),
    isString = __webpack_require__(90),
    stringSize = __webpack_require__(686);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(287),
    util = __webpack_require__(705);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(107),
    metaMap = __webpack_require__(335);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(304);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(337),
    composeArgsRight = __webpack_require__(338),
    countHolders = __webpack_require__(709),
    createCtor = __webpack_require__(151),
    createRecurry = __webpack_require__(339),
    getHolder = __webpack_require__(344),
    reorder = __webpack_require__(724),
    replaceHolders = __webpack_require__(215),
    root = __webpack_require__(34);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(710),
    setData = __webpack_require__(342),
    setWrapToString = __webpack_require__(343);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(335),
    noop = __webpack_require__(711);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    baseLodash = __webpack_require__(214);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(334),
    shortOut = __webpack_require__(317);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(716),
    insertWrapDetails = __webpack_require__(717),
    setToString = __webpack_require__(204),
    updateWrapDetails = __webpack_require__(718);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(727);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(347),
    isIterateeCall = __webpack_require__(209);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(107),
    overRest = __webpack_require__(316),
    setToString = __webpack_require__(204);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(132),
    assignMergeValue = __webpack_require__(349),
    baseFor = __webpack_require__(319),
    baseMergeDeep = __webpack_require__(746),
    isObject = __webpack_require__(28),
    keysIn = __webpack_require__(143);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(139),
    eq = __webpack_require__(104);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaded = exports.lockNow = exports.ofResolution = exports.ClientTimestamp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.reducer = reducer;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _flowClassyTypeWrapper = __webpack_require__(188);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// We usually want a server timestamp, so let's use the typechecker to avoid
// ever accidentally using a client timestamp.
var ClientTimestamp = exports.ClientTimestamp = function (_TypeWrapper) {
  _inherits(ClientTimestamp, _TypeWrapper);

  function ClientTimestamp() {
    _classCallCheck(this, ClientTimestamp);

    return _possibleConstructorReturn(this, (ClientTimestamp.__proto__ || Object.getPrototypeOf(ClientTimestamp)).apply(this, arguments));
  }

  _createClass(ClientTimestamp, null, [{
    key: "toServer",
    value: function toServer(now, offset) {
      return Util.Timestamp.add(Util.Timestamp.wrap(ClientTimestamp.unwrap(now)), offset);
    }
  }, {
    key: "map",
    value: function map(fn, now) {
      return ClientTimestamp.wrap(fn(ClientTimestamp.unwrap(now)));
    }
  }]);

  return ClientTimestamp;
}(_flowClassyTypeWrapper.TypeWrapper);

function exactNow(rootState) {
  return ClientTimestamp.wrap(rootState.clientNow);
}
var ofResolution = exports.ofResolution = _lodash2.default.memoize(function (resolution) {
  return (0, _reselect.createSelector)(exactNow, function (n) {
    return ClientTimestamp.map(function (n) {
      return n - n % resolution;
    }, n);
  });
});

var now = function now() {
  return ClientTimestamp.wrap(Date.now());
};
var lockNow = exports.lockNow = function lockNow() {
  var now_ = now();
  return function () {
    return now_;
  };
};

var loaded = exports.loaded = lockNow();

function reducer(state, action) {
  return state == null || action.type === "TICK" ? ClientTimestamp.wrap(Date.now()) : state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extract = exports.of = undefined;
exports.id = id;
exports.map = map;
exports.ap = ap;
exports.chain = chain;
exports.reduce = reduce;
exports.alt = alt;
exports.traverse = traverse;
exports.extend = extend;
exports.chainRec = chainRec;
exports.getSetoid = getSetoid;
exports.getOrd = getOrd;
exports.getSemigroup = getSemigroup;
exports.getMonoid = getMonoid;

var _HKT = __webpack_require__(153);

var _ChainRec = __webpack_require__(753);

var _Fun = __webpack_require__(352);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsIdentity = function IsIdentity() {
  _classCallCheck(this, IsIdentity);
};

function prj(fa) {
  return fa;
}

function inj(a) {
  return a;
}

function id(a) {
  return a;
}

function map(f, fa) {
  return inj(f(prj(fa)));
}

function ap(fab, fa) {
  return map(prj(fab), fa);
}

var of = exports.of = inj;

function chain(f, fa) {
  return f(prj(fa));
}

function reduce(f, b, fa) {
  return f(b, prj(fa));
}

function alt(fx, fy) {
  // eslint-disable-line no-unused-vars
  return fx;
}

function traverse(applicative, f, ta) {
  return applicative.map(of, f(prj(ta)));
}

function extend(f, ea) {
  return of(f(ea));
}

var extract = exports.extract = prj;

function chainRec(f, a) {
  return inj((0, _ChainRec.tailRec)((0, _Fun.compose)(extract, f), a));
}

function getSetoid(setoid) {
  return {
    equals: function equals(fx, fy) {
      return setoid.equals(prj(fx), prj(fy));
    }
  };
}

function getOrd(ord) {
  return {
    equals: getSetoid(ord).equals,
    compare: function compare(fx, fy) {
      return ord.compare(prj(fx), prj(fy));
    }
  };
}

function getSemigroup(semigroup) {
  return {
    concat: function concat(fx, fy) {
      return inj(semigroup.concat(prj(fx), prj(fy)));
    }
  };
}

function getMonoid(monoid) {
  return {
    concat: getSemigroup(monoid).concat,
    empty: function empty() {
      return inj(monoid.empty());
    }
  };
}

if (false) {
  // eslint-disable-line
  ({
    map: map,
    ap: ap,
    of: of,
    chain: chain,
    reduce: reduce,
    alt: alt,
    traverse: traverse,
    extend: extend,
    extract: extract,
    chainRec: chainRec
  });
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flip = flip;
exports.constant = constant;
exports.on = on;
exports.compose = compose;
exports.pipe = pipe;
exports.curry = curry;
// eslint-disable-line no-redeclare

// Flips the order of the arguments to a function of two arguments.
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare

// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare

// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
function flip(f) {
  return function (b, a) {
    return f(a, b);
  };
}

// Returns its first argument and ignores its second.
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare
// eslint-disable-line no-redeclare

function constant(a) {
  return function () {
    return a;
  };
}

// The `on` function is used to change the domain of a binary operator.
function on(o, f) {
  return function (x, y) {
    return o(f(x), f(y));
  };
}

function compose() {
  var _this = this;

  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  // eslint-disable-line no-redeclare
  var len = fns.length - 1;
  return function (x) {
    var y = x;
    for (var _i = len; _i > -1; _i--) {
      y = fns[_i].call(_this, y);
    }
    return y;
  };
}

function pipe() {
  var _this2 = this;

  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  // eslint-disable-line no-redeclare
  var len = fns.length - 1;
  return function (x) {
    var y = x;
    for (var _i2 = 0; _i2 <= len; _i2++) {
      y = fns[_i2].call(_this2, y);
    }
    return y;
  };
}

function curried(f, length, acc) {
  return function () {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chars = exports.user = exports.roles = exports.email = exports.isAnonymous = exports.isNotEmpty = exports.isEmpty = exports.authError = exports.userId = exports.maybeUserId = exports.localState = exports.loadStatus = undefined;

var _types = __webpack_require__(216);

var T = _interopRequireWildcard(_types);

var _assert = __webpack_require__(12);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _reselect = __webpack_require__(2);

var _users = __webpack_require__(217);

var Users = _interopRequireWildcard(_users);

var _charactersByUser = __webpack_require__(354);

var CharsByUser = _interopRequireWildcard(_charactersByUser);

var _authLoaded = __webpack_require__(218);

var AuthLoaded = _interopRequireWildcard(_authLoaded);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var rawState = function rawState(s) {
  return s.firebase.auth;
};
var loadStatus = exports.loadStatus = (0, _reselect.createSelector)(AuthLoaded.isLoaded, AuthLoaded.isEmpty, rawState, function (isLoaded, isEmpty, auth) {
  // Auth's a bit weird, don't use the common utils to interpret it.
  // Empty-auth should never happen (since RRF 2.0) but if it does, assume pending.
  //
  // RRF has an auth.isLoaded field, but it lies, as of v2-beta9: when the
  // user's not logged in, isLoaded never becomes true. #203. So, use my own
  // AuthLoaded instead. Eventually RRF is likely to fix this bug, at which
  // point it'll be safe to remove auth-loaded.js.
  if (!auth || !isLoaded) return "pending";
  // isEmpty doesn't lie, but the timing doesn't quite match my custom isLoaded.
  if (isEmpty) return "empty";
  // Once empty/non-empty is cleared, it's safe to use RRF's auth status. It's
  // one action behind mine, though, so wait for it to finish.
  if (!auth.isLoaded) return "pending";
  // My AuthLoaded should always catch this condition first, but just in case.
  if (auth.isEmpty) return "empty";
  // Finally, auth is valid.
  return "done";
});
var localState = exports.localState = (0, _reselect.createSelector)(loadStatus, rawState, function (status, auth) {
  return status === "done" || status === "empty" ? auth : (0, _assert.throws)("auth not loaded", { auth: auth, status: status });
});
var maybeUserId = exports.maybeUserId = (0, _reselect.createSelector)(localState, function (state) {
  return state.uid ? T.Id.wrap(state.uid) : null;
});
var userId = exports.userId = (0, _reselect.createSelector)(maybeUserId, function (userId) {
  return userId != null ? userId : (0, _assert.throws)("no auth.userId", userId);
});

var authError = exports.authError = (0, _queryStatus.selectPath)(function () {
  return "authError";
});

// no playable account exists
var isEmpty = exports.isEmpty = (0, _reselect.createSelector)(loadStatus, function (status) {
  return status === "empty";
});
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);
// a fully-playable account exists, but no login credentials are attached
var isAnonymous = exports.isAnonymous = (0, _reselect.createSelector)(localState, function (state) {
  return state.isAnonymous;
});
var email = exports.email = (0, _reselect.createSelector)(localState, function (state) {
  return state.email;
});

//export const roles = _.mapValues(paths.roles, role =>createSelector(userId, role.data))
var userIdString = _lodash2.default.flow(userId, T.Id.unwrap);
var createRoleSelector = function createRoleSelector(rolePath) {
  var path = (0, _reselect.createSelector)(userIdString, rolePath.data);
  return _queryStatus.selectPath.isNotEmpty(path);
};
var roles = exports.roles = {
  prereleaseFlags: createRoleSelector(paths.roles.prereleaseFlags),
  betaUsers: createRoleSelector(paths.roles.betaUsers)
};

var createUserSelector = function createUserSelector(selector) {
  return (0, _reselect.createSelector)(function (root) {
    return root;
  }, (0, _reselect.createStructuredSelector)({
    userId: userIdString,
    queryLoaded: function queryLoaded(s, p) {
      return p.queryLoaded;
    },
    error: function error(s, p) {
      return p.error;
    }
  }), selector);
};
var user = exports.user = {
  id: userIdString,
  isEmpty: createUserSelector(Users.isEmpty),
  isNotEmpty: createUserSelector(Users.isNotEmpty),
  displayName: createUserSelector(Users.displayName),
  createdAt: createUserSelector(Users.createdAt)
};
var chars = exports.chars = {
  list: createUserSelector(CharsByUser.list),
  limit: createUserSelector(CharsByUser.limit),
  lastPlayed: createUserSelector(CharsByUser.lastPlayed),
  isCharLimit: createUserSelector(CharsByUser.isCharLimit),
  isEmpty: createUserSelector(CharsByUser.isEmpty)
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastPlayed = exports.isCharLimit = exports.list = exports.isEmpty = exports.localState = exports.limit = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _Maybe = __webpack_require__(152);

var Maybe = _interopRequireWildcard(_Maybe);

var _reselect = __webpack_require__(2);

var _types = __webpack_require__(91);

var UsersT = _interopRequireWildcard(_types);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var limit = exports.limit = function limit() {
  return 5;
};

var userId = function userId(state, props) {
  return props.userId;
};
var userIdString = (0, _reselect.createSelector)(userId, UsersT.Id.unwrap);
var path = (0, _reselect.createSelector)(userIdString, paths.charactersByUser.data);
var localState = exports.localState = (0, _queryStatus.selectPath)(path);
var isEmpty = exports.isEmpty = _queryStatus.selectPath.isEmpty(path);

var list = exports.list = (0, _reselect.createSelector)(localState, function (state) {
  return (0, _lodash2.default)(state).entries().sortBy(function (c) {
    return c.lastActionAt || c.createdAt;
  }).reverse().map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        id = _ref2[0],
        val = _ref2[1];

    return id;
  }).value();
});
var count = (0, _reselect.createSelector)(list, function (list) {
  return list.length;
});
var isCharLimit = exports.isCharLimit = (0, _reselect.createSelector)(count, limit, function (c, l) {
  return c >= l;
});
var lastPlayed = exports.lastPlayed = (0, _reselect.createSelector)(list, function (list) {
  return list.length ? Maybe.of(list[0]) : Maybe.Nothing;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(760);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _meta = __webpack_require__(774);

Object.keys(_meta).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _meta[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0ICogZnJvbSBcIi4vbWV0YVwiXG4iXX0=

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = __webpack_require__(2);

// Each action includes the root state, minus some non-essential stuff, so we
// can use selectors within reducers.
exports.default = (0, _reselect.createStructuredSelector)({
  firebase: (0, _reselect.createStructuredSelector)({
    auth: function auth(root) {
      return root.firebase.auth;
    },
    data: (0, _reselect.createStructuredSelector)({
      options: function options(root) {
        return root.firebase.data.options;
      },
      roles: function roles(root) {
        return root.firebase.data.roles;
      }
    })
  }),
  firebaseAuthLoaded: function firebaseAuthLoaded(root) {
    return root.firebaseAuthLoaded;
  },
  entities2: function entities2(root) {
    return root.entities2;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY2FjaGVhYmxlLXJvb3QuanMiXSwibmFtZXMiOlsiZmlyZWJhc2UiLCJhdXRoIiwicm9vdCIsImRhdGEiLCJvcHRpb25zIiwicm9sZXMiLCJmaXJlYmFzZUF1dGhMb2FkZWQiLCJlbnRpdGllczIiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBOztBQUVBO0FBQ0E7a0JBQ2Usd0NBQXlCO0FBQ3RDQSxZQUFVLHdDQUF5QjtBQUNqQ0MsVUFBTTtBQUFBLGFBQVFDLEtBQUtGLFFBQUwsQ0FBY0MsSUFBdEI7QUFBQSxLQUQyQjtBQUVqQ0UsVUFBTSx3Q0FBeUI7QUFDN0JDLGVBQVM7QUFBQSxlQUFRRixLQUFLRixRQUFMLENBQWNHLElBQWQsQ0FBbUJDLE9BQTNCO0FBQUEsT0FEb0I7QUFFN0JDLGFBQU87QUFBQSxlQUFRSCxLQUFLRixRQUFMLENBQWNHLElBQWQsQ0FBbUJFLEtBQTNCO0FBQUE7QUFGc0IsS0FBekI7QUFGMkIsR0FBekIsQ0FENEI7QUFRdENDLHNCQUFvQjtBQUFBLFdBQVFKLEtBQUtJLGtCQUFiO0FBQUEsR0FSa0I7QUFTdENDLGFBQVc7QUFBQSxXQUFRTCxLQUFLSyxTQUFiO0FBQUE7QUFUMkIsQ0FBekIsQyIsImZpbGUiOiJjYWNoZWFibGUtcm9vdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcblxuLy8gRWFjaCBhY3Rpb24gaW5jbHVkZXMgdGhlIHJvb3Qgc3RhdGUsIG1pbnVzIHNvbWUgbm9uLWVzc2VudGlhbCBzdHVmZiwgc28gd2Vcbi8vIGNhbiB1c2Ugc2VsZWN0b3JzIHdpdGhpbiByZWR1Y2Vycy5cbmV4cG9ydCBkZWZhdWx0IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gIGZpcmViYXNlOiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgIGF1dGg6IHJvb3QgPT4gcm9vdC5maXJlYmFzZS5hdXRoLFxuICAgIGRhdGE6IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gICAgICBvcHRpb25zOiByb290ID0+IHJvb3QuZmlyZWJhc2UuZGF0YS5vcHRpb25zLFxuICAgICAgcm9sZXM6IHJvb3QgPT4gcm9vdC5maXJlYmFzZS5kYXRhLnJvbGVzLFxuICAgIH0pLFxuICB9KSxcbiAgZmlyZWJhc2VBdXRoTG9hZGVkOiByb290ID0+IHJvb3QuZmlyZWJhc2VBdXRoTG9hZGVkLFxuICBlbnRpdGllczI6IHJvb3QgPT4gcm9vdC5lbnRpdGllczIsXG59KVxuIl19

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.lootParams = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.startAction = startAction;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _stats = __webpack_require__(54);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _zoneTypes = __webpack_require__(156);

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

var _actionBase = __webpack_require__(367);

var Actions = _interopRequireWildcard(_actionBase);

var _combat = __webpack_require__(369);

var UnitsCombat = _interopRequireWildcard(_combat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startAction(zone) {
  return { type: "COMBAT_START", zone: zone };
}

function decToNum(decs) {
  return _lodash2.default.mapValues(decs, function (dec) {
    return dec.toNumber();
  });
}
function initSoldiers(counts) {
  // starting lair is hardcoded
  return _lodash2.default.mapValues(_extends({}, counts, { lair: 1 }), function (count) {
    return { count: count, deaths: 0, hp: 0 };
  });
}
var lootParams = exports.lootParams = (0, _reselect.createStructuredSelector)({
  isZoneCleared: Zones.isCleared,
  isGrind: UnitsCombat.isGrind
});
var init = exports.init = (0, _reselect.createStructuredSelector)({
  init: (0, _reselect.createStructuredSelector)({
    player: (0, _reselect.createStructuredSelector)({
      soldiers: (0, _reselect.createSelector)(UnitsCombat.soldiers, _lodash2.default.flow(decToNum, initSoldiers))
    }),
    enemy: (0, _reselect.createStructuredSelector)({
      soldiers: (0, _reselect.createSelector)(ZoneTypes.soldiers, initSoldiers)
    }),
    event: (0, _reselect.createStructuredSelector)({
      type: function type() {
        return "COMBAT_START";
      },
      zone: function zone(s, p) {
        return p.zone;
      },
      createdAt: Now.now
    }),
    params: lootParams
  })
});
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "COMBAT_START":
      {
        // TODO reject if combat is running
        var _fixedNow = action.createdAt,
            _zone = action.zone,
            root = action.root,
            _character = action.character;

        return init(root, { zone: _zone, character: _character, fixedNow: _fixedNow });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlord = __webpack_require__(362);

var _overlord2 = _interopRequireDefault(_overlord);

var _standard = __webpack_require__(781);

var _standard2 = _interopRequireDefault(_standard);

var _void = __webpack_require__(782);

var _void2 = _interopRequireDefault(_void);

var _prerelease = __webpack_require__(783);

var _prerelease2 = _interopRequireDefault(_prerelease);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [].concat(_overlord2.default, _standard2.default, _void2.default, _prerelease2.default);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L2luZGV4LmpzIl0sIm5hbWVzIjpbImNvbmNhdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztrQkFHZ0IsR0FBR0EsTUFBSCw4RSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgT3ZlcmxvcmQgZnJvbSBcIi4vb3ZlcmxvcmRcIlxuaW1wb3J0IFN0YW5kYXJkIGZyb20gXCIuL3N0YW5kYXJkXCJcbmltcG9ydCBWb2lkIGZyb20gXCIuL3ZvaWRcIlxuaW1wb3J0IFByZXJlbGVhc2UgZnJvbSBcIi4vcHJlcmVsZWFzZVwiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgTGVhZ3VlfSBmcm9tIFwiLi4vcmF3XCJcblxuZXhwb3J0IGRlZmF1bHQgKFtdLmNvbmNhdChPdmVybG9yZCwgU3RhbmRhcmQsIFZvaWQsIFByZXJlbGVhc2UpOiBMZWFndWVbXSlcbiJdfQ==

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = exports.closedAt = exports.openAt = exports.visibleAt = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UTC = Util.Timestamp.UTC;
var visibleAt = exports.visibleAt = UTC(2017, "dec", 12);
var openAt = exports.openAt = UTC(2017, "dec", 15);
var closedAt = exports.closedAt = UTC(2017, "jan", 15);
var ruleset = exports.ruleset = {
  unlockZone6: true,
  twinMeatUpgrades: true
};
exports.default = [{
  name: "overlord",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: visibleAt,
    openAt: openAt,
    //closedAt,
    migrateToLeague: "standard"
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L292ZXJsb3JkLmpzIl0sIm5hbWVzIjpbIlV0aWwiLCJVVEMiLCJUaW1lc3RhbXAiLCJ2aXNpYmxlQXQiLCJvcGVuQXQiLCJjbG9zZWRBdCIsInJ1bGVzZXQiLCJ1bmxvY2tab25lNiIsInR3aW5NZWF0VXBncmFkZXMiLCJuYW1lIiwibGlmZWN5Y2xlIiwibWlncmF0ZVRvTGVhZ3VlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7Ozs7QUFHWixJQUFNQyxNQUFNRCxLQUFLRSxTQUFMLENBQWVELEdBQTNCO0FBRU8sSUFBTUUsZ0NBQVlGLElBQUksSUFBSixFQUFVLEtBQVYsRUFBaUIsRUFBakIsQ0FBbEI7QUFDQSxJQUFNRywwQkFBU0gsSUFBSSxJQUFKLEVBQVUsS0FBVixFQUFpQixFQUFqQixDQUFmO0FBQ0EsSUFBTUksOEJBQVdKLElBQUksSUFBSixFQUFVLEtBQVYsRUFBaUIsRUFBakIsQ0FBakI7QUFDQSxJQUFNSyw0QkFBbUI7QUFDOUJDLGVBQWEsSUFEaUI7QUFFOUJDLG9CQUFrQjtBQUZZLENBQXpCO2tCQUlTLENBQ2Q7QUFDRUMsUUFBTSxVQURSO0FBRUVILGtCQUZGO0FBR0VJLGFBQVc7QUFDVFAsd0JBRFM7QUFFVEMsa0JBRlM7QUFHVDtBQUNBTyxxQkFBaUI7QUFKUjtBQUhiLENBRGMsQyIsImZpbGUiOiJvdmVybG9yZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi8uLi8uLi91dGlsXCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBMZWFndWV9IGZyb20gXCIuLi9yYXdcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIFJ1bGVzZXR9IGZyb20gXCIuLi9ydWxlc2V0c1wiXG5jb25zdCBVVEMgPSBVdGlsLlRpbWVzdGFtcC5VVENcblxuZXhwb3J0IGNvbnN0IHZpc2libGVBdCA9IFVUQygyMDE3LCBcImRlY1wiLCAxMilcbmV4cG9ydCBjb25zdCBvcGVuQXQgPSBVVEMoMjAxNywgXCJkZWNcIiwgMTUpXG5leHBvcnQgY29uc3QgY2xvc2VkQXQgPSBVVEMoMjAxNywgXCJqYW5cIiwgMTUpXG5leHBvcnQgY29uc3QgcnVsZXNldDogUnVsZXNldCA9IHtcbiAgdW5sb2NrWm9uZTY6IHRydWUsXG4gIHR3aW5NZWF0VXBncmFkZXM6IHRydWUsXG59XG5leHBvcnQgZGVmYXVsdCAoW1xuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZFwiLFxuICAgIHJ1bGVzZXQsXG4gICAgbGlmZWN5Y2xlOiB7XG4gICAgICB2aXNpYmxlQXQsXG4gICAgICBvcGVuQXQsXG4gICAgICAvL2Nsb3NlZEF0LFxuICAgICAgbWlncmF0ZVRvTGVhZ3VlOiBcInN0YW5kYXJkXCIsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.releaseNewsUrl = exports.sinceRelease = exports.isReleased = undefined;

var _flags = __webpack_require__(786);

Object.keys(_flags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _flags[key];
    }
  });
});

var _criteria = __webpack_require__(364);

var _release = __webpack_require__(366);

exports.isReleased = _criteria.isReleased;
exports.sinceRelease = _criteria.sinceRelease;
exports.releaseNewsUrl = _release.newsUrl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvZmxhZ3MvaW5kZXguanMiXSwibmFtZXMiOlsiaXNSZWxlYXNlZCIsInNpbmNlUmVsZWFzZSIsInJlbGVhc2VOZXdzVXJsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFHQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBRkE7O0FBQ0E7O1FBRVFBLFU7UUFBWUMsWTtRQUFjQyxjIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7aXNSZWxlYXNlZCwgc2luY2VSZWxlYXNlfSBmcm9tIFwiLi9jcml0ZXJpYVwiXG5pbXBvcnQge25ld3NVcmwgYXMgcmVsZWFzZU5ld3NVcmx9IGZyb20gXCIuL3JlbGVhc2VcIlxuZXhwb3J0ICogZnJvbSBcIi4vZmxhZ3NcIlxuZXhwb3J0IHtpc1JlbGVhc2VkLCBzaW5jZVJlbGVhc2UsIHJlbGVhc2VOZXdzVXJsfVxuIl19

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prerelease = exports.isAfterRelease = exports.releaseCountdown = exports.isReleased = exports.sinceRelease = exports.isNowAfterUTC = exports.isNowAfterTS = exports.isNowBeforeUTC = exports.isNowBeforeTS = exports.isPrereleaseFlags = exports.isQuery = exports.queryOr = exports.selectOr = exports.selectAll = exports.selectAny = undefined;

var _assert = __webpack_require__(12);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _options = __webpack_require__(365);

var Options = _interopRequireWildcard(_options);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _Maybe = __webpack_require__(152);

var Maybe = _interopRequireWildcard(_Maybe);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _queryString = __webpack_require__(223);

var _queryString2 = _interopRequireDefault(_queryString);

var _reselect = __webpack_require__(2);

var _release = __webpack_require__(366);

var Release = _interopRequireWildcard(_release);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// criteria combinators
var any = function any() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _lodash2.default.some(args);
};
var selectAny = exports.selectAny = function selectAny() {
  for (var _len2 = arguments.length, sel = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    sel[_key2] = arguments[_key2];
  }

  return _reselect.createSelector.apply(undefined, _toConsumableArray(sel).concat([any]));
};
var all = function all() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return _lodash2.default.every(args);
};
var selectAll = exports.selectAll = function selectAll() {
  for (var _len4 = arguments.length, sel = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    sel[_key4] = arguments[_key4];
  }

  return _reselect.createSelector.apply(undefined, _toConsumableArray(sel).concat([all]));
};
var selectOr = exports.selectOr = function selectOr(maybe, next) {
  return (0, _reselect.createSelector)(next, maybe, Maybe.fromMaybe);
};
var queryOr = exports.queryOr = function queryOr(propname, next) {
  return selectOr(maybeQuery(propname), next);
};

// Don't use env-name! Instead, trusted users should get the prerelease role.
// That way, we can minimize env config differences, and even test new features
// in prod!
//const envName = (state: any, props: {entities: Entities.State}) =>
//  props.entities.envConfig.envName
//const isDevEnv = createSelector(
//  envName,
//  n => n === "swarm2-dev" || n === "swarm2-integration",
//)

// criteria: query string
// Use document.location, not react-router's location, so flag changes persist
// when clicking across pages.
var docLocation = function docLocation() {
  return global.window && window.document && window.document.location;
};
var mockLocation = function mockLocation(state, props) {
  return props && props._mockLocation;
};
var location = function location(state, props) {
  return mockLocation(state, props) || docLocation() || null;
};
var locationSearch = (0, _reselect.createSelector)(location, function (location) {
  return location ? Maybe.of(location.search) : Maybe.Nothing;
});
var queryString = (0, _reselect.createSelector)(locationSearch, function (loc) {
  return Maybe.map(_queryString2.default.parse, loc);
});
function parseQSBool(v) {
  if (v === "0" || v === "no" || v === "" || v === "false" || v === "off") return Maybe.of(false);
  if (v === "1" || v === "yes" || v === "true" || v === "on") return Maybe.of(true);
  return Maybe.Nothing;
}
var maybeQuery = function maybeQuery(propname) {
  return (0, _reselect.createSelector)(queryString, function (qs) {
    return Maybe.chain(function (qs) {
      return parseQSBool(qs[propname]);
    }, qs);
  });
};
// Allow per-request feature toggling by messing with the query string. Example:
// https://www.warswarms.com?leagueSelectUI=true/#/
// This can change client flags, but not server flags! Server will always use
// the default.
var isQuery = exports.isQuery = function isQuery(propname, default_) {
  return (0, _reselect.createSelector)(maybeQuery(propname), function (val) {
    return Maybe.fromMaybe(default_, val);
  });
};

// criteria: prerelease flags role
var isPrereleaseFlags = exports.isPrereleaseFlags = (0, _reselect.createSelector)(Auth.roles.prereleaseFlags, Options.prereleaseFlags,
// querystring-toggle all prerelease flags off
isQuery("prereleaseFlags", true), all);

// criteria: current time
var isNowBeforeTS = exports.isNowBeforeTS = function isNowBeforeTS(before) {
  return (0, _reselect.createSelector)(Now.now, function (now) {
    return Util.Timestamp.isBefore((0, _assert.assertNumber)(now, "now", { now: now }), (0, _assert.assertNumber)(before, "before", { before: before }));
  });
};
var isNowBeforeUTC = exports.isNowBeforeUTC = function isNowBeforeUTC(y, m) {
  for (var _len5 = arguments.length, a = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    a[_key5 - 2] = arguments[_key5];
  }

  var _Util$Timestamp;

  return isNowBeforeTS((_Util$Timestamp = Util.Timestamp).UTC.apply(_Util$Timestamp, [y, m].concat(a)));
};
var isNowAfterTS = exports.isNowAfterTS = function isNowAfterTS(after) {
  return _lodash2.default.negate(isNowBeforeTS(after));
};
var isNowAfterUTC = exports.isNowAfterUTC = function isNowAfterUTC(y, m) {
  for (var _len6 = arguments.length, a = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
    a[_key6 - 2] = arguments[_key6];
  }

  return _lodash2.default.negate(isNowBeforeUTC.apply(undefined, [y, m].concat(a)));
};
var sinceRelease = exports.sinceRelease = (0, _reselect.createSelector)(Now.now, function () {
  return Release.at;
}, Util.Duration.sinceNeg);
var isReleased = exports.isReleased = (0, _reselect.createSelector)(sinceRelease, function (until) {
  return Util.Duration.unwrap(until) > 0;
});
// Show the countdown between two dates. Alternately, force the countdown to
// show/hide by url.
var releaseCountdown = exports.releaseCountdown = queryOr("releaseCountdown", selectAll(function () {
  return !!Release.newsUrl;
}, isNowAfterTS(Release.countdown.startsAt), isNowBeforeTS(Release.countdown.endsAt)));

var isAfterRelease = exports.isAfterRelease = isNowAfterTS(Release.at);
// Features that appear in the next big update. They're automatically visible to
// all users after a certain date/time. Before that release date, they're
// visible to my trusted test user accounts with the prerelease role - even in
// production! I can disable flags per-request with `?prereleaseFlags=off`, but
// they'll still run on the server. TODO: options for quick-disable server-side.
var prerelease = exports.prerelease = function prerelease() {
  var qsFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return selectAny(isAfterRelease, selectAll(isPrereleaseFlags,
  // querystring-toggle a single prerelease flag off
  qsFlag ? isQuery(qsFlag, true) : function () {
    return true;
  }));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(787);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});

var _actions = __webpack_require__(788);

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

var _types = __webpack_require__(789);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2Uvb3B0aW9ucy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5leHBvcnQgKiBmcm9tIFwiLi9yb290XCJcbmV4cG9ydCAqIGZyb20gXCIuL2FjdGlvbnNcIlxuZXhwb3J0ICogZnJvbSBcIi4vdHlwZXNcIlxuIl19

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countdown = exports.at = exports.newsUrl = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// After a release: clear the releaseNewsUrl, bump months up by one.
// release at midnight UTC. 8 EST, 5 PST
var newsUrl = exports.newsUrl = "";
var at = exports.at = Util.Timestamp.UTC(2099, "nov", 1);
var countdown = exports.countdown = {
  startsAt: Util.Timestamp.UTC(2099, "oct", 24),
  endsAt: Util.Timestamp.UTC(2099, "nov", 1)
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvZmxhZ3MvcmVsZWFzZS5qcyJdLCJuYW1lcyI6WyJVdGlsIiwibmV3c1VybCIsImF0IiwiVGltZXN0YW1wIiwiVVRDIiwiY291bnRkb3duIiwic3RhcnRzQXQiLCJlbmRzQXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7SUFBWUEsSTs7OztBQUVaO0FBQ0E7QUFDTyxJQUFNQyw0QkFBVSxFQUFoQjtBQUNBLElBQU1DLGtCQUFLRixLQUFLRyxTQUFMLENBQWVDLEdBQWYsQ0FBbUIsSUFBbkIsRUFBeUIsS0FBekIsRUFBZ0MsQ0FBaEMsQ0FBWDtBQUNBLElBQU1DLGdDQUFZO0FBQ3ZCQyxZQUFVTixLQUFLRyxTQUFMLENBQWVDLEdBQWYsQ0FBbUIsSUFBbkIsRUFBeUIsS0FBekIsRUFBZ0MsRUFBaEMsQ0FEYTtBQUV2QkcsVUFBUVAsS0FBS0csU0FBTCxDQUFlQyxHQUFmLENBQW1CLElBQW5CLEVBQXlCLEtBQXpCLEVBQWdDLENBQWhDO0FBRmUsQ0FBbEIiLCJmaWxlIjoicmVsZWFzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi91dGlsXCJcblxuLy8gQWZ0ZXIgYSByZWxlYXNlOiBjbGVhciB0aGUgcmVsZWFzZU5ld3NVcmwsIGJ1bXAgbW9udGhzIHVwIGJ5IG9uZS5cbi8vIHJlbGVhc2UgYXQgbWlkbmlnaHQgVVRDLiA4IEVTVCwgNSBQU1RcbmV4cG9ydCBjb25zdCBuZXdzVXJsID0gXCJcIlxuZXhwb3J0IGNvbnN0IGF0ID0gVXRpbC5UaW1lc3RhbXAuVVRDKDIwOTksIFwibm92XCIsIDEpXG5leHBvcnQgY29uc3QgY291bnRkb3duID0ge1xuICBzdGFydHNBdDogVXRpbC5UaW1lc3RhbXAuVVRDKDIwOTksIFwib2N0XCIsIDI0KSxcbiAgZW5kc0F0OiBVdGlsLlRpbWVzdGFtcC5VVEMoMjA5OSwgXCJub3ZcIiwgMSksXG59XG4iXX0=

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseAction = exports.numPendingActions = exports.actions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.push = push;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

var _version = __webpack_require__(368);

var Version = _interopRequireWildcard(_version);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionObj = (0, _reselect.createSelector)(Raw.localState, function (char) {
  return char.actions || {};
});
var actions = exports.actions = (0, _reselect.createSelector)(actionObj, function (actionObj) {
  return (0, _lodash2.default)(actionObj).mapValues(function (act, id) {
    return _extends({}, act, { id: id });
  }).values().sortBy(["version", "createdAt"]).value();
});
var numPendingActions = exports.numPendingActions = (0, _reselect.createSelector)(actions, _lodash2.default.size);

var baseAction = exports.baseAction = (0, _reselect.createStructuredSelector)({
  version: Version.get,
  createdAt: Now.now
});

function push(charId,
// $FlowFixMe I don't understand why it's not seeing the BaseActions I'm passing here.
action0) {
  return function (dispatch, getState, _ref) {
    var getFirebase = _ref.getFirebase;

    var path = "/characters/" + charId + "/actions";
    // no RRF push shortcut here - we want the key right away for easier debugging
    var ref = getFirebase().database().ref(path).push();
    var actionId = ref.key;
    var action = action0(getState(), { charId: charId });
    // flowtype should prevent this, but let's be extra sure at runtime
    var unsafeAct = action;
    if (!!unsafeAct.root || !!unsafeAct.character || !!unsafeAct.id) {
      return (0, _assert.throws)("cannot push fancy action, with root/char/id", action);
    }
    return Util.dispatchPromise("characters/pushAction/" + action.type, dispatch, ref.set(action), { charId: charId, actionId: actionId, action: action });
  };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (/^(@@redux\/|__)/.test(action.type)) return state;
  (0, _assert.assert)("id" in action, "actions must have ids", { action: action });
  return _lodash2.default.omit(state, [action.id]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.version || 0;
});
function reducer(state, action) {
  // redux init actions break flowtype rules. Don't want to define my code's
  // typings just for that.
  // Private actions have special behavior too.
  if (/^(@@redux\/|__)/.test(action.type)) return state || null;
  if (action.version == null) return (0, _assert.throws)("action.version required", { action: action });
  state = state || 0;
  if (state !== action.version) return (0, _assert.throws)("action.version must match", { state: state, action: action });
  return state + 1;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGrind = exports.grindTokenCount = exports.soldiers = undefined;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectUtils = __webpack_require__(158);

var _stats = __webpack_require__(54);

var _raw = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw);

var _reify = __webpack_require__(110);

var Reify = _interopRequireWildcard(_reify);

var _visible = __webpack_require__(224);

var Vis = _interopRequireWildcard(_visible);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var soldiers = exports.soldiers = (0, _reselect.createSelector)(Reify.counts, Vis.visibleCombatNames, _lodash2.default.pick);
var grindTokenCount = exports.grindTokenCount = (0, _selectUtils.withFixedProps)({ unitName: "_lootGrindToken" }, Reify.count);
var isNotZero = (0, _reselect.createSelector)(Reify.count, function (c) {
  return !c.isZero();
});
var isGrind = exports.isGrind = (0, _selectUtils.withFixedProps)({ unitName: "_lootGrindToken" }, isNotZero);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvY29tYmF0LmpzIl0sIm5hbWVzIjpbIlJhd0NoYXIiLCJSZWlmeSIsIlZpcyIsInNvbGRpZXJzIiwiY291bnRzIiwidmlzaWJsZUNvbWJhdE5hbWVzIiwicGljayIsImdyaW5kVG9rZW5Db3VudCIsInVuaXROYW1lIiwiY291bnQiLCJpc05vdFplcm8iLCJjIiwiaXNaZXJvIiwiaXNHcmluZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0lBQVlBLE87O0FBQ1o7O0lBQVlDLEs7O0FBQ1o7O0lBQVlDLEc7Ozs7OztBQUVMLElBQU1DLDhCQUdjLDhCQUN6QkYsTUFBTUcsTUFEbUIsRUFFekJGLElBQUlHLGtCQUZxQixFQUd6QixpQkFBRUMsSUFIdUIsQ0FIcEI7QUFTQSxJQUFNQyw0Q0FBa0IsaUNBQzdCLEVBQUNDLFVBQVUsaUJBQVgsRUFENkIsRUFFN0JQLE1BQU1RLEtBRnVCLENBQXhCO0FBSVAsSUFBTUMsWUFBWSw4QkFBZVQsTUFBTVEsS0FBckIsRUFBNEI7QUFBQSxTQUFLLENBQUNFLEVBQUVDLE1BQUYsRUFBTjtBQUFBLENBQTVCLENBQWxCO0FBQ08sSUFBTUMsNEJBQVUsaUNBQWUsRUFBQ0wsVUFBVSxpQkFBWCxFQUFmLEVBQThDRSxTQUE5QyxDQUFoQiIsImZpbGUiOiJjb21iYXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuaW1wb3J0IHt3aXRoRml4ZWRQcm9wc30gZnJvbSBcIi4uLy4uLy4uLy4uL3NlbGVjdC11dGlsc1wiXG5pbXBvcnQge0RlY2ltYWx9IGZyb20gXCIuL3N0YXRzXCJcbmltcG9ydCAqIGFzIFJhd0NoYXIgZnJvbSBcIi4uL3Jhd1wiXG5pbXBvcnQgKiBhcyBSZWlmeSBmcm9tIFwiLi9yZWlmeVwiXG5pbXBvcnQgKiBhcyBWaXMgZnJvbSBcIi4vdmlzaWJsZVwiXG5cbmV4cG9ydCBjb25zdCBzb2xkaWVyczogKFxuICAqLFxuICB7Y2hhcmFjdGVyPzogUmF3Q2hhci5TdGF0ZSwgY2hhcklkPzogc3RyaW5nLCBmaXhlZE5vdzogbnVtYmVyfSxcbikgPT4ge1tzdHJpbmddOiBEZWNpbWFsfSA9IGNyZWF0ZVNlbGVjdG9yKFxuICBSZWlmeS5jb3VudHMsXG4gIFZpcy52aXNpYmxlQ29tYmF0TmFtZXMsXG4gIF8ucGljayxcbilcblxuZXhwb3J0IGNvbnN0IGdyaW5kVG9rZW5Db3VudCA9IHdpdGhGaXhlZFByb3BzKFxuICB7dW5pdE5hbWU6IFwiX2xvb3RHcmluZFRva2VuXCJ9LFxuICBSZWlmeS5jb3VudCxcbilcbmNvbnN0IGlzTm90WmVybyA9IGNyZWF0ZVNlbGVjdG9yKFJlaWZ5LmNvdW50LCBjID0+ICFjLmlzWmVybygpKVxuZXhwb3J0IGNvbnN0IGlzR3JpbmQgPSB3aXRoRml4ZWRQcm9wcyh7dW5pdE5hbWU6IFwiX2xvb3RHcmluZFRva2VuXCJ9LCBpc05vdFplcm8pXG4iXX0=

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = global.Decimal || __webpack_require__(118);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWNpbWFsLmpzIl0sIm5hbWVzIjpbImdsb2JhbCIsIkRlY2ltYWwiLCJyZXF1aXJlIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBZUEsT0FBT0MsT0FBUCxJQUFrQkMsUUFBUSxZQUFSLEMiLCJmaWxlIjoiZGVjaW1hbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGdsb2JhbC5EZWNpbWFsIHx8IHJlcXVpcmUoXCJkZWNpbWFsLmpzXCIpXG4iXX0=
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = solveHorners;

var _decimal = __webpack_require__(370);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factorials = [1];


function fact(n) {
  if (!factorials[n]) {
    factorials[n] = fact(n - 1) * n;
  }
  return factorials[n];
}

function solveHorners(coeffs, t) {
  // Fastest solution, as shown in github:erosson/swarm-production experiments.
  // https://en.wikipedia.org/wiki/Horner's_method
  // http://jsbin.com/doqudoxopo/edit?html,output
  var ret = new _decimal2.default(0);
  for (var i = 0; i < coeffs.length; i++) {
    var degree = coeffs.length - i - 1;
    // ret * t + (coeffs[degree] / fact(degree)
    ret = ret.times(t).plus(coeffs[degree].div(fact(degree)));
  }
  return ret;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = exports.hatchery = exports.hatcheryPerZone = undefined;

var _reselect = __webpack_require__(2);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

var _stats = __webpack_require__(54);

var UnitStats = _interopRequireWildcard(_stats);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Decimal = UnitStats.Decimal;
// Production multipliers.
var hatcheryPerZone = exports.hatcheryPerZone = function hatcheryPerZone(s, p) {
  return 1.4;
};
// expose all multipliers, or one at a time.
var hatchery = exports.hatchery = (0, _reselect.createSelector)(Zones.totalClears, hatcheryPerZone, function (clears, each) {
  return Decimal(each).pow(clears);
});

var all = exports.all = (0, _reselect.createStructuredSelector)({
  hatchery: hatchery
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvcHJvZC1tdWx0aXMuanMiXSwibmFtZXMiOlsiWm9uZXMiLCJVbml0U3RhdHMiLCJEZWNpbWFsIiwiaGF0Y2hlcnlQZXJab25lIiwicyIsInAiLCJoYXRjaGVyeSIsInRvdGFsQ2xlYXJzIiwiY2xlYXJzIiwiZWFjaCIsInBvdyIsImFsbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBOztBQUNBOztJQUFZQSxLOztBQUNaOztJQUFZQyxTOzs7O0FBQ1osSUFBTUMsVUFBVUQsVUFBVUMsT0FBMUI7QUFKQTtBQU1PLElBQU1DLDRDQUFrQixTQUFsQkEsZUFBa0IsQ0FBQ0MsQ0FBRCxFQUFTQyxDQUFUO0FBQUEsU0FBb0IsR0FBcEI7QUFBQSxDQUF4QjtBQUNQO0FBQ08sSUFBTUMsOEJBQVcsOEJBQ3RCTixNQUFNTyxXQURnQixFQUV0QkosZUFGc0IsRUFHdEIsVUFBQ0ssTUFBRCxFQUFTQyxJQUFUO0FBQUEsU0FBa0JQLFFBQVFPLElBQVIsRUFBY0MsR0FBZCxDQUFrQkYsTUFBbEIsQ0FBbEI7QUFBQSxDQUhzQixDQUFqQjs7QUFPQSxJQUFNRyxvQkFBWSx3Q0FBeUI7QUFDaERMO0FBRGdELENBQXpCLENBQWxCIiwiZmlsZSI6InByb2QtbXVsdGlzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8vIFByb2R1Y3Rpb24gbXVsdGlwbGllcnMuXG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yLCBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQgKiBhcyBab25lcyBmcm9tIFwiLi4vem9uZXNcIlxuaW1wb3J0ICogYXMgVW5pdFN0YXRzIGZyb20gXCIuL3N0YXRzXCJcbmNvbnN0IERlY2ltYWwgPSBVbml0U3RhdHMuRGVjaW1hbFxuXG5leHBvcnQgY29uc3QgaGF0Y2hlcnlQZXJab25lID0gKHM6IGFueSwgcDogYW55KSA9PiAxLjRcbi8vIGV4cG9zZSBhbGwgbXVsdGlwbGllcnMsIG9yIG9uZSBhdCBhIHRpbWUuXG5leHBvcnQgY29uc3QgaGF0Y2hlcnkgPSBjcmVhdGVTZWxlY3RvcihcbiAgWm9uZXMudG90YWxDbGVhcnMsXG4gIGhhdGNoZXJ5UGVyWm9uZSxcbiAgKGNsZWFycywgZWFjaCkgPT4gRGVjaW1hbChlYWNoKS5wb3coY2xlYXJzKSxcbilcblxudHlwZSBhbGxUID0gKCosICopID0+IHtbcGFyZW50OiBzdHJpbmddOiBEZWNpbWFsfVxuZXhwb3J0IGNvbnN0IGFsbDogYWxsVCA9IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gIGhhdGNoZXJ5LFxufSlcbiJdfQ==

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dates = __webpack_require__(225);

Object.keys(_dates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dates[key];
    }
  });
});

var _progress = __webpack_require__(374);

Object.keys(_progress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _progress[key];
    }
  });
});

var _status = __webpack_require__(798);

Object.keys(_status).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _status[key];
    }
  });
});
exports.reducer = reducer;

var _assert = __webpack_require__(12);

var Status = _interopRequireWildcard(_status);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var root = action.root,
      character = action.character,
      fixedNow = action.createdAt;

  (0, _assert.assert)(character.achievements === state, "char.achievements doesnt match state", { character: character, state: state });
  return Status.updatedDates(root, { character: character, fixedNow: fixedNow });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYWNoaWV2ZW1lbnRzL2luZGV4LmpzIl0sIm5hbWVzIjpbInJlZHVjZXIiLCJTdGF0dXMiLCJzdGF0ZSIsImFjdGlvbiIsInJvb3QiLCJjaGFyYWN0ZXIiLCJmaXhlZE5vdyIsImNyZWF0ZWRBdCIsImFjaGlldmVtZW50cyIsInVwZGF0ZWREYXRlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFNQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBSEE7O0FBSUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO1FBRWdCQSxPLEdBQUFBLE87O0FBVGhCOztJQUdZQyxNOzs7O0FBTUwsU0FBU0QsT0FBVCxHQUFnRTtBQUFBLE1BQS9DRSxLQUErQyx1RUFBaEMsRUFBZ0M7QUFBQSxNQUE1QkMsTUFBNEI7QUFBQSxNQUM5REMsSUFEOEQsR0FDdEJELE1BRHNCLENBQzlEQyxJQUQ4RDtBQUFBLE1BQ3hEQyxTQUR3RCxHQUN0QkYsTUFEc0IsQ0FDeERFLFNBRHdEO0FBQUEsTUFDbENDLFFBRGtDLEdBQ3RCSCxNQURzQixDQUM3Q0ksU0FENkM7O0FBRXJFLHNCQUNFRixVQUFVRyxZQUFWLEtBQTJCTixLQUQ3QixFQUVFLHNDQUZGLEVBR0UsRUFBQ0csb0JBQUQsRUFBWUgsWUFBWixFQUhGO0FBS0EsU0FBT0QsT0FBT1EsWUFBUCxDQUFvQkwsSUFBcEIsRUFBMEIsRUFBQ0Msb0JBQUQsRUFBWUMsa0JBQVosRUFBMUIsQ0FBUDtBQUNEIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7YXNzZXJ0fSBmcm9tIFwiQHN3YXJtMi9hc3NlcnRcIlxuaW1wb3J0IHR5cGUge0ZhbmN5QWN0aW9ufSBmcm9tIFwiLi4vYWN0aW9uLWJhc2VcIlxuaW1wb3J0IHR5cGUge1N0YXRlfSBmcm9tIFwiLi9kYXRlc1wiXG5pbXBvcnQgKiBhcyBTdGF0dXMgZnJvbSBcIi4vc3RhdHVzXCJcblxuZXhwb3J0ICogZnJvbSBcIi4vZGF0ZXNcIlxuZXhwb3J0ICogZnJvbSBcIi4vcHJvZ3Jlc3NcIlxuZXhwb3J0ICogZnJvbSBcIi4vc3RhdHVzXCJcblxuZXhwb3J0IGZ1bmN0aW9uIHJlZHVjZXIoc3RhdGU6IFN0YXRlID0ge30sIGFjdGlvbjogRmFuY3lBY3Rpb24pOiBTdGF0ZSB7XG4gIGNvbnN0IHtyb290LCBjaGFyYWN0ZXIsIGNyZWF0ZWRBdDogZml4ZWROb3d9ID0gYWN0aW9uXG4gIGFzc2VydChcbiAgICBjaGFyYWN0ZXIuYWNoaWV2ZW1lbnRzID09PSBzdGF0ZSxcbiAgICBcImNoYXIuYWNoaWV2ZW1lbnRzIGRvZXNudCBtYXRjaCBzdGF0ZVwiLFxuICAgIHtjaGFyYWN0ZXIsIHN0YXRlfSxcbiAgKVxuICByZXR1cm4gU3RhdHVzLnVwZGF0ZWREYXRlcyhyb290LCB7Y2hhcmFjdGVyLCBmaXhlZE5vd30pXG59XG4iXX0=

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisible = exports.isVisibleByName = exports.visibilityProgressByName = exports.isComplete = exports.isCompleteByName = exports.percent = exports.progress = exports.completionPercentByName = exports.completionProgressByName = exports.Decimal = undefined;
exports._progress = _progress;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _achievementTypes = __webpack_require__(226);

var AchievementTypes = _interopRequireWildcard(_achievementTypes);

var _schema = __webpack_require__(797);

var Schema = _interopRequireWildcard(_schema);

var _dates = __webpack_require__(225);

var Dates = _interopRequireWildcard(_dates);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Decimal = exports.Decimal = Schema.Decimal;

var ZERO = Decimal(0);
function bound01(val) {
  return Math.min(1, Math.max(0, val));
}
function _progress(type, quota, value, schemaKey) {
  switch (type) {
    case "boolean":
      {
        (0, _assert.assert)(quota, "achievement.schema: boolean quota must be true", quota);
        var val = !!value ? 1 : 0;
        return { quota: 1, value: val, percent: val };
      }
    case "number":
      (0, _assert.assert)(!!quota, "achievement.schema: number quota must not be zero", quota, { schemaKey: schemaKey });
      // $FlowTODO
      return { quota: quota, value: value, percent: bound01(value / quota) };
    case "decimal":
      (0, _assert.assert)(!ZERO.eq(quota), "achievement.schema: decimal quota must not be zero", quota, { schemaKey: schemaKey });
      return {
        quota: Decimal(quota),
        value: Decimal(value),
        percent: bound01(Decimal(value).dividedBy(quota).toNumber())
      };
    default:
      return (0, _assert.throws)("unknown achievement.schema type", type, {
        schemaKey: schemaKey,
        quota: quota,
        value: value
      });
  }
}
var typesList = (0, _reselect.createSelector)(AchievementTypes.localState, function (s) {
  return s.list;
});
var typesByName = (0, _reselect.createSelector)(typesList, function (list) {
  return _lodash2.default.keyBy(list, "name");
});

function achievementProgressSelector(fieldGetter) {
  return (0, _reselect.createSelector)(typesByName, Schema.schema, Dates.byName, function (achieves, schema, dates) {
    return _lodash2.default.mapValues(achieves, function (achieve, achieveName) {
      return _lodash2.default.mapValues(fieldGetter(achieve), function (quota, critKey) {
        return (
          // if this already has a completion date, progress is automatically 100%
          _progress(Schema.types[critKey], quota, dates[achieveName] ? quota : schema[critKey], critKey)
        );
      });
    });
  });
}
var nameProp = function nameProp(s, p) {
  return p.achievementName;
};
var _get = function _get() {
  for (var _len = arguments.length, mess = Array(_len), _key = 0; _key < _len; _key++) {
    mess[_key] = arguments[_key];
  }

  return function (byName, name) {
    return _assert.assertDefined.apply(undefined, [byName[name]].concat(mess, [{ byName: byName, name: name }]));
  };
};
function progressToPercent(progresses) {
  // .concat[1]: if no criteria given, it's complete
  return _lodash2.default.min(_lodash2.default.map(progresses, function (prog) {
    return prog.percent;
  }).concat([1]));
}
function progressToBool(progresses) {
  return progressToPercent(progresses) >= 1;
}

var completionProgressByName = exports.completionProgressByName = achievementProgressSelector(function (s) {
  return s.complete;
});
var completionPercentByName = exports.completionPercentByName = (0, _reselect.createSelector)(completionProgressByName, function (achieves) {
  return _lodash2.default.mapValues(achieves, progressToPercent);
});
var progress = exports.progress = (0, _reselect.createSelector)(completionProgressByName, nameProp, _get("completionProgress"));
var percent = exports.percent = (0, _reselect.createSelector)(completionPercentByName, nameProp, _get("completionPercent"));
var isCompleteByName = exports.isCompleteByName = (0, _reselect.createSelector)(completionProgressByName, function (achieves) {
  return _lodash2.default.mapValues(achieves, progressToBool);
});
var isComplete = exports.isComplete = (0, _reselect.createSelector)(isCompleteByName, nameProp, _get("isComplete"));

var visibilityProgressByName = exports.visibilityProgressByName = achievementProgressSelector(function (s) {
  return s.visible;
});
var isVisibleByName = exports.isVisibleByName = (0, _reselect.createSelector)(visibilityProgressByName, function (achieves) {
  return _lodash2.default.mapValues(achieves, progressToBool);
});
var isVisible = exports.isVisible = (0, _reselect.createSelector)(isVisibleByName, nameProp, _get("isVisible"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDone = exports.doneStatus = exports.Enemy = exports.Player = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// TeamsBase defines lots of general selectors across any team. There's only two
// possible teams, and I don't want to have to pass props.team every time. So,
// here we define selectors where the team is already known. That is:
//
// * Player.x(root, {...}) instead of TeamsBase.x(root, {..., team: 'player'})
// * Enemy.x(root, {...}) instead of TeamsBase.x(root, {..., team: 'enemy'})


var _reselect = __webpack_require__(2);

var _teamsBase = __webpack_require__(376);

var TeamsBase = _interopRequireWildcard(_teamsBase);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var withTeam = function withTeam(team) {
  return function (selector) {
    return function (s, p) {
      return selector(s, _extends({}, p, { team: team }));
    };
  };
};
//const withPlayerTeam = withTeam("player")
//const withEnemyTeam = withTeam("enemy")

var teamSelectors = function teamSelectors(team) {
  var withMyTeam = withTeam(team);
  return {
    reducer: function reducer(state, event) {
      return TeamsBase.reducer(state, _extends({}, event, { team: team }));
    },
    // no _.mapValues tricks. More verbose this way, but we preserve flow types.
    rawCounts: withMyTeam(TeamsBase.rawCounts),
    counts: withMyTeam(TeamsBase.counts),
    visibleNames: withMyTeam(TeamsBase.visibleNames),
    rawCount: withMyTeam(TeamsBase.rawCount),
    count: withMyTeam(TeamsBase.count),
    maxHp: withMyTeam(TeamsBase.maxHp),
    attackPowerEach: withMyTeam(TeamsBase.attackPowerEach),
    hp: withMyTeam(TeamsBase.hp),
    death: withMyTeam(TeamsBase.death),
    isZero: withMyTeam(TeamsBase.isZero),
    isNonzero: withMyTeam(TeamsBase.isNonzero),
    isGameOver: withMyTeam(TeamsBase.isGameOver),
    isNotGameOver: withMyTeam(TeamsBase.isNotGameOver)
  };
};

var Player = exports.Player = teamSelectors("player");
var Enemy = exports.Enemy = teamSelectors("enemy");

var doneStatus = exports.doneStatus = (0, _reselect.createSelector)(Player.isGameOver, Enemy.isGameOver, function (p, e) {
  return e ? p ? "draw" : "win" : p ? "lose" : null;
});
var isDone = exports.isDone = (0, _reselect.createSelector)(doneStatus, function (s) {
  return s != null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleNames = exports.reify = exports.hp = exports.attackPowerEach = exports.maxHp = exports.isNotGameOver = exports.isGameOver = exports.isNonzero = exports.isZero = exports.count = exports.counts = exports.death = exports.rawCount = exports.rawCounts = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reducer = reducer;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _soldierTypes = __webpack_require__(228);

var SoldierTypes = _interopRequireWildcard(_soldierTypes);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

var _combat = __webpack_require__(92);

var Main = _interopRequireWildcard(_combat);

var _growth = __webpack_require__(806);

var Growth = _interopRequireWildcard(_growth);

var _defend = __webpack_require__(807);

var Defend = _interopRequireWildcard(_defend);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var player = (0, _reselect.createSelector)(Raw.get, function (s) {
  return s.player;
});
var enemy = (0, _reselect.createSelector)(Raw.get, function (s) {
  return s.enemy;
});

var teamProp = function teamProp(s, p) {
  return p.team;
};
var state = (0, _reselect.createSelector)(player, enemy, teamProp, function (p, e, team) {
  switch (team) {
    case "player":
      return p;
    case "enemy":
      return e;
    default:
      return (0, _assert.throws)("invalid team", team);
  }
});
function otherTeam(team) {
  return team === "player" ? "enemy" : "player";
}

var soldiers = (0, _reselect.createSelector)(state, function (s) {
  return s.soldiers;
});
var rawCounts = exports.rawCounts = (0, _reselect.createSelector)(soldiers, function (s) {
  return _lodash2.default.mapValues(s, "count");
});
var soldierProp = function soldierProp(s, p) {
  return p.soldierName;
};
var soldier = (0, _reselect.createSelector)(soldiers, soldierProp, function (ss, n) {
  return ss[n];
});
var rawCount = exports.rawCount = (0, _reselect.createSelector)(soldier, function (s) {
  return s && s.count || 0;
});
var death = exports.death = (0, _reselect.createSelector)(soldier, function (s) {
  return s && s.deaths || 0;
});

// Swarm-growth is written for Decimals, but combat uses non-Decimal numbers.
// Combat doesn't have parents-of-parents yet though - drone -> meat, but no
// queen -> drone - so we'll just write our own little growth function here.
var prodsEach = (0, _reselect.createSelector)(SoldierTypes.root.localState, SoldierTypes.Producer.prodsEach);
var producedByEach = (0, _reselect.createSelector)(prodsEach, function (prodsEach) {
  var ret = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(prodsEach)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _parent = _step.value;

      var children = prodsEach[_parent];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(children)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _child = _step2.value;

          var prod = children[_child];
          ret[_child] = ret[_child] || {};
          ret[_child][_parent] = prod;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
});
//const velocities = createSelector(rawCounts, producedByEach, Growth.velocities)
var counts = exports.counts = (0, _reselect.createSelector)(rawCounts, producedByEach, Main.sinceUpdated, Growth.counts);
var count = exports.count = (0, _reselect.createSelector)(counts, soldierProp, function (cs, n) {
  return cs[n];
});
var _selectCount = _lodash2.default.memoize(function (name) {
  return (0, _reselect.createSelector)(counts, function (cs) {
    return cs[name];
  });
});
var selectCount = function selectCount(name, default_) {
  var selector = _selectCount(name);
  return default_ === undefined ? selector : _lodash2.default.flow(selector, function (c) {
    return c !== undefined ? c : default_;
  });
};
var isZero = exports.isZero = (0, _reselect.createSelector)(count, function (c) {
  return c === 0;
});
var isNonzero = exports.isNonzero = _lodash2.default.negate(isZero);
// When a player's lair dies, they lose.
var isGameOver = exports.isGameOver = function isGameOver(s, p) {
  return isZero(s, _extends({}, p, { soldierName: "lair" }));
};
var isNotGameOver = exports.isNotGameOver = _lodash2.default.negate(isGameOver);

// attack and defense power.
var attackPowersEach = (0, _reselect.createSelector)(SoldierTypes.root.localState, selectCount("overlord", 0), function (types, overlords) {
  return (0, _lodash2.default)(types).keyBy("name").mapValues(_lodash2.default.flow(function (t) {
    return t.attack;
  }, function (a) {
    return a * (1 + overlords * 0.2);
  })).pickBy().value();
});
var maxHpEach = (0, _reselect.createSelector)(SoldierTypes.root.localState, selectCount("overlord", 0), function (types, overlords) {
  return (0, _lodash2.default)(types).keyBy("name").mapValues(_lodash2.default.flow(function (t) {
    return t.maxHp;
  }, function (hp) {
    return hp * (1 + overlords * 0.15);
  })).pickBy().value();
});
var maxHp = exports.maxHp = (0, _reselect.createSelector)(maxHpEach, soldierProp, function (hps, n) {
  return hps[n];
});
var attackPowerEach = exports.attackPowerEach = (0, _reselect.createSelector)(attackPowersEach, soldierProp, function (aps, n) {
  return aps[n];
});
var hp = exports.hp = (0, _reselect.createSelector)(soldier, maxHp, function (s, maxHp) {
  return s && s.hp || maxHp;
});

var reify = exports.reify = (0, _reselect.createSelector)(counts, soldiers, function (cs, ss) {
  return _extends({}, ss, _lodash2.default.mapValues(cs, function (count, name) {
    return _extends({}, ss[name] || { deaths: 0, hp: 0 }, {
      count: count
    });
  }));
});
var visibleNames = exports.visibleNames = (0, _reselect.createSelector)(counts, Defend.defenderNames, function (counts, defenders) {
  return _lodash2.default.filter(defenders, function (d) {
    return d in counts;
  });
});
var withOtherTeam = function withOtherTeam(selector) {
  return function (s, p) {
    return selector(s, _extends({}, p, { team: otherTeam(p.team) }));
  };
};
var reifyTeam = (0, _reselect.createSelector)(reify, function (soldiers) {
  return { soldiers: soldiers };
});
var attackerNames = (0, _reselect.createSelector)(SoldierTypes.root.localState, function (types) {
  return _lodash2.default.map(_lodash2.default.filter(types, "attack"), "name");
});
var attackPowersByName = (0, _reselect.createSelector)(counts, attackPowersEach, function (cs, as) {
  return _lodash2.default.pickBy(_lodash2.default.mapValues(as, function (a, name) {
    return a * (cs[name] || 0);
  }));
});
var totalHpByName = (0, _reselect.createSelector)(reify, maxHpEach, Defend.soldiersToTotalHps);
// Each action includes the root state, minus some non-essential stuff, so we
// can use selectors within reducers.
var attackEventProps = (0, _reselect.createStructuredSelector)({
  combat: Raw.getFullState,
  team: teamProp,
  root: (0, _reselect.createStructuredSelector)({
    entities2: function entities2(root) {
      return root.entities2;
    }
  })
});
// withOtherTeam - inside reducers, the current team is the defender
var attackEvents = withOtherTeam((0, _reselect.createSelector)(attackerNames, attackPowersByName, attackEventProps, function (names, powers, eprops) {
  return _lodash2.default.filter(_lodash2.default.map(names, function (soldierName) {
    return _extends({}, eprops, {
      soldierName: soldierName,
      power: powers[soldierName]
    });
  }), "power");
}));
var defendRound = (0, _reselect.createSelector)(reify, totalHpByName, maxHpEach, attackEvents,
// Convert each defending soldier to a life total for all soldiers of that type, hps0;
function (soldiers0, hps0, maxHps, attacks) {
  // attack the total life, killing defenders along the way;
  var hps = _lodash2.default.reduce(attacks, Defend.reducer, hps0);
  // finally, convert each life total back to the soldier's stored stats.
  var soldiers = Defend.totalHpsToSoldiers(soldiers0, hps, maxHps);
  //console.log("defendRound", soldiers0, soldiers)
  return { soldiers: soldiers };
});

function reducer(state, event0) {
  var event = event0; // I don't get it, flow, but whatever works.
  if (_lodash2.default.startsWith(event.type, "@@redux/")) return state || null;
  var team = event0.team,
      root = event0.root,
      combat = event0.combat,
      fixedNow = event0.createdAt;

  var props = { team: team, combat: combat, fixedNow: fixedNow };
  switch (event.type) {
    case "ROUND":
      return defendRound(root, props);
    default:
      // always reify, because updatedAt will always change
      return reifyTeam(root, props);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doneAt = exports.isRunning = exports.isDone = exports.doneStatus = exports.isTimeLimit = undefined;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _combat = __webpack_require__(92);

var Main = _interopRequireWildcard(_combat);

var _teams = __webpack_require__(375);

var Teams = _interopRequireWildcard(_teams);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTimeLimit = exports.isTimeLimit = (0, _reselect.createSelector)(Raw.get, function (s) {
  return s.event.type === "TIMELIMIT";
});
var doneStatus = exports.doneStatus = (0, _reselect.createSelector)(Teams.doneStatus, isTimeLimit, function (status, timelimit) {
  return status || (timelimit ? "draw" : null);
});
var isDone = exports.isDone = (0, _reselect.createSelector)(doneStatus, function (s) {
  return s != null;
});
var isRunning = exports.isRunning = _lodash2.default.negate(isDone);
var doneAt = exports.doneAt = (0, _reselect.createSelector)(isDone, Main.updatedAt, function (isDone, updatedAt) {
  return isDone ? updatedAt : null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY29tYmF0L2RvbmUuanMiXSwibmFtZXMiOlsiVXRpbCIsIk1haW4iLCJUZWFtcyIsIlJhdyIsImlzVGltZUxpbWl0IiwiZ2V0IiwicyIsImV2ZW50IiwidHlwZSIsImRvbmVTdGF0dXMiLCJzdGF0dXMiLCJ0aW1lbGltaXQiLCJpc0RvbmUiLCJpc1J1bm5pbmciLCJuZWdhdGUiLCJkb25lQXQiLCJ1cGRhdGVkQXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFDQTs7OztBQUNBOztJQUFZQSxJOztBQUNaOztJQUFZQyxJOztBQUNaOztJQUFZQyxLOztBQUNaOztJQUFZQyxHOzs7Ozs7QUFFTCxJQUFNQyxvQ0FBbUQsOEJBQzlERCxJQUFJRSxHQUQwRCxFQUU5RDtBQUFBLFNBQUtDLEVBQUVDLEtBQUYsQ0FBUUMsSUFBUixLQUFpQixXQUF0QjtBQUFBLENBRjhELENBQXpEO0FBS0EsSUFBTUMsa0NBR1EsOEJBQ25CUCxNQUFNTyxVQURhLEVBRW5CTCxXQUZtQixFQUduQixVQUFDTSxNQUFELEVBQVNDLFNBQVQ7QUFBQSxTQUF1QkQsV0FBV0MsWUFBWSxNQUFaLEdBQXFCLElBQWhDLENBQXZCO0FBQUEsQ0FIbUIsQ0FIZDtBQVFBLElBQU1DLDBCQUE4Qyw4QkFDekRILFVBRHlELEVBRXpEO0FBQUEsU0FBS0gsS0FBSyxJQUFWO0FBQUEsQ0FGeUQsQ0FBcEQ7QUFJQSxJQUFNTyxnQ0FBWSxpQkFBRUMsTUFBRixDQUFTRixNQUFULENBQWxCO0FBQ0EsSUFBTUcsMEJBR2dCLDhCQUMzQkgsTUFEMkIsRUFFM0JYLEtBQUtlLFNBRnNCLEVBRzNCLFVBQUNKLE1BQUQsRUFBU0ksU0FBVDtBQUFBLFNBQXdCSixTQUFTSSxTQUFULEdBQXFCLElBQTdDO0FBQUEsQ0FIMkIsQ0FIdEIiLCJmaWxlIjoiZG9uZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi8uLi91dGlsXCJcbmltcG9ydCAqIGFzIE1haW4gZnJvbSBcIi4vY29tYmF0XCJcbmltcG9ydCAqIGFzIFRlYW1zIGZyb20gXCIuL3RlYW1zXCJcbmltcG9ydCAqIGFzIFJhdyBmcm9tIFwiLi9yYXdcIlxuXG5leHBvcnQgY29uc3QgaXNUaW1lTGltaXQ6IChVdGlsLlJvb3RTdGF0ZSwgT2JqZWN0KSA9PiBib29sZWFuID0gY3JlYXRlU2VsZWN0b3IoXG4gIFJhdy5nZXQsXG4gIHMgPT4gcy5ldmVudC50eXBlID09PSBcIlRJTUVMSU1JVFwiLFxuKVxuZXhwb3J0IHR5cGUgU3RhdHVzID0gVGVhbXMuRG9uZVN0YXR1c1xuZXhwb3J0IGNvbnN0IGRvbmVTdGF0dXM6IChcbiAgVXRpbC5Sb290U3RhdGUsXG4gIE9iamVjdCxcbikgPT4gbnVsbCB8IFN0YXR1cyA9IGNyZWF0ZVNlbGVjdG9yKFxuICBUZWFtcy5kb25lU3RhdHVzLFxuICBpc1RpbWVMaW1pdCxcbiAgKHN0YXR1cywgdGltZWxpbWl0KSA9PiBzdGF0dXMgfHwgKHRpbWVsaW1pdCA/IFwiZHJhd1wiIDogbnVsbCksXG4pXG5leHBvcnQgY29uc3QgaXNEb25lOiAoVXRpbC5Sb290U3RhdGUsIE9iamVjdCkgPT4gYm9vbGVhbiA9IGNyZWF0ZVNlbGVjdG9yKFxuICBkb25lU3RhdHVzLFxuICBzID0+IHMgIT0gbnVsbCxcbilcbmV4cG9ydCBjb25zdCBpc1J1bm5pbmcgPSBfLm5lZ2F0ZShpc0RvbmUpXG5leHBvcnQgY29uc3QgZG9uZUF0OiAoXG4gIFV0aWwuUm9vdFN0YXRlLFxuICAqLFxuKSA9PiBudWxsIHwgVXRpbC5UaW1lc3RhbXAgPSBjcmVhdGVTZWxlY3RvcihcbiAgaXNEb25lLFxuICBNYWluLnVwZGF0ZWRBdCxcbiAgKGlzRG9uZSwgdXBkYXRlZEF0KSA9PiAoaXNEb25lID8gdXBkYXRlZEF0IDogbnVsbCksXG4pXG4iXX0=

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * swarm-numberformat v0.3.5
 * MIT Licensed
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(118));
	else if(typeof define === 'function' && define.amd)
		define(["decimal.js"], factory);
	else if(typeof exports === 'object')
		exports["numberformat"] = factory(require("decimal.js"));
	else
		root["numberformat"] = factory(root["Decimal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = requireDecimal;
// Lazy-load - we might not need decimal. It's a peerDependency, so the parent
// library must include it if needed - we don't, because many callers don't need
// it.
var Decimal = void 0;
function requireDecimal(config) {
  return config && config.Decimal || Decimal || (Decimal = function () {
    // Allow node callers to inject their own decimal.js, because I am sick to
    // death of trying to wrangle require/webpack/import/etc.
    if (global && global.Decimal) {
      return global.Decimal;
    }
    // `nwb.config.js: extenals` ensures this points to window.Decimal for umd (`<script src="...">`) builds
    return __webpack_require__(7);
  }());
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decimal__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Formats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Formatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatShort; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Can't comment a .json file, but the suffixes come from these pages:
// http://home.kpn.nl/vanadovv/BignumbyN.html




// TODO: use this page to generate names dynamically, for even larger numbers:
//   http://mathforum.org/library/drmath/view/59154.html

function validate(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
  return condition;
}

// polyfill IE and phantomjs
var log10 = function () {
  if (!!Math.log10) {
    return Math.log10;
  }
  return function (val) {
    var ret = Math.log(val) / Math.LN10;
    // bloody stupid rounding errors
    ret = Math.round(ret * 1e6) / 1e6;
    return ret;
  };
}();

var backends = {
  'native': {
    normalize: function normalize(val) {
      return val;
    },

    // Suffixes are a list - which index of the list do we want?
    // _index(999) === 0
    // _index(1000) === 1
    // _index(1000000) === 2
    index: function index(val) {
      // string length is faster but fails for length >= 20, where JS starts
      // formatting with e
      return Math.max(0, Math.floor(log10(Math.abs(val)) / 3));
    },
    prefix: function prefix(val, index, _ref) {
      var sigfigs = _ref.sigfigs;

      // `sigfigs||undefined` supports sigfigs=[null|0], #15
      return (val / Math.pow(1000, index)).toPrecision(sigfigs || undefined);
    }
  },
  'decimal.js': {
    // api docs: https://mikemcl.github.io/decimal.js/
    _requireDecimal: function _requireDecimal(config) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decimal__["a" /* requireDecimal */])(config)) throw new Error('requireDecimal() failed');
      return new __WEBPACK_IMPORTED_MODULE_2__decimal__["a" /* requireDecimal */](config)(0).constructor.clone(config);
    },
    normalize: function normalize(val, _ref2) {
      var rounding = _ref2.rounding;

      var Decimal = this._requireDecimal({ rounding: rounding });
      return new Decimal(val);
    },
    index: function index(val) {
      var Decimal = this._requireDecimal();
      // index = val.log10().dividedToIntegerBy(Decimal.log 1000)
      // Decimal.log() is too slow for large numbers. Docs say performance degrades exponentially as # digits increases, boo.
      // Lucky me, the length is used by decimal.js internally: num.e
      // this is in the docs, so I think it's stable enough to use...
      val = new Decimal(val);
      return Math.floor(val.e / 3);
    },
    prefix: function prefix(val, index, _ref3) {
      var sigfigs = _ref3.sigfigs,
          rounding = _ref3.rounding;

      var Decimal = this._requireDecimal({ rounding: rounding });
      var div = new Decimal(1000).pow(index);
      // `sigfigs||undefined` supports sigfigs=[null|0], #15
      return new Decimal(val).dividedBy(div).toPrecision(sigfigs || undefined);
    }
  }
};

// The formatting function.
function _format(val, opts) {
  var backend = validate(backends[opts.backend], 'not a backend: ' + opts.backend);
  val = backend.normalize(val, opts);
  var index = backend.index(val);
  var suffix = opts.suffixFn(index);
  // `{sigfigs: undefined|null|0}` for automatic sigfigs is supported.
  var sigfigs = opts.sigfigs || undefined;
  // optionally format small numbers differently: show decimals without trailing zeros
  if (Math.abs(val) < opts.maxSmall) {
    // second param for decimal.js only, native ignores it
    return val.toPrecision(sigfigs, opts.rounding).replace(/(\.\d*[1-9])0+$/, '$1');
  }
  // opts.minSuffix: Use JS native formatting for smallish numbers, because
  // '99,999' is prettier than '99.9k'
  // it's safe to let Math coerce Decimal.js to infinity here, gt/lt still work
  if (Math.abs(val) < opts.minSuffix) {
    val = Math.floor(val);
    return val.toLocaleString();
  }
  // No suffix found: use scientific notation. JS's native toExponential is fine.
  if (!suffix && suffix !== '') {
    if (!!sigfigs) {
      sigfigs -= 1;
    }
    return val.toExponential(sigfigs).replace('e+', 'e');
  }
  // Found a suffix. Calculate the prefix, the number before the suffix.
  var prefix = backend.prefix(val, index, opts);
  return '' + prefix + suffix;
}

var defaultOptions = {
  backend: 'native',
  flavor: 'full',
  suffixGroup: 'full',
  suffixFn: function suffixFn(index) {
    var suffixes = this.suffixes || this.suffixGroups[this.suffixGroup];
    validate(suffixes, 'no such suffixgroup: ' + this.suffixGroup);
    if (index < suffixes.length) {
      return suffixes[index] || '';
    }
    // return undefined
  },

  // minimum value to use any suffix, because '99,900' is prettier than '99.9k'
  minSuffix: 1e5,
  // don't use sigfigs for smallish numbers. #13
  minSuffixSigfigs: false,
  // Special formatting for numbers with a decimal point
  maxSmall: 0,
  sigfigs: 3, // often overridden by flavor
  format: 'standard'
};
// User-visible format choices, like on swarmsim's options screen.
// Each has a different set of options.
var Formats = {
  standard: { suffixGroups: __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default.a },
  // like standard formatting, with a different set of suffixes
  longScale: { suffixGroups: __WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json___default.a },
  // like standard formatting, with no suffixes at all
  scientific: { suffixGroups: { full: [], short: [] } },
  // like standard formatting, with a smaller set of suffixes
  hybrid: {
    suffixGroups: {
      full: __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default.a.full.slice(0, 12),
      short: __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default.a.short.slice(0, 12)
    }
  },
  // like standard formatting, with a different/infinite set of suffixes
  engineering: { suffixFn: function suffixFn(index) {
      return index === 0 ? '' : 'E' + index * 3;
    } }
};
// A convenient way for the developer to modify formatters.
// These are different from formats - not user-visible.
var Flavors = {
  full: { suffixGroup: 'full', sigfigs: 5 },
  short: { suffixGroup: 'short', sigfigs: 3 }
};
// Allow callers to extend formats and flavors.
defaultOptions.formats = Formats;
defaultOptions.flavors = Flavors;

var Formatter = function () {
  /**
   * @param {Object} opts All formatter configuration.
   * @param {string} [opts.flavor='full'] 'full' or 'short'. Flavors can modify any number of other options here. Full is the default; short has fewer sigfigs and shorter standard-suffixes.
   * @param {Object} [opts.flavors] Specify your own custom flavors.
   * @param {string} [opts.backend='native'] 'native' or 'decimal.js'.
   * @param {string} [opts.suffixGroup]
   * @param {Function} [opts.suffixFn]
   * @param {number} [opts.minSuffix=1e5]
   * @param {number} [opts.maxSmall=0] Special formatting for numbers with a decimal point
   * @param {number} [opts.sigfigs=5]
   * @param {number} [opts.format='standard'] 'standard', 'hybrid', 'scientific', 'longScale'.
   * @param {Object} [opts.formats] Specify your own custom formats.
   */
  function Formatter() {
    var _this = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Formatter);

    /** @type Object */
    this.opts = opts;
    // create convenience methods for each flavor
    var flavors = Object.keys(this._normalizeOpts().flavors);
    // the fn(i) is for stupid binding tricks with the looped fn(val, opts)
    for (var i = 0; i < flavors.length; i++) {
      (function (i) {
        var flavor = flavors[i];
        // capitalize the first letter to camel-case method name, like formatShort
        var key = 'format' + flavor.charAt(0).toUpperCase() + flavor.substr(1);
        /** @ignore */
        _this[key] = function (val, opts) {
          return _this.formatFlavor(val, flavor, opts);
        };
      })(i);
    }
  }

  Formatter.prototype._normalizeOpts = function _normalizeOpts() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // all the user-specified opts, no defaults
    opts = Object.assign({}, this.opts, opts);
    // opts.format redefines some other opts, but should never override the user's opts
    var format = opts && opts.format;
    var formats = opts && opts.formats || defaultOptions.formats;
    var formatOptions = formats[format || defaultOptions.format];
    validate(formatOptions, 'no such format: ' + format);
    var flavor = opts && opts.flavor;
    var flavors = opts && opts.flavors || defaultOptions.flavors;
    var flavorOptions = flavors[flavor || defaultOptions.flavor];
    validate(flavorOptions, 'no such flavor: ' + flavor);
    // finally, add the implied options: defaults and format-derived
    return Object.assign({}, defaultOptions, formatOptions, flavorOptions, opts);
  };
  /**
   * @param {number} val
   * @param {Object} [opts]
   * @return {number} which suffix to use for this number in a list of suffixes. You can also think of this as "how many commas are in the number?"
   */


  Formatter.prototype.index = function index(val, opts) {
    opts = this._normalizeOpts(opts);
    return backends[opts.backend].index(val);
  };
  /**
   * @param {number} val
   * @param {Object} [opts]
   * @return {string} The suffix that this number would use, with no number shown.
   * @example
   * new Formatter().suffix(1e6)
   * // => " million"
   * @example
   * new Formatter().suffix(1e6, {flavor: "short"})
   * // => "M"
   */


  Formatter.prototype.suffix = function suffix(val, opts) {
    opts = this._normalizeOpts(opts);
    var index = backends[opts.backend].index(val);
    return opts.suffixFn(index);
  };
  /**
   * Format a number.
   * @param {number} val
   * @param {Object} [opts] Override the options provided to the Formatter constructor.
   * @return {string} The formatted number.
   * @example
   * new Formatter().format(1e6)
   * // => "1.0000 million"
   */


  Formatter.prototype.format = function format(val, opts) {
    opts = this._normalizeOpts(opts);
    return _format(val, opts);
  };
  /**
   * Format a number with a specified flavor. It's very common to call the formatter with different flavors, so it has its own shortcut.
   *
   * `Formatter.formatFull()` and `Formatter.formatShort()` are also available.
   * @param {number} val
   * @param {string} flavor 'short' or 'full'. See opts.flavor.
   * @param {Object} [opts]
   * @return {string} The formatted number.
   * @example
   * new Formatter().format(1e6, 'short')
   * // => "1.00M"
   */


  Formatter.prototype.formatFlavor = function formatFlavor(val, flavor, opts) {
    return this.format(val, Object.assign({}, opts, { flavor: flavor }));
  };
  /**
   * @param {Object} [opts]
   * @return {string[]} The complete list of formats available. Use this to build an options UI to allow your players to choose their favorite format.
   */


  Formatter.prototype.listFormats = function listFormats(opts) {
    opts = this._normalizeOpts(opts);
    return Object.keys(opts.formats);
  };

  return Formatter;
}();

var numberformat = new Formatter();
numberformat.defaultOptions = defaultOptions;
numberformat.Formatter = Formatter;
/* harmony default export */ __webpack_exports__["f"] = numberformat;

/**
 * Format a number using the default options.
 * @param {number} val
 * @param {Object} [opts]
 * @return string
 * @example
 * format(1e6)
 * // => "1.0000 million"
 * @example
 * format(1e6, {sigfigs: 1})
 * // => "1 million"
 */
var format = function format(val, opts) {
  return numberformat.format(val, opts);
};
/**
 * Format a full-flavor number using the default options. Identical to `format()`
 * @param {number} val
 * @param {Object} [opts]
 * @return string
 * @example
 * format(1e6)
 * // => "1.0000 million"
 */
var formatFull = function formatFull(val, opts) {
  return numberformat.formatFlavor(val, 'full', opts);
};
/**
 * Format a short-flavor number using the default options.
 * @param {number} val
 * @param {Object} [opts]
 * @return string
 * @example
 * format(1e6)
 * // => "1.00M"
 */
var formatShort = function formatShort(val, opts) {
  return numberformat.formatFlavor(val, 'short', opts);
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = {
	"short": [
		"",
		"K",
		"M",
		"Md",
		"B",
		"Bd",
		"T",
		"Td",
		"Qa",
		"Qad",
		"Qi",
		"Qid",
		"Sx",
		"Sxd",
		"Sp",
		"Spd",
		"Oc",
		"Od",
		"No",
		"Nd",
		"Dc",
		"Dd",
		"UDc",
		"UDd",
		"DDc",
		"DDd",
		"TDc",
		"TDd",
		"QaDc",
		"QaDd",
		"QiDc",
		"QiDd",
		"SxDc",
		"SxDd",
		"SpDc",
		"SpDd",
		"ODc",
		"ODd",
		"NDc",
		"NDd",
		"Vi",
		"Vd",
		"UVi",
		"UVd",
		"DVi",
		"DVd",
		"TVi",
		"TVd",
		"QaVi",
		"QaVd",
		"QiVi",
		"QiVd",
		"SxVi",
		"SxVd",
		"SpVi",
		"SpVd",
		"OVi",
		"OVd",
		"NVi",
		"NVd",
		"Tg",
		"TD",
		"UTg",
		"UTD",
		"DTg",
		"DTD",
		"TTg",
		"TTD",
		"QaTg",
		"QaTD",
		"QiTg",
		"QiTD",
		"SxTg",
		"SxTD",
		"SpTg",
		"SpTD",
		"OTg",
		"OTD",
		"NTg",
		"NTD",
		"Qd",
		"QD",
		"UQd",
		"UQD",
		"DQd",
		"DQD",
		"TQd",
		"TQD",
		"QaQd",
		"QaQD"
	],
	"full": [
		"",
		" thousand",
		" million",
		" milliard",
		" billion",
		" billiard",
		" trillion",
		" trilliard",
		" quadrillion",
		" quadrilliard",
		" quintillion",
		" quintilliard",
		" sextillion",
		" sextilliard",
		" septillion",
		" septilliard",
		" octillion",
		" octilliard",
		" nonillion",
		" nonilliard",
		" decillion",
		" decilliard",
		" undecillion",
		" undecilliard",
		" duodecillion",
		" duodecilliard",
		" tredecillion",
		" tredecilliard",
		" quattuordecillion",
		" quattuordecilliard",
		" quinquadecillion",
		" quinquadecilliard",
		" sedecillion",
		" sedecilliard",
		" septendecillion",
		" septendecilliard",
		" octodecillion",
		" octodecilliard",
		" novendecillion",
		" novendecilliard",
		" vigintillion",
		" vigintilliard",
		" unvigintillion",
		" unvigintilliard",
		" duovigintillion",
		" duovigintilliard",
		" tresvigintillion",
		" tresvigintilliard",
		" quattuorvigintillion",
		" quattuorvigintilliard",
		" quinquavigintillion",
		" quinquavigintilliard",
		" sesvigintillion",
		" sesvigintilliard",
		" septemvigintillion",
		" septemvigintilliard",
		" octovigintillion",
		" octovigintilliard",
		" novemvigintillion",
		" novemvigintilliard",
		" trigintillion",
		" trigintilliard",
		" untrigintillion",
		" untrigintilliard",
		" duotrigintillion",
		" duotrigintilliard",
		" trestrigintillion",
		" trestrigintilliard",
		" quattuortrigintillion",
		" quattuortrigintilliard",
		" quinquatrigintillion",
		" quinquatrigintilliard",
		" sestrigintillion",
		" sestrigintilliard",
		" septentrigintillion",
		" septentrigintilliard",
		" octotrigintillion",
		" octotrigintilliard",
		" noventrigintillion",
		" noventrigintilliard",
		" quadragintillion",
		" quadragintilliard",
		" unquadragintillion",
		" unquadragintilliard"
	]
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = {
	"short": [
		"",
		"K",
		"M",
		"B",
		"T",
		"Qa",
		"Qi",
		"Sx",
		"Sp",
		"Oc",
		"No",
		"Dc",
		"UDc",
		"DDc",
		"TDc",
		"QaDc",
		"QiDc",
		"SxDc",
		"SpDc",
		"ODc",
		"NDc",
		"Vi",
		"UVi",
		"DVi",
		"TVi",
		"QaVi",
		"QiVi",
		"SxVi",
		"SpVi",
		"OVi",
		"NVi",
		"Tg",
		"UTg",
		"DTg",
		"TTg",
		"QaTg",
		"QiTg",
		"SxTg",
		"SpTg",
		"OTg",
		"NTg",
		"Qd",
		"UQd",
		"DQd",
		"TQd",
		"QaQd",
		"QiQd",
		"SxQd",
		"SpQd",
		"OQd",
		"NQd",
		"Qq",
		"UQq",
		"DQq",
		"TQq",
		"QaQq",
		"QiQq",
		"SxQq",
		"SpQq",
		"OQq",
		"NQq",
		"Sg",
		"USg",
		"DSg",
		"TSg",
		"QaSg",
		"QiSg",
		"SxSg",
		"SpSg",
		"OSg",
		"NSg",
		"St",
		"USt",
		"DSt",
		"TSt",
		"QaSt",
		"QiSt",
		"SxSt",
		"SpSt",
		"OSt",
		"NSt",
		"Og",
		"UOg",
		"DOg",
		"TOg",
		"QaOg",
		"QiOg",
		"SxOg",
		"SpOg",
		"OOg",
		"NOg"
	],
	"full": [
		"",
		" thousand",
		" million",
		" billion",
		" trillion",
		" quadrillion",
		" quintillion",
		" sextillion",
		" septillion",
		" octillion",
		" nonillion",
		" decillion",
		" undecillion",
		" duodecillion",
		" tredecillion",
		" quattuordecillion",
		" quinquadecillion",
		" sedecillion",
		" septendecillion",
		" octodecillion",
		" novendecillion",
		" vigintillion",
		" unvigintillion",
		" duovigintillion",
		" tresvigintillion",
		" quattuorvigintillion",
		" quinquavigintillion",
		" sesvigintillion",
		" septemvigintillion",
		" octovigintillion",
		" novemvigintillion",
		" trigintillion",
		" untrigintillion",
		" duotrigintillion",
		" trestrigintillion",
		" quattuortrigintillion",
		" quinquatrigintillion",
		" sestrigintillion",
		" septentrigintillion",
		" octotrigintillion",
		" noventrigintillion",
		" quadragintillion",
		" unquadragintillion",
		" duoquadragintillion",
		" tresquadragintillion",
		" quattuorquadragintillion",
		" quinquaquadragintillion",
		" sesquadragintillion",
		" septenquadragintillion",
		" octoquadragintillion",
		" novenquadragintillion",
		" quinquagintillion",
		" unquinquagintillion",
		" duoquinquagintillion",
		" tresquinquagintillion",
		" quattuorquinquagintillion",
		" quinquaquinquagintillion",
		" sesquinquagintillion",
		" septenquinquagintillion",
		" octoquinquagintillion",
		" novenquinquagintillion",
		" sexagintillion",
		" unsexagintillion",
		" duosexagintillion",
		" tresexagintillion",
		" quattuorsexagintillion",
		" quinquasexagintillion",
		" sesexagintillion",
		" septensexagintillion",
		" octosexagintillion",
		" novensexagintillion",
		" septuagintillion",
		" unseptuagintillion",
		" duoseptuagintillion",
		" treseptuagintillion",
		" quattuorseptuagintillion",
		" quinquaseptuagintillion",
		" seseptuagintillion",
		" septenseptuagintillion",
		" octoseptuagintillion",
		" novenseptuagintillion",
		" octogintillion",
		" unoctogintillion",
		" duooctogintillion"
	]
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format__ = __webpack_require__(1);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Formats", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatFull", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatShort", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "numberformat", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(5);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_1__parse__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return __WEBPACK_IMPORTED_MODULE_1__parse__["b"]; });




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_long_scale_suffixes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decimal_js__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Parser; });


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





//const suffixGroups = {standard, longScale}
var suffixGroups = { standard: __WEBPACK_IMPORTED_MODULE_0__static_standard_suffixes_json___default.a }; // TODO longscale parsing. There's a duplicate
var suffixGroupsToExp = {};
for (var _iterator = Object.keys(suffixGroups), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
  var _ref;

  if (_isArray) {
    if (_i >= _iterator.length) break;
    _ref = _iterator[_i++];
  } else {
    _i = _iterator.next();
    if (_i.done) break;
    _ref = _i.value;
  }

  var groupName = _ref;

  var group = suffixGroups[groupName];
  var suffixToExp = suffixGroupsToExp[groupName] = {};
  for (var _iterator2 = Object.keys(group), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var fkey = _ref2;

    var fg = group[fkey];
    for (var index in fg) {
      var suffix = fg[index].toLowerCase();
      var exp = index * 3;
      if (suffixToExp[suffix] && suffixToExp[suffix].exp === exp, "duplicate parsenumber suffix with different exponents: " + suffix) suffixToExp[suffix] = { index: index, exp: exp, replace: 'e' + exp };
    }
  }
}

var backends = {
  'native': {
    parseInt: function parseInt(text, config) {
      var val = Math.ceil(Number(text, 10));
      return 'default' in config && !this.isValid(val) ? config['default'] : val;
    },
    isValid: function isValid(val) {
      return (val || val === 0) && !Number.isNaN(val);
    }
  },
  'decimal.js': {
    parseInt: function parseInt(text, config) {
      if ('default' in config) {
        try {
          var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decimal_js__["a" /* requireDecimal */])(config)(text).ceil();
          return this.isValid(val) ? val : config['default'];
        } catch (e) {
          return config.default;
        }
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decimal_js__["a" /* requireDecimal */])(config)(text).ceil();
    },
    isValid: function isValid(val) {
      return val && !val.isNaN();
    }
  }
};

function _parse(text) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!text) return config['default'] || null;
  // TODO make this an option
  var suffixToExp = suffixGroupsToExp[config.suffixGroup || 'standard'];
  var backend = backends[config.backend || 'native'];
  if (!backend) throw new Error('no such backend: ' + config.backend);
  // remove commas. TODO: i18n fail
  text = text.replace(/,/g, '');
  // replace suffixes ('billion', etc)
  var match = / ?[a-zA-Z]+/.exec(text);
  if (match && match.length > 0) {
    var exp = suffixToExp[match[0].toLowerCase()];
    if (exp) {
      // ceil(): buy at least this many. The default of floor() is annoying when
      // we're trying to purchase exactly-n for an upgrade.
      return backend.parseInt(text.replace(match[0], exp.replace), config);
    }
  }
  // no/invalid suffix found
  // note that we also get here for a suffix of 'e', like '1e3', because it's not
  // used as a suffix. Decimal.js will parse it.
  return backend.parseInt(text, config);
}

var Parser = function () {
  function Parser(config) {
    _classCallCheck(this, Parser);

    this.config = config;
  }

  Parser.prototype.parse = function parse(text) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _parse(text, _extends({}, this.config, config));
  };

  return Parser;
}();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ })
/******/ ]);
});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// usage: createStore(reducers, state, compose(..., withOfflineStore))
// We're mimicking the react-redux-firebase state structure here. Offline, we
// don't use it/don't connect to the real firebase with firebaseConnect;
// but we populate the state in a similar way, so react-redux-firebase selectors
// still work offline.
var user = {
  createdAt: 1,
  username: "Fake offline user"
};
var character = {
  createdAt: 1,
  user: "offline-userid",
  displayName: "Fake offline character",
  version: 1
};
var characters = {
  "offline-charid1": _extends({}, character, {
    units: {
      hatchery: {
        count: 1,
        firstAt: 1
      },
      drone: {
        bought: 1,
        count: 1,
        firstAt: 1
      }
    },
    achievements: {
      drone1: 1
    }
  }),
  "offline-charid2": character,
  "offline-charid3": character,
  "offline-charid-combatwin": _extends({}, character, {
    units: {
      "swarmling-queen": {
        bought: 2,
        count: 2,
        firstAt: 1
      }
    },
    actions: {
      act1: {
        type: "COMBAT_START",
        zone: "zone1",
        version: 1,
        createdAt: 2,
        flags: { multiSoldierCombat: true }
      }
    }
  })
};
var offlineState = exports.offlineState = {
  auth: {
    uid: "offline-userid",
    isLoaded: true
  },
  authError: null,
  profile: user,
  data: {
    users: {
      "offline-userid": user,
      "offline-userid-nobeta": user,
      "offline-userid-nochars": user,
      "404": null
    },
    options: {
      "404": null,
      "offline-userid": {
        isDebug: true,
        numberformat: null
      }
    },
    characters: _extends({}, characters, { "404": null }),
    "characters-by-user": {
      "offline-userid": characters,
      "offline-userid-nochars": []
    },
    rankings: {
      standard: {
        drone: {
          "offline-charid1": { displayName: "rankdisplayname1", value: 3 },
          "offline-charid2": { displayName: "rankdisplayname2", value: 2 },
          "offline-charid3": { displayName: "rankdisplayname3", value: 1 }
        }
      }
    },
    betaUsers: {
      "offline-userid": "somebetakey",
      "offline-userid-nochars": "somebetakey2",
      "offline-userid-nobeta": null,
      "404": null
    },
    betaKeyUsers: {
      "404": null,
      "valid-betakey": null
    },
    betaKeys: {
      "404": null,
      "valid-betakey": true
    },
    "": {
      info: {
        connected: true,
        serverTimeOffset: 0
      }
    },
    userRoles: {
      betaKeys: { "offline-userid": null },
      prereleaseFlags: { "offline-userid": null }
    },
    appInfo: {
      version: "867.5309.53669", // http://phonespell.org/combo.cgi?n=53669
      longVersion: "v867.5309.53669-1-g0123456",
      lastDeployedAt: "1234"
    }
  },
  requesting: {}
};
var offlineReducers = exports.offlineReducers = {
  firebase: function firebase() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : offlineState;
    var action = arguments[1];

    switch (action && action.type) {
      case "__test_offlineFirebaseFn":
        return action.fn(state);
      default:
        return state;
    }
  },
  firebaseAuthLoaded: function firebaseAuthLoaded() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: true };
    return state;
  },
  // It's inconvenient to mock out Date.now in every test, and we rarely want
  // real dates in our tests anyway
  clientNow: function clientNow() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1497000000000;
    return state;
  },
  _isAppOffline: function _isAppOffline() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return state;
  }
};
var isStateOffline = exports.isStateOffline = function isStateOffline(state) {
  return state && state._isAppOffline;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1eC9PZmZsaW5lLmpzIl0sIm5hbWVzIjpbInVzZXIiLCJjcmVhdGVkQXQiLCJ1c2VybmFtZSIsImNoYXJhY3RlciIsImRpc3BsYXlOYW1lIiwidmVyc2lvbiIsImNoYXJhY3RlcnMiLCJ1bml0cyIsImhhdGNoZXJ5IiwiY291bnQiLCJmaXJzdEF0IiwiZHJvbmUiLCJib3VnaHQiLCJhY2hpZXZlbWVudHMiLCJkcm9uZTEiLCJhY3Rpb25zIiwiYWN0MSIsInR5cGUiLCJ6b25lIiwiZmxhZ3MiLCJtdWx0aVNvbGRpZXJDb21iYXQiLCJvZmZsaW5lU3RhdGUiLCJhdXRoIiwidWlkIiwiaXNMb2FkZWQiLCJhdXRoRXJyb3IiLCJwcm9maWxlIiwiZGF0YSIsInVzZXJzIiwib3B0aW9ucyIsImlzRGVidWciLCJudW1iZXJmb3JtYXQiLCJyYW5raW5ncyIsInN0YW5kYXJkIiwidmFsdWUiLCJiZXRhVXNlcnMiLCJiZXRhS2V5VXNlcnMiLCJiZXRhS2V5cyIsImluZm8iLCJjb25uZWN0ZWQiLCJzZXJ2ZXJUaW1lT2Zmc2V0IiwidXNlclJvbGVzIiwicHJlcmVsZWFzZUZsYWdzIiwiYXBwSW5mbyIsImxvbmdWZXJzaW9uIiwibGFzdERlcGxveWVkQXQiLCJyZXF1ZXN0aW5nIiwib2ZmbGluZVJlZHVjZXJzIiwiZmlyZWJhc2UiLCJzdGF0ZSIsImFjdGlvbiIsImZuIiwiZmlyZWJhc2VBdXRoTG9hZGVkIiwiY2xpZW50Tm93IiwiX2lzQXBwT2ZmbGluZSIsImlzU3RhdGVPZmZsaW5lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSxJQUFNQSxPQUFPO0FBQ1hDLGFBQVcsQ0FEQTtBQUVYQyxZQUFVO0FBRkMsQ0FBYjtBQUlBLElBQU1DLFlBQVk7QUFDaEJGLGFBQVcsQ0FESztBQUVoQkQsUUFBTSxnQkFGVTtBQUdoQkksZUFBYSx3QkFIRztBQUloQkMsV0FBUztBQUpPLENBQWxCO0FBTUEsSUFBTUMsYUFBYTtBQUNqQixrQ0FDS0gsU0FETDtBQUVFSSxXQUFPO0FBQ0xDLGdCQUFVO0FBQ1JDLGVBQU8sQ0FEQztBQUVSQyxpQkFBUztBQUZELE9BREw7QUFLTEMsYUFBTztBQUNMQyxnQkFBUSxDQURIO0FBRUxILGVBQU8sQ0FGRjtBQUdMQyxpQkFBUztBQUhKO0FBTEYsS0FGVDtBQWFFRyxrQkFBYztBQUNaQyxjQUFRO0FBREk7QUFiaEIsSUFEaUI7QUFrQmpCLHFCQUFtQlgsU0FsQkY7QUFtQmpCLHFCQUFtQkEsU0FuQkY7QUFvQmpCLDJDQUNLQSxTQURMO0FBRUVJLFdBQU87QUFDTCx5QkFBbUI7QUFDakJLLGdCQUFRLENBRFM7QUFFakJILGVBQU8sQ0FGVTtBQUdqQkMsaUJBQVM7QUFIUTtBQURkLEtBRlQ7QUFTRUssYUFBUztBQUNQQyxZQUFNO0FBQ0pDLGNBQU0sY0FERjtBQUVKQyxjQUFNLE9BRkY7QUFHSmIsaUJBQVMsQ0FITDtBQUlKSixtQkFBVyxDQUpQO0FBS0prQixlQUFPLEVBQUNDLG9CQUFvQixJQUFyQjtBQUxIO0FBREM7QUFUWDtBQXBCaUIsQ0FBbkI7QUF3Q08sSUFBTUMsc0NBQWU7QUFDMUJDLFFBQU07QUFDSkMsU0FBSyxnQkFERDtBQUVKQyxjQUFVO0FBRk4sR0FEb0I7QUFLMUJDLGFBQVcsSUFMZTtBQU0xQkMsV0FBUzFCLElBTmlCO0FBTzFCMkIsUUFBTTtBQUNKQyxXQUFPO0FBQ0wsd0JBQWtCNUIsSUFEYjtBQUVMLCtCQUF5QkEsSUFGcEI7QUFHTCxnQ0FBMEJBLElBSHJCO0FBSUwsYUFBTztBQUpGLEtBREg7QUFPSjZCLGFBQVM7QUFDUCxhQUFPLElBREE7QUFFUCx3QkFBa0I7QUFDaEJDLGlCQUFTLElBRE87QUFFaEJDLHNCQUFjO0FBRkU7QUFGWCxLQVBMO0FBY0p6Qiw2QkFBZ0JBLFVBQWhCLElBQTRCLE9BQU8sSUFBbkMsR0FkSTtBQWVKLDBCQUFzQjtBQUNwQix3QkFBa0JBLFVBREU7QUFFcEIsZ0NBQTBCO0FBRk4sS0FmbEI7QUFtQkowQixjQUFVO0FBQ1JDLGdCQUFVO0FBQ1J0QixlQUFPO0FBQ0wsNkJBQW1CLEVBQUNQLGFBQWEsa0JBQWQsRUFBa0M4QixPQUFPLENBQXpDLEVBRGQ7QUFFTCw2QkFBbUIsRUFBQzlCLGFBQWEsa0JBQWQsRUFBa0M4QixPQUFPLENBQXpDLEVBRmQ7QUFHTCw2QkFBbUIsRUFBQzlCLGFBQWEsa0JBQWQsRUFBa0M4QixPQUFPLENBQXpDO0FBSGQ7QUFEQztBQURGLEtBbkJOO0FBNEJKQyxlQUFXO0FBQ1Qsd0JBQWtCLGFBRFQ7QUFFVCxnQ0FBMEIsY0FGakI7QUFHVCwrQkFBeUIsSUFIaEI7QUFJVCxhQUFPO0FBSkUsS0E1QlA7QUFrQ0pDLGtCQUFjO0FBQ1osYUFBTyxJQURLO0FBRVosdUJBQWlCO0FBRkwsS0FsQ1Y7QUFzQ0pDLGNBQVU7QUFDUixhQUFPLElBREM7QUFFUix1QkFBaUI7QUFGVCxLQXRDTjtBQTBDSixRQUFJO0FBQ0ZDLFlBQU07QUFDSkMsbUJBQVcsSUFEUDtBQUVKQywwQkFBa0I7QUFGZDtBQURKLEtBMUNBO0FBZ0RKQyxlQUFXO0FBQ1RKLGdCQUFVLEVBQUMsa0JBQWtCLElBQW5CLEVBREQ7QUFFVEssdUJBQWlCLEVBQUMsa0JBQWtCLElBQW5CO0FBRlIsS0FoRFA7QUFvREpDLGFBQVM7QUFDUHRDLGVBQVMsZ0JBREYsRUFDb0I7QUFDM0J1QyxtQkFBYSw0QkFGTjtBQUdQQyxzQkFBZ0I7QUFIVDtBQXBETCxHQVBvQjtBQWlFMUJDLGNBQVk7QUFqRWMsQ0FBckI7QUFtRUEsSUFBTUMsNENBQWtCO0FBQzdCQyxZQUFVLG9CQUdMO0FBQUEsUUFGSEMsS0FFRyx1RUFGYTVCLFlBRWI7QUFBQSxRQURINkIsTUFDRzs7QUFDSCxZQUFRQSxVQUFVQSxPQUFPakMsSUFBekI7QUFDRSxXQUFLLDBCQUFMO0FBQ0UsZUFBT2lDLE9BQU9DLEVBQVAsQ0FBVUYsS0FBVixDQUFQO0FBQ0Y7QUFDRSxlQUFPQSxLQUFQO0FBSko7QUFNRCxHQVg0QjtBQVk3Qkcsc0JBQW9CO0FBQUEsUUFBQ0gsS0FBRCx1RUFBaUIsRUFBQ3pCLFVBQVUsSUFBWCxFQUFqQjtBQUFBLFdBQXNDeUIsS0FBdEM7QUFBQSxHQVpTO0FBYTdCO0FBQ0E7QUFDQUksYUFBVztBQUFBLFFBQUNKLEtBQUQsdUVBQWlCLGFBQWpCO0FBQUEsV0FBbUNBLEtBQW5DO0FBQUEsR0Fma0I7QUFnQjdCSyxpQkFBZTtBQUFBLFFBQUNMLEtBQUQsdUVBQWtCLElBQWxCO0FBQUEsV0FBMkJBLEtBQTNCO0FBQUE7QUFoQmMsQ0FBeEI7QUFrQkEsSUFBTU0sMENBQWlCLFNBQWpCQSxjQUFpQixDQUFDTixLQUFEO0FBQUEsU0FBbUJBLFNBQVNBLE1BQU1LLGFBQWxDO0FBQUEsQ0FBdkIiLCJmaWxlIjoiT2ZmbGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyB1c2FnZTogY3JlYXRlU3RvcmUocmVkdWNlcnMsIHN0YXRlLCBjb21wb3NlKC4uLiwgd2l0aE9mZmxpbmVTdG9yZSkpXG4vLyBXZSdyZSBtaW1pY2tpbmcgdGhlIHJlYWN0LXJlZHV4LWZpcmViYXNlIHN0YXRlIHN0cnVjdHVyZSBoZXJlLiBPZmZsaW5lLCB3ZVxuLy8gZG9uJ3QgdXNlIGl0L2Rvbid0IGNvbm5lY3QgdG8gdGhlIHJlYWwgZmlyZWJhc2Ugd2l0aCBmaXJlYmFzZUNvbm5lY3Q7XG4vLyBidXQgd2UgcG9wdWxhdGUgdGhlIHN0YXRlIGluIGEgc2ltaWxhciB3YXksIHNvIHJlYWN0LXJlZHV4LWZpcmViYXNlIHNlbGVjdG9yc1xuLy8gc3RpbGwgd29yayBvZmZsaW5lLlxuY29uc3QgdXNlciA9IHtcbiAgY3JlYXRlZEF0OiAxLFxuICB1c2VybmFtZTogXCJGYWtlIG9mZmxpbmUgdXNlclwiLFxufVxuY29uc3QgY2hhcmFjdGVyID0ge1xuICBjcmVhdGVkQXQ6IDEsXG4gIHVzZXI6IFwib2ZmbGluZS11c2VyaWRcIixcbiAgZGlzcGxheU5hbWU6IFwiRmFrZSBvZmZsaW5lIGNoYXJhY3RlclwiLFxuICB2ZXJzaW9uOiAxLFxufVxuY29uc3QgY2hhcmFjdGVycyA9IHtcbiAgXCJvZmZsaW5lLWNoYXJpZDFcIjoge1xuICAgIC4uLmNoYXJhY3RlcixcbiAgICB1bml0czoge1xuICAgICAgaGF0Y2hlcnk6IHtcbiAgICAgICAgY291bnQ6IDEsXG4gICAgICAgIGZpcnN0QXQ6IDEsXG4gICAgICB9LFxuICAgICAgZHJvbmU6IHtcbiAgICAgICAgYm91Z2h0OiAxLFxuICAgICAgICBjb3VudDogMSxcbiAgICAgICAgZmlyc3RBdDogMSxcbiAgICAgIH0sXG4gICAgfSxcbiAgICBhY2hpZXZlbWVudHM6IHtcbiAgICAgIGRyb25lMTogMSxcbiAgICB9LFxuICB9LFxuICBcIm9mZmxpbmUtY2hhcmlkMlwiOiBjaGFyYWN0ZXIsXG4gIFwib2ZmbGluZS1jaGFyaWQzXCI6IGNoYXJhY3RlcixcbiAgXCJvZmZsaW5lLWNoYXJpZC1jb21iYXR3aW5cIjoge1xuICAgIC4uLmNoYXJhY3RlcixcbiAgICB1bml0czoge1xuICAgICAgXCJzd2FybWxpbmctcXVlZW5cIjoge1xuICAgICAgICBib3VnaHQ6IDIsXG4gICAgICAgIGNvdW50OiAyLFxuICAgICAgICBmaXJzdEF0OiAxLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGFjdGlvbnM6IHtcbiAgICAgIGFjdDE6IHtcbiAgICAgICAgdHlwZTogXCJDT01CQVRfU1RBUlRcIixcbiAgICAgICAgem9uZTogXCJ6b25lMVwiLFxuICAgICAgICB2ZXJzaW9uOiAxLFxuICAgICAgICBjcmVhdGVkQXQ6IDIsXG4gICAgICAgIGZsYWdzOiB7bXVsdGlTb2xkaWVyQ29tYmF0OiB0cnVlfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn1cbmV4cG9ydCBjb25zdCBvZmZsaW5lU3RhdGUgPSB7XG4gIGF1dGg6IHtcbiAgICB1aWQ6IFwib2ZmbGluZS11c2VyaWRcIixcbiAgICBpc0xvYWRlZDogdHJ1ZSxcbiAgfSxcbiAgYXV0aEVycm9yOiBudWxsLFxuICBwcm9maWxlOiB1c2VyLFxuICBkYXRhOiB7XG4gICAgdXNlcnM6IHtcbiAgICAgIFwib2ZmbGluZS11c2VyaWRcIjogdXNlcixcbiAgICAgIFwib2ZmbGluZS11c2VyaWQtbm9iZXRhXCI6IHVzZXIsXG4gICAgICBcIm9mZmxpbmUtdXNlcmlkLW5vY2hhcnNcIjogdXNlcixcbiAgICAgIFwiNDA0XCI6IG51bGwsXG4gICAgfSxcbiAgICBvcHRpb25zOiB7XG4gICAgICBcIjQwNFwiOiBudWxsLFxuICAgICAgXCJvZmZsaW5lLXVzZXJpZFwiOiB7XG4gICAgICAgIGlzRGVidWc6IHRydWUsXG4gICAgICAgIG51bWJlcmZvcm1hdDogbnVsbCxcbiAgICAgIH0sXG4gICAgfSxcbiAgICBjaGFyYWN0ZXJzOiB7Li4uY2hhcmFjdGVycywgXCI0MDRcIjogbnVsbH0sXG4gICAgXCJjaGFyYWN0ZXJzLWJ5LXVzZXJcIjoge1xuICAgICAgXCJvZmZsaW5lLXVzZXJpZFwiOiBjaGFyYWN0ZXJzLFxuICAgICAgXCJvZmZsaW5lLXVzZXJpZC1ub2NoYXJzXCI6IFtdLFxuICAgIH0sXG4gICAgcmFua2luZ3M6IHtcbiAgICAgIHN0YW5kYXJkOiB7XG4gICAgICAgIGRyb25lOiB7XG4gICAgICAgICAgXCJvZmZsaW5lLWNoYXJpZDFcIjoge2Rpc3BsYXlOYW1lOiBcInJhbmtkaXNwbGF5bmFtZTFcIiwgdmFsdWU6IDN9LFxuICAgICAgICAgIFwib2ZmbGluZS1jaGFyaWQyXCI6IHtkaXNwbGF5TmFtZTogXCJyYW5rZGlzcGxheW5hbWUyXCIsIHZhbHVlOiAyfSxcbiAgICAgICAgICBcIm9mZmxpbmUtY2hhcmlkM1wiOiB7ZGlzcGxheU5hbWU6IFwicmFua2Rpc3BsYXluYW1lM1wiLCB2YWx1ZTogMX0sXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIH0sXG4gICAgYmV0YVVzZXJzOiB7XG4gICAgICBcIm9mZmxpbmUtdXNlcmlkXCI6IFwic29tZWJldGFrZXlcIixcbiAgICAgIFwib2ZmbGluZS11c2VyaWQtbm9jaGFyc1wiOiBcInNvbWViZXRha2V5MlwiLFxuICAgICAgXCJvZmZsaW5lLXVzZXJpZC1ub2JldGFcIjogbnVsbCxcbiAgICAgIFwiNDA0XCI6IG51bGwsXG4gICAgfSxcbiAgICBiZXRhS2V5VXNlcnM6IHtcbiAgICAgIFwiNDA0XCI6IG51bGwsXG4gICAgICBcInZhbGlkLWJldGFrZXlcIjogbnVsbCxcbiAgICB9LFxuICAgIGJldGFLZXlzOiB7XG4gICAgICBcIjQwNFwiOiBudWxsLFxuICAgICAgXCJ2YWxpZC1iZXRha2V5XCI6IHRydWUsXG4gICAgfSxcbiAgICBcIlwiOiB7XG4gICAgICBpbmZvOiB7XG4gICAgICAgIGNvbm5lY3RlZDogdHJ1ZSxcbiAgICAgICAgc2VydmVyVGltZU9mZnNldDogMCxcbiAgICAgIH0sXG4gICAgfSxcbiAgICB1c2VyUm9sZXM6IHtcbiAgICAgIGJldGFLZXlzOiB7XCJvZmZsaW5lLXVzZXJpZFwiOiBudWxsfSxcbiAgICAgIHByZXJlbGVhc2VGbGFnczoge1wib2ZmbGluZS11c2VyaWRcIjogbnVsbH0sXG4gICAgfSxcbiAgICBhcHBJbmZvOiB7XG4gICAgICB2ZXJzaW9uOiBcIjg2Ny41MzA5LjUzNjY5XCIsIC8vIGh0dHA6Ly9waG9uZXNwZWxsLm9yZy9jb21iby5jZ2k/bj01MzY2OVxuICAgICAgbG9uZ1ZlcnNpb246IFwidjg2Ny41MzA5LjUzNjY5LTEtZzAxMjM0NTZcIixcbiAgICAgIGxhc3REZXBsb3llZEF0OiBcIjEyMzRcIixcbiAgICB9LFxuICB9LFxuICByZXF1ZXN0aW5nOiB7fSxcbn1cbmV4cG9ydCBjb25zdCBvZmZsaW5lUmVkdWNlcnMgPSB7XG4gIGZpcmViYXNlOiAoXG4gICAgc3RhdGU6IE9iamVjdCA9IG9mZmxpbmVTdGF0ZSxcbiAgICBhY3Rpb246IHt0eXBlOiBzdHJpbmcsIGZuOiBGdW5jdGlvbn0sXG4gICkgPT4ge1xuICAgIHN3aXRjaCAoYWN0aW9uICYmIGFjdGlvbi50eXBlKSB7XG4gICAgICBjYXNlIFwiX190ZXN0X29mZmxpbmVGaXJlYmFzZUZuXCI6XG4gICAgICAgIHJldHVybiBhY3Rpb24uZm4oc3RhdGUpXG4gICAgICBkZWZhdWx0OlxuICAgICAgICByZXR1cm4gc3RhdGVcbiAgICB9XG4gIH0sXG4gIGZpcmViYXNlQXV0aExvYWRlZDogKHN0YXRlOiBPYmplY3QgPSB7aXNMb2FkZWQ6IHRydWV9KSA9PiBzdGF0ZSxcbiAgLy8gSXQncyBpbmNvbnZlbmllbnQgdG8gbW9jayBvdXQgRGF0ZS5ub3cgaW4gZXZlcnkgdGVzdCwgYW5kIHdlIHJhcmVseSB3YW50XG4gIC8vIHJlYWwgZGF0ZXMgaW4gb3VyIHRlc3RzIGFueXdheVxuICBjbGllbnROb3c6IChzdGF0ZTogbnVtYmVyID0gMTQ5NzAwMDAwMDAwMCkgPT4gc3RhdGUsXG4gIF9pc0FwcE9mZmxpbmU6IChzdGF0ZTogYm9vbGVhbiA9IHRydWUpID0+IHN0YXRlLFxufVxuZXhwb3J0IGNvbnN0IGlzU3RhdGVPZmZsaW5lID0gKHN0YXRlOiBPYmplY3QpID0+IHN0YXRlICYmIHN0YXRlLl9pc0FwcE9mZmxpbmVcbiJdfQ==

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAuth = exports.AppRoot = exports._CreateUserProfile = exports.Start = exports.CreateAnonymousAccount = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _actions = __webpack_require__(95);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _lifecycle = __webpack_require__(75);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _characters = __webpack_require__(383);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateAnonymousAccount = exports.CreateAnonymousAccount = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth)/,
  onReady: (0, _reselect.createStructuredSelector)({
    isAuthEmpty: _selectors2.default.auth.isEmpty
  })
}), { signInAnonymously: _selectors2.default.auth.signInAnonymously }), (0, _actions.dispatchLocalPromise)("signInAnonymously", "request",
// this could be shorter, but let's stick to the pattern needed for promises with params
(0, _reselect.createSelector)(function (s, p) {
  return p.signInAnonymously;
}, function (signin) {
  return function () {
    return signin();
  };
})), (0, _withProps2.default)(function (props) {
  var isAuthEmpty = props.isAuthEmpty,
      signInAnonymously = props.signInAnonymously,
      request = props.request;

  var needsSignin = isAuthEmpty && !request.type;
  if (needsSignin) signInAnonymously();
  return needsSignin || request.status === "pending" ? { isError: true, isPending: true, pendingKeys: ["signInAnonymously"] } : {};
}));
var Start = exports.Start = (0, _compose2.default)(CreateAnonymousAccount, _characters.LastCharacter);

var all = function all() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _lodash2.default.every(args);
};
var needsProfile = (0, _reselect.createSelector)(_selectors2.default.auth.isNotEmpty, _selectors2.default.beta.isAllowed, _selectors2.default.auth.user.isEmpty, all);
var _CreateUserProfile = exports._CreateUserProfile = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|users|betaUsers)/,
  // don't attempt to create the profile if we're unauthed - that is,
  // CreateAnonymousAccount hasn't run yet
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    needsProfile: needsProfile
  })
}), { create: _selectors2.default.chars2.createWithUser }), (0, _actions.dispatchLocalPromise)("create", "request", function (s, p) {
  return p.create;
}));
var CreateUserProfile = (0, _compose2.default)(_CreateUserProfile, (0, _withProps2.default)(function (props) {
  if (props.needsProfile && !props.request.type) {
    props.create();
  }
}));

// Emit TICK actions, advancing client-side time.
var NowProvider = (0, _compose2.default)((0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  stoptime: _selectors2.default.flags.stoptime
})), (0, _lifecycle2.default)({
  componentWillMount: function componentWillMount() {
    var _this = this;

    var _tick1 = function _tick1() {
      _this.props.dispatch({ type: "TICK" });
      _this.timeout = null;
      _this.raf = window.requestAnimationFrame(_tick2);
    };
    var _tick2 = function _tick2() {
      _this.raf = null;
      _this.timeout = window.setTimeout(_tick1, 50);
    };
    if (!this.props.stoptime) {
      this.raf = window.requestAnimationFrame(_tick1);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
  }
}));

var AppRoot = exports.AppRoot = (0, _compose2.default)(
// If the user has an account, try to create a profile for it. Don't create
// the account here, though! This runs at the top level, for everything, but
// account creation must go through the title screen.
CreateUserProfile,
// Each page that requires now must include it.
NowProvider);

// Wraps any page that requires a valid user account. Caller must inspect
// isAllowed and take appropriate action if not-allowed.
var withAuth = exports.withAuth = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|betaUsers)/,
  onReady: (0, _reselect.createStructuredSelector)({
    isAuthed: _lodash2.default.negate(_selectors2.default.auth.isEmpty),
    isAllowed: _selectors2.default.beta.isAllowed
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var WithReducer = function (_Component) {
      _inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
      };

      return WithReducer;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

exports.default = withReducer;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StuckActionsError = exports.LastCharacter = exports.AuthCharacterList = exports.NewCharacterLeague = exports.NewCharacter = exports.CharacterList = exports.CharacterListItem = exports.CharacterRO = exports.CharacterRW = exports.CharacterRouter = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _branch = __webpack_require__(111);

var _branch2 = _interopRequireDefault(_branch);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _form = __webpack_require__(56);

var _actions = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CharacterRouter = exports.CharacterRouter = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    userId: _selectors2.default.chars2.user.id,
    isAuthChar: _selectors2.default.chars2.user.isAuth
  })
})));
var CharacterRW = exports.CharacterRW = (0, _compose2.default)(Url.charId, (0, _withProps2.default)(function (props) {
  return { readonly: false };
}), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    userId: _selectors2.default.chars2.user.id,
    createdAt: _selectors2.default.chars2.createdAt,
    ownerName: _selectors2.default.chars2.user.displayName,
    isCombatVisible: _selectors2.default.chars2.breakpoints.isNavCombatVisible
  })
}), { setDisplayName: _selectors2.default.chars2.pushRename }), (0, _actions.dispatchLocalPromise)("setDisplayName", "request", (0, _reselect.createSelector)(function (s, p) {
  return p.setDisplayName;
}, function (s, p) {
  return p.charId;
}, function (set, charId) {
  return function (displayName) {
    return set(charId, displayName);
  };
})));
var CharacterRO = exports.CharacterRO = (0, _compose2.default)(Url.charId, (0, _withProps2.default)(function (props) {
  return { readonly: true };
}), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    userId: _selectors2.default.chars2.user.id,
    createdAt: _selectors2.default.chars2.createdAt,
    ownerName: _selectors2.default.chars2.user.displayName,
    isCombatVisible: _selectors2.default.chars2.breakpoints.isNavCombatVisible
  })
})));

var CharacterListItem = exports.CharacterListItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    league: _selectors2.default.chars2.league.name,
    updatedAt: _selectors2.default.chars2.lastActionAt
  })
}), { delete: _selectors2.default.chars2.delete_ }), (0, _actions.dispatchLocalPromise)("delete", "request", (0, _reselect.createSelector)(function (s, p) {
  return p.delete;
}, function (s, p) {
  return p.charId;
}, function (delete_, charId) {
  return function () {
    return delete_(charId);
  };
})));
var CharacterList = exports.CharacterList = (0, _compose2.default)(Url.userId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    user: _selectors2.default.users.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    chars: _selectors2.default.users.chars.list,
    user: (0, _reselect.createStructuredSelector)({
      displayName: _selectors2.default.users.displayName
    })
  })
})));

var newCharState = function newCharState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === undefined ? "" : _ref$displayName,
      _ref$league = _ref.league,
      league = _ref$league === undefined ? "standard" : _ref$league;

  return (0, _compose2.default)((0, _withState2.default)("displayName", "setDisplayName", displayName), (0, _withState2.default)("league", "setLeague", league)
  //withState("request", "setRequest", {state: "CLEAR"}),
  );
};
var NewCharacter = exports.NewCharacter = (0, _compose2.default)(newCharState(), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    leagues: _selectors2.default.chars2.league.names,
    isCharLimit: _selectors2.default.auth.chars.isCharLimit,
    input: (0, _form.handleInputs)("setDisplayName", "setLeague"),
    isLeagueOpen: _selectors2.default.chars2.league.isOpen
  })
}), { create: _selectors2.default.chars2.create }), (0, _actions.dispatchLocalPromise)("create", "request", (0, _reselect.createSelector)(function (s, p) {
  return p.create;
}, (0, _reselect.createStructuredSelector)({
  displayName: function displayName(s, p) {
    return p.displayName;
  },
  league: function league(s, p) {
    return p.league;
  }
}), function (create, props) {
  return function () {
    return create(props);
  };
})));
var NewCharacterLeague = exports.NewCharacterLeague = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    isOpen: _selectors2.default.chars2.league.isOpen,
    untilOpen: _selectors2.default.chars2.league.untilOpen
  })
})));
var AuthCharacterList = exports.AuthCharacterList = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    chars: _selectors2.default.auth.chars.list,
    limit: _selectors2.default.auth.chars.limit,
    user: (0, _reselect.createStructuredSelector)({
      displayName: _selectors2.default.auth.user.displayName
    })
  })
})));

var LastCharacter = exports.LastCharacter = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    characterList: _selectors2.default.auth.chars.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    charId: _selectors2.default.auth.chars.lastPlayed
  })
})));
var StuckActionsError = exports.StuckActionsError = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    numPendingActions: _selectors2.default.chars2.numPendingActions
  })
})),
// the common case: no stuck actions. Small threshold for pending actions
// between client-side click and server-side processing. Ideally we'd check
// the time of the earliest action instead, but that's harder; and if one gets
// stuck others will probably follow.
(0, _branch2.default)(
//props => true,
function (props) {
  return props.numPendingActions != null && props.numPendingActions > 2;
}, (0, _compose2.default)((0, _withState2.default)("open", "setOpen", true), (0, _withProps2.default)(function (_ref2) {
  var setOpen = _ref2.setOpen;
  return { onClose: function onClose() {
      return setOpen(false);
    } };
})), (0, _withProps2.default)({ open: false })));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(120);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDrawerState = undefined;

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _lifecycle = __webpack_require__(75);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _mapProps = __webpack_require__(159);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _classnames = __webpack_require__(387);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withDrawerState = function withDrawerState(_ref) {
  var _ref$dockedPx = _ref.dockedPx,
      dockedPx = _ref$dockedPx === undefined ? 960 : _ref$dockedPx;
  return (0, _compose2.default)((0, _lifecycle2.default)({
    componentWillMount: function componentWillMount() {
      var _this = this;

      var setOpen = function setOpen(open) {
        return _this.setState({ open: open });
      };
      this.setState({ setOpen: setOpen });
      setOpen(false);

      this.listener = function () {
        // The 960px default is the 'medium' breakpoint, defined here:
        // https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-breakpoints
        // Default to desktop view in browsers without matchMedia
        _this.setState({
          docked: !window.matchMedia || window.matchMedia("(min-width: " + dockedPx + "px)").matches
        });
      };
      this.listener();
      window.addEventListener("resize", this.listener);
    },
    componentWillUnmount: function componentWillUnmount() {
      window.removeEventListener("resize", this.listener);
    },

    // When we click a nav link, close the drawer on mobile
    componentWillReceiveProps: function componentWillReceiveProps(props) {
      if (this.props.location !== props.location) {
        this.setState({ open: false });
      }
    }
  }), (0, _withProps2.default)(function (props) {
    return {
      toggleOpen: function toggleOpen() {
        return props.setOpen(!props.open);
      }
    };
  }), (0, _mapProps2.default)(function (_ref2) {
    var docked = _ref2.docked,
        open = _ref2.open,
        setOpen = _ref2.setOpen,
        props = _objectWithoutProperties(_ref2, ["docked", "open", "setOpen"]);

    open = open || docked;
    return Object.assign({}, props, {
      drawerProps: {
        docked: docked,
        open: docked || open,
        setOpen: setOpen,
        onRequestChange: setOpen
      },
      drawerStyle: {
        containerClassName: (0, _classnames2.default)("drawerContainer", { docked: docked, open: open }),
        className: (0, _classnames2.default)("drawer", { docked: docked, open: open })
      }
    });
  }));
};
exports.withDrawerState = withDrawerState;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Store__ = __webpack_require__(858);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["a"]; });


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnitsRouter__ = __webpack_require__(860);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UnitsRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnitsReducer__ = __webpack_require__(932);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__UnitsReducer__["a"]; });
//export * from './UnitView'
//export * from './UnitListView'

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(863), __esModule: true };

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(114);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(866);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(867);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(868);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__(394);

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(392);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__(395);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(870);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(
          _TransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(266);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var verticalPosition = props.verticalPosition;
  var horizontalPosition = props.horizontalPosition;
  var touchMarginOffset = props.touch ? 10 : 0;
  var touchOffsetTop = props.touch ? -20 : -10;
  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      zIndex = _context$muiTheme.zIndex,
      tooltip = _context$muiTheme.tooltip,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'absolute',
      fontFamily: baseTheme.fontFamily,
      fontSize: '10px',
      lineHeight: '22px',
      padding: '0 8px',
      zIndex: zIndex.tooltip,
      color: tooltip.color,
      overflow: 'hidden',
      top: -10000,
      borderRadius: borderRadius,
      userSelect: 'none',
      opacity: 0,
      right: horizontalPosition === 'left' ? 12 : null,
      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    label: {
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    ripple: {
      position: 'absolute',
      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
      top: verticalPosition === 'bottom' ? 0 : '100%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    },
    rootWhenShown: {
      top: verticalPosition === 'top' ? touchOffsetTop : 36,
      opacity: tooltip.opacity,
      transform: 'translate(0px, ' + offset + 'px)',
      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    rootWhenTouched: {
      fontSize: '14px',
      lineHeight: '32px',
      padding: '0 16px'
    },
    rippleWhenShown: {
      backgroundColor: tooltip.rippleBackgroundColor,
      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    }
  };

  return styles;
}

var Tooltip = function (_Component) {
  (0, _inherits3.default)(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      offsetWidth: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRippleSize();
      this.setTooltipPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setTooltipPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setRippleSize();
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var ripple = this.refs.ripple;
      var tooltip = this.refs.tooltip;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);

      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.props.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    }
  }, {
    key: 'setTooltipPosition',
    value: function setTooltipPosition() {
      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          horizontalPosition = _props.horizontalPosition,
          label = _props.label,
          show = _props.show,
          touch = _props.touch,
          verticalPosition = _props.verticalPosition,
          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: 'tooltip',
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
        }),
        _react2.default.createElement('div', {
          ref: 'ripple',
          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          label
        )
      );
    }
  }]);
  return Tooltip;
}(_react.Component);

Tooltip.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tooltip.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
  label: _propTypes2.default.node.isRequired,
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  touch: _propTypes2.default.bool,
  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};
exports.default = Tooltip;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMenu = function NavigationMenu(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
  );
};
NavigationMenu = (0, _pure2.default)(NavigationMenu);
NavigationMenu.displayName = 'NavigationMenu';
NavigationMenu.muiName = 'SvgIcon';

exports.default = NavigationMenu;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(888);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(889);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSpinner; });
/* unused harmony export loadingIf */
/* unused harmony export readyIf */
/* unused harmony export propsLoading */
/* unused harmony export propsLoadings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RefreshIndicator__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RefreshIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RefreshIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_branch__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_renderComponent__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_renderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_renderComponent__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var LoadingSpinner=function LoadingSpinner(_ref){var _ref$left=_ref.left,left=_ref$left===undefined?0:_ref$left,_ref$top=_ref.top,top=_ref$top===undefined?0:_ref$top,_ref$size=_ref.size,size=_ref$size===undefined?undefined:_ref$size,props=_objectWithoutProperties(_ref,["left","top","size"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",Object.assign({},props,{style:{position:"relative"}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_RefreshIndicator___default.a,Object.assign({status:"loading",style:{display:"inline-block",position:"relative"}},{left:left,top:top,size:size})));};var loadingIf=function loadingIf(pred){return __WEBPACK_IMPORTED_MODULE_2_recompose_branch___default()(pred,__WEBPACK_IMPORTED_MODULE_3_recompose_renderComponent___default()(LoadingSpinner));};var readyIf=function readyIf(pred){return loadingIf(function(props){return!pred(props);});};function areNamesDefined(names,props){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=names[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var name=_step.value;if(props[name]===undefined){return false;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return true;}var propsLoading=function propsLoading(names){return readyIf(function(props){return areNamesDefined(names,props);});};var propsLoadings=function propsLoadings(){for(var _len=arguments.length,names=Array(_len),_key=0;_key<_len;_key++){names[_key]=arguments[_key];}return propsLoading(names);};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFoundView__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoadingSpinner__ = __webpack_require__(400);
function Error(props){var inline=props.inline,error=props.error;if(error.isPending){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LoadingSpinner__["a" /* LoadingSpinner */],{title:"Pending: "+JSON.stringify(error.pendingKeys)});}if(error.isEmpty){var Tag=inline?__WEBPACK_IMPORTED_MODULE_3__LoadingSpinner__["a" /* LoadingSpinner */]:__WEBPACK_IMPORTED_MODULE_2__NotFoundView__["a" /* NotFoundView */];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tag,{title:"Empty: "+JSON.stringify(error.emptyKeys)});}return Object(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__["throws"])("unknown Error2",props);}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotFoundView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function NotFoundView(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",props,"404!");}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyboardArrowUp = __webpack_require__(909);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardArrowDown = __webpack_require__(910);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _IconButton = __webpack_require__(67);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      top: 0,
      bottom: 0,
      right: 4,
      margin: 'auto',
      position: 'absolute'
    }
  };
}

var CardExpandable = function (_Component) {
  (0, _inherits3.default)(CardExpandable, _Component);

  function CardExpandable() {
    (0, _classCallCheck3.default)(this, CardExpandable);
    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardExpandable, [{
    key: 'render',
    value: function render() {
      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _IconButton2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          onClick: this.props.onExpanding,
          iconStyle: this.props.iconStyle
        },
        this.props.expanded ? this.props.openIcon : this.props.closeIcon
      );
    }
  }]);
  return CardExpandable;
}(_react.Component);

CardExpandable.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardExpandable.defaultProps = {
  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
};
CardExpandable.propTypes =  false ? {
  closeIcon: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  onExpanding: _propTypes2.default.func.isRequired,
  openIcon: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = CardExpandable;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Drawer = __webpack_require__(919);

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Drawer2.default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(82);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(112);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _IconButton = __webpack_require__(67);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _expandLess = __webpack_require__(925);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(926);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _NestedList = __webpack_require__(927);

var _NestedList2 = _interopRequireDefault(_NestedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
      insetChildren = props.insetChildren,
      leftAvatar = props.leftAvatar,
      leftCheckbox = props.leftCheckbox,
      leftIcon = props.leftIcon,
      nestedItems = props.nestedItems,
      nestedLevel = props.nestedLevel,
      rightAvatar = props.rightAvatar,
      rightIcon = props.rightIcon,
      rightIconButton = props.rightIconButton,
      rightToggle = props.rightToggle,
      secondaryText = props.secondaryText,
      secondaryTextLines = props.secondaryTextLines;
  var muiTheme = context.muiTheme;
  var listItem = muiTheme.listItem;


  var textColor = muiTheme.baseTheme.palette.textColor;
  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
  var twoLine = secondaryText && secondaryTextLines === 1;
  var threeLine = secondaryText && secondaryTextLines > 1;

  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;

  var styles = {
    root: {
      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
      color: textColor,
      display: 'block',
      fontSize: 16,
      lineHeight: '16px',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },

    // This inner div is needed so that ripples will span the entire container
    innerDiv: {
      marginLeft: nestedLevel * listItem.nestedLevelDepth,
      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
      paddingBottom: singleAvatar ? 20 : 16,
      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
      position: 'relative'
    },

    icons: {
      height: 24,
      width: 24,
      display: 'block',
      position: 'absolute',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      margin: 12
    },

    leftIcon: {
      left: 4
    },

    rightIcon: {
      right: 4
    },

    avatars: {
      position: 'absolute',
      top: singleAvatar ? 8 : 16
    },

    label: {
      cursor: 'pointer'
    },

    leftAvatar: {
      left: 16
    },

    rightAvatar: {
      right: 16
    },

    leftCheckbox: {
      position: 'absolute',
      display: 'block',
      width: 24,
      top: twoLine ? 24 : singleAvatar ? 16 : 12,
      left: 16
    },

    primaryText: {},

    rightIconButton: {
      position: 'absolute',
      display: 'block',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      right: 4
    },

    rightToggle: {
      position: 'absolute',
      display: 'block',
      width: 54,
      top: twoLine ? 25 : singleAvatar ? 17 : 13,
      right: 8
    },

    secondaryText: {
      fontSize: 14,
      lineHeight: threeLine ? '18px' : '16px',
      height: threeLine ? 36 : 16,
      margin: 0,
      marginTop: 4,
      color: listItem.secondaryTextColor,

      // needed for 2 and 3 line ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: threeLine ? null : 'nowrap',
      display: threeLine ? '-webkit-box' : null,
      WebkitLineClamp: threeLine ? 2 : null,
      WebkitBoxOrient: threeLine ? 'vertical' : null
    }
  };

  return styles;
}

var ListItem = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      open: false,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchTap = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (_this.props.primaryTogglesNestedList) {
        _this.handleNestedListToggle(event);
      }
    }, _this.handleNestedListToggle = function (event) {
      if (_this.props.leftCheckbox) {
        event.preventDefault();
      }
      event.stopPropagation();

      if (_this.props.open === null) {
        _this.setState({ open: !_this.state.open }, function () {
          _this.props.onNestedListToggle(_this);
        });
      } else {
        // Exposing `this` in the callback is quite a bad API.
        // I'm doing a one level deep clone to expose a fake state.open.
        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
          state: {
            open: !_this.state.open
          }
        }));
      }
    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
      if (isKeyboardFocused) {
        _this.setState({
          isKeyboardFocused: false,
          rightIconButtonKeyboardFocused: isKeyboardFocused
        });
      }

      var iconButton = _this.props.rightIconButton;

      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleRightIconButtonMouseLeave = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: false });
      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
    }, _this.handleRightIconButtonMouseEnter = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: true });
      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
    }, _this.handleRightIconButtonMouseUp = function (event) {
      var iconButton = _this.props.rightIconButton;
      event.stopPropagation();
      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
    }, _this.handleRightIconButtonTouchTap = function (event) {
      var iconButton = _this.props.rightIconButton;

      // Stop the event from bubbling up to the list-item
      event.stopPropagation();
      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _this.handleTouchEnd = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchEnd(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.open !== null) this.setState({ open: nextProps.open });
      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }

    // This method is needed by the `MenuItem` component.

  }, {
    key: 'applyFocusState',
    value: function applyFocusState(focusState) {
      if (this.button) {
        var buttonEl = _reactDom2.default.findDOMNode(this.button);

        switch (focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            this.button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  }, {
    key: 'createDisabledElement',
    value: function createDisabledElement(styles, contentChildren, additionalProps) {
      var _props = this.props,
          innerDivStyle = _props.innerDivStyle,
          style = _props.style;


      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createLabelElement',
    value: function createLabelElement(styles, contentChildren, additionalProps) {
      var _props2 = this.props,
          innerDivStyle = _props2.innerDivStyle,
          style = _props2.style;


      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

      return _react2.default.createElement(
        'label',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createTextElement',
    value: function createTextElement(styles, data, key) {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      if (_react2.default.isValidElement(data)) {
        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
        if (typeof data.type === 'string') {
          // if element is a native dom node
          style = prepareStyles(style);
        }
        return _react2.default.cloneElement(data, {
          key: key,
          style: style
        });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: prepareStyles(styles) },
        data
      );
    }
  }, {
    key: 'pushElement',
    value: function pushElement(children, element, baseStyles, additionalProps) {
      if (element) {
        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
          key: children.length,
          style: styles
        }, additionalProps)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          hoverColor = _props3.hoverColor,
          initiallyOpen = _props3.initiallyOpen,
          innerDivStyle = _props3.innerDivStyle,
          insetChildren = _props3.insetChildren,
          leftAvatar = _props3.leftAvatar,
          leftCheckbox = _props3.leftCheckbox,
          leftIcon = _props3.leftIcon,
          nestedItems = _props3.nestedItems,
          nestedLevel = _props3.nestedLevel,
          nestedListStyle = _props3.nestedListStyle,
          onKeyboardFocus = _props3.onKeyboardFocus,
          isKeyboardFocused = _props3.isKeyboardFocused,
          onMouseEnter = _props3.onMouseEnter,
          onMouseLeave = _props3.onMouseLeave,
          onNestedListToggle = _props3.onNestedListToggle,
          onTouchStart = _props3.onTouchStart,
          onClick = _props3.onClick,
          rightAvatar = _props3.rightAvatar,
          rightIcon = _props3.rightIcon,
          rightIconButton = _props3.rightIconButton,
          rightToggle = _props3.rightToggle,
          primaryText = _props3.primaryText,
          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
          secondaryText = _props3.secondaryText,
          secondaryTextLines = _props3.secondaryTextLines,
          style = _props3.style,
          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var contentChildren = [children];

      if (leftIcon) {
        var additionalProps = {
          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
        };
        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
      }

      if (rightIcon) {
        var _additionalProps = {
          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
        };
        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
      }

      if (leftAvatar) {
        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
      }

      if (rightAvatar) {
        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
      }

      if (leftCheckbox) {
        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
      }

      // RightIconButtonElement
      var hasNestListItems = nestedItems.length;
      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

      if (rightIconButton || needsNestedIndicator) {
        var rightIconButtonElement = rightIconButton;
        var rightIconButtonHandlers = {
          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
          onMouseEnter: this.handleRightIconButtonMouseEnter,
          onMouseLeave: this.handleRightIconButtonMouseLeave,
          onClick: this.handleRightIconButtonTouchTap,
          onMouseDown: this.handleRightIconButtonMouseUp,
          onMouseUp: this.handleRightIconButtonMouseUp
        };

        // Create a nested list indicator icon if we don't have an icon on the right
        if (needsNestedIndicator) {
          rightIconButtonElement = this.state.open ? _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandLess2.default, null)
          ) : _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandMore2.default, null)
          );
          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
        }

        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
      }

      if (rightToggle) {
        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
      }

      if (primaryText) {
        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
        contentChildren.push(primaryTextElement);
      }

      if (secondaryText) {
        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
        contentChildren.push(secondaryTextElement);
      }

      var nestedList = nestedItems.length ? _react2.default.createElement(
        _NestedList2.default,
        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
        nestedItems
      ) : undefined;

      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);

      return _react2.default.createElement(
        'div',
        null,
        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({
            containerElement: containerElement
          }, other, {
            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
            onKeyboardFocus: this.handleKeyboardFocus,
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onClick: this.handleTouchTap,
            disabled: disabled,
            ref: function ref(node) {
              return _this2.button = node;
            },
            style: (0, _simpleAssign2.default)({}, styles.root, style)
          }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
            contentChildren
          )
        ),
        nestedList
      );
    }
  }]);
  return ListItem;
}(_react.Component);

ListItem.muiName = 'ListItem';
ListItem.defaultProps = {
  autoGenerateNestedIndicator: true,
  containerElement: 'span',
  disableKeyboardFocus: false,
  disabled: false,
  initiallyOpen: false,
  insetChildren: false,
  nestedItems: [],
  nestedLevel: 0,
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onNestedListToggle: function onNestedListToggle() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {},
  open: null,
  primaryTogglesNestedList: false,
  secondaryTextLines: 1
};
ListItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ListItem.propTypes =  false ? {
  /**
   * If true, generate a nested-list-indicator icon when nested list
   * items are detected. Note that an indicator will not be created
   * if a `rightIcon` or `rightIconButton` has been provided to
   * the element.
   */
  autoGenerateNestedIndicator: _propTypes2.default.bool,
  /**
   * Children passed into the `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * The element to use as the container for the ListItem. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * ListItem in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element will not be able to be focused by the keyboard.
   */
  disableKeyboardFocus: _propTypes2.default.bool,
  /**
   * If true, the element will not be clickable
   * and will not display hover effects.
   * This is automatically disabled if either `leftCheckbox`
   * or `rightToggle` is set.
   */
  disabled: _propTypes2.default.bool,
  /**
  * Override the hover background color.
  */
  hoverColor: _propTypes2.default.string,
  /**
   * If true, the nested `ListItem`s are initially displayed.
   */
  initiallyOpen: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner div element.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * Use to control if the list item should render as keyboard focused.  If
   * undefined (default), this will be automatically managed.  If provided,
   * it will change the components style.  Note that this will not change the
   * actual focus - and should only be used when you want to simulate
   * keyboard focus (eg. in a rich text input autocomplete).
   */
  isKeyboardFocused: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the left side.
   */
  leftAvatar: _propTypes2.default.element,
  /**
   * This is the `Checkbox` element to be displayed on the left side.
   */
  leftCheckbox: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * An array of `ListItem`s to nest underneath the current `ListItem`.
   */
  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Controls how deep a `ListItem` appears.
   * This property is automatically managed, so modify at your own risk.
   */
  nestedLevel: _propTypes2.default.number,
  /**
   * Override the inline-styles of the nested items' `NestedList`.
   */
  nestedListStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the list item is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the list item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` toggles its nested list.
   *
   * @param {object} listItem The `ListItem`.
   */
  onNestedListToggle: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Control toggle state of nested list.
   */
  open: _propTypes2.default.bool,
  /**
   * This is the block element that contains the primary text.
   * If a string is passed in, a div tag will be rendered.
   */
  primaryText: _propTypes2.default.node,
  /**
   * If true, clicking or tapping the primary text of the `ListItem`
   * toggles the nested list.
   */
  primaryTogglesNestedList: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the right side.
   */
  rightAvatar: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * This is the `IconButton` to be displayed on the right side.
   * Hovering over this button will remove the `ListItem` hover.
   * Also, clicking on this button will not trigger a
   * ripple on the `ListItem`; the event will be stopped and prevented
   * from bubbling up to cause a `ListItem` click.
   */
  rightIconButton: _propTypes2.default.element,
  /**
   * This is the `Toggle` element to display on the right side.
   */
  rightToggle: _propTypes2.default.element,
  /**
   * This is the block element that contains the secondary text.
   * If a string is passed in, a div tag will be rendered.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Can be 1 or 2. This is the number of secondary
   * text lines before ellipsis will show.
   */
  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ListItem;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LinearProgress = __webpack_require__(943);

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LinearProgress2.default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCircle = function FaCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.3 20q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaCircle;
module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCheckCircle = function FaCheckCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaCheckCircle;
module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Snackbar = __webpack_require__(949);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Snackbar2.default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeEdit = function EditorModeEdit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
EditorModeEdit.displayName = 'EditorModeEdit';
EditorModeEdit.muiName = 'SvgIcon';

exports.default = EditorModeEdit;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Checkbox = __webpack_require__(960);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(115);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(113);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(391);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(393);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      position: 'relative',
      overflow: 'visible',
      display: 'table',
      height: 'auto',
      width: '100%'
    },
    input: {
      position: 'absolute',
      cursor: 'inherit',
      pointerEvents: 'all',
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      left: 0,
      boxSizing: 'border-box',
      padding: 0,
      margin: 0
    },
    controls: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    label: {
      float: 'left',
      position: 'relative',
      display: 'block',
      width: 'calc(100% - 60px)',
      lineHeight: '24px',
      color: baseTheme.palette.textColor,
      fontFamily: baseTheme.fontFamily
    },
    wrap: {
      transition: _transitions2.default.easeOut(),
      float: 'left',
      position: 'relative',
      display: 'block',
      flexShrink: 0,
      width: 60 - baseTheme.spacing.desktopGutterLess,
      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
    },
    ripple: {
      color: props.rippleColor || baseTheme.palette.primary1Color,
      height: '200%',
      width: '200%',
      top: -12,
      left: -12
    }
  };
}

var EnhancedSwitch = function (_Component) {
  (0, _inherits3.default)(EnhancedSwitch, _Component);

  function EnhancedSwitch() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedSwitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleChange = function (event) {
      _this.tabPressed = false;
      _this.setState({
        isKeyboardFocused: false
      });

      var isInputChecked = _this.refs.checkbox.checked;

      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
        _this.props.onParentShouldUpdate(isInputChecked);
      }

      if (_this.props.onSwitch) {
        _this.props.onSwitch(event, isInputChecked);
      }
    }, _this.handleKeyDown = function (event) {
      var code = (0, _keycode2.default)(event);

      if (code === 'tab') {
        _this.tabPressed = true;
      }
      if (_this.state.isKeyboardFocused && code === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.refs.touchRipple.start(event);
      }
    }, _this.handleMouseUp = function () {
      _this.refs.touchRipple.end();
    }, _this.handleMouseLeave = function () {
      _this.refs.touchRipple.end();
    }, _this.handleTouchStart = function (event) {
      _this.refs.touchRipple.start(event);
    }, _this.handleTouchEnd = function () {
      _this.refs.touchRipple.end();
    }, _this.handleBlur = function (event) {
      _this.setState({
        isKeyboardFocused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      // setTimeout is needed becuase the focus event fires first
      // Wait so that we can capture if this was a keyboard focus
      // or touch focus
      setTimeout(function () {
        if (_this.tabPressed) {
          _this.setState({
            isKeyboardFocused: true
          });
        }
      }, 150);

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedSwitch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inputNode = this.refs.checkbox;
      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
        this.props.onParentShouldUpdate(inputNode.checked);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasCheckedProp = nextProps.hasOwnProperty('checked');
      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;

      if (hasCheckedProp || hasNewDefaultProp) {
        var switched = nextProps.checked || nextProps.defaultChecked || false;

        this.setState({
          switched: switched
        });

        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
          this.props.onParentShouldUpdate(switched);
        }
      }
    }
  }, {
    key: 'isSwitched',
    value: function isSwitched() {
      return this.refs.checkbox.checked;
    }

    // no callback here because there is no event

  }, {
    key: 'setSwitched',
    value: function setSwitched(newSwitchedValue) {
      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
        if (this.props.onParentShouldUpdate) {
          this.props.onParentShouldUpdate(newSwitchedValue);
        }
        this.refs.checkbox.checked = newSwitchedValue;
      } else {
         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.checkbox.value;
    }

    // Checkbox inputs only use SPACE to change their state. Using ENTER will
    // update the ui but not the input.


    /**
     * Because both the ripples and the checkbox input cannot share pointer
     * events, the checkbox input takes control of pointer events and calls
     * ripple animations manually.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          value = _props.value,
          checked = _props.checked,
          iconStyle = _props.iconStyle,
          inputStyle = _props.inputStyle,
          inputType = _props.inputType,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          onSwitch = _props.onSwitch,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onParentShouldUpdate = _props.onParentShouldUpdate,
          disabled = _props.disabled,
          disableTouchRipple = _props.disableTouchRipple,
          disableFocusRipple = _props.disableFocusRipple,
          className = _props.className,
          rippleColor = _props.rippleColor,
          rippleStyle = _props.rippleStyle,
          style = _props.style,
          switched = _props.switched,
          switchElement = _props.switchElement,
          thumbStyle = _props.thumbStyle,
          trackStyle = _props.trackStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

      if (thumbStyle) {
        wrapStyles.marginLeft /= 2;
        wrapStyles.marginRight /= 2;
      }

      var labelElement = label && _react2.default.createElement(
        'label',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
        label
      );

      var showTouchRipple = !disabled && !disableTouchRipple;
      var showFocusRipple = !disabled && !disableFocusRipple;

      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
        ref: 'touchRipple',
        key: 'touchRipple',
        style: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        centerRipple: true
      });

      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
        key: 'focusRipple',
        innerStyle: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        show: this.state.isKeyboardFocused
      });

      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];

      var touchHandlers = showTouchRipple ? {
        onMouseUp: this.handleMouseUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};

      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
        ref: 'checkbox',
        type: inputType,
        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
        name: name,
        value: value,
        checked: this.state.switched,
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange
      }, touchHandlers));

      // If toggle component (indicated by whether the style includes thumb) manually lay out
      // elements in order to nest ripple elements
      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        switchElement,
        ripples
      ) : _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
        _react2.default.createElement(
          _Paper2.default,
          { style: thumbStyle, zDepth: 1, circle: true },
          ' ',
          ripples,
          ' '
        )
      );

      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
        'div',
        { style: styles.controls },
        switchOrThumbElement,
        labelElement
      ) : _react2.default.createElement(
        'div',
        { style: styles.controls },
        labelElement,
        switchOrThumbElement
      );

      return _react2.default.createElement(
        'div',
        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp
        }),
        inputElement,
        elementsInOrder
      );
    }
  }]);
  return EnhancedSwitch;
}(_react.Component);

EnhancedSwitch.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedSwitch.propTypes =  false ? {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  disableFocusRipple: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  inputStyle: _propTypes2.default.object,
  inputType: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.node,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelStyle: _propTypes2.default.object,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onParentShouldUpdate: _propTypes2.default.func,
  onSwitch: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  rippleColor: _propTypes2.default.string,
  rippleStyle: _propTypes2.default.object,
  style: _propTypes2.default.object,
  switchElement: _propTypes2.default.element.isRequired,
  switched: _propTypes2.default.bool.isRequired,
  thumbStyle: _propTypes2.default.object,
  trackStyle: _propTypes2.default.object,
  value: _propTypes2.default.any
} : {};
exports.default = EnhancedSwitch;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = __webpack_require__(396);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;


  return {
    root: {
      fontWeight: 'normal',
      fontSize: 12,
      paddingLeft: tableHeaderColumn.spacing,
      paddingRight: tableHeaderColumn.spacing,
      height: tableHeaderColumn.height,
      textAlign: 'left',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: tableHeaderColumn.textColor,
      position: 'relative'
    },
    tooltip: {
      boxSizing: 'border-box',
      marginTop: tableHeaderColumn.height / 2
    }
  };
}

var TableHeaderColumn = function (_Component) {
  (0, _inherits3.default)(TableHeaderColumn, _Component);

  function TableHeaderColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeaderColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onMouseEnter = function () {
      if (_this.props.tooltip !== undefined) {
        _this.setState({ hovered: true });
      }
    }, _this.onMouseLeave = function () {
      if (_this.props.tooltip !== undefined) {
        _this.setState({ hovered: false });
      }
    }, _this.onClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.columnNumber);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeaderColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          columnNumber = _props.columnNumber,
          hoverable = _props.hoverable,
          onClick = _props.onClick,
          onHover = _props.onHover,
          onHoverExit = _props.onHoverExit,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipStyle = _props.tooltipStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var handlers = {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onClick: this.onClick
      };

      var tooltipNode = void 0;

      if (tooltip !== undefined) {
        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
          label: tooltip,
          show: this.state.hovered,
          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
        });
      }

      return _react2.default.createElement(
        'th',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, handlers, other),
        tooltipNode,
        children
      );
    }
  }]);
  return TableHeaderColumn;
}(_react.Component);

TableHeaderColumn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableHeaderColumn.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Number to identify the header row. This property
   * is automatically populated when used with TableHeader.
   */
  columnNumber: _propTypes2.default.number,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  hoverable: _propTypes2.default.bool,
  /** @ignore */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  onHover: _propTypes2.default.func,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  onHoverExit: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The string to supply to the tooltip. If not
   * string is supplied no tooltip will be shown.
   */
  tooltip: _propTypes2.default.string,
  /**
   * Additional styling that can be applied to the tooltip.
   */
  tooltipStyle: _propTypes2.default.object
} : {};
exports.default = TableHeaderColumn;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = exports.Tab = undefined;

var _Tab2 = __webpack_require__(966);

var _Tab3 = _interopRequireDefault(_Tab2);

var _Tabs2 = __webpack_require__(967);

var _Tabs3 = _interopRequireDefault(_Tabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tab = _Tab3.default;
exports.Tabs = _Tabs3.default;
exports.default = _Tabs3.default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SelectField = __webpack_require__(973);

var _SelectField2 = _interopRequireDefault(_SelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SelectField2.default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toArray2 = __webpack_require__(394);

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _ClickAwayListener = __webpack_require__(235);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _keycode = __webpack_require__(113);

var _keycode2 = _interopRequireDefault(_keycode);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _List = __webpack_require__(233);

var _List2 = _interopRequireDefault(_List);

var _menuUtils = __webpack_require__(977);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var desktop = props.desktop,
      maxHeight = props.maxHeight,
      width = props.width;
  var muiTheme = context.muiTheme;


  var styles = {
    root: {
      // Nested div because the List scales x faster than it scales y
      zIndex: muiTheme.zIndex.menu,
      maxHeight: maxHeight,
      overflowY: maxHeight ? 'auto' : null
    },
    divider: {
      marginTop: 7,
      marginBottom: 8
    },
    list: {
      display: 'table-cell',
      paddingBottom: desktop ? 16 : 8,
      paddingTop: desktop ? 16 : 8,
      userSelect: 'none',
      width: width
    },
    selectedMenuItem: {
      color: muiTheme.menuItem.selectedTextColor
    }
  };

  return styles;
}

var Menu = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props, context) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));

    _initialiseProps.call(_this);

    var filteredChildren = _this.getFilteredChildren(props.children);
    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);

    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
      props.onMenuItemFocusChange(null, newFocusIndex);
    }
    _this.state = {
      focusIndex: newFocusIndex,
      isKeyboardFocused: props.initiallyKeyboardFocused,
      keyWidth: props.desktop ? 64 : 56
    };

    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
      this.setScollPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedIndex = void 0;
      var filteredChildren = this.getFilteredChildren(nextProps.children);

      if (this.props.multiple !== true) {
        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
      } else {
        selectedIndex = this.state.focusIndex;
      }

      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
        this.props.onMenuItemFocusChange(null, newFocusIndex);
      }
      this.setState({
        focusIndex: newFocusIndex,
        keyWidth: nextProps.desktop ? 64 : 56
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoWidth) this.setWidth();
    }
  }, {
    key: 'getValueLink',


    // Do not use outside of this component, it will be removed once valueLink is deprecated
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'setKeyboardFocused',
    value: function setKeyboardFocused(keyboardFocused) {
      this.setState({
        isKeyboardFocused: keyboardFocused
      });
    }
  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(children) {
      var filteredChildren = [];
      _react2.default.Children.forEach(children, function (child) {
        if (child) {
          filteredChildren.push(child);
        }
      });
      return filteredChildren;
    }
  }, {
    key: 'cloneMenuItem',
    value: function cloneMenuItem(child, childIndex, styles, index) {
      var _this2 = this;

      var childIsDisabled = child.props.disabled;

      var selectedChildStyles = {};
      if (!childIsDisabled) {
        var selected = this.isChildSelected(child, this.props);

        if (selected) {
          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
        }
      }
      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);

      var extraProps = {
        desktop: this.props.desktop,
        style: mergedChildStyles
      };
      if (!childIsDisabled) {
        var isFocused = childIndex === this.state.focusIndex;
        var focusState = 'none';
        if (isFocused) {
          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
        }

        (0, _simpleAssign2.default)(extraProps, {
          focusState: focusState,
          onClick: function onClick(event) {
            _this2.handleMenuItemTouchTap(event, child, index);
            if (child.props.onClick) child.props.onClick(event);
          },
          ref: isFocused ? 'focusedMenuItem' : null
        });
      }
      return _react2.default.cloneElement(child, extraProps);
    }
  }, {
    key: 'decrementKeyboardFocusIndex',
    value: function decrementKeyboardFocusIndex(event) {
      var index = this.state.focusIndex;

      index--;
      if (index < 0) index = 0;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'getMenuItemCount',
    value: function getMenuItemCount(filteredChildren) {
      var menuItemCount = 0;
      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        if (!childIsADivider && !childIsDisabled) menuItemCount++;
      });
      return menuItemCount;
    }
  }, {
    key: 'getLastSelectedIndex',
    value: function getLastSelectedIndex(props, filteredChildren) {
      var _this3 = this;

      var selectedIndex = -1;
      var menuItemIndex = 0;

      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';

        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
        if (!childIsADivider) menuItemIndex++;
      });

      return selectedIndex;
    }
  }, {
    key: 'setFocusIndexStartsWith',
    value: function setFocusIndexStartsWith(event, keys) {
      var foundIndex = -1;
      _react2.default.Children.forEach(this.props.children, function (child, index) {
        if (foundIndex >= 0) {
          return;
        }
        var primaryText = child.props.primaryText;

        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
          foundIndex = index;
        }
      });
      if (foundIndex >= 0) {
        this.setFocusIndex(event, foundIndex, true);
        return true;
      }
      return false;
    }
  }, {
    key: 'handleMenuItemTouchTap',
    value: function handleMenuItemTouchTap(event, item, index) {
      var children = this.props.children;
      var multiple = this.props.multiple;
      var valueLink = this.getValueLink(this.props);
      var menuValue = valueLink.value;
      var itemValue = item.props.value;
      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);

      this.setFocusIndex(event, focusIndex, false);

      if (multiple) {
        menuValue = menuValue || [];

        var itemIndex = menuValue.indexOf(itemValue);

        var _menuValue = menuValue,
            _menuValue2 = (0, _toArray3.default)(_menuValue),
            newMenuValue = _menuValue2.slice(0);

        if (itemIndex === -1) {
          newMenuValue.push(itemValue);
        } else {
          newMenuValue.splice(itemIndex, 1);
        }

        valueLink.requestChange(event, newMenuValue);
      } else if (!multiple && itemValue !== menuValue) {
        valueLink.requestChange(event, itemValue);
      }

      this.props.onItemTouchTap(event, item, index);
    }
  }, {
    key: 'incrementKeyboardFocusIndex',
    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
      var index = this.state.focusIndex;
      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;

      index++;
      if (index > maxIndex) index = maxIndex;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'isChildSelected',
    value: function isChildSelected(child, props) {
      var menuValue = this.getValueLink(props).value;
      var childValue = child.props.value;

      if (props.multiple) {
        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
      } else {
        return child.props.hasOwnProperty('value') && menuValue === childValue;
      }
    }
  }, {
    key: 'setFocusIndex',
    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
      if (this.props.onMenuItemFocusChange) {
        // Do this even if `newIndex === this.state.focusIndex` to allow users
        // to detect up-arrow on the first MenuItem or down-arrow on the last.
        this.props.onMenuItemFocusChange(event, newIndex);
      }
      this.setState({
        focusIndex: newIndex,
        isKeyboardFocused: isKeyboardFocused
      });
    }
  }, {
    key: 'setScollPosition',
    value: function setScollPosition() {
      var desktop = this.props.desktop;
      var focusedMenuItem = this.refs.focusedMenuItem;
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;

        // Make the focused item be the 2nd item in the list the user sees
        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;

        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
      }
    }
  }, {
    key: 'cancelScrollEvent',
    value: function cancelScrollEvent(event) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = _reactDom2.default.findDOMNode(this);
      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
      var elWidth = el.offsetWidth;
      var keyWidth = this.state.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          desktop = _props.desktop,
          disableAutoFocus = _props.disableAutoFocus,
          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          multiple = _props.multiple,
          onItemTouchTap = _props.onItemTouchTap,
          onEscKeyDown = _props.onEscKeyDown,
          onMenuItemFocusChange = _props.onMenuItemFocusChange,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          menuItemStyle = _props.menuItemStyle,
          style = _props.style,
          value = _props.value,
          valueLink = _props.valueLink,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);

      var filteredChildren = this.getFilteredChildren(children);

      var menuItemIndex = 0;
      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
        var childIsDisabled = child.props.disabled;
        var childName = child.type ? child.type.muiName : '';
        var newChild = child;

        switch (childName) {
          case 'MenuItem':
            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
            break;

          case 'Divider':
            newChild = _react2.default.cloneElement(child, {
              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
            });
            break;
        }

        if (childName === 'MenuItem' && !childIsDisabled) {
          menuItemIndex++;
        }

        return newChild;
      });

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.handleKeyDown,
            onWheel: this.handleOnWheel,
            style: prepareStyles(mergedRootStyles),
            ref: 'scrollContainer',
            role: 'presentation'
          },
          _react2.default.createElement(
            _List2.default,
            (0, _extends3.default)({}, other, {
              ref: 'list',
              style: mergedListStyles,
              role: 'menu'
            }),
            newChildren
          )
        )
      );
    }
  }]);
  return Menu;
}(_react.Component);

Menu.defaultProps = {
  autoWidth: true,
  desktop: false,
  disableAutoFocus: false,
  initiallyKeyboardFocused: false,
  maxHeight: null,
  multiple: false,
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  onItemTouchTap: function onItemTouchTap() {},
  onKeyDown: function onKeyDown() {}
};
Menu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleClickAway = function (event) {
    if (event.defaultPrevented) {
      return;
    }

    var focusIndex = _this5.state.focusIndex;

    if (focusIndex < 0) {
      return;
    }

    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var focusedItem = filteredChildren[focusIndex];
    if (focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
      return;
    }

    _this5.setFocusIndex(event, -1, false);
  };

  this.handleKeyDown = function (event) {
    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var key = (0, _keycode2.default)(event);
    switch (key) {
      case 'down':
        event.preventDefault();
        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        break;
      case 'esc':
        _this5.props.onEscKeyDown(event);
        break;
      case 'tab':
        event.preventDefault();
        if (event.shiftKey) {
          _this5.decrementKeyboardFocusIndex(event);
        } else {
          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        }
        break;
      case 'up':
        event.preventDefault();
        _this5.decrementKeyboardFocusIndex(event);
        break;
      default:
        if (key && key.length === 1) {
          var hotKeys = _this5.hotKeyHolder.append(key);
          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
            event.preventDefault();
          }
        }
    }
    _this5.props.onKeyDown(event);
  };

  this.handleOnWheel = function (event) {
    var scrollContainer = _this5.refs.scrollContainer;
    // Only scroll lock if the the Menu is scrollable.
    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;

    var scrollTop = scrollContainer.scrollTop,
        scrollHeight = scrollContainer.scrollHeight,
        clientHeight = scrollContainer.clientHeight;

    var wheelDelta = event.deltaY;
    var isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
      scrollContainer.scrollTop = scrollHeight;
      return _this5.cancelScrollEvent(event);
    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
      scrollContainer.scrollTop = 0;
      return _this5.cancelScrollEvent(event);
    }
  };
};

Menu.propTypes =  false ? {
  /**
   * If true, the width of the menu will be set automatically
   * according to the widths of its children,
   * using proper keyline increments (64px for desktop,
   * 56px otherwise).
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The content of the menu. This is usually used to pass `MenuItem`
   * elements.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the menu item will render with compact desktop styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu will not be auto-focused.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If true, the menu will be keyboard-focused initially.
   */
  initiallyKeyboardFocused: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the menu in pixels. If specified,
   * the menu will be scrollable if it is taller than the provided
   * height.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item with `value` not
   * equal to the current `value` of the menu is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   * @param {any}  value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is focused and the *Esc* key
   * is pressed.
   *
   * @param {object} event `keydown` event targeting the menu.
   */
  onEscKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   * @param {object} menuItem The menu item.
   * @param {number} index The index of the menu item.
   */
  onItemTouchTap: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when the focus on a `MenuItem` is changed.
   * There will be some "duplicate" changes reported if two different
   * focusing event happen, for example if a `MenuItem` is focused via
   * the keyboard and then it is clicked on.
   *
   * @param {object} event The event that triggered the focus change.
   * The event can be null since the focus can be changed for non-event
   * reasons such as prop changes.
   * @param {number} newFocusIndex The index of the newly focused
   * `MenuItem` or `-1` if focus was lost.
   */
  onMenuItemFocusChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   * This component also supports valueLink.
   */
  value: _propTypes2.default.any,
  /**
   * ValueLink for the menu's `value`.
   */
  valueLink: _propTypes2.default.object,
  /**
   * The width of the menu. If not specified, the menu's width
   * will be set according to the widths of its children, using
   * proper keyline increments (64px for desktop, 56px otherwise).
   */
  width: _propTypes4.default.stringOrNumber
} : {};
exports.default = Menu;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(115);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _RenderToLayer = __webpack_require__(980);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _lodash = __webpack_require__(981);

var _lodash2 = _interopRequireDefault(_lodash);

var _PopoverAnimationDefault = __webpack_require__(982);

var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'none'
  }
};

var Popover = function (_Component) {
  (0, _inherits3.default)(Popover, _Component);

  function Popover(props, context) {
    (0, _classCallCheck3.default)(this, Popover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));

    _this.timeout = null;

    _this.renderLayer = function () {
      var _this$props = _this.props,
          animated = _this$props.animated,
          animation = _this$props.animation,
          anchorEl = _this$props.anchorEl,
          anchorOrigin = _this$props.anchorOrigin,
          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
          canAutoPosition = _this$props.canAutoPosition,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose,
          style = _this$props.style,
          targetOrigin = _this$props.targetOrigin,
          useLayerForClickAway = _this$props.useLayerForClickAway,
          scrollableContainer = _this$props.scrollableContainer,
          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);


      var styleRoot = style;

      if (!animated) {
        styleRoot = {
          position: 'fixed',
          zIndex: _this.context.muiTheme.zIndex.popover
        };

        if (!_this.state.open) {
          return null;
        }

        return _react2.default.createElement(
          _Paper2.default,
          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
          children
        );
      }

      var Animation = animation || _PopoverAnimationDefault2.default;

      return _react2.default.createElement(
        Animation,
        (0, _extends3.default)({
          targetOrigin: targetOrigin,
          style: styleRoot
        }, other, {
          open: _this.state.open && !_this.state.closing
        }),
        children
      );
    };

    _this.componentClickAway = function () {
      _this.requestClose('clickAway');
    };

    _this.setPlacement = function (scrolling) {
      if (!_this.state.open) {
        return;
      }

      if (!_this.popoverRefs.layer.getLayer()) {
        return;
      }

      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
      if (!targetEl) {
        return;
      }

      var _this$props2 = _this.props,
          targetOrigin = _this$props2.targetOrigin,
          anchorOrigin = _this$props2.anchorOrigin;

      var anchorEl = _this.props.anchorEl || _this.anchorEl;

      var anchor = _this.getAnchorPosition(anchorEl);
      var target = _this.getTargetPosition(targetEl);

      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };

      if (scrolling && _this.props.autoCloseWhenOffScreen) {
        _this.autoCloseWhenOffScreen(anchor);
      }

      if (_this.props.canAutoPosition) {
        target = _this.getTargetPosition(targetEl); // update as height may have changed
        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }

      targetEl.style.top = targetPosition.top + 'px';
      targetEl.style.left = targetPosition.left + 'px';
      targetEl.style.maxHeight = window.innerHeight + 'px';
    };

    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);

    _this.popoverRefs = {};

    _this.state = {
      open: props.open,
      closing: false
    };
    return _this;
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open === this.props.open) {
        return;
      }

      if (nextProps.open) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
        this.setState({
          open: true,
          closing: false
        });
      } else {
        if (nextProps.animated) {
          if (this.timeout !== null) return;
          this.setState({ closing: true });
          this.timeout = setTimeout(function () {
            _this2.setState({
              open: false
            }, function () {
              _this2.timeout = null;
            });
          }, 500);
        } else {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.placementTimeout);
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleScroll.cancel();

      if (this.placementTimeout) {
        clearTimeout(this.placementTimeout);
        this.placementTimeout = null;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(reason) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(reason);
      }
    }
  }, {
    key: 'getAnchorPosition',
    value: function getAnchorPosition(el) {
      if (!el) {
        el = _reactDom2.default.findDOMNode(this);
      }

      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.offsetWidth,
        height: el.offsetHeight
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    }
  }, {
    key: 'getTargetPosition',
    value: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    }
  }, {
    key: 'autoCloseWhenOffScreen',
    value: function autoCloseWhenOffScreen(anchorPosition) {
      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
        this.requestClose('offScreen');
      }
    }
  }, {
    key: 'getOverlapMode',
    value: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    }
  }, {
    key: 'getPositions',
    value: function getPositions(anchor, target) {
      var a = (0, _extends3.default)({}, anchor);
      var t = (0, _extends3.default)({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    }
  }, {
    key: 'applyAutoPositionIfNeeded',
    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
          positions = _getPositions.positions,
          anchorPos = _getPositions.anchorPos;

      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) {
          targetPosition.top = Math.max(0, newTop);
        } else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) {
            targetPosition.top = Math.max(0, newTop);
          }
        }
      }

      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(0, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) {
            targetPosition.left = Math.max(0, newLeft);
          }
        }
      }

      return targetPosition;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(_reactEventListener2.default, {
          target: this.props.scrollableContainer,
          onScroll: this.handleScroll,
          onResize: this.handleResize
        }),
        _react2.default.createElement(_RenderToLayer2.default, {
          ref: function ref(_ref) {
            return _this3.popoverRefs.layer = _ref;
          },
          open: this.state.open,
          componentClickAway: this.componentClickAway,
          useLayerForClickAway: this.props.useLayerForClickAway,
          render: this.renderLayer
        })
      );
    }
  }]);
  return Popover;
}(_react.Component);

Popover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  autoCloseWhenOffScreen: true,
  canAutoPosition: true,
  onRequestClose: function onRequestClose() {},
  open: false,
  scrollableContainer: 'window',
  style: {
    overflowY: 'auto'
  },
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  useLayerForClickAway: true,
  zDepth: 1
};
Popover.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Popover.propTypes =  false ? {
  /**
   * This is the DOM element that will be used to set the position of the
   * popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it is added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, the popover will hide when the anchor is scrolled off the screen.
   */
  autoCloseWhenOffScreen: _propTypes2.default.bool,
  /**
   * If true, the popover (potentially) ignores `targetOrigin`
   * and `anchorOrigin` to make itself fit on screen,
   * which is useful for mobile devices.
   */
  canAutoPosition: _propTypes2.default.bool,
  /**
   * The content of the popover.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {string} reason The reason for the close request. Possibles values
   * are 'clickAway' and 'offScreen'.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * If true, the popover is visible.
   */
  open: _propTypes2.default.bool,
  /**
   * Represents the parent scrollable container.
   * It can be an element or a string like `window`.
   */
  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying
   * elements, and trigger an `onRequestClose('clickAway')` call.
   */
  useLayerForClickAway: _propTypes2.default.bool,
  /**
   * The zDepth of the popover.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Popover;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Popover = __webpack_require__(418);

var _Popover2 = _interopRequireDefault(_Popover);

var _check = __webpack_require__(984);

var _check2 = _interopRequireDefault(_check);

var _ListItem = __webpack_require__(406);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Menu = __webpack_require__(417);

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nestedMenuStyle = {
  position: 'relative'
};

function getStyles(props, context) {
  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
  var textColor = context.muiTheme.baseTheme.palette.textColor;
  var indent = props.desktop ? 64 : 72;
  var sidePadding = props.desktop ? 24 : 16;

  var styles = {
    root: {
      color: props.disabled ? disabledColor : textColor,
      cursor: props.disabled ? 'default' : 'pointer',
      minHeight: props.desktop ? '32px' : '48px',
      lineHeight: props.desktop ? '32px' : '48px',
      fontSize: props.desktop ? 15 : 16,
      whiteSpace: 'nowrap'
    },

    innerDivStyle: {
      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
      paddingRight: props.rightIcon ? indent : sidePadding,
      paddingBottom: 0,
      paddingTop: 0
    },

    secondaryText: {
      float: 'right'
    },

    leftIconDesktop: {
      margin: 0,
      left: 24,
      top: 4
    },

    rightIconDesktop: {
      margin: 0,
      right: 24,
      top: 4,
      fill: context.muiTheme.menuItem.rightIconDesktopFill
    }
  };

  return styles;
}

var MenuItem = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.cloneMenuItem = function (item) {
      return _react2.default.cloneElement(item, {
        onClick: function onClick(event) {
          if (!item.props.menuItems) {
            _this.handleRequestClose();
          }

          if (item.props.onClick) {
            item.props.onClick(event);
          }
        }
      });
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this)
      });

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleRequestClose = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open && nextProps.focusState === 'none') {
        this.handleRequestClose();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'applyFocusState',
    value: function applyFocusState() {
      this.refs.listItem.applyFocusState(this.props.focusState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          desktop = _props.desktop,
          disabled = _props.disabled,
          focusState = _props.focusState,
          innerDivStyle = _props.innerDivStyle,
          insetChildren = _props.insetChildren,
          leftIcon = _props.leftIcon,
          menuItems = _props.menuItems,
          rightIcon = _props.rightIcon,
          secondaryText = _props.secondaryText,
          style = _props.style,
          animation = _props.animation,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);

      // Left Icon
      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
      if (leftIconElement) {
        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
      }

      // Right Icon
      var rightIconElement = void 0;
      if (rightIcon) {
        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
      }

      // Secondary Text
      var secondaryTextElement = void 0;
      if (secondaryText) {
        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;

        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.secondaryText) },
          secondaryText
        );
      }
      var childMenuPopover = void 0;
      if (menuItems) {
        childMenuPopover = _react2.default.createElement(
          _Popover2.default,
          {
            animation: animation,
            anchorOrigin: anchorOrigin,
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            targetOrigin: targetOrigin,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose
          },
          _react2.default.createElement(
            _Menu2.default,
            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
            _react2.default.Children.map(menuItems, this.cloneMenuItem)
          )
        );
        other.onClick = this.handleTouchTap;
      }

      return _react2.default.createElement(
        _ListItem2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          hoverColor: this.context.muiTheme.menuItem.hoverColor,
          innerDivStyle: mergedInnerDivStyles,
          insetChildren: insetChildren,
          leftIcon: leftIconElement,
          ref: 'listItem',
          rightIcon: rightIconElement,
          role: 'menuitem',
          style: mergedRootStyles
        }),
        children,
        secondaryTextElement,
        childMenuPopover
      );
    }
  }]);
  return MenuItem;
}(_react.Component);

MenuItem.muiName = 'MenuItem';
MenuItem.defaultProps = {
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  checked: false,
  desktop: false,
  disabled: false,
  focusState: 'none',
  insetChildren: false,
  targetOrigin: { horizontal: 'left', vertical: 'top' }
};
MenuItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MenuItem.propTypes =  false ? {
  /**
   * Location of the anchor for the popover of nested `MenuItem`
   * elements.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, a left check mark will be rendered.
   */
  checked: _propTypes2.default.bool,
  /**
   * Elements passed as children to the underlying `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * If true, the menu item will render with compact desktop
   * styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu item will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The focus state of the menu item. This prop is used to set the focus
   * state of the underlying `ListItem`.
   */
  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
  /**
   * Override the inline-styles of the inner div.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented.
   * This is only needed when there is no `leftIcon`.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * `MenuItem` elements to nest within the menu item.
   */
  menuItems: _propTypes2.default.node,
  /**
   * Callback function fired when the menu item is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the menu item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Can be used to render primary text within the menu item.
   */
  primaryText: _propTypes2.default.node,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * Can be used to render secondary text within the menu item.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Location on the popover of nested `MenuItem` elements that will attach
   * to the anchor's origin.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * The value of the menu item.
   */
  value: _propTypes2.default.any
} : {};
exports.default = MenuItem;

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CombatRunSoldierItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombatRunContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Divider__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_List__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var M=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("view.CombatRun");var SM=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("soldiers");var ZM=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("zone");function CombatRunSoldierItemRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{inline:true,error:props});var soldierName=props.soldierName,count=props.count,hp=props.hp,maxHp=props.maxHp,attackPower=props.attackPower;var primaryText=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{textTransform:"capitalize"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"soldier.name",values:{soldier:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SM,{id:soldierName,values:{count:count}}),count:count,countText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:count})}}));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_List__["ListItem"],{primaryText:primaryText,secondaryText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{style:{color:"inherit"}},count===1?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default.a,{mode:"determinate",value:hp,max:maxHp,min:0}):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"soldier.hp",values:{count:count,maxHp:maxHp,maxHpText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:maxHp}),hp:hp,hpText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:hp}),attack:attackPower||0,attackText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:attackPower||0})}}))});}var CombatRunSoldierItem=__WEBPACK_IMPORTED_MODULE_5__swarm2_core__["containers"].combat.CombatRunSoldierItem(CombatRunSoldierItemRender);function CombatRunSoldierList(props){var charId=props.charId,clientNow=props.clientNow,team=props.team,soldiers=props.soldiers,title=props.title,float=props.float;var names=[].concat(_toConsumableArray(soldiers)).reverse();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_List__["List"],{style:{width:"45%",float:float}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_List__["ListItem"],{primaryText:title,disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Divider___default.a,null),names.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatRunSoldierItem,{key:name,soldierName:name,team:team,charId:charId,clientNow:clientNow});}));}function CombatRunContentRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});var charId=props.charId,clientNow=props.clientNow,zone=props.zone,playerSoldiers=props.playerSoldiers,enemySoldiers=props.enemySoldiers,createdAt=props.createdAt,doneAt=props.doneAt,displayName=props.displayName;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{textAlign:"center"}},doneAt?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["b" /* Duration */],{millis:doneAt-createdAt,noSuffix:true}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["d" /* FromNow */],{since:createdAt,noSuffix:true}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatRunSoldierList,{charId:charId,clientNow:clientNow,team:"player",soldiers:playerSoldiers,title:displayName,float:"left"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatRunSoldierList,{charId:charId,clientNow:clientNow,team:"enemy",soldiers:enemySoldiers,title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ZM,{id:zone}),float:"right"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{clear:"both"}}));}// This is for use within CombatResult
var CombatRunContent=__WEBPACK_IMPORTED_MODULE_5__swarm2_core__["containers"].combat.CombatRun(CombatRunContentRender);function CombatRunRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});var zone=props.zone;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"title",values:{zone:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ZM,{id:zone})}})}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatRunContentRender,props));}/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_5__swarm2_core__["containers"].combat.CombatRun(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* DumpProps */](CombatRunRender)));

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFolderShared = function FileFolderShared(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
  );
};
FileFolderShared = (0, _pure2.default)(FileFolderShared);
FileFolderShared.displayName = 'FileFolderShared';
FileFolderShared.muiName = 'SvgIcon';

exports.default = FileFolderShared;

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return url; });
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
//
//
//
// More information:
//
// <!--
//   manifest.json provides metadata used when your web app is added to the
//  homescreen on Android. See https://developers.google.com/web/fundamentals/engage-and-retain/web-app-manifest/
// -->
//
// https://github.com/facebookincubator/create-react-app/releases/tag/v1.0.0
// > progressive web app
//export const url = `${process.env.PUBLIC_URL}/service-worker.js`
var url="/service-worker.js";function register(){if("production"==="production"&&"serviceWorker"in navigator){window.addEventListener("load",function(){navigator.serviceWorker.register(url).then(function(registration){console.log("registerServiceWorker registered");// no update-notifying here. Just making sure the service worker is
// registered first thing, so we can always update it. UpdateButton does
// the real update work.
//registration.onupdatefound = () => {
//  console.log('Found updated content; downloading.');
//  const installingWorker = registration.installing;
//  installingWorker.onstatechange = () => {
//    if (installingWorker.state === 'installed') {
//      if (navigator.serviceWorker.controller) {
//        // At this point, the old content will have been purged and
//        // the fresh content will have been added to the cache.
//        // It's the perfect time to display a "New content is
//        // available; please refresh." message in your web app.
//        console.log('New content is available; please refresh.');
//      } else {
//        // At this point, everything has been precached.
//        // It's the perfect time to display a
//        // "Content is cached for offline use." message.
//        console.log('Content is cached for offline use.');
//      }
//    }
//  };
//};
}).catch(function(error){console.error("Error during service worker registration:",error);});});}}function unregister(){if("serviceWorker"in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NumberFormatChooserRender */
/* unused harmony export NumberFormatChooser */
/* unused harmony export IsDebugChooser */
/* unused harmony export PrereleaseFlagsChooser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_8__common__["k" /* intlMessages */]("view.Options");var enums=["standard","scientific","engineering","longScale"];var enumset=new Set(enums);var NumberFormatChooserRender=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* injectIntl */])(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var numberformat=props.numberformat,setNumberformat=props.setNumberformat,request=props.request,intl=props.intl;numberformat=enumset.has(numberformat)?numberformat:"standard";var ex1=__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:123.456e6});var ex2=__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:123.456e9});var ex3=__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:123.456e36});return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_List__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,{value:numberformat,onChange:function onChange(event,index,value){return setNumberformat(value);},floatingLabelText:intl.formatMessage({id:"view.Options.NumberFormatChooser.title"})},enums.map(function(name){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a,{key:name,value:name,primaryText:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"NumberFormatChooser."+name})});})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,request.status==="pending"?__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["e" /* LoadingSpinner */],{style:{display:"inline"}}):__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"NumberFormatChooser.examples",values:{ex1:ex1,ex2:ex2,ex3:ex3}}),request.status==="error"?JSON.stringify(request):null)));});var NumberFormatChooser=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].options.NumberFormatChooser(NumberFormatChooserRender);var IsDebugChooserRender=function IsDebugChooserRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var isDebug=props.isDebug,setIsDebug=props.setIsDebug,request=props.request;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_List__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default.a,{label:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"IsDebug.title"}),labelPosition:"right",toggled:!!isDebug,onToggle:function onToggle(){return setIsDebug(!isDebug);}})),request.status==="pending"?__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["e" /* LoadingSpinner */],{style:{display:"inline"}}):null,request.status==="error"?JSON.stringify(request):null);};var IsDebugChooser=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].options.IsDebugChooser(IsDebugChooserRender);var PrereleaseFlagsChooserRender=function PrereleaseFlagsChooserRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var prereleaseFlags=props.prereleaseFlags,setPrereleaseFlags=props.setPrereleaseFlags,isVisible=props.isVisible,request=props.request;if(!isVisible)return null;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_List__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default.a,{label:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"PrereleaseFlags.title"}),labelPosition:"right",toggled:!!prereleaseFlags,onToggle:function onToggle(){return setPrereleaseFlags(!prereleaseFlags);}})),request.status==="pending"?__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["e" /* LoadingSpinner */],{style:{display:"inline"}}):null,request.status==="error"?JSON.stringify(request):null);};var PrereleaseFlagsChooser=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].options.PrereleaseFlagsChooser(PrereleaseFlagsChooserRender);var Options=function Options(){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_List__["List"],{className:"view-options"},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](NumberFormatChooser,null),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](IsDebugChooser,null),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](PrereleaseFlagsChooser,null)));};/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVerifiedUser = function ActionVerifiedUser(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
  );
};
ActionVerifiedUser = (0, _pure2.default)(ActionVerifiedUser);
ActionVerifiedUser.displayName = 'ActionVerifiedUser';
ActionVerifiedUser.muiName = 'SvgIcon';

exports.default = ActionVerifiedUser;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(426);
module.exports = __webpack_require__(431);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(427).enable();
  window.Promise = __webpack_require__(429);
}

// fetch() polyfill for making API calls.
__webpack_require__(430);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(117);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(240);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(240);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 430 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__ = __webpack_require__(422);
// Needed for offline loading/progressive webapp.
// https://github.com/facebookincubator/create-react-app/releases/tag/v1.0.0
Object(__WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__["a" /* default */])();var store=Object(__WEBPACK_IMPORTED_MODULE_4__redux__["a" /* createReduxStore */])();var App=Object(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* app */])({store:store});__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(App,null),document.getElementById("root"));

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_decimal_js__ = __webpack_require__(118);
// This ensures all dependencies (that I've written, anyway) use the same
// decimal.js version. Yeah, globals are bad, but this is so much easier than
// wrangling webpack/require, especially since create-react-app restricts what
// config we can change anyway. Immutable globals like this are less bad anyway.
global.Decimal=__WEBPACK_IMPORTED_MODULE_0_decimal_js__["default"];
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
var f=__webpack_require__(117),p=__webpack_require__(241);__webpack_require__(119);var r=__webpack_require__(96);
function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0);__webpack_require__(119);var l=__webpack_require__(435),n=__webpack_require__(117),ba=__webpack_require__(436),ca=__webpack_require__(96),da=__webpack_require__(241),ea=__webpack_require__(120),fa=__webpack_require__(437),ha=__webpack_require__(440),ia=__webpack_require__(441);
function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(96);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(438);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(439);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(242);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });
/* unused harmony reexport default */


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(445), src$en$$ = __webpack_require__(450);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(244), src$es5$$ = __webpack_require__(446), src$compiler$$ = __webpack_require__(447), intl$messageformat$parser$$ = __webpack_require__(448);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(244);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(449)['default'];
exports['default'] = exports;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 451 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(453)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(458);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(454), src$en$$ = __webpack_require__(457);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(243), src$diff$$ = __webpack_require__(455), src$es5$$ = __webpack_require__(456);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(96);
var invariant = __webpack_require__(119);
var ReactPropTypesSecret = __webpack_require__(460);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(462)['default'];
exports['default'] = exports;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__(463);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(163);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(485);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(251);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(473);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(471);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(248);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(475);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(478);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(479);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(60)(module)))

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(249);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(250);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(251);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(486);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(163);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__(265);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(489);
module.exports = __webpack_require__(33).Object.getPrototypeOf;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(98);
var $getPrototypeOf = __webpack_require__(253);

__webpack_require__(254)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(492);
var $Object = __webpack_require__(33).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(70), 'Object', { defineProperty: __webpack_require__(63).f });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(494), __esModule: true };

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
__webpack_require__(176);
module.exports = __webpack_require__(177).f('iterator');


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(170);
var defined = __webpack_require__(165);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(172);
var descriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(175);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(78)(IteratorPrototype, __webpack_require__(40)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63);
var anObject = __webpack_require__(69);
var getKeys = __webpack_require__(101);

module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(81);
var toLength = __webpack_require__(262);
var toAbsoluteIndex = __webpack_require__(499);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(170);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(61).document;
module.exports = document && document.documentElement;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(502);
var step = __webpack_require__(503);
var Iterators = __webpack_require__(80);
var toIObject = __webpack_require__(81);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(258)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(505), __esModule: true };

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(506);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
module.exports = __webpack_require__(33).Symbol;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(61);
var has = __webpack_require__(68);
var DESCRIPTORS = __webpack_require__(70);
var $export = __webpack_require__(62);
var redefine = __webpack_require__(259);
var META = __webpack_require__(507).KEY;
var $fails = __webpack_require__(79);
var shared = __webpack_require__(167);
var setToStringTag = __webpack_require__(175);
var uid = __webpack_require__(121);
var wks = __webpack_require__(40);
var wksExt = __webpack_require__(177);
var wksDefine = __webpack_require__(178);
var enumKeys = __webpack_require__(508);
var isArray = __webpack_require__(509);
var anObject = __webpack_require__(69);
var toIObject = __webpack_require__(81);
var toPrimitive = __webpack_require__(169);
var createDesc = __webpack_require__(100);
var _create = __webpack_require__(172);
var gOPNExt = __webpack_require__(510);
var $GOPD = __webpack_require__(264);
var $DP = __webpack_require__(63);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(263).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(124).f = $propertyIsEnumerable;
  __webpack_require__(179).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(171)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(78)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(121)('meta');
var isObject = __webpack_require__(99);
var has = __webpack_require__(68);
var setDesc = __webpack_require__(63).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(79)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(179);
var pIE = __webpack_require__(124);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(173);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(81);
var gOPN = __webpack_require__(263).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 511 */
/***/ (function(module, exports) {



/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178)('asyncIterator');


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178)('observable');


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(515), __esModule: true };

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(516);
module.exports = __webpack_require__(33).Object.setPrototypeOf;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(62);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(517).set });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(99);
var anObject = __webpack_require__(69);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(168)(Function.call, __webpack_require__(264).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(519), __esModule: true };

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(520);
var $Object = __webpack_require__(33).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(172) });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
__webpack_require__(522);
module.exports = __webpack_require__(33).Array.from;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(168);
var $export = __webpack_require__(62);
var toObject = __webpack_require__(98);
var call = __webpack_require__(523);
var isArrayIter = __webpack_require__(524);
var toLength = __webpack_require__(262);
var createProperty = __webpack_require__(525);
var getIterFn = __webpack_require__(267);

$export($export.S + $export.F * !__webpack_require__(526)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(69);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(80);
var ITERATOR = __webpack_require__(40)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(63);
var createDesc = __webpack_require__(100);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(40)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(60)(module)))

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(126);

var _colorManipulator = __webpack_require__(82);

var _spacing = __webpack_require__(529);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__(532);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(534);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__(539);

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__(548);

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(533);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(269);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(270);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(271);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(180);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(535);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(538);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(180);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(270);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(271);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(269);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(536);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(537)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
      result.android = t
    } else if (!result.windowsphone && !result.msedge && iosdevice) {
      result[iosdevice] = t
      result.ios = t
    } else if (mac) {
      result.mac = t
    } else if (xbox) {
      result.xbox = t
    } else if (windows) {
      result.windows = t
    } else if (linux) {
      result.linux = t
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(540);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(541);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(542);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(543);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(544);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(545);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(546);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(83);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(272);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(549);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(550);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(551);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(552);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(553);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(554);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(555);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(181);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(181);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(272);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(181);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(180);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(182);

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(559);
module.exports = __webpack_require__(33).Object.keys;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(98);
var $keys = __webpack_require__(101);

__webpack_require__(254)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(185);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(183);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(184);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(185);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(183);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(184);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(277);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(102);

var _LocationUtils = __webpack_require__(183);

var _createTransitionManager = __webpack_require__(184);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(276);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(570)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(279);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(280);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(574);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(575);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(576);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(103);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(281);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(187);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(282);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(283);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(128);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(284);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isConnected = exports.sinceServerDeployed = exports.serverDeployedAt = exports.serverShortHash = exports.serverLongHash = exports.serverLongVersion = exports.serverVersion = exports.isEmpty = exports.sinceClientDeployed = exports.isClientDeployed = exports.clientDeployedAt = exports.clientShortHash = exports.clientLongHash = exports.clientLongVersion = exports.clientVersionDate = exports.clientVersion = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _reselect = __webpack_require__(2);

var _Maybe = __webpack_require__(152);

var Maybe = _interopRequireWildcard(_Maybe);

var _package = __webpack_require__(757);

var _package2 = _interopRequireDefault(_package);

var _version = __webpack_require__(758);

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clientVersion = exports.clientVersion = function clientVersion() {
  return _package2.default.version;
};
// core/lib/version.json is some git version info generated by core/version.js
var clientVersionDate = exports.clientVersionDate = function clientVersionDate() {
  return _version2.default.date;
};
var clientLongVersion = exports.clientLongVersion = function clientLongVersion() {
  return _version2.default.longVersion;
};
var clientLongHash = exports.clientLongHash = function clientLongHash() {
  return _version2.default.longHash;
};
var clientShortHash = exports.clientShortHash = function clientShortHash() {
  return _version2.default.shortHash;
};

// this is set by each client when a remote update is detected. It's usually
// null, when we're playing the latest known version.
var clientDeployedAt = exports.clientDeployedAt = function clientDeployedAt(state, props) {
  return props.clientDeployedAt != null ? Maybe.of(props.clientDeployedAt) : Maybe.Nothing;
};
var isClientDeployed = exports.isClientDeployed = (0, _reselect.createSelector)(clientDeployedAt, Maybe.isJust);
var sinceClientDeployed = exports.sinceClientDeployed = (0, _reselect.createSelector)(Now.now, clientDeployedAt, function (now, at) {
  return Maybe.map(function (at) {
    return Util.Duration.since(now, at);
  }, at);
});

var localState = (0, _queryStatus.selectPath)(paths.appInfo.data);
var isEmpty = exports.isEmpty = _queryStatus.selectPath.isEmpty(paths.appInfo.data);
var serverVersion = exports.serverVersion = (0, _reselect.createSelector)(localState, function (state) {
  return state.version;
});
var serverLongVersion = exports.serverLongVersion = (0, _reselect.createSelector)(localState, function (state) {
  return state.longVersion;
});
var serverLongHash = exports.serverLongHash = (0, _reselect.createSelector)(localState, function (state) {
  return state.longHash;
});
var serverShortHash = exports.serverShortHash = (0, _reselect.createSelector)(localState, function (state) {
  return state.shortHash;
});
var serverDeployedAt = exports.serverDeployedAt = (0, _reselect.createSelector)(localState, function (state) {
  return Util.Timestamp.wrap(state.lastDeployedAt);
});
var sinceServerDeployed = exports.sinceServerDeployed = (0, _reselect.createSelector)(Now.now, serverDeployedAt, Util.Duration.since);

var isConnected = exports.isConnected = (0, _queryStatus.selectPath)(paths.connected.data);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJ0eXBlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Duration = exports.Timestamp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _flowClassyTypeWrapper = __webpack_require__(188);

var _assert = __webpack_require__(12);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Defining this as a map allows flow to use $Keys, instead of repeating the
// list of keys, so flow catches misspellings. Trade-off: we have to list the
// month-numbers that should rightfully come from array indexes. Worth it.
var months = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11
};

function monthNum(month) {
  (0, _assert.assert)(month in months, "no such month", month, months);
  return months[month];
}

var Timestamp = exports.Timestamp = function (_TypeWrapper) {
  _inherits(Timestamp, _TypeWrapper);

  function Timestamp() {
    _classCallCheck(this, Timestamp);

    return _possibleConstructorReturn(this, (Timestamp.__proto__ || Object.getPrototypeOf(Timestamp)).apply(this, arguments));
  }

  _createClass(Timestamp, null, [{
    key: "isBefore",
    value: function isBefore(now, before) {
      return Timestamp.unwrap(now) < Timestamp.unwrap(before);
    }
  }, {
    key: "isAfter",
    value: function isAfter(now, after) {
      return Timestamp.unwrap(now) > Timestamp.unwrap(after);
    }
  }, {
    key: "isEqual",
    value: function isEqual(a, b) {
      return Timestamp.unwrap(a) === Timestamp.unwrap(b);
    }
  }, {
    key: "add",
    value: function add(now, dur) {
      return Timestamp.wrap(Timestamp.unwrap(now) + Duration.millis.to(dur));
    }
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/UTC
    // it's way too easy to mess up zero-based months, so insist on an unambiguous
    // string. Otherwise, this is similar to Date.UTC().

  }, {
    key: "UTC",
    value: function UTC(year, month) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var ret = Date.UTC.apply(Date, [year, monthNum(month)].concat(args));
      (0, _assert.assert)(!isNaN(ret), "invalid date", { year: year, month: month, args: args, ret: ret });
      return Timestamp.wrap(ret);
    }
  }, {
    key: "max",
    value: function max() {
      for (var _len2 = arguments.length, ds = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        ds[_key2] = arguments[_key2];
      }

      return Timestamp.wrap(Math.max.apply(Math, _toConsumableArray(ds.map(Timestamp.unwrap))));
    }
  }, {
    key: "min",
    value: function min() {
      for (var _len3 = arguments.length, ds = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        ds[_key3] = arguments[_key3];
      }

      return Timestamp.wrap(Math.min.apply(Math, _toConsumableArray(ds.map(Timestamp.unwrap))));
    }
  }]);

  return Timestamp;
}(_flowClassyTypeWrapper.TypeWrapper);

// ideally flow would catch every instance of this, but I want to be damn sure


function diff(now, before) {
  (0, _assert.assert)(now != null, "Duration.since: null now", { now: now, before: before });
  (0, _assert.assert)(before != null, "Duration.since: null before", { now: now, before: before });
  return Timestamp.unwrap(now) - Timestamp.unwrap(before);
}

var Duration = exports.Duration = function (_TypeWrapper2) {
  _inherits(Duration, _TypeWrapper2);

  function Duration() {
    _classCallCheck(this, Duration);

    return _possibleConstructorReturn(this, (Duration.__proto__ || Object.getPrototypeOf(Duration)).apply(this, arguments));
  }

  _createClass(Duration, null, [{
    key: "since",

    // If 'before' is in fact after 'now', it's nice to round to 0 sometimes.
    // This can happen due to clock skew - we receive a time from the server
    // that's later than the server-time calculated by the client.
    // serverTimeOffset tries to compensate for that skew, but it's not exact, so
    // this function ignores what it misses.
    value: function since(now, before) {
      return Duration.millis.from(Math.max(0, diff(now, before)));
    }
  }, {
    key: "until",
    value: function until(now, after) {
      return Duration.millis.from(Math.max(0, diff(after, now)));
    }
    // When before should never be after now, rounding to zero is inappropriate.

  }, {
    key: "sinceStrict",
    value: function sinceStrict(now, before) {
      var dt = diff(now, before);
      (0, _assert.assert)(dt >= 0, "Duration.sinceStrict is negative", { now: now, before: before, dt: dt });
      return Duration.millis.from(dt);
    }
    // When it's totally normal and fine for before to be after.

  }, {
    key: "sinceNeg",
    value: function sinceNeg(now, beforeOrAfter) {
      return Duration.millis.from(diff(now, beforeOrAfter));
    }
  }, {
    key: "max",
    value: function max() {
      var _Duration$millis;

      for (var _len4 = arguments.length, ds = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        ds[_key4] = arguments[_key4];
      }

      return (_Duration$millis = Duration.millis).maps.apply(_Duration$millis, [Math.max].concat(ds));
    }
  }, {
    key: "min",
    value: function min() {
      var _Duration$millis2;

      for (var _len5 = arguments.length, ds = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        ds[_key5] = arguments[_key5];
      }

      return (_Duration$millis2 = Duration.millis).maps.apply(_Duration$millis2, [Math.min].concat(ds));
    }
  }, {
    key: "times",
    value: function times(d, n) {
      return Duration.millis.map(function (ms) {
        return ms * n;
      }, d);
    }
  }]);

  return Duration;
}(_flowClassyTypeWrapper.TypeWrapper);

Duration.millis = durationUnit(
// Duration.wrap/unwrap don't exist when this is instantiated, so can't pass
// them directly without a wrapper fn. Sigh.
function (sec) {
  return Duration.wrap(sec);
}, function (dur) {
  return Duration.unwrap(dur);
});
Duration.seconds = durationUnit(function (sec) {
  return Duration.millis.from(sec * 1000);
}, function (dur) {
  return Duration.millis.to(dur) / 1000;
});
Duration.minutes = durationUnit(function (sec) {
  return Duration.seconds.from(sec * 60);
}, function (dur) {
  return Duration.seconds.to(dur) / 60;
});

function durationUnit(from, to) {
  return {
    from: from,
    to: to,
    map: function map(fn, dur) {
      return this.from(fn(this.to(dur)));
    },
    map2: function map2(fn, dur1, dur2) {
      return this.from(fn(this.to(dur1), this.to(dur2)));
    },
    maps: function maps(fn) {
      var _this3 = this;

      for (var _len6 = arguments.length, durs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        durs[_key6 - 1] = arguments[_key6];
      }

      var nums = durs.map(function (dur) {
        return _this3.to(dur);
      });
      return this.from(fn.apply(undefined, _toConsumableArray(nums)));
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dispatchPromise;
function dispatchPromise(type, dispatch, promise) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  dispatch({ type: type, status: "pending", params: params });
  return promise.then(function (result) {
    return (
      // $FlowFixMe no clue how to type promises properly
      dispatch({ type: type, status: "success", result: result, params: params })
    );
  }, function (error) {
    return (
      // $FlowFixMe no clue how to type promises properly
      dispatch({ type: type, status: "error", error: error, params: params })
    );
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvdXRpbC9kaXNwYXRjaC1wcm9taXNlLmpzIl0sIm5hbWVzIjpbImRpc3BhdGNoUHJvbWlzZSIsInR5cGUiLCJkaXNwYXRjaCIsInByb21pc2UiLCJwYXJhbXMiLCJzdGF0dXMiLCJ0aGVuIiwicmVzdWx0IiwiZXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUV3QkEsZTtBQUFULFNBQVNBLGVBQVQsQ0FDYkMsSUFEYSxFQUViQyxRQUZhLEVBR2JDLE9BSGEsRUFLRDtBQUFBLE1BRFpDLE1BQ1ksdUVBREUsRUFDRjs7QUFDWkYsV0FBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsU0FBZixFQUEwQkQsY0FBMUIsRUFBVDtBQUNBLFNBQU9ELFFBQVFHLElBQVIsQ0FDTDtBQUFBO0FBQ0U7QUFDQUosZUFBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsU0FBZixFQUEwQkUsY0FBMUIsRUFBa0NILGNBQWxDLEVBQVQ7QUFGRjtBQUFBLEdBREssRUFJTDtBQUFBO0FBQ0U7QUFDQUYsZUFBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsT0FBZixFQUF3QkcsWUFBeEIsRUFBK0JKLGNBQS9CLEVBQVQ7QUFGRjtBQUFBLEdBSkssQ0FBUDtBQVFEIiwiZmlsZSI6ImRpc3BhdGNoLXByb21pc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkaXNwYXRjaFByb21pc2U8VD4oXG4gIHR5cGU6IHN0cmluZyxcbiAgZGlzcGF0Y2g6ICh7fSkgPT4gdm9pZCxcbiAgcHJvbWlzZTogUHJvbWlzZTxUPixcbiAgcGFyYW1zOiA/e30gPSB7fSxcbik6IFByb21pc2U8VD4ge1xuICBkaXNwYXRjaCh7dHlwZSwgc3RhdHVzOiBcInBlbmRpbmdcIiwgcGFyYW1zfSlcbiAgcmV0dXJuIHByb21pc2UudGhlbihcbiAgICByZXN1bHQgPT5cbiAgICAgIC8vICRGbG93Rml4TWUgbm8gY2x1ZSBob3cgdG8gdHlwZSBwcm9taXNlcyBwcm9wZXJseVxuICAgICAgZGlzcGF0Y2goe3R5cGUsIHN0YXR1czogXCJzdWNjZXNzXCIsIHJlc3VsdCwgcGFyYW1zfSksXG4gICAgZXJyb3IgPT5cbiAgICAgIC8vICRGbG93Rml4TWUgbm8gY2x1ZSBob3cgdG8gdHlwZSBwcm9taXNlcyBwcm9wZXJseVxuICAgICAgZGlzcGF0Y2goe3R5cGUsIHN0YXR1czogXCJlcnJvclwiLCBlcnJvciwgcGFyYW1zfSksXG4gIClcbn1cbiJdfQ==

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(84);

var _createFirestoreInstance = __webpack_require__(286);

exports.default = function (firebaseInstance, otherConfig) {
  return function (next) {
    return function (reducer, initialState, middleware) {
      var store = next(reducer, initialState, middleware);

      var configs = _extends({}, _constants.defaultConfig, otherConfig);

      firebaseInstance = (0, _createFirestoreInstance.createFirestoreInstance)(firebaseInstance.firebase_ || firebaseInstance, configs, store.dispatch);

      store.firestore = _extends({}, firebaseInstance, { _: { config: configs } });

      return store;
    };
  };
};

module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firestoreActions = undefined;

var _firestore = __webpack_require__(587);

var firestoreActions = _interopRequireWildcard(_firestore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.firestoreActions = firestoreActions;
exports.default = { firestoreActions: firestoreActions };

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetListeners = exports.unsetListener = exports.setListeners = exports.setListener = exports.onSnapshot = exports.update = exports.get = exports.set = exports.add = undefined;

var _lodash = __webpack_require__(3);

var _actions = __webpack_require__(588);

var _constants = __webpack_require__(84);

var _query = __webpack_require__(589);

var add = exports.add = function add(firebase, dispatch, queryOption) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var _getQueryConfig = (0, _query.getQueryConfig)(queryOption),
      collection = _getQueryConfig.collection,
      doc = _getQueryConfig.doc;

  return (0, _actions.wrapInDispatch)(dispatch, {
    ref: (0, _query.firestoreRef)(firebase, dispatch, { collection: collection, doc: doc }),
    method: 'add',
    collection: collection,
    doc: doc,
    args: args,
    types: [_constants.actionTypes.ADD_REQUEST, _constants.actionTypes.ADD_SUCCESS, _constants.actionTypes.ADD_FAILURE]
  });
};

var set = exports.set = function set(firebase, dispatch, queryOption) {
  for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  var _getQueryConfig2 = (0, _query.getQueryConfig)(queryOption),
      collection = _getQueryConfig2.collection,
      doc = _getQueryConfig2.doc;

  return (0, _actions.wrapInDispatch)(dispatch, {
    ref: (0, _query.firestoreRef)(firebase, dispatch, { collection: collection, doc: doc }),
    method: 'set',
    args: args,
    types: [_constants.actionTypes.SET_REQUEST, _constants.actionTypes.SET_SUCCESS, _constants.actionTypes.SET_FAILURE]
  });
};

var get = exports.get = function get(firebase, dispatch, queryOption) {
  var _getQueryConfig3 = (0, _query.getQueryConfig)(queryOption),
      collection = _getQueryConfig3.collection,
      doc = _getQueryConfig3.doc;

  return (0, _actions.wrapInDispatch)(dispatch, {
    ref: (0, _query.firestoreRef)(firebase, dispatch, { collection: collection, doc: doc }),
    method: 'get',
    collection: collection,
    doc: doc,
    types: [_constants.actionTypes.GET_REQUEST, {
      type: _constants.actionTypes.GET_SUCCESS,
      payload: function payload(snap) {
        var ordered = (0, _query.orderedFromSnap)(snap);
        var data = (0, _query.dataByIdSnapshot)(snap);
        return { data: data, ordered: ordered };
      }
    }, _constants.actionTypes.GET_FAILURE]
  });
};

var update = exports.update = function update(firebase, dispatch, queryOption) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var _getQueryConfig4 = (0, _query.getQueryConfig)(queryOption),
      collection = _getQueryConfig4.collection,
      doc = _getQueryConfig4.doc;

  return (0, _actions.wrapInDispatch)(dispatch, {
    ref: (0, _query.firestoreRef)(firebase, dispatch, { collection: collection, doc: doc }),
    method: 'update',
    collection: collection,
    doc: doc,
    args: args,
    types: [_constants.actionTypes.UPDATE_REQUEST, _constants.actionTypes.UPDATE_SUCCESS, _constants.actionTypes.UPDATE_FAILURE]
  });
};

var onSnapshot = exports.onSnapshot = function onSnapshot(firebase, dispatch, _ref, successCb, errorCb) {
  var collection = _ref.collection,
      doc = _ref.doc;

  var query = firebase.firestore().collection(collection);
  var unsubscribe = doc ? query.doc(doc) : query.onSnapshot(function (docData) {
    dispatch({
      type: _constants.actionTypes.LISTENER_RESPONSE,
      meta: { collection: collection, doc: doc },
      payload: {
        data: (0, _query.dataByIdSnapshot)(docData),
        ordered: (0, _query.orderedFromSnap)(docData)
      }
    });
    if (successCb) {
      successCb(docData);
    }
  }, function (err) {
    dispatch({
      type: _constants.actionTypes.ON_SNAPSHOT_ERROR,
      meta: { collection: collection, doc: doc },
      payload: err
    });
    if (errorCb) {
      errorCb(err);
    }
  });
  (0, _query.attachListener)(firebase, dispatch, { collection: collection, doc: doc }, unsubscribe);
};

var setListener = exports.setListener = function setListener(firebase, dispatch, queryOpts) {
  var _getQueryConfigs = (0, _query.getQueryConfigs)(queryOpts),
      collection = _getQueryConfigs.collection,
      doc = _getQueryConfigs.doc;

  var unsubscribe = (0, _query.firestoreRef)(firebase, dispatch, { collection: collection, doc: doc }).onSnapshot(function (docData) {
    dispatch({
      type: _constants.actionTypes.LISTENER_RESPONSE,
      meta: { collection: collection, doc: doc },
      payload: {
        data: (0, _query.dataByIdSnapshot)(docData),
        ordered: (0, _query.orderedFromSnap)(docData)
      }
    });
  }, function (err) {
    dispatch({
      type: _constants.actionTypes.ON_SNAPSHOT_ERROR,
      meta: { collection: collection, doc: doc },
      payload: err
    });
  });
  (0, _query.attachListener)(firebase, dispatch, { collection: collection, doc: doc }, unsubscribe);
};

var setListeners = exports.setListeners = function setListeners(firebase, dispatch, listeners) {
  if (!(0, _lodash.isArray)(listeners)) {
    throw new Error('Listeners must be an Array of listener configs (Strings/Objects)');
  }
  return listeners.map(function (listener) {
    return setListener(firebase, dispatch, listener);
  });
};

var unsetListener = exports.unsetListener = function unsetListener(firebase, dispatch, opts) {
  return (0, _query.detachListener)(firebase, dispatch, (0, _query.getQueryConfigs)(opts));
};

var unsetListeners = exports.unsetListeners = function unsetListeners(firebase, dispatch, listeners) {
  if (!(0, _lodash.isArray)(listeners)) {
    throw new Error('Listeners must be an Array of listener configs (Strings/Objects)');
  }
  return listeners.map(function (listener) {
    return unsetListener(firebase, dispatch, listener);
  });
};

exports.default = {
  get: get,
  firestoreRef: _query.firestoreRef,
  add: add,
  update: update,
  onSnapshot: onSnapshot,
  setListener: setListener,
  setListeners: setListeners,
  unsetListener: unsetListener,
  unsetListeners: unsetListeners
};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapInDispatch = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lodash = __webpack_require__(3);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var wrapInDispatch = exports.wrapInDispatch = function wrapInDispatch(dispatch, _ref) {
  var ref = _ref.ref,
      collection = _ref.collection,
      doc = _ref.doc,
      method = _ref.method,
      args = _ref.args,
      types = _ref.types;

  var _types = _slicedToArray(types, 3),
      requestingType = _types[0],
      successType = _types[1],
      errorType = _types[2];

  dispatch({
    type: (0, _lodash.isObject)(requestingType) ? requestingType.type : requestingType,
    payload: (0, _lodash.isObject)(requestingType) ? requestingType.payload : { args: args }
  });
  var methodPromise = args && args.length ? ref[method].apply(ref, _toConsumableArray(args)) : ref[method]();
  return methodPromise.then(function (val) {
    var makePayload = function makePayload(_ref2) {
      var payload = _ref2.payload;
      return (0, _lodash.isFunction)(payload) ? payload(val) : payload;
    };
    dispatch({
      type: (0, _lodash.isObject)(successType) ? successType.type : successType,
      collection: collection,
      doc: doc,
      payload: (0, _lodash.isObject)(successType) ? makePayload(successType) : { args: args }
    });
    return val;
  }).catch(function (err) {
    dispatch({
      type: errorType,
      payload: err
    });
    return Promise.reject(err);
  });
};

exports.default = { wrapInDispatch: wrapInDispatch };

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataByIdSnapshot = exports.orderedFromSnap = exports.getQueryConfigs = exports.getQueryConfig = exports.detachListener = exports.attachListener = exports.firestoreRef = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(3);

var _constants = __webpack_require__(84);

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var firestoreRef = exports.firestoreRef = function firestoreRef(firebase, dispatch, _ref) {
  var collection = _ref.collection,
      doc = _ref.doc;

  if (!firebase.firestore) {
    throw new Error('Firestore must be required and initalized.');
  }
  var ref = firebase.firestore().collection(collection);
  return doc ? ref.doc(doc) : ref;
};

var attachListener = exports.attachListener = function attachListener(firebase, dispatch, _ref2, unsubscribe) {
  var collection = _ref2.collection,
      doc = _ref2.doc;

  var name = doc ? collection + '/' + doc : collection;
  if (!firebase._.listeners[name]) {
    firebase._.listeners[name] = unsubscribe;
  } else {
    console.warn('Listener already exists for ' + name);
  }

  dispatch({
    type: _constants.actionTypes.SET_LISTENER,
    meta: { collection: collection, doc: doc },
    payload: { name: name }
  });

  return firebase._.listeners;
};

var detachListener = exports.detachListener = function detachListener(firebase, dispatch, _ref3) {
  var collection = _ref3.collection,
      doc = _ref3.doc;

  var name = doc ? collection + '/' + doc : collection;
  if (firebase._.listeners[name]) {
    firebase._.listeners[name]();
  } else {
    console.warn('Listener does not exist for ' + name);
  }

  dispatch({
    type: _constants.actionTypes.UNSET_LISTENER,
    meta: { collection: collection, doc: doc },
    payload: { name: name }
  });
};

var queryStrToObj = function queryStrToObj(queryPathStr) {
  var pathArr = (0, _lodash.trim)(queryPathStr, ['/']).split('/');

  var _pathArr = _toArray(pathArr),
      collection = _pathArr[0],
      doc = _pathArr[1],
      subCollection = _pathArr[2],
      other = _pathArr.slice(3);

  return {
    collection: collection,
    doc: doc,
    subCollection: subCollection,
    other: other
  };
};

var getQueryConfig = exports.getQueryConfig = function getQueryConfig(query) {
  if ((0, _lodash.isString)(query)) {
    return queryStrToObj(query);
  }
  if ((0, _lodash.isObject)(query)) {
    if (!query.collection && !query.doc) {
      throw new Error('Collection and/or Doc are required parameters within query definition object');
    }
    if (query.subCollections) {
      return _extends({}, query, {
        subCollections: query.subCollections.map(getQueryConfig)
      });
    }
    return query;
  }
  throw new Error('Invalid Path Definition: Only Strings and Objects are accepted.');
};

var getQueryConfigs = exports.getQueryConfigs = function getQueryConfigs(queries) {
  if ((0, _lodash.isArray)(queries)) {
    return queries.map(getQueryConfig);
  }
  if ((0, _lodash.isString)(queries)) {
    return queryStrToObj(queries);
  }
  throw new Error('Querie(s) must be an Array or a string');
};

var orderedFromSnap = exports.orderedFromSnap = function orderedFromSnap(snap) {
  var ordered = [];
  if (snap.forEach) {
    snap.forEach(function (doc) {
      var obj = (0, _lodash.isObject)(doc.data()) ? _extends({ id: doc.id }, doc.data() || doc.data) : { id: doc.id, data: doc.data() };
      ordered.push(obj);
    });
  }
  return ordered;
};

var dataByIdSnapshot = exports.dataByIdSnapshot = function dataByIdSnapshot(snap) {
  var data = {};
  if (snap.forEach) {
    snap.forEach(function (doc) {
      data[doc.id] = doc.data() || doc;
    });
  }
  return (0, _lodash.size)(data) ? data : null;
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderedReducer = exports.dataReducer = exports.listenersReducer = exports.errorsReducer = exports.profileReducer = exports.authErrorReducer = exports.authReducer = exports.timestampsReducer = exports.requestedReducer = exports.requestingReducer = exports.isInitializingReducer = exports.getDotStrPath = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(3);

var _fp = __webpack_require__(51);

var _constants = __webpack_require__(84);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var START = _constants.actionTypes.START,
    SET = _constants.actionTypes.SET,
    SET_PROFILE = _constants.actionTypes.SET_PROFILE,
    MERGE = _constants.actionTypes.MERGE,
    LOGIN = _constants.actionTypes.LOGIN,
    LOGOUT = _constants.actionTypes.LOGOUT,
    LOGIN_ERROR = _constants.actionTypes.LOGIN_ERROR,
    GET_SUCCESS = _constants.actionTypes.GET_SUCCESS,
    NO_VALUE = _constants.actionTypes.NO_VALUE,
    SET_LISTENER = _constants.actionTypes.SET_LISTENER,
    UNSET_LISTENER = _constants.actionTypes.UNSET_LISTENER,
    LISTENER_RESPONSE = _constants.actionTypes.LISTENER_RESPONSE,
    AUTHENTICATION_INIT_STARTED = _constants.actionTypes.AUTHENTICATION_INIT_STARTED,
    AUTHENTICATION_INIT_FINISHED = _constants.actionTypes.AUTHENTICATION_INIT_FINISHED,
    AUTH_LINK_SUCCESS = _constants.actionTypes.AUTH_LINK_SUCCESS,
    UNAUTHORIZED_ERROR = _constants.actionTypes.UNAUTHORIZED_ERROR,
    AUTH_UPDATE_SUCCESS = _constants.actionTypes.AUTH_UPDATE_SUCCESS;

var pathToArr = function pathToArr(path) {
  return path ? path.split(/\//).filter(function (p) {
    return !!p;
  }) : [];
};

var getSlashStrPath = function getSlashStrPath(path) {
  return pathToArr(path).join('/');
};

var getDotStrPath = exports.getDotStrPath = function getDotStrPath(path) {
  return pathToArr(path).join('.');
};

var combineReducers = function combineReducers(reducers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return Object.keys(reducers).reduce(function (nextState, key) {
      nextState[key] = reducers[key](state[key], action);
      return nextState;
    }, {});
  };
};

var isInitializingReducer = exports.isInitializingReducer = function isInitializingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case AUTHENTICATION_INIT_STARTED:
      return true;
    case AUTHENTICATION_INIT_FINISHED:
      return false;
    default:
      return state;
  }
};

var requestingReducer = exports.requestingReducer = function requestingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      path = _ref.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), true));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), false));
    default:
      return state;
  }
};

var requestedReducer = exports.requestedReducer = function requestedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      path = _ref2.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), false));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), true));
    default:
      return state;
  }
};

var timestampsReducer = exports.timestampsReducer = function timestampsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      path = _ref3.path;

  switch (type) {
    case START:
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), Date.now()));
    default:
      return state;
  }
};

var getFirestorePath = function getFirestorePath(action) {
  if (!action.meta) {
    throw new Error('Meta is required to create firestore path');
  }
  var _action$meta = action.meta,
      collection = _action$meta.collection,
      doc = _action$meta.doc;

  return doc ? collection + '/' + doc : collection;
};

var createDataReducer = function createDataReducer() {
  var actionKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case SET:
        return (0, _fp.setWith)(Object, getDotStrPath(action.path), action.payload[actionKey], state);
      case MERGE:
        var previousData = (0, _lodash.get)(state, getDotStrPath(action.path), {});
        var mergedData = (0, _fp.assign)(previousData, action.payload[actionKey]);
        return (0, _fp.setWith)(Object, getDotStrPath(action.path), mergedData, state);
      case NO_VALUE:
        return (0, _fp.setWith)(Object, getDotStrPath(action.path), null, state);
      case GET_SUCCESS:
      case LISTENER_RESPONSE:
        return (0, _fp.setWith)(Object, getDotStrPath(getFirestorePath(action)), action.payload[actionKey], state);
      case LOGOUT:
        if (action.preserve) {
          return (0, _lodash.pick)(state, action.preserve);
        }
        return {};
      default:
        return state;
    }
  };
};

var authReducer = exports.authReducer = function authReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case AUTH_UPDATE_SUCCESS:
      if (!action.auth) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      var auth = action.auth.toJSON ? action.auth.toJSON() : action.auth;
      return _extends({}, auth, { isEmpty: false, isLoaded: true });
    case AUTH_LINK_SUCCESS:
      if (!action.payload) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      return _extends({}, action.payload.toJSON ? action.payload.toJSON() : action.payload, {
        isEmpty: false,
        isLoaded: true
      });
    case LOGIN_ERROR:
      return { isLoaded: true, isEmpty: true };
    case LOGOUT:
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var authErrorReducer = exports.authErrorReducer = function authErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return {};
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return action.authError;
    default:
      return state;
  }
};

var profileReducer = exports.profileReducer = function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case SET_PROFILE:
      if (!action.profile) {
        return _extends({}, state, {
          isEmpty: true,
          isLoaded: true
        });
      }
      return _extends({}, state, action.profile, {
        isEmpty: false,
        isLoaded: true
      });
    case LOGOUT:
    case LOGIN_ERROR:
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var errorsReducer = exports.errorsReducer = function errorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return [].concat(_toConsumableArray(state), [action.authError]);
    case LOGOUT:
      return [];
    default:
      return state;
  }
};

var listenersById = function listenersById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = arguments[1];
  var type = _ref4.type,
      path = _ref4.path,
      payload = _ref4.payload;

  switch (type) {
    case SET_LISTENER:
      return _extends({}, state, _defineProperty({}, payload.id, {
        id: payload.id,
        path: path
      }));
    case UNSET_LISTENER:
      return (0, _lodash.omit)(state, [payload.id]);
    default:
      return state;
  }
};

var allListeners = function allListeners() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref5 = arguments[1];
  var type = _ref5.type,
      payload = _ref5.payload;

  switch (type) {
    case SET_LISTENER:
      return [].concat(_toConsumableArray(state), [payload.id]);
    case UNSET_LISTENER:
      return state.filter(function (lId) {
        return lId !== payload.id;
      });
    default:
      return state;
  }
};

var listenersReducer = exports.listenersReducer = combineReducers({
  byId: listenersById,
  allIds: allListeners
});

var dataReducer = exports.dataReducer = createDataReducer();

var orderedReducer = exports.orderedReducer = createDataReducer('ordered');

exports.default = combineReducers({
  requesting: requestingReducer,
  requested: requestedReducer,
  timestamps: timestampsReducer,
  data: dataReducer,
  ordered: orderedReducer,
  auth: authReducer,
  profile: profileReducer,
  listeners: listenersReducer,
  errors: errorsReducer
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t){return n.set(t[0],t[1]),n}function t(n,t){return n.add(t),n}function r(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function e(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function i(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););
return n}function o(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;return true}function f(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function c(n,t){return!(null==n||!n.length)&&-1<d(n,t,0)}function a(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function l(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function s(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];
return n}function h(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);return r}function p(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function _(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function g(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function d(n,t,r){if(t===t)n:{
--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=g(n,b,r);return n}function y(n,t,r,e){--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function b(n){return n!==n}function x(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:P}function j(n){return function(t){return null==t?F:t[n]}}function w(n){return function(t){return null==n?F:n[t]}}function m(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;
return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==F&&(r=r===F?i:r+i)}return r}function E(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function O(n,t){return l(t,function(t){return[t,n[t]]})}function S(n){return function(t){return n(t)}}function I(n,t){return l(t,function(t){return n[t]})}function R(n,t){return n.has(t)}function z(n,t){for(var r=-1,e=n.length;++r<e&&-1<d(t,n[r],0););return r}function W(n,t){for(var r=n.length;r--&&-1<d(t,n[r],0););return r}function B(n){
return"\\"+Tn[n]}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function U(n,t){return function(r){return n(t(r))}}function C(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function D(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function T(n){if(Bn.test(n)){
for(var t=zn.lastIndex=0;zn.test(n);)++t;n=t}else n=tt(n);return n}function $(n){return Bn.test(n)?n.match(zn)||[]:n.split("")}var F,N=1/0,P=NaN,Z=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],q=/\b__p\+='';/g,V=/\b(__p\+=)''\+/g,K=/(__e\(.*?\)|\b__t\))\+'';/g,G=/&(?:amp|lt|gt|quot|#39);/g,H=/[&<>"']/g,J=RegExp(G.source),Y=RegExp(H.source),Q=/<%-([\s\S]+?)%>/g,X=/<%([\s\S]+?)%>/g,nn=/<%=([\s\S]+?)%>/g,tn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,rn=/^\w*$/,en=/^\./,un=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,on=/[\\^$.*+?()[\]{}|]/g,fn=RegExp(on.source),cn=/^\s+|\s+$/g,an=/^\s+/,ln=/\s+$/,sn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,hn=/\{\n\/\* \[wrapped with (.+)\] \*/,pn=/,? & /,_n=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,vn=/\\(\\)?/g,gn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,dn=/\w*$/,yn=/^[-+]0x[0-9a-f]+$/i,bn=/^0b[01]+$/i,xn=/^\[object .+?Constructor\]$/,jn=/^0o[0-7]+$/i,wn=/^(?:0|[1-9]\d*)$/,mn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,An=/($^)/,kn=/['\n\r\u2028\u2029\\]/g,En="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",On="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+En,Sn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",In=RegExp("['\u2019]","g"),Rn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),zn=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Sn+En,"g"),Wn=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",On].join("|"),"g"),Bn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Ln=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Un="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Cn={};
Cn["[object Float32Array]"]=Cn["[object Float64Array]"]=Cn["[object Int8Array]"]=Cn["[object Int16Array]"]=Cn["[object Int32Array]"]=Cn["[object Uint8Array]"]=Cn["[object Uint8ClampedArray]"]=Cn["[object Uint16Array]"]=Cn["[object Uint32Array]"]=true,Cn["[object Arguments]"]=Cn["[object Array]"]=Cn["[object ArrayBuffer]"]=Cn["[object Boolean]"]=Cn["[object DataView]"]=Cn["[object Date]"]=Cn["[object Error]"]=Cn["[object Function]"]=Cn["[object Map]"]=Cn["[object Number]"]=Cn["[object Object]"]=Cn["[object RegExp]"]=Cn["[object Set]"]=Cn["[object String]"]=Cn["[object WeakMap]"]=false;
var Dn={};Dn["[object Arguments]"]=Dn["[object Array]"]=Dn["[object ArrayBuffer]"]=Dn["[object DataView]"]=Dn["[object Boolean]"]=Dn["[object Date]"]=Dn["[object Float32Array]"]=Dn["[object Float64Array]"]=Dn["[object Int8Array]"]=Dn["[object Int16Array]"]=Dn["[object Int32Array]"]=Dn["[object Map]"]=Dn["[object Number]"]=Dn["[object Object]"]=Dn["[object RegExp]"]=Dn["[object Set]"]=Dn["[object String]"]=Dn["[object Symbol]"]=Dn["[object Uint8Array]"]=Dn["[object Uint8ClampedArray]"]=Dn["[object Uint16Array]"]=Dn["[object Uint32Array]"]=true,
Dn["[object Error]"]=Dn["[object Function]"]=Dn["[object WeakMap]"]=false;var Mn,Tn={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},$n=parseFloat,Fn=parseInt,Nn=typeof global=="object"&&global&&global.Object===Object&&global,Pn=typeof self=="object"&&self&&self.Object===Object&&self,Zn=Nn||Pn||Function("return this")(),qn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Vn=qn&&typeof module=="object"&&module&&!module.nodeType&&module,Kn=Vn&&Vn.exports===qn,Gn=Kn&&Nn.process;
n:{try{Mn=Gn&&Gn.binding&&Gn.binding("util");break n}catch(n){}Mn=void 0}var Hn=Mn&&Mn.isArrayBuffer,Jn=Mn&&Mn.isDate,Yn=Mn&&Mn.isMap,Qn=Mn&&Mn.isRegExp,Xn=Mn&&Mn.isSet,nt=Mn&&Mn.isTypedArray,tt=j("length"),rt=w({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I",
"\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C",
"\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i",
"\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S",
"\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe",
"\u0149":"'n","\u017f":"s"}),et=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),ut=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),it=function w(En){function On(n){if(xu(n)&&!af(n)&&!(n instanceof Mn)){if(n instanceof zn)return n;if(ci.call(n,"__wrapped__"))return Pe(n)}return new zn(n)}function Sn(){}function zn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=F}function Mn(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,
this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Pn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function qn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Pn;++t<r;)this.add(n[t])}function Vn(n){
this.size=(this.__data__=new Nn(n)).size}function Gn(n,t){var r,e=af(n),u=!e&&cf(n),i=!e&&!u&&sf(n),o=!e&&!u&&!i&&gf(n),u=(e=e||u||i||o)?E(n.length,ri):[],f=u.length;for(r in n)!t&&!ci.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Re(r,f))||u.push(r);return u}function tt(n){var t=n.length;return t?n[cr(0,t-1)]:F}function ot(n,t){return Te(Mr(n),gt(t,0,n.length))}function ft(n){return Te(Mr(n))}function ct(n,t,r){(r===F||hu(n[t],r))&&(r!==F||t in n)||_t(n,t,r);
}function at(n,t,r){var e=n[t];ci.call(n,t)&&hu(e,r)&&(r!==F||t in n)||_t(n,t,r)}function lt(n,t){for(var r=n.length;r--;)if(hu(n[r][0],t))return r;return-1}function st(n,t,r,e){return oo(n,function(n,u,i){t(e,n,r(n),i)}),e}function ht(n,t){return n&&Tr(t,Lu(t),n)}function pt(n,t){return n&&Tr(t,Uu(t),n)}function _t(n,t,r){"__proto__"==t&&Ei?Ei(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function vt(n,t){for(var r=-1,e=t.length,u=Hu(e),i=null==n;++r<e;)u[r]=i?F:Wu(n,t[r]);return u;
}function gt(n,t,r){return n===n&&(r!==F&&(n=n<=r?n:r),t!==F&&(n=n>=t?n:t)),n}function dt(n,t,r,e,i,o){var f,c=1&t,a=2&t,l=4&t;if(r&&(f=i?r(n,e,i,o):r(n)),f!==F)return f;if(!bu(n))return n;if(e=af(n)){if(f=Ee(n),!c)return Mr(n,f)}else{var s=yo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(sf(n))return Wr(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Oe(n),!c)return a?Fr(n,pt(f,n)):$r(n,ht(f,n))}else{if(!Dn[s])return i?n:{};f=Se(n,s,dt,c)}}if(o||(o=new Vn),
i=o.get(n))return i;o.set(n,f);var a=l?a?ye:de:a?Uu:Lu,p=e?F:a(n);return u(p||n,function(e,u){p&&(u=e,e=n[u]),at(f,u,dt(e,t,r,u,n,o))}),f}function yt(n){var t=Lu(n);return function(r){return bt(r,n,t)}}function bt(n,t,r){var e=r.length;if(null==n)return!e;for(n=ni(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===F&&!(u in n)||!i(o))return false}return true}function xt(n,t,r){if(typeof n!="function")throw new ei("Expected a function");return jo(function(){n.apply(F,r)},t)}function jt(n,t,r,e){var u=-1,i=c,o=true,f=n.length,s=[],h=t.length;
if(!f)return s;r&&(t=l(t,S(r))),e?(i=a,o=false):200<=t.length&&(i=R,o=false,t=new qn(t));n:for(;++u<f;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(o&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function wt(n,t){var r=true;return oo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function mt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===F?o===o&&!Au(o):r(o,f)))var f=o,c=i}return c}function At(n,t){var r=[];return oo(n,function(n,e,u){
t(n,e,u)&&r.push(n)}),r}function kt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ie),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?kt(f,t-1,r,e,u):s(u,f):e||(u[u.length]=f)}return u}function Et(n,t){return n&&co(n,t,Lu)}function Ot(n,t){return n&&ao(n,t,Lu)}function St(n,t){return f(t,function(t){return gu(n[t])})}function It(n,t){t=Rr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[$e(t[r++])];return r&&r==e?n:F}function Rt(n,t,r){return t=t(n),af(n)?t:s(t,r(n))}function zt(n){if(null==n)n=n===F?"[object Undefined]":"[object Null]";else if(ki&&ki in ni(n)){
var t=ci.call(n,ki),r=n[ki];try{n[ki]=F;var e=true}catch(n){}var u=si.call(n);e&&(t?n[ki]=r:delete n[ki]),n=u}else n=si.call(n);return n}function Wt(n,t){return n>t}function Bt(n,t){return null!=n&&ci.call(n,t)}function Lt(n,t){return null!=n&&t in ni(n)}function Ut(n,t,r){for(var e=r?a:c,u=n[0].length,i=n.length,o=i,f=Hu(i),s=1/0,h=[];o--;){var p=n[o];o&&t&&(p=l(p,S(t))),s=Mi(p.length,s),f[o]=!r&&(t||120<=u&&120<=p.length)?new qn(o&&p):F}var p=n[0],_=-1,v=f[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;
if(v?!R(v,d):!e(h,d,r)){for(o=i;--o;){var y=f[o];if(y?!R(y,d):!e(n[o],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ct(n,t,r){var e={};return Et(n,function(n,u,i){t(e,r(n),u,i)}),e}function Dt(n,t,e){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),t=null==n?n:n[$e(Ge(t))],null==t?F:r(t,n,e)}function Mt(n){return xu(n)&&"[object Arguments]"==zt(n)}function Tt(n){return xu(n)&&"[object ArrayBuffer]"==zt(n)}function $t(n){return xu(n)&&"[object Date]"==zt(n)}function Ft(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!xu(n)&&!xu(t))t=n!==n&&t!==t;else n:{
var i=af(n),o=af(t),f=i?"[object Array]":yo(n),c=o?"[object Array]":yo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&sf(n)){if(!sf(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Vn),t=i||gf(n)?_e(n,t,r,e,Ft,u):ve(n,t,f,r,e,Ft,u);else{if(!(1&r)&&(i=a&&ci.call(n,"__wrapped__"),f=o&&ci.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Vn),t=Ft(n,t,r,e,u);break n}if(c)t:if(u||(u=new Vn),
i=1&r,f=de(n),o=f.length,c=de(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:ci.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===F?h!==p&&!Ft(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l)}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),
u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Nt(n){return xu(n)&&"[object Map]"==yo(n)}function Pt(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ni(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===F&&!(c in n))return false}else{if(f=new Vn,e)var s=e(a,l,c,n,t,f);if(s===F?!Ft(l,a,3,e,f):!s)return false}}return true}function Zt(n){return!(!bu(n)||li&&li in n)&&(gu(n)?_i:xn).test(Fe(n))}function qt(n){
return xu(n)&&"[object RegExp]"==zt(n)}function Vt(n){return xu(n)&&"[object Set]"==yo(n)}function Kt(n){return xu(n)&&yu(n.length)&&!!Cn[zt(n)]}function Gt(n){return typeof n=="function"?n:null==n?Nu:typeof n=="object"?af(n)?Xt(n[0],n[1]):Qt(n):Vu(n)}function Ht(n){if(!Le(n))return Ci(n);var t,r=[];for(t in ni(n))ci.call(n,t)&&"constructor"!=t&&r.push(t);return r}function Jt(n,t){return n<t}function Yt(n,t){var r=-1,e=pu(n)?Hu(n.length):[];return oo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Qt(n){
var t=me(n);return 1==t.length&&t[0][2]?Ue(t[0][0],t[0][1]):function(r){return r===n||Pt(r,n,t)}}function Xt(n,t){return We(n)&&t===t&&!bu(t)?Ue($e(n),t):function(r){var e=Wu(r,n);return e===F&&e===t?Bu(r,n):Ft(t,e,3)}}function nr(n,t,r,e,u){n!==t&&co(t,function(i,o){if(bu(i)){u||(u=new Vn);var f=u,c=n[o],a=t[o],l=f.get(a);if(l)ct(n,o,l);else{var l=e?e(c,a,o+"",n,t,f):F,s=l===F;if(s){var h=af(a),p=!h&&sf(a),_=!h&&!p&&gf(a),l=a;h||p||_?af(c)?l=c:_u(c)?l=Mr(c):p?(s=false,l=Wr(a,true)):_?(s=false,l=Lr(a,true)):l=[]:wu(a)||cf(a)?(l=c,
cf(c)?l=Ru(c):(!bu(c)||r&&gu(c))&&(l=Oe(a))):s=false}s&&(f.set(a,l),nr(l,a,r,e,f),f.delete(a)),ct(n,o,l)}}else f=e?e(n[o],i,o+"",n,t,u):F,f===F&&(f=i),ct(n,o,f)},Uu)}function tr(n,t){var r=n.length;if(r)return t+=0>t?r:0,Re(t,r)?n[t]:F}function rr(n,t,r){var e=-1;return t=l(t.length?t:[Nu],S(je())),n=Yt(n,function(n){return{a:l(t,function(t){return t(n)}),b:++e,c:n}}),A(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Ur(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);
break n}}e=n.b-t.b}return e})}function er(n,t){return ur(n,t,function(t,r){return Bu(n,r)})}function ur(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=It(n,o);r(f,o)&&pr(i,Rr(o,n),f)}return i}function ir(n){return function(t){return It(t,n)}}function or(n,t,r,e){var u=e?y:d,i=-1,o=t.length,f=n;for(n===t&&(t=Mr(t)),r&&(f=l(n,S(r)));++i<o;)for(var c=0,a=t[i],a=r?r(a):a;-1<(c=u(f,a,c,e));)f!==n&&wi.call(f,c,1),wi.call(n,c,1);return n}function fr(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];
if(r==e||u!==i){var i=u;Re(u)?wi.call(n,u,1):mr(n,u)}}}function cr(n,t){return n+zi(Fi()*(t-n+1))}function ar(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=zi(t/2))&&(n+=n);while(t);return r}function lr(n,t){return wo(Ce(n,t,Nu),n+"")}function sr(n){return tt(Du(n))}function hr(n,t){var r=Du(n);return Te(r,gt(t,0,r.length))}function pr(n,t,r,e){if(!bu(n))return n;t=Rr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=$e(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):F;
a===F&&(a=bu(l)?l:Re(t[u+1])?[]:{})}at(f,c,a),f=f[c]}return n}function _r(n){return Te(Du(n))}function vr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Hu(u);++e<u;)r[e]=n[e+t];return r}function gr(n,t){var r;return oo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function dr(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!Au(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return yr(n,t,Nu,r);
}function yr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=Au(t),a=t===F;u<i;){var l=zi((u+i)/2),s=r(n[l]),h=s!==F,p=null===s,_=s===s,v=Au(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Mi(i,4294967294)}function br(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!hu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function xr(n){return typeof n=="number"?n:Au(n)?P:+n}function jr(n){if(typeof n=="string")return n;
if(af(n))return l(n,jr)+"";if(Au(n))return uo?uo.call(n):"";var t=n+"";return"0"==t&&1/n==-N?"-0":t}function wr(n,t,r){var e=-1,u=c,i=n.length,o=true,f=[],l=f;if(r)o=false,u=a;else if(200<=i){if(u=t?null:po(n))return D(u);o=false,u=R,l=new qn}else l=t?[]:f;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(o&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),f.push(s)}else u(l,h,r)||(l!==f&&l.push(h),f.push(s))}return f}function mr(n,t){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),
null==n||delete n[$e(Ge(t))]}function Ar(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?vr(n,e?0:i,e?i+1:u):vr(n,e?i+1:0,e?u:i)}function kr(n,t){var r=n;return r instanceof Mn&&(r=r.value()),h(t,function(n,t){return t.func.apply(t.thisArg,s([n],t.args))},r)}function Er(n,t,r){var e=n.length;if(2>e)return e?wr(n[0]):[];for(var u=-1,i=Hu(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=jt(i[u]||o,n[f],t,r));return wr(kt(i,1),t,r)}function Or(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:F);
return o}function Sr(n){return _u(n)?n:[]}function Ir(n){return typeof n=="function"?n:Nu}function Rr(n,t){return af(n)?n:We(n,t)?[n]:mo(zu(n))}function zr(n,t,r){var e=n.length;return r=r===F?e:r,!t&&r>=e?n:vr(n,t,r)}function Wr(n,t){if(t)return n.slice();var r=n.length,r=yi?yi(r):new n.constructor(r);return n.copy(r),r}function Br(n){var t=new n.constructor(n.byteLength);return new di(t).set(new di(n)),t}function Lr(n,t){return new n.constructor(t?Br(n.buffer):n.buffer,n.byteOffset,n.length)}function Ur(n,t){
if(n!==t){var r=n!==F,e=null===n,u=n===n,i=Au(n),o=t!==F,f=null===t,c=t===t,a=Au(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cr(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Di(i-o,0),l=Hu(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Dr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Di(i-f,0),s=Hu(l+a);
for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Mr(n,t){var r=-1,e=n.length;for(t||(t=Hu(e));++r<e;)t[r]=n[r];return t}function Tr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):F;c===F&&(c=n[f]),u?_t(r,f,c):at(r,f,c)}return r}function $r(n,t){return Tr(n,vo(n),t)}function Fr(n,t){return Tr(n,go(n),t)}function Nr(n,t){return function(r,u){var i=af(r)?e:st,o=t?t():{};return i(r,n,je(u,2),o);
}}function Pr(n){return lr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:F,o=2<u?r[2]:F,i=3<n.length&&typeof i=="function"?(u--,i):F;for(o&&ze(r[0],r[1],o)&&(i=3>u?F:i,u=1),t=ni(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Zr(n,t){return function(r,e){if(null==r)return r;if(!pu(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ni(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function qr(n){return function(t,r,e){var u=-1,i=ni(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
}return t}}function Vr(n,t,r){function e(){return(this&&this!==Zn&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Hr(n);return e}function Kr(n){return function(t){t=zu(t);var r=Bn.test(t)?$(t):F,e=r?r[0]:t.charAt(0);return t=r?zr(r,1).join(""):t.slice(1),e[n]()+t}}function Gr(n){return function(t){return h($u(Tu(t).replace(In,"")),n,"")}}function Hr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=io(n.prototype),t=n.apply(r,t);return bu(t)?t:r}}function Jr(n,t,e){function u(){for(var o=arguments.length,f=Hu(o),c=o,a=xe(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:C(f,a),o-=c.length,o<e?fe(n,t,Xr,u.placeholder,F,f,c,F,F,e-o):r(this&&this!==Zn&&this instanceof u?i:n,this,f);
}var i=Hr(n);return u}function Yr(n){return function(t,r,e){var u=ni(t);if(!pu(t)){var i=je(r,3);t=Lu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:F}}function Qr(n){return ge(function(t){var r=t.length,e=r,u=zn.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ei("Expected a function");if(u&&!o&&"wrapper"==be(i))var o=new zn([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=be(i),f="wrapper"==u?_o(i):F,o=f&&Be(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[be(f[0])].apply(o,f[3]):1==i.length&&Be(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&af(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Xr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Hu(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=xe(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Cr(y,e,u,_)),i&&(y=Dr(y,i,o,_)),d-=x,_&&d<a)return j=C(y,j),fe(n,t,Xr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Mi(f.length,x),m=Mr(y);w--;){
var A=f[w];y[w]=Re(A,x)?m[A]:F}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==Zn&&this instanceof l&&(b=g||Hr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?F:Hr(n);return l}function ne(n,t){return function(r,e){return Ct(r,n,t(e))}}function te(n,t){return function(r,e){var u;if(r===F&&e===F)return t;if(r!==F&&(u=r),e!==F){if(u===F)return e;typeof r=="string"||typeof e=="string"?(r=jr(r),e=jr(e)):(r=xr(r),e=xr(e)),u=n(r,e)}return u}}function re(n){return ge(function(t){
return t=l(t,S(je())),lr(function(e){var u=this;return n(t,function(n){return r(n,u,e)})})})}function ee(n,t){t=t===F?" ":jr(t);var r=t.length;return 2>r?r?ar(t,n):t:(r=ar(t,Ri(n/T(t))),Bn.test(t)?zr($(r),0,n).join(""):r.slice(0,n))}function ue(n,t,e,u){function i(){for(var t=-1,c=arguments.length,a=-1,l=u.length,s=Hu(l+c),h=this&&this!==Zn&&this instanceof i?f:n;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++t];return r(h,o?e:this,s)}var o=1&t,f=Hr(n);return i}function ie(n){return function(t,r,e){
e&&typeof e!="number"&&ze(t,r,e)&&(r=e=F),t=Eu(t),r===F?(r=t,t=0):r=Eu(r),e=e===F?t<r?1:-1:Eu(e);var u=-1;r=Di(Ri((r-t)/(e||1)),0);for(var i=Hu(r);r--;)i[n?r:++u]=t,t+=e;return i}}function oe(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Iu(t),r=Iu(r)),n(t,r)}}function fe(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:F;o=l?F:o;var h=l?i:F;return i=l?F:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(F,u),Be(n)&&xo(r,u),r.placeholder=e,De(r,n,t)}function ce(n){
var t=Xu[n];return function(n,r){if(n=Iu(n),r=null==r?0:Mi(Ou(r),292)){var e=(zu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(zu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ae(n){return function(t){var r=yo(t);return"[object Map]"==r?L(t):"[object Set]"==r?M(t):O(t,n(t))}}function le(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ei("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=F),o=o===F?o:Di(Ou(o),0),f=f===F?f:Ou(f),a-=u?u.length:0,64&t){
var l=e,s=u;e=u=F}var h=c?F:_o(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Cr(e,r,h[4]):r,i[4]=e?C(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Dr(e,r,h[6]):r,i[6]=e?C(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Mi(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===F?c?0:n.length:Di(i[9]-a,0),!f&&24&t&&(t&=-25),De((h?lo:xo)(t&&1!=t?8==t||16==t?Jr(n,t,f):32!=t&&33!=t||u.length?Xr.apply(F,i):ue(n,t,r,e):Vr(n,t,r),i),n,t)}function se(n,t,r,e){return n===F||hu(n,ii[r])&&!ci.call(e,r)?t:n}function he(n,t,r,e,u,i){return bu(n)&&bu(t)&&(i.set(t,n),nr(n,t,F,he,i),i.delete(t)),n}function pe(n){return wu(n)?F:n}function _e(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;var c=-1,a=true,l=2&r?new qn:F;
for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],h=t[c];if(e)var p=o?e(h,s,c,t,n,i):e(s,h,c,n,t,i);if(p!==F){if(p)continue;a=false;break}if(l){if(!_(t,function(n,t){if(!R(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==h&&!u(s,h,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function ve(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":if(n.byteLength!=t.byteLength||!i(new di(n),new di(t)))break;
return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return hu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=L;case"[object Set]":if(f||(f=D),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=_e(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(eo)return eo.call(n)==eo.call(t)}return false}function ge(n){return wo(Ce(n,F,Ve),n+"")}function de(n){
return Rt(n,Lu,vo)}function ye(n){return Rt(n,Uu,go)}function be(n){for(var t=n.name+"",r=Ji[t],e=ci.call(Ji,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function xe(n){return(ci.call(On,"placeholder")?On:n).placeholder}function je(){var n=On.iteratee||Pu,n=n===Pu?Gt:n;return arguments.length?n(arguments[0],arguments[1]):n}function we(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function me(n){for(var t=Lu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!bu(u)]}return t}function Ae(n,t){var r=null==n?F:n[t];return Zt(r)?r:F}function ke(n,t,r){t=Rr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=$e(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&yu(u)&&Re(o,u)&&(af(n)||cf(n)))}function Ee(n){var t=n.length,r=n.constructor(t);return t&&"string"==typeof n[0]&&ci.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Oe(n){
return typeof n.constructor!="function"||Le(n)?{}:io(bi(n))}function Se(r,e,u,i){var o=r.constructor;switch(e){case"[object ArrayBuffer]":return Br(r);case"[object Boolean]":case"[object Date]":return new o(+r);case"[object DataView]":return e=i?Br(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return Lr(r,i);case"[object Map]":return e=i?u(L(r),1):L(r),h(e,n,new r.constructor);case"[object Number]":case"[object String]":return new o(r);case"[object RegExp]":return e=new r.constructor(r.source,dn.exec(r)),e.lastIndex=r.lastIndex,e;case"[object Set]":return e=i?u(D(r),1):D(r),h(e,t,new r.constructor);case"[object Symbol]":return eo?ni(eo.call(r)):{}}}function Ie(n){return af(n)||cf(n)||!!(mi&&n&&n[mi])}function Re(n,t){return t=null==t?9007199254740991:t,
!!t&&(typeof n=="number"||wn.test(n))&&-1<n&&0==n%1&&n<t}function ze(n,t,r){if(!bu(r))return false;var e=typeof t;return!!("number"==e?pu(r)&&Re(t,r.length):"string"==e&&t in r)&&hu(r[t],n)}function We(n,t){if(af(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!Au(n))||(rn.test(n)||!tn.test(n)||null!=t&&n in ni(t))}function Be(n){var t=be(n),r=On[t];return typeof r=="function"&&t in Mn.prototype&&(n===r||(t=_o(r),!!t&&n===t[0]))}function Le(n){var t=n&&n.constructor;
return n===(typeof t=="function"&&t.prototype||ii)}function Ue(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==F||n in ni(r)))}}function Ce(n,t,e){return t=Di(t===F?n.length-1:t,0),function(){for(var u=arguments,i=-1,o=Di(u.length-t,0),f=Hu(o);++i<o;)f[i]=u[t+i];for(i=-1,o=Hu(t+1);++i<t;)o[i]=u[i];return o[t]=e(f),r(n,this,o)}}function De(n,t,r){var e=t+"";t=wo;var u,i=Ne;return u=(u=e.match(hn))?u[1].split(pn):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),
e=e.replace(sn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Me(n){var t=0,r=0;return function(){var e=Ti(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(F,arguments)}}function Te(n,t){var r=-1,e=n.length,u=e-1;for(t=t===F?e:t;++r<t;){var e=cr(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function $e(n){if(typeof n=="string"||Au(n))return n;var t=n+"";return"0"==t&&1/n==-N?"-0":t}function Fe(n){if(null!=n){try{return fi.call(n)}catch(n){}return n+""}return"";
}function Ne(n,t){return u(Z,function(r){var e="_."+r[0];t&r[1]&&!c(n,e)&&n.push(e)}),n.sort()}function Pe(n){if(n instanceof Mn)return n.clone();var t=new zn(n.__wrapped__,n.__chain__);return t.__actions__=Mr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ze(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),g(n,je(t,3),r)):-1}function qe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==F&&(u=Ou(r),u=0>r?Di(e+u,0):Mi(u,e-1)),
g(n,je(t,3),u,true)}function Ve(n){return(null==n?0:n.length)?kt(n,1):[]}function Ke(n){return n&&n.length?n[0]:F}function Ge(n){var t=null==n?0:n.length;return t?n[t-1]:F}function He(n,t){return n&&n.length&&t&&t.length?or(n,t):n}function Je(n){return null==n?n:Ni.call(n)}function Ye(n){if(!n||!n.length)return[];var t=0;return n=f(n,function(n){if(_u(n))return t=Di(n.length,t),true}),E(t,function(t){return l(n,j(t))})}function Qe(n,t){if(!n||!n.length)return[];var e=Ye(n);return null==t?e:l(e,function(n){
return r(t,F,n)})}function Xe(n){return n=On(n),n.__chain__=true,n}function nu(n,t){return t(n)}function tu(){return this}function ru(n,t){return(af(n)?u:oo)(n,je(t,3))}function eu(n,t){return(af(n)?i:fo)(n,je(t,3))}function uu(n,t){return(af(n)?l:Yt)(n,je(t,3))}function iu(n,t,r){return t=r?F:t,t=n&&null==t?n.length:t,le(n,128,F,F,F,F,t)}function ou(n,t){var r;if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=F),
r}}function fu(n,t,r){return t=r?F:t,n=le(n,8,F,F,F,F,F,t),n.placeholder=fu.placeholder,n}function cu(n,t,r){return t=r?F:t,n=le(n,16,F,F,F,F,F,t),n.placeholder=cu.placeholder,n}function au(n,t,r){function e(t){var r=c,e=a;return c=a=F,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===F||r>=t||0>r||g&&n>=l}function i(){var n=Jo();if(u(n))return o(n);var r,e=jo;r=n-_,n=t-(n-p),r=g?Mi(n,l-r):n,h=e(i,r)}function o(n){return h=F,d&&c?e(n):(c=a=F,s)}function f(){var n=Jo(),r=u(n);if(c=arguments,
a=this,p=n,r){if(h===F)return _=n=p,h=jo(i,t),v?e(n):s;if(g)return h=jo(i,t),e(p)}return h===F&&(h=jo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ei("Expected a function");return t=Iu(t)||0,bu(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Di(Iu(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==F&&ho(h),_=0,c=p=a=h=F},f.flush=function(){return h===F?s:o(Jo())},f}function lu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ei("Expected a function");return r.cache=new(lu.Cache||Pn),r}function su(n){if(typeof n!="function")throw new ei("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function hu(n,t){return n===t||n!==n&&t!==t}function pu(n){return null!=n&&yu(n.length)&&!gu(n);
}function _u(n){return xu(n)&&pu(n)}function vu(n){if(!xu(n))return false;var t=zt(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!wu(n)}function gu(n){return!!bu(n)&&(n=zt(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function du(n){return typeof n=="number"&&n==Ou(n)}function yu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function bu(n){var t=typeof n;return null!=n&&("object"==t||"function"==t);
}function xu(n){return null!=n&&typeof n=="object"}function ju(n){return typeof n=="number"||xu(n)&&"[object Number]"==zt(n)}function wu(n){return!(!xu(n)||"[object Object]"!=zt(n))&&(n=bi(n),null===n||(n=ci.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&fi.call(n)==hi))}function mu(n){return typeof n=="string"||!af(n)&&xu(n)&&"[object String]"==zt(n)}function Au(n){return typeof n=="symbol"||xu(n)&&"[object Symbol]"==zt(n)}function ku(n){if(!n)return[];if(pu(n))return mu(n)?$(n):Mr(n);
if(Ai&&n[Ai]){n=n[Ai]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=yo(n),("[object Map]"==t?L:"[object Set]"==t?D:Du)(n)}function Eu(n){return n?(n=Iu(n),n===N||n===-N?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Ou(n){n=Eu(n);var t=n%1;return n===n?t?n-t:n:0}function Su(n){return n?gt(Ou(n),0,4294967295):0}function Iu(n){if(typeof n=="number")return n;if(Au(n))return P;if(bu(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=bu(n)?n+"":n),typeof n!="string")return 0===n?n:+n;
n=n.replace(cn,"");var t=bn.test(n);return t||jn.test(n)?Fn(n.slice(2),t?2:8):yn.test(n)?P:+n}function Ru(n){return Tr(n,Uu(n))}function zu(n){return null==n?"":jr(n)}function Wu(n,t,r){return n=null==n?F:It(n,t),n===F?r:n}function Bu(n,t){return null!=n&&ke(n,t,Lt)}function Lu(n){return pu(n)?Gn(n):Ht(n)}function Uu(n){if(pu(n))n=Gn(n,true);else if(bu(n)){var t,r=Le(n),e=[];for(t in n)("constructor"!=t||!r&&ci.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in ni(n))t.push(r);n=t}return n}function Cu(n,t){
if(null==n)return{};var r=l(ye(n),function(n){return[n]});return t=je(t),ur(n,r,function(n,r){return t(n,r[0])})}function Du(n){return null==n?[]:I(n,Lu(n))}function Mu(n){return Nf(zu(n).toLowerCase())}function Tu(n){return(n=zu(n))&&n.replace(mn,rt).replace(Rn,"")}function $u(n,t,r){return n=zu(n),t=r?F:t,t===F?Ln.test(n)?n.match(Wn)||[]:n.match(_n)||[]:n.match(t)||[]}function Fu(n){return function(){return n}}function Nu(n){return n}function Pu(n){return Gt(typeof n=="function"?n:dt(n,1))}function Zu(n,t,r){
var e=Lu(t),i=St(t,e);null!=r||bu(t)&&(i.length||!e.length)||(r=t,t=n,n=this,i=St(t,Lu(t)));var o=!(bu(r)&&"chain"in r&&!r.chain),f=gu(n);return u(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Mr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,s([this.value()],arguments))})}),n}function qu(){}function Vu(n){return We(n)?j($e(n)):ir(n)}function Ku(){return[]}function Gu(){
return false}En=null==En?Zn:it.defaults(Zn.Object(),En,it.pick(Zn,Un));var Hu=En.Array,Ju=En.Date,Yu=En.Error,Qu=En.Function,Xu=En.Math,ni=En.Object,ti=En.RegExp,ri=En.String,ei=En.TypeError,ui=Hu.prototype,ii=ni.prototype,oi=En["__core-js_shared__"],fi=Qu.prototype.toString,ci=ii.hasOwnProperty,ai=0,li=function(){var n=/[^.]+$/.exec(oi&&oi.keys&&oi.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),si=ii.toString,hi=fi.call(ni),pi=Zn._,_i=ti("^"+fi.call(ci).replace(on,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),vi=Kn?En.Buffer:F,gi=En.Symbol,di=En.Uint8Array,yi=vi?vi.f:F,bi=U(ni.getPrototypeOf,ni),xi=ni.create,ji=ii.propertyIsEnumerable,wi=ui.splice,mi=gi?gi.isConcatSpreadable:F,Ai=gi?gi.iterator:F,ki=gi?gi.toStringTag:F,Ei=function(){
try{var n=Ae(ni,"defineProperty");return n({},"",{}),n}catch(n){}}(),Oi=En.clearTimeout!==Zn.clearTimeout&&En.clearTimeout,Si=Ju&&Ju.now!==Zn.Date.now&&Ju.now,Ii=En.setTimeout!==Zn.setTimeout&&En.setTimeout,Ri=Xu.ceil,zi=Xu.floor,Wi=ni.getOwnPropertySymbols,Bi=vi?vi.isBuffer:F,Li=En.isFinite,Ui=ui.join,Ci=U(ni.keys,ni),Di=Xu.max,Mi=Xu.min,Ti=Ju.now,$i=En.parseInt,Fi=Xu.random,Ni=ui.reverse,Pi=Ae(En,"DataView"),Zi=Ae(En,"Map"),qi=Ae(En,"Promise"),Vi=Ae(En,"Set"),Ki=Ae(En,"WeakMap"),Gi=Ae(ni,"create"),Hi=Ki&&new Ki,Ji={},Yi=Fe(Pi),Qi=Fe(Zi),Xi=Fe(qi),no=Fe(Vi),to=Fe(Ki),ro=gi?gi.prototype:F,eo=ro?ro.valueOf:F,uo=ro?ro.toString:F,io=function(){
function n(){}return function(t){return bu(t)?xi?xi(t):(n.prototype=t,t=new n,n.prototype=F,t):{}}}();On.templateSettings={escape:Q,evaluate:X,interpolate:nn,variable:"",imports:{_:On}},On.prototype=Sn.prototype,On.prototype.constructor=On,zn.prototype=io(Sn.prototype),zn.prototype.constructor=zn,Mn.prototype=io(Sn.prototype),Mn.prototype.constructor=Mn,Tn.prototype.clear=function(){this.__data__=Gi?Gi(null):{},this.size=0},Tn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Tn.prototype.get=function(n){var t=this.__data__;return Gi?(n=t[n],"__lodash_hash_undefined__"===n?F:n):ci.call(t,n)?t[n]:F},Tn.prototype.has=function(n){var t=this.__data__;return Gi?t[n]!==F:ci.call(t,n)},Tn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Gi&&t===F?"__lodash_hash_undefined__":t,this},Nn.prototype.clear=function(){this.__data__=[],this.size=0},Nn.prototype.delete=function(n){var t=this.__data__;return n=lt(t,n),!(0>n)&&(n==t.length-1?t.pop():wi.call(t,n,1),
--this.size,true)},Nn.prototype.get=function(n){var t=this.__data__;return n=lt(t,n),0>n?F:t[n][1]},Nn.prototype.has=function(n){return-1<lt(this.__data__,n)},Nn.prototype.set=function(n,t){var r=this.__data__,e=lt(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Pn.prototype.clear=function(){this.size=0,this.__data__={hash:new Tn,map:new(Zi||Nn),string:new Tn}},Pn.prototype.delete=function(n){return n=we(this,n).delete(n),this.size-=n?1:0,n},Pn.prototype.get=function(n){return we(this,n).get(n);
},Pn.prototype.has=function(n){return we(this,n).has(n)},Pn.prototype.set=function(n,t){var r=we(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},qn.prototype.add=qn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},qn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.clear=function(){this.__data__=new Nn,this.size=0},Vn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Vn.prototype.get=function(n){
return this.__data__.get(n)},Vn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Nn){var e=r.__data__;if(!Zi||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Pn(e)}return r.set(n,t),this.size=r.size,this};var oo=Zr(Et),fo=Zr(Ot,true),co=qr(),ao=qr(true),lo=Hi?function(n,t){return Hi.set(n,t),n}:Nu,so=Ei?function(n,t){return Ei(n,"toString",{configurable:true,enumerable:false,value:Fu(t),writable:true})}:Nu,ho=Oi||function(n){
return Zn.clearTimeout(n)},po=Vi&&1/D(new Vi([,-0]))[1]==N?function(n){return new Vi(n)}:qu,_o=Hi?function(n){return Hi.get(n)}:qu,vo=Wi?function(n){return null==n?[]:(n=ni(n),f(Wi(n),function(t){return ji.call(n,t)}))}:Ku,go=Wi?function(n){for(var t=[];n;)s(t,vo(n)),n=bi(n);return t}:Ku,yo=zt;(Pi&&"[object DataView]"!=yo(new Pi(new ArrayBuffer(1)))||Zi&&"[object Map]"!=yo(new Zi)||qi&&"[object Promise]"!=yo(qi.resolve())||Vi&&"[object Set]"!=yo(new Vi)||Ki&&"[object WeakMap]"!=yo(new Ki))&&(yo=function(n){
var t=zt(n);if(n=(n="[object Object]"==t?n.constructor:F)?Fe(n):"")switch(n){case Yi:return"[object DataView]";case Qi:return"[object Map]";case Xi:return"[object Promise]";case no:return"[object Set]";case to:return"[object WeakMap]"}return t});var bo=oi?gu:Gu,xo=Me(lo),jo=Ii||function(n,t){return Zn.setTimeout(n,t)},wo=Me(so),mo=function(n){n=lu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return en.test(n)&&t.push(""),n.replace(un,function(n,r,e,u){
t.push(e?u.replace(vn,"$1"):r||n)}),t}),Ao=lr(function(n,t){return _u(n)?jt(n,kt(t,1,_u,true)):[]}),ko=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),je(r,2)):[]}),Eo=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),F,r):[]}),Oo=lr(function(n){var t=l(n,Sr);return t.length&&t[0]===n[0]?Ut(t):[]}),So=lr(function(n){var t=Ge(n),r=l(n,Sr);return t===Ge(r)?t=F:r.pop(),r.length&&r[0]===n[0]?Ut(r,je(t,2)):[]}),Io=lr(function(n){var t=Ge(n),r=l(n,Sr);return(t=typeof t=="function"?t:F)&&r.pop(),
r.length&&r[0]===n[0]?Ut(r,F,t):[]}),Ro=lr(He),zo=ge(function(n,t){var r=null==n?0:n.length,e=vt(n,t);return fr(n,l(t,function(n){return Re(n,r)?+n:n}).sort(Ur)),e}),Wo=lr(function(n){return wr(kt(n,1,_u,true))}),Bo=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),wr(kt(n,1,_u,true),je(t,2))}),Lo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return wr(kt(n,1,_u,true),F,t)}),Uo=lr(function(n,t){return _u(n)?jt(n,t):[]}),Co=lr(function(n){return Er(f(n,_u))}),Do=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),
Er(f(n,_u),je(t,2))}),Mo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return Er(f(n,_u),F,t)}),To=lr(Ye),$o=lr(function(n){var t=n.length,t=1<t?n[t-1]:F,t=typeof t=="function"?(n.pop(),t):F;return Qe(n,t)}),Fo=ge(function(n){function t(t){return vt(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Mn&&Re(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(F),
n})):this.thru(t)}),No=Nr(function(n,t,r){ci.call(n,r)?++n[r]:_t(n,r,1)}),Po=Yr(Ze),Zo=Yr(qe),qo=Nr(function(n,t,r){ci.call(n,r)?n[r].push(t):_t(n,r,[t])}),Vo=lr(function(n,t,e){var u=-1,i=typeof t=="function",o=pu(n)?Hu(n.length):[];return oo(n,function(n){o[++u]=i?r(t,n,e):Dt(n,t,e)}),o}),Ko=Nr(function(n,t,r){_t(n,r,t)}),Go=Nr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ho=lr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&ze(n,t[0],t[1])?t=[]:2<r&&ze(t[0],t[1],t[2])&&(t=[t[0]]),
rr(n,kt(t,1),[])}),Jo=Si||function(){return Zn.Date.now()},Yo=lr(function(n,t,r){var e=1;if(r.length)var u=C(r,xe(Yo)),e=32|e;return le(n,e,t,r,u)}),Qo=lr(function(n,t,r){var e=3;if(r.length)var u=C(r,xe(Qo)),e=32|e;return le(t,e,n,r,u)}),Xo=lr(function(n,t){return xt(n,1,t)}),nf=lr(function(n,t,r){return xt(n,Iu(t)||0,r)});lu.Cache=Pn;var tf=lr(function(n,t){t=1==t.length&&af(t[0])?l(t[0],S(je())):l(kt(t,1),S(je()));var e=t.length;return lr(function(u){for(var i=-1,o=Mi(u.length,e);++i<o;)u[i]=t[i].call(this,u[i]);
return r(n,this,u)})}),rf=lr(function(n,t){return le(n,32,F,t,C(t,xe(rf)))}),ef=lr(function(n,t){return le(n,64,F,t,C(t,xe(ef)))}),uf=ge(function(n,t){return le(n,256,F,F,F,t)}),of=oe(Wt),ff=oe(function(n,t){return n>=t}),cf=Mt(function(){return arguments}())?Mt:function(n){return xu(n)&&ci.call(n,"callee")&&!ji.call(n,"callee")},af=Hu.isArray,lf=Hn?S(Hn):Tt,sf=Bi||Gu,hf=Jn?S(Jn):$t,pf=Yn?S(Yn):Nt,_f=Qn?S(Qn):qt,vf=Xn?S(Xn):Vt,gf=nt?S(nt):Kt,df=oe(Jt),yf=oe(function(n,t){return n<=t}),bf=Pr(function(n,t){
if(Le(t)||pu(t))Tr(t,Lu(t),n);else for(var r in t)ci.call(t,r)&&at(n,r,t[r])}),xf=Pr(function(n,t){Tr(t,Uu(t),n)}),jf=Pr(function(n,t,r,e){Tr(t,Uu(t),n,e)}),wf=Pr(function(n,t,r,e){Tr(t,Lu(t),n,e)}),mf=ge(vt),Af=lr(function(n){return n.push(F,se),r(jf,F,n)}),kf=lr(function(n){return n.push(F,he),r(Rf,F,n)}),Ef=ne(function(n,t,r){n[t]=r},Fu(Nu)),Of=ne(function(n,t,r){ci.call(n,t)?n[t].push(r):n[t]=[r]},je),Sf=lr(Dt),If=Pr(function(n,t,r){nr(n,t,r)}),Rf=Pr(function(n,t,r,e){nr(n,t,r,e)}),zf=ge(function(n,t){
var r={};if(null==n)return r;var e=false;t=l(t,function(t){return t=Rr(t,n),e||(e=1<t.length),t}),Tr(n,ye(n),r),e&&(r=dt(r,7,pe));for(var u=t.length;u--;)mr(r,t[u]);return r}),Wf=ge(function(n,t){return null==n?{}:er(n,t)}),Bf=ae(Lu),Lf=ae(Uu),Uf=Gr(function(n,t,r){return t=t.toLowerCase(),n+(r?Mu(t):t)}),Cf=Gr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Df=Gr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Mf=Kr("toLowerCase"),Tf=Gr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase();
}),$f=Gr(function(n,t,r){return n+(r?" ":"")+Nf(t)}),Ff=Gr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Nf=Kr("toUpperCase"),Pf=lr(function(n,t){try{return r(n,F,t)}catch(n){return vu(n)?n:new Yu(n)}}),Zf=ge(function(n,t){return u(t,function(t){t=$e(t),_t(n,t,Yo(n[t],n))}),n}),qf=Qr(),Vf=Qr(true),Kf=lr(function(n,t){return function(r){return Dt(r,n,t)}}),Gf=lr(function(n,t){return function(r){return Dt(n,r,t)}}),Hf=re(l),Jf=re(o),Yf=re(_),Qf=ie(),Xf=ie(true),nc=te(function(n,t){return n+t},0),tc=ce("ceil"),rc=te(function(n,t){
return n/t},1),ec=ce("floor"),uc=te(function(n,t){return n*t},1),ic=ce("round"),oc=te(function(n,t){return n-t},0);return On.after=function(n,t){if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){if(1>--n)return t.apply(this,arguments)}},On.ary=iu,On.assign=bf,On.assignIn=xf,On.assignInWith=jf,On.assignWith=wf,On.at=mf,On.before=ou,On.bind=Yo,On.bindAll=Zf,On.bindKey=Qo,On.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return af(n)?n:[n]},
On.chain=Xe,On.chunk=function(n,t,r){if(t=(r?ze(n,t,r):t===F)?1:Di(Ou(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Hu(Ri(r/t));e<r;)i[u++]=vr(n,e,e+=t);return i},On.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u},On.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Hu(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return s(af(r)?Mr(r):[r],kt(t,1))},On.cond=function(n){var t=null==n?0:n.length,e=je();return n=t?l(n,function(n){
if("function"!=typeof n[1])throw new ei("Expected a function");return[e(n[0]),n[1]]}):[],lr(function(e){for(var u=-1;++u<t;){var i=n[u];if(r(i[0],this,e))return r(i[1],this,e)}})},On.conforms=function(n){return yt(dt(n,1))},On.constant=Fu,On.countBy=No,On.create=function(n,t){var r=io(n);return null==t?r:ht(r,t)},On.curry=fu,On.curryRight=cu,On.debounce=au,On.defaults=Af,On.defaultsDeep=kf,On.defer=Xo,On.delay=nf,On.difference=Ao,On.differenceBy=ko,On.differenceWith=Eo,On.drop=function(n,t,r){var e=null==n?0:n.length;
return e?(t=r||t===F?1:Ou(t),vr(n,0>t?0:t,e)):[]},On.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0,0>t?0:t)):[]},On.dropRightWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true,true):[]},On.dropWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true):[]},On.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&ze(n,t,r)&&(r=0,e=u),u=n.length,r=Ou(r),0>r&&(r=-r>u?0:u+r),e=e===F||e>u?u:Ou(e),0>e&&(e+=u),e=r>e?0:Su(e);r<e;)n[r++]=t;
return n},On.filter=function(n,t){return(af(n)?f:At)(n,je(t,3))},On.flatMap=function(n,t){return kt(uu(n,t),1)},On.flatMapDeep=function(n,t){return kt(uu(n,t),N)},On.flatMapDepth=function(n,t,r){return r=r===F?1:Ou(r),kt(uu(n,t),r)},On.flatten=Ve,On.flattenDeep=function(n){return(null==n?0:n.length)?kt(n,N):[]},On.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===F?1:Ou(t),kt(n,t)):[]},On.flip=function(n){return le(n,512)},On.flow=qf,On.flowRight=Vf,On.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){
var u=n[t];e[u[0]]=u[1]}return e},On.functions=function(n){return null==n?[]:St(n,Lu(n))},On.functionsIn=function(n){return null==n?[]:St(n,Uu(n))},On.groupBy=qo,On.initial=function(n){return(null==n?0:n.length)?vr(n,0,-1):[]},On.intersection=Oo,On.intersectionBy=So,On.intersectionWith=Io,On.invert=Ef,On.invertBy=Of,On.invokeMap=Vo,On.iteratee=Pu,On.keyBy=Ko,On.keys=Lu,On.keysIn=Uu,On.map=uu,On.mapKeys=function(n,t){var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,t(n,e,u),n)}),r},On.mapValues=function(n,t){
var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,e,t(n,e,u))}),r},On.matches=function(n){return Qt(dt(n,1))},On.matchesProperty=function(n,t){return Xt(n,dt(t,1))},On.memoize=lu,On.merge=If,On.mergeWith=Rf,On.method=Kf,On.methodOf=Gf,On.mixin=Zu,On.negate=su,On.nthArg=function(n){return n=Ou(n),lr(function(t){return tr(t,n)})},On.omit=zf,On.omitBy=function(n,t){return Cu(n,su(je(t)))},On.once=function(n){return ou(2,n)},On.orderBy=function(n,t,r,e){return null==n?[]:(af(t)||(t=null==t?[]:[t]),
r=e?F:r,af(r)||(r=null==r?[]:[r]),rr(n,t,r))},On.over=Hf,On.overArgs=tf,On.overEvery=Jf,On.overSome=Yf,On.partial=rf,On.partialRight=ef,On.partition=Go,On.pick=Wf,On.pickBy=Cu,On.property=Vu,On.propertyOf=function(n){return function(t){return null==n?F:It(n,t)}},On.pull=Ro,On.pullAll=He,On.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,je(r,2)):n},On.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,F,r):n},On.pullAt=zo,On.range=Qf,On.rangeRight=Xf,On.rearg=uf,On.reject=function(n,t){
return(af(n)?f:At)(n,su(je(t,3)))},On.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=je(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return fr(n,u),r},On.rest=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=t===F?t:Ou(t),lr(n,t)},On.reverse=Je,On.sampleSize=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),(af(n)?ot:hr)(n,t)},On.set=function(n,t,r){return null==n?n:pr(n,t,r)},On.setWith=function(n,t,r,e){return e=typeof e=="function"?e:F,
null==n?n:pr(n,t,r,e)},On.shuffle=function(n){return(af(n)?ft:_r)(n)},On.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&ze(n,t,r)?(t=0,r=e):(t=null==t?0:Ou(t),r=r===F?e:Ou(r)),vr(n,t,r)):[]},On.sortBy=Ho,On.sortedUniq=function(n){return n&&n.length?br(n):[]},On.sortedUniqBy=function(n,t){return n&&n.length?br(n,je(t,2)):[]},On.split=function(n,t,r){return r&&typeof r!="number"&&ze(n,t,r)&&(t=r=F),r=r===F?4294967295:r>>>0,r?(n=zu(n))&&(typeof t=="string"||null!=t&&!_f(t))&&(t=jr(t),
!t&&Bn.test(n))?zr($(n),0,r):n.split(t,r):[]},On.spread=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=null==t?0:Di(Ou(t),0),lr(function(e){var u=e[t];return e=zr(e,0,t),u&&s(e,u),r(n,this,e)})},On.tail=function(n){var t=null==n?0:n.length;return t?vr(n,1,t):[]},On.take=function(n,t,r){return n&&n.length?(t=r||t===F?1:Ou(t),vr(n,0,0>t?0:t)):[]},On.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0>t?0:t,e)):[]},On.takeRightWhile=function(n,t){
return n&&n.length?Ar(n,je(t,3),false,true):[]},On.takeWhile=function(n,t){return n&&n.length?Ar(n,je(t,3)):[]},On.tap=function(n,t){return t(n),n},On.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ei("Expected a function");return bu(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),au(n,t,{leading:e,maxWait:t,trailing:u})},On.thru=nu,On.toArray=ku,On.toPairs=Bf,On.toPairsIn=Lf,On.toPath=function(n){return af(n)?l(n,$e):Au(n)?[n]:Mr(mo(zu(n)))},On.toPlainObject=Ru,
On.transform=function(n,t,r){var e=af(n),i=e||sf(n)||gf(n);if(t=je(t,4),null==r){var o=n&&n.constructor;r=i?e?new o:[]:bu(n)&&gu(o)?io(bi(n)):{}}return(i?u:Et)(n,function(n,e,u){return t(r,n,e,u)}),r},On.unary=function(n){return iu(n,1)},On.union=Wo,On.unionBy=Bo,On.unionWith=Lo,On.uniq=function(n){return n&&n.length?wr(n):[]},On.uniqBy=function(n,t){return n&&n.length?wr(n,je(t,2)):[]},On.uniqWith=function(n,t){return t=typeof t=="function"?t:F,n&&n.length?wr(n,F,t):[]},On.unset=function(n,t){return null==n||mr(n,t);
},On.unzip=Ye,On.unzipWith=Qe,On.update=function(n,t,r){return null==n?n:pr(n,t,Ir(r)(It(n,t)),void 0)},On.updateWith=function(n,t,r,e){return e=typeof e=="function"?e:F,null!=n&&(n=pr(n,t,Ir(r)(It(n,t)),e)),n},On.values=Du,On.valuesIn=function(n){return null==n?[]:I(n,Uu(n))},On.without=Uo,On.words=$u,On.wrap=function(n,t){return rf(Ir(t),n)},On.xor=Co,On.xorBy=Do,On.xorWith=Mo,On.zip=To,On.zipObject=function(n,t){return Or(n||[],t||[],at)},On.zipObjectDeep=function(n,t){return Or(n||[],t||[],pr);
},On.zipWith=$o,On.entries=Bf,On.entriesIn=Lf,On.extend=xf,On.extendWith=jf,Zu(On,On),On.add=nc,On.attempt=Pf,On.camelCase=Uf,On.capitalize=Mu,On.ceil=tc,On.clamp=function(n,t,r){return r===F&&(r=t,t=F),r!==F&&(r=Iu(r),r=r===r?r:0),t!==F&&(t=Iu(t),t=t===t?t:0),gt(Iu(n),t,r)},On.clone=function(n){return dt(n,4)},On.cloneDeep=function(n){return dt(n,5)},On.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,5,t)},On.cloneWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,4,t)},
On.conformsTo=function(n,t){return null==t||bt(n,t,Lu(t))},On.deburr=Tu,On.defaultTo=function(n,t){return null==n||n!==n?t:n},On.divide=rc,On.endsWith=function(n,t,r){n=zu(n),t=jr(t);var e=n.length,e=r=r===F?e:gt(Ou(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},On.eq=hu,On.escape=function(n){return(n=zu(n))&&Y.test(n)?n.replace(H,et):n},On.escapeRegExp=function(n){return(n=zu(n))&&fn.test(n)?n.replace(on,"\\$&"):n},On.every=function(n,t,r){var e=af(n)?o:wt;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3));
},On.find=Po,On.findIndex=Ze,On.findKey=function(n,t){return v(n,je(t,3),Et)},On.findLast=Zo,On.findLastIndex=qe,On.findLastKey=function(n,t){return v(n,je(t,3),Ot)},On.floor=ec,On.forEach=ru,On.forEachRight=eu,On.forIn=function(n,t){return null==n?n:co(n,je(t,3),Uu)},On.forInRight=function(n,t){return null==n?n:ao(n,je(t,3),Uu)},On.forOwn=function(n,t){return n&&Et(n,je(t,3))},On.forOwnRight=function(n,t){return n&&Ot(n,je(t,3))},On.get=Wu,On.gt=of,On.gte=ff,On.has=function(n,t){return null!=n&&ke(n,t,Bt);
},On.hasIn=Bu,On.head=Ke,On.identity=Nu,On.includes=function(n,t,r,e){return n=pu(n)?n:Du(n),r=r&&!e?Ou(r):0,e=n.length,0>r&&(r=Di(e+r,0)),mu(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<d(n,t,r)},On.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),d(n,t,r)):-1},On.inRange=function(n,t,r){return t=Eu(t),r===F?(r=t,t=0):r=Eu(r),n=Iu(n),n>=Mi(t,r)&&n<Di(t,r)},On.invoke=Sf,On.isArguments=cf,On.isArray=af,On.isArrayBuffer=lf,On.isArrayLike=pu,On.isArrayLikeObject=_u,
On.isBoolean=function(n){return true===n||false===n||xu(n)&&"[object Boolean]"==zt(n)},On.isBuffer=sf,On.isDate=hf,On.isElement=function(n){return xu(n)&&1===n.nodeType&&!wu(n)},On.isEmpty=function(n){if(null==n)return true;if(pu(n)&&(af(n)||typeof n=="string"||typeof n.splice=="function"||sf(n)||gf(n)||cf(n)))return!n.length;var t=yo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(Le(n))return!Ht(n).length;for(var r in n)if(ci.call(n,r))return false;return true},On.isEqual=function(n,t){return Ft(n,t);
},On.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:F)?r(n,t):F;return e===F?Ft(n,t,F,r):!!e},On.isError=vu,On.isFinite=function(n){return typeof n=="number"&&Li(n)},On.isFunction=gu,On.isInteger=du,On.isLength=yu,On.isMap=pf,On.isMatch=function(n,t){return n===t||Pt(n,t,me(t))},On.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:F,Pt(n,t,me(t),r)},On.isNaN=function(n){return ju(n)&&n!=+n},On.isNative=function(n){if(bo(n))throw new Yu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
return Zt(n)},On.isNil=function(n){return null==n},On.isNull=function(n){return null===n},On.isNumber=ju,On.isObject=bu,On.isObjectLike=xu,On.isPlainObject=wu,On.isRegExp=_f,On.isSafeInteger=function(n){return du(n)&&-9007199254740991<=n&&9007199254740991>=n},On.isSet=vf,On.isString=mu,On.isSymbol=Au,On.isTypedArray=gf,On.isUndefined=function(n){return n===F},On.isWeakMap=function(n){return xu(n)&&"[object WeakMap]"==yo(n)},On.isWeakSet=function(n){return xu(n)&&"[object WeakSet]"==zt(n)},On.join=function(n,t){
return null==n?"":Ui.call(n,t)},On.kebabCase=Cf,On.last=Ge,On.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==F&&(u=Ou(r),u=0>u?Di(e+u,0):Mi(u,e-1)),t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=g(n,b,u,true);return n},On.lowerCase=Df,On.lowerFirst=Mf,On.lt=df,On.lte=yf,On.max=function(n){return n&&n.length?mt(n,Nu,Wt):F},On.maxBy=function(n,t){return n&&n.length?mt(n,je(t,2),Wt):F},On.mean=function(n){return x(n,Nu)},On.meanBy=function(n,t){return x(n,je(t,2))},On.min=function(n){
return n&&n.length?mt(n,Nu,Jt):F},On.minBy=function(n,t){return n&&n.length?mt(n,je(t,2),Jt):F},On.stubArray=Ku,On.stubFalse=Gu,On.stubObject=function(){return{}},On.stubString=function(){return""},On.stubTrue=function(){return true},On.multiply=uc,On.nth=function(n,t){return n&&n.length?tr(n,Ou(t)):F},On.noConflict=function(){return Zn._===this&&(Zn._=pi),this},On.noop=qu,On.now=Jo,On.pad=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return!t||e>=t?n:(t=(t-e)/2,ee(zi(t),r)+n+ee(Ri(t),r))},On.padEnd=function(n,t,r){
n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?n+ee(t-e,r):n},On.padStart=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?ee(t-e,r)+n:n},On.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),$i(zu(n).replace(an,""),t||0)},On.random=function(n,t,r){if(r&&typeof r!="boolean"&&ze(n,t,r)&&(t=r=F),r===F&&(typeof t=="boolean"?(r=t,t=F):typeof n=="boolean"&&(r=n,n=F)),n===F&&t===F?(n=0,t=1):(n=Eu(n),t===F?(t=n,n=0):t=Eu(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Fi(),Mi(n+r*(t-n+$n("1e-"+((r+"").length-1))),t)):cr(n,t);
},On.reduce=function(n,t,r){var e=af(n)?h:m,u=3>arguments.length;return e(n,je(t,4),r,u,oo)},On.reduceRight=function(n,t,r){var e=af(n)?p:m,u=3>arguments.length;return e(n,je(t,4),r,u,fo)},On.repeat=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),ar(zu(n),t)},On.replace=function(){var n=arguments,t=zu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},On.result=function(n,t,r){t=Rr(t,n);var e=-1,u=t.length;for(u||(u=1,n=F);++e<u;){var i=null==n?F:n[$e(t[e])];i===F&&(e=u,i=r),n=gu(i)?i.call(n):i;
}return n},On.round=ic,On.runInContext=w,On.sample=function(n){return(af(n)?tt:sr)(n)},On.size=function(n){if(null==n)return 0;if(pu(n))return mu(n)?T(n):n.length;var t=yo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Ht(n).length},On.snakeCase=Tf,On.some=function(n,t,r){var e=af(n)?_:gr;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3))},On.sortedIndex=function(n,t){return dr(n,t)},On.sortedIndexBy=function(n,t,r){return yr(n,t,je(r,2))},On.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){
var e=dr(n,t);if(e<r&&hu(n[e],t))return e}return-1},On.sortedLastIndex=function(n,t){return dr(n,t,true)},On.sortedLastIndexBy=function(n,t,r){return yr(n,t,je(r,2),true)},On.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=dr(n,t,true)-1;if(hu(n[r],t))return r}return-1},On.startCase=$f,On.startsWith=function(n,t,r){return n=zu(n),r=null==r?0:gt(Ou(r),0,n.length),t=jr(t),n.slice(r,r+t.length)==t},On.subtract=oc,On.sum=function(n){return n&&n.length?k(n,Nu):0},On.sumBy=function(n,t){return n&&n.length?k(n,je(t,2)):0;
},On.template=function(n,t,r){var e=On.templateSettings;r&&ze(n,t,r)&&(t=F),n=zu(n),t=jf({},t,e,se),r=jf({},t.imports,e.imports,se);var u,i,o=Lu(r),f=I(r,o),c=0;r=t.interpolate||An;var a="__p+='";r=ti((t.escape||An).source+"|"+r.source+"|"+(r===nn?gn:An).source+"|"+(t.evaluate||An).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(kn,B),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),
e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(q,""):a).replace(V,"$1").replace(K,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Pf(function(){return Qu(o,l+"return "+a).apply(F,f)}),t.source=a,vu(t))throw t;return t},On.times=function(n,t){if(n=Ou(n),1>n||9007199254740991<n)return[];
var r=4294967295,e=Mi(n,4294967295);for(t=je(t),n-=4294967295,e=E(e,t);++r<n;)t(r);return e},On.toFinite=Eu,On.toInteger=Ou,On.toLength=Su,On.toLower=function(n){return zu(n).toLowerCase()},On.toNumber=Iu,On.toSafeInteger=function(n){return n?gt(Ou(n),-9007199254740991,9007199254740991):0===n?n:0},On.toString=zu,On.toUpper=function(n){return zu(n).toUpperCase()},On.trim=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(cn,""):n&&(t=jr(t))?(n=$(n),r=$(t),t=z(n,r),r=W(n,r)+1,zr(n,t,r).join("")):n;
},On.trimEnd=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(ln,""):n&&(t=jr(t))?(n=$(n),t=W(n,$(t))+1,zr(n,0,t).join("")):n},On.trimStart=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(an,""):n&&(t=jr(t))?(n=$(n),t=z(n,$(t)),zr(n,t).join("")):n},On.truncate=function(n,t){var r=30,e="...";if(bu(t))var u="separator"in t?t.separator:u,r="length"in t?Ou(t.length):r,e="omission"in t?jr(t.omission):e;n=zu(n);var i=n.length;if(Bn.test(n))var o=$(n),i=o.length;if(r>=i)return n;if(i=r-T(e),1>i)return e;
if(r=o?zr(o,0,i).join(""):n.slice(0,i),u===F)return r+e;if(o&&(i+=r.length-i),_f(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=ti(u.source,zu(dn.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===F?i:c)}}else n.indexOf(jr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},On.unescape=function(n){return(n=zu(n))&&J.test(n)?n.replace(G,ut):n},On.uniqueId=function(n){var t=++ai;return zu(n)+t},On.upperCase=Ff,On.upperFirst=Nf,On.each=ru,On.eachRight=eu,On.first=Ke,
Zu(On,function(){var n={};return Et(On,function(t,r){ci.call(On.prototype,r)||(n[r]=t)}),n}(),{chain:false}),On.VERSION="4.17.4",u("bind bindKey curry curryRight partial partialRight".split(" "),function(n){On[n].placeholder=On}),u(["drop","take"],function(n,t){Mn.prototype[n]=function(r){r=r===F?1:Di(Ou(r),0);var e=this.__filtered__&&!t?new Mn(this):this.clone();return e.__filtered__?e.__takeCount__=Mi(r,e.__takeCount__):e.__views__.push({size:Mi(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Mn.prototype[n+"Right"]=function(t){
return this.reverse()[n](t).reverse()}}),u(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Mn.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:je(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),u(["head","last"],function(n,t){var r="take"+(t?"Right":"");Mn.prototype[n]=function(){return this[r](1).value()[0]}}),u(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Mn.prototype[n]=function(){return this.__filtered__?new Mn(this):this[r](1);
}}),Mn.prototype.compact=function(){return this.filter(Nu)},Mn.prototype.find=function(n){return this.filter(n).head()},Mn.prototype.findLast=function(n){return this.reverse().find(n)},Mn.prototype.invokeMap=lr(function(n,t){return typeof n=="function"?new Mn(this):this.map(function(r){return Dt(r,n,t)})}),Mn.prototype.reject=function(n){return this.filter(su(je(n)))},Mn.prototype.slice=function(n,t){n=Ou(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Mn(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),
t!==F&&(t=Ou(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Mn.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Mn.prototype.toArray=function(){return this.take(4294967295)},Et(Mn.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=On[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(On.prototype[t]=function(){function t(n){return n=u.apply(On,s([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Mn,a=f[0],l=c||af(o);
l&&r&&typeof a=="function"&&1!=a.length&&(c=l=false);var h=this.__chain__,p=!!this.__actions__.length,a=i&&!h,c=c&&!p;return!i&&l?(o=c?o:new Mn(this),o=n.apply(o,f),o.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(o,h)):a&&c?n.apply(this,f):(o=this.thru(t),a?e?o.value()[0]:o.value():o)})}),u("pop push shift sort splice unshift".split(" "),function(n){var t=ui[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);On.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){
var u=this.value();return t.apply(af(u)?u:[],n)}return this[r](function(r){return t.apply(af(r)?r:[],n)})}}),Et(Mn.prototype,function(n,t){var r=On[t];if(r){var e=r.name+"";(Ji[e]||(Ji[e]=[])).push({name:t,func:r})}}),Ji[Xr(F,2).name]=[{name:"wrapper",func:F}],Mn.prototype.clone=function(){var n=new Mn(this.__wrapped__);return n.__actions__=Mr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Mr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Mr(this.__views__),
n},Mn.prototype.reverse=function(){if(this.__filtered__){var n=new Mn(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Mn.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=af(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Mi(n,f+s);break;case"takeRight":f=Di(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,
o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Mi(n,this.__takeCount__),!e||!u&&i==n&&l==n)return kr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},On.prototype.at=Fo,On.prototype.chain=function(){return Xe(this)},On.prototype.commit=function(){return new zn(this.value(),this.__chain__)},On.prototype.next=function(){this.__values__===F&&(this.__values__=ku(this.value()));
var n=this.__index__>=this.__values__.length;return{done:n,value:n?F:this.__values__[this.__index__++]}},On.prototype.plant=function(n){for(var t,r=this;r instanceof Sn;){var e=Pe(r);e.__index__=0,e.__values__=F,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},On.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Mn?(this.__actions__.length&&(n=new Mn(this)),n=n.reverse(),n.__actions__.push({func:nu,args:[Je],thisArg:F}),new zn(n,this.__chain__)):this.thru(Je);
},On.prototype.toJSON=On.prototype.valueOf=On.prototype.value=function(){return kr(this.__wrapped__,this.__actions__)},On.prototype.first=On.prototype.head,Ai&&(On.prototype[Ai]=tu),On}(); true?(Zn._=it, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return it}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Vn?((Vn.exports=it)._=it,qn._=it):Zn._=it}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(60)(module)))

/***/ }),
/* 592 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduxFirestoreMiddleware = exports.CALL_FIRESTORE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(3);

var _constants = __webpack_require__(84);

function callFirestore(firebaseInstance, callInfoObj) {
  var method = callInfoObj.method;
  var modelArgs = callInfoObj.modelArgs,
      methodArgs = callInfoObj.methodArgs;

  if (!(0, _lodash.isArray)(modelArgs)) modelArgs = [modelArgs];
  if (!(0, _lodash.isArray)(methodArgs)) methodArgs = [methodArgs];
  if (!firebaseInstance || !firebaseInstance.firestore) {
    throw new Error('firestore is not a Firebase namespace');
  }

  return !methodArgs ? firebaseInstance.firestore()[method] : firebaseInstance.firestore()[method].apply(firebaseInstance, methodArgs);
}

var CALL_FIRESTORE = exports.CALL_FIRESTORE = 'CALL_FIRESTORE';

var typesMap = {
  get: [_constants.actionTypes.GET_REQUEST, _constants.actionTypes.GET_SUCCESS, _constants.actionTypes.GET_FAILURE]
};

var reduxFirestoreMiddleware = exports.reduxFirestoreMiddleware = function reduxFirestoreMiddleware(firestore) {
  return function (store) {
    return function (next) {
      return function (action) {
        var callAPI = action.type === CALL_FIRESTORE ? action : undefined;
        if (typeof callAPI === 'undefined') return next(action);

        var method = callAPI.method;


        if (typeof method === 'function') method = method(store.getState());

        if (typeof method !== 'string') throw new Error('Specify a method.');

        var args = callAPI.args;

        var types = typesMap[method];

        if (!Array.isArray(types) || types.length !== 3) {
          throw new Error('Expected an array of three action types.');
        }

        if (!types.every(function (type) {
          return typeof type === 'string';
        })) {
          throw new Error('Expected action types to be strings.');
        }

        function actionWith(data) {
          var finalAction = _extends({}, action, data);
          delete finalAction[CALL_FIRESTORE];
          return finalAction;
        }

        var _types = _slicedToArray(types, 3),
            requestType = _types[0],
            successType = _types[1],
            failureType = _types[2];

        next({ type: requestType });
        var callInfoObj = { method: method };
        return callFirestore(firestore, callInfoObj).then(function (response) {
          return next({ response: response, method: method, args: args, type: successType });
        }).catch(function (error) {
          return next(actionWith({
            type: failureType,
            error: error.message || error || 'Something bad happened'
          }));
        });
      };
    };
  };
};

exports.default = reduxFirestoreMiddleware;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkWithCredential = exports.reloadAuth = exports.updateEmail = exports.updateAuth = exports.updateProfile = exports.verifyPasswordResetCode = exports.confirmPasswordReset = exports.resetPassword = exports.createUser = exports.logout = exports.login = exports.init = exports.handleRedirectResult = exports.createUserProfile = exports.watchUserProfile = exports.unWatchUserProfile = undefined;

var _omit2 = __webpack_require__(290);

var _omit3 = _interopRequireDefault(_omit2);

var _forEach2 = __webpack_require__(205);

var _forEach3 = _interopRequireDefault(_forEach2);

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__(90);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(21);

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(52);

var _auth = __webpack_require__(206);

var _populate = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var dispatchLoginError = function dispatchLoginError(dispatch, authError) {
  return dispatch({
    type: _constants.actionTypes.LOGIN_ERROR,
    authError: authError
  });
};

var unWatchUserProfile = exports.unWatchUserProfile = function unWatchUserProfile(firebase) {
  var _firebase$_ = firebase._,
      authUid = _firebase$_.authUid,
      _firebase$_$config = _firebase$_.config,
      userProfile = _firebase$_$config.userProfile,
      useFirestoreForProfile = _firebase$_$config.useFirestoreForProfile;

  if (firebase._.profileWatch) {
    if (useFirestoreForProfile && firebase.firestore) {
      firebase._.profileWatch();
    } else {
      firebase.database().ref().child(userProfile + '/' + authUid).off('value', firebase._.profileWatch);
    }
    firebase._.profileWatch = null;
  }
};

var getProfileFromSnap = function getProfileFromSnap(snap) {
  if (snap && snap.val) {
    return snap.val();
  }
  if (snap && snap.data && snap.exists) {
    return snap.data();
  }
  return null;
};

var handleProfileWatchResponse = function handleProfileWatchResponse(dispatch, firebase, userProfileSnap) {
  var _firebase$_$config2 = firebase._.config,
      profileParamsToPopulate = _firebase$_$config2.profileParamsToPopulate,
      autoPopulateProfile = _firebase$_$config2.autoPopulateProfile;

  var profile = getProfileFromSnap(userProfileSnap);
  if (!profileParamsToPopulate || !(0, _isArray3.default)(profileParamsToPopulate) && !(0, _isString3.default)(profileParamsToPopulate)) {
    dispatch({ type: _constants.actionTypes.SET_PROFILE, profile: profile });
  } else {
    (0, _populate.promisesForPopulate)(firebase, userProfileSnap.key, profile, profileParamsToPopulate).then(function (data) {
      (0, _forEach3.default)(data, function (result, path) {
        dispatch({
          type: _constants.actionTypes.SET,
          path: path,
          data: result,
          timestamp: Date.now(),
          requesting: false,
          requested: true
        });
      });
      dispatch({
        type: _constants.actionTypes.SET_PROFILE,
        profile: profile
      });

      if (autoPopulateProfile) {
        console.warn('Auto populate is no longer supported. We are working on backwards compatibility for v2.0.0');
      }
    });
  }
};

var watchUserProfile = exports.watchUserProfile = function watchUserProfile(dispatch, firebase) {
  var _firebase$_2 = firebase._,
      authUid = _firebase$_2.authUid,
      _firebase$_2$config = _firebase$_2.config,
      userProfile = _firebase$_2$config.userProfile,
      useFirestoreForProfile = _firebase$_2$config.useFirestoreForProfile;

  unWatchUserProfile(firebase);

  if (userProfile) {
    if (useFirestoreForProfile && firebase.firestore) {
      firebase._.profileWatch = firebase.firestore().collection(userProfile).doc(authUid).onSnapshot(function (userProfileSnap) {
        return handleProfileWatchResponse(dispatch, firebase, userProfileSnap);
      });
    } else if (firebase.database) {
      firebase._.profileWatch = firebase.database().ref().child(userProfile + '/' + authUid).on('value', function (userProfileSnap) {
        return handleProfileWatchResponse(dispatch, firebase, userProfileSnap);
      });
    } else {
      throw new Error('Real Time Database or Firestore must be included to enable user profile');
    }
  }
};

var createUserProfile = exports.createUserProfile = function createUserProfile(dispatch, firebase, userData, profile) {
  var config = firebase._.config;

  if (!config.userProfile || !firebase.database && !firebase.firestore) {
    return Promise.resolve(userData);
  }

  if ((0, _isFunction3.default)(config.profileFactory)) {
    try {
      profile = config.profileFactory(userData, profile);
    } catch (err) {
      console.error('Error occured within profileFactory function:', err.message || err);
      return Promise.reject(err);
    }
  }
  if (config.useFirestoreForProfile) {
    return firebase.firestore().collection(config.userProfile).doc(userData.uid).get().then(function (profileSnap) {
      return !config.updateProfileOnLogin && profileSnap.exists ? profileSnap.data() : profileSnap.ref.set((0, _omit3.default)(profile, ['providerData'])).then(function () {
        return profile;
      });
    }).catch(function (err) {
      dispatch({ type: _constants.actionTypes.UNAUTHORIZED_ERROR, authError: err });
      return Promise.reject(err);
    });
  }

  return firebase.database().ref().child(config.userProfile + '/' + userData.uid).once('value').then(function (profileSnap) {
    return !config.updateProfileOnLogin && profileSnap.val() !== null ? profileSnap.val() : profileSnap.ref.update(profile).then(function () {
      return profile;
    });
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.UNAUTHORIZED_ERROR, authError: err });
    return Promise.reject(err);
  });
};

var setupPresence = function setupPresence(dispatch, firebase) {
  if (!firebase.database || !firebase.database.ServerValue) {
    return;
  }
  var ref = firebase.database().ref();
  var _firebase$_3 = firebase._,
      _firebase$_3$config = _firebase$_3.config,
      presence = _firebase$_3$config.presence,
      sessions = _firebase$_3$config.sessions,
      authUid = _firebase$_3.authUid;

  var amOnline = ref.child('.info/connected');
  var onlineRef = ref.child((0, _isFunction3.default)(presence) ? presence(firebase.auth().currentUser, firebase) : presence).child(authUid);
  var sessionsRef = (0, _isFunction3.default)(sessions) ? sessions(firebase.auth().currentUser, firebase) : sessions;
  if (sessionsRef) {
    sessionsRef = ref.child(sessions);
  }
  amOnline.on('value', function (snapShot) {
    if (!snapShot.val()) return;

    if (sessionsRef) {
      dispatch({ type: _constants.actionTypes.SESSION_START, payload: authUid });

      var session = sessionsRef.push({
        startedAt: firebase.database.ServerValue.TIMESTAMP,
        user: authUid
      });

      session.setPriority(authUid);
      var endedRef = session.child('endedAt');
      endedRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP, function () {
        dispatch({ type: _constants.actionTypes.SESSION_END });
      });
    }

    onlineRef.set(true);
    onlineRef.onDisconnect().remove();
  });
};

var handleAuthStateChange = function handleAuthStateChange(dispatch, firebase, authData) {
  var config = firebase._.config;

  if (!authData) {
    if ((0, _isFunction3.default)(config.onAuthStateChanged) && config.enableEmptyAuthChanges) {
      firebase._.config.onAuthStateChanged(authData, firebase, dispatch);
    }

    dispatch({ type: _constants.actionTypes.AUTH_EMPTY_CHANGE });
  } else {
    firebase._.authUid = authData.uid;
    if (config.presence && firebase.database && firebase.database.ServerValue) {
      setupPresence(dispatch, firebase);
    }

    watchUserProfile(dispatch, firebase);

    dispatch({ type: _constants.actionTypes.LOGIN, auth: authData });

    if ((0, _isFunction3.default)(config.onAuthStateChanged)) {
      config.onAuthStateChanged(authData, firebase, dispatch);
    }
  }
};

var handleRedirectResult = exports.handleRedirectResult = function handleRedirectResult(dispatch, firebase, authData) {
  if (typeof firebase._.config.onRedirectResult === 'function') {
    firebase._.config.onRedirectResult(authData, firebase, dispatch);
  }
  if (authData && authData.user) {
    var user = authData.user;


    firebase._.authUid = user.uid;
    watchUserProfile(dispatch, firebase);

    dispatch({ type: _constants.actionTypes.LOGIN, auth: user });

    createUserProfile(dispatch, firebase, user, {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    });
  }
};

var init = exports.init = function init(dispatch, firebase) {
  if (!firebase.auth) {
    return;
  }
  dispatch({ type: _constants.actionTypes.AUTHENTICATION_INIT_STARTED });

  firebase.auth().onAuthStateChanged(function (authData) {
    return handleAuthStateChange(dispatch, firebase, authData);
  });

  if (firebase._.config.enableRedirectHandling && (0, _isFunction3.default)(firebase.auth().getRedirectResult) && typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('http') !== -1) {
    firebase.auth().getRedirectResult().then(function (authData) {
      return handleRedirectResult(dispatch, firebase, authData);
    }).catch(function (error) {
      dispatchLoginError(dispatch, error);
      return Promise.reject(error);
    });
  }

  firebase.auth().currentUser;

  dispatch({ type: _constants.actionTypes.AUTHENTICATION_INIT_FINISHED });
};
var login = exports.login = function login(dispatch, firebase, credentials) {
  var _firebase$auth;

  if (firebase._.config.resetBeforeLogin) {
    dispatchLoginError(dispatch, null);
  }

  var _getLoginMethodAndPar = (0, _auth.getLoginMethodAndParams)(firebase, credentials),
      method = _getLoginMethodAndPar.method,
      params = _getLoginMethodAndPar.params;

  return (_firebase$auth = firebase.auth())[method].apply(_firebase$auth, _toConsumableArray(params)).then(function (userData) {
    if (!userData) return Promise.resolve(null);

    if (method === 'signInWithEmailAndPassword') {
      return { user: userData };
    }

    if (method === 'signInWithCustomToken') {
      if (!firebase._.config.updateProfileOnLogin) {
        return { user: userData };
      }
      return createUserProfile(dispatch, firebase, userData);
    }

    var user = userData.user || userData;

    return createUserProfile(dispatch, firebase, user, {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    }).then(function (profile) {
      return _extends({ profile: profile }, userData);
    });
  }).catch(function (err) {
    dispatchLoginError(dispatch, err);
    return Promise.reject(err);
  });
};

var logout = exports.logout = function logout(dispatch, firebase) {
  return firebase.auth().signOut().then(function () {
    dispatch({
      type: _constants.actionTypes.LOGOUT,
      preserve: firebase._.config.preserveOnLogout
    });
    firebase._.authUid = null;
    unWatchUserProfile(firebase);
    return firebase;
  });
};

var createUser = exports.createUser = function createUser(dispatch, firebase, _ref, profile) {
  var email = _ref.email,
      password = _ref.password,
      signIn = _ref.signIn;

  dispatchLoginError(dispatch, null);

  if (!email || !password) {
    dispatchLoginError(dispatch, new Error('Email and Password are required to create user'));
    return Promise.reject(new Error('Email and Password are Required'));
  }

  return firebase.auth().createUserWithEmailAndPassword(email, password).then(function (userData) {
    return firebase.auth().currentUser || !!signIn && signIn === false ? createUserProfile(dispatch, firebase, userData, profile || { email: email }) : login(dispatch, firebase, { email: email, password: password }).then(function () {
      return createUserProfile(dispatch, firebase, userData, profile || { email: email });
    }).catch(function (err) {
      if (err) {
        switch (err.code) {
          case 'auth/user-not-found':
            dispatchLoginError(dispatch, new Error('The specified user account does not exist.'));
            break;
          default:
            dispatchLoginError(dispatch, err);
        }
      }
      return Promise.reject(err);
    });
  }).catch(function (err) {
    dispatchLoginError(dispatch, err);
    return Promise.reject(err);
  });
};

var resetPassword = exports.resetPassword = function resetPassword(dispatch, firebase, email) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().sendPasswordResetEmail(email).catch(function (err) {
    if (err) {
      switch (err.code) {
        case 'auth/user-not-found':
          dispatchLoginError(dispatch, new Error('The specified user account does not exist.'));
          break;
        default:
          dispatchLoginError(dispatch, err);
      }
      return Promise.reject(err);
    }
  });
};

var confirmPasswordReset = exports.confirmPasswordReset = function confirmPasswordReset(dispatch, firebase, code, password) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().confirmPasswordReset(code, password).catch(function (err) {
    if (err) {
      switch (err.code) {
        case 'auth/expired-action-code':
          dispatchLoginError(dispatch, new Error('The action code has expired.'));
          break;
        case 'auth/invalid-action-code':
          dispatchLoginError(dispatch, new Error('The action code is invalid.'));
          break;
        case 'auth/user-disabled':
          dispatchLoginError(dispatch, new Error('The user is disabled.'));
          break;
        case 'auth/user-not-found':
          dispatchLoginError(dispatch, new Error('The user is not found.'));
          break;
        case 'auth/weak-password':
          dispatchLoginError(dispatch, new Error('The password is not strong enough.'));
          break;
        default:
          dispatchLoginError(dispatch, err);
      }
      return Promise.reject(err);
    }
  });
};

var verifyPasswordResetCode = exports.verifyPasswordResetCode = function verifyPasswordResetCode(dispatch, firebase, code) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().verifyPasswordResetCode(code).catch(function (err) {
    if (err) {
      dispatchLoginError(dispatch, err);
    }
    return Promise.reject(err);
  });
};

var updateProfile = exports.updateProfile = function updateProfile(dispatch, firebase, profileUpdate) {
  var database = firebase.database,
      _firebase$_4 = firebase._,
      config = _firebase$_4.config,
      authUid = _firebase$_4.authUid;

  dispatch({
    type: _constants.actionTypes.PROFILE_UPDATE_START,
    payload: profileUpdate
  });
  var profileRef = database().ref(config.userProfile + '/' + authUid);
  return profileRef.update(profileUpdate).then(function () {
    return profileRef.once('value').then(function (snap) {
      dispatch({
        type: _constants.actionTypes.PROFILE_UPDATE_SUCCESS,
        payload: snap.val()
      });
      return snap;
    });
  }).catch(function (payload) {
    dispatch({ type: _constants.actionTypes.PROFILE_UPDATE_ERROR, payload: payload });
    return Promise.reject(payload);
  });
};

var updateAuth = exports.updateAuth = function updateAuth(dispatch, firebase, authUpdate, updateInProfile) {
  dispatch({ type: _constants.actionTypes.AUTH_UPDATE_START, payload: authUpdate });

  if (!firebase.auth().currentUser) {
    var msg = 'User must be logged in to update auth.';
    dispatch({ type: _constants.actionTypes.AUTH_UPDATE_ERROR, payload: msg });
    return Promise.reject(msg);
  }

  return firebase.auth().currentUser.updateProfile(authUpdate).then(function (payload) {
    dispatch({
      type: _constants.actionTypes.AUTH_UPDATE_SUCCESS,
      payload: firebase.auth().currentUser
    });
    if (updateInProfile) {
      return updateProfile(dispatch, firebase, authUpdate);
    }
    return payload;
  }).catch(function (payload) {
    dispatch({ type: _constants.actionTypes.AUTH_UPDATE_ERROR, payload: payload });
    return Promise.reject(payload);
  });
};

var updateEmail = exports.updateEmail = function updateEmail(dispatch, firebase, newEmail, updateInProfile) {
  dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_START, payload: newEmail });

  if (!firebase.auth().currentUser) {
    var msg = 'User must be logged in to update email.';
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_ERROR, payload: msg });
    return Promise.reject(msg);
  }

  return firebase.auth().currentUser.updateEmail(newEmail).then(function (payload) {
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_SUCCESS, payload: newEmail });
    if (updateInProfile) {
      return updateProfile(dispatch, firebase, { email: newEmail });
    }
    return payload;
  }).catch(function (payload) {
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_ERROR, payload: payload });
    return Promise.reject(payload);
  });
};

var reloadAuth = exports.reloadAuth = function reloadAuth(dispatch, firebase) {
  dispatch({ type: _constants.actionTypes.AUTH_RELOAD_START });

  if (!firebase.auth().currentUser) {
    var err = new Error('Must be logged in to reload auth');
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_ERROR, payload: err });
    return Promise.reject(err);
  }

  return firebase.auth().currentUser.reload().then(function () {
    var auth = firebase.auth().currentUser;
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_SUCCESS, payload: auth });
    return auth;
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_ERROR, payload: err });
    return Promise.reject(err);
  });
};

var linkWithCredential = exports.linkWithCredential = function linkWithCredential(dispatch, firebase, credential) {
  dispatch({ type: _constants.actionTypes.AUTH_LINK_START });

  if (!firebase.auth().currentUser) {
    var err = new Error('Must be logged in to linkWithCredential');
    dispatch({ type: _constants.actionTypes.AUTH_LINK_ERROR, payload: err });
    return Promise.reject(err);
  }

  return firebase.auth().currentUser.linkWithCredential(credential).then(function (auth) {
    dispatch({ type: _constants.actionTypes.AUTH_LINK_SUCCESS, payload: auth });
    return auth;
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.AUTH_LINK_ERROR, payload: err });
    return Promise.reject(err);
  });
};

exports.default = {
  dispatchLoginError: dispatchLoginError,
  unWatchUserProfile: unWatchUserProfile,
  watchUserProfile: watchUserProfile,
  init: init,
  createUserProfile: createUserProfile,
  login: login,
  logout: logout,
  createUser: createUser,
  resetPassword: resetPassword,
  confirmPasswordReset: confirmPasswordReset,
  verifyPasswordResetCode: verifyPasswordResetCode,
  updateAuth: updateAuth,
  updateProfile: updateProfile,
  updateEmail: updateEmail,
  reloadAuth: reloadAuth
};

/***/ }),
/* 595 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(134);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(134);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(134);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(134);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(133);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 602 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 603 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(133),
    Map = __webpack_require__(191),
    MapCache = __webpack_require__(192);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(41),
    isMasked = __webpack_require__(608),
    isObject = __webpack_require__(28),
    toSource = __webpack_require__(292);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(609);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(34);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 610 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(612),
    ListCache = __webpack_require__(133),
    Map = __webpack_require__(191);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(613),
    hashDelete = __webpack_require__(614),
    hashGet = __webpack_require__(615),
    hashHas = __webpack_require__(616),
    hashSet = __webpack_require__(617);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(135);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 614 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(135);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(135);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(135);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 619 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(136);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 623 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isLength = __webpack_require__(194),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 627 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(291);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(296);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keysIn = __webpack_require__(143);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28),
    isPrototype = __webpack_require__(142),
    nativeKeysIn = __webpack_require__(632);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbols = __webpack_require__(196);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbolsIn = __webpack_require__(300);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(34);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(34);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(71),
    root = __webpack_require__(34);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(200),
    cloneDataView = __webpack_require__(640),
    cloneMap = __webpack_require__(641),
    cloneRegExp = __webpack_require__(643),
    cloneSet = __webpack_require__(644),
    cloneSymbol = __webpack_require__(646),
    cloneTypedArray = __webpack_require__(308);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(200);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(642),
    arrayReduce = __webpack_require__(201),
    mapToArray = __webpack_require__(306);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 642 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(645),
    arrayReduce = __webpack_require__(201),
    setToArray = __webpack_require__(307);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(648);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(192);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85),
    arrayMap = __webpack_require__(131),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(106);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(146),
    baseSlice = __webpack_require__(313);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(314);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(315);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85),
    isArguments = __webpack_require__(140),
    isArray = __webpack_require__(21);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(655),
    defineProperty = __webpack_require__(293),
    identity = __webpack_require__(107);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(65);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(107);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(145),
    upperFirst = __webpack_require__(660);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(661);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(662),
    hasUnicode = __webpack_require__(207),
    stringToArray = __webpack_require__(663),
    toString = __webpack_require__(145);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(313);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(664),
    hasUnicode = __webpack_require__(207),
    unicodeToArray = __webpack_require__(665);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 664 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(89);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(669),
    getMatchData = __webpack_require__(677),
    matchesStrictComparable = __webpack_require__(324);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(132),
    baseIsEqual = __webpack_require__(208);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(132),
    equalArrays = __webpack_require__(321),
    equalByTag = __webpack_require__(675),
    equalObjects = __webpack_require__(676),
    getTag = __webpack_require__(199),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(141),
    isTypedArray = __webpack_require__(193);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(192),
    setCacheAdd = __webpack_require__(672),
    setCacheHas = __webpack_require__(673);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(85),
    Uint8Array = __webpack_require__(305),
    eq = __webpack_require__(104),
    equalArrays = __webpack_require__(321),
    mapToArray = __webpack_require__(306),
    setToArray = __webpack_require__(307);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(301);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(323),
    keys = __webpack_require__(86);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(208),
    get = __webpack_require__(149),
    hasIn = __webpack_require__(325),
    isKey = __webpack_require__(202),
    isStrictComparable = __webpack_require__(323),
    matchesStrictComparable = __webpack_require__(324),
    toKey = __webpack_require__(73);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 679 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(327),
    basePropertyDeep = __webpack_require__(681),
    isKey = __webpack_require__(202),
    toKey = __webpack_require__(73);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(146);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(89),
    isArrayLike = __webpack_require__(65);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(298),
    baseFilter = __webpack_require__(685),
    baseIteratee = __webpack_require__(66),
    isArray = __webpack_require__(21);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(89);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(687),
    hasUnicode = __webpack_require__(207),
    unicodeSize = __webpack_require__(688);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(327);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(690);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(64),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteFile = exports.uploadFiles = exports.uploadFile = exports.uploadFileWithProgress = undefined;

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _map2 = __webpack_require__(150);

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(52);

var _actions = __webpack_require__(692);

var _storage = __webpack_require__(693);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FILE_UPLOAD_START = _constants.actionTypes.FILE_UPLOAD_START,
    FILE_UPLOAD_ERROR = _constants.actionTypes.FILE_UPLOAD_ERROR,
    FILE_UPLOAD_PROGRESS = _constants.actionTypes.FILE_UPLOAD_PROGRESS,
    FILE_UPLOAD_COMPLETE = _constants.actionTypes.FILE_UPLOAD_COMPLETE,
    FILE_DELETE_START = _constants.actionTypes.FILE_DELETE_START,
    FILE_DELETE_ERROR = _constants.actionTypes.FILE_DELETE_ERROR,
    FILE_DELETE_COMPLETE = _constants.actionTypes.FILE_DELETE_COMPLETE;
var uploadFileWithProgress = exports.uploadFileWithProgress = function uploadFileWithProgress(dispatch, firebase, _ref) {
  var path = _ref.path,
      file = _ref.file;

  dispatch({ type: FILE_UPLOAD_START, payload: { path: path, file: file } });
  var uploadEvent = firebase.storage().ref(path + '/' + file.name).put(file);

  var unListen = uploadEvent.on(firebase.storage.TaskEvent.STATE_CHANGED, {
    next: function next(snapshot) {
      dispatch({
        type: FILE_UPLOAD_PROGRESS,
        path: path,
        payload: {
          snapshot: snapshot,
          percent: Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100)
        }
      });
    },
    error: function error(err) {
      dispatch({ type: FILE_UPLOAD_ERROR, path: path, payload: err });
      unListen();
    },
    complete: function complete() {
      dispatch({ type: FILE_UPLOAD_COMPLETE, path: path, payload: file });
      unListen();
    }
  });
  return uploadEvent;
};

var uploadFile = exports.uploadFile = function uploadFile(dispatch, firebase, config) {
  var path = config.path,
      file = config.file,
      dbPath = config.dbPath,
      _config$options = config.options,
      options = _config$options === undefined ? {} : _config$options;

  var nameFromOptions = options.name && (0, _isFunction3.default)(options.name) ? options.name(file, firebase, config) : options.name;
  var filename = nameFromOptions || file.name;

  dispatch({ type: FILE_UPLOAD_START, payload: _extends({}, config, { filename: filename }) });

  return firebase.storage().ref(path + '/' + filename).put(file).then(function (uploadTaskSnaphot) {
    if (!dbPath || !firebase.database) {
      dispatch({
        type: FILE_UPLOAD_COMPLETE,
        meta: _extends({}, config, { filename: filename }),
        payload: { uploadTaskSnaphot: uploadTaskSnaphot }
      });
      return { uploadTaskSnaphot: uploadTaskSnaphot };
    }
    var _uploadTaskSnaphot$me = uploadTaskSnaphot.metadata,
        name = _uploadTaskSnaphot$me.name,
        fullPath = _uploadTaskSnaphot$me.fullPath,
        downloadURLs = _uploadTaskSnaphot$me.downloadURLs;
    var fileMetadataFactory = firebase._.config.fileMetadataFactory;

    var fileData = (0, _isFunction3.default)(fileMetadataFactory) ? fileMetadataFactory(uploadTaskSnaphot, firebase) : { name: name, fullPath: fullPath, downloadURL: downloadURLs[0] };

    return firebase.database().ref(dbPath).push(fileData).then(function (metaDataSnapshot) {
      var payload = {
        snapshot: metaDataSnapshot,
        key: metaDataSnapshot.key,
        File: fileData,
        uploadTaskSnaphot: uploadTaskSnaphot,
        metaDataSnapshot: metaDataSnapshot
      };
      dispatch({
        type: FILE_UPLOAD_COMPLETE,
        meta: _extends({}, config, { filename: filename }),
        payload: payload
      });
      return payload;
    });
  }).catch(function (err) {
    dispatch({ type: FILE_UPLOAD_ERROR, path: path, payload: err });
    return Promise.reject(err);
  });
};

var uploadFiles = function uploadFiles(dispatch, firebase, _ref2) {
  var files = _ref2.files,
      other = _objectWithoutProperties(_ref2, ['files']);

  return Promise.all((0, _map3.default)(files, function (file) {
    return uploadFile(dispatch, firebase, _extends({ file: file }, other));
  }));
};

exports.uploadFiles = uploadFiles;
var deleteFile = exports.deleteFile = function deleteFile(dispatch, firebase, _ref3) {
  var path = _ref3.path,
      dbPath = _ref3.dbPath;
  return (0, _actions.wrapInDispatch)(dispatch, {
    method: _storage.deleteFile,
    args: [firebase, { path: path, dbPath: dbPath }],
    types: [FILE_DELETE_START, FILE_DELETE_COMPLETE, FILE_DELETE_ERROR]
  });
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapInDispatch = undefined;

var _isObject2 = __webpack_require__(28);

var _isObject3 = _interopRequireDefault(_isObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var wrapInDispatch = exports.wrapInDispatch = function wrapInDispatch(dispatch, _ref) {
  var method = _ref.method,
      args = _ref.args,
      types = _ref.types;

  dispatch({
    type: (0, _isObject3.default)(types[0]) ? types[0].type : types[0],
    payload: (0, _isObject3.default)(types[0]) ? types[0].payload : { args: args }
  });
  return method.apply(undefined, _toConsumableArray(args)).then(function (val) {
    dispatch({
      type: types[1],
      payload: val
    });
    return val;
  }).catch(function (err) {
    dispatch({
      type: types[2],
      payload: err
    });
    return Promise.reject(err);
  });
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deleteFile = exports.deleteFile = function deleteFile(firebase, _ref) {
  var path = _ref.path,
      dbPath = _ref.dbPath;
  return firebase.storage().ref(path).delete().then(function () {
    return !dbPath || !firebase.database ? { path: path } : firebase.database().ref(dbPath).remove().then(function () {
      return { path: path, dbPath: dbPath };
    });
  });
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirebaseConnect = undefined;

var _isEqual2 = __webpack_require__(695);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(97);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _query = __webpack_require__(330);

var _utils = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFirebaseConnect = exports.createFirebaseConnect = function createFirebaseConnect() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function () {
    var dataOrFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (WrappedComponent) {
      var FirebaseConnect = function (_Component) {
        _inherits(FirebaseConnect, _Component);

        function FirebaseConnect() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, FirebaseConnect);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirebaseConnect.__proto__ || Object.getPrototypeOf(FirebaseConnect)).call.apply(_ref, [this].concat(args))), _this), _this.firebaseEvents = [], _this.firebase = null, _this.prevData = null, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(FirebaseConnect, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            var _context$storeKey = this.context[storeKey],
                firebase = _context$storeKey.firebase,
                dispatch = _context$storeKey.dispatch;

            var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
            this.prevData = inputAsFunc(this.props, firebase);

            var ref = firebase.ref,
                helpers = firebase.helpers,
                storage = firebase.storage,
                database = firebase.database,
                auth = firebase.auth;

            this.firebase = _extends({ ref: ref, storage: storage, database: database, auth: auth }, helpers);

            this._firebaseEvents = (0, _utils.getEventsFromInput)(this.prevData);

            (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _context$store = this.context.store,
                firebase = _context$store.firebase,
                dispatch = _context$store.dispatch;

            (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(np) {
            var _context$store2 = this.context.store,
                firebase = _context$store2.firebase,
                dispatch = _context$store2.dispatch;

            var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
            var data = inputAsFunc(np, firebase);

            if (!(0, _isEqual3.default)(data, this.prevData)) {
              this.prevData = data;

              (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);

              this._firebaseEvents = (0, _utils.getEventsFromInput)(data);

              (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
              firebase: this.firebase
            }));
          }
        }]);

        return FirebaseConnect;
      }(_react.Component);

      FirebaseConnect.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);
      FirebaseConnect.displayName = 'FirebaseConnect(' + (0, _utils.getDisplayName)(WrappedComponent) + ')';
      FirebaseConnect.wrappedComponent = WrappedComponent;


      return (0, _hoistNonReactStatics2.default)(FirebaseConnect, WrappedComponent);
    };
  };
};

exports.default = createFirebaseConnect();

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(208);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventsFromInput = exports.pathStrToObj = undefined;

var _remove2 = __webpack_require__(697);

var _remove3 = _interopRequireDefault(_remove2);

var _isString2 = __webpack_require__(90);

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = __webpack_require__(28);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(21);

var _isArray3 = _interopRequireDefault(_isArray2);

var _flatMap2 = __webpack_require__(699);

var _flatMap3 = _interopRequireDefault(_flatMap2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _populate = __webpack_require__(148);

var _query = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathStrToObj = exports.pathStrToObj = function pathStrToObj(path) {
  var pathObj = { path: path, type: 'value', isQuery: false };
  var queryId = (0, _query.getQueryIdFromPath)(path);

  if (queryId) {
    var pathArray = path.split('#');
    pathObj = _extends({}, pathObj, {
      queryId: queryId,
      isQuery: true,
      path: pathArray[0],
      queryParams: pathArray[1].split('&')
    });
    if ((0, _populate.getPopulates)(pathArray[1].split('&'))) {
      pathObj.populates = (0, _populate.getPopulates)(pathArray[1].split('&'));
      pathObj.queryParams = (0, _remove3.default)(pathArray[1].split('&'), function (p) {
        return p.indexOf('populate') === -1;
      });
    }
  }

  return pathObj;
};

var getEventsFromInput = exports.getEventsFromInput = function getEventsFromInput(paths) {
  return (0, _flatMap3.default)(paths, function (path) {
    if ((0, _isString3.default)(path)) {
      return [pathStrToObj(path)];
    }

    if ((0, _isArray3.default)(path)) {
      return [{ type: 'first_child', path: path[0] }, { type: 'child_added', path: path[0] }, { type: 'child_removed', path: path[0] }, { type: 'child_moved', path: path[0] }, { type: 'child_changed', path: path[0] }];
    }

    if ((0, _isObject3.default)(path)) {
      if (!path.path) {
        throw new Error('Path is a required parameter within definition object');
      }
      var strPath = path.path;

      if (path.queryParams) {
        strPath = strPath + '#' + path.queryParams.join('&');
      }

      path = _extends({}, pathStrToObj(strPath), path);
      return [path];
    }

    throw new Error('Invalid Path Definition: ' + path + '. Only strings, objects, and arrays accepted.');
  });
};

exports.default = { getEventsFromInput: getEventsFromInput };

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(66),
    basePullAt = __webpack_require__(698);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(310),
    isIndex = __webpack_require__(87);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(315),
    map = __webpack_require__(150);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirestoreConnect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(97);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFirestoreConnect = exports.createFirestoreConnect = function createFirestoreConnect() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function () {
    var dataOrFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (WrappedComponent) {
      var FirestoreConnect = function (_Component) {
        _inherits(FirestoreConnect, _Component);

        function FirestoreConnect() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, FirestoreConnect);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirestoreConnect.__proto__ || Object.getPrototypeOf(FirestoreConnect)).call.apply(_ref, [this].concat(args))), _this), _this.firebaseEvents = [], _this.firebase = null, _this.prevData = null, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(FirestoreConnect, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            var firebase = this.context[storeKey].firebase;

            if (firebase.firestore) {
              var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
              this.prevData = inputAsFunc(this.props, this.context[storeKey]);

              firebase.firestoreHelpers.setListeners(this.prevData);
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.prevData) {
              var firebase = this.context[storeKey].firebase;

              firebase.firestoreHelpers.unsetListeners(this.prevData);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var firebase = this.context[storeKey].firebase;

            return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
              firebase: _extends({ firebase: firebase }, firebase.helpers),
              firestore: _extends({}, firebase.firestore(), firebase.firestoreHelpers)
            }));
          }
        }]);

        return FirestoreConnect;
      }(_react.Component);

      FirestoreConnect.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);
      FirestoreConnect.displayName = 'FirestoreConnect(' + (0, _utils.getDisplayName)(WrappedComponent) + ')';
      FirestoreConnect.wrappedComponent = WrappedComponent;


      return (0, _hoistNonReactStatics2.default)(FirestoreConnect, WrappedComponent);
    };
  };
};

exports.default = createFirestoreConnect();

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWithFirebase = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(97);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createWithFirebase = exports.createWithFirebase = function createWithFirebase() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function (WrappedComponent) {
    var ChildComponent = function ChildComponent(props, context) {
      var _context$storeKey = undefined.context[storeKey],
          firebase = _context$storeKey.firebase,
          dispatch = _context$storeKey.dispatch;

      return _react2.default.createElement(WrappedComponent, _extends({}, props, {
        dispatch: dispatch,
        firebase: _extends({}, firebase, firebase.helpers)
      }));
    };

    ChildComponent.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);
    ChildComponent.wrappedComponent = WrappedComponent;
    ChildComponent.displayName = 'withFirebase(' + (0, _utils.getDisplayName)(WrappedComponent) + ')';

    return (0, _hoistNonReactStatics2.default)(ChildComponent, WrappedComponent);
  };
};

exports.default = createWithFirebase();

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirebase = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxFirestore = __webpack_require__(285);

var _createFirebaseInstance = __webpack_require__(288);

var _auth = __webpack_require__(206);

var _constants = __webpack_require__(52);

var _actions = __webpack_require__(289);

var firebaseInstance = void 0;

exports.default = function (instance, otherConfig) {
  return function (next) {
    return function (reducer, initialState, middleware) {
      var store = next(reducer, initialState, middleware);

      if (!instance.SDK_VERSION && !instance.firebase_ && !instance.database) {
        throw new Error('v2.0.0-beta and higher require passing a firebase app instance or a firebase library instance. View the migration guide for details.');
      }

      var configs = _extends({}, _constants.defaultConfig, otherConfig);
      firebaseInstance = (0, _createFirebaseInstance.createFirebaseInstance)(instance.firebase_ || instance, configs, store.dispatch);
      if (configs.includeFirestore) {
        firebaseInstance = (0, _reduxFirestore.createFirestoreInstance)(instance.firebase_ || instance, configs, store.dispatch);
      }

      _actions.authActions.init(store.dispatch, firebaseInstance);
      store.firebase = firebaseInstance;

      if (configs.attachAuthIsReady) {
        store.firebaseAuthIsReady = (0, _auth.createAuthIsReady)(store, configs);
      }

      return store;
    };
  };
};

var getFirebase = exports.getFirebase = function getFirebase() {
  if (!firebaseInstance) {
    throw new Error('Firebase instance does not yet exist. Check your compose function.');
  }

  return firebaseInstance;
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderedReducer = exports.dataReducer = exports.listenersReducer = exports.errorsReducer = exports.profileReducer = exports.authErrorReducer = exports.authReducer = exports.timestampsReducer = exports.requestedReducer = exports.requestingReducer = exports.isInitializingReducer = exports.getDotStrPath = undefined;

var _assign2 = __webpack_require__(704);

var _assign3 = _interopRequireDefault(_assign2);

var _setWith2 = __webpack_require__(735);

var _setWith3 = _interopRequireDefault(_setWith2);

var _get2 = __webpack_require__(149);

var _get3 = _interopRequireDefault(_get2);

var _omit2 = __webpack_require__(290);

var _omit3 = _interopRequireDefault(_omit2);

var _pick2 = __webpack_require__(737);

var _pick3 = _interopRequireDefault(_pick2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var START = _constants.actionTypes.START,
    SET = _constants.actionTypes.SET,
    SET_PROFILE = _constants.actionTypes.SET_PROFILE,
    MERGE = _constants.actionTypes.MERGE,
    LOGIN = _constants.actionTypes.LOGIN,
    LOGOUT = _constants.actionTypes.LOGOUT,
    LOGIN_ERROR = _constants.actionTypes.LOGIN_ERROR,
    REMOVE = _constants.actionTypes.REMOVE,
    NO_VALUE = _constants.actionTypes.NO_VALUE,
    SET_LISTENER = _constants.actionTypes.SET_LISTENER,
    UNSET_LISTENER = _constants.actionTypes.UNSET_LISTENER,
    AUTHENTICATION_INIT_STARTED = _constants.actionTypes.AUTHENTICATION_INIT_STARTED,
    AUTHENTICATION_INIT_FINISHED = _constants.actionTypes.AUTHENTICATION_INIT_FINISHED,
    AUTH_EMPTY_CHANGE = _constants.actionTypes.AUTH_EMPTY_CHANGE,
    AUTH_LINK_SUCCESS = _constants.actionTypes.AUTH_LINK_SUCCESS,
    UNAUTHORIZED_ERROR = _constants.actionTypes.UNAUTHORIZED_ERROR,
    AUTH_UPDATE_SUCCESS = _constants.actionTypes.AUTH_UPDATE_SUCCESS;

var pathToArr = function pathToArr(path) {
  return path ? path.split(/\//).filter(function (p) {
    return !!p;
  }) : [];
};

var getSlashStrPath = function getSlashStrPath(path) {
  return pathToArr(path).join('/');
};

var getDotStrPath = exports.getDotStrPath = function getDotStrPath(path) {
  return pathToArr(path).join('.');
};

var combineReducers = function combineReducers(reducers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return Object.keys(reducers).reduce(function (nextState, key) {
      nextState[key] = reducers[key](state[key], action);
      return nextState;
    }, {});
  };
};

var isInitializingReducer = exports.isInitializingReducer = function isInitializingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case AUTHENTICATION_INIT_STARTED:
      return true;
    case AUTHENTICATION_INIT_FINISHED:
      return false;
    default:
      return state;
  }
};

var requestingReducer = exports.requestingReducer = function requestingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      path = _ref.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), true));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), false));
    default:
      return state;
  }
};

var requestedReducer = exports.requestedReducer = function requestedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      path = _ref2.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), false));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), true));
    default:
      return state;
  }
};

var timestampsReducer = exports.timestampsReducer = function timestampsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      path = _ref3.path;

  switch (type) {
    case START:
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, getSlashStrPath(path), Date.now()));
    default:
      return state;
  }
};

var createDataReducer = function createDataReducer() {
  var actionKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case SET:
        return (0, _setWith3.default)(Object, getDotStrPath(action.path), action[actionKey], state);
      case MERGE:
        var previousData = (0, _get3.default)(state, getDotStrPath(action.path), {});
        var mergedData = (0, _assign3.default)(previousData, action[actionKey]);
        return (0, _setWith3.default)(Object, getDotStrPath(action.path), mergedData, state);
      case NO_VALUE:
        return (0, _setWith3.default)(Object, getDotStrPath(action.path), null, state);
      case REMOVE:
        return (0, _setWith3.default)(Object, getDotStrPath(action.path), undefined, state);
      case LOGOUT:
        if (action.preserve) {
          return (0, _pick3.default)(state, action.preserve);
        }
        return {};
      default:
        return state;
    }
  };
};

var authReducer = exports.authReducer = function authReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case AUTH_UPDATE_SUCCESS:
      if (!action.auth) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      var auth = action.auth.toJSON ? action.auth.toJSON() : action.auth;
      return _extends({}, auth, { isEmpty: false, isLoaded: true });
    case AUTH_LINK_SUCCESS:
      if (!action.payload) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      return _extends({}, action.payload.toJSON ? action.payload.toJSON() : action.payload, {
        isEmpty: false,
        isLoaded: true
      });
    case LOGIN_ERROR:
    case AUTH_EMPTY_CHANGE:
      return { isLoaded: true, isEmpty: true };
    case LOGOUT:
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var authErrorReducer = exports.authErrorReducer = function authErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return {};
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return action.authError;
    default:
      return state;
  }
};

var profileReducer = exports.profileReducer = function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case SET_PROFILE:
      if (!action.profile) {
        return _extends({}, state, {
          isEmpty: true,
          isLoaded: true
        });
      }
      return _extends({}, state, action.profile, {
        isEmpty: false,
        isLoaded: true
      });
    case LOGOUT:
    case LOGIN_ERROR:
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var errorsReducer = exports.errorsReducer = function errorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return [].concat(_toConsumableArray(state), [action.authError]);
    case LOGOUT:
      return [];
    default:
      return state;
  }
};

var listenersById = function listenersById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = arguments[1];
  var type = _ref4.type,
      path = _ref4.path,
      payload = _ref4.payload;

  switch (type) {
    case SET_LISTENER:
      return _extends({}, state, _defineProperty({}, payload.id, {
        id: payload.id,
        path: path
      }));
    case UNSET_LISTENER:
      return (0, _omit3.default)(state, [payload.id]);
    default:
      return state;
  }
};

var allListeners = function allListeners() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref5 = arguments[1];
  var type = _ref5.type,
      path = _ref5.path,
      payload = _ref5.payload;

  switch (type) {
    case SET_LISTENER:
      return [].concat(_toConsumableArray(state), [payload.id]);
    case UNSET_LISTENER:
      return state.filter(function (lId) {
        return lId !== payload.id;
      });
    default:
      return state;
  }
};

var listenersReducer = exports.listenersReducer = combineReducers({
  byId: listenersById,
  allIds: allListeners
});

var dataReducer = exports.dataReducer = createDataReducer();

var orderedReducer = exports.orderedReducer = createDataReducer('ordered');

exports.default = combineReducers({
  requesting: requestingReducer,
  requested: requestedReducer,
  timestamps: timestampsReducer,
  data: dataReducer,
  ordered: orderedReducer,
  auth: authReducer,
  authError: authErrorReducer,
  profile: profileReducer,
  listeners: listenersReducer,
  isInitializing: isInitializingReducer,
  errors: errorsReducer
});

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(333),
    func = convert('assign', __webpack_require__(734));

func.placeholder = __webpack_require__(189);
module.exports = func;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(706),
  'assign': __webpack_require__(294),
  'clone': __webpack_require__(729),
  'curry': __webpack_require__(730),
  'forEach': __webpack_require__(137),
  'isArray': __webpack_require__(21),
  'isFunction': __webpack_require__(41),
  'iteratee': __webpack_require__(731),
  'keys': __webpack_require__(195),
  'rearg': __webpack_require__(732),
  'toInteger': __webpack_require__(345),
  'toPath': __webpack_require__(733)
};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(212);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(151),
    root = __webpack_require__(34);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    createCtor = __webpack_require__(151),
    createHybrid = __webpack_require__(336),
    createRecurry = __webpack_require__(339),
    getHolder = __webpack_require__(344),
    replaceHolders = __webpack_require__(215),
    root = __webpack_require__(34);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(213),
    getData = __webpack_require__(340),
    getFuncName = __webpack_require__(712),
    lodash = __webpack_require__(714);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(713);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 713 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(213),
    LodashWrapper = __webpack_require__(341),
    baseLodash = __webpack_require__(214),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(44),
    wrapperClone = __webpack_require__(715);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(213),
    LodashWrapper = __webpack_require__(341),
    copyArray = __webpack_require__(105);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(137),
    arrayIncludes = __webpack_require__(719);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(720);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(721),
    baseIsNaN = __webpack_require__(722),
    strictIndexOf = __webpack_require__(723);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 721 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 722 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(105),
    isIndex = __webpack_require__(87);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    createCtor = __webpack_require__(151),
    root = __webpack_require__(34);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(337),
    composeArgsRight = __webpack_require__(338),
    replaceHolders = __webpack_require__(215);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(728);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28),
    isSymbol = __webpack_require__(106);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(190);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(212);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(190),
    baseIteratee = __webpack_require__(66);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(212),
    flatRest = __webpack_require__(203);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(131),
    copyArray = __webpack_require__(105),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(106),
    stringToPath = __webpack_require__(311),
    toKey = __webpack_require__(73),
    toString = __webpack_require__(145);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(138),
    copyObject = __webpack_require__(72),
    createAssigner = __webpack_require__(346),
    isArrayLike = __webpack_require__(65),
    isPrototype = __webpack_require__(142),
    keys = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(333),
    func = convert('setWith', __webpack_require__(736));

func.placeholder = __webpack_require__(189);
module.exports = func;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(210);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(738),
    flatRest = __webpack_require__(203);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(739),
    hasIn = __webpack_require__(325);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(146),
    baseSet = __webpack_require__(210),
    castPath = __webpack_require__(88);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populate = exports.buildChildList = exports.fixPath = exports.isEmpty = exports.isLoaded = undefined;

var _isFunction2 = __webpack_require__(41);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _some2 = __webpack_require__(741);

var _some3 = _interopRequireDefault(_some2);

var _compact2 = __webpack_require__(743);

var _compact3 = _interopRequireDefault(_compact2);

var _isString2 = __webpack_require__(90);

var _isString3 = _interopRequireDefault(_isString2);

var _defaultsDeep2 = __webpack_require__(744);

var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);

var _reduce2 = __webpack_require__(750);

var _reduce3 = _interopRequireDefault(_reduce2);

var _every2 = __webpack_require__(320);

var _every3 = _interopRequireDefault(_every2);

var _mapValues2 = __webpack_require__(752);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _map2 = __webpack_require__(150);

var _map3 = _interopRequireDefault(_map2);

var _last2 = __webpack_require__(312);

var _last3 = _interopRequireDefault(_last2);

var _has2 = __webpack_require__(328);

var _has3 = _interopRequireDefault(_has2);

var _get2 = __webpack_require__(149);

var _get3 = _interopRequireDefault(_get2);

var _set2 = __webpack_require__(329);

var _set3 = _interopRequireDefault(_set2);

var _size2 = __webpack_require__(332);

var _size3 = _interopRequireDefault(_size2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(52);

var _populate = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isLoaded = exports.isLoaded = function isLoaded() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args || !args.length ? true : (0, _every3.default)(args, function (arg) {
    return arg !== undefined && (0, _get3.default)(arg, 'isLoaded') !== false;
  });
};

var isEmpty = exports.isEmpty = function isEmpty() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return (0, _some3.default)(args, function (arg) {
    return !(arg && (0, _size3.default)(arg)) || arg.isEmpty === true;
  });
};

var fixPath = exports.fixPath = function fixPath(path) {
  return (path.substring(0, 1) === '/' ? '' : '/') + path;
};

var buildChildList = exports.buildChildList = function buildChildList(state, list, p) {
  return (0, _mapValues3.default)(list, function (val, key) {
    var getKey = val;

    if (val === true) {
      getKey = key;
    }
    var dotRoot = (0, _compact3.default)(p.root.split('/')).join('.');
    var pathString = p.childParam ? dotRoot + '.' + getKey + '.' + p.childParam : dotRoot + '.' + getKey;

    if ((0, _get3.default)(state.data, pathString)) {
      return p.keyProp ? _extends(_defineProperty({}, p.keyProp, getKey), (0, _get3.default)(state.data, pathString)) : (0, _get3.default)(state.data, pathString);
    }

    return val === true ? val : getKey;
  });
};

var populateChild = function populateChild(state, child, p) {
  var childVal = (0, _get3.default)(child, p.child);
  if (!child || !childVal) {
    return null;
  }

  if ((0, _isString3.default)(childVal)) {
    var dotRoot = (0, _compact3.default)(p.root.split('/')).join('.');
    var pathString = p.childParam ? dotRoot + '.' + childVal + '.' + p.childParam : dotRoot + '.' + childVal;
    var populateVal = (0, _get3.default)(state.data, pathString);
    if (populateVal) {
      return (0, _set3.default)({}, p.child, p.keyProp ? _extends(_defineProperty({}, p.keyProp, childVal), populateVal) : populateVal);
    }

    return child;
  }

  return (0, _set3.default)({}, p.child, buildChildList(state, childVal, p));
};

var populate = exports.populate = function populate(state, path, populates, notSetValue) {
  var splitPath = (0, _compact3.default)(path.split('/'));

  var pathArr = _constants.topLevelPaths.indexOf(splitPath[0]) === -1 ? ['data'].concat(_toConsumableArray(splitPath)) : splitPath;
  var dotPath = pathArr.join('.');

  var data = (0, _get3.default)(state, dotPath, notSetValue);

  if (!state || data === notSetValue) {
    return notSetValue;
  }

  if (data === null) {
    return null;
  }

  var populatesForData = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates((0, _last3.default)(pathArr), data) : populates);

  var dataHasPopluateChilds = (0, _every3.default)(populatesForData, function (p) {
    return (0, _has3.default)(data, p.child);
  });
  if (dataHasPopluateChilds) {
    return (0, _reduce3.default)((0, _map3.default)(populatesForData, function (p, obj) {
      return populateChild(state, data, p);
    }), function (obj, v) {
      return (0, _defaultsDeep3.default)(v, obj);
    }, data);
  }

  if (pathArr.indexOf('profile') !== -1) {
    return data;
  }

  return (0, _mapValues3.default)(data, function (child, childKey) {
    var key = pathArr[0] === 'ordered' ? child.key : childKey;

    var populatesForDataItem = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates(key, child) : populates);

    return (0, _reduce3.default)((0, _map3.default)(populatesForDataItem, function (p) {
      return populateChild(state, child, p);
    }), function (obj, v) {
      return (0, _defaultsDeep3.default)(v, obj);
    }, child);
  });
};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(322),
    baseIteratee = __webpack_require__(66),
    baseSome = __webpack_require__(742),
    isArray = __webpack_require__(21),
    isIterateeCall = __webpack_require__(209);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(89);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    baseRest = __webpack_require__(347),
    customDefaultsMerge = __webpack_require__(745),
    mergeWith = __webpack_require__(749);

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(348),
    isObject = __webpack_require__(28);

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(349),
    cloneBuffer = __webpack_require__(297),
    cloneTypedArray = __webpack_require__(308),
    copyArray = __webpack_require__(105),
    initCloneObject = __webpack_require__(309),
    isArguments = __webpack_require__(140),
    isArray = __webpack_require__(21),
    isArrayLikeObject = __webpack_require__(747),
    isBuffer = __webpack_require__(141),
    isFunction = __webpack_require__(41),
    isObject = __webpack_require__(28),
    isPlainObject = __webpack_require__(314),
    isTypedArray = __webpack_require__(193),
    toPlainObject = __webpack_require__(748);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(65),
    isObjectLike = __webpack_require__(44);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keysIn = __webpack_require__(143);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(348),
    createAssigner = __webpack_require__(346);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(201),
    baseEach = __webpack_require__(89),
    baseIteratee = __webpack_require__(66),
    baseReduce = __webpack_require__(751),
    isArray = __webpack_require__(21);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(139),
    baseForOwn = __webpack_require__(318),
    baseIteratee = __webpack_require__(66);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tailRec = tailRec;

var _HKT = __webpack_require__(153);

var _Either = __webpack_require__(754);

var either = _interopRequireWildcard(_Either);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function tailRec(f, a) {
  var v = f(a);
  while (either.isLeft(v)) {
    v = f(either.fromLeft(v));
  }
  return either.fromRight(v);
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Do = exports.chain = exports.of = exports.map = exports.Right = exports.Left = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.inj = inj;
exports.prj = prj;
exports.left = left;
exports.right = right;
exports.isLeft = isLeft;
exports.isRight = isRight;
exports.fromLeft = fromLeft;
exports.fromRight = fromRight;
exports.bimap = bimap;
exports.leftMap = leftMap;
exports.ap = ap;
exports.alt = alt;
exports.extend = extend;
exports.reduce = reduce;
exports.traverse = traverse;
exports.getMonadError = getMonadError;
exports.concat = concat;
exports.getSemigroup = getSemigroup;
exports.either = either;

var _HKT = __webpack_require__(153);

var _Unsafe = __webpack_require__(755);

var _Data3 = __webpack_require__(756);

var _Identity = __webpack_require__(351);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsEither = function IsEither() {
  _classCallCheck(this, IsEither);
};

var Left = exports.Left = function (_Data) {
  _inherits(Left, _Data);

  function Left() {
    _classCallCheck(this, Left);

    return _possibleConstructorReturn(this, (Left.__proto__ || Object.getPrototypeOf(Left)).apply(this, arguments));
  }

  return Left;
}(_Data3.Data1);

var Right = exports.Right = function (_Data2) {
  _inherits(Right, _Data2);

  function Right() {
    _classCallCheck(this, Right);

    return _possibleConstructorReturn(this, (Right.__proto__ || Object.getPrototypeOf(Right)).apply(this, arguments));
  }

  return Right;
}(_Data3.Data1);

function inj(e) {
  return e;
}

function prj(fe) {
  return fe;
}

function left(left) {
  return inj(new Left(left));
}

function right(right) {
  return inj(new Right(right));
}

function isLeft(e) {
  return prj(e) instanceof Left;
}

function isRight(e) {
  return prj(e) instanceof Right;
}

function fromLeft(flr) {
  var lr = prj(flr);
  if (lr instanceof Right) {
    throw new Error('fromLeft returned a Right');
  }
  return lr.value0;
}

function fromRight(flr) {
  var lr = prj(flr);
  if (lr instanceof Left) {
    throw new Error('fromRight returned a Left');
  }
  return lr.value0;
}

function _map(f, fa) {
  var a = prj(fa);
  if (a instanceof Left) {
    return (0, _Unsafe.unsafeCoerce)(a);
  }
  return right(f(a.value0));
}

exports.map = _map;
function bimap(f, g, fac) {
  var ac = prj(fac);
  if (ac instanceof Left) {
    return left(f(ac.value0));
  }
  return right(g(ac.value0));
}

function leftMap(f, e) {
  return either.bimap(f, _Identity.id, e);
}

function ap(fab, fa) {
  var ab = prj(fab);
  if (ab instanceof Left) {
    return (0, _Unsafe.unsafeCoerce)(ab);
  }
  return _map(ab.value0, fa);
}

var _of = right;

exports.of = _of;
function _chain(f, fa) {
  var a = prj(fa);
  if (a instanceof Left) {
    return (0, _Unsafe.unsafeCoerce)(fa);
  }
  return f(a.value0);
}

exports.chain = _chain;
function alt(fx, fy) {
  if (prj(fx) instanceof Left) {
    return fy;
  }
  return fx;
}

function extend(f, ea) {
  return prj(ea) instanceof Left ? (0, _Unsafe.unsafeCoerce)(ea) : right(f(ea));
}

function reduce(f, b, fa) {
  var a = prj(fa);
  if (a instanceof Left) {
    return b;
  }
  return f(b, a.value0);
}

function traverse(applicative, f, ta) {
  var a = prj(ta);
  if (a instanceof Left) {
    return applicative.of((0, _Unsafe.unsafeCoerce)(ta));
  }
  return applicative.map(_of, f(a.value0));
}

function getMonadError() {
  return {
    of: _of,
    map: _map,
    ap: ap,
    chain: _chain,
    throwError: function throwError(e) {
      return left(e);
    },
    catchError: function catchError(ma, handler) {
      return either(handler, right, ma);
    }
  };
}

function concat(semigroup) {
  return function concat(fx, fy) {
    var x = prj(fx);
    var y = prj(fy);
    if (x instanceof Right && y instanceof Right) {
      return right(semigroup.concat(x.value0, y.value0));
    }
    return fx;
  };
}

function getSemigroup(semigroup) {
  return {
    concat: concat(semigroup)
  };
}

function either(f, g, fa) {
  var a = prj(fa);
  if (a instanceof Left) {
    return f(a.value0);
  }
  return g(a.value0);
}

var Do = exports.Do = function () {
  _createClass(Do, null, [{
    key: 'of',
    value: function of(a) {
      return new Do(_of(a));
    }
  }]);

  function Do(value) {
    _classCallCheck(this, Do);

    this.value = value;
  }

  _createClass(Do, [{
    key: 'map',
    value: function map(f) {
      return new Do(_map(f, this.value));
    }
  }, {
    key: 'chain',
    value: function chain(f) {
      return new Do(_chain(f, this.value));
    }
  }]);

  return Do;
}();

if (false) {
  // eslint-disable-line
  ({
    map: _map,
    ap: ap,
    of: _of,
    chain: _chain,
    bimap: bimap,
    alt: alt,
    extend: extend,
    reduce: reduce,
    traverse: traverse
  });
}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsafeCoerce = unsafeCoerce;
function unsafeCoerce(a) {
  return a;
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Data1 = exports.Data1 = function Data1(value0) {
  _classCallCheck(this, Data1);

  this.value0 = value0;
};

var Data2 = exports.Data2 = function Data2(value0, value1) {
  _classCallCheck(this, Data2);

  this.value0 = value0;
  this.value1 = value1;
};

var Data3 = exports.Data3 = function Data3(value0, value1, value2) {
  _classCallCheck(this, Data3);

  this.value0 = value0;
  this.value1 = value1;
  this.value2 = value2;
};

var Data4 = exports.Data4 = function Data4(value0, value1, value2, value3) {
  _classCallCheck(this, Data4);

  this.value0 = value0;
  this.value1 = value1;
  this.value2 = value2;
  this.value3 = value3;
};

var Data5 = exports.Data5 = function Data5(value0, value1, value2, value3, value4) {
  _classCallCheck(this, Data5);

  this.value0 = value0;
  this.value1 = value1;
  this.value2 = value2;
  this.value3 = value3;
  this.value4 = value4;
};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = {"name":"@swarm2/core","version":"0.3.0","description":"core2 React component","main":"lib/index.js","private":true,"files":["css","lib"],"scripts":{"version-json":"mkdir -p lib/ && node ./version.js > lib/version.json","build":"babel src --out-dir lib --source-maps inline --copy-files --delete-dir-on-start","build:flow":"flow-copy-source -v -i '**/*.test.js' src lib","postbuild":"yarn run build:flow && yarn run version-json && cat lib/version.json","build:watch":"yarn run clean && concurrently --kill-others-on-fail \"yarn run build --watch\" \"yarn run build:flow --watch\" \"yarn run version-json\"","clean":"rm -rf lib","eslint":"eslint --max-warnings 0 \"src/**/*.js\"","test":"jest","test:coverage":"jest --coverage","test:watch":"jest --watch --notify"},"babel":{"presets":["@swarm2/babel-preset"]},"//jest":"Ignore /lib/ because we copy *.test.js there - some www tests are based on them.","jest":{"testPathIgnorePatterns":["/node_modules/","/lib/"],"setupFiles":["raf/polyfill"],"setupTestFrameworkScriptFile":"./src/setupTests.js"},"dependencies":{"@swarm2/assert":"^0.3.0","@swarm2/growth":"^0.3.0","classnames":"^2.2.5","decimal.js":"7.2.1","firebase":"^3.9.0","flow-classy-type-wrapper":"^1.0.2","flow-static-land":"^0.2.7","query-string":"^5.0.0","react":"^16.0.0","react-redux":"^5.0.5","react-redux-firebase":"^2.0.0-beta.11","react-router":"^4.1.1","recompose":"^0.25.1","redux":"^3.6.0","redux-thunk":"^2.2.0","reselect":"^3.0.1","swarm-numberformat":"^0.3.5","swarm-thresholds":"^0.0.3","uuid":"^3.0.1"},"devDependencies":{"@swarm2/babel-preset":"^0.3.0","babel-cli":"^6.26.0","babel-eslint":"^8.0.1","babel-jest":"^21.2.0","concurrently":"^3.5.0","enzyme":"^3.0.0","enzyme-adapter-react-16":"^1.0.0","eslint":"^4.6.1","eslint-config-react-app":"^2.0.0","eslint-plugin-flowtype":"^2.35.1","eslint-plugin-import":"^2.7.0","eslint-plugin-jsx-a11y":"^6.0.2","eslint-plugin-react":"^7.3.0","flow-bin":"^0.53.1","flow-copy-source":"^1.2.0","jest":"^21.2.0","raf":"^3.3.2","react-dom":"^16.0.0"},"author":"","homepage":"","license":"GPL-3.0","repository":""}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = {"longVersion":"v0.3.0-31-g88f32ab","longHash":"88f32ab27cf660d65b6a530e5c98ee1b52b9f9d7","shortHash":"88f32ab","date":1516327604000}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chars = exports.createdAt = exports.displayName = exports.isNotEmpty = exports.isEmpty = exports.localState = undefined;

var _types = __webpack_require__(91);

var T = _interopRequireWildcard(_types);

var _charactersByUser = __webpack_require__(354);

var CharsByUser = _interopRequireWildcard(_charactersByUser);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var userId = function userId(state, props) {
  return (0, _assert.assertDefined)(props.userId, "userId");
};
var path = (0, _reselect.createSelector)(userId, paths.user.data);
var localState = exports.localState = (0, _queryStatus.selectPath)(path);
var isEmpty = exports.isEmpty = _queryStatus.selectPath.isEmpty(path);
var isNotEmpty = exports.isNotEmpty = _queryStatus.selectPath.isNotEmpty(path);

var displayName = exports.displayName = (0, _reselect.createSelector)(localState, function (state) {
  return "username" in state ? state.username : "Unnamed player";
});
var createdAt = exports.createdAt = (0, _reselect.createSelector)(localState, function (state) {
  return T.Timestamp.wrap(state.createdAt);
});
var chars = exports.chars = CharsByUser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(761)))

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(108);
(function(){
(function(){var h,aa=aa||{},l=this,ba=function(){},ca=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},da=function(a){return null===a},ea=function(a){return"array"==ca(a)},fa=function(a){var b=ca(a);return"array"==b||"object"==b&&"number"==typeof a.length},m=function(a){return"string"==typeof a},ga=function(a){return"number"==typeof a},p=function(a){return"function"==ca(a)},ha=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ia=function(a,
b,c){return a.call.apply(a.bind,arguments)},ja=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},q=function(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return q.apply(null,arguments)},ka=function(a,b){var c=Array.prototype.slice.call(arguments,
1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},la=Date.now||function(){return+new Date},r=function(a,b){function c(){}c.prototype=b.prototype;a.xd=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Tf=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var t=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,t);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};r(t,Error);t.prototype.name="CustomError";var ma=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},na=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},oa=/&/g,pa=/</g,qa=/>/g,ra=/"/g,sa=/'/g,ta=/\x00/g,ua=/[\x00&<>"']/,u=function(a,b){return-1!=a.indexOf(b)},va=function(a,b){return a<b?-1:a>b?1:0};var wa=function(a,b){b.unshift(a);t.call(this,ma.apply(null,b));b.shift()};r(wa,t);wa.prototype.name="AssertionError";
var xa=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new wa(""+e,f||[]);},v=function(a,b,c){a||xa("",null,b,Array.prototype.slice.call(arguments,2))},ya=function(a,b){throw new wa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},za=function(a,b,c){ga(a)||xa("Expected number but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b,c){m(a)||xa("Expected string but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,
2))},Ba=function(a,b,c){p(a)||xa("Expected function but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2))};var Ca=Array.prototype.indexOf?function(a,b,c){v(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){v(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Da=function(a,b){for(var c=m(a)?
a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ea=Array.prototype.map?function(a,b,c){v(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Fa=Array.prototype.some?function(a,b,c){v(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
Ha=function(a){var b;a:{b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]},Ia=function(a,b){return 0<=Ca(a,b)},Ka=function(a,b){b=Ca(a,b);var c;(c=0<=b)&&Ja(a,b);return c},Ja=function(a,b){v(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},La=function(a,b){var c=0;Da(a,function(d,e){b.call(void 0,d,e,a)&&Ja(a,e)&&c++})},Ma=function(a){return Array.prototype.concat.apply([],arguments)},
Na=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Oa=function(a){return Ea(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Pa;a:{var Qa=l.navigator;if(Qa){var Ra=Qa.userAgent;if(Ra){Pa=Ra;break a}}Pa=""}var x=function(a){return u(Pa,a)};var Sa=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},Ta=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Ua=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Va=function(a){for(var b in a)return!1;return!0},Wa=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},Xa=function(a){var b={},c;for(c in a)b[c]=a[c];return b},Ya="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
Za=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ya.length;f++)c=Ya[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var $a=function(a){$a[" "](a);return a};$a[" "]=ba;var bb=function(a,b){var c=ab;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var cb=x("Opera"),y=x("Trident")||x("MSIE"),eb=x("Edge"),fb=eb||y,gb=x("Gecko")&&!(u(Pa.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),hb=u(Pa.toLowerCase(),"webkit")&&!x("Edge"),ib=function(){var a=l.document;return a?a.documentMode:void 0},jb;
a:{var kb="",lb=function(){var a=Pa;if(gb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(eb)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(hb)return/WebKit\/(\S+)/.exec(a);if(cb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();lb&&(kb=lb?lb[1]:"");if(y){var mb=ib();if(null!=mb&&mb>parseFloat(kb)){jb=String(mb);break a}}jb=kb}
var nb=jb,ab={},z=function(a){return bb(a,function(){for(var b=0,c=na(String(nb)).split("."),d=na(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=va(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||va(0==g[2].length,0==k[2].length)||va(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})},ob;var pb=l.document;
ob=pb&&y?ib()||("CSS1Compat"==pb.compatMode?parseInt(nb,10):5):void 0;var qb=null,rb=null,tb=function(a){var b="";sb(a,function(a){b+=String.fromCharCode(a)});return b},sb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=rb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}ub();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}},ub=function(){if(!qb){qb={};rb={};for(var a=0;65>a;a++)qb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
rb[qb[a]]=a,62<=a&&(rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var vb=function(){this.Da=-1};var yb=function(a,b){this.Da=64;this.ec=l.Uint8Array?new Uint8Array(this.Da):Array(this.Da);this.Fc=this.hb=0;this.h=[];this.lf=a;this.Wd=b;this.Mf=l.Int32Array?new Int32Array(64):Array(64);void 0!==wb||(wb=l.Int32Array?new Int32Array(xb):xb);this.reset()},wb;r(yb,vb);for(var zb=[],Ab=0;63>Ab;Ab++)zb[Ab]=0;var Bb=Ma(128,zb);yb.prototype.reset=function(){this.Fc=this.hb=0;this.h=l.Int32Array?new Int32Array(this.Wd):Na(this.Wd)};
var Cb=function(a){var b=a.ec;v(b.length==a.Da);for(var c=a.Mf,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){var e=c[b-15]|0,d=c[b-2]|0,f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}for(var d=a.h[0]|0,e=a.h[1]|0,k=a.h[2]|0,n=a.h[3]|0,C=a.h[4]|0,db=a.h[5]|0,Pb=a.h[6]|0,f=a.h[7]|0,b=0;64>b;b++)var Ah=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&k^e&k)|0,g=C&db^~C&Pb,f=f+((C>>>6|
C<<26)^(C>>>11|C<<21)^(C>>>25|C<<7))|0,g=g+(wb[b]|0)|0,g=f+(g+(c[b]|0)|0)|0,f=Pb,Pb=db,db=C,C=n+g|0,n=k,k=e,e=d,d=g+Ah|0;a.h[0]=a.h[0]+d|0;a.h[1]=a.h[1]+e|0;a.h[2]=a.h[2]+k|0;a.h[3]=a.h[3]+n|0;a.h[4]=a.h[4]+C|0;a.h[5]=a.h[5]+db|0;a.h[6]=a.h[6]+Pb|0;a.h[7]=a.h[7]+f|0};
yb.prototype.update=function(a,b){void 0===b&&(b=a.length);var c=0,d=this.hb;if(m(a))for(;c<b;)this.ec[d++]=a.charCodeAt(c++),d==this.Da&&(Cb(this),d=0);else if(fa(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.ec[d++]=e;d==this.Da&&(Cb(this),d=0)}else throw Error("message must be string or array");this.hb=d;this.Fc+=b};
yb.prototype.digest=function(){var a=[],b=8*this.Fc;56>this.hb?this.update(Bb,56-this.hb):this.update(Bb,this.Da-(this.hb-56));for(var c=63;56<=c;c--)this.ec[c]=b&255,b/=256;Cb(this);for(c=b=0;c<this.lf;c++)for(var d=24;0<=d;d-=8)a[b++]=this.h[c]>>d&255;return a};
var xb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Eb=function(){yb.call(this,8,Db)};r(Eb,yb);var Db=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Fb=function(){this.Ga=this.Ga;this.tc=this.tc};Fb.prototype.Ga=!1;Fb.prototype.isDisposed=function(){return this.Ga};Fb.prototype.cb=function(){if(this.tc)for(;this.tc.length;)this.tc.shift()()};var Gb=!y||9<=Number(ob),Hb=y&&!z("9");!hb||z("528");gb&&z("1.9b")||y&&z("8")||cb&&z("9.5")||hb&&z("528");gb&&!z("8")||y&&z("9");var Ib=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.nb=!1;this.ee=!0};Ib.prototype.preventDefault=function(){this.defaultPrevented=!0;this.ee=!1};var Jb=function(a,b){Ib.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.eb=this.state=null;a&&this.init(a,b)};r(Jb,Ib);
Jb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(gb){var e;a:{try{$a(b.nodeName);e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=hb||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=hb||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:
a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.eb=
a;a.defaultPrevented&&this.preventDefault()};Jb.prototype.preventDefault=function(){Jb.xd.preventDefault.call(this);var a=this.eb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Hb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Jb.prototype.Pe=function(){return this.eb};var Kb="closure_listenable_"+(1E6*Math.random()|0),Lb=0;var Mb=function(a,b,c,d,e){this.listener=a;this.xc=null;this.src=b;this.type=c;this.capture=!!d;this.kc=e;this.key=++Lb;this.rb=this.dc=!1},Nb=function(a){a.rb=!0;a.listener=null;a.xc=null;a.src=null;a.kc=null};var Ob=function(a){this.src=a;this.G={};this.$b=0};Ob.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.G[f];a||(a=this.G[f]=[],this.$b++);var g=Qb(a,b,d,e);-1<g?(b=a[g],c||(b.dc=!1)):(b=new Mb(b,this.src,f,!!d,e),b.dc=c,a.push(b));return b};Ob.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.G))return!1;var e=this.G[a];b=Qb(e,b,c,d);return-1<b?(Nb(e[b]),Ja(e,b),0==e.length&&(delete this.G[a],this.$b--),!0):!1};
var Rb=function(a,b){var c=b.type;c in a.G&&Ka(a.G[c],b)&&(Nb(b),0==a.G[c].length&&(delete a.G[c],a.$b--))};Ob.prototype.Uc=function(a,b,c,d){a=this.G[a.toString()];var e=-1;a&&(e=Qb(a,b,c,d));return-1<e?a[e]:null};var Qb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.rb&&f.listener==b&&f.capture==!!c&&f.kc==d)return e}return-1};var Sb="closure_lm_"+(1E6*Math.random()|0),Tb={},Ub=0,Vb=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)Vb(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.listen(b,c,d,e):Xb(a,b,c,!1,d,e)},Xb=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=Yb(a);k||(a[Sb]=k=new Ob(a));c=k.add(b,c,d,e,f);if(!c.xc){d=Zb();c.xc=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent($b(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
Ub++}},Zb=function(){var a=ac,b=Gb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},bc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)bc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?cc(a,b,c,d,e):Xb(a,b,c,!0,d,e)},dc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)dc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.fa.remove(String(b),c,d,e):a&&(a=Yb(a))&&(b=a.Uc(b,c,!!d,e))&&ec(b)},ec=function(a){if(!ga(a)&&a&&!a.rb){var b=a.src;if(b&&
b[Kb])Rb(b.fa,a);else{var c=a.type,d=a.xc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent($b(c),d);Ub--;(c=Yb(b))?(Rb(c,a),0==c.$b&&(c.src=null,b[Sb]=null)):Nb(a)}}},$b=function(a){return a in Tb?Tb[a]:Tb[a]="on"+a},gc=function(a,b,c,d){var e=!0;if(a=Yb(a))if(b=a.G[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.rb&&(f=fc(f,d),e=e&&!1!==f)}return e},fc=function(a,b){var c=a.listener,d=a.kc||a.src;a.dc&&ec(a);return c.call(d,
b)},ac=function(a,b){if(a.rb)return!0;if(!Gb){if(!b)a:{b=["window","event"];for(var c=l,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Jb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.nb&&0<=e;e--){b.currentTarget=d[e];var f=gc(d[e],a,!0,b),c=c&&f}for(e=0;!b.nb&&e<d.length;e++)b.currentTarget=
d[e],f=gc(d[e],a,!1,b),c=c&&f}return c}return fc(a,new Jb(b,this))},Yb=function(a){a=a[Sb];return a instanceof Ob?a:null},hc="__closure_events_fn_"+(1E9*Math.random()>>>0),Wb=function(a){v(a,"Listener can not be null.");if(p(a))return a;v(a.handleEvent,"An object listener must have handleEvent method.");a[hc]||(a[hc]=function(b){return a.handleEvent(b)});return a[hc]};var ic=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var kc=function(){this.Cc="";this.we=jc};kc.prototype.Eb=!0;kc.prototype.Bb=function(){return this.Cc};kc.prototype.toString=function(){return"Const{"+this.Cc+"}"};var lc=function(a){if(a instanceof kc&&a.constructor===kc&&a.we===jc)return a.Cc;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"},jc={},mc=function(a){var b=new kc;b.Cc=a;return b};mc("");var oc=function(){this.wc="";this.xe=nc};oc.prototype.Eb=!0;oc.prototype.Bb=function(){return this.wc};oc.prototype.toString=function(){return"TrustedResourceUrl{"+this.wc+"}"};var nc={};var qc=function(){this.pa="";this.ve=pc};qc.prototype.Eb=!0;qc.prototype.Bb=function(){return this.pa};qc.prototype.toString=function(){return"SafeUrl{"+this.pa+"}"};
var rc=function(a){if(a instanceof qc&&a.constructor===qc&&a.ve===pc)return a.pa;ya("expected object of type SafeUrl, got '"+a+"' of type "+ca(a));return"type_error:SafeUrl"},sc=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,uc=function(a){if(a instanceof qc)return a;a=a.Eb?a.Bb():String(a);sc.test(a)||(a="about:invalid#zClosurez");return tc(a)},pc={},tc=function(a){var b=new qc;b.pa=a;return b};tc("about:blank");var xc=function(a){var b=[];vc(new wc,a,b);return b.join("")},wc=function(){this.yc=void 0},vc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ea(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],vc(a,a.yc?a.yc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
yc(d,c),c.push(":"),vc(a,a.yc?a.yc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":yc(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},zc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ac=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
yc=function(a,b){b.push('"',a.replace(Ac,function(a){var b=zc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),zc[a]=b);return b}),'"')};var Bc=function(){};Bc.prototype.Dd=null;var Cc=function(a){return a.Dd||(a.Dd=a.$c())};var Dc,Ec=function(){};r(Ec,Bc);Ec.prototype.fc=function(){var a=Fc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Ec.prototype.$c=function(){var a={};Fc(this)&&(a[0]=!0,a[1]=!0);return a};
var Fc=function(a){if(!a.Vd&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.Vd=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.Vd};Dc=new Ec;var Gc=function(){};r(Gc,Bc);Gc.prototype.fc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Hc;throw Error("Unsupported browser");};Gc.prototype.$c=function(){return{}};
var Hc=function(){this.ua=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.ua.onload=q(this.Re,this);this.ua.onerror=q(this.Sd,this);this.ua.onprogress=q(this.Se,this);this.ua.ontimeout=q(this.Te,this)};h=Hc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.ua.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.ua.send(a);else throw Error("Only string data is supported");else this.ua.send()};h.abort=function(){this.ua.abort()};h.setRequestHeader=function(){};h.Re=function(){this.status=200;this.responseText=this.ua.responseText;Ic(this,4)};h.Sd=function(){this.status=500;this.responseText="";Ic(this,4)};h.Te=function(){this.Sd()};h.Se=function(){this.status=200;Ic(this,1)};var Ic=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};var Jc=function(a,b,c){this.ef=c;this.Fe=a;this.wf=b;this.sc=0;this.lc=null};Jc.prototype.get=function(){var a;0<this.sc?(this.sc--,a=this.lc,this.lc=a.next,a.next=null):a=this.Fe();return a};Jc.prototype.put=function(a){this.wf(a);this.sc<this.ef&&(this.sc++,a.next=this.lc,this.lc=a)};var Kc=function(a){l.setTimeout(function(){throw a;},0)},Lc,Mc=function(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
a=q(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.Gd;c.Gd=null;a()}};return function(a){d.next={Gd:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}};var Nc=function(){this.Jc=this.Za=null},Pc=new Jc(function(){return new Oc},function(a){a.reset()},100);Nc.prototype.add=function(a,b){var c=Pc.get();c.set(a,b);this.Jc?this.Jc.next=c:(v(!this.Za),this.Za=c);this.Jc=c};Nc.prototype.remove=function(){var a=null;this.Za&&(a=this.Za,this.Za=this.Za.next,this.Za||(this.Jc=null),a.next=null);return a};var Oc=function(){this.next=this.scope=this.Tc=null};Oc.prototype.set=function(a,b){this.Tc=a;this.scope=b;this.next=null};
Oc.prototype.reset=function(){this.next=this.scope=this.Tc=null};var Uc=function(a,b){Qc||Rc();Sc||(Qc(),Sc=!0);Tc.add(a,b)},Qc,Rc=function(){if(-1!=String(l.Promise).indexOf("[native code]")){var a=l.Promise.resolve(void 0);Qc=function(){a.then(Vc)}}else Qc=function(){var a=Vc;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!x("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Lc||(Lc=Mc()),Lc(a)):l.setImmediate(a)}},Sc=!1,Tc=new Nc,Vc=function(){for(var a;a=Tc.remove();){try{a.Tc.call(a.scope)}catch(b){Kc(b)}Pc.put(a)}Sc=!1};!gb&&!y||y&&9<=Number(ob)||gb&&z("1.9.1");y&&z("9");var Xc=function(){this.pa="";this.ue=Wc};Xc.prototype.Eb=!0;Xc.prototype.Bb=function(){return this.pa};Xc.prototype.toString=function(){return"SafeHtml{"+this.pa+"}"};var Yc=function(a){if(a instanceof Xc&&a.constructor===Xc&&a.ue===Wc)return a.pa;ya("expected object of type SafeHtml, got '"+a+"' of type "+ca(a));return"type_error:SafeHtml"},Wc={};Xc.prototype.$e=function(a){this.pa=a;return this};var $c=function(a,b){Sa(b,function(b,d){b&&b.Eb&&(b=b.Bb());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Zc.hasOwnProperty(d)?a.setAttribute(Zc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},Zc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};var ad=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},bd=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var A=function(a,b){this.N=0;this.ra=void 0;this.bb=this.na=this.s=null;this.jc=this.Sc=!1;if(a!=ba)try{var c=this;a.call(b,function(a){cd(c,2,a)},function(a){if(!(a instanceof dd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}cd(c,3,a)})}catch(d){cd(this,3,d)}},ed=function(){this.next=this.context=this.jb=this.Oa=this.child=null;this.xb=!1};ed.prototype.reset=function(){this.context=this.jb=this.Oa=this.child=null;this.xb=!1};
var fd=new Jc(function(){return new ed},function(a){a.reset()},100),gd=function(a,b,c){var d=fd.get();d.Oa=a;d.jb=b;d.context=c;return d},B=function(a){if(a instanceof A)return a;var b=new A(ba);cd(b,2,a);return b},D=function(a){return new A(function(b,c){c(a)})},id=function(a,b,c){hd(a,b,c,null)||Uc(ka(b,a))},jd=function(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ne:!0,value:f}:{Ne:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],id(g,ka(e,f,!0),
ka(e,f,!1));else b(d)})};A.prototype.then=function(a,b,c){null!=a&&Ba(a,"opt_onFulfilled should be a function.");null!=b&&Ba(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return kd(this,p(a)?a:null,p(b)?b:null,c)};ad(A);var md=function(a,b){b=gd(b,b,void 0);b.xb=!0;ld(a,b);return a};A.prototype.f=function(a,b){return kd(this,null,a,b)};A.prototype.cancel=function(a){0==this.N&&Uc(function(){var b=new dd(a);nd(this,b)},this)};
var nd=function(a,b){if(0==a.N)if(a.s){var c=a.s;if(c.na){for(var d=0,e=null,f=null,g=c.na;g&&(g.xb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.N&&1==d?nd(c,b):(f?(d=f,v(c.na),v(null!=d),d.next==c.bb&&(c.bb=d),d.next=d.next.next):od(c),pd(c,e,3,b)))}a.s=null}else cd(a,3,b)},ld=function(a,b){a.na||2!=a.N&&3!=a.N||qd(a);v(null!=b.Oa);a.bb?a.bb.next=b:a.na=b;a.bb=b},kd=function(a,b,c,d){var e=gd(null,null,null);e.child=new A(function(a,g){e.Oa=b?function(c){try{var e=b.call(d,c);a(e)}catch(C){g(C)}}:
a;e.jb=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof dd?g(b):a(e)}catch(C){g(C)}}:g});e.child.s=a;ld(a,e);return e.child};A.prototype.Jf=function(a){v(1==this.N);this.N=0;cd(this,2,a)};A.prototype.Kf=function(a){v(1==this.N);this.N=0;cd(this,3,a)};
var cd=function(a,b,c){0==a.N&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.N=1,hd(c,a.Jf,a.Kf,a)||(a.ra=c,a.N=b,a.s=null,qd(a),3!=b||c instanceof dd||rd(a,c)))},hd=function(a,b,c,d){if(a instanceof A)return null!=b&&Ba(b,"opt_onFulfilled should be a function."),null!=c&&Ba(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),ld(a,gd(b||ba,c||null,d)),!0;if(bd(a))return a.then(b,c,d),!0;if(ha(a))try{var e=a.then;if(p(e))return sd(a,
e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},sd=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},k=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,k)}catch(n){k(n)}},qd=function(a){a.Sc||(a.Sc=!0,Uc(a.Je,a))},od=function(a){var b=null;a.na&&(b=a.na,a.na=b.next,b.next=null);a.na||(a.bb=null);null!=b&&v(null!=b.Oa);return b};A.prototype.Je=function(){for(var a;a=od(this);)pd(this,a,this.N,this.ra);this.Sc=!1};
var pd=function(a,b,c,d){if(3==c&&b.jb&&!b.xb)for(;a&&a.jc;a=a.s)a.jc=!1;if(b.child)b.child.s=null,td(b,c,d);else try{b.xb?b.Oa.call(b.context):td(b,c,d)}catch(e){ud.call(null,e)}fd.put(b)},td=function(a,b,c){2==b?a.Oa.call(a.context,c):a.jb&&a.jb.call(a.context,c)},rd=function(a,b){a.jc=!0;Uc(function(){a.jc&&ud.call(null,b)})},ud=Kc,dd=function(a){t.call(this,a)};r(dd,t);dd.prototype.name="cancel";
var vd=function(a,b){this.zc=[];this.$d=a;this.Jd=b||null;this.Cb=this.fb=!1;this.ra=void 0;this.ud=this.Cd=this.Nc=!1;this.Gc=0;this.s=null;this.Oc=0};vd.prototype.cancel=function(a){if(this.fb)this.ra instanceof vd&&this.ra.cancel();else{if(this.s){var b=this.s;delete this.s;a?b.cancel(a):(b.Oc--,0>=b.Oc&&b.cancel())}this.$d?this.$d.call(this.Jd,this):this.ud=!0;this.fb||wd(this,new xd)}};vd.prototype.Hd=function(a,b){this.Nc=!1;yd(this,a,b)};
var yd=function(a,b,c){a.fb=!0;a.ra=c;a.Cb=!b;zd(a)},Bd=function(a){if(a.fb){if(!a.ud)throw new Ad;a.ud=!1}};vd.prototype.callback=function(a){Bd(this);Cd(a);yd(this,!0,a)};
var wd=function(a,b){Bd(a);Cd(b);yd(a,!1,b)},Cd=function(a){v(!(a instanceof vd),"An execution sequence may not be initiated with a blocking Deferred.")},Gd=function(a){var b=Dd("https://apis.google.com/js/client.js?onload="+Ed);Fd(b,null,a,void 0)},Fd=function(a,b,c,d){v(!a.Cd,"Blocking Deferreds can not be re-used");a.zc.push([b,c,d]);a.fb&&zd(a)};vd.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});Fd(this,d,function(a){a instanceof xd?f.cancel():e(a)});return f.then(a,b,c)};
ad(vd);
var Hd=function(a){return Fa(a.zc,function(a){return p(a[1])})},zd=function(a){if(a.Gc&&a.fb&&Hd(a)){var b=a.Gc,c=Id[b];c&&(l.clearTimeout(c.Db),delete Id[b]);a.Gc=0}a.s&&(a.s.Oc--,delete a.s);for(var b=a.ra,d=c=!1;a.zc.length&&!a.Nc;){var e=a.zc.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Cb?g:f)try{var k=f.call(e||a.Jd,b);void 0!==k&&(a.Cb=a.Cb&&(k==b||k instanceof Error),a.ra=b=k);if(bd(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.Nc=!0}catch(n){b=n,a.Cb=!0,Hd(a)||(c=!0)}}a.ra=b;d&&
(k=q(a.Hd,a,!0),d=q(a.Hd,a,!1),b instanceof vd?(Fd(b,k,d),b.Cd=!0):b.then(k,d));c&&(b=new Jd(b),Id[b.Db]=b,a.Gc=b.Db)},Ad=function(){t.call(this)};r(Ad,t);Ad.prototype.message="Deferred has already fired";Ad.prototype.name="AlreadyCalledError";var xd=function(){t.call(this)};r(xd,t);xd.prototype.message="Deferred was canceled";xd.prototype.name="CanceledError";var Jd=function(a){this.Db=l.setTimeout(q(this.If,this),0);this.P=a};
Jd.prototype.If=function(){v(Id[this.Db],"Cannot throw an error that is not scheduled.");delete Id[this.Db];throw this.P;};var Id={};var Dd=function(a){var b=new oc;b.wc=a;return Kd(b)},Kd=function(a){var b={},c=b.document||document,d;a instanceof oc&&a.constructor===oc&&a.xe===nc?d=a.wc:(ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ca(a)),d="type_error:TrustedResourceUrl");var e=document.createElement("SCRIPT");a={fe:e,Zb:void 0};var f=new vd(Ld,a),g=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(g=window.setTimeout(function(){Md(e,!0);wd(f,new Nd(1,"Timeout reached for loading script "+d))},k),a.Zb=g);e.onload=
e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Md(e,b.Uf||!1,g),f.callback(null))};e.onerror=function(){Md(e,!0,g);wd(f,new Nd(0,"Error while loading script "+d))};a=b.attributes||{};Za(a,{type:"text/javascript",charset:"UTF-8",src:d});$c(e,a);Od(c).appendChild(e);return f},Od=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Ld=function(){if(this&&this.fe){var a=this.fe;a&&"SCRIPT"==a.tagName&&
Md(a,!0,this.Zb)}},Md=function(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ba;a.onerror=ba;a.onreadystatechange=ba;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},Nd=function(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);t.call(this,c);this.code=a};r(Nd,t);var Pd="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""},Qd=function(){};Qd.prototype.next=function(){throw Pd;};Qd.prototype.ye=function(){return this};var Rd=function(a,b){this.ga={};this.w=[];this.wb=this.o=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};Rd.prototype.Z=function(){Sd(this);for(var a=[],b=0;b<this.w.length;b++)a.push(this.ga[this.w[b]]);return a};Rd.prototype.oa=function(){Sd(this);return this.w.concat()};Rd.prototype.yb=function(a){return Td(this.ga,a)};
Rd.prototype.remove=function(a){return Td(this.ga,a)?(delete this.ga[a],this.o--,this.wb++,this.w.length>2*this.o&&Sd(this),!0):!1};var Sd=function(a){if(a.o!=a.w.length){for(var b=0,c=0;b<a.w.length;){var d=a.w[b];Td(a.ga,d)&&(a.w[c++]=d);b++}a.w.length=c}if(a.o!=a.w.length){for(var e={},c=b=0;b<a.w.length;)d=a.w[b],Td(e,d)||(a.w[c++]=d,e[d]=1),b++;a.w.length=c}};h=Rd.prototype;h.get=function(a,b){return Td(this.ga,a)?this.ga[a]:b};
h.set=function(a,b){Td(this.ga,a)||(this.o++,this.w.push(a),this.wb++);this.ga[a]=b};h.addAll=function(a){var b;a instanceof Rd?(b=a.oa(),a=a.Z()):(b=Ua(a),a=Ta(a));for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.oa(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new Rd(this)};
h.ye=function(a){Sd(this);var b=0,c=this.wb,d=this,e=new Qd;e.next=function(){if(c!=d.wb)throw Error("The map has changed since the iterator was created");if(b>=d.w.length)throw Pd;var e=d.w[b++];return a?e:d.ga[e]};return e};var Td=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Ud=function(a){if(a.Z&&"function"==typeof a.Z)return a.Z();if(m(a))return a.split("");if(fa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ta(a)},Vd=function(a){if(a.oa&&"function"==typeof a.oa)return a.oa();if(!a.Z||"function"!=typeof a.Z){if(fa(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ua(a)}},Wd=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(fa(a)||m(a))w(a,b,void 0);else for(var c=Vd(a),d=Ud(a),e=
d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var Xd=function(a,b,c,d,e){this.reset(a,b,c,d,e)};Xd.prototype.Md=null;var Yd=0;Xd.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Yd++;d||la();this.Ib=a;this.hf=b;delete this.Md};Xd.prototype.ie=function(a){this.Ib=a};var Zd=function(a){this.jf=a;this.Td=this.Pc=this.Ib=this.s=null},$d=function(a,b){this.name=a;this.value=b};$d.prototype.toString=function(){return this.name};var ae=new $d("SEVERE",1E3),be=new $d("CONFIG",700),ce=new $d("FINE",500);Zd.prototype.getParent=function(){return this.s};Zd.prototype.ie=function(a){this.Ib=a};var de=function(a){if(a.Ib)return a.Ib;if(a.s)return de(a.s);ya("Root logger has no level set.");return null};
Zd.prototype.log=function(a,b,c){if(a.value>=de(this).value)for(p(b)&&(b=b()),a=new Xd(a,String(b),this.jf),c&&(a.Md=c),c="log:"+a.hf,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),c=this;c;){var d=c,e=a;if(d.Td)for(var f=0;b=d.Td[f];f++)b(e);c=c.getParent()}};
var ee={},fe=null,ge=function(a){fe||(fe=new Zd(""),ee[""]=fe,fe.ie(be));var b;if(!(b=ee[a])){b=new Zd(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ge(a.substr(0,c));c.Pc||(c.Pc={});c.Pc[d]=b;b.s=c;ee[a]=b}return b};var he=function(){Fb.call(this);this.fa=new Ob(this);this.ze=this;this.hd=null};r(he,Fb);he.prototype[Kb]=!0;h=he.prototype;h.addEventListener=function(a,b,c,d){Vb(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){dc(this,a,b,c,d)};
h.dispatchEvent=function(a){ie(this);var b,c=this.hd;if(c){b=[];for(var d=1;c;c=c.hd)b.push(c),v(1E3>++d,"infinite loop")}c=this.ze;d=a.type||a;if(m(a))a=new Ib(a,c);else if(a instanceof Ib)a.target=a.target||c;else{var e=a;a=new Ib(d,c);Za(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.nb&&0<=g;g--)f=a.currentTarget=b[g],e=je(f,d,!0,a)&&e;a.nb||(f=a.currentTarget=c,e=je(f,d,!0,a)&&e,a.nb||(e=je(f,d,!1,a)&&e));if(b)for(g=0;!a.nb&&g<b.length;g++)f=a.currentTarget=b[g],e=je(f,d,!1,a)&&e;return e};
h.cb=function(){he.xd.cb.call(this);if(this.fa){var a=this.fa,b=0,c;for(c in a.G){for(var d=a.G[c],e=0;e<d.length;e++)++b,Nb(d[e]);delete a.G[c];a.$b--}}this.hd=null};h.listen=function(a,b,c,d){ie(this);return this.fa.add(String(a),b,!1,c,d)};
var cc=function(a,b,c,d,e){a.fa.add(String(b),c,!0,d,e)},je=function(a,b,c,d){b=a.fa.G[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.rb&&g.capture==c){var k=g.listener,n=g.kc||g.src;g.dc&&Rb(a.fa,g);e=!1!==k.call(n,d)&&e}}return e&&0!=d.ee};he.prototype.Uc=function(a,b,c,d){return this.fa.Uc(String(a),b,c,d)};var ie=function(a){v(a.fa,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var E=function(a,b){a&&a.log(ce,b,void 0)};var ke=function(a,b,c){if(p(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)},le=function(a){var b=null;return(new A(function(c,d){b=ke(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).f(function(a){l.clearTimeout(b);throw a;})};var me=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,ne=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e,f=null;0<=d?(e=a[c].substring(0,d),f=a[c].substring(d+1)):e=a[c];b(e,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};var F=function(a){he.call(this);this.headers=new Rd;this.Lc=a||null;this.va=!1;this.Kc=this.b=null;this.Hb=this.Zd=this.qc="";this.Ka=this.Yc=this.oc=this.Rc=!1;this.sb=0;this.Ec=null;this.de="";this.Hc=this.sf=this.te=!1};r(F,he);var oe=F.prototype,pe=ge("goog.net.XhrIo");oe.U=pe;var qe=/^https?$/i,re=["POST","PUT"];
F.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.qc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.qc=a;this.Hb="";this.Zd=b;this.Rc=!1;this.va=!0;this.b=this.Lc?this.Lc.fc():Dc.fc();this.Kc=this.Lc?Cc(this.Lc):Cc(Dc);this.b.onreadystatechange=q(this.be,this);this.sf&&"onprogress"in this.b&&(this.b.onprogress=q(function(a){this.ae(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=q(this.ae,this)));try{E(this.U,se(this,"Opening Xhr")),
this.Yc=!0,this.b.open(b,String(a),!0),this.Yc=!1}catch(f){E(this.U,se(this,"Error opening Xhr: "+f.message));this.P(5,f);return}a=c||"";var e=this.headers.clone();d&&Wd(d,function(a,b){e.set(b,a)});d=Ha(e.oa());c=l.FormData&&a instanceof l.FormData;!Ia(re,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.de&&(this.b.responseType=this.de);"withCredentials"in this.b&&this.b.withCredentials!==this.te&&(this.b.withCredentials=
this.te);try{te(this),0<this.sb&&(this.Hc=ue(this.b),E(this.U,se(this,"Will abort after "+this.sb+"ms if incomplete, xhr2 "+this.Hc)),this.Hc?(this.b.timeout=this.sb,this.b.ontimeout=q(this.Zb,this)):this.Ec=ke(this.Zb,this.sb,this)),E(this.U,se(this,"Sending request")),this.oc=!0,this.b.send(a),this.oc=!1}catch(f){E(this.U,se(this,"Send error: "+f.message)),this.P(5,f)}};var ue=function(a){return y&&z(9)&&ga(a.timeout)&&void 0!==a.ontimeout},Ga=function(a){return"content-type"==a.toLowerCase()};
F.prototype.Zb=function(){"undefined"!=typeof aa&&this.b&&(this.Hb="Timed out after "+this.sb+"ms, aborting",E(this.U,se(this,this.Hb)),this.dispatchEvent("timeout"),this.abort(8))};F.prototype.P=function(a,b){this.va=!1;this.b&&(this.Ka=!0,this.b.abort(),this.Ka=!1);this.Hb=b;ve(this);we(this)};var ve=function(a){a.Rc||(a.Rc=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
F.prototype.abort=function(){this.b&&this.va&&(E(this.U,se(this,"Aborting")),this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),we(this))};F.prototype.cb=function(){this.b&&(this.va&&(this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1),we(this,!0));F.xd.cb.call(this)};F.prototype.be=function(){this.isDisposed()||(this.Yc||this.oc||this.Ka?xe(this):this.nf())};F.prototype.nf=function(){xe(this)};
var xe=function(a){if(a.va&&"undefined"!=typeof aa)if(a.Kc[1]&&4==ye(a)&&2==ze(a))E(a.U,se(a,"Local request error detected and ignored"));else if(a.oc&&4==ye(a))ke(a.be,0,a);else if(a.dispatchEvent("readystatechange"),4==ye(a)){E(a.U,se(a,"Request complete"));a.va=!1;try{var b=ze(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.qc).match(me)[1]||null;if(!f&&l.self&&l.self.location)var g=l.self.location.protocol,
f=g.substr(0,g.length-1);e=!qe.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{var k;try{k=2<ye(a)?a.b.statusText:""}catch(n){E(a.U,"Can not get status: "+n.message),k=""}a.Hb=k+" ["+ze(a)+"]";ve(a)}}finally{we(a)}}};F.prototype.ae=function(a,b){v("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Ae(a,"progress"));this.dispatchEvent(Ae(a,b?"downloadprogress":"uploadprogress"))};
var Ae=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},we=function(a,b){if(a.b){te(a);var c=a.b,d=a.Kc[0]?ba:null;a.b=null;a.Kc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.U)&&a.log(ae,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},te=function(a){a.b&&a.Hc&&(a.b.ontimeout=null);ga(a.Ec)&&(l.clearTimeout(a.Ec),a.Ec=null)},ye=function(a){return a.b?a.b.readyState:0},ze=function(a){try{return 2<ye(a)?
a.b.status:-1}catch(b){return-1}},Be=function(a){try{return a.b?a.b.responseText:""}catch(b){return E(a.U,"Can not get responseText: "+b.message),""}},se=function(a,b){return b+" ["+a.Zd+" "+a.qc+" "+ze(a)+"]"};var G=function(a,b){this.ea=this.Xa=this.ha="";this.lb=null;this.Ja=this.xa="";this.S=this.df=!1;var c;a instanceof G?(this.S=void 0!==b?b:a.S,Ce(this,a.ha),c=a.Xa,H(this),this.Xa=c,De(this,a.ea),Ee(this,a.lb),Fe(this,a.xa),Ge(this,a.W.clone()),a=a.Ja,H(this),this.Ja=a):a&&(c=String(a).match(me))?(this.S=!!b,Ce(this,c[1]||"",!0),a=c[2]||"",H(this),this.Xa=He(a),De(this,c[3]||"",!0),Ee(this,c[4]),Fe(this,c[5]||"",!0),Ge(this,c[6]||"",!0),a=c[7]||"",H(this),this.Ja=He(a)):(this.S=!!b,this.W=new I(null,
0,this.S))};G.prototype.toString=function(){var a=[],b=this.ha;b&&a.push(Ie(b,Je,!0),":");var c=this.ea;if(c||"file"==b)a.push("//"),(b=this.Xa)&&a.push(Ie(b,Je,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.lb,null!=c&&a.push(":",String(c));if(c=this.xa)this.ea&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ie(c,"/"==c.charAt(0)?Ke:Le,!0));(c=this.W.toString())&&a.push("?",c);(c=this.Ja)&&a.push("#",Ie(c,Me));return a.join("")};
G.prototype.resolve=function(a){var b=this.clone(),c=!!a.ha;c?Ce(b,a.ha):c=!!a.Xa;if(c){var d=a.Xa;H(b);b.Xa=d}else c=!!a.ea;c?De(b,a.ea):c=null!=a.lb;d=a.xa;if(c)Ee(b,a.lb);else if(c=!!a.xa){if("/"!=d.charAt(0))if(this.ea&&!this.xa)d="/"+d;else{var e=b.xa.lastIndexOf("/");-1!=e&&(d=b.xa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(u(e,"./")||u(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||
1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?Fe(b,d):c=""!==a.W.toString();c?Ge(b,a.W.clone()):c=!!a.Ja;c&&(a=a.Ja,H(b),b.Ja=a);return b};G.prototype.clone=function(){return new G(this)};
var Ce=function(a,b,c){H(a);a.ha=c?He(b,!0):b;a.ha&&(a.ha=a.ha.replace(/:$/,""))},De=function(a,b,c){H(a);a.ea=c?He(b,!0):b},Ee=function(a,b){H(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.lb=b}else a.lb=null},Fe=function(a,b,c){H(a);a.xa=c?He(b,!0):b},Ge=function(a,b,c){H(a);b instanceof I?(a.W=b,a.W.td(a.S)):(c||(b=Ie(b,Ne)),a.W=new I(b,0,a.S))},J=function(a,b,c){H(a);a.W.set(b,c)},Oe=function(a,b){return a.W.get(b)};
G.prototype.removeParameter=function(a){H(this);this.W.remove(a);return this};var H=function(a){if(a.df)throw Error("Tried to modify a read-only Uri");};G.prototype.td=function(a){this.S=a;this.W&&this.W.td(a);return this};
var Pe=function(a){return a instanceof G?a.clone():new G(a,void 0)},Qe=function(a,b){var c=new G(null,void 0);Ce(c,"https");a&&De(c,a);b&&Fe(c,b);return c},He=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ie=function(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Re),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},Re=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},Je=/[#\/\?@]/g,Le=/[\#\?:]/g,Ke=/[\#\?]/g,Ne=/[\#\?@]/g,
Me=/#/g,I=function(a,b,c){this.o=this.l=null;this.O=a||null;this.S=!!c},Se=function(a){a.l||(a.l=new Rd,a.o=0,a.O&&ne(a.O,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},Ue=function(a){var b=Vd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new I(null,0,void 0);a=Ud(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ea(f)?Te(c,e,f):c.add(e,f)}return c};h=I.prototype;
h.add=function(a,b){Se(this);this.O=null;a=this.R(a);var c=this.l.get(a);c||this.l.set(a,c=[]);c.push(b);this.o=za(this.o)+1;return this};h.remove=function(a){Se(this);a=this.R(a);return this.l.yb(a)?(this.O=null,this.o=za(this.o)-this.l.get(a).length,this.l.remove(a)):!1};h.yb=function(a){Se(this);a=this.R(a);return this.l.yb(a)};h.oa=function(){Se(this);for(var a=this.l.Z(),b=this.l.oa(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
h.Z=function(a){Se(this);var b=[];if(m(a))this.yb(a)&&(b=Ma(b,this.l.get(this.R(a))));else{a=this.l.Z();for(var c=0;c<a.length;c++)b=Ma(b,a[c])}return b};h.set=function(a,b){Se(this);this.O=null;a=this.R(a);this.yb(a)&&(this.o=za(this.o)-this.l.get(a).length);this.l.set(a,[b]);this.o=za(this.o)+1;return this};h.get=function(a,b){a=a?this.Z(a):[];return 0<a.length?String(a[0]):b};var Te=function(a,b,c){a.remove(b);0<c.length&&(a.O=null,a.l.set(a.R(b),Na(c)),a.o=za(a.o)+c.length)};
I.prototype.toString=function(){if(this.O)return this.O;if(!this.l)return"";for(var a=[],b=this.l.oa(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.Z(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.O=a.join("&")};I.prototype.clone=function(){var a=new I;a.O=this.O;this.l&&(a.l=this.l.clone(),a.o=this.o);return a};I.prototype.R=function(a){a=String(a);this.S&&(a=a.toLowerCase());return a};
I.prototype.td=function(a){a&&!this.S&&(Se(this),this.O=null,this.l.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),Te(this,b,a))},this));this.S=a};var Ve=function(){var a=K();return y&&!!ob&&11==ob||/Edge\/\d+/.test(a)},We=function(){return l.window&&l.window.location.href||""},Xe=function(a,b){b=b||l.window;var c="about:blank";a&&(c=rc(uc(a)));b.location.href=c},Ye=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ea(a[d])?Wa(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Ye(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},$e=function(){var a;
a=K();a="Chrome"!=Ze(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!ob||9<ob},af=function(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},bf=function(a){a=a||l.window;try{a.close()}catch(b){}},cf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,u(c,"crios/")&&(b.target="_blank"));"Firefox"==Ze(K())&&(a=a||"http://localhost",b.scrollbars=!0);var g;c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof qc?c:uc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;
default:e.push(g+"="+(d[g]?1:0))}g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&(e=g&&(g instanceof HTMLAnchorElement||!(g instanceof Location||g instanceof Element)),f=ha(g)?g.constructor.displayName||g.constructor.name||Object.prototype.toString.call(g):void 0===g?"undefined":null===g?"null":
typeof g,v(e,"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",f)),b=b instanceof qc?b:uc(b),g.href=rc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=rc(b),g&&(fb&&u(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=mc("b/12014412, meta tag with sanitized URL"),ua.test(d)&&(-1!=d.indexOf("&")&&(d=d.replace(oa,
"&amp;")),-1!=d.indexOf("<")&&(d=d.replace(pa,"&lt;")),-1!=d.indexOf(">")&&(d=d.replace(qa,"&gt;")),-1!=d.indexOf('"')&&(d=d.replace(ra,"&quot;")),-1!=d.indexOf("'")&&(d=d.replace(sa,"&#39;")),-1!=d.indexOf("\x00")&&(d=d.replace(ta,"&#0;"))),d='<META HTTP-EQUIV="refresh" content="0; url='+d+'">',Aa(lc(a),"must provide justification"),v(!/^[\s\xa0]*$/.test(lc(a)),"must provide non-empty justification"),g.document.write(Yc((new Xc).$e(d))),g.document.close())):g=a.open(rc(b),c,g);if(g)try{g.focus()}catch(k){}return g},
df=function(a){return new A(function(b){var c=function(){le(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},ef=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ff=function(){var a=null;return(new A(function(b){"complete"==l.document.readyState?b():(a=function(){b()},bc(window,"load",a))})).f(function(b){dc(window,"load",a);throw b;})},hf=function(){return gf(void 0)?ff().then(function(){return new A(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},
1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):D(Error("Cordova must run in an Android or iOS file scheme."))},gf=function(a){a=a||K();return!("file:"!==jf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},kf=function(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}},L=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},lf=function(){var a=L();return"ReactNative"===
a||"Node"===a},Ze=function(a){var b=a.toLowerCase();if(u(b,"opera/")||u(b,"opr/")||u(b,"opios/"))return"Opera";if(u(b,"iemobile"))return"IEMobile";if(u(b,"msie")||u(b,"trident/"))return"IE";if(u(b,"edge/"))return"Edge";if(u(b,"firefox/"))return"Firefox";if(u(b,"silk/"))return"Silk";if(u(b,"blackberry"))return"Blackberry";if(u(b,"webos"))return"Webos";if(!u(b,"safari/")||u(b,"chrome/")||u(b,"crios/")||u(b,"android"))if(!u(b,"chrome/")&&!u(b,"crios/")||u(b,"edge/")){if(u(b,"android"))return"Android";
if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},mf=function(a){var b=L();return("Browser"===b?Ze(K()):b)+"/JsCore/"+a},K=function(){return l.navigator&&l.navigator.userAgent||""},M=function(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},pf=function(){var a;if(a=(nf()||"chrome-extension:"===jf()||gf())&&!lf())a:{try{var b=l.localStorage,c=
of();if(b){b.setItem(c,"1");b.removeItem(c);a=Ve()?!!l.indexedDB:!0;break a}}catch(d){}a=!1}return a},nf=function(){return"http:"===jf()||"https:"===jf()},jf=function(){return l.location&&l.location.protocol||null},qf=function(a){a=a||K();return af(a)||"Firefox"==Ze(a)?!1:!0},rf=function(a){return"undefined"===typeof a?null:xc(a)},sf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},tf=function(a){if(null!==a)return JSON.parse(a)},of=function(a){return a?
a:""+Math.floor(1E9*Math.random()).toString()},uf=function(a){a=a||K();return"Safari"==Ze(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},vf=function(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},wf=function(){return l.navigator&&"boolean"===typeof l.navigator.onLine?l.navigator.onLine:!0},xf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");
this.Ff=a;this.gf=b;a=c||K();d=d||L();this.cf=af(a)||"ReactNative"===d};xf.prototype.get=function(){return this.cf?this.gf:this.Ff};
var yf=function(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},zf=function(){var a=l.document,b=null;return yf()||!a?B():(new A(function(c){b=function(){yf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).f(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Af={},Bf=function(a){Af[a]||(Af[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Cf;try{var Df={};Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:2});Cf=2==Df.abcd}catch(a){Cf=!1}
var N=function(a,b,c){Cf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Ef=function(a,b){Cf?Object.defineProperty(a,"provider",{configurable:!0,enumerable:!0,get:function(){Bf("firebase.auth.AuthCredential.provider is deprecated. Please use the providerId field instead.");return b}}):a.provider=b},Ff=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&N(a,c,b[c])},Gf=function(a){var b={};Ff(b,a);return b},Hf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=
a[c]);return b},If=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},Jf=function(a){var b=a;if("object"==typeof a&&null!=a){var b="length"in a?[]:{},c;for(c in a)N(b,c,Jf(a[c]))}return b};var Kf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Lf=["client_id","response_type","scope","redirect_uri","state"],Mf={Pf:{Mb:500,Lb:600,providerId:"facebook.com",qd:Lf},Qf:{Mb:500,Lb:620,providerId:"github.com",qd:Lf},Rf:{Mb:515,Lb:680,providerId:"google.com",qd:Lf},Sf:{Mb:485,Lb:705,providerId:"twitter.com",qd:Kf}},Nf=function(a){for(var b in Mf)if(Mf[b].providerId==a)return Mf[b];return null};var O=function(a,b){this.code="auth/"+a;this.message=b||Of[a]||""};r(O,Error);O.prototype.C=function(){return{code:this.code,message:this.message}};O.prototype.toJSON=function(){return this.C()};
var Pf=function(a){var b=a&&a.code;return b?new O(b.substring(5),a.message):null},Of={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"",
"code-expired":"","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
"email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.",
"invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-identifier-number":"","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-verification-id":"","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"","missing-verification-code":"","missing-identifier-number":"","missing-verification-id":"","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.",
"user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var P=function(a,b,c,d,e){this.da=a;this.J=b||null;this.tb=c||null;this.sd=d||null;this.P=e||null;if(this.tb||this.P){if(this.tb&&this.P)throw new O("invalid-auth-event");if(this.tb&&!this.sd)throw new O("invalid-auth-event");}else throw new O("invalid-auth-event");};P.prototype.ic=function(){return this.sd};P.prototype.getError=function(){return this.P};P.prototype.C=function(){return{type:this.da,eventId:this.J,urlResponse:this.tb,sessionId:this.sd,error:this.P&&this.P.C()}};
var Qf=function(a){a=a||{};return a.type?new P(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&Pf(a.error)):null};var Rf=function(a){var b="unauthorized-domain",c=void 0,d=Pe(a);a=d.ea;d=d.ha;"chrome-extension"==d?c=ma("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=ma("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
"operation-not-supported-in-this-environment";O.call(this,b,c)};r(Rf,O);var Sf=function(a){this.ff=a.sub;la();this.gc=a.email||null};var Tf=function(a,b){return a.then(function(a){if(a.idToken){var c;a:{var e=a.idToken.split(".");if(3==e.length){for(var e=e[1],f=(4-e.length%4)%4,g=0;g<f;g++)e+=".";try{var k=JSON.parse(tb(e));if(k.sub&&k.iss&&k.aud&&k.exp){c=new Sf(k);break a}}catch(n){}}c=null}if(!c||b!=c.ff)throw new O("user-mismatch");return a}throw new O("user-mismatch");}).f(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new O("user-mismatch"):a;})},Uf=function(a,b){if(b.idToken||b.accessToken)b.idToken&&N(this,
"idToken",b.idToken),b.accessToken&&N(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)N(this,"accessToken",b.oauthToken),N(this,"secret",b.oauthTokenSecret);else throw new O("internal-error","failed to construct a credential");Ef(this,a);N(this,"providerId",a)};Uf.prototype.Ab=function(a){return Vf(a,Wf(this))};Uf.prototype.cd=function(a,b){var c=Wf(this);c.idToken=b;return Xf(a,c)};Uf.prototype.ed=function(a,b){var c=Wf(this);return Tf(Yf(a,c),b)};
var Wf=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ue(b).toString(),requestUri:"http://localhost"}};Uf.prototype.C=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
var Zf=function(a,b){this.vf=b||[];Ff(this,{providerId:a,isOAuthProvider:!0});this.Id={}};Zf.prototype.setCustomParameters=function(a){this.Id=Xa(a);return this};var Q=function(a){Zf.call(this,a,Lf);this.rd=[]};r(Q,Zf);Q.prototype.addScope=function(a){Ia(this.rd,a)||this.rd.push(a);return this};Q.prototype.Rd=function(){return Na(this.rd)};
Q.prototype.credential=function(a,b){if(!a&&!b)throw new O("argument-error","credential failed: must provide the ID token and/or the access token.");return new Uf(this.providerId,{idToken:a||null,accessToken:b||null})};var $f=function(){Q.call(this,"facebook.com")};r($f,Q);N($f,"PROVIDER_ID","facebook.com");
var ag=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new $f).credential(null,b)},bg=function(){Q.call(this,"github.com")};r(bg,Q);N(bg,"PROVIDER_ID","github.com");
var cg=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new bg).credential(null,b)},dg=function(){Q.call(this,"google.com");this.addScope("profile")};r(dg,Q);N(dg,"PROVIDER_ID","google.com");var eg=function(a,b){var c=a;ha(a)&&(c=a.idToken,b=a.accessToken);return(new dg).credential(c,b)},fg=function(){Zf.call(this,"twitter.com",Kf)};r(fg,Zf);N(fg,"PROVIDER_ID","twitter.com");
var gg=function(a,b){var c=a;ha(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new O("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Uf("twitter.com",c)},hg=function(a,b){this.gc=a;this.jd=b;Ef(this,"password");N(this,"providerId","password")};hg.prototype.Ab=function(a){return R(a,ig,{email:this.gc,password:this.jd})};hg.prototype.cd=function(a,b){return R(a,jg,{idToken:b,email:this.gc,password:this.jd})};
hg.prototype.ed=function(a,b){return Tf(this.Ab(a),b)};hg.prototype.C=function(){return{email:this.gc,password:this.jd}};var kg=function(){Ff(this,{providerId:"password",isOAuthProvider:!1})};Ff(kg,{PROVIDER_ID:"password"});var lg=function(a){if(!(a.Bd&&a.Ad||a.Yb&&a.ya))throw new O("internal-error");this.I=a;N(this,"providerId","identifier")};lg.prototype.Ab=function(a){return a.se(mg(this))};lg.prototype.cd=function(a,b){var c=mg(this);c.idToken=b;return R(a,ng,c)};
lg.prototype.ed=function(a,b){var c=mg(this);c.operation="REAUTH";a=R(a,og,c);return Tf(a,b)};lg.prototype.C=function(){var a={providerId:"identifier"};this.I.Bd&&(a.verificationId=this.I.Bd);this.I.Ad&&(a.verificationCode=this.I.Ad);this.I.Yb&&(a.temporaryProof=this.I.Yb);this.I.ya&&(a.identifierNumber=this.I.ya);return a};
var mg=function(a){return a.I.Yb&&a.I.ya?{temporaryProof:a.I.Yb,identifierNumber:a.I.ya}:{sessionInfo:a.I.Bd,code:a.I.Ad}},pg=function(a){try{this.Ce=a||firebase.auth()}catch(b){throw new O("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.identifierAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}Ff(this,{providerId:"identifier",isOAuthProvider:!1})};
pg.prototype.se=function(a,b){var c=this.Ce.g;return B(b.verify()).then(function(d){if(!m(d))throw new O("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return R(c,qg,{identifierNumber:a,recaptchaToken:d});default:throw new O("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};Ff(pg,{PROVIDER_ID:"identifier"});
var rg=function(a){if(a.temporaryProof&&a.identifierNumber)return new lg({Yb:a.temporaryProof,ya:a.identifierNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return eg(a,c);case "facebook.com":return ag(c);case "github.com":return cg(c);case "twitter.com":return gg(c,d);default:return(new Q(b)).credential(a,c)}}catch(e){return null}},sg=function(a){if(!a.isOAuthProvider)throw new O("invalid-oauth-provider");
};var tg=function(a,b,c){O.call(this,a,c);a=b||{};a.email&&N(this,"email",a.email);a.ya&&N(this,"identifierNumber",a.ya);a.credential&&N(this,"credential",a.credential)};r(tg,O);tg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.identifierNumber&&(a.identifierNumber=this.identifierNumber);var b=this.credential&&this.credential.C();b&&Za(a,b);return a};tg.prototype.toJSON=function(){return this.C()};
var ug=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:rg(a)};if(a.email)c.email=a.email;else if(a.identifierNumber)c.ya=a.identifierNumber;else return new O(b,a.message||void 0);return new tg(b,c,a.message)}return null};var vg=function(a){this.Of=a};r(vg,Bc);vg.prototype.fc=function(){return new this.Of};vg.prototype.$c=function(){return{}};
var S=function(a,b,c){var d;d="Node"==L();d=l.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new O("internal-error","The XMLHttpRequest compatibility library was not found.");this.j=a;a=b||{};this.Bf=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Cf=a.secureTokenTimeout||wg;this.ge=Xa(a.secureTokenHeaders||xg);this.Le=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Me=a.firebaseTimeout||
yg;this.Pd=Xa(a.firebaseHeaders||zg);c&&(this.Pd["X-Client-Version"]=c,this.ge["X-Client-Version"]=c);this.Ee=new Gc;this.Nf=new vg(d)},Ag,wg=new xf(3E4,6E4),xg={"Content-Type":"application/x-www-form-urlencoded"},yg=new xf(3E4,6E4),zg={"Content-Type":"application/json"},Cg=function(a,b,c,d,e,f,g){wf()?($e()?a=q(a.Ef,a):(Ag||(Ag=new A(function(a,b){Bg(a,b)})),a=q(a.Df,a)),a(b,c,d,e,f,g)):c&&c(null)};
S.prototype.Ef=function(a,b,c,d,e,f){var g="Node"==L(),k=lf()?g?new F(this.Nf):new F:new F(this.Ee),n;f&&(k.sb=Math.max(0,f),n=setTimeout(function(){k.dispatchEvent("timeout")},f));k.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Be(this))||null}catch(db){a=null}b&&b(a)});cc(k,"ready",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb())});cc(k,"timeout",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb());b&&b(null)});k.send(a,c,d,e)};
var Ed="__fcb"+Math.floor(1E6*Math.random()).toString(),Bg=function(a,b){((window.gapi||{}).client||{}).request?a():(l[Ed]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))},Gd(function(){b(Error("CORS_UNSUPPORTED"))}))};
S.prototype.Df=function(a,b,c,d,e){var f=this;Ag.then(function(){window.gapi.client.setApiKey(f.j);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).f(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
var Eg=function(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Cg(a,a.Bf+"?key="+encodeURIComponent(a.j),function(a){a?a.error?d(Dg(a)):a.access_token&&a.refresh_token?c(a):d(new O("internal-error")):d(new O("network-request-failed"))},"POST",Ue(b).toString(),a.ge,a.Cf.get()):d(new O("internal-error"))})},Fg=function(a,b,c,d,e,f){var g=Pe(a.Le+b);J(g,"key",a.j);f&&J(g,"cb",la().toString());var k="GET"==c;if(k)for(var n in d)d.hasOwnProperty(n)&&
J(g,n,d[n]);return new A(function(b,f){Cg(a,g.toString(),function(a){a?a.error?f(Dg(a,e||{})):b(a):f(new O("network-request-failed"))},c,k?void 0:xc(sf(d)),a.Pd,a.Me.get())})},Gg=function(a){if(!ic.test(a.email))throw new O("invalid-email");},Hg=function(a){"email"in a&&Gg(a)},Jg=function(a,b){return R(a,Ig,{identifier:b,continueUri:nf()?We():"http://localhost"}).then(function(a){return a.allProviders||[]})},Lg=function(a){return R(a,Kg,{}).then(function(a){return a.authorizedDomains||[]})},Mg=function(a){if(!a.idToken)throw new O("internal-error");
},Ng=function(a){if(a.identifierNumber||a.temporaryProof){if(!a.identifierNumber||!a.temporaryProof)throw new O("internal-error");}else{if(!a.sessionInfo)throw new O("missing-verification-id");if(!a.code)throw new O("missing-verification-code");}};S.prototype.signInAnonymously=function(){return R(this,Og,{})};S.prototype.updateEmail=function(a,b){return R(this,Pg,{idToken:a,email:b})};S.prototype.updatePassword=function(a,b){return R(this,jg,{idToken:a,password:b})};var Qg={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
S.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];Sa(Qg,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return R(this,Pg,c)};S.prototype.sendPasswordResetEmail=function(a){return R(this,Rg,{requestType:"PASSWORD_RESET",email:a})};S.prototype.sendEmailVerification=function(a){return R(this,Sg,{requestType:"VERIFY_EMAIL",idToken:a})};S.prototype.se=function(a){return R(this,Tg,a)};
var Vg=function(a,b,c){return R(a,Ug,{idToken:b,deleteProvider:c})},Wg=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new O("internal-error");},Xg=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=ug(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=ug(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=ug(a));if(b)throw b;if(!a.idToken)throw new O("internal-error");},Vf=function(a,
b){b.returnIdpCredential=!0;return R(a,Yg,b)},Xf=function(a,b){b.returnIdpCredential=!0;return R(a,Zg,b)},Yf=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return R(a,$g,b)},ah=function(a){if(!a.oobCode)throw new O("invalid-action-code");};S.prototype.confirmPasswordReset=function(a,b){return R(this,bh,{oobCode:a,newPassword:b})};S.prototype.checkActionCode=function(a){return R(this,ch,{oobCode:a})};S.prototype.applyActionCode=function(a){return R(this,dh,{oobCode:a})};
var dh={endpoint:"setAccountInfo",A:ah,Wa:"email"},ch={endpoint:"resetPassword",A:ah,Y:function(a){if(!a.email||!a.requestType)throw new O("internal-error");}},eh={endpoint:"signupNewUser",A:function(a){Gg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Ig={endpoint:"createAuthUri"},fh={endpoint:"deleteAccount",Ua:["idToken"]},Ug={endpoint:"setAccountInfo",Ua:["idToken","deleteProvider"],A:function(a){if(!ea(a.deleteProvider))throw new O("internal-error");}},gh={endpoint:"getAccountInfo"},
Sg={endpoint:"getOobConfirmationCode",Ua:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new O("internal-error");},Wa:"email"},Rg={endpoint:"getOobConfirmationCode",Ua:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new O("internal-error");Gg(a)},Wa:"email"},Kg={De:!0,endpoint:"getProjectConfig",We:"GET"},bh={endpoint:"resetPassword",A:ah,Wa:"email"},qg={endpoint:"sendVerificationCode",Ua:["identifierNumber","recaptchaToken"],Wa:"sessionInfo"},Pg={endpoint:"setAccountInfo",
Ua:["idToken"],A:Hg,sa:!0},jg={endpoint:"setAccountInfo",Ua:["idToken"],A:function(a){Hg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Og={endpoint:"signupNewUser",Y:Mg,sa:!0},Yg={endpoint:"verifyAssertion",A:Wg,Y:Xg,sa:!0},$g={endpoint:"verifyAssertion",A:Wg,Y:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new O("user-not-found");if(!a.idToken)throw new O("internal-error");},sa:!0},Zg={endpoint:"verifyAssertion",A:function(a){Wg(a);if(!a.idToken)throw new O("internal-error");
},Y:Xg,sa:!0},hh={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new O("invalid-custom-token");},Y:Mg,sa:!0},ig={endpoint:"verifyPassword",A:function(a){Gg(a);if(!a.password)throw new O("wrong-password");},Y:Mg,sa:!0},Tg={endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},ng={endpoint:"verifyidentifierNumber",A:function(a){if(!a.idToken)throw new O("internal-error");Ng(a)},Y:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",ug(a);Mg(a)}},og={Ge:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},R=function(a,b,c){if(!If(c,b.Ua))return D(new O("internal-error"));var d=b.We||"POST",e;return B(c).then(b.A).then(function(){b.sa&&(c.returnSecureToken=!0);return Fg(a,b.endpoint,d,c,b.Ge,b.De||!1)}).then(function(a){return e=a}).then(b.Y).then(function(){if(!b.Wa)return e;if(!(b.Wa in e))throw new O("internal-error");return e[b.Wa]})},Dg=function(a,b){var c;c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};
if(c=d[c]?new O(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",
FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",
CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_identifier_NUMBER:"invalid-identifier-number",INVALID_SESSION_INFO:"invalid-verification-id",
INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_identifier_NUMBER:"missing-identifier-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired"};Za(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new O(d[e],b);!b&&a&&(b=rf(a));return new O("internal-error",b)};var ih=function(a){this.V=a};ih.prototype.value=function(){return this.V};ih.prototype.je=function(a){this.V.style=a;return this};var jh=function(a){this.V=a||{}};jh.prototype.value=function(){return this.V};jh.prototype.je=function(a){this.V.style=a;return this};var lh=function(a){this.Lf=a;this.nc=null;this.gd=kh(this)},mh=function(a){var b=new jh;b.V.where=document.body;b.V.url=a.Lf;b.V.messageHandlersFilter=M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.V.attributes=b.V.attributes||{};(new ih(b.V.attributes)).je({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.V.dontclear=!0;return b},kh=function(a){return nh().then(function(){return new A(function(b,c){M("gapi.iframes.getContext")().open(mh(a).value(),function(d){a.nc=d;a.nc.restyle({setHideOnLeave:!1});
var e=setTimeout(function(){c(Error("Network Error"))},oh.get()),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};lh.prototype.sendMessage=function(a){var b=this;return this.gd.then(function(){return new A(function(c){b.nc.send(a.type,a,c,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
var ph=function(a,b){a.gd.then(function(){a.nc.register("authEvent",b,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},qh=new xf(3E4,6E4),oh=new xf(5E3,15E3),nh=function(){return new A(function(a,b){if(wf()){var c=function(){vf();M("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){vf();b(Error("Network Error"))},timeout:qh.get()})};if(M("gapi.iframes.Iframe"))a();else if(M("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){M("gapi.load")?
c():b(Error("Network Error"))};B(Dd("https://apis.google.com/js/api.js?onload="+d)).f(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})};var rh=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Ya=null;this.ac=Qe(this.v,"/__/auth/iframe");J(this.ac,"apiKey",this.j);J(this.ac,"appName",this.D)};rh.prototype.setVersion=function(a){this.Ya=a;return this};rh.prototype.toString=function(){this.Ya?J(this.ac,"v",this.Ya):this.ac.removeParameter("v");return this.ac.toString()};var sh=function(a,b,c,d,e){this.v=a;this.j=b;this.D=c;this.Be=d;this.Ya=this.J=this.pd=null;this.Pb=e};sh.prototype.setVersion=function(a){this.Ya=a;return this};
sh.prototype.toString=function(){var a=Qe(this.v,"/__/auth/handler");J(a,"apiKey",this.j);J(a,"appName",this.D);J(a,"authType",this.Be);if(this.Pb.isOAuthProvider){J(a,"providerId",this.Pb.providerId);var b=this.Pb,c=sf(b.Id),d;for(d in c)c[d]=c[d].toString();b=b.vf;c=Xa(c);for(d=0;d<b.length;d++){var e=b[d];e in c&&delete c[e]}Va(c)||J(a,"customParameters",rf(c))}"function"===typeof this.Pb.Rd&&(b=this.Pb.Rd(),b.length&&J(a,"scopes",b.join(",")));this.pd?J(a,"redirectUrl",this.pd):a.removeParameter("redirectUrl");
this.J?J(a,"eventId",this.J):a.removeParameter("eventId");this.Ya?J(a,"v",this.Ya):a.removeParameter("v");if(this.bc)for(var f in this.bc)this.bc.hasOwnProperty(f)&&!Oe(a,f)&&J(a,f,this.bc[f]);return a.toString()};
var th=function(a,b,c,d){this.v=a;this.j=b;this.D=c;this.Oe=(this.Ea=d||null)?mf(this.Ea):null;d=this.Ea;this.Xe=(new rh(a,b,c)).setVersion(d).toString();this.ma=[];this.g=new S(b,null,this.Oe);this.pc=this.wa=null},uh=function(a){var b=We();return Lg(a).then(function(a){a:{for(var c=Pe(b),e=c.ha,c=c.ea,f=0;f<a.length;f++){var g;var k=a[f];g=c;var n=e;0==k.indexOf("chrome-extension://")?g=Pe(k).ea==g&&"chrome-extension"==n:"http"!=n&&"https"!=n?g=!1:ef.test(k)?g=g==k:(k=k.split(".").join("\\."),g=
(new RegExp("^(.+\\."+k+"|"+k+")$","i")).test(g));if(g){a=!0;break a}}a=!1}if(!a)throw new Rf(We());})};h=th.prototype;h.Gb=function(){if(this.pc)return this.pc;var a=this;return this.pc=ff().then(function(){a.mc=new lh(a.Xe);vh(a)})};h.Vb=function(a,b,c){var d=new O("popup-closed-by-user"),e=new O("web-storage-unsupported"),f=this,g=!1;return this.La().then(function(){wh(f).then(function(c){c||(a&&bf(a),b(e),g=!0)})}).f(function(){}).then(function(){if(!g)return df(a)}).then(function(){if(!g)return le(c).then(function(){b(d)})})};
h.ke=function(){var a=K();return!qf(a)&&!uf(a)};h.Ud=function(){return!1};h.Nb=function(a,b,c,d,e,f,g){if(!a)return D(new O("popup-blocked"));if(g&&!qf())return this.La().f(function(b){bf(a);e(b)}),d(),B();this.wa||(this.wa=uh(this.g));var k=this;return this.wa.then(function(){var b=k.La().f(function(b){bf(a);e(b);throw b;});d();return b}).then(function(){sg(c);if(!g){var d=xh(k.v,k.j,k.D,b,c,null,f,k.Ea);Xe(d,a)}}).f(function(a){"auth/network-request-failed"==a.code&&(k.wa=null);throw a;})};
h.Ob=function(a,b,c){this.wa||(this.wa=uh(this.g));var d=this;return this.wa.then(function(){sg(b);var e=xh(d.v,d.j,d.D,a,b,We(),c,d.Ea);Xe(e)})};h.La=function(){var a=this;return this.Gb().then(function(){return a.mc.gd}).f(function(){a.wa=null;throw new O("network-request-failed");})};h.ne=function(){return!0};
var xh=function(a,b,c,d,e,f,g,k,n){a=new sh(a,b,c,d,e);a.pd=f;a.J=g;f=a.setVersion(k);f.bc=Xa(n||null);return f.toString()},vh=function(a){if(!a.mc)throw Error("IfcHandler must be initialized!");ph(a.mc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Qf(b.authEvent);for(c=0;c<a.ma.length;c++)d=a.ma[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})},wh=function(a){var b={type:"webStorageSupport"};return a.Gb().then(function(){return a.mc.sendMessage(b)}).then(function(a){if(a&&
a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};th.prototype.$a=function(a){this.ma.push(a)};th.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var yh=function(a){this.B=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.B)throw new O("internal-error","The React Native compatibility library was not found.");};h=yh.prototype;h.get=function(a){return B(this.B.getItem(a)).then(function(a){return a&&tf(a)})};h.set=function(a,b){return B(this.B.setItem(a,rf(b)))};h.remove=function(a){return B(this.B.removeItem(a))};h.ab=function(){};h.Ta=function(){};var zh=function(){this.B={}};h=zh.prototype;h.get=function(a){return B(this.B[a])};h.set=function(a,b){this.B[a]=b;return B()};h.remove=function(a){delete this.B[a];return B()};h.ab=function(){};h.Ta=function(){};var Ch=function(){if(!Bh()){if("Node"==L())throw new O("internal-error","The LocalStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.localStorage||firebase.INTERNAL.node.localStorage},Bh=function(){var a="Node"==L(),a=l.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Ch.prototype;
h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(a){l.window&&Vb(l.window,"storage",a)};h.Ta=function(a){l.window&&dc(l.window,"storage",a)};var Dh=function(){this.B={}};h=Dh.prototype;h.get=function(){return B(null)};h.set=function(){return B()};h.remove=function(){return B()};h.ab=function(){};h.Ta=function(){};var Fh=function(){if(!Eh()){if("Node"==L())throw new O("internal-error","The SessionStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.sessionStorage||firebase.INTERNAL.node.sessionStorage},Eh=function(){var a="Node"==L(),a=l.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Fh.prototype;
h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(){};h.Ta=function(){};var Gh=function(a,b,c,d,e,f){if(!window.indexedDB)throw new O("web-storage-unsupported");this.He=a;this.fd=b;this.Qc=c;this.re=d;this.wb=e;this.$={};this.Wb=[];this.Jb=0;this.Ye=f||l.indexedDB},Hh,Ih=function(a){return new A(function(b,c){var d=a.Ye.open(a.He,a.wb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.fd,{keyPath:a.Qc})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},Jh=function(a){a.Xd||(a.Xd=
Ih(a));return a.Xd},Kh=function(a,b){return b.objectStore(a.fd)},Lh=function(a,b,c){return b.transaction([a.fd],c?"readwrite":"readonly")},Mh=function(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=Gh.prototype;
h.set=function(a,b){var c=!1,d,e=this;return md(Jh(this).then(function(b){d=b;b=Kh(e,Lh(e,d,!0));return Mh(b.get(a))}).then(function(f){var g=Kh(e,Lh(e,d,!0));if(f)return f.value=b,Mh(g.put(f));e.Jb++;c=!0;f={};f[e.Qc]=a;f[e.re]=b;return Mh(g.add(f))}).then(function(){e.$[a]=b}),function(){c&&e.Jb--})};h.get=function(a){var b=this;return Jh(this).then(function(c){return Mh(Kh(b,Lh(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
h.remove=function(a){var b=!1,c=this;return md(Jh(this).then(function(d){b=!0;c.Jb++;return Mh(Kh(c,Lh(c,d,!0))["delete"](a))}).then(function(){delete c.$[a]}),function(){b&&c.Jb--})};
h.Hf=function(){var a=this;return Jh(this).then(function(b){var c=Kh(a,Lh(a,b,!1));return c.getAll?Mh(c.getAll()):new A(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Jb){for(d=0;d<b.length;d++)c[b[d][a.Qc]]=b[d][a.re];d=Ye(a.$,c);a.$=c}return d})};h.ab=function(a){0==this.Wb.length&&this.vd();this.Wb.push(a)};
h.Ta=function(a){La(this.Wb,function(b){return b==a});0==this.Wb.length&&this.Bc()};h.vd=function(){var a=this;this.Bc();var b=function(){a.kd=le(800).then(q(a.Hf,a)).then(function(b){0<b.length&&w(a.Wb,function(a){a(b)})}).then(b).f(function(a){"STOP_EVENT"!=a.message&&b()});return a.kd};b()};h.Bc=function(){this.kd&&this.kd.cancel("STOP_EVENT")};var Qh=function(){this.Ld={Browser:Nh,Node:Oh,ReactNative:Ph}[L()]},Rh,Nh={M:Ch,yd:Fh},Oh={M:Ch,yd:Fh},Ph={M:yh,yd:Dh};var Sh=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;N(this,"operation",a);N(this,"data",Jf(b))};var Th=function(a,b,c,d,e,f){this.pf=a;this.xf=b;this.Qe=c;this.rc=d;this.zd=e;this.yf=!!f;this.kb=null;this.Ma=this.rc;if(this.zd<this.rc)throw Error("Proactive refresh lower bound greater than upper bound!");};Th.prototype.start=function(){this.Ma=this.rc;Uh(this,!0)};
var Vh=function(a,b){if(b)return a.Ma=a.rc,a.Qe();b=a.Ma;a.Ma*=2;a.Ma>a.zd&&(a.Ma=a.zd);return b},Uh=function(a,b){a.stop();a.kb=le(Vh(a,b)).then(function(){return a.yf?B():zf()}).then(function(){return a.pf()}).then(function(){Uh(a,!0)}).f(function(b){a.xf(b)&&Uh(a,!1)})};Th.prototype.stop=function(){this.kb&&(this.kb.cancel(),this.kb=null)};var ai=function(a){var b={};b["facebook.com"]=Wh;b["google.com"]=Xh;b["github.com"]=Yh;b["twitter.com"]=Zh;var c=a&&a.providerId;return c?b[c]?new b[c](a):new $h(a):null},$h=function(a){var b=tf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");N(this,"profile",Jf(b||{}));N(this,"providerId",a)},Wh=function(a){$h.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};r(Wh,$h);
var Yh=function(a){$h.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",this.profile&&this.profile.login||null)};r(Yh,$h);var Xh=function(a){$h.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};r(Xh,$h);var Zh=function(a){$h.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",a.screenName||null)};r(Zh,$h);var bi=function(a,b,c,d){this.kf=a;this.he=b;this.zf=c;this.Ub=d;this.T={};Rh||(Rh=new Qh);a=Rh;try{var e;Ve()?(Hh||(Hh=new Gh("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1)),e=Hh):e=new a.Ld.M;this.Qa=e}catch(f){this.Qa=new zh,this.Ub=!0}try{this.Dc=new a.Ld.yd}catch(f){this.Dc=new zh}this.wd=q(this.le,this);this.$={}},ci,di=function(){ci||(ci=new bi("firebase",":",!uf(K())&&kf()?!0:!1,qf()));return ci};h=bi.prototype;
h.R=function(a,b){return this.kf+this.he+a.name+(b?this.he+b:"")};h.get=function(a,b){return(a.M?this.Qa:this.Dc).get(this.R(a,b))};h.remove=function(a,b){b=this.R(a,b);a.M&&!this.Ub&&(this.$[b]=null);return(a.M?this.Qa:this.Dc).remove(b)};h.set=function(a,b,c){var d=this.R(a,c),e=this,f=a.M?this.Qa:this.Dc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.M&&!this.Ub&&(e.$[d]=b)})};
h.addListener=function(a,b,c){a=this.R(a,b);this.Ub||(this.$[a]=l.localStorage.getItem(a));Va(this.T)&&this.vd();this.T[a]||(this.T[a]=[]);this.T[a].push(c)};h.removeListener=function(a,b,c){a=this.R(a,b);this.T[a]&&(La(this.T[a],function(a){return a==c}),0==this.T[a].length&&delete this.T[a]);Va(this.T)&&this.Bc()};h.vd=function(){this.Qa.ab(this.wd);this.Ub||Ve()||ei(this)};
var ei=function(a){fi(a);a.dd=setInterval(function(){for(var b in a.T){var c=l.localStorage.getItem(b),d=a.$[b];c!=d&&(a.$[b]=c,c=new Jb({type:"storage",key:b,target:window,oldValue:d,newValue:c,rf:!0}),a.le(c))}},1E3)},fi=function(a){a.dd&&(clearInterval(a.dd),a.dd=null)};bi.prototype.Bc=function(){this.Qa.Ta(this.wd);fi(this)};
bi.prototype.le=function(a){if(a&&a.Pe){var b=a.eb.key;"undefined"!==typeof a.eb.rf?this.Qa.Ta(this.wd):fi(this);if(this.zf){var c=l.localStorage.getItem(b);a=a.eb.newValue;a!=c&&(a?l.localStorage.setItem(b,a):a||l.localStorage.removeItem(b))}this.$[b]=l.localStorage.getItem(b);this.Ed(b)}else w(a,q(this.Ed,this))};bi.prototype.Ed=function(a){this.T[a]&&w(this.T[a],function(a){a()})};var gi=function(a,b){this.u=a;this.i=b||di()},hi={name:"authEvent",M:!0},ii=function(a){return a.i.get(hi,a.u).then(function(a){return Qf(a)})};gi.prototype.$a=function(a){this.i.addListener(hi,this.u,a)};gi.prototype.Tb=function(a){this.i.removeListener(hi,this.u,a)};var ji=function(a){this.i=a||di()},ki={name:"sessionId",M:!1};ji.prototype.ic=function(a){return this.i.get(ki,a)};var li=function(a,b,c,d,e,f){this.v=a;this.j=b;this.D=c;this.Ea=d||null;this.me=b+":"+c;this.Af=new ji;this.Qd=new gi(this.me);this.Zc=null;this.ma=[];this.bf=e||500;this.tf=f||2E3;this.Fb=this.uc=null},mi=function(a){return new O("invalid-cordova-configuration",a)};
li.prototype.La=function(){return this.ad?this.ad:this.ad=hf().then(function(){if("function"!==typeof M("universalLinks.subscribe",l))throw mi("cordova-universal-links-plugin is not installed");if("undefined"===typeof M("BuildInfo.packageName",l))throw mi("cordova-plugin-buildinfo is not installed");if("function"!==typeof M("cordova.plugins.browsertab.openUrl",l))throw mi("cordova-plugin-browsertab is not installed");if("function"!==typeof M("cordova.InAppBrowser.open",l))throw mi("cordova-plugin-inappbrowser is not installed");
},function(){throw new O("cordova-not-ready");})};var ni=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},oi=function(a){var b=new Eb;b.update(a);return Oa(b.digest())};h=li.prototype;h.Vb=function(a,b){b(new O("operation-not-supported-in-this-environment"));return B()};h.Nb=function(){return D(new O("operation-not-supported-in-this-environment"))};h.ne=function(){return!1};h.ke=function(){return!0};
h.Ud=function(){return!0};
h.Ob=function(a,b,c){if(this.uc)return D(new O("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,k=null,n=null;return this.uc=md(B().then(function(){sg(b);return pi(d)}).then(function(){return qi(d,a,b,c)}).then(function(){return(new A(function(a,b){g=function(){var b=M("cordova.plugins.browsertab.close",l);a();"function"===typeof b&&b();d.Fb&&"function"===typeof d.Fb.close&&(d.Fb.close(),d.Fb=null);return!1};d.$a(g);k=function(){f||(f=le(d.tf).then(function(){b(new O("redirect-cancelled-by-user"))}))};n=
function(){yf()&&k()};e.addEventListener("resume",k,!1);K().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).f(function(a){return ri(d).then(function(){throw a;})})}),function(){k&&e.removeEventListener("resume",k,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Tb(g);d.uc=null})};
var qi=function(a,b,c,d){var e=ni(),f=new P(b,d,null,e,new O("no-auth-event")),g=M("BuildInfo.packageName",l);if("string"!==typeof g)throw new O("invalid-cordova-configuration");var k=M("BuildInfo.displayName",l),n={};if(K().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(K().toLowerCase().match(/android/))n.apn=g;else return D(new O("operation-not-supported-in-this-environment"));k&&(n.appDisplayName=k);e=oi(e);n.sessionId=e;var C=xh(a.v,a.j,a.D,b,c,null,d,a.Ea,n);return a.La().then(function(){var b=
a.me;return a.Af.i.set(hi,f.C(),b)}).then(function(){var b=M("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=M("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");c(C)}else{c=M("cordova.InAppBrowser.open",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");b=c;var d;d=K();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.Fb=b(C,d?"_blank":"_system","location=yes")}})})},si=function(a,b){for(var c=0;c<a.ma.length;c++)try{a.ma[c](b)}catch(d){}},pi=function(a){a.Zc||(a.Zc=a.La().then(function(){return new A(function(b){var c=function(d){b(d);a.Tb(c);return!1};a.$a(c);ti(a)})}));return a.Zc},ri=function(a){var b=null;return ii(a.Qd).then(function(c){b=c;c=a.Qd;return c.i.remove(hi,c.u)}).then(function(){return b})},ti=function(a){var b=M("universalLinks.subscribe",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");
var c=new P("unknown",null,null,null,new O("no-auth-event")),d=!1,e=le(a.bf).then(function(){return ri(a).then(function(){d||si(a,c)})}),f=function(b){d=!0;e&&e.cancel();ri(a).then(function(d){var e=c;if(d&&b&&b.url){var e=null,f;f=b.url;var g=Pe(f),k=Oe(g,"link"),n=Oe(Pe(k),"link"),g=Oe(g,"deep_link_id");f=Oe(Pe(g),"link")||g||n||k||f;-1!=f.indexOf("/__/auth/callback")&&(e=Pe(f),e=tf(Oe(e,"firebaseError")||null),e=(e="object"===typeof e?Pf(e):null)?new P(d.da,d.J,null,null,e):new P(d.da,d.J,f,d.ic()));
e=e||c}si(a,e)})},g=l.handleOpenURL;l.handleOpenURL=function(a){0==a.indexOf(M("BuildInfo.packageName",l)+"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};li.prototype.$a=function(a){this.ma.push(a);pi(this).f(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new P("unknown",null,null,null,new O("no-auth-event")),a(b))})};li.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var ui=function(a){this.u=a;this.i=di()},vi={name:"pendingRedirect",M:!1},wi=function(a){return a.i.set(vi,"pending",a.u)},xi=function(a){return a.i.remove(vi,a.u)},yi=function(a){return a.i.get(vi,a.u).then(function(a){return"pending"==a})};var T=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Xb=[];this.ib=!1;this.Mc=q(this.Wc,this);this.Ra=new zi(this);this.ld=new Ai(this);this.Kb=new ui(this.j+":"+this.D);this.Aa={};this.Aa.unknown=this.Ra;this.Aa.signInViaRedirect=this.Ra;this.Aa.linkViaRedirect=this.Ra;this.Aa.reauthViaRedirect=this.Ra;this.Aa.signInViaPopup=this.ld;this.Aa.linkViaPopup=this.ld;this.Aa.reauthViaPopup=this.ld;this.K=Bi(this.v,this.j,this.D)},Bi=function(a,b,c){var d=firebase.SDK_VERSION||null;return gf()?new li(a,
b,c,d):new th(a,b,c,d)};T.prototype.reset=function(){this.ib=!1;this.K.Tb(this.Mc);this.K=Bi(this.v,this.j,this.D)};T.prototype.Gb=function(){var a=this;this.ib||(this.ib=!0,this.K.$a(this.Mc));var b=this.K;return this.K.La().f(function(c){a.K==b&&a.reset();throw c;})};var Ei=function(a){a.K.ke()&&a.Gb().f(function(b){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(b)&&a.Wc(c)});a.K.Ud()||Di(a.Ra)};
T.prototype.subscribe=function(a){Ia(this.Xb,a)||this.Xb.push(a);if(!this.ib){var b=this;yi(this.Kb).then(function(a){a?xi(b.Kb).then(function(){b.Gb().f(function(a){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(a)&&b.Wc(c)})}):Ei(b)}).f(function(){Ei(b)})}};T.prototype.unsubscribe=function(a){La(this.Xb,function(b){return b==a})};
T.prototype.Wc=function(a){if(!a)throw new O("invalid-auth-event");for(var b=!1,c=0;c<this.Xb.length;c++){var d=this.Xb[c];if(d.Fd(a.da,a.J)){(b=this.Aa[a.da])&&b.ce(a,d);b=!0;break}}Di(this.Ra);return b};var Fi=new xf(2E3,1E4),Gi=new xf(3E4,6E4);T.prototype.getRedirectResult=function(){return this.Ra.getRedirectResult()};T.prototype.Nb=function(a,b,c,d,e){var f=this;return this.K.Nb(a,b,c,function(){f.ib||(f.ib=!0,f.K.$a(f.Mc))},function(){f.reset()},d,e)};
var Ci=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};T.prototype.Ob=function(a,b,c){var d=this,e;return wi(this.Kb).then(function(){return d.K.Ob(a,b,c).f(function(a){if(Ci(a))throw new O("operation-not-supported-in-this-environment");e=a;return xi(d.Kb).then(function(){throw e;})}).then(function(){return d.K.ne()?new A(function(){}):xi(d.Kb).then(function(){return d.getRedirectResult()}).then(function(){}).f(function(){})})})};
T.prototype.Vb=function(a,b,c,d){return this.K.Vb(c,function(c){a.Va(b,null,c,d)},Fi.get())};var Hi={},Ii=function(a,b,c){var d=b+":"+c;Hi[d]||(Hi[d]=new T(a,b,c));return Hi[d]},zi=function(a){this.i=a;this.qb=null;this.Rb=[];this.Qb=[];this.ob=null;this.od=!1};zi.prototype.reset=function(){this.qb=null;this.ob&&(this.ob.cancel(),this.ob=null)};
zi.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));this.reset();this.od=!0;var c=a.da,d=a.J,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event")):(Ji(this,!1,null,null),a=B());return a};var Di=function(a){a.od||(a.od=!0,Ji(a,!1,null,null))};
zi.prototype.md=function(a){Ji(this,!0,null,a.getError());return B()};zi.prototype.nd=function(a,b){var c=this;b=b.zb(a.da,a.J);var d=a.tb,e=a.ic(),f=!!a.da.match(/Redirect$/);return b(d,e).then(function(a){Ji(c,f,a,null)}).f(function(a){Ji(c,f,null,a)})};
var Ki=function(a,b){a.qb=function(){return D(b)};if(a.Qb.length)for(var c=0;c<a.Qb.length;c++)a.Qb[c](b)},Li=function(a,b){a.qb=function(){return B(b)};if(a.Rb.length)for(var c=0;c<a.Rb.length;c++)a.Rb[c](b)},Ji=function(a,b,c,d){b?d?Ki(a,d):Li(a,c):Li(a,{user:null});a.Rb=[];a.Qb=[]};zi.prototype.getRedirectResult=function(){var a=this;return new A(function(b,c){a.qb?a.qb().then(b,c):(a.Rb.push(b),a.Qb.push(c),Mi(a))})};
var Mi=function(a){var b=new O("timeout");a.ob&&a.ob.cancel();a.ob=le(Gi.get()).then(function(){a.qb||Ji(a,!0,null,b)})},Ai=function(a){this.i=a};Ai.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));var c=a.da,d=a.J;return a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event"))};Ai.prototype.md=function(a,b){b.Va(a.da,null,a.getError(),a.J);return B()};
Ai.prototype.nd=function(a,b){var c=a.J,d=a.da,e=b.zb(d,c),f=a.tb;a=a.ic();return e(f,a).then(function(a){b.Va(d,a,null,c)}).f(function(a){b.Va(d,null,a,c)})};var Ni=function(a){this.g=a;this.Ba=this.X=null;this.Ha=0};Ni.prototype.C=function(){return{apiKey:this.g.j,refreshToken:this.X,accessToken:this.Ba,expirationTime:this.Ha}};
var Pi=function(a,b){var c=b.idToken,d=b.refreshToken;b=Oi(b.expiresIn);a.Ba=c;a.Ha=b;a.X=d},Oi=function(a){return la()+1E3*parseInt(a,10)},Qi=function(a,b){return Eg(a.g,b).then(function(b){a.Ba=b.access_token;a.Ha=Oi(b.expires_in);a.X=b.refresh_token;return{accessToken:a.Ba,expirationTime:a.Ha,refreshToken:a.X}}).f(function(b){"auth/user-token-expired"==b.code&&(a.X=null);throw b;})};
Ni.prototype.getToken=function(a){a=!!a;return this.Ba&&!this.X?D(new O("user-token-expired")):a||!this.Ba||la()>this.Ha-3E4?this.X?Qi(this,{grant_type:"refresh_token",refresh_token:this.X}):B(null):B({accessToken:this.Ba,expirationTime:this.Ha,refreshToken:this.X})};var Ri=function(a,b,c,d,e){Ff(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},Si=function(a,b){Ib.call(this,a);for(var c in b)this[c]=b[c]};r(Si,Ib);
var U=function(a,b,c){this.ba=[];this.j=a.apiKey;this.D=a.appName;this.v=a.authDomain||null;a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null;this.g=new S(this.j,null,a);this.ia=new Ni(this.g);Ti(this,b.idToken);Pi(this.ia,b);N(this,"refreshToken",this.ia.X);Ui(this,c||{});he.call(this);this.vc=!1;this.v&&pf()&&(this.m=Ii(this.v,this.j,this.D));this.Ac=[];this.ka=null;this.mb=Vi(this);this.vb=q(this.Xc,this)};r(U,he);U.prototype.Xc=function(){this.mb.kb&&(this.mb.stop(),this.mb.start())};
var Vi=function(a){return new Th(function(){return a.getToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.ia.Ha-la()-3E5;return 0<b?b:0},3E4,96E4,!1)},Wi=function(a){a.Kd||a.mb.kb||(a.mb.start(),dc(a,"tokenChanged",a.vb),Vb(a,"tokenChanged",a.vb))},Xi=function(a){dc(a,"tokenChanged",a.vb);a.mb.stop()},Ti=function(a,b){a.Yd=b;N(a,"_lat",b)},Yi=function(a,b){La(a.Ac,function(a){return a==b})},Zi=function(a){for(var b=[],c=0;c<a.Ac.length;c++)b.push(a.Ac[c](a));
return jd(b).then(function(){return a})},$i=function(a){a.m&&!a.vc&&(a.vc=!0,a.m.subscribe(a))},Ui=function(a,b){Ff(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,identifierNumber:b.identifierNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};N(U.prototype,"providerId","firebase");
var aj=function(){},bj=function(a){return B().then(function(){if(a.Kd)throw new O("app-deleted");})},cj=function(a){return Ea(a.providerData,function(a){return a.providerId})},ej=function(a,b){b&&(dj(a,b.providerId),a.providerData.push(b))},dj=function(a,b){La(a.providerData,function(a){return a.providerId==b})},fj=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&N(a,b,c)};
U.prototype.copy=function(a){var b=this;b!=a&&(Ff(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,identifierNumber:a.identifierNumber,isAnonymous:a.isAnonymous,providerData:[]}),w(a.providerData,function(a){ej(b,a)}),this.ia=a.ia,N(this,"refreshToken",this.ia.X))};U.prototype.reload=function(){var a=this;return this.c(bj(this).then(function(){return gj(a).then(function(){return Zi(a)}).then(aj)}))};
var gj=function(a){return a.getToken().then(function(b){var c=a.isAnonymous;return hj(a,b).then(function(){c||fj(a,"isAnonymous",!1);return b})})};U.prototype.getToken=function(a){var b=this;return this.c(bj(this).then(function(){return b.ia.getToken(a)}).then(function(a){if(!a)throw new O("internal-error");a.accessToken!=b.Yd&&(Ti(b,a.accessToken),b.Na());fj(b,"refreshToken",a.refreshToken);return a.accessToken}))};
var ij=function(a,b){b.idToken&&a.Yd!=b.idToken&&(Pi(a.ia,b),a.Na(),Ti(a,b.idToken),fj(a,"refreshToken",a.ia.X))};U.prototype.Na=function(){this.dispatchEvent(new Si("tokenChanged"))};var hj=function(a,b){return R(a.g,gh,{idToken:b}).then(q(a.qf,a))};
U.prototype.qf=function(a){a=a.users;if(!a||!a.length)throw new O("internal-error");a=a[0];Ui(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,identifierNumber:a.identifierNumber});for(var b=jj(a),c=0;c<b.length;c++)ej(this,b[c]);fj(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
var jj=function(a){return(a=a.providerUserInfo)&&a.length?Ea(a,function(a){return new Ri(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]},lj=function(a,b){var c=null;return a.c(b.ed(a.g,a.uid).then(function(b){ij(a,b);c=kj(a,b,"reauthenticate");a.ka=null;return a.reload()}).then(function(){return c}),!0)};U.prototype.reauthenticate=function(a){Bf("firebase.User.prototype.reauthenticate is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.reauthenticateWithCredential(a)};
U.prototype.reauthenticateWithCredential=function(a){return lj(this,a).then(function(){})};var mj=function(a,b){return gj(a).then(function(){if(Ia(cj(a),b))return Zi(a).then(function(){throw new O("provider-already-linked");})})},oj=function(a,b){var c=null;return a.c(mj(a,b.providerId).then(function(){return a.getToken()}).then(function(c){return b.cd(a.g,c)}).then(function(b){c=kj(a,b,"link");return nj(a,b)}).then(function(){return c}))};
U.prototype.link=function(a){Bf("firebase.User.prototype.link is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.linkWithCredential(a)};U.prototype.linkWithCredential=function(a){return oj(this,a).then(function(a){return a.user})};var kj=function(a,b,c){var d=rg(b);b=ai(b);return Gf({user:a,credential:d,additionalUserInfo:b,operationType:c})},nj=function(a,b){ij(a,b);return a.reload().then(function(){return a})};h=U.prototype;
h.updateEmail=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updateEmail(c,a)}).then(function(a){ij(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updatePassword(c,a)}).then(function(a){ij(b,a);return b.reload()}))};
h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return bj(this);var b=this;return this.c(this.getToken().then(function(c){return b.g.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){ij(b,a);fj(b,"displayName",a.displayName||null);fj(b,"photoURL",a.photoUrl||null);return Zi(b)}).then(aj))};
h.unlink=function(a){var b=this;return this.c(gj(this).then(function(c){return Ia(cj(b),a)?Vg(b.g,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(cj(b),function(a){c[a]||dj(b,a)});return Zi(b)}):Zi(b).then(function(){throw new O("no-such-provider");})}))};
h["delete"]=function(){var a=this;return this.c(this.getToken().then(function(b){return R(a.g,fh,{idToken:b})}).then(function(){a.dispatchEvent(new Si("userDeleted"))})).then(function(){for(var b=0;b<a.ba.length;b++)a.ba[b].cancel("app-deleted");a.ba=[];a.Kd=!0;Xi(a);N(a,"refreshToken",null);a.m&&a.m.unsubscribe(a)})};
h.Fd=function(a,b){return"linkViaPopup"==a&&(this.ca||null)==b&&this.aa||"reauthViaPopup"==a&&(this.ca||null)==b&&this.aa||"linkViaRedirect"==a&&(this.za||null)==b||"reauthViaRedirect"==a&&(this.za||null)==b?!0:!1};h.Va=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.ca||null)||(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};
h.zb=function(a,b){return"linkViaPopup"==a&&b==(this.ca||null)?q(this.Nd,this):"reauthViaPopup"==a&&b==(this.ca||null)?q(this.Od,this):"linkViaRedirect"==a&&(this.za||null)==b?q(this.Nd,this):"reauthViaRedirect"==a&&(this.za||null)==b?q(this.Od,this):null};h.hc=function(){return of(this.uid+":::")};var qj=function(a,b){return pj(a,"linkViaPopup",b,function(){return mj(a,b.providerId).then(function(){return Zi(a)})},!1)};
U.prototype.linkWithPopup=function(a){return qj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};var rj=function(a,b){return pj(a,"reauthViaPopup",b,function(){return B()},!0)};U.prototype.reauthenticateWithPopup=function(a){return rj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
var pj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=Nf(c.providerId),g=a.hc(),k=null;(!qf()||kf())&&a.v&&c.isOAuthProvider&&(k=xh(a.v,a.j,a.D,b,c,null,g,firebase.SDK_VERSION||null));var n=cf(k,f&&f.Mb,f&&f.Lb);d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){return a.m.Nb(n,b,c,g,!!k)}).then(function(){return new A(function(c,d){a.Va(b,null,new O("cancelled-popup-request"),a.ca||
null);a.aa=c;a.Pa=d;a.ca=g;a.F=a.m.Vb(a,b,n,g)})}).then(function(a){n&&bf(n);return a}).f(function(a){n&&bf(n);throw a;});return a.c(d,e)};U.prototype.linkWithRedirect=function(a){var b=this;return tj(this,"linkViaRedirect",a,function(){return mj(b,a.providerId)},!1)};U.prototype.reauthenticateWithRedirect=function(a){return tj(this,"reauthViaRedirect",a,function(){return B()},!0)};
var tj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=null,g=a.hc();d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){a.za=g;return Zi(a)}).then(function(b){a.Sa&&(b=a.Sa,b=b.i.set(uj,a.C(),b.u));return b}).then(function(){return a.m.Ob(b,c,g)}).f(function(b){f=b;if(a.Sa)return vj(a.Sa);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},sj=function(a){if(!a.m||!a.vc){if(a.m&&
!a.vc)throw new O("internal-error");throw new O("auth-domain-config-required");}};U.prototype.Nd=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=this.getToken().then(function(d){return Xf(c.g,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=kj(c,a,"link");return nj(c,a)}).then(function(){return d});return this.c(e)};
U.prototype.Od=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=B().then(function(){return Tf(Yf(c.g,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=kj(c,a,"reauthenticate");ij(c,a);c.ka=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};U.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getToken().then(function(b){return a.g.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};
U.prototype.c=function(a,b){var c=this,d=wj(this,a,b);this.ba.push(d);md(d,function(){Ka(c.ba,d)});return d};var wj=function(a,b,c){return a.ka&&!c?(b.cancel(),D(a.ka)):b.f(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.ka||a.dispatchEvent(new Si("userInvalidated")),a.ka=b);throw b;})};U.prototype.toJSON=function(){return this.C()};
U.prototype.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,identifierNumber:this.identifierNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.j,appName:this.D,authDomain:this.v,stsTokenManager:this.ia.C(),redirectEventId:this.za||null};w(this.providerData,function(b){a.providerData.push(Hf(b))});return a};
var xj=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-la())/1E3;else return null;var d=new U(b,c,a);a.providerData&&w(a.providerData,function(a){a&&ej(d,Gf(a))});a.redirectEventId&&(d.za=a.redirectEventId);return d},
yj=function(a,b,c){var d=new U(a,b);c&&(d.Sa=c);return d.reload().then(function(){return d})};var zj=function(a){this.u=a;this.i=di()},uj={name:"redirectUser",M:!1},vj=function(a){return a.i.remove(uj,a.u)},Aj=function(a,b){return a.i.get(uj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var Bj=function(a){this.u=a;this.i=di()},Cj={name:"authUser",M:!0},Dj=function(a,b){return a.i.set(Cj,b.C(),a.u)},Ej=function(a){return a.i.remove(Cj,a.u)},Fj=function(a,b){return a.i.get(Cj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var W=function(a){this.Fa=!1;N(this,"app",a);if(V(this).options&&V(this).options.apiKey)a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null,this.g=new S(V(this).options&&V(this).options.apiKey,null,a);else throw new O("invalid-api-key");this.ba=[];this.Ca=[];this.ub=[];this.mf=firebase.INTERNAL.createSubscribe(q(this.Ze,this));this.Ic=void 0;firebase.INTERNAL.createSubscribe(q(this.af,this));Gj(this,null);this.ta=new Bj(V(this).options.apiKey+":"+V(this).name);this.pb=new zj(V(this).options.apiKey+
":"+V(this).name);this.cc=this.c(Hj(this));this.qa=this.c(Ij(this));this.bd=!1;this.Vc=q(this.Gf,this);this.qe=q(this.gb,this);this.vb=q(this.Xc,this);this.oe=q(this.Ue,this);this.pe=q(this.Ve,this);Jj(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this["delete"],this);this.Ia=0};W.prototype.toJSON=function(){return{apiKey:V(this).options.apiKey,authDomain:V(this).options.authDomain,appName:V(this).name,currentUser:X(this)&&X(this).C()}};
var Kj=function(a){return a.Ie||D(new O("auth-domain-config-required"))},Jj=function(a){var b=V(a).options.authDomain,c=V(a).options.apiKey;b&&pf()&&(a.Ie=a.cc.then(function(){if(!a.Fa)return a.m=Ii(b,c,V(a).name),a.m.subscribe(a),X(a)&&$i(X(a)),a.Sb&&($i(a.Sb),a.Sb=null),a.m}))};h=W.prototype;h.Fd=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ca==b&&!!this.aa;default:return!1}};
h.Va=function(a,b,c,d){"signInViaPopup"==a&&this.ca==d&&(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};h.zb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ca==b&&this.aa?q(this.Ke,this):null};
h.Ke=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.F&&(this.F.cancel(),this.F=null);var d=null,e=null,f=Vf(c.g,a).then(function(a){d=rg(a);e=ai(a);return a});a=c.cc.then(function(){return f}).then(function(a){return Lj(c,a)}).then(function(){return Gf({user:X(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.hc=function(){return of()};
var Mj=function(a,b){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var c=Nf(b.providerId),d=a.hc(),e=null;(!qf()||kf())&&V(a).options.authDomain&&b.isOAuthProvider&&(e=xh(V(a).options.authDomain,V(a).options.apiKey,V(a).name,"signInViaPopup",b,null,d,firebase.SDK_VERSION||null));var f=cf(e,c&&c.Mb,c&&c.Lb),c=Kj(a).then(function(a){return a.Nb(f,"signInViaPopup",b,d,!!e)}).then(function(){return new A(function(b,c){a.Va("signInViaPopup",null,new O("cancelled-popup-request"),
a.ca);a.aa=b;a.Pa=c;a.ca=d;a.F=a.m.Vb(a,"signInViaPopup",f,d)})}).then(function(a){f&&bf(f);return a}).f(function(a){f&&bf(f);throw a;});return a.c(c)};W.prototype.signInWithPopup=function(a){return Mj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};W.prototype.getRedirectResult=function(){return Nj(this).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
W.prototype.signInWithRedirect=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=this,c=Kj(this).then(function(){return b.m.Ob("signInViaRedirect",a)});return this.c(c)};
var Nj=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=Kj(a).then(function(){return a.m.getRedirectResult()});return a.c(b)},Lj=function(a,b){var c={};c.apiKey=V(a).options.apiKey;c.authDomain=V(a).options.authDomain;c.appName=V(a).name;return a.cc.then(function(){return yj(c,b,a.pb)}).then(function(b){if(X(a)&&b.uid==X(a).uid)return X(a).copy(b),a.gb(b);Gj(a,b);$i(b);return a.gb(b)}).then(function(){a.Na()})},Gj=function(a,b){X(a)&&(Yi(X(a),a.qe),dc(X(a),
"tokenChanged",a.vb),dc(X(a),"userDeleted",a.oe),dc(X(a),"userInvalidated",a.pe),Xi(X(a)));b&&(b.Ac.push(a.qe),Vb(b,"tokenChanged",a.vb),Vb(b,"userDeleted",a.oe),Vb(b,"userInvalidated",a.pe),0<a.Ia&&Wi(b));N(a,"currentUser",b)};W.prototype.signOut=function(){var a=this,b=this.qa.then(function(){if(!X(a))return B();Gj(a,null);return Ej(a.ta).then(function(){a.Na()})});return this.c(b)};
var Oj=function(a){var b=Aj(a.pb,V(a).options.authDomain).then(function(b){if(a.Sb=b)b.Sa=a.pb;return vj(a.pb)});return a.c(b)},Hj=function(a){var b=V(a).options.authDomain,c=Oj(a).then(function(){return Fj(a.ta,b)}).then(function(b){return b?(b.Sa=a.pb,a.Sb&&(a.Sb.za||null)==(b.za||null)?b:b.reload().then(function(){return Dj(a.ta,b).then(function(){return b})}).f(function(c){return"auth/network-request-failed"==c.code?b:Ej(a.ta)})):null}).then(function(b){Gj(a,b||null)});return a.c(c)},Ij=function(a){return a.cc.then(function(){return a.getRedirectResult()}).f(function(){}).then(function(){if(!a.Fa)return a.Vc()}).f(function(){}).then(function(){if(!a.Fa){a.bd=
!0;var b=a.ta;b.i.addListener(Cj,b.u,a.Vc)}})};h=W.prototype;h.Gf=function(){var a=this;return Fj(this.ta,V(this).options.authDomain).then(function(b){if(!a.Fa){var c;if(c=X(a)&&b){c=X(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return X(a).copy(b),X(a).getToken();if(X(a)||b)Gj(a,b),b&&($i(b),b.Sa=a.pb),a.m&&a.m.subscribe(a),a.Na()}})};h.gb=function(a){return Dj(this.ta,a)};h.Xc=function(){this.Na();this.gb(X(this))};h.Ue=function(){this.signOut()};
h.Ve=function(){this.signOut()};var Pj=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=rg(b);d=ai(b);return Lj(a,b)}).then(function(){return Gf({user:X(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=W.prototype;h.Ze=function(a){var b=this;this.addAuthTokenListener(function(){a.next(X(b))})};h.af=function(a){var b=this;Qj(this,function(){a.next(X(b))})};
h.onAuthStateChanged=function(a,b,c){var d=this;this.bd&&firebase.Promise.resolve().then(function(){p(a)?a(X(d)):p(a.next)&&a.next(X(d))});return this.mf(a,b,c)};h.getToken=function(a){var b=this,c=this.qa.then(function(){return X(b)?X(b).getToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};h.signInWithCustomToken=function(a){var b=this;return this.qa.then(function(){return Pj(b,R(b.g,hh,{token:a}))}).then(function(a){a=a.user;fj(a,"isAnonymous",!1);return b.gb(a)}).then(function(){return X(b)})};
h.signInWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,ig,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,eh,{email:a,password:b}))}).then(function(a){return a.user})};h.signInWithCredential=function(a){return Rj(this,a).then(function(a){return a.user})};var Rj=function(a,b){return a.qa.then(function(){return Pj(a,b.Ab(a.g))})};
W.prototype.signInAnonymously=function(){var a=X(this),b=this;return a&&a.isAnonymous?B(a):this.qa.then(function(){return Pj(b,b.g.signInAnonymously())}).then(function(a){a=a.user;fj(a,"isAnonymous",!0);return b.gb(a)}).then(function(){return X(b)})};var V=function(a){return a.app},X=function(a){return a.currentUser};W.prototype.getUid=function(){return X(this)&&X(this).uid||null};var Sj=function(a){return X(a)&&X(a)._lat||null};h=W.prototype;
h.Na=function(){if(this.bd){for(var a=0;a<this.Ca.length;a++)if(this.Ca[a])this.Ca[a](Sj(this));if(this.Ic!==this.getUid()&&this.ub.length)for(this.Ic=this.getUid(),a=0;a<this.ub.length;a++)if(this.ub[a])this.ub[a](Sj(this))}};h.Ae=function(a){this.addAuthTokenListener(a);this.Ia++;0<this.Ia&&X(this)&&Wi(X(this))};h.uf=function(a){var b=this;w(this.Ca,function(c){c==a&&b.Ia--});0>this.Ia&&(this.Ia=0);0==this.Ia&&X(this)&&Xi(X(this));this.removeAuthTokenListener(a)};
h.addAuthTokenListener=function(a){var b=this;this.Ca.push(a);this.c(this.qa.then(function(){b.Fa||Ia(b.Ca,a)&&a(Sj(b))}))};h.removeAuthTokenListener=function(a){La(this.Ca,function(b){return b==a})};var Qj=function(a,b){a.ub.push(b);a.c(a.qa.then(function(){!a.Fa&&Ia(a.ub,b)&&a.Ic!==a.getUid()&&(a.Ic=a.getUid(),b(Sj(a)))}))};h=W.prototype;
h["delete"]=function(){this.Fa=!0;for(var a=0;a<this.ba.length;a++)this.ba[a].cancel("app-deleted");this.ba=[];this.ta&&(a=this.ta,a.i.removeListener(Cj,a.u,this.Vc));this.m&&this.m.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.ba.push(a);md(a,function(){Ka(b.ba,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(Jg(this.g,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
h.confirmPasswordReset=function(a,b){return this.c(this.g.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.g.checkActionCode(a).then(function(a){return new Sh(a)}))};h.applyActionCode=function(a){return this.c(this.g.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.g.sendPasswordResetEmail(a).then(function(){}))};var Tj="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),Y=function(a,b){return{name:a||"",ja:"a valid string",optional:!!b,la:m}},Z=function(a){return{name:a||"",ja:"a valid object",optional:!1,la:ha}},Uj=function(a,b){return{name:a||"",ja:"a function",optional:!!b,la:p}},Vj=function(){return{name:"",ja:"null",optional:!1,la:da}},Wj=function(){return{name:"credential",ja:"a valid credential",optional:!1,la:function(a){return a?!!a.Ab:!1}}},Xj=function(){return{name:"authProvider",
ja:"a valid Auth provider",optional:!1,la:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},Yj=function(a,b,c,d){return{name:c||"",ja:a.ja+" or "+b.ja,optional:!!d,la:function(c){return a.la(c)||b.la(c)}}};var ak=function(a,b){for(var c in b){var d=b[c].name;a[d]=Zj(d,a[c],b[c].a)}},bk=function(a,b,c,d){a[b]=Zj(b,c,d)},Zj=function(a,b,c){if(!c)return b;var d=ck(a);a=function(){var a=Array.prototype.slice.call(arguments),e;a:{e=Array.prototype.slice.call(a);var k;k=0;for(var n=!1,C=0;C<c.length;C++)if(c[C].optional)n=!0;else{if(n)throw new O("internal-error","Argument validator encountered a required argument after an optional argument.");k++}n=c.length;if(e.length<k||n<e.length)e="Expected "+(k==n?
1==k?"1 argument":k+" arguments":k+"-"+n+" arguments")+" but got "+e.length+".";else{for(k=0;k<e.length;k++)if(n=c[k].optional&&void 0===e[k],!c[k].la(e[k])&&!n){e=c[k];if(0>k||k>=Tj.length)throw new O("internal-error","Argument validator received an unsupported number of arguments.");e=Tj[k]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.ja+".";break a}e=null}}if(e)throw new O("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
b.prototype[e];return a},ck=function(a){a=a.split(".");return a[a.length-1]};ak(W.prototype,{applyActionCode:{name:"applyActionCode",a:[Y("code")]},checkActionCode:{name:"checkActionCode",a:[Y("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[Y("code"),Y("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[Y("email"),Y("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[Y("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[Yj(Z(),Uj(),"nextOrObserver"),
Uj("opt_error",!0),Uj("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[Y("email")]},signInAnonymously:{name:"signInAnonymously",a:[]},signInWithCredential:{name:"signInWithCredential",a:[Wj()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[Y("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",a:[Y("email"),Y("password")]},signInWithPopup:{name:"signInWithPopup",a:[Xj()]},signInWithRedirect:{name:"signInWithRedirect",a:[Xj()]},signOut:{name:"signOut",
a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[Y("code")]}});
ak(U.prototype,{"delete":{name:"delete",a:[]},getToken:{name:"getToken",a:[{name:"opt_forceRefresh",ja:"a boolean",optional:!0,la:function(a){return"boolean"==typeof a}}]},link:{name:"link",a:[Wj()]},linkWithCredential:{name:"linkWithCredential",a:[Wj()]},linkWithPopup:{name:"linkWithPopup",a:[Xj()]},linkWithRedirect:{name:"linkWithRedirect",a:[Xj()]},reauthenticate:{name:"reauthenticate",a:[Wj()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[Wj()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",
a:[Xj()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[Xj()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},unlink:{name:"unlink",a:[Y("provider")]},updateEmail:{name:"updateEmail",a:[Y("email")]},updatePassword:{name:"updatePassword",a:[Y("password")]},updateProfile:{name:"updateProfile",a:[Z("profile")]}});ak(A.prototype,{f:{name:"catch"},then:{name:"then"}});
bk(kg,"credential",function(a,b){return new hg(a,b)},[Y("email"),Y("password")]);ak($f.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk($f,"credential",ag,[Yj(Y(),Z(),"token")]);ak(bg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(bg,"credential",cg,[Yj(Y(),Z(),"token")]);
ak(dg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(dg,"credential",eg,[Yj(Y(),Yj(Z(),Vj()),"idToken"),Yj(Y(),Vj(),"accessToken",!0)]);ak(fg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(fg,"credential",gg,[Yj(Y(),Z(),"token"),Y("secret",!0)]);ak(O.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});ak(tg.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
ak(Rf.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:W,Error:O};bk(a,"EmailAuthProvider",kg,[]);bk(a,"FacebookAuthProvider",$f,[]);bk(a,"GithubAuthProvider",bg,[]);bk(a,"GoogleAuthProvider",dg,[]);bk(a,"TwitterAuthProvider",fg,[]);firebase.INTERNAL.registerService("auth",function(a,c){a=new W(a);c({INTERNAL:{getUid:q(a.getUid,a),getToken:q(a.getToken,a),addAuthTokenListener:q(a.Ae,a),removeAuthTokenListener:q(a.uf,a)}});return a},a,function(a,
c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:U})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.auth;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/

---

typedarray.js
Copyright (c) 2010, Linden Research, Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var firebase = __webpack_require__(108);
(function(){
(function() {var g,aa=this;function n(a){return void 0!==a}function ba(){}function ca(a){a.Vb=function(){return a.Ye?a.Ye:a.Ye=new a}}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return"array"==da(a)}function fa(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"string"==typeof a}function ga(a){return"number"==typeof a}function ha(a){return"function"==da(a)}function ia(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ja(a,b,c){return a.call.apply(a.bind,arguments)}
function ka(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return q.apply(null,arguments)}
function la(a,b){function c(){}c.prototype=b.prototype;a.wg=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.sg=function(a,c,f){for(var h=Array(arguments.length-2),k=2;k<arguments.length;k++)h[k-2]=arguments[k];return b.prototype[c].apply(a,h)}};function ma(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function na(){this.Fd=void 0}
function oa(a,b,c){switch(typeof b){case "string":pa(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(ea(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],oa(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),pa(f,c),
c.push(":"),oa(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var qa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ra=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function pa(a,b){b.push('"',a.replace(ra,function(a){if(a in qa)return qa[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return qa[a]=e+b.toString(16)}),'"')};function sa(){this.Wa=-1};function ta(){this.Wa=-1;this.Wa=64;this.M=[];this.Wd=[];this.Af=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Wa;++a)this.zd[a]=0;this.Pd=this.$b=0;this.reset()}la(ta,sa);ta.prototype.reset=function(){this.M[0]=1732584193;this.M[1]=4023233417;this.M[2]=2562383102;this.M[3]=271733878;this.M[4]=3285377520;this.Pd=this.$b=0};
function ua(a,b,c){c||(c=0);var d=a.Af;if(p(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.M[0];c=a.M[1];for(var h=a.M[2],k=a.M[3],m=a.M[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(h^k),l=1518500249):(f=c^h^k,l=1859775393):60>e?(f=c&h|k&(c|h),l=2400959708):(f=c^h^k,l=3395469782),f=(b<<
5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=h,h=(c<<30|c>>>2)&4294967295,c=b,b=f;a.M[0]=a.M[0]+b&4294967295;a.M[1]=a.M[1]+c&4294967295;a.M[2]=a.M[2]+h&4294967295;a.M[3]=a.M[3]+k&4294967295;a.M[4]=a.M[4]+m&4294967295}
ta.prototype.update=function(a,b){if(null!=a){n(b)||(b=a.length);for(var c=b-this.Wa,d=0,e=this.Wd,f=this.$b;d<b;){if(0==f)for(;d<=c;)ua(this,a,d),d+=this.Wa;if(p(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Wa){ua(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Wa){ua(this,e);f=0;break}}this.$b=f;this.Pd+=b}};var r;a:{var va=aa.navigator;if(va){var wa=va.userAgent;if(wa){r=wa;break a}}r=""};var t=Array.prototype,xa=t.indexOf?function(a,b,c){return t.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ya=t.forEach?function(a,b,c){t.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},za=t.filter?function(a,b,c){return t.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,h=p(a)?
a.split(""):a,k=0;k<d;k++)if(k in h){var m=h[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},Aa=t.map?function(a,b,c){return t.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,h=0;h<d;h++)h in f&&(e[h]=b.call(c,f[h],h,a));return e},Ba=t.reduce?function(a,b,c,d){for(var e=[],f=1,h=arguments.length;f<h;f++)e.push(arguments[f]);d&&(e[0]=q(b,d));return t.reduce.apply(a,e)}:function(a,b,c,d){var e=c;ya(a,function(c,h){e=b.call(d,e,c,h,a)});return e},Ca=t.every?function(a,b,
c){return t.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Da(a,b){var c=Ea(a,b,void 0);return 0>c?null:p(a)?a.charAt(c):a[c]}function Ea(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Fa(a,b){var c=xa(a,b);0<=c&&t.splice.call(a,c,1)}function Ga(a,b,c){return 2>=arguments.length?t.slice.call(a,b):t.slice.call(a,b,c)}
function Ha(a,b){a.sort(b||Ia)}function Ia(a,b){return a>b?1:a<b?-1:0};function v(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ja(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function Ka(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function La(a){var b=0,c;for(c in a)b++;return b}function Ma(a){for(var b in a)return b}function Na(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Oa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Pa(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
function Qa(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function Ra(a,b){var c=Qa(a,b,void 0);return c&&a[c]}function Sa(a){for(var b in a)return!1;return!0}function Ta(a){var b={},c;for(c in a)b[c]=a[c];return b};var Ua=-1!=r.indexOf("Opera")||-1!=r.indexOf("OPR"),Va=-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE"),Wa=-1!=r.indexOf("Gecko")&&-1==r.toLowerCase().indexOf("webkit")&&!(-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE")),Xa=-1!=r.toLowerCase().indexOf("webkit");
(function(){var a="",b;if(Ua&&aa.opera)return a=aa.opera.version,ha(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(r))?a[1]:"");return Va&&(b=(b=aa.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!fa(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],h=e+1<a.length,k=h?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,h||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a,b){if(!a)throw db(b);}function db(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function eb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function fb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function gb(a){var b=[];fb(a,function(a,d){ea(d)?ya(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var hb=firebase.Promise;function ib(){var a=this;this.reject=this.resolve=null;this.ra=new hb(function(b,c){a.resolve=b;a.reject=c})}function jb(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ha(b)&&(kb(a.ra),1===b.length?b(c):b(c,d))}}function kb(a){a.then(void 0,ba)};function lb(a){return"undefined"!==typeof JSON&&n(JSON.parse)?JSON.parse(a):ma(a)}function x(a){if("undefined"!==typeof JSON&&n(JSON.stringify))a=JSON.stringify(a);else{var b=[];oa(new na,a,b);a=b.join("")}return a};function mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,cb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function A(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
function B(a,b,c,d){if((!d||n(c))&&!ha(c))throw Error(A(a,b,d)+"must be a valid function.");}function ob(a,b,c){if(n(c)&&(!ia(c)||null===c))throw Error(A(a,b,!0)+"must be a valid context object.");};function pb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function C(a,b){this.name=a;this.R=b}function qb(a,b){return new C(a,b)};function rb(a,b){return sb(a.name,b.name)}function tb(a,b){return sb(a,b)};function ub(a){this.uc=a;this.Cd="firebase:"}g=ub.prototype;g.set=function(a,b){null==b?this.uc.removeItem(this.Cd+a):this.uc.setItem(this.Cd+a,x(b))};g.get=function(a){a=this.uc.getItem(this.Cd+a);return null==a?null:lb(a)};g.remove=function(a){this.uc.removeItem(this.Cd+a)};g.Ze=!1;g.toString=function(){return this.uc.toString()};function vb(){this.pc={}}vb.prototype.set=function(a,b){null==b?delete this.pc[a]:this.pc[a]=b};vb.prototype.get=function(a){return eb(this.pc,a)?this.pc[a]:null};vb.prototype.remove=function(a){delete this.pc[a]};vb.prototype.Ze=!0;function wb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new ub(b)}}catch(c){}return new vb}var xb=wb("localStorage"),yb=wb("sessionStorage");function zb(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.qg=d;this.gf=e||"";this.$a=xb.get("host:"+a)||this.host}function Ab(a,b){b!==a.$a&&(a.$a=b,"s-"===a.$a.substr(0,2)&&xb.set("host:"+a.host,a.$a))}
function Bb(a,b,c){D("string"===typeof b,"typeof type must == string");D("object"===typeof c,"typeof params must == object");if(b===Cb)b=(a.Sc?"wss://":"ws://")+a.$a+"/.ws?";else if(b===Db)b=(a.Sc?"https://":"http://")+a.$a+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.$a&&(c.ns=a.pe);var d=[];v(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}zb.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.gf&&(a+="<"+this.gf+">");return a};function Eb(a,b){return a&&"object"===typeof a?(D(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Fb(a,b){var c=new Gb;Hb(a,new E(""),function(a,e){Ib(c,a,Jb(e,b))});return c}function Jb(a,b){var c=a.C().H(),c=Eb(c,b),d;if(a.J()){var e=Eb(a.Ca(),b);return e!==a.Ca()||c!==a.C().H()?new Kb(e,G(c)):a}d=a;c!==a.C().H()&&(d=d.fa(new Kb(c)));a.O(H,function(a,c){var e=Jb(c,b);e!==c&&(d=d.T(a,e))});return d};var Lb=function(){var a=1;return function(){return a++}}(),D=cb,Mb=db;
function Nb(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],h=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==h||null==k||null==m)throw Error();d.push(f<<2|h>>4);64!=k&&(d.push(h<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ga(d,c,c+8192));b=a}return b}catch(l){I("base64Decode failed: ",
l)}return null}function Ob(a){var b=mb(a);a=new ta;a.update(b);var b=[],c=8*a.Pd;56>a.$b?a.update(a.zd,56-a.$b):a.update(a.zd,a.Wa-(a.$b-56));for(var d=a.Wa-1;56<=d;d--)a.Wd[d]=c&255,c/=256;ua(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.M[d]>>e&255,++c;return ab(b)}function Pb(a){for(var b="",c=0;c<arguments.length;c++)b=fa(arguments[c])?b+Pb.apply(null,arguments[c]):"object"===typeof arguments[c]?b+x(arguments[c]):b+arguments[c],b+=" ";return b}var Qb=null,Rb=!0;
function Sb(a,b){cb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?Qb=q(console.log,console):"object"===typeof console.log&&(Qb=function(a){console.log(a)})),b&&yb.set("logging_enabled",!0)):ha(a)?Qb=a:(Qb=null,yb.remove("logging_enabled"))}function I(a){!0===Rb&&(Rb=!1,null===Qb&&!0===yb.get("logging_enabled")&&Sb(!0));if(Qb){var b=Pb.apply(null,arguments);Qb(b)}}
function Tb(a){return function(){I(a,arguments)}}function Ub(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+Pb.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function Vb(a){var b=Pb.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function J(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+Pb.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
function Wb(a){var b,c,d,e,f,h=a;f=c=a=b="";d=!0;e="https";if(p(h)){var k=h.indexOf("//");0<=k&&(e=h.substring(0,k-1),h=h.substring(k+2));k=h.indexOf("/");-1===k&&(k=h.length);b=h.substring(0,k);f="";h=h.substring(k).split("/");for(k=0;k<h.length;k++)if(0<h[k].length){var m=h[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}h=b.split(".");3===h.length?(a=h[1],c=h[0].toLowerCase()):2===h.length&&(a=h[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&Vb(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
c&&"undefined"!=c||Vb("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&J("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{jc:new zb(b,d,c,"ws"===e||"wss"===e),path:new E(f)}}function Xb(a){return ga(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
function Yb(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
function sb(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=Zb(a),d=Zb(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function $b(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+x(b));}
function ac(a){if("object"!==typeof a||null===a)return x(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=x(b[d]),c+=":",c+=ac(a[b[d]]);return c+"}"}function bc(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function cc(a,b){if(ea(a))for(var c=0;c<a.length;++c)b(c,a[c]);else v(a,b)}
function dc(a){D(!Xb(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
(d="0"+d),c+=d;return c.toLowerCase()}var ec=/^-?\d{1,10}$/;function Zb(a){return ec.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function fc(a){try{a()}catch(b){setTimeout(function(){J("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function gc(a,b,c){Object.defineProperty(a,b,{get:c})}function hc(a,b){var c=setTimeout(a,b);"object"===typeof c&&c.unref&&c.unref();return c};function ic(a){var b={},c={},d={},e="";try{var f=a.split("."),b=lb(Nb(f[0])||""),c=lb(Nb(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(h){}return{tg:b,Je:c,data:d,mg:e}}function jc(a){a=ic(a);var b=a.Je;return!!a.mg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function kc(a){a=ic(a).Je;return"object"===typeof a&&!0===w(a,"admin")};function lc(){}var mc={};function nc(a){return q(a.compare,a)}lc.prototype.nd=function(a,b){return 0!==this.compare(new C("[MIN_NAME]",a),new C("[MIN_NAME]",b))};lc.prototype.Hc=function(){return oc};function pc(a){D(!a.e()&&".priority"!==K(a),"Can't create PathIndex with empty path or .priority key");this.bc=a}la(pc,lc);g=pc.prototype;g.xc=function(a){return!a.P(this.bc).e()};g.compare=function(a,b){var c=a.R.P(this.bc),d=b.R.P(this.bc),c=c.sc(d);return 0===c?sb(a.name,b.name):c};
g.Ec=function(a,b){var c=G(a),c=L.F(this.bc,c);return new C(b,c)};g.Fc=function(){var a=L.F(this.bc,qc);return new C("[MAX_NAME]",a)};g.toString=function(){return this.bc.slice().join("/")};function rc(){}la(rc,lc);g=rc.prototype;g.compare=function(a,b){var c=a.R.C(),d=b.R.C(),c=c.sc(d);return 0===c?sb(a.name,b.name):c};g.xc=function(a){return!a.C().e()};g.nd=function(a,b){return!a.C().Z(b.C())};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",new Kb("[PRIORITY-POST]",qc))};
g.Ec=function(a,b){var c=G(a);return new C(b,new Kb("[PRIORITY-POST]",c))};g.toString=function(){return".priority"};var H=new rc;function sc(){}la(sc,lc);g=sc.prototype;g.compare=function(a,b){return sb(a.name,b.name)};g.xc=function(){throw Mb("KeyIndex.isDefinedOn not expected to be called.");};g.nd=function(){return!1};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",L)};g.Ec=function(a){D(p(a),"KeyIndex indexValue must always be a string.");return new C(a,L)};g.toString=function(){return".key"};
var tc=new sc;function uc(){}la(uc,lc);g=uc.prototype;g.compare=function(a,b){var c=a.R.sc(b.R);return 0===c?sb(a.name,b.name):c};g.xc=function(){return!0};g.nd=function(a,b){return!a.Z(b)};g.Hc=function(){return oc};g.Fc=function(){return vc};g.Ec=function(a,b){var c=G(a);return new C(b,c)};g.toString=function(){return".value"};var wc=new uc;function xc(a,b){this.od=a;this.cc=b}xc.prototype.get=function(a){var b=w(this.od,a);if(!b)throw Error("No index defined for "+a);return b===mc?null:b};function yc(a,b,c){var d=Ja(a.od,function(d,f){var h=w(a.cc,f);D(h,"Missing index implementation for "+f);if(d===mc){if(h.xc(b.R)){for(var k=[],m=c.Wb(qb),l=M(m);l;)l.name!=b.name&&k.push(l),l=M(m);k.push(b);return zc(k,nc(h))}return mc}h=c.get(b.name);k=d;h&&(k=k.remove(new C(b.name,h)));return k.Oa(b,b.R)});return new xc(d,a.cc)}
function Ac(a,b,c){var d=Ja(a.od,function(a){if(a===mc)return a;var d=c.get(b.name);return d?a.remove(new C(b.name,d)):a});return new xc(d,a.cc)}var Bc=new xc({".priority":mc},{".priority":H});function Kb(a,b){this.B=a;D(n(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||L;Cc(this.aa);this.Db=null}var Dc=["object","boolean","number","string"];g=Kb.prototype;g.J=function(){return!0};g.C=function(){return this.aa};g.fa=function(a){return new Kb(this.B,a)};g.Q=function(a){return".priority"===a?this.aa:L};g.P=function(a){return a.e()?this:".priority"===K(a)?this.aa:L};g.Da=function(){return!1};g.Ve=function(){return null};
g.T=function(a,b){return".priority"===a?this.fa(b):b.e()&&".priority"!==a?this:L.T(a,b).fa(this.aa)};g.F=function(a,b){var c=K(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;D(".priority"!==c||1===Ec(a),".priority must be the last token in a path");return this.T(c,L.F(N(a),b))};g.e=function(){return!1};g.Eb=function(){return 0};g.O=function(){return!1};g.H=function(a){return a&&!this.C().e()?{".value":this.Ca(),".priority":this.C().H()}:this.Ca()};
g.hash=function(){if(null===this.Db){var a="";this.aa.e()||(a+="priority:"+Fc(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+dc(this.B):a+this.B;this.Db=Ob(a)}return this.Db};g.Ca=function(){return this.B};g.sc=function(a){if(a===L)return 1;if(a instanceof O)return-1;D(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=xa(Dc,b),e=xa(Dc,c);D(0<=d,"Unknown leaf type: "+b);D(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
g.nb=function(){return this};g.yc=function(){return!0};g.Z=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.Z(a.aa):!1};g.toString=function(){return x(this.H(!0))};function Gc(){this.set={}}g=Gc.prototype;g.add=function(a,b){this.set[a]=null!==b?b:!0};g.contains=function(a){return eb(this.set,a)};g.get=function(a){return this.contains(a)?this.set[a]:void 0};g.remove=function(a){delete this.set[a]};g.clear=function(){this.set={}};g.e=function(){return Sa(this.set)};g.count=function(){return La(this.set)};function Hc(a,b){v(a.set,function(a,d){b(d,a)})}g.keys=function(){var a=[];v(this.set,function(b,c){a.push(c)});return a};function Ic(a){D(ea(a)&&0<a.length,"Requires a non-empty array");this.Bf=a;this.Dc={}}Ic.prototype.Ge=function(a,b){var c;c=this.Dc[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ie.apply(c[d].Ma,Array.prototype.slice.call(arguments,1))};Ic.prototype.gc=function(a,b,c){Jc(this,a);this.Dc[a]=this.Dc[a]||[];this.Dc[a].push({Ie:b,Ma:c});(a=this.Ue(a))&&b.apply(c,a)};
Ic.prototype.Ic=function(a,b,c){Jc(this,a);a=this.Dc[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ie===b&&(!c||c===a[d].Ma)){a.splice(d,1);break}};function Jc(a,b){D(Da(a.Bf,function(a){return a===b}),"Unknown event: "+b)};var Kc=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);D(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);D(20===c.length,"nextPushId: Length should be 20.");
return c}}();function Lc(){Ic.call(this,["online"]);this.hc=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!pb()){var a=this;window.addEventListener("online",function(){a.hc||(a.hc=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.hc&&(a.hc=!1,a.Ge("online",!1))},!1)}}la(Lc,Ic);Lc.prototype.Ue=function(a){D("online"===a,"Unknown event type: "+a);return[this.hc]};ca(Lc);function Mc(){Ic.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Mb=!0;if(b){var c=this;document.addEventListener(b,
function(){var b=!document[a];b!==c.Mb&&(c.Mb=b,c.Ge("visible",b))},!1)}}la(Mc,Ic);Mc.prototype.Ue=function(a){D("visible"===a,"Unknown event type: "+a);return[this.Mb]};ca(Mc);function E(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Y=0}else this.o=a,this.Y=b}function P(a,b){var c=K(a);if(null===c)return b;if(c===K(b))return P(N(a),N(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
function Nc(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=sb(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function K(a){return a.Y>=a.o.length?null:a.o[a.Y]}function Ec(a){return a.o.length-a.Y}function N(a){var b=a.Y;b<a.o.length&&b++;return new E(a.o,b)}function Oc(a){return a.Y<a.o.length?a.o[a.o.length-1]:null}g=E.prototype;
g.toString=function(){for(var a="",b=this.Y;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};g.slice=function(a){return this.o.slice(this.Y+(a||0))};g.parent=function(){if(this.Y>=this.o.length)return null;for(var a=[],b=this.Y;b<this.o.length-1;b++)a.push(this.o[b]);return new E(a,0)};
g.n=function(a){for(var b=[],c=this.Y;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof E)for(c=a.Y;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new E(b,0)};g.e=function(){return this.Y>=this.o.length};g.Z=function(a){if(Ec(this)!==Ec(a))return!1;for(var b=this.Y,c=a.Y;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
g.contains=function(a){var b=this.Y,c=a.Y;if(Ec(this)>Ec(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var Q=new E("");function Pc(a,b){this.Qa=a.slice();this.Ha=Math.max(1,this.Qa.length);this.Qe=b;for(var c=0;c<this.Qa.length;c++)this.Ha+=nb(this.Qa[c]);Qc(this)}Pc.prototype.push=function(a){0<this.Qa.length&&(this.Ha+=1);this.Qa.push(a);this.Ha+=nb(a);Qc(this)};Pc.prototype.pop=function(){var a=this.Qa.pop();this.Ha-=nb(a);0<this.Qa.length&&--this.Ha};
function Qc(a){if(768<a.Ha)throw Error(a.Qe+"has a key path longer than 768 bytes ("+a.Ha+").");if(32<a.Qa.length)throw Error(a.Qe+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+Rc(a));}function Rc(a){return 0==a.Qa.length?"":"in property '"+a.Qa.join(".")+"'"};function Sc(){this.children={};this.bd=0;this.value=null}function Tc(a,b,c){this.ud=a?a:"";this.Pc=b?b:null;this.A=c?c:new Sc}function Uc(a,b){for(var c=b instanceof E?b:new E(b),d=a,e;null!==(e=K(c));)d=new Tc(e,d,w(d.A.children,e)||new Sc),c=N(c);return d}g=Tc.prototype;g.Ca=function(){return this.A.value};function Vc(a,b){D("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;Wc(a)}g.clear=function(){this.A.value=null;this.A.children={};this.A.bd=0;Wc(this)};
g.kd=function(){return 0<this.A.bd};g.e=function(){return null===this.Ca()&&!this.kd()};g.O=function(a){var b=this;v(this.A.children,function(c,d){a(new Tc(d,b,c))})};function Xc(a,b,c,d){c&&!d&&b(a);a.O(function(a){Xc(a,b,!0,d)});c&&d&&b(a)}function Yc(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}g.path=function(){return new E(null===this.Pc?this.ud:this.Pc.path()+"/"+this.ud)};g.name=function(){return this.ud};g.parent=function(){return this.Pc};
function Wc(a){if(null!==a.Pc){var b=a.Pc,c=a.ud,d=a.e(),e=eb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.bd--,Wc(b)):d||e||(b.A.children[c]=a.A,b.A.bd++,Wc(b))}};function Zc(a,b){this.La=a;this.ba=b?b:$c}g=Zc.prototype;g.Oa=function(a,b){return new Zc(this.La,this.ba.Oa(a,b,this.La).X(null,null,!1,null,null))};g.remove=function(a){return new Zc(this.La,this.ba.remove(a,this.La).X(null,null,!1,null,null))};g.get=function(a){for(var b,c=this.ba;!c.e();){b=this.La(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
function ad(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.La(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}g.e=function(){return this.ba.e()};g.count=function(){return this.ba.count()};g.Gc=function(){return this.ba.Gc()};g.ec=function(){return this.ba.ec()};g.ha=function(a){return this.ba.ha(a)};
g.Wb=function(a){return new bd(this.ba,null,this.La,!1,a)};g.Xb=function(a,b){return new bd(this.ba,a,this.La,!1,b)};g.Zb=function(a,b){return new bd(this.ba,a,this.La,!0,b)};g.We=function(a){return new bd(this.ba,null,this.La,!0,a)};function bd(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Pa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Pa.push(a);break}else this.Pa.push(a),a=this.le?a.right:a.left}
function M(a){if(0===a.Pa.length)return null;var b=a.Pa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Pa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Pa.push(b),b=b.left;return c}function cd(a){if(0===a.Pa.length)return null;var b;b=a.Pa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function dd(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:$c;this.right=null!=e?e:$c}g=dd.prototype;
g.X=function(a,b,c,d,e){return new dd(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};g.count=function(){return this.left.count()+1+this.right.count()};g.e=function(){return!1};g.ha=function(a){return this.left.ha(a)||a(this.key,this.value)||this.right.ha(a)};function ed(a){return a.left.e()?a:ed(a.left)}g.Gc=function(){return ed(this).key};g.ec=function(){return this.right.e()?this.key:this.right.ec()};
g.Oa=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.X(null,null,null,e.left.Oa(a,b,c),null):0===d?e.X(null,b,null,null,null):e.X(null,null,null,null,e.right.Oa(a,b,c));return gd(e)};function hd(a){if(a.left.e())return $c;a.left.ea()||a.left.left.ea()||(a=id(a));a=a.X(null,null,null,hd(a.left),null);return gd(a)}
g.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.ea()||c.left.left.ea()||(c=id(c)),c=c.X(null,null,null,c.left.remove(a,b),null);else{c.left.ea()&&(c=jd(c));c.right.e()||c.right.ea()||c.right.left.ea()||(c=kd(c),c.left.left.ea()&&(c=jd(c),c=kd(c)));if(0===b(a,c.key)){if(c.right.e())return $c;d=ed(c.right);c=c.X(d.key,d.value,null,null,hd(c.right))}c=c.X(null,null,null,null,c.right.remove(a,b))}return gd(c)};g.ea=function(){return this.color};
function gd(a){a.right.ea()&&!a.left.ea()&&(a=ld(a));a.left.ea()&&a.left.left.ea()&&(a=jd(a));a.left.ea()&&a.right.ea()&&(a=kd(a));return a}function id(a){a=kd(a);a.right.left.ea()&&(a=a.X(null,null,null,null,jd(a.right)),a=ld(a),a=kd(a));return a}function ld(a){return a.right.X(null,null,a.color,a.X(null,null,!0,null,a.right.left),null)}function jd(a){return a.left.X(null,null,a.color,null,a.X(null,null,!0,a.left.right,null))}
function kd(a){return a.X(null,null,!a.color,a.left.X(null,null,!a.left.color,null,null),a.right.X(null,null,!a.right.color,null,null))}function md(){}g=md.prototype;g.X=function(){return this};g.Oa=function(a,b){return new dd(a,b,null)};g.remove=function(){return this};g.count=function(){return 0};g.e=function(){return!0};g.ha=function(){return!1};g.Gc=function(){return null};g.ec=function(){return null};g.ea=function(){return!1};var $c=new md;function O(a,b,c){this.k=a;(this.aa=b)&&Cc(this.aa);a.e()&&D(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.yb=c;this.Db=null}g=O.prototype;g.J=function(){return!1};g.C=function(){return this.aa||L};g.fa=function(a){return this.k.e()?this:new O(this.k,a,this.yb)};g.Q=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?L:a};g.P=function(a){var b=K(a);return null===b?this:this.Q(b).P(N(a))};g.Da=function(a){return null!==this.k.get(a)};
g.T=function(a,b){D(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.fa(b);var c=new C(a,b),d,e;b.e()?(d=this.k.remove(a),c=Ac(this.yb,c,this.k)):(d=this.k.Oa(a,b),c=yc(this.yb,c,this.k));e=d.e()?L:this.aa;return new O(d,e,c)};g.F=function(a,b){var c=K(a);if(null===c)return b;D(".priority"!==K(a)||1===Ec(a),".priority must be the last token in a path");var d=this.Q(c).F(N(a),b);return this.T(c,d)};g.e=function(){return this.k.e()};g.Eb=function(){return this.k.count()};
var nd=/^(0|[1-9]\d*)$/;g=O.prototype;g.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.O(H,function(f,h){b[f]=h.H(a);c++;e&&nd.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],h;for(h in b)f[h]=b[h];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};g.hash=function(){if(null===this.Db){var a="";this.C().e()||(a+="priority:"+Fc(this.C().H())+":");this.O(H,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Db=""===a?"":Ob(a)}return this.Db};
g.Ve=function(a,b,c){return(c=od(this,c))?(a=ad(c,new C(a,b)))?a.name:null:ad(this.k,a)};function pd(a,b){var c;c=(c=od(a,b))?(c=c.Gc())&&c.name:a.k.Gc();return c?new C(c,a.k.get(c)):null}function qd(a,b){var c;c=(c=od(a,b))?(c=c.ec())&&c.name:a.k.ec();return c?new C(c,a.k.get(c)):null}g.O=function(a,b){var c=od(this,a);return c?c.ha(function(a){return b(a.name,a.R)}):this.k.ha(b)};g.Wb=function(a){return this.Xb(a.Hc(),a)};
g.Xb=function(a,b){var c=od(this,b);if(c)return c.Xb(a,function(a){return a});for(var c=this.k.Xb(a.name,qb),d=cd(c);null!=d&&0>b.compare(d,a);)M(c),d=cd(c);return c};g.We=function(a){return this.Zb(a.Fc(),a)};g.Zb=function(a,b){var c=od(this,b);if(c)return c.Zb(a,function(a){return a});for(var c=this.k.Zb(a.name,qb),d=cd(c);null!=d&&0<b.compare(d,a);)M(c),d=cd(c);return c};g.sc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===qc?-1:0};
g.nb=function(a){if(a===tc||Pa(this.yb.cc,a.toString()))return this;var b=this.yb,c=this.k;D(a!==tc,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Wb(qb),f=M(c);f;)e=e||a.xc(f.R),d.push(f),f=M(c);d=e?zc(d,nc(a)):mc;e=a.toString();c=Ta(b.cc);c[e]=a;a=Ta(b.od);a[e]=d;return new O(this.k,this.aa,new xc(a,c))};g.yc=function(a){return a===tc||Pa(this.yb.cc,a.toString())};
g.Z=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().Z(a.C())&&this.k.count()===a.k.count()){var b=this.Wb(H);a=a.Wb(H);for(var c=M(b),d=M(a);c&&d;){if(c.name!==d.name||!c.R.Z(d.R))return!1;c=M(b);d=M(a)}return null===c&&null===d}return!1};function od(a,b){return b===tc?null:a.yb.get(b.toString())}g.toString=function(){return x(this.H(!0))};function G(a,b){if(null===a)return L;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);D(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Kb(a,G(c));if(a instanceof Array){var d=L,e=a;v(e,function(a,b){if(eb(e,b)&&"."!==b.substring(0,1)){var c=G(a);if(c.J()||!c.e())d=
d.T(b,c)}});return d.fa(G(c))}var f=[],h=!1,k=a;fb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=G(k[a]);b.e()||(h=h||!b.C().e(),f.push(new C(a,b)))}});if(0==f.length)return L;var m=zc(f,rb,function(a){return a.name},tb);if(h){var l=zc(f,nc(H));return new O(m,G(c),new xc({".priority":l},{".priority":H}))}return new O(m,G(c),Bc)}var rd=Math.log(2);
function sd(a){this.count=parseInt(Math.log(a+1)/rd,10);this.Oe=this.count-1;this.Cf=a+1&parseInt(Array(this.count+1).join("1"),2)}function td(a){var b=!(a.Cf&1<<a.Oe);a.Oe--;return b}
function zc(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new dd(u,l.R,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new dd(u,l.R,!1,f,z)}a.sort(b);var f=function(b){function d(b,h){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],F=c?c(k):k,z=new dd(F,k.R,h,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var F=td(b),fd=Math.pow(2,b.count-(z+1));F?d(fd,!1):(d(fd,!1),d(fd,!0))}return l}(new sd(a.length));
return null!==f?new Zc(d||b,f):new Zc(d||b)}function Fc(a){return"number"===typeof a?"number:"+dc(a):"string:"+a}function Cc(a){if(a.J()){var b=a.H();D("string"===typeof b||"number"===typeof b||"object"===typeof b&&eb(b,".sv"),"Priority must be a string or number.")}else D(a===qc||a.e(),"priority of unexpected type.");D(a===qc||a.C().e(),"Priority nodes can't have a priority of their own.")}var L=new O(new Zc(tb),null,Bc);function ud(){O.call(this,new Zc(tb),L,Bc)}la(ud,O);g=ud.prototype;
g.sc=function(a){return a===this?0:1};g.Z=function(a){return a===this};g.C=function(){return this};g.Q=function(){return L};g.e=function(){return!1};var qc=new ud,oc=new C("[MIN_NAME]",L),vc=new C("[MAX_NAME]",qc);function vd(a,b){this.value=a;this.children=b||wd}var wd=new Zc(function(a,b){return a===b?0:a<b?-1:1});function xd(a){var b=R;v(a,function(a,d){b=b.set(new E(d),a)});return b}g=vd.prototype;g.e=function(){return null===this.value&&this.children.e()};function yd(a,b,c){if(null!=a.value&&c(a.value))return{path:Q,value:a.value};if(b.e())return null;var d=K(b);a=a.children.get(d);return null!==a?(b=yd(a,N(b),c),null!=b?{path:(new E(d)).n(b.path),value:b.value}:null):null}
function zd(a,b){return yd(a,b,function(){return!0})}g.subtree=function(a){if(a.e())return this;var b=this.children.get(K(a));return null!==b?b.subtree(N(a)):R};g.set=function(a,b){if(a.e())return new vd(b,this.children);var c=K(a),d=(this.children.get(c)||R).set(N(a),b),c=this.children.Oa(c,d);return new vd(this.value,c)};
g.remove=function(a){if(a.e())return this.children.e()?R:new vd(null,this.children);var b=K(a),c=this.children.get(b);return c?(a=c.remove(N(a)),b=a.e()?this.children.remove(b):this.children.Oa(b,a),null===this.value&&b.e()?R:new vd(this.value,b)):this};g.get=function(a){if(a.e())return this.value;var b=this.children.get(K(a));return b?b.get(N(a)):null};
function Ad(a,b,c){if(b.e())return c;var d=K(b);b=Ad(a.children.get(d)||R,N(b),c);d=b.e()?a.children.remove(d):a.children.Oa(d,b);return new vd(a.value,d)}function Bd(a,b){return Cd(a,Q,b)}function Cd(a,b,c){var d={};a.children.ha(function(a,f){d[a]=Cd(f,b.n(a),c)});return c(b,a.value,d)}function Dd(a,b,c){return Ed(a,b,Q,c)}function Ed(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=K(b);return(a=a.children.get(e))?Ed(a,N(b),c.n(e),d):null}
function Fd(a,b,c){Gd(a,b,Q,c)}function Gd(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=K(b);return(a=a.children.get(e))?Gd(a,N(b),c.n(e),d):R}function Hd(a,b){Id(a,Q,b)}function Id(a,b,c){a.children.ha(function(a,e){Id(e,b.n(a),c)});a.value&&c(b,a.value)}function Jd(a,b){a.children.ha(function(a,d){d.value&&b(a,d.value)})}var R=new vd(null);vd.prototype.toString=function(){var a={};Hd(this,function(b,c){a[b.toString()]=c.toString()});return x(a)};var Kd=/[\[\].#$\/\u0000-\u001F\u007F]/,Ld=/[\[\].#$\u0000-\u001F\u007F]/;function Md(a){return p(a)&&0!==a.length&&!Kd.test(a)}function Nd(a){return null===a||p(a)||ga(a)&&!Xb(a)||ia(a)&&eb(a,".sv")}function Od(a,b,c,d){d&&!n(b)||Pd(A(a,1,d),b,c)}
function Pd(a,b,c){c instanceof E&&(c=new Pc(c,a));if(!n(b))throw Error(a+"contains undefined "+Rc(c));if(ha(b))throw Error(a+"contains a function "+Rc(c)+" with contents: "+b.toString());if(Xb(b))throw Error(a+"contains "+b.toString()+" "+Rc(c));if(p(b)&&b.length>10485760/3&&10485760<nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+Rc(c)+" ('"+b.substring(0,50)+"...')");if(ia(b)){var d=!1,e=!1;fb(b,function(b,h){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
!0,!Md(b)))throw Error(a+" contains an invalid key ("+b+") "+Rc(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Pd(a,h,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+Rc(c)+" in addition to actual children.");}}
function Qd(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Md(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(Nc);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
function Rd(a,b,c){var d=A(a,1,!1);if(!ia(b)||ea(b))throw Error(d+" must be an object containing the children to replace.");var e=[];fb(b,function(a,b){var k=new E(a);Pd(d,b,c.n(k));if(".priority"===Oc(k)&&!Nd(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Qd(d,e)}
function Sd(a,b,c){if(Xb(c))throw Error(A(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Nd(c))throw Error(A(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
function Td(a,b,c){if(!c||n(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(A(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Ud(a,b){if(n(b)&&!Md(b))throw Error(A(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
function Vd(a,b){if(!p(b)||0===b.length||Ld.test(b))throw Error(A(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Wd(a,b){if(".info"===K(b))throw Error(a+" failed: Can't modify data under /.info/");}
function Xd(a,b){var c=b.path.toString(),d;!(d=!p(b.jc.host)||0===b.jc.host.length||!Md(b.jc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(p(c)&&0!==c.length&&!Ld.test(c)));if(d)throw Error(A(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function Gb(){this.k=this.B=null}Gb.prototype.find=function(a){if(null!=this.B)return this.B.P(a);if(a.e()||null==this.k)return null;var b=K(a);a=N(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Ib(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Gc);var d=K(b);a.k.contains(d)||a.k.add(d,new Gb);a=a.k.get(d);b=N(b);Ib(a,b,c)}}
function Yd(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.O(H,function(b,c){Ib(a,new E(b),c)});return Yd(a,b)}return null!==a.k?(c=K(b),b=N(b),a.k.contains(c)&&Yd(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Hb(a,b,c){null!==a.B?c(b,a.B):a.O(function(a,e){var f=new E(b.toString()+"/"+a);Hb(e,f,c)})}Gb.prototype.O=function(a){null!==this.k&&Hc(this.k,function(b,c){a(b,c)})};function Zd(a,b){this.type=$d;this.source=a;this.path=b}Zd.prototype.Mc=function(){return this.path.e()?new Zd(this.source,Q):new Zd(this.source,N(this.path))};Zd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function ae(a,b,c){this.type=be;this.source=a;this.path=b;this.children=c}ae.prototype.Mc=function(a){if(this.path.e())return a=this.children.subtree(new E(a)),a.e()?null:a.value?new ce(this.source,Q,a.value):new ae(this.source,Q,a);D(K(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new ae(this.source,N(this.path),this.children)};ae.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function de(a,b,c){this.type=ee;this.source=fe;this.path=a;this.Ob=b;this.Id=c}de.prototype.Mc=function(a){if(this.path.e()){if(null!=this.Ob.value)return D(this.Ob.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Ob.subtree(new E(a));return new de(Q,a,this.Id)}D(K(this.path)===a,"operationForChild called for unrelated child.");return new de(N(this.path),this.Ob,this.Id)};
de.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Ob+")"};function ce(a,b,c){this.type=ge;this.source=a;this.path=b;this.Ga=c}ce.prototype.Mc=function(a){return this.path.e()?new ce(this.source,Q,this.Ga.Q(a)):new ce(this.source,N(this.path),this.Ga)};ce.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ga.toString()+")"};var ge=0,be=1,ee=2,$d=3;function he(a,b,c,d){this.ee=a;this.Se=b;this.Hb=c;this.Ee=d;D(!d||b,"Tagged queries must be from server.")}var fe=new he(!0,!1,null,!1),ie=new he(!1,!0,null,!1);he.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Hb+")":"server"};function je(a,b,c){this.A=a;this.da=b;this.Sb=c}function ke(a){return a.da}function le(a){return a.Sb}function me(a,b){return b.e()?a.da&&!a.Sb:ne(a,K(b))}function ne(a,b){return a.da&&!a.Sb||a.A.Da(b)}je.prototype.j=function(){return this.A};function oe(a,b){this.N=a;this.Ld=b}function pe(a,b,c,d){return new oe(new je(b,c,d),a.Ld)}function qe(a){return a.N.da?a.N.j():null}oe.prototype.w=function(){return this.Ld};function re(a){return a.Ld.da?a.Ld.j():null};function se(){}se.prototype.Te=function(){return null};se.prototype.fe=function(){return null};var te=new se;function ue(a,b,c){this.xf=a;this.Ka=b;this.yd=c}ue.prototype.Te=function(a){var b=this.Ka.N;if(ne(b,a))return b.j().Q(a);b=null!=this.yd?new je(this.yd,!0,!1):this.Ka.w();return this.xf.qc(a,b)};ue.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:re(this.Ka);a=this.xf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function ve(a,b){this.Sd=a;this.Df=b}function we(a){this.U=a}
we.prototype.eb=function(a,b,c,d){var e=new xe,f;if(b.type===ge)b.source.ee?c=ye(this,a,b.path,b.Ga,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w())&&!b.path.e(),c=ze(this,a,b.path,b.Ga,c,d,f,e));else if(b.type===be)b.source.ee?c=Ae(this,a,b.path,b.children,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w()),c=Be(this,a,b.path,b.children,c,d,f,e));else if(b.type===ee)if(b.Id)if(b=b.path,null!=c.lc(b))c=a;else{f=new ue(c,a,d);d=a.N.j();if(b.e()||".priority"===K(b))ke(a.w())?
b=c.Aa(re(a)):(b=a.w().j(),D(b instanceof O,"serverChildren would be complete if leaf node"),b=c.rc(b)),b=this.U.ya(d,b,e);else{var h=K(b),k=c.qc(h,a.w());null==k&&ne(a.w(),h)&&(k=d.Q(h));b=null!=k?this.U.F(d,h,k,N(b),f,e):a.N.j().Da(h)?this.U.F(d,h,L,N(b),f,e):d;b.e()&&ke(a.w())&&(d=c.Aa(re(a)),d.J()&&(b=this.U.ya(b,d,e)))}d=ke(a.w())||null!=c.lc(Q);c=pe(a,b,d,this.U.Na())}else c=Ce(this,a,b.path,b.Ob,c,d,e);else if(b.type===$d)d=b.path,b=a.w(),f=b.j(),h=b.da||d.e(),c=De(this,new oe(a.N,new je(f,
h,b.Sb)),d,c,te,e);else throw Mb("Unknown operation type: "+b.type);e=Na(e.fb);d=c;b=d.N;b.da&&(f=b.j().J()||b.j().e(),h=qe(a),(0<e.length||!a.N.da||f&&!b.j().Z(h)||!b.j().C().Z(h.C()))&&e.push(Ee(qe(d))));return new ve(c,e)};
function De(a,b,c,d,e,f){var h=b.N;if(null!=d.lc(c))return b;var k;if(c.e())D(ke(b.w()),"If change path is empty, we must have complete server data"),le(b.w())?(e=re(b),d=d.rc(e instanceof O?e:L)):d=d.Aa(re(b)),f=a.U.ya(b.N.j(),d,f);else{var m=K(c);if(".priority"==m)D(1==Ec(c),"Can't have a priority with additional path components"),f=h.j(),k=b.w().j(),d=d.ad(c,f,k),f=null!=d?a.U.fa(f,d):h.j();else{var l=N(c);ne(h,m)?(k=b.w().j(),d=d.ad(c,h.j(),k),d=null!=d?h.j().Q(m).F(l,d):h.j().Q(m)):d=d.qc(m,
b.w());f=null!=d?a.U.F(h.j(),m,d,l,e,f):h.j()}}return pe(b,f,h.da||c.e(),a.U.Na())}function ze(a,b,c,d,e,f,h,k){var m=b.w();h=h?a.U:a.U.Ub();if(c.e())d=h.ya(m.j(),d,null);else if(h.Na()&&!m.Sb)d=m.j().F(c,d),d=h.ya(m.j(),d,null);else{var l=K(c);if(!me(m,c)&&1<Ec(c))return b;var u=N(c);d=m.j().Q(l).F(u,d);d=".priority"==l?h.fa(m.j(),d):h.F(m.j(),l,d,u,te,null)}m=m.da||c.e();b=new oe(b.N,new je(d,m,h.Na()));return De(a,b,c,e,new ue(e,b,f),k)}
function ye(a,b,c,d,e,f,h){var k=b.N;e=new ue(e,b,f);if(c.e())h=a.U.ya(b.N.j(),d,h),a=pe(b,h,!0,a.U.Na());else if(f=K(c),".priority"===f)h=a.U.fa(b.N.j(),d),a=pe(b,h,k.da,k.Sb);else{c=N(c);var m=k.j().Q(f);if(!c.e()){var l=e.Te(f);d=null!=l?".priority"===Oc(c)&&l.P(c.parent()).e()?l:l.F(c,d):L}m.Z(d)?a=b:(h=a.U.F(k.j(),f,d,c,e,h),a=pe(b,h,k.da,a.U.Na()))}return a}
function Ae(a,b,c,d,e,f,h){var k=b;Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))&&(k=ye(a,k,u,l,e,f,h))});Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))||(k=ye(a,k,u,l,e,f,h))});return k}function Fe(a,b){Hd(b,function(b,d){a=a.F(b,d)});return a}
function Be(a,b,c,d,e,f,h,k){if(b.w().j().e()&&!ke(b.w()))return b;var m=b;c=c.e()?d:Ad(R,c,d);var l=b.w().j();c.children.ha(function(c,d){if(l.Da(c)){var F=b.w().j().Q(c),F=Fe(F,d);m=ze(a,m,new E(c),F,e,f,h,k)}});c.children.ha(function(c,d){var F=!ne(b.w(),c)&&null==d.value;l.Da(c)||F||(F=b.w().j().Q(c),F=Fe(F,d),m=ze(a,m,new E(c),F,e,f,h,k))});return m}
function Ce(a,b,c,d,e,f,h){if(null!=e.lc(c))return b;var k=le(b.w()),m=b.w();if(null!=d.value){if(c.e()&&m.da||me(m,c))return ze(a,b,c,m.j().P(c),e,f,k,h);if(c.e()){var l=R;m.j().O(tc,function(a,b){l=l.set(new E(a),b)});return Be(a,b,c,l,e,f,k,h)}return b}l=R;Hd(d,function(a){var b=c.n(a);me(m,b)&&(l=l.set(a,m.j().P(b)))});return Be(a,b,c,l,e,f,k,h)};function Ge(a){this.V=a;this.g=a.m.g}function He(a,b,c,d){var e=[],f=[];ya(b,function(b){b.type===Ie&&a.g.nd(b.qe,b.Ja)&&f.push(new S(Je,b.Ja,b.Xa))});Ke(a,e,Le,b,d,c);Ke(a,e,Me,b,d,c);Ke(a,e,Je,f,d,c);Ke(a,e,Ie,b,d,c);Ke(a,e,Ne,b,d,c);return e}function Ke(a,b,c,d,e,f){d=za(d,function(a){return a.type===c});Ha(d,q(a.Ff,a));ya(d,function(c){var d=Oe(a,c,f);ya(e,function(e){e.nf(c.type)&&b.push(e.createEvent(d,a.V))})})}
function Oe(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ve(b.Xa,b.Ja,a.g));return b}Ge.prototype.Ff=function(a,b){if(null==a.Xa||null==b.Xa)throw Mb("Should only compare child_ events.");return this.g.compare(new C(a.Xa,a.Ja),new C(b.Xa,b.Ja))};function Pe(a,b){this.V=a;var c=a.m,d=new Qe(c.g),c=T(c)?new Qe(c.g):c.xa?new Re(c):new Se(c);this.hf=new we(c);var e=b.w(),f=b.N,h=d.ya(L,e.j(),null),k=c.ya(L,f.j(),null);this.Ka=new oe(new je(k,f.da,c.Na()),new je(h,e.da,d.Na()));this.Za=[];this.Jf=new Ge(a)}function Te(a){return a.V}g=Pe.prototype;g.w=function(){return this.Ka.w().j()};g.hb=function(a){var b=re(this.Ka);return b&&(T(this.V.m)||!a.e()&&!b.Q(K(a)).e())?b.P(a):null};g.e=function(){return 0===this.Za.length};g.Nb=function(a){this.Za.push(a)};
g.kb=function(a,b){var c=[];if(b){D(null==a,"A cancel should cancel all event registrations.");var d=this.V.path;ya(this.Za,function(a){(a=a.Me(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.Za.length;++f){var h=this.Za[f];if(!h.matches(a))e.push(h);else if(a.Xe()){e=e.concat(this.Za.slice(f+1));break}}this.Za=e}else this.Za=[];return c};
g.eb=function(a,b,c){a.type===be&&null!==a.source.Hb&&(D(re(this.Ka),"We should always have a full cache before handling merges"),D(qe(this.Ka),"Missing event cache, even though we have a server cache"));var d=this.Ka;a=this.hf.eb(d,a,b,c);b=this.hf;c=a.Sd;D(c.N.j().yc(b.U.g),"Event snap not indexed");D(c.w().j().yc(b.U.g),"Server snap not indexed");D(ke(a.Sd.w())||!ke(d.w()),"Once a server snap is complete, it should never go back");this.Ka=a.Sd;return Ue(this,a.Df,a.Sd.N.j(),null)};
function Ve(a,b){var c=a.Ka.N,d=[];c.j().J()||c.j().O(H,function(a,b){d.push(new S(Me,b,a))});c.da&&d.push(Ee(c.j()));return Ue(a,d,c.j(),b)}function Ue(a,b,c,d){return He(a.Jf,b,c,d?[d]:a.Za)};function We(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.hd=a}We.prototype.Yb=function(){var a=this.Md.wb();return"value"===this.hd?a.path:a.getParent().path};We.prototype.ge=function(){return this.hd};We.prototype.Tb=function(){return this.ae.Tb(this)};We.prototype.toString=function(){return this.Yb().toString()+":"+this.hd+":"+x(this.Md.be())};function Xe(a,b,c){this.ae=a;this.error=b;this.path=c}Xe.prototype.Yb=function(){return this.path};Xe.prototype.ge=function(){return"cancel"};
Xe.prototype.Tb=function(){return this.ae.Tb(this)};Xe.prototype.toString=function(){return this.path.toString()+":cancel"};function Ye(){this.vb=[]}function Ze(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Yb();null===c||f.Z(c.Yb())||(a.vb.push(c),c=null);null===c&&(c=new $e(f));c.add(e)}c&&a.vb.push(c)}function af(a,b,c){Ze(a,c);bf(a,function(a){return a.Z(b)})}function cf(a,b,c){Ze(a,c);bf(a,function(a){return a.contains(b)||b.contains(a)})}
function bf(a,b){for(var c=!0,d=0;d<a.vb.length;d++){var e=a.vb[d];if(e)if(e=e.Yb(),b(e)){for(var e=a.vb[d],f=0;f<e.jd.length;f++){var h=e.jd[f];if(null!==h){e.jd[f]=null;var k=h.Tb();Qb&&I("event: "+h.toString());fc(k)}}a.vb[d]=null}else c=!1}c&&(a.vb=[])}function $e(a){this.qa=a;this.jd=[]}$e.prototype.add=function(a){this.jd.push(a)};$e.prototype.Yb=function(){return this.qa};function Qe(a){this.g=a}g=Qe.prototype;g.F=function(a,b,c,d,e,f){D(a.yc(this.g),"A node must be indexed if only a child is updated");e=a.Q(b);if(e.P(d).Z(c.P(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Da(b)?df(f,new S(Le,e,b)):D(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?df(f,new S(Me,c,b)):df(f,new S(Ie,c,b,e)));return a.J()&&c.e()?a:a.T(b,c).nb(this.g)};
g.ya=function(a,b,c){null!=c&&(a.J()||a.O(H,function(a,e){b.Da(a)||df(c,new S(Le,e,a))}),b.J()||b.O(H,function(b,e){if(a.Da(b)){var f=a.Q(b);f.Z(e)||df(c,new S(Ie,e,b,f))}else df(c,new S(Me,e,b))}));return b.nb(this.g)};g.fa=function(a,b){return a.e()?L:a.fa(b)};g.Na=function(){return!1};g.Ub=function(){return this};function Se(a){this.he=new Qe(a.g);this.g=a.g;var b;a.ka?(b=ef(a),b=a.g.Ec(ff(a),b)):b=a.g.Hc();this.Uc=b;a.na?(b=gf(a),a=a.g.Ec(hf(a),b)):a=a.g.Fc();this.vc=a}g=Se.prototype;g.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.vc)};g.F=function(a,b,c,d,e,f){this.matches(new C(b,c))||(c=L);return this.he.F(a,b,c,d,e,f)};
g.ya=function(a,b,c){b.J()&&(b=L);var d=b.nb(this.g),d=d.fa(L),e=this;b.O(H,function(a,b){e.matches(new C(a,b))||(d=d.T(a,L))});return this.he.ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.he};function Re(a){this.sa=new Se(a);this.g=a.g;D(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Ib=!jf(a)}g=Re.prototype;g.F=function(a,b,c,d,e,f){this.sa.matches(new C(b,c))||(c=L);return a.Q(b).Z(c)?a:a.Eb()<this.oa?this.sa.Ub().F(a,b,c,d,e,f):kf(this,a,b,c,e,f)};
g.ya=function(a,b,c){var d;if(b.J()||b.e())d=L.nb(this.g);else if(2*this.oa<b.Eb()&&b.yc(this.g)){d=L.nb(this.g);b=this.Ib?b.Zb(this.sa.vc,this.g):b.Xb(this.sa.Uc,this.g);for(var e=0;0<b.Pa.length&&e<this.oa;){var f=M(b),h;if(h=this.Ib?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.vc))d=d.T(f.name,f.R),e++;else break}}else{d=b.nb(this.g);d=d.fa(L);var k,m,l;if(this.Ib){b=d.We(this.g);k=this.sa.vc;m=this.sa.Uc;var u=nc(this.g);l=function(a,b){return u(b,a)}}else b=d.Wb(this.g),k=this.sa.Uc,
m=this.sa.vc,l=nc(this.g);for(var e=0,z=!1;0<b.Pa.length;)f=M(b),!z&&0>=l(k,f)&&(z=!0),(h=z&&e<this.oa&&0>=l(f,m))?e++:d=d.T(f.name,L)}return this.sa.Ub().ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.sa.Ub()};
function kf(a,b,c,d,e,f){var h;if(a.Ib){var k=nc(a.g);h=function(a,b){return k(b,a)}}else h=nc(a.g);D(b.Eb()==a.oa,"");var m=new C(c,d),l=a.Ib?pd(b,a.g):qd(b,a.g),u=a.sa.matches(m);if(b.Da(c)){for(var z=b.Q(c),l=e.fe(a.g,l,a.Ib);null!=l&&(l.name==c||b.Da(l.name));)l=e.fe(a.g,l,a.Ib);e=null==l?1:h(l,m);if(u&&!d.e()&&0<=e)return null!=f&&df(f,new S(Ie,d,c,z)),b.T(c,d);null!=f&&df(f,new S(Le,z,c));b=b.T(c,L);return null!=l&&a.sa.matches(l)?(null!=f&&df(f,new S(Me,l.R,l.name)),b.T(l.name,l.R)):b}return d.e()?
b:u&&0<=h(l,m)?(null!=f&&(df(f,new S(Le,l.R,l.name)),df(f,new S(Me,d,c))),b.T(c,d).T(l.name,L)):b};function S(a,b,c,d){this.type=a;this.Ja=b;this.Xa=c;this.qe=d;this.Dd=void 0}function Ee(a){return new S(Ne,a)}var Me="child_added",Le="child_removed",Ie="child_changed",Je="child_moved",Ne="value";function xe(){this.fb={}}
function df(a,b){var c=b.type,d=b.Xa;D(c==Me||c==Ie||c==Le,"Only child changes supported for tracking");D(".priority"!==d,"Only non-priority child changes can be tracked.");var e=w(a.fb,d);if(e){var f=e.type;if(c==Me&&f==Le)a.fb[d]=new S(Ie,b.Ja,d,e.Ja);else if(c==Le&&f==Me)delete a.fb[d];else if(c==Le&&f==Ie)a.fb[d]=new S(Le,e.qe,d);else if(c==Ie&&f==Me)a.fb[d]=new S(Me,b.Ja,d);else if(c==Ie&&f==Ie)a.fb[d]=new S(Ie,b.Ja,d,e.qe);else throw Mb("Illegal combination of changes: "+b+" occurred after "+
e);}else a.fb[d]=b};function lf(){this.Rb=this.na=this.Kb=this.ka=this.xa=!1;this.oa=0;this.mb="";this.dc=null;this.zb="";this.ac=null;this.xb="";this.g=H}var mf=new lf;function jf(a){return""===a.mb?a.ka:"l"===a.mb}function ff(a){D(a.ka,"Only valid if start has been set");return a.dc}function ef(a){D(a.ka,"Only valid if start has been set");return a.Kb?a.zb:"[MIN_NAME]"}function hf(a){D(a.na,"Only valid if end has been set");return a.ac}
function gf(a){D(a.na,"Only valid if end has been set");return a.Rb?a.xb:"[MAX_NAME]"}function nf(a){var b=new lf;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.dc=a.dc;b.Kb=a.Kb;b.zb=a.zb;b.na=a.na;b.ac=a.ac;b.Rb=a.Rb;b.xb=a.xb;b.g=a.g;b.mb=a.mb;return b}g=lf.prototype;g.ne=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="l";return b};g.oe=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="r";return b};g.Nd=function(a,b){var c=nf(this);c.ka=!0;n(a)||(a=null);c.dc=a;null!=b?(c.Kb=!0,c.zb=b):(c.Kb=!1,c.zb="");return c};
g.gd=function(a,b){var c=nf(this);c.na=!0;n(a)||(a=null);c.ac=a;n(b)?(c.Rb=!0,c.xb=b):(c.vg=!1,c.xb="");return c};function of(a,b){var c=nf(a);c.g=b;return c}function pf(a){var b={};a.ka&&(b.sp=a.dc,a.Kb&&(b.sn=a.zb));a.na&&(b.ep=a.ac,a.Rb&&(b.en=a.xb));if(a.xa){b.l=a.oa;var c=a.mb;""===c&&(c=jf(a)?"l":"r");b.vf=c}a.g!==H&&(b.i=a.g.toString());return b}function T(a){return!(a.ka||a.na||a.xa)}function qf(a){return T(a)&&a.g==H}
function rf(a){var b={};if(qf(a))return b;var c;a.g===H?c="$priority":a.g===wc?c="$value":a.g===tc?c="$key":(D(a.g instanceof pc,"Unrecognized index type!"),c=a.g.toString());b.orderBy=x(c);a.ka&&(b.startAt=x(a.dc),a.Kb&&(b.startAt+=","+x(a.zb)));a.na&&(b.endAt=x(a.ac),a.Rb&&(b.endAt+=","+x(a.xb)));a.xa&&(jf(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}g.toString=function(){return x(pf(this))};function sf(a){this.W=a}var tf=new sf(new vd(null));function uf(a,b,c){if(b.e())return new sf(new vd(c));var d=zd(a.W,b);if(null!=d){var e=d.path,d=d.value;b=P(e,b);d=d.F(b,c);return new sf(a.W.set(e,d))}a=Ad(a.W,b,new vd(c));return new sf(a)}function vf(a,b,c){var d=a;fb(c,function(a,c){d=uf(d,b.n(a),c)});return d}sf.prototype.Ed=function(a){if(a.e())return tf;a=Ad(this.W,a,R);return new sf(a)};function wf(a,b){var c=zd(a.W,b);return null!=c?a.W.get(c.path).P(P(c.path,b)):null}
function xf(a){var b=[],c=a.W.value;null!=c?c.J()||c.O(H,function(a,c){b.push(new C(a,c))}):a.W.children.ha(function(a,c){null!=c.value&&b.push(new C(a,c.value))});return b}function yf(a,b){if(b.e())return a;var c=wf(a,b);return null!=c?new sf(new vd(c)):new sf(a.W.subtree(b))}sf.prototype.e=function(){return this.W.e()};sf.prototype.apply=function(a){return zf(Q,this.W,a)};
function zf(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ha(function(b,f){".priority"===b?(D(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=zf(a.n(b),f,c)});c.P(a).e()||null===d||(c=c.F(a.n(".priority"),d));return c};function Af(){this.Jd=L}Af.prototype.j=function(a){return this.Jd.P(a)};Af.prototype.toString=function(){return this.Jd.toString()};function Bf(a){this.oc=a}Bf.prototype.getToken=function(a){return this.oc.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(I("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function Cf(a,b){a.oc.INTERNAL.addAuthTokenListener(b)};function Df(){this.S=tf;this.la=[];this.Bc=-1}function Ef(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}g=Df.prototype;
g.Ed=function(a){var b=Ea(this.la,function(b){return b.Zc===a});D(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var h=this.la[f];h.visible&&(f>=b&&Ff(h,c.path)?d=!1:c.path.contains(h.path)&&(e=!0));f--}if(d){if(e)this.S=Gf(this.la,Hf,Q),this.Bc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ga)this.S=this.S.Ed(c.path);else{var k=this;v(c.children,function(a,b){k.S=k.S.Ed(c.path.n(b))})}return!0}return!1};
g.Aa=function(a,b,c,d){if(c||d){var e=yf(this.S,a);return!d&&e.e()?b:d||null!=b||null!=wf(e,Q)?(e=Gf(this.la,function(b){return(b.visible||d)&&(!c||!(0<=xa(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||L,e.apply(b)):null}e=wf(this.S,a);if(null!=e)return e;e=yf(this.S,a);return e.e()?b:null!=b||null!=wf(e,Q)?(b=b||L,e.apply(b)):null};
g.rc=function(a,b){var c=L,d=wf(this.S,a);if(d)d.J()||d.O(H,function(a,b){c=c.T(a,b)});else if(b){var e=yf(this.S,a);b.O(H,function(a,b){var d=yf(e,new E(a)).apply(b);c=c.T(a,d)});ya(xf(e),function(a){c=c.T(a.name,a.R)})}else e=yf(this.S,a),ya(xf(e),function(a){c=c.T(a.name,a.R)});return c};g.ad=function(a,b,c,d){D(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.n(b);if(null!=wf(this.S,a))return null;a=yf(this.S,a);return a.e()?d.P(b):a.apply(d.P(b))};
g.qc=function(a,b,c){a=a.n(b);var d=wf(this.S,a);return null!=d?d:ne(c,b)?yf(this.S,a).apply(c.j().Q(b)):null};g.lc=function(a){return wf(this.S,a)};g.Xd=function(a,b,c,d,e,f){var h;a=yf(this.S,a);h=wf(a,Q);if(null==h)if(null!=b)h=a.apply(b);else return[];h=h.nb(f);if(h.e()||h.J())return[];b=[];a=nc(f);e=e?h.Zb(c,f):h.Xb(c,f);for(f=M(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=M(e);return b};
function Ff(a,b){return a.Ga?a.path.contains(b):!!Qa(a.children,function(c,d){return a.path.n(d).contains(b)})}function Hf(a){return a.visible}
function Gf(a,b,c){for(var d=tf,e=0;e<a.length;++e){var f=a[e];if(b(f)){var h=f.path;if(f.Ga)c.contains(h)?(h=P(c,h),d=uf(d,h,f.Ga)):h.contains(c)&&(h=P(h,c),d=uf(d,Q,f.Ga.P(h)));else if(f.children)if(c.contains(h))h=P(c,h),d=vf(d,h,f.children);else{if(h.contains(c))if(h=P(h,c),h.e())d=vf(d,Q,f.children);else if(f=w(f.children,K(h)))f=f.P(N(h)),d=uf(d,Q,f)}else throw Mb("WriteRecord should have .snap or .children");}}return d}function If(a,b){this.Lb=a;this.W=b}g=If.prototype;
g.Aa=function(a,b,c){return this.W.Aa(this.Lb,a,b,c)};g.rc=function(a){return this.W.rc(this.Lb,a)};g.ad=function(a,b,c){return this.W.ad(this.Lb,a,b,c)};g.lc=function(a){return this.W.lc(this.Lb.n(a))};g.Xd=function(a,b,c,d,e){return this.W.Xd(this.Lb,a,b,c,d,e)};g.qc=function(a,b){return this.W.qc(this.Lb,a,b)};g.n=function(a){return new If(this.Lb.n(a),this.W)};function Jf(a,b){this.rf={};this.Vc=new Kf(a);this.va=b;var c=1E4+2E4*Math.random();hc(q(this.lf,this),Math.floor(c))}Jf.prototype.lf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&eb(this.rf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);hc(q(this.lf,this),Math.floor(6E5*Math.random()))};function Lf(){this.tc={}}function Mf(a,b,c){n(c)||(c=1);eb(a.tc,b)||(a.tc[b]=0);a.tc[b]+=c}Lf.prototype.get=function(){return Ta(this.tc)};function Kf(a){this.Ef=a;this.rd=null}Kf.prototype.get=function(){var a=this.Ef.get(),b=Ta(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var Nf={},Of={};function Pf(a){a=a.toString();Nf[a]||(Nf[a]=new Lf);return Nf[a]}function Qf(a,b){var c=a.toString();Of[c]||(Of[c]=b());return Of[c]};function Rf(a,b,c){this.f=Tb("p:rest:");this.L=a;this.Gb=b;this.$c=c;this.$={}}function Sf(a,b){if(n(b))return"tag$"+b;D(qf(a.m),"should have a tag if it's not a default query.");return a.path.toString()}g=Rf.prototype;
g.$e=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ja());var f=Sf(a,c),h={};this.$[f]=h;a=rf(a.m);var k=this;Tf(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Gb(e,u,!1,c);w(k.$,f)===h&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};g.uf=function(a,b){var c=Sf(a,b);delete this.$[c]};g.kf=function(){};g.re=function(){};g.cf=function(){};g.xd=function(){};g.put=function(){};g.af=function(){};g.ye=function(){};
function Tf(a,b,c,d){c=c||{};c.format="export";a.$c.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.L.Sc?"https://":"http://")+a.L.host+b+"?"+gb(c);a.f("Sending REST request for "+f);var h=new XMLHttpRequest;h.onreadystatechange=function(){if(d&&4===h.readyState){a.f("REST Response for "+f+" received. status:",h.status,"response:",h.responseText);var b=null;if(200<=h.status&&300>h.status){try{b=lb(h.responseText)}catch(c){J("Failed to parse JSON response for "+f+": "+h.responseText)}d(null,
b)}else 401!==h.status&&404!==h.status&&J("Got unsuccessful REST response for "+f+" Status: "+h.status),d(h.status);d=null}};h.open("GET",f,!0);h.send()})};function Uf(a){this.te=a;this.Bd=[];this.Qb=0;this.Yd=-1;this.Fb=null}function Vf(a,b,c){a.Yd=b;a.Fb=c;a.Yd<a.Qb&&(a.Fb(),a.Fb=null)}function Wf(a,b,c){for(a.Bd[b]=c;a.Bd[a.Qb];){var d=a.Bd[a.Qb];delete a.Bd[a.Qb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;fc(function(){f.te(d[e])})}if(a.Qb===a.Yd){a.Fb&&(clearTimeout(a.Fb),a.Fb(),a.Fb=null);break}a.Qb++}};var Cb="websocket",Db="long_polling";var Xf=null;"undefined"!==typeof MozWebSocket?Xf=MozWebSocket:"undefined"!==typeof WebSocket&&(Xf=WebSocket);function Yf(a,b,c,d){this.Zd=a;this.f=Tb(this.Zd);this.frames=this.zc=null;this.pb=this.qb=this.Fe=0;this.Va=Pf(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ke=Bb(b,Cb,a)}var Zf;
Yf.prototype.open=function(a,b){this.ib=b;this.Xf=a;this.f("Websocket connecting to "+this.Ke);this.wc=!1;xb.set("previous_websocket_failure",!0);try{this.Ia=new Xf(this.Ke)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.bb();return}var e=this;this.Ia.onopen=function(){e.f("Websocket connected.");e.wc=!0};this.Ia.onclose=function(){e.f("Websocket connection was disconnected.");e.Ia=null;e.bb()};this.Ia.onmessage=function(a){if(null!==e.Ia)if(a=a.data,e.pb+=
a.length,Mf(e.Va,"bytes_received",a.length),$f(e),null!==e.frames)ag(e,a);else{a:{D(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&ag(e,a)}};this.Ia.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.bb()}};Yf.prototype.start=function(){};
Yf.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==Xf&&!Zf};Yf.responsesRequiredToBeHealthy=2;Yf.healthyTimeout=3E4;g=Yf.prototype;g.sd=function(){xb.remove("previous_websocket_failure")};function ag(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=lb(c);a.Xf(c)}}
g.send=function(a){$f(this);a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=bc(a,16384);1<a.length&&bg(this,String(a.length));for(var b=0;b<a.length;b++)bg(this,a[b])};g.Tc=function(){this.Ab=!0;this.zc&&(clearInterval(this.zc),this.zc=null);this.Ia&&(this.Ia.close(),this.Ia=null)};g.bb=function(){this.Ab||(this.f("WebSocket is closing itself"),this.Tc(),this.ib&&(this.ib(this.wc),this.ib=null))};g.close=function(){this.Ab||(this.f("WebSocket is being closed"),this.Tc())};
function $f(a){clearInterval(a.zc);a.zc=setInterval(function(){a.Ia&&bg(a,"0");$f(a)},Math.floor(45E3))}function bg(a,b){try{a.Ia.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(q(a.bb,a),0)}};function cg(a,b,c,d){this.Zd=a;this.f=Tb(a);this.jc=b;this.pb=this.qb=0;this.Va=Pf(b);this.tf=c;this.wc=!1;this.Cb=d;this.Yc=function(a){return Bb(b,Db,a)}}var dg,eg;
cg.prototype.open=function(a,b){this.Ne=0;this.ia=b;this.bf=new Uf(a);this.Ab=!1;var c=this;this.sb=setTimeout(function(){c.f("Timed out trying to connect.");c.bb();c.sb=null},Math.floor(3E4));Yb(function(){if(!c.Ab){c.Ta=new fg(function(a,b,d,k,m){gg(c,arguments);if(c.Ta)if(c.sb&&(clearTimeout(c.sb),c.sb=null),c.wc=!0,"start"==a)c.id=b,c.ff=d;else if("close"===a)b?(c.Ta.Kd=!1,Vf(c.bf,b,function(){c.bb()})):c.bb();else throw Error("Unrecognized command received: "+a);},function(a,b){gg(c,arguments);
Wf(c.bf,a,b)},function(){c.bb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Ta.Qd&&(a.cb=c.Ta.Qd);a.v="5";c.tf&&(a.s=c.tf);c.Cb&&(a.ls=c.Cb);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);hg(c.Ta,a,function(){})}})};
cg.prototype.start=function(){var a=this.Ta,b=this.ff;a.Vf=this.id;a.Wf=b;for(a.Ud=!0;ig(a););a=this.id;b=this.ff;this.fc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.fc.src=this.Yc(c);this.fc.style.display="none";document.body.appendChild(this.fc)};
cg.isAvailable=function(){return dg||!eg&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.rg)&&!0};g=cg.prototype;g.sd=function(){};g.Tc=function(){this.Ab=!0;this.Ta&&(this.Ta.close(),this.Ta=null);this.fc&&(document.body.removeChild(this.fc),this.fc=null);this.sb&&(clearTimeout(this.sb),this.sb=null)};
g.bb=function(){this.Ab||(this.f("Longpoll is closing itself"),this.Tc(),this.ia&&(this.ia(this.wc),this.ia=null))};g.close=function(){this.Ab||(this.f("Longpoll is being closed."),this.Tc())};g.send=function(a){a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=mb(a);a=ab(a,!0);a=bc(a,1840);for(var b=0;b<a.length;b++){var c=this.Ta;c.Qc.push({jg:this.Ne,pg:a.length,Pe:a[b]});c.Ud&&ig(c);this.Ne++}};function gg(a,b){var c=x(b).length;a.pb+=c;Mf(a.Va,"bytes_received",c)}
function fg(a,b,c,d){this.Yc=d;this.ib=c;this.ve=new Gc;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Lb();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||I("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
a.contentDocument?a.gb=a.contentDocument:a.contentWindow?a.gb=a.contentWindow.document:a.document&&(a.gb=a.document);this.Ea=a;a="";this.Ea.src&&"javascript:"===this.Ea.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ea.gb.open(),this.Ea.gb.write(a),this.Ea.gb.close()}catch(f){I("frame writing exception"),f.stack&&I(f.stack),I(f)}}
fg.prototype.close=function(){this.Ud=!1;if(this.Ea){this.Ea.gb.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ea&&(document.body.removeChild(a.Ea),a.Ea=null)},Math.floor(0))}var b=this.ib;b&&(this.ib=null,b())};
function ig(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.Vf;b.pw=a.Wf;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Pe.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.jg+"&ts"+d+"="+e.pg+"&d"+d+"="+e.Pe;d++}else break;jg(a,b+c,a.$d);return!0}return!1}function jg(a,b,c){function d(){a.ve.remove(c);ig(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));hg(a,b,function(){clearTimeout(e);d()})}
function hg(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ea.gb.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){I("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ea.gb.body.appendChild(d)}}catch(e){}},Math.floor(1))};function kg(a){lg(this,a)}var mg=[cg,Yf];function lg(a,b){var c=Yf&&Yf.isAvailable(),d=c&&!(xb.Ze||!0===xb.get("previous_websocket_failure"));b.qg&&(c||J("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[Yf];else{var e=a.Wc=[];cc(mg,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function ng(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function og(a,b,c,d,e,f,h){this.id=a;this.f=Tb("c:"+this.id+":");this.te=c;this.Lc=d;this.ia=e;this.se=f;this.L=b;this.Ad=[];this.Le=0;this.sf=new kg(b);this.Ua=0;this.Cb=h;this.f("Connection created");pg(this)}
function pg(a){var b=ng(a.sf);a.I=new b("c:"+a.id+":"+a.Le++,a.L,void 0,a.Cb);a.xe=b.responsesRequiredToBeHealthy||0;var c=qg(a,a.I),d=rg(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Bb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=hc(function(){a.md=null;a.Bb||(a.I&&102400<a.I.pb?(a.f("Connection exceeded healthy timeout but has received "+a.I.pb+" bytes.  Marking connection healthy."),a.Bb=!0,a.I.sd()):a.I&&10240<a.I.qb?a.f("Connection exceeded healthy timeout but has sent "+
a.I.qb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function rg(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.Ua?1===a.Ua&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.L.$a.substr(0,2)&&(xb.remove("host:"+a.L.host),a.L.$a=a.L.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
function qg(a,b){return function(c){if(2!=a.Ua)if(b===a.Rc){var d=$b("t",c);c=$b("d",c);if("c"==d){if(d=$b("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.qf=c.s;Ab(a.L,f);0==a.Ua&&(a.I.start(),sg(a,a.I,d),"5"!==e&&J("Protocol version mismatch detected"),c=a.sf,(c=1<c.Wc.length?c.Wc[1]:null)&&tg(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];ug(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
a.se&&(a.se(c),a.se=null),a.ia=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),Ab(a.L,c),1===a.Ua?a.close():(vg(a),pg(a))):"e"===d?Ub("Server Error: "+c):"o"===d?(a.f("got pong on primary."),wg(a),xg(a)):Ub("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=$b("t",c),c=$b("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?yg(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
a.pf--,yg(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}og.prototype.ua=function(a){zg(this,{t:"d",d:a})};function ug(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
function yg(a){0>=a.pf?(a.f("Secondary connection is healthy."),a.Bb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,ug(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}og.prototype.wd=function(a){wg(this);this.te(a)};function wg(a){a.Bb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Bb=!0,a.I.sd()))}
function tg(a,b){a.D=new b("c:"+a.id+":"+a.Le++,a.L,a.qf);a.pf=b.responsesRequiredToBeHealthy||0;a.D.open(qg(a,a.D),rg(a,a.D));hc(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function sg(a,b,c){a.f("Realtime connection established.");a.I=b;a.Ua=1;a.Lc&&(a.Lc(c,a.qf),a.Lc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Bb=!0):hc(function(){xg(a)},Math.floor(5E3))}
function xg(a){a.Bb||1!==a.Ua||(a.f("sending ping on primary."),zg(a,{t:"c",d:{t:"p",d:{}}}))}function zg(a,b){if(1!==a.Ua)throw"Connection is not connected";a.Xc.send(b)}og.prototype.close=function(){2!==this.Ua&&(this.f("Closing realtime connection."),this.Ua=2,vg(this),this.ia&&(this.ia(),this.ia=null))};function vg(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function Ag(a,b,c,d,e,f){this.id=Bg++;this.f=Tb("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Oc=0;this.Kc=[];this.ma=!1;this.Sa=1E3;this.td=3E5;this.Gb=b;this.Jc=c;this.ue=d;this.L=a;this.ob=this.Fa=this.Cb=this.ze=null;this.$c=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Vd=f;this.ub=null;this.Mb=!1;this.Gd={};this.ig=0;this.Re=!0;this.Ac=this.me=null;Cg(this,0);Mc.Vb().gc("visible",this.Zf,this);-1===a.host.indexOf("fblocal")&&
Lc.Vb().gc("online",this.Yf,this)}var Bg=0,Dg=0;g=Ag.prototype;g.ua=function(a,b,c){var d=++this.ig;a={r:d,a:a,b:b};this.f(x(a));D(this.ma,"sendRequest call when we're not connected not allowed.");this.Fa.ua(a);c&&(this.Gd[d]=c)};
g.$e=function(a,b,c,d){var e=a.ja(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};D(qf(a.m)||!T(a.m),"listen() called for non-default but complete query");D(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,eg:a,tag:c};this.$[f][e]=a;this.ma&&Eg(this,a)};
function Eg(a,b){var c=b.eg,d=c.path.toString(),e=c.ja();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=pf(c.m),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&eb(k,"w")){var l=w(k,"w");ea(l)&&0<=xa(l,"no_index")&&J("Using an unspecified index. Consider adding "+('".indexOn": "'+c.m.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&Fg(a,d,e),b.G&&b.G(m,
k))})}g.kf=function(a){this.ob=a;this.f("Auth token refreshed");this.ob?Gg(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||kc(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function Gg(a){if(a.ma&&a.ob){var b=a.ob,c=jc(b)?"auth":"gauth",d={cred:b};null===a.Vd?d.noauth=!0:"object"===typeof a.Vd&&(d.authvar=a.Vd);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.ob===b&&("ok"===d?a.ke=0:Hg(a,d,c))})}}
g.uf=function(a,b){var c=a.path.toString(),d=a.ja();this.f("Unlisten called for "+c+" "+d);D(qf(a.m)||!T(a.m),"unlisten() called for non-default but complete query");if(Fg(this,c,d)&&this.ma){var e=pf(a.m);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};g.re=function(a,b,c){this.ma?Ig(this,"o",a,b,c):this.Kc.push({we:a,action:"o",data:b,G:c})};g.cf=function(a,b,c){this.ma?Ig(this,"om",a,b,c):this.Kc.push({we:a,action:"om",data:b,G:c})};
g.xd=function(a,b){this.ma?Ig(this,"oc",a,null,b):this.Kc.push({we:a,action:"oc",data:null,G:b})};function Ig(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}g.put=function(a,b,c,d){Jg(this,"p",a,b,c,d)};g.af=function(a,b,c,d){Jg(this,"m",a,b,c,d)};function Jg(a,b,c,d,e,f){d={p:c,d:d};n(f)&&(d.h=f);a.pa.push({action:b,mf:d,G:e});a.Oc++;b=a.pa.length-1;a.ma?Kg(a,b):a.f("Buffering put: "+c)}
function Kg(a,b){var c=a.pa[b].action,d=a.pa[b].mf,e=a.pa[b].G;a.pa[b].fg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Oc--;0===a.Oc&&(a.pa=[]);e&&e(d.s,d.d)})}g.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
g.wd=function(a){if("r"in a){this.f("from server: "+x(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Gb(a.p,a.d,!1,a.t):"m"===b?this.Gb(a.p,a.d,!0,a.t):"c"===b?Lg(this,a.p,a.q):"ac"===b?Hg(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):Ub("Unrecognized action received from server: "+
x(b)+"\nAre you using the latest client?"))}};g.Lc=function(a,b){this.f("connection ready");this.ma=!0;this.Ac=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Cb=b;if(this.Re){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;pb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}Mg(this);this.Re=!1;this.Jc(!0)};
function Cg(a,b){D(!a.Fa,"Scheduling a connect when we're already connected/ing?");a.ub&&clearTimeout(a.ub);a.ub=setTimeout(function(){a.ub=null;Ng(a)},Math.floor(b))}g.Zf=function(a){a&&!this.Mb&&this.Sa===this.td&&(this.f("Window became visible.  Reducing delay."),this.Sa=1E3,this.Fa||Cg(this,0));this.Mb=a};g.Yf=function(a){a?(this.f("Browser went online."),this.Sa=1E3,this.Fa||Cg(this,0)):(this.f("Browser went offline.  Killing connection."),this.Fa&&this.Fa.close())};
g.df=function(){this.f("data client disconnected");this.ma=!1;this.Fa=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.mf&&b.fg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Oc--)}0===this.Oc&&(this.pa=[]);this.Gd={};Og(this)&&(this.Mb?this.Ac&&(3E4<(new Date).getTime()-this.Ac&&(this.Sa=1E3),this.Ac=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Sa=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Sa-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
a+"ms"),Cg(this,a),this.Sa=Math.min(this.td,1.3*this.Sa));this.Jc(!1)};
function Ng(a){if(Og(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Ac=null;var b=q(a.wd,a),c=q(a.Lc,a),d=q(a.df,a),e=a.id+":"+Dg++,f=a.Cb,h=!1,k=null,m=function(){k?k.close():(h=!0,d())};a.Fa={close:m,ua:function(a){D(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.$c.getToken(l).then(function(l){h?I("getToken() completed but was canceled"):(I("getToken() completed. Creating connection."),a.ob=l&&l.accessToken,k=new og(e,a.L,b,c,d,function(b){J(b+
" ("+a.L.toString()+")");a.ab("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);h||m()})}}g.ab=function(a){I("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Fa?this.Fa.close():(this.ub&&(clearTimeout(this.ub),this.ub=null),this.ma&&this.df())};g.kc=function(a){I("Resuming connection for reason: "+a);delete this.qd[a];Sa(this.qd)&&(this.Sa=1E3,this.Fa||Cg(this,0))};
function Lg(a,b,c){c=c?Aa(c,function(a){return ac(a)}).join("$"):"default";(a=Fg(a,b,c))&&a.G&&a.G("permission_denied")}function Fg(a,b,c){b=(new E(b)).toString();var d;n(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===La(a.$[b])&&delete a.$[b]):d=void 0;return d}
function Hg(a,b,c){I("Auth token revoked: "+b+"/"+c);a.ob=null;a.de=!0;a.Fa.close();if("invalid_token"===b||"permission_denied"===b)a.ke++,3<=a.ke&&(a.Sa=3E4,a=a.$c,b='Provided authentication credentials for the app named "'+a.oc.name+'" are invalid. This usually indicates your app was not initialized correctly. ',b="credential"in a.oc.options?b+'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':"serviceAccount"in
a.oc.options?b+'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':b+'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.',J(b))}
function Mg(a){Gg(a);v(a.$,function(b){v(b,function(b){Eg(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&Kg(a,b);for(;a.Kc.length;)b=a.Kc.shift(),Ig(a,b.action,b.we,b.data,b.G)}function Og(a){var b;b=Lc.Vb().hc;return Sa(a.qd)&&b};function Pg(a){a instanceof Qg||Vb("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,Q);this.INTERNAL=new Rg(this)}var Sg={TIMESTAMP:{".sv":"timestamp"}};g=Pg.prototype;g.app=null;g.jf=function(a){Tg(this,"ref");y("database.ref",0,1,arguments.length);return n(a)?this.ba.n(a):this.ba};
g.gg=function(a){Tg(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=Wb(a);Xd("database.refFromURL",b);var c=b.jc;c.host!==this.ta.L.host&&Vb("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.L.host+")");return this.jf(b.path.toString())};function Tg(a,b){null===a.ta&&Vb("Cannot call "+b+" on a deleted database.")}g.Pf=function(){y("database.goOffline",0,0,arguments.length);Tg(this,"goOffline");this.ta.ab()};
g.Qf=function(){y("database.goOnline",0,0,arguments.length);Tg(this,"goOnline");this.ta.kc()};Object.defineProperty(Pg.prototype,"app",{get:function(){return this.ta.app}});function Rg(a){this.Ya=a}Rg.prototype.delete=function(){Tg(this.Ya,"delete");var a=Ug.Vb(),b=this.Ya.ta;w(a.lb,b.app.name)!==b&&Vb("Database "+b.app.name+" has already been deleted.");b.ab();delete a.lb[b.app.name];this.Ya.ta=null;this.Ya.ba=null;this.Ya=this.Ya.INTERNAL=null;return firebase.Promise.resolve()};
Pg.prototype.ref=Pg.prototype.jf;Pg.prototype.refFromURL=Pg.prototype.gg;Pg.prototype.goOnline=Pg.prototype.Qf;Pg.prototype.goOffline=Pg.prototype.Pf;Rg.prototype["delete"]=Rg.prototype.delete;function V(a,b,c){this.A=a;this.V=b;this.g=c}V.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};V.prototype.val=V.prototype.H;V.prototype.be=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};V.prototype.exportVal=V.prototype.be;V.prototype.toJSON=function(){y("Firebase.DataSnapshot.toJSON",0,1,arguments.length);return this.be()};V.prototype.toJSON=V.prototype.toJSON;
V.prototype.Lf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};V.prototype.exists=V.prototype.Lf;V.prototype.n=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);ga(a)&&(a=String(a));Vd("Firebase.DataSnapshot.child",a);var b=new E(a),c=this.V.n(b);return new V(this.A.P(b),c,H)};V.prototype.child=V.prototype.n;
V.prototype.Da=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Vd("Firebase.DataSnapshot.hasChild",a);var b=new E(a);return!this.A.P(b).e()};V.prototype.hasChild=V.prototype.Da;V.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};V.prototype.getPriority=V.prototype.C;
V.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);B("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.O(this.g,function(c,d){return a(new V(d,b.V.n(c),H))})};V.prototype.forEach=V.prototype.forEach;V.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};V.prototype.hasChildren=V.prototype.kd;
V.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.V.getKey()};gc(V.prototype,"key",V.prototype.getKey);V.prototype.Eb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Eb()};V.prototype.numChildren=V.prototype.Eb;V.prototype.wb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.V};gc(V.prototype,"ref",V.prototype.wb);function Vg(a,b,c){this.Pb=a;this.rb=b;this.tb=c||null}g=Vg.prototype;g.nf=function(a){return"value"===a};g.createEvent=function(a,b){var c=b.m.g;return new We("value",this,new V(a.Ja,b.wb(),c))};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.Pb;return function(){d.call(b,a.Md)}};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.matches=function(a){return a instanceof Vg?a.Pb&&this.Pb?a.Pb===this.Pb&&a.tb===this.tb:!0:!1};g.Xe=function(){return null!==this.Pb};function Wg(a,b,c){this.ga=a;this.rb=b;this.tb=c}g=Wg.prototype;g.nf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ga};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.createEvent=function(a,b){D(null!=a.Xa,"Child events should have a childName.");var c=b.wb().n(a.Xa);return new We(a.type,this,new V(a.Ja,c,b.m.g),a.Dd)};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.ga[a.hd];return function(){d.call(b,a.Md,a.Dd)}};
g.matches=function(a){if(a instanceof Wg){if(!this.ga||!a.ga)return!0;if(this.tb===a.tb){var b=La(a.ga);if(b===La(this.ga)){if(1===b){var b=Ma(a.ga),c=Ma(this.ga);return c===b&&(!a.ga[b]||!this.ga[c]||a.ga[b]===this.ga[c])}return Ka(this.ga,function(b,c){return a.ga[c]===b})}}}return!1};g.Xe=function(){return null!==this.ga};function Xg(){this.za={}}g=Xg.prototype;g.e=function(){return Sa(this.za)};g.eb=function(a,b,c){var d=a.source.Hb;if(null!==d)return d=w(this.za,d),D(null!=d,"SyncTree gave us an op for an invalid query."),d.eb(a,b,c);var e=[];v(this.za,function(d){e=e.concat(d.eb(a,b,c))});return e};g.Nb=function(a,b,c,d,e){var f=a.ja(),h=w(this.za,f);if(!h){var h=c.Aa(e?d:null),k=!1;h?k=!0:(h=d instanceof O?c.rc(d):L,k=!1);h=new Pe(a,new oe(new je(h,k,!1),new je(d,e,!1)));this.za[f]=h}h.Nb(b);return Ve(h,b)};
g.kb=function(a,b,c){var d=a.ja(),e=[],f=[],h=null!=Yg(this);if("default"===d){var k=this;v(this.za,function(a,d){f=f.concat(a.kb(b,c));a.e()&&(delete k.za[d],T(a.V.m)||e.push(a.V))})}else{var m=w(this.za,d);m&&(f=f.concat(m.kb(b,c)),m.e()&&(delete this.za[d],T(m.V.m)||e.push(m.V)))}h&&null==Yg(this)&&e.push(new U(a.u,a.path));return{hg:e,Kf:f}};function Zg(a){return za(Na(a.za),function(a){return!T(a.V.m)})}g.hb=function(a){var b=null;v(this.za,function(c){b=b||c.hb(a)});return b};
function $g(a,b){if(T(b.m))return Yg(a);var c=b.ja();return w(a.za,c)}function Yg(a){return Ra(a.za,function(a){return T(a.V.m)})||null};function ah(a){this.wa=R;this.jb=new Df;this.De={};this.ic={};this.Cc=a}function bh(a,b,c,d,e){var f=a.jb,h=e;D(d>f.Bc,"Stacking an older write on top of newer ones");n(h)||(h=!0);f.la.push({path:b,Ga:c,Zc:d,visible:h});h&&(f.S=uf(f.S,b,c));f.Bc=d;return e?ch(a,new ce(fe,b,c)):[]}function dh(a,b,c,d){var e=a.jb;D(d>e.Bc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.S=vf(e.S,b,c);e.Bc=d;c=xd(c);return ch(a,new ae(fe,b,c))}
function eh(a,b,c){c=c||!1;var d=Ef(a.jb,b);if(a.jb.Ed(b)){var e=R;null!=d.Ga?e=e.set(Q,!0):fb(d.children,function(a,b){e=e.set(new E(a),b)});return ch(a,new de(d.path,e,c))}return[]}function fh(a,b,c){c=xd(c);return ch(a,new ae(ie,b,c))}function gh(a,b,c,d){d=hh(a,d);if(null!=d){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=new ce(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
function kh(a,b,c,d){if(d=hh(a,d)){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=xd(c);c=new ae(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
ah.prototype.Nb=function(a,b){var c=a.path,d=null,e=!1;Fd(this.wa,c,function(a,b){var f=P(a,c);d=d||b.hb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.hb(Q)):(f=new Xg,this.wa=this.wa.set(c,f));var h;null!=d?h=!0:(h=!1,d=L,Jd(this.wa.subtree(c),function(a,b){var c=b.hb(Q);c&&(d=d.T(a,c))}));var k=null!=$g(f,a);if(!k&&!T(a.m)){var m=lh(a);D(!(m in this.ic),"View does not exist, but we have a tag");var l=mh++;this.ic[m]=l;this.De["_"+l]=m}h=f.Nb(a,b,new If(c,this.jb),d,h);k||
e||(f=$g(f,a),h=h.concat(nh(this,a,f)));return h};
ah.prototype.kb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ja()||null!=$g(e,a))){f=e.kb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.hg;f=f.Kf;b=-1!==Ea(e,function(a){return T(a.m)});var h=Dd(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!h&&(d=this.wa.subtree(d),!d.e()))for(var d=oh(d),k=0;k<d.length;++k){var m=d[k],l=m.V,m=ph(this,m);this.Cc.Ae(qh(l),rh(this,l),m.ld,m.G)}if(!h&&0<e.length&&!c)if(b)this.Cc.Od(qh(a),null);else{var u=this;ya(e,function(a){a.ja();
var b=u.ic[lh(a)];u.Cc.Od(qh(a),b)})}sh(this,e)}return f};ah.prototype.Aa=function(a,b){var c=this.jb,d=Dd(this.wa,a,function(b,c){var d=P(b,a);if(d=c.hb(d))return d});return c.Aa(a,d,b,!0)};function oh(a){return Bd(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));v(d,function(a){e=e.concat(a)});return e})}function sh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!T(d.m)){var d=lh(d),e=a.ic[d];delete a.ic[d];delete a.De["_"+e]}}}
function qh(a){return T(a.m)&&!qf(a.m)?a.wb():a}function nh(a,b,c){var d=b.path,e=rh(a,b);c=ph(a,c);b=a.Cc.Ae(qh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)D(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Bd(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[Te(Yg(b))];var d=[];b&&(d=d.concat(Aa(Zg(b),function(a){return a.V})));v(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Cc.Od(qh(c),rh(a,c));return b}
function ph(a,b){var c=b.V,d=rh(a,c);return{ld:function(){return(b.w()||L).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=hh(a,d)){var h=ih(b);b=h.path;h=h.Hb;f=P(b,f);f=new Zd(new he(!1,!0,h,!0),f);b=jh(a,b,f)}else b=[]}else b=ch(a,new Zd(ie,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.kb(c,null,f)}}}function lh(a){return a.path.toString()+"$"+a.ja()}function ih(a){var b=a.indexOf("$");D(-1!==b&&b<a.length-1,"Bad queryKey.");return{Hb:a.substr(b+1),path:new E(a.substr(0,b))}}function hh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function rh(a,b){var c=lh(b);return w(a.ic,c)}var mh=1;
function jh(a,b,c){var d=a.wa.get(b);D(d,"Missing sync point for query tag that we're tracking");return d.eb(c,new If(b,a.jb),null)}function ch(a,b){return th(a,b,a.wa,null,new If(Q,a.jb))}function th(a,b,c,d,e){if(b.path.e())return uh(a,b,c,d,e);var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[],k=K(b.path),m=b.Mc(k);if((c=c.children.get(k))&&m)var l=d?d.Q(k):null,k=e.n(k),h=h.concat(th(a,m,c,l,k));f&&(h=h.concat(f.eb(b,e,d)));return h}
function uh(a,b,c,d,e){var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[];c.children.ha(function(c,f){var l=d?d.Q(c):null,u=e.n(c),z=b.Mc(c);z&&(h=h.concat(uh(a,z,f,l,u)))});f&&(h=h.concat(f.eb(b,e,d)));return h};function Qg(a,b,c){this.app=c;var d=new Bf(c);this.L=a;this.Va=Pf(a);this.Vc=null;this.ca=new Ye;this.vd=1;this.Ra=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Rf(this.L,q(this.Gb,this),d),setTimeout(q(this.Jc,this,!0),0);else{b=c.options.databaseAuthVariableOverride;if("undefined"!==da(b)&&null!==b){if("object"!==da(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
try{x(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ra=new Ag(this.L,q(this.Gb,this),q(this.Jc,this),q(this.ue,this),d,b)}var f=this;Cf(d,function(a){f.va.kf(a)});this.og=Qf(a,q(function(){return new Jf(this.Va,this.va)},this));this.mc=new Tc;this.ie=new Af;this.pd=new ah({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=ch(f.pd,new ce(ie,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:ba});vh(this,"connected",!1);this.ia=new Gb;this.Ya=new Pg(this);this.fd=
0;this.je=null;this.K=new ah({Ae:function(a,b,c,d){f.va.$e(a,c,b,function(b,c){var e=d(b,c);cf(f.ca,a.path,e)});return[]},Od:function(a,b){f.va.uf(a,b)}})}g=Qg.prototype;g.toString=function(){return(this.L.Sc?"https://":"http://")+this.L.host};g.name=function(){return this.L.pe};function wh(a){a=a.ie.j(new E(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function xh(a){a=a={timestamp:wh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
g.Gb=function(a,b,c,d){this.fd++;var e=new E(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=Ja(b,function(a){return G(a)}),a=kh(this.K,e,b,d)):(b=G(b),a=gh(this.K,e,b,d)):c?(d=Ja(b,function(a){return G(a)}),a=fh(this.K,e,d)):(d=G(b),a=ch(this.K,new ce(ie,e,d)));d=e;0<a.length&&(d=yh(this,e));cf(this.ca,d,a)};g.Jc=function(a){vh(this,"connected",a);!1===a&&zh(this)};g.ue=function(a){var b=this;cc(a,function(a,d){vh(b,d,a)})};
function vh(a,b,c){b=new E("/.info/"+b);c=G(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=ch(a.pd,new ce(ie,b,c));cf(a.ca,b,c)}g.Jb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,ug:c});var e=xh(this);b=G(b,c);var e=Jb(b,e),f=this.vd++,e=bh(this.K,a,e,f,!0);Ze(this.ca,e);var h=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||J("set at "+a+" failed: "+b);e=eh(h.K,f,!e);cf(h.ca,a,e);Ah(d,b,c)});e=Bh(this,a);yh(this,e);cf(this.ca,e,[])};
g.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=xh(this),f={};v(b,function(a,b){d=!1;var c=G(a);f[b]=Jb(c,e)});if(d)I("update() called with empty data.  Don't do anything."),Ah(c,"ok");else{var h=this.vd++,k=dh(this.K,a,f,h);Ze(this.ca,k);var m=this;this.va.af(a.toString(),b,function(b,d){var e="ok"===b;e||J("update at "+a+" failed: "+b);var e=eh(m.K,h,!e),f=a;0<e.length&&(f=yh(m,a));cf(m.ca,f,e);Ah(c,b,d)});v(b,function(b,c){var d=Bh(m,a.n(c));yh(m,d)});cf(this.ca,
a,[])}};function zh(a){a.f("onDisconnectEvents");var b=xh(a),c=[];Hb(Fb(a.ia,b),Q,function(b,e){c=c.concat(ch(a.K,new ce(ie,b,e)));var f=Bh(a,b);yh(a,f)});a.ia=new Gb;cf(a.ca,Q,c)}g.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&Yd(c.ia,a);Ah(b,d,e)})};function Ch(a,b,c,d){var e=G(c);a.va.re(b.toString(),e.H(!0),function(c,h){"ok"===c&&Ib(a.ia,b,e);Ah(d,c,h)})}
function Dh(a,b,c,d,e){var f=G(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Ib(a.ia,b,f);Ah(e,c,d)})}function Eh(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(I("onDisconnect().update() called with empty data.  Don't do anything."),Ah(d,"ok")):a.va.cf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=G(c[m]);Ib(a.ia,b.n(m),l)}Ah(d,e,f)})}function Fh(a,b,c){c=".info"===K(b.path)?a.pd.Nb(b,c):a.K.Nb(b,c);af(a.ca,b.path,c)}g.ab=function(){this.Ra&&this.Ra.ab("repo_interrupt")};
g.kc=function(){this.Ra&&this.Ra.kc("repo_interrupt")};g.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new Kf(this.Va)),a=this.Vc.get()):a=this.Va.get();var b=Ba(Oa(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};g.Ce=function(a){Mf(this.Va,a);this.og.rf[a]=!0};g.f=function(a){var b="";this.Ra&&(b=this.Ra.id+":");I(b,arguments)};
function Ah(a,b,c){a&&fc(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function Gh(a,b,c,d,e){function f(){}a.f("transaction on "+b);var h=new U(a,b);h.gc("value",f);c={path:b,update:c,G:d,status:null,ef:Lb(),He:e,of:0,Rd:function(){h.Ic("value",f)},Td:null,Ba:null,cd:null,dd:null,ed:null};d=a.K.Aa(b,void 0)||L;c.cd=d;d=c.update(d.H());if(n(d)){Pd("transaction failed: Data returned ",d,c.path);c.status=1;e=Uc(a.mc,b);var k=e.Ca()||[];k.push(c);Vc(e,k);"object"===typeof d&&null!==d&&eb(d,".priority")?(k=w(d,".priority"),D(Nd(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
k=(a.K.Aa(b)||L).C().H();e=xh(a);d=G(d,k);e=Jb(d,e);c.dd=d;c.ed=e;c.Ba=a.vd++;c=bh(a.K,b,e,c.Ba,c.He);cf(a.ca,b,c);Hh(a)}else c.Rd(),c.dd=null,c.ed=null,c.G&&(a=new V(c.cd,new U(a,c.path),H),c.G(null,!1,a))}function Hh(a,b){var c=b||a.mc;b||Ih(a,c);if(null!==c.Ca()){var d=Jh(a,c);D(0<d.length,"Sending zero length transaction queue");Ca(d,function(a){return 1===a.status})&&Kh(a,c.path(),d)}else c.kd()&&c.O(function(b){Hh(a,b)})}
function Kh(a,b,c){for(var d=Aa(c,function(a){return a.Ba}),e=a.K.Aa(b,d)||L,d=e,e=e.hash(),f=0;f<c.length;f++){var h=c[f];D(1===h.status,"tryToSendTransactionQueue_: items in queue should all be run.");h.status=2;h.of++;var k=P(b,h.path),d=d.F(k,h.dd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(eh(a.K,c[f].Ba));if(c[f].G){var h=c[f].ed,k=new U(a,c[f].path);d.push(q(c[f].G,
null,null,!0,new V(h,k,H)))}c[f].Rd()}Ih(a,Uc(a.mc,b));Hh(a);cf(a.ca,b,e);for(f=0;f<d.length;f++)fc(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(J("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;yh(a,b)}},e)}function yh(a,b){var c=Lh(a,b),d=c.path(),c=Jh(a,c);Mh(a,c,d);return d}
function Mh(a,b,c){if(0!==b.length){for(var d=[],e=[],f=za(b,function(a){return 1===a.status}),f=Aa(f,function(a){return a.Ba}),h=0;h<b.length;h++){var k=b[h],m=P(c,k.path),l=!1,u;D(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(eh(a.K,k.Ba,!0));else if(1===k.status)if(25<=k.of)l=!0,u="maxretry",e=e.concat(eh(a.K,k.Ba,!0));else{var z=a.K.Aa(k.path,f)||L;k.cd=z;var F=b[h].update(z.H());n(F)?(Pd("transaction failed: Data returned ",F,
k.path),m=G(F),"object"===typeof F&&null!=F&&eb(F,".priority")||(m=m.fa(z.C())),z=k.Ba,F=xh(a),F=Jb(m,F),k.dd=m,k.ed=F,k.Ba=a.vd++,Fa(f,z),e=e.concat(bh(a.K,k.path,F,k.Ba,k.He)),e=e.concat(eh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(eh(a.K,k.Ba,!0)))}cf(a.ca,c,e);e=[];l&&(b[h].status=3,setTimeout(b[h].Rd,Math.floor(0)),b[h].G&&("nodata"===u?(k=new U(a,b[h].path),d.push(q(b[h].G,null,null,!1,new V(b[h].cd,k,H)))):d.push(q(b[h].G,null,Error(u),!1,null))))}Ih(a,a.mc);for(h=0;h<d.length;h++)fc(d[h]);Hh(a)}}
function Lh(a,b){for(var c,d=a.mc;null!==(c=K(b))&&null===d.Ca();)d=Uc(d,c),b=N(b);return d}function Jh(a,b){var c=[];Nh(a,b,c);c.sort(function(a,b){return a.ef-b.ef});return c}function Nh(a,b,c){var d=b.Ca();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.O(function(b){Nh(a,b,c)})}function Ih(a,b){var c=b.Ca();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;Vc(b,0<c.length?c:null)}b.O(function(b){Ih(a,b)})}
function Bh(a,b){var c=Lh(a,b).path(),d=Uc(a.mc,b);Yc(d,function(b){Oh(a,b)});Oh(a,d);Xc(d,function(b){Oh(a,b)});return c}
function Oh(a,b){var c=b.Ca();if(null!==c){for(var d=[],e=[],f=-1,h=0;h<c.length;h++)4!==c[h].status&&(2===c[h].status?(D(f===h-1,"All SENT items should be at beginning of queue."),f=h,c[h].status=4,c[h].Td="set"):(D(1===c[h].status,"Unexpected transaction status in abort"),c[h].Rd(),e=e.concat(eh(a.K,c[h].Ba,!0)),c[h].G&&d.push(q(c[h].G,null,Error("set"),!1,null))));-1===f?Vc(b,null):c.length=f+1;cf(a.ca,b.path(),e);for(h=0;h<d.length;h++)fc(d[h])}};function Ug(){this.lb={};this.wf=!1}Ug.prototype.ab=function(){for(var a in this.lb)this.lb[a].ab()};Ug.prototype.kc=function(){for(var a in this.lb)this.lb[a].kc()};Ug.prototype.ce=function(a){this.wf=a};ca(Ug);Ug.prototype.interrupt=Ug.prototype.ab;Ug.prototype.resume=Ug.prototype.kc;var W={};W.nc=Ag;W.DataConnection=W.nc;Ag.prototype.ng=function(a,b){this.ua("q",{p:a},b)};W.nc.prototype.simpleListen=W.nc.prototype.ng;Ag.prototype.Hf=function(a,b){this.ua("echo",{d:a},b)};W.nc.prototype.echo=W.nc.prototype.Hf;Ag.prototype.interrupt=Ag.prototype.ab;W.zf=og;W.RealTimeConnection=W.zf;og.prototype.sendRequest=og.prototype.ua;og.prototype.close=og.prototype.close;
W.Rf=function(a){var b=Ag.prototype.put;Ag.prototype.put=function(c,d,e,f){n(f)&&(f=a());b.call(this,c,d,e,f)};return function(){Ag.prototype.put=b}};W.hijackHash=W.Rf;W.yf=zb;W.ConnectionTarget=W.yf;W.ja=function(a){return a.ja()};W.queryIdentifier=W.ja;W.Uf=function(a){return a.u.Ra.$};W.listens=W.Uf;W.ce=function(a){Ug.Vb().ce(a)};W.forceRestClient=W.ce;W.Context=Ug;function Ph(a,b){this.committed=a;this.snapshot=b};function X(a,b,c,d){this.u=a;this.path=b;this.m=c;this.Nc=d}
function Qh(a){var b=null,c=null;a.ka&&(b=ff(a));a.na&&(c=hf(a));if(a.g===tc){if(a.ka){if("[MIN_NAME]"!=ef(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=gf(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===H){if(null!=b&&!Nd(b)||null!=c&&!Nd(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(D(a.g instanceof pc||a.g===wc,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
}function Rh(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.mb))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function Sh(a,b){if(!0===a.Nc)throw Error(b+": You can't combine multiple orderBy calls.");}g=X.prototype;g.wb=function(){y("Query.ref",0,0,arguments.length);return new U(this.u,this.path)};
g.gc=function(a,b,c,d){y("Query.on",2,4,arguments.length);Td("Query.on",a,!1);B("Query.on",2,b,!1);var e=Th("Query.on",c,d);if("value"===a)Fh(this.u,this,new Vg(b,e.cancel||null,e.Ma||null));else{var f={};f[a]=b;Fh(this.u,this,new Wg(f,e.cancel,e.Ma))}return b};
g.Ic=function(a,b,c){y("Query.off",0,3,arguments.length);Td("Query.off",a,!0);B("Query.off",2,b,!0);ob("Query.off",3,c);var d=null,e=null;"value"===a?d=new Vg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new Wg(e,null,c||null));e=this.u;d=".info"===K(this.path)?e.pd.kb(this,d):e.K.kb(this,d);af(e.ca,this.path,d)};
g.$f=function(a,b){function c(k){f&&(f=!1,e.Ic(a,c),b&&b.call(d.Ma,k),h.resolve(k))}y("Query.once",1,4,arguments.length);Td("Query.once",a,!1);B("Query.once",2,b,!0);var d=Th("Query.once",arguments[2],arguments[3]),e=this,f=!0,h=new ib;kb(h.ra);this.gc(a,c,function(b){e.Ic(a,c);d.cancel&&d.cancel.call(d.Ma,b);h.reject(b)});return h.ra};
g.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.ne(a),this.Nc)};
g.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.oe(a),this.Nc)};
g.ag=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Vd("Query.orderByChild",a);Sh(this,"Query.orderByChild");var b=new E(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
b=new pc(b);b=of(this.m,b);Qh(b);return new X(this.u,this.path,b,!0)};g.bg=function(){y("Query.orderByKey",0,0,arguments.length);Sh(this,"Query.orderByKey");var a=of(this.m,tc);Qh(a);return new X(this.u,this.path,a,!0)};g.cg=function(){y("Query.orderByPriority",0,0,arguments.length);Sh(this,"Query.orderByPriority");var a=of(this.m,H);Qh(a);return new X(this.u,this.path,a,!0)};
g.dg=function(){y("Query.orderByValue",0,0,arguments.length);Sh(this,"Query.orderByValue");var a=of(this.m,wc);Qh(a);return new X(this.u,this.path,a,!0)};g.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Od("Query.startAt",a,this.path,!0);Ud("Query.startAt",b);var c=this.m.Nd(a,b);Rh(c);Qh(c);if(this.m.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");n(a)||(b=a=null);return new X(this.u,this.path,c,this.Nc)};
g.gd=function(a,b){y("Query.endAt",0,2,arguments.length);Od("Query.endAt",a,this.path,!0);Ud("Query.endAt",b);var c=this.m.gd(a,b);Rh(c);Qh(c);if(this.m.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.u,this.path,c,this.Nc)};
g.If=function(a,b){y("Query.equalTo",1,2,arguments.length);Od("Query.equalTo",a,this.path,!1);Ud("Query.equalTo",b);if(this.m.ka)throw Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");if(this.m.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).gd(a,b)};
g.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Y;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.u.toString()+(b||"/")};g.toJSON=function(){y("Query.toJSON",0,1,arguments.length);return this.toString()};g.ja=function(){var a=ac(pf(this.m));return"{}"===a?"default":a};
g.isEqual=function(a){y("Query.isEqual",1,1,arguments.length);if(!(a instanceof X))throw Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");var b=this.u===a.u,c=this.path.Z(a.path),d=this.ja()===a.ja();return b&&c&&d};
function Th(a,b,c){var d={cancel:null,Ma:null};if(b&&c)d.cancel=b,B(a,3,d.cancel,!0),d.Ma=c,ob(a,4,d.Ma);else if(b)if("object"===typeof b&&null!==b)d.Ma=b;else if("function"===typeof b)d.cancel=b;else throw Error(A(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.gc;X.prototype.off=X.prototype.Ic;X.prototype.once=X.prototype.$f;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.ag;
X.prototype.orderByKey=X.prototype.bg;X.prototype.orderByPriority=X.prototype.cg;X.prototype.orderByValue=X.prototype.dg;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.gd;X.prototype.equalTo=X.prototype.If;X.prototype.toString=X.prototype.toString;X.prototype.isEqual=X.prototype.isEqual;gc(X.prototype,"ref",X.prototype.wb);function Y(a,b){this.ta=a;this.qa=b}Y.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);B("Firebase.onDisconnect().cancel",1,a,!0);var b=new ib;this.ta.xd(this.qa,jb(b,a));return b.ra};Y.prototype.cancel=Y.prototype.cancel;Y.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Wd("Firebase.onDisconnect().remove",this.qa);B("Firebase.onDisconnect().remove",1,a,!0);var b=new ib;Ch(this.ta,this.qa,null,jb(b,a));return b.ra};
Y.prototype.remove=Y.prototype.remove;Y.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Wd("Firebase.onDisconnect().set",this.qa);Od("Firebase.onDisconnect().set",a,this.qa,!1);B("Firebase.onDisconnect().set",2,b,!0);var c=new ib;Ch(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.set=Y.prototype.set;
Y.prototype.Jb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Wd("Firebase.onDisconnect().setWithPriority",this.qa);Od("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Sd("Firebase.onDisconnect().setWithPriority",2,b);B("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new ib;Dh(this.ta,this.qa,a,b,jb(d,c));return d.ra};Y.prototype.setWithPriority=Y.prototype.Jb;
Y.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Wd("Firebase.onDisconnect().update",this.qa);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.onDisconnect().update",a,this.qa);B("Firebase.onDisconnect().update",2,b,!0);
c=new ib;Eh(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.update=Y.prototype.update;var Z={Mf:function(){dg=Zf=!0}};Z.forceLongPolling=Z.Mf;Z.Nf=function(){eg=!0};Z.forceWebSockets=Z.Nf;Z.Tf=function(){return Yf.isAvailable()};Z.isWebSocketsAvailable=Z.Tf;Z.lg=function(a,b){a.u.Ra.ze=b};Z.setSecurityDebugCallback=Z.lg;Z.Be=function(a,b){a.u.Be(b)};Z.stats=Z.Be;Z.Ce=function(a,b){a.u.Ce(b)};Z.statsIncrementCounter=Z.Ce;Z.fd=function(a){return a.u.fd};Z.dataUpdateCount=Z.fd;Z.Sf=function(a,b){a.u.je=b};Z.interceptServerData=Z.Sf;function U(a,b){if(!(a instanceof Qg))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,mf,!1);this.then=void 0;this["catch"]=void 0}la(U,X);g=U.prototype;g.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:Oc(this.path)};
g.n=function(a){y("Firebase.child",1,1,arguments.length);if(ga(a))a=String(a);else if(!(a instanceof E))if(null===K(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Vd("Firebase.child",b)}else Vd("Firebase.child",a);return new U(this.u,this.path.n(a))};g.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.u,a)};
g.Of=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};g.Gf=function(){return this.u.Ya};g.set=function(a,b){y("Firebase.set",1,2,arguments.length);Wd("Firebase.set",this.path);Od("Firebase.set",a,this.path,!1);B("Firebase.set",2,b,!0);var c=new ib;this.u.Jb(this.path,a,null,jb(c,b));return c.ra};
g.update=function(a,b){y("Firebase.update",1,2,arguments.length);Wd("Firebase.update",this.path);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.update",a,this.path);B("Firebase.update",2,b,!0);c=new ib;this.u.update(this.path,a,jb(c,b));return c.ra};
g.Jb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Wd("Firebase.setWithPriority",this.path);Od("Firebase.setWithPriority",a,this.path,!1);Sd("Firebase.setWithPriority",2,b);B("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new ib;this.u.Jb(this.path,a,b,jb(d,c));return d.ra};
g.remove=function(a){y("Firebase.remove",0,1,arguments.length);Wd("Firebase.remove",this.path);B("Firebase.remove",1,a,!0);return this.set(null,a)};
g.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Wd("Firebase.transaction",this.path);B("Firebase.transaction",1,a,!1);B("Firebase.transaction",2,b,!0);if(n(c)&&"boolean"!=typeof c)throw Error(A("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new ib;ha(b)&&kb(d.ra);Gh(this.u,this.path,a,function(a,c,h){a?
d.reject(a):d.resolve(new Ph(c,h));ha(b)&&b(a,c,h)},c);return d.ra};g.kg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Wd("Firebase.setPriority",this.path);Sd("Firebase.setPriority",1,a);B("Firebase.setPriority",2,b,!0);var c=new ib;this.u.Jb(this.path.n(".priority"),a,null,jb(c,b));return c.ra};
g.push=function(a,b){y("Firebase.push",0,2,arguments.length);Wd("Firebase.push",this.path);Od("Firebase.push",a,this.path,!0);B("Firebase.push",2,b,!0);var c=wh(this.u),d=Kc(c),c=this.n(d),e=this.n(d),d=null!=a?c.set(a,b).then(function(){return e}):hb.resolve(e);c.then=q(d.then,d);c["catch"]=q(d.then,d,void 0);ha(b)&&kb(d);return c};g.ib=function(){Wd("Firebase.onDisconnect",this.path);return new Y(this.u,this.path)};U.prototype.child=U.prototype.n;U.prototype.set=U.prototype.set;
U.prototype.update=U.prototype.update;U.prototype.setWithPriority=U.prototype.Jb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.kg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.ib;gc(U.prototype,"database",U.prototype.Gf);gc(U.prototype,"key",U.prototype.getKey);gc(U.prototype,"parent",U.prototype.getParent);gc(U.prototype,"root",U.prototype.Of);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
try{firebase.INTERNAL.registerService("database",function(a){var b=Ug.Vb(),c=a.options.databaseURL;n(c)||Vb("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=Wb(c),c=d.jc;Xd("Invalid Firebase Database URL",d);d.path.e()||Vb("Database URL must point to the root of a Firebase Database (not including a child path).");(d=w(b.lb,a.name))&&Vb("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new Qg(c,b.wf,a);b.lb[a.name]=
d;return d.Ya},{Reference:U,Query:X,Database:Pg,enableLogging:Sb,INTERNAL:Z,TEST_ACCESS:W,ServerValue:Sg})}catch(Uh){Vb("Failed to register the Firebase Database Service ("+Uh+")")};})();

}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.database;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(108);
(function(){
(function(){for(var h,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},l="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,n=["Number","MIN_SAFE_INTEGER"],ba=0;ba<n.length-1;ba++){var ca=n[ba];ca in l||(l[ca]={});l=l[ca]}var da=n[n.length-1];-9007199254740991!=l[da]&&aa(l,da,{configurable:!0,writable:!0,value:-9007199254740991});
var p=this,q=function(a){return void 0!==a},ea=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b};var r=function(a,b){this.code="storage/"+a;this.message="Firebase Storage: "+b;this.serverResponse=null;this.name="FirebaseError"};(function(){var a=Error;function b(){}b.prototype=a.prototype;r.b=a.prototype;r.prototype=new b;r.a=function(b,d,e){for(var c=Array(arguments.length-2),f=2;f<arguments.length;f++)c[f-2]=arguments[f];return a.prototype[d].apply(b,c)}})();
var fa=function(){return new r("unknown","An unknown error occurred, please check the error payload for server response.")},ga=function(){return new r("canceled","User canceled the upload/download.")},ha=function(){return new r("cannot-slice-blob","Cannot slice blob for upload. Please retry the upload.")},ia=function(a,b,c){return new r("invalid-argument","Invalid argument in `"+b+"` at index "+a+": "+c)},ja=function(){return new r("app-deleted","The Firebase app was deleted.")},t=function(a,b){return new r("invalid-format",
"String does not match format '"+a+"': "+b)},u=function(a){throw new r("internal-error","Internal error: "+a);};var v="https://firebasestorage.googleapis.com";var ka=function(a){if("undefined"!==typeof firebase)return new firebase.Promise(a);throw Error("Error in Firebase Storage - be sure to load firebase-app.js first.");};var la=function(a,b){return-1!==a.indexOf(b)};var ma=function(a,b,c){function d(){C||(C=!0,b.apply(null,arguments))}function e(b){m=setTimeout(function(){m=null;a(g,2===y)},b)}function g(a,b){if(!C)if(a)d.apply(null,arguments);else if(2===y||z)d.apply(null,arguments);else{64>k&&(k*=2);var c;1===y?(y=2,c=0):c=1E3*(k+Math.random());e(c)}}function f(a){Pa||(Pa=!0,C||(null!==m?(a||(y=2),clearTimeout(m),e(0)):a||(y=1)))}var k=1,m=null,z=!1,y=0,C=!1,Pa=!1;e(0);setTimeout(function(){z=!0;f(!0)},c);return f};var na=function(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])},oa=function(a){var b={};na(a,function(a,d){b[a]=d});return b};var w=function(a,b,c,d){this.l=a;this.b={};this.method=b;this.headers={};this.body=null;this.m=c;this.c=this.a=null;this.f=[200];this.i=[];this.timeout=d;this.g=!0};var pa=function(a){var b=encodeURIComponent,c="?";na(a,function(a,e){a=b(a)+"="+b(e);c=c+a+"&"});return c=c.slice(0,-1)};var ra=function(a,b,c,d,e,g,f,k,m,z,y){this.F=a;this.D=b;this.A=c;this.u=d;this.B=e.slice();this.s=g.slice();this.m=this.o=this.c=this.b=null;this.g=this.i=!1;this.v=f;this.l=k;this.f=z;this.G=y;this.C=m;var C=this;this.w=ka(function(a,b){C.o=a;C.m=b;qa(C)})},sa=function(a,b,c){this.b=a;this.c=b;this.a=!!c},qa=function(a){function b(a,b){function c(a){d.f(a.loaded,a.lengthComputable?a.total:-1)}b?a(!1,new sa(!1,null,!0)):(b=new ta,b.h.withCredentials=d.G,d.b=b,null!==d.f&&q(b.h.upload)&&b.h.upload.addEventListener("progress",
c),ua(b,d.F,d.D,d.u,d.A).then(function(b){null!==d.f&&q(b.h.upload)&&b.h.upload.removeEventListener("progress",c);d.b=null;var e=0===va(b),f=x(b);if(!(e=!e))var e=la([408,429],f),g=la(d.s,f),e=500<=f&&600>f||e||g;e?(b=2===va(b),a(!1,new sa(!1,null,b))):a(!0,new sa(la(d.B,f),b))}))}function c(a,b){var c=d.o;a=d.m;var e=b.c;if(b.b)try{var g=d.v(e,wa(e));q(g)?c(g):c()}catch(z){a(z)}else null!==e?(b=fa(),g=wa(e),b.serverResponse=g,d.l?a(d.l(e,b)):a(b)):(b=b.a?d.g?ja():ga():new r("retry-limit-exceeded",
"Max retry time for operation exceeded, please try again."),a(b))}var d=a;a.i?c(0,new sa(!1,null,!0)):a.c=ma(b,c,a.C)};ra.prototype.a=function(){return this.w};ra.prototype.cancel=function(a){this.i=!0;this.g=a||!1;null!==this.c&&(0,this.c)(!1);null!==this.b&&this.b.abort()};
var xa=function(a,b,c){var d=pa(a.b),d=a.l+d,e=a.headers?oa(a.headers):{};null!==b&&0<b.length&&(e.Authorization="Firebase "+b);e["X-Firebase-Storage-Version"]="webjs/"+("undefined"!==typeof firebase?firebase.SDK_VERSION:"AppManager");return new ra(d,a.method,e,a.body,a.f,a.i,a.m,a.a,a.timeout,a.c,c)};var ya=function(a){this.b=firebase.Promise.reject(a)};ya.prototype.a=function(){return this.b};ya.prototype.cancel=function(){};var A=function(a,b){this.bucket=a;this.path=b},za=function(a){var b=encodeURIComponent;return"/b/"+b(a.bucket)+"/o/"+b(a.path)},Ba=function(a){var b;try{b=Aa(a)}catch(c){return new A(a,"")}if(""===b.path)return b;throw new r("invalid-default-bucket","Invalid default bucket '"+a+"'.");},Aa=function(a){for(var b=null,c=[{M:/^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i,H:{bucket:1,path:3},L:function(a){"/"===a.path.charAt(a.path.length-1)&&(a.path=a.path.slice(0,-1))}},{M:/^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i,
H:{bucket:1,path:3},L:function(a){a.path=decodeURIComponent(a.path)}}],d=0;d<c.length;d++){var e=c[d],g=e.M.exec(a);if(g){b=g[e.H.bucket];(g=g[e.H.path])||(g="");b=new A(b,g);e.L(b);break}}if(null==b)throw new r("invalid-url","Invalid URL '"+a+"'.");return b};var Ca=function(){this.a={};this.b=Number.MIN_SAFE_INTEGER},Da=function(a,b){function c(){delete e.a[d]}var d=a.b;a.b++;a.a[d]=b;var e=a;b.a().then(c,c)},Ea=function(a){na(a.a,function(a,c){c&&c.cancel(!0)});a.a={}};var B=function(a){return q(a)&&null!==a},Fa=function(a){return"string"===typeof a||a instanceof String},Ga=function(){return"undefined"!==typeof Blob};var Ha=function(a,b,c,d,e){this.a=a;this.g=null;null!==this.a&&(a=this.a.options,B(a)&&(a=a.storageBucket||null,this.g=null==a?null:Ba(a).bucket));this.s=b;this.o=c;this.l=e;this.m=d;this.c=12E4;this.b=6E4;this.i=new Ca;this.f=!1},Ia=function(a){return null!==a.a&&B(a.a.INTERNAL)&&B(a.a.INTERNAL.getToken)?a.a.INTERNAL.getToken().then(function(a){return B(a)?a.accessToken:null},function(){return null}):firebase.Promise.resolve(null)};Ha.prototype.bucket=function(){if(this.f)throw ja();return this.g};
var D=function(a,b,c){if(a.f)return new ya(ja());b=a.o(b,c,null===a.a,a.l);Da(a.i,b);return b};var Ja=function(a,b){b=b.split("/").filter(function(a){return 0<a.length}).join("/");return 0===a.length?b:a+"/"+b},Ka=function(a){var b=a.lastIndexOf("/",a.length-2);return-1===b?a:a.slice(b+1)};var La=function(a,b){return b},E=function(a,b,c,d){this.c=a;this.b=b||a;this.writable=!!c;this.a=d||La},Ma=null,Na=function(){if(Ma)return Ma;var a=[];a.push(new E("bucket"));a.push(new E("generation"));a.push(new E("metageneration"));a.push(new E("name","fullPath",!0));var b=new E("name");b.a=function(a,b){return!Fa(b)||2>b.length?b:Ka(b)};a.push(b);b=new E("size");b.a=function(a,b){return B(b)?+b:b};a.push(b);a.push(new E("timeCreated"));a.push(new E("updated"));a.push(new E("md5Hash",null,!0));
a.push(new E("cacheControl",null,!0));a.push(new E("contentDisposition",null,!0));a.push(new E("contentEncoding",null,!0));a.push(new E("contentLanguage",null,!0));a.push(new E("contentType",null,!0));a.push(new E("metadata","customMetadata",!0));a.push(new E("downloadTokens","downloadURLs",!1,function(a,b){if(!(Fa(b)&&0<b.length))return[];var c=encodeURIComponent;return b.split(",").map(function(b){var d=a.fullPath,d="https://firebasestorage.googleapis.com/v0"+("/b/"+c(a.bucket)+"/o/"+c(d));b=pa({alt:"media",
token:b});return d+b})}));return Ma=a},Oa=function(a,b){Object.defineProperty(a,"ref",{get:function(){return b.s(b,new A(a.bucket,a.fullPath))}})},Qa=function(a,b){for(var c={},d=b.length,e=0;e<d;e++){var g=b[e];g.writable&&(c[g.c]=a[g.b])}return JSON.stringify(c)},Ra=function(a){if(!a||"object"!==typeof a)throw"Expected Metadata object.";for(var b in a){var c=a[b];if("customMetadata"===b){if("object"!==typeof c)throw"Expected object for 'customMetadata' mapping.";}else if(null!=c&&"object"===typeof c)throw"Mapping for '"+
b+"' cannot be an object.";}};var F=function(a,b,c){for(var d=b.length,e=b.length,g=0;g<b.length;g++)if(b[g].b){d=g;break}if(!(d<=c.length&&c.length<=e))throw d===e?(b=d,d=1===d?"argument":"arguments"):(b="between "+d+" and "+e,d="arguments"),new r("invalid-argument-count","Invalid argument count in `"+a+"`: Expected "+b+" "+d+", received "+c.length+".");for(g=0;g<c.length;g++)try{b[g].a(c[g])}catch(f){if(f instanceof Error)throw ia(g,a,f.message);throw ia(g,a,f);}},G=function(a,b){var c=this;this.a=function(b){c.b&&!q(b)||a(b)};
this.b=!!b},Sa=function(a,b){return function(c){a(c);b(c)}},H=function(a,b){function c(a){if(!("string"===typeof a||a instanceof String))throw"Expected string.";}var d;a?d=Sa(c,a):d=c;return new G(d,b)},Ta=function(){return new G(function(a){if(!(a instanceof Uint8Array||a instanceof ArrayBuffer||Ga()&&a instanceof Blob))throw"Expected Blob or File.";})},Ua=function(){return new G(function(a){if(!(("number"===typeof a||a instanceof Number)&&0<=a))throw"Expected a number 0 or greater.";})},Va=function(a,
b){return new G(function(b){if(!(null===b||B(b)&&b instanceof Object))throw"Expected an Object.";B(a)&&a(b)},b)},I=function(){return new G(function(a){if(null!==a&&"function"!=ea(a))throw"Expected a Function.";},!0)};var J=function(a){return function(){var b=[];Array.prototype.push.apply(b,arguments);firebase.Promise.resolve(!0).then(function(){a.apply(null,b)})}};var Wa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},Xa=function(a,b){return a<b?-1:a>b?1:0};var K;a:{var Ya=p.navigator;if(Ya){var Za=Ya.userAgent;if(Za){K=Za;break a}}K=""};var ab=function(a,b){var c=$a;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var bb=-1!=K.indexOf("Opera"),cb=-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"),db=-1!=K.indexOf("Edge"),eb=-1!=K.indexOf("Gecko")&&!(-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"))&&!(-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"))&&-1==K.indexOf("Edge"),fb=-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"),gb;
a:{var hb="",ib=function(){var a=K;if(eb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(db)return/Edge\/([\d\.]+)/.exec(a);if(cb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(fb)return/WebKit\/(\S+)/.exec(a);if(bb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();ib&&(hb=ib?ib[1]:"");if(cb){var jb,kb=p.document;jb=kb?kb.documentMode:void 0;if(null!=jb&&jb>parseFloat(hb)){gb=String(jb);break a}}gb=hb}
var lb=gb,$a={},mb=function(a){return ab(a,function(){for(var b=0,c=Wa(String(lb)).split("."),d=Wa(String(a)).split("."),e=Math.max(c.length,d.length),g=0;0==b&&g<e;g++){var f=c[g]||"",k=d[g]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==f[0].length&&0==k[0].length)break;b=Xa(0==f[1].length?0:parseInt(f[1],10),0==k[1].length?0:parseInt(k[1],10))||Xa(0==f[2].length,0==k[2].length)||Xa(f[2],k[2]);f=f[3];k=k[3]}while(0==b)}return 0<=b})};var nb=function(a){var b=p.BlobBuilder||p.WebKitBlobBuilder;if(q(b)){for(var b=new b,c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}b=Array.prototype.slice.call(arguments);c=p.BlobBuilder||p.WebKitBlobBuilder;if(q(c)){for(var c=new c,d=0;d<b.length;d++)c.append(b[d],void 0);b=c.getBlob(void 0)}else if(q(p.Blob))b=new Blob(b,{});else throw Error("This browser doesn't seem to support creating Blobs");return b},ob=function(a,b,c){q(c)||(c=a.size);return a.webkitSlice?a.webkitSlice(b,
c):a.mozSlice?a.mozSlice(b,c):a.slice?eb&&!mb("13.0")||fb&&!mb("537.1")?(0>b&&(b+=a.size),0>b&&(b=0),0>c&&(c+=a.size),c<b&&(c=b),a.slice(b,c-b)):a.slice(b,c):null};var L={RAW:"raw",BASE64:"base64",BASE64URL:"base64url",DATA_URL:"data_url"},pb=function(a){switch(a){case "raw":case "base64":case "base64url":case "data_url":break;default:throw"Expected one of the event types: [raw, base64, base64url, data_url].";}},qb=function(a,b){this.data=a;this.a=b||null},ub=function(a,b){switch(a){case "raw":return new qb(rb(b));case "base64":case "base64url":return new qb(sb(a,b));case "data_url":a=new tb(b);var c;if(a.a)c=sb("base64",a.c);else{try{c=decodeURIComponent(a.c)}catch(d){throw t("data_url",
"Malformed data URL.");}c=rb(c)}return new qb(c,(new tb(b)).b)}throw fa();},rb=function(a){for(var b=[],c=0;c<a.length;c++){var d=a.charCodeAt(c);if(127>=d)b.push(d);else if(2047>=d)b.push(192|d>>6,128|d&63);else if(55296==(d&64512))if(c<a.length-1&&56320==(a.charCodeAt(c+1)&64512)){var e=a.charCodeAt(++c),d=65536|(d&1023)<<10|e&1023;b.push(240|d>>18,128|d>>12&63,128|d>>6&63,128|d&63)}else b.push(239,191,189);else 56320==(d&64512)?b.push(239,191,189):b.push(224|d>>12,128|d>>6&63,128|d&63)}return new Uint8Array(b)},
sb=function(a,b){switch(a){case "base64":var c=-1!==b.indexOf("-"),d=-1!==b.indexOf("_");if(c||d)throw t(a,"Invalid character '"+(c?"-":"_")+"' found: is it base64url encoded?");break;case "base64url":c=-1!==b.indexOf("+");d=-1!==b.indexOf("/");if(c||d)throw t(a,"Invalid character '"+(c?"+":"/")+"' found: is it base64 encoded?");b=b.replace(/-/g,"+").replace(/_/g,"/")}var e;try{e=atob(b)}catch(g){throw t(a,"Invalid character found");}a=new Uint8Array(e.length);for(b=0;b<e.length;b++)a[b]=e.charCodeAt(b);
return a},tb=function(a){var b=a.match(/^data:([^,]+)?,/);if(null===b)throw t("data_url","Must be formatted 'data:[<mediatype>][;base64],<data>");b=b[1]||null;this.a=!1;this.b=null;if(null!=b){var c=b.length-7;this.b=(this.a=0<=c&&b.indexOf(";base64",c)==c)?b.substring(0,b.length-7):b}this.c=a.substring(a.indexOf(",")+1)};var M=function(a,b){Ga()&&a instanceof Blob?(this.j=a,b=a.size,a=a.type):(a instanceof ArrayBuffer?(b?this.j=new Uint8Array(a):(this.j=new Uint8Array(a.byteLength),this.j.set(new Uint8Array(a))),b=this.j.length):(b?this.j=a:(this.j=new Uint8Array(a.length),this.j.set(a)),b=a.length),a="");this.a=b;this.b=a};M.prototype.type=function(){return this.b};
M.prototype.slice=function(a,b){if(Ga()&&this.j instanceof Blob)return a=ob(this.j,a,b),null===a?null:new M(a);a=new Uint8Array(this.j.buffer,a,b-a);return new M(a,!0)};
var vb=function(a){var b=[];Array.prototype.push.apply(b,arguments);if(Ga())return b=b.map(function(a){return a instanceof M?a.j:a}),new M(nb.apply(null,b));var b=b.map(function(a){return Fa(a)?ub("raw",a).data:a.j}),c=0;b.forEach(function(a){c+=a.byteLength});var d=new Uint8Array(c),e=0;b.forEach(function(a){for(var b=0;b<a.length;b++)d[e++]=a[b]});return new M(d,!0)};var wb=function(a,b,c){"function"==ea(a)||B(b)||B(c)?(this.b=a,this.error=b||null,this.a=c||null):(this.b=a.next||null,this.error=a.error||null,this.a=a.complete||null)};var N=function(a){if(!a)throw fa();},xb=function(a,b){return function(c,d){var e;a:{try{e=JSON.parse(d)}catch(k){e=null;break a}c=typeof e;e="object"==c&&null!=e||"function"==c?e:null}if(null===e)e=null;else{c={type:"file"};d=b.length;for(var g=0;g<d;g++){var f=b[g];c[f.b]=f.a(c,e[f.c])}Oa(c,a);e=c}N(null!==e);return e}},O=function(a){return function(b,c){b=401===x(b)?new r("unauthenticated","User is not authenticated, please authenticate using Firebase Authentication and try again."):402===x(b)?
new r("quota-exceeded","Quota for bucket '"+a.bucket+"' exceeded, please view quota on https://firebase.google.com/pricing/."):403===x(b)?new r("unauthorized","User does not have permission to access '"+a.path+"'."):c;b.serverResponse=c.serverResponse;return b}},yb=function(a){var b=O(a);return function(c,d){var e=b(c,d);404===x(c)&&(e=new r("object-not-found","Object '"+a.path+"' does not exist."));e.serverResponse=d.serverResponse;return e}},zb=function(a,b,c){var d=za(b);a=new w(v+"/v0"+d,"GET",
xb(a,c),a.c);a.a=yb(b);return a},Ab=function(a,b){var c=za(b);a=new w(v+"/v0"+c,"DELETE",function(){},a.c);a.f=[200,204];a.a=yb(b);return a},Bb=function(a,b,c){c=c?oa(c):{};c.fullPath=a.path;c.size=b.a;c.contentType||(a=b&&b.type()||"application/octet-stream",c.contentType=a);return c},Cb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f={"X-Goog-Upload-Protocol":"multipart"},k;k="";for(var m=0;2>m;m++)k+=Math.random().toString().slice(2);f["Content-Type"]="multipart/related; boundary="+
k;e=Bb(b,d,e);m=Qa(e,c);d=vb("--"+k+"\r\nContent-Type: application/json; charset=utf-8\r\n\r\n"+m+"\r\n--"+k+"\r\nContent-Type: "+e.contentType+"\r\n\r\n",d,"\r\n--"+k+"--");if(null===d)throw ha();a=new w(v+"/v0"+g,"POST",xb(a,c),a.b);a.b={name:e.fullPath};a.headers=f;a.body=d.j;a.a=O(b);return a},Db=function(a,b,c,d){this.current=a;this.total=b;this.I=!!c;this.metadata=d||null},Eb=function(a,b){var c;try{c=a.h.getResponseHeader("X-Goog-Upload-Status")}catch(d){N(!1)}N(la(b||["active"],c));return c},
Fb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f=Bb(b,d,e);e={name:f.fullPath};g=v+"/v0"+g;d={"X-Goog-Upload-Protocol":"resumable","X-Goog-Upload-Command":"start","X-Goog-Upload-Header-Content-Length":d.a,"X-Goog-Upload-Header-Content-Type":f.contentType,"Content-Type":"application/json; charset=utf-8"};c=Qa(f,c);a=new w(g,"POST",function(a){Eb(a);var b;try{b=a.h.getResponseHeader("X-Goog-Upload-URL")}catch(z){N(!1)}N(Fa(b));return b},a.b);a.b=e;a.headers=d;a.body=c;a.a=O(b);
return a},Gb=function(a,b,c,d){a=new w(c,"POST",function(a){var b=Eb(a,["active","final"]),c;try{c=a.h.getResponseHeader("X-Goog-Upload-Size-Received")}catch(k){N(!1)}a=c;isFinite(a)&&(a=String(a));a="string"==typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN;N(!isNaN(a));return new Db(a,d.a,"final"===b)},a.b);a.headers={"X-Goog-Upload-Command":"query"};a.a=O(b);a.g=!1;return a},Hb=function(a,b,c,d,e,g,f,k){var m=new Db(0,0);f?(m.current=f.current,m.total=f.total):(m.current=0,m.total=
d.a);if(d.a!==m.total)throw new r("server-file-wrong-size","Server recorded incorrect upload file size, please retry the upload.");var z=f=m.total-m.current;0<e&&(z=Math.min(z,e));var y=m.current;e={"X-Goog-Upload-Command":z===f?"upload, finalize":"upload","X-Goog-Upload-Offset":m.current};f=d.slice(y,y+z);if(null===f)throw ha();c=new w(c,"POST",function(a,c){var e=Eb(a,["active","final"]),f=m.current+z,k=d.a,y;"final"===e?y=xb(b,g)(a,c):y=null;return new Db(f,k,"final"===e,y)},b.b);c.headers=e;c.body=
f.j;c.c=k||null;c.a=O(a);c.g=!1;return c};var Ib={STATE_CHANGED:"state_changed"},P={RUNNING:"running",PAUSED:"paused",SUCCESS:"success",CANCELED:"canceled",ERROR:"error"},Jb=function(a){switch(a){case "running":case "pausing":case "canceling":return"running";case "paused":return"paused";case "success":return"success";case "canceled":return"canceled";case "error":return"error";default:return"error"}};var ta=function(){var a=this;this.h=new XMLHttpRequest;this.b=0;this.c=ka(function(b){a.h.addEventListener("abort",function(){a.b=2;b(a)});a.h.addEventListener("error",function(){a.b=1;b(a)});a.h.addEventListener("load",function(){b(a)})});this.a=!1},ua=function(a,b,c,d,e){if(a.a)throw u("cannot .send() more than once");a.a=!0;a.h.open(c,b,!0);B(e)&&na(e,function(b,c){a.h.setRequestHeader(b,c.toString())});B(d)?a.h.send(d):a.h.send();return a.c},va=function(a){if(!a.a)throw u("cannot .getErrorCode() before sending");
return a.b},x=function(a){if(!a.a)throw u("cannot .getStatus() before sending");try{return a.h.status}catch(b){return-1}},wa=function(a){if(!a.a)throw u("cannot .getResponseText() before sending");return a.h.responseText};ta.prototype.abort=function(){this.h.abort()};var Kb=function(){};var Q=function(a,b,c,d,e,g){this.b=a;this.i=b;this.f=c;this.a=d;this.g=e;this.c=g};h=Q.prototype;h.X=function(){return this.b};h.sa=function(){return this.i};h.pa=function(){return this.f};h.ka=function(){return this.a};h.Y=function(){if(B(this.a)){var a=this.a.downloadURLs;return B(a)&&B(a[0])?a[0]:null}return null};h.ra=function(){return this.g};h.na=function(){return this.c};var T=function(a,b,c,d,e,g){var f=this;this.O=a;this.c=b;this.o=c;this.f=e;this.i=void 0===g?null:g;this.u=d;this.l=0;this.G=this.w=!1;this.B=[];this.U=262144<this.f.a;this.b="running";this.a=this.A=this.g=null;this.m=1;this.s=function(a){f.a=null;f.m=1;"storage/canceled"===a.code?(f.w=!0,R(f)):(f.g=a,S(f,"error"))};this.N=function(a){f.a=null;"storage/canceled"===a.code?R(f):(f.g=a,S(f,"error"))};this.D=this.v=null;this.F=ka(function(a,b){f.v=a;f.D=b;Lb(f)});this.F.then(null,function(){})},Nb=function(a){var b=
a.l;return function(c){Mb(a,b+c)}},Lb=function(a){"running"===a.b&&null===a.a&&(a.U?null===a.A?Ob(a):a.w?Pb(a):a.G?Qb(a):Rb(a):Sb(a))},U=function(a,b){Ia(a.c).then(function(c){switch(a.b){case "running":b(c);break;case "canceling":S(a,"canceled");break;case "pausing":S(a,"paused")}})},Ob=function(a){U(a,function(b){var c=Fb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.A=b;a.w=!1;R(a)},a.s)})},Pb=function(a){var b=a.A;U(a,function(c){var d=Gb(a.c,a.o,b,a.f);a.a=D(a.c,d,c);
a.a.a().then(function(b){a.a=null;Mb(a,b.current);a.w=!1;b.I&&(a.G=!0);R(a)},a.s)})},Rb=function(a){var b=262144*a.m,c=new Db(a.l,a.f.a),d=a.A;U(a,function(e){var g;try{g=Hb(a.o,a.c,d,a.f,b,a.u,c,Nb(a))}catch(f){a.g=f;S(a,"error");return}a.a=D(a.c,g,e);a.a.a().then(function(b){33554432>262144*a.m&&(a.m*=2);a.a=null;Mb(a,b.current);b.I?(a.i=b.metadata,S(a,"success")):R(a)},a.s)})},Qb=function(a){U(a,function(b){var c=zb(a.c,a.o,a.u);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;S(a,"success")},
a.N)})},Sb=function(a){U(a,function(b){var c=Cb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;Mb(a,a.f.a);S(a,"success")},a.s)})},Mb=function(a,b){var c=a.l;a.l=b;a.l!==c&&V(a)},S=function(a,b){if(a.b!==b)switch(b){case "canceling":a.b=b;null!==a.a&&a.a.cancel();break;case "pausing":a.b=b;null!==a.a&&a.a.cancel();break;case "running":var c="paused"===a.b;a.b=b;c&&(V(a),Lb(a));break;case "paused":a.b=b;V(a);break;case "canceled":a.g=ga();a.b=b;V(a);break;case "error":a.b=
b;V(a);break;case "success":a.b=b,V(a)}},R=function(a){switch(a.b){case "pausing":S(a,"paused");break;case "canceling":S(a,"canceled");break;case "running":Lb(a)}};T.prototype.C=function(){return new Q(this.l,this.f.a,Jb(this.b),this.i,this,this.O)};
T.prototype.P=function(a,b,c,d){function e(a){try{f(a);return}catch(C){}try{if(k(a),!(q(a.next)||q(a.error)||q(a.complete)))throw"";}catch(C){throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";}}function g(a){return function(b,c,d){null!==a&&F("on",a,arguments);var e=new wb(b,c,d);m.B.push(e);Tb(m,e);return function(){var a=m.B,b=a.indexOf(e);-1!==b&&a.splice(b,1)}}}var f=I().a,k=Va(null,!0).a;F("on",[H(function(){if("state_changed"!==a)throw"Expected one of the event types: [state_changed].";
}),Va(e,!0),I(),I()],arguments);var m=this,z=[Va(function(a){if(null===a)throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a)}),I(),I()];return q(b)||q(c)||q(d)?g(null)(b,c,d):g(z)};T.prototype.then=function(a,b){return this.F.then(void 0===a?null:a,void 0===b?null:b)};T.prototype["catch"]=function(a){return this.then(null,a)};
var V=function(a){Ub(a);Array.prototype.slice.call(a.B).forEach(function(b){Tb(a,b)})},Ub=function(a){if(null!==a.v){var b=!0;switch(Jb(a.b)){case "success":J(a.v.bind(null,a.C()))();break;case "canceled":case "error":J(a.D.bind(null,a.g))();break;default:b=!1}b&&(a.v=null,a.D=null)}},Tb=function(a,b){switch(Jb(a.b)){case "running":case "paused":null!==b.b&&J(b.b.bind(b,a.C()))();break;case "success":null!==b.a&&J(b.a.bind(b))();break;case "canceled":case "error":null!==b.error&&J(b.error.bind(b,
a.g))();break;default:null!==b.error&&J(b.error.bind(b,a.g))()}};T.prototype.T=function(){F("resume",[],arguments);var a="paused"===this.b||"pausing"===this.b;a&&S(this,"running");return a};T.prototype.R=function(){F("pause",[],arguments);var a="running"===this.b;a&&S(this,"pausing");return a};T.prototype.cancel=function(){F("cancel",[],arguments);var a="running"===this.b||"pausing"===this.b;a&&S(this,"canceling");return a};var W=function(a,b){this.a=a;this.location=b instanceof A?b:Aa(b)};W.prototype.toString=function(){F("toString",[],arguments);return"gs://"+this.location.bucket+"/"+this.location.path};var Vb=function(a,b){return new W(a,b)};h=W.prototype;h.J=function(a){F("child",[H()],arguments);var b=Ja(this.location.path,a);return Vb(this.a,new A(this.location.bucket,b))};
h.ma=function(){var a;a=this.location.path;if(0==a.length)a=null;else{var b=a.lastIndexOf("/");a=-1===b?"":a.slice(0,b)}return null===a?null:Vb(this.a,new A(this.location.bucket,a))};h.oa=function(){return Vb(this.a,new A(this.location.bucket,""))};h.W=function(){return this.location.bucket};h.ha=function(){return this.location.path};h.la=function(){return Ka(this.location.path)};h.qa=function(){return this.a.m};
h.aa=function(a,b){F("put",[Ta(),new G(Ra,!0)],arguments);X(this,"put");return new T(this,this.a,this.location,Na(),new M(a),b)};h.ba=function(a,b,c){F("putString",[H(),H(pb,!0),new G(Ra,!0)],arguments);X(this,"putString");var d=ub(B(b)?b:"raw",a),e=c?oa(c):{};!B(e.contentType)&&B(d.a)&&(e.contentType=d.a);return new T(this,this.a,this.location,Na(),new M(d.data,!0),e)};
h.Z=function(){F("delete",[],arguments);X(this,"delete");var a=this;return Ia(this.a).then(function(b){var c=Ab(a.a,a.location);return D(a.a,c,b).a()})};h.K=function(){F("getMetadata",[],arguments);X(this,"getMetadata");var a=this;return Ia(this.a).then(function(b){var c=zb(a.a,a.location,Na());return D(a.a,c,b).a()})};
h.ca=function(a){F("updateMetadata",[new G(Ra,void 0)],arguments);X(this,"updateMetadata");var b=this;return Ia(this.a).then(function(c){var d=b.a,e=b.location,g=a,f=Na(),k=za(e),k=v+"/v0"+k,g=Qa(g,f),d=new w(k,"PATCH",xb(d,f),d.c);d.headers={"Content-Type":"application/json; charset=utf-8"};d.body=g;d.a=yb(e);return D(b.a,d,c).a()})};
h.$=function(){F("getDownloadURL",[],arguments);X(this,"getDownloadURL");return this.K().then(function(a){a=a.downloadURLs[0];if(B(a))return a;throw new r("no-download-url","The given file does not have any download URLs.");})};var X=function(a,b){if(""===a.location.path)throw new r("invalid-root-operation","The operation '"+b+"' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");};var Y=function(a,b,c){this.a=new Ha(a,function(a,b){return new W(a,b)},xa,this,b);this.c=a;q(c)?this.b=Ba(c):null!=this.a.bucket()&&(this.b=new A(this.a.bucket(),""));this.f=new Wb(this)};h=Y.prototype;h.da=function(a){F("ref",[H(function(a){if(/^[A-Za-z]+:\/\//.test(a))throw"Expected child path but got a URL, use refFromURL instead.";},!0)],arguments);if(null===this.b)throw Error("No Storage Bucket defined in Firebase Options.");var b=new W(this.a,this.b);return q(a)?b.J(a):b};
h.ea=function(a){F("refFromURL",[H(function(a){if(!/^[A-Za-z]+:\/\//.test(a))throw"Expected full URL but got a child path, use ref instead.";try{Aa(a)}catch(c){throw"Expected valid full URL but got an invalid one.";}},!1)],arguments);return new W(this.a,a)};h.ja=function(){return this.a.b};h.ga=function(a){F("setMaxUploadRetryTime",[Ua()],arguments);this.a.b=a};h.ia=function(){return this.a.c};h.fa=function(a){F("setMaxOperationRetryTime",[Ua()],arguments);this.a.c=a};h.V=function(){return this.c};
h.S=function(){return this.f};var Wb=function(a){this.a=a};Wb.prototype.b=function(){var a=this.a.a;a.f=!0;a.a=null;Ea(a.i)};var Z=function(a,b,c){Object.defineProperty(a,b,{get:c})};W.prototype.toString=W.prototype.toString;W.prototype.child=W.prototype.J;W.prototype.put=W.prototype.aa;W.prototype.putString=W.prototype.ba;W.prototype["delete"]=W.prototype.Z;W.prototype.getMetadata=W.prototype.K;W.prototype.updateMetadata=W.prototype.ca;W.prototype.getDownloadURL=W.prototype.$;Z(W.prototype,"parent",W.prototype.ma);Z(W.prototype,"root",W.prototype.oa);Z(W.prototype,"bucket",W.prototype.W);Z(W.prototype,"fullPath",W.prototype.ha);
Z(W.prototype,"name",W.prototype.la);Z(W.prototype,"storage",W.prototype.qa);Y.prototype.ref=Y.prototype.da;Y.prototype.refFromURL=Y.prototype.ea;Z(Y.prototype,"maxOperationRetryTime",Y.prototype.ia);Y.prototype.setMaxOperationRetryTime=Y.prototype.fa;Z(Y.prototype,"maxUploadRetryTime",Y.prototype.ja);Y.prototype.setMaxUploadRetryTime=Y.prototype.ga;Z(Y.prototype,"app",Y.prototype.V);Z(Y.prototype,"INTERNAL",Y.prototype.S);Wb.prototype["delete"]=Wb.prototype.b;Y.prototype.capi_=function(a){v=a};
T.prototype.on=T.prototype.P;T.prototype.resume=T.prototype.T;T.prototype.pause=T.prototype.R;T.prototype.cancel=T.prototype.cancel;T.prototype.then=T.prototype.then;T.prototype["catch"]=T.prototype["catch"];Z(T.prototype,"snapshot",T.prototype.C);Z(Q.prototype,"bytesTransferred",Q.prototype.X);Z(Q.prototype,"totalBytes",Q.prototype.sa);Z(Q.prototype,"state",Q.prototype.pa);Z(Q.prototype,"metadata",Q.prototype.ka);Z(Q.prototype,"downloadURL",Q.prototype.Y);Z(Q.prototype,"task",Q.prototype.ra);
Z(Q.prototype,"ref",Q.prototype.na);Ib.STATE_CHANGED="state_changed";P.RUNNING="running";P.PAUSED="paused";P.SUCCESS="success";P.CANCELED="canceled";P.ERROR="error";L.RAW="raw";L.BASE64="base64";L.BASE64URL="base64url";L.DATA_URL="data_url";
(function(){function a(a,b,e){return new Y(a,new Kb,e)}var b={TaskState:P,TaskEvent:Ib,StringFormat:L,Storage:Y,Reference:W};if("undefined"!==typeof firebase)firebase.INTERNAL.registerService("storage",a,b,void 0,!0);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.storage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(108);
(function(){
(function(){var f=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;for(var d in b)if(Object.defineProperties){var e=Object.getOwnPropertyDescriptor(b,d);e&&Object.defineProperty(a,d,e)}else a[d]=b[d]},g=this,h=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&
"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},k=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;a.v=function(a,c,n){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-
2]=arguments[e];return b.prototype[c].apply(a,d)}};var m=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,m);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};k(m,Error);var p=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};var q=function(a,b){b.unshift(a);m.call(this,p.apply(null,b));b.shift()};k(q,m);var r=function(a,b,c){if(!a){var d="Assertion failed";if(b)var d=d+(": "+b),e=Array.prototype.slice.call(arguments,2);throw new q(""+d,e||[]);}};var t=null;var v=function(a){a=new Uint8Array(a);var b=h(a);r("array"==b||"object"==b&&"number"==typeof a.length,"encodeByteArray takes an array as a parameter");if(!t)for(t={},b=0;65>b;b++)t[b]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(b);for(var b=t,c=[],d=0;d<a.length;d+=3){var e=a[d],n=d+1<a.length,l=n?a[d+1]:0,z=d+2<a.length,u=z?a[d+2]:0,M=e>>2,e=(e&3)<<4|l>>4,l=(l&15)<<2|u>>6,u=u&63;z||(u=64,n||(l=64));c.push(b[M],b[e],b[l],b[u])}return c.join("").replace(/\+/g,"-").replace(/\//g,
"_").replace(/=+$/,"")};var w={},x=(w["only-available-in-window"]="This method is available in a Window context.",w["only-available-in-sw"]="This method is available in a service worker context.",w["should-be-overriden"]="This method should be overriden by extended classes.",w["bad-sender-id"]="Please ensure that 'messagingSenderId' is set correctly in the options passed into firebase.initializeApp().",w["permission-default"]="The required permissions were not granted and dismissed instead.",w["permission-blocked"]="The required permissions were not granted and blocked instead.",
w["unsupported-browser"]="This browser doesn't support the API's required to use the firebase SDK.",w["notifications-blocked"]="Notifications have been blocked.",w["failed-serviceworker-registration"]="We are unable to register the default service worker. {$browserErrorMessage}",w["sw-registration-expected"]="A service worker registration was the expected input.",w["get-subscription-failed"]="There was an error when trying to get any existing Push Subscriptions.",w["invalid-saved-token"]="Unable to access details of the saved token.",
w["sw-reg-redundant"]="The service worker being used for push was made redundant.",w["token-subscribe-failed"]="A problem occured while subscribing the user to FCM: {$message}",w["token-subscribe-no-token"]="FCM returned no token when subscribing the user to push.",w["token-subscribe-no-push-set"]="FCM returned an invalid response when getting an FCM token.",w["use-sw-before-get-token"]="You must call useServiceWorker() before calling getToken() to ensure your service worker is used.",w["invalid-delete-token"]=
"You must pass a valid token into deleteToken(), i.e. the token from getToken().",w["delete-token-not-found"]="The deletion attempt for token could not be performed as the token was not found.",w["delete-scope-not-found"]="The deletion attempt for service worker scope could not be performed as the scope was not found.",w["bg-handler-function-expected"]="The input to setBackgroundMessageHandler() must be a function.",w["no-window-client-to-msg"]="An attempt was made to message a non-existant window client.",
w["unable-to-resubscribe"]="There was an error while re-subscribing the FCM token for push messaging. Will have to resubscribe the user on next visit. {$message}",w["no-fcm-token-for-resubscribe"]="Could not find an FCM token and as a result, unable to resubscribe. Will have to resubscribe the user on next visit.",w["failed-to-delete-token"]="Unable to delete the currently saved token.",w["no-sw-in-reg"]="Even though the service worker registration was successful, there was a problem accessing the service worker itself.",
w["incorrect-gcm-sender-id"]="Please change your web app manifest's 'gcm_sender_id' value to '103953800507' to use Firebase messaging.",w["bad-scope"]="The service worker scope must be a string with at least one character.",w["bad-vapid-key"]="The public VAPID key must be a string with at least one character.",w["bad-subscription"]="The subscription must be a valid PushSubscription.",w["bad-token"]="The FCM Token used for storage / lookup was not a valid token string.",w["bad-push-set"]="The FCM push set used for storage / lookup was not not a valid push set string.",
w["failed-delete-vapid-key"]="The VAPID key could not be deleted.",w);var y={userVisibleOnly:!0,applicationServerKey:new Uint8Array([4,51,148,247,223,161,235,177,220,3,162,94,21,113,219,72,211,46,237,237,178,52,219,183,71,58,12,143,196,204,225,111,60,140,132,223,171,182,102,62,242,12,212,139,254,227,249,118,47,20,28,99,8,106,111,45,177,26,149,176,206,55,192,156,110])};var A=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x),B=function(){this.a=null},C=function(a){if(a.a)return a.a;a.a=new Promise(function(a,c){var b=g.indexedDB.open("fcm_token_details_db",1);b.onerror=function(a){c(a.target.error)};b.onsuccess=function(b){a(b.target.result)};b.onupgradeneeded=function(a){a=a.target.result.createObjectStore("fcm_token_object_Store",{keyPath:"swScope"});a.createIndex("fcmSenderId","fcmSenderId",{unique:!1});a.createIndex("fcmToken","fcmToken",{unique:!0})}});
return a.a},D=function(a){a.a?a.a.then(function(b){b.close();a.a=null}):Promise.resolve()},E=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").index("fcmToken").get(b);d.onerror=function(a){e(a.target.error)};d.onsuccess=function(a){c(a.target.result)}})})},F=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=[],l=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").openCursor();
l.onerror=function(a){e(a.target.error)};l.onsuccess=function(a){(a=a.target.result)?(a.value.fcmSenderId===b&&d.push(a.value),a.continue()):c(d)}})})},G=function(a,b,c){var d=v(b.getKey("p256dh")),e=v(b.getKey("auth"));a="authorized_entity="+a+"&"+("endpoint="+b.endpoint+"&")+("encryption_key="+d+"&")+("encryption_auth="+e);c&&(a+="&pushSet="+c);c=new Headers;c.append("Content-Type","application/x-www-form-urlencoded");return fetch("https://fcm.googleapis.com/fcm/connect/subscribe",{method:"POST",
headers:c,body:a}).then(function(a){return a.json()}).then(function(a){if(a.error)throw A.create("token-subscribe-failed",{message:a.error.message});if(!a.token)throw A.create("token-subscribe-no-token");if(!a.pushSet)throw A.create("token-subscribe-no-push-set");return{token:a.token,pushSet:a.pushSet}})},H=function(a,b,c,d,e,n){var l={swScope:c.scope,endpoint:d.endpoint,auth:v(d.getKey("auth")),p256dh:v(d.getKey("p256dh")),fcmToken:e,fcmPushSet:n,fcmSenderId:b};return C(a).then(function(a){return new Promise(function(b,
c){var d=a.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").put(l);d.onerror=function(a){c(a.target.error)};d.onsuccess=function(){b()}})})};
B.prototype.i=function(a,b){return b instanceof ServiceWorkerRegistration?"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):F(this,a).then(function(c){if(0!==c.length){var d=c.findIndex(function(c){return b.scope===c.swScope&&a===c.fcmSenderId});if(-1!==d)return c[d]}}).then(function(a){if(a)return b.pushManager.getSubscription().catch(function(){throw A.create("get-subscription-failed");}).then(function(b){var c;if(c=b)c=b.endpoint===a.endpoint&&v(b.getKey("auth"))===a.auth&&
v(b.getKey("p256dh"))===a.p256dh;if(c)return a.fcmToken})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.getSavedToken=B.prototype.i;
B.prototype.h=function(a,b){var c=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):b instanceof ServiceWorkerRegistration?b.pushManager.getSubscription().then(function(a){return a?a:b.pushManager.subscribe(y)}).then(function(d){return G(a,d).then(function(e){return H(c,a,b,d,e.token,e.pushSet).then(function(){return e.token})})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.createToken=B.prototype.h;
B.prototype.deleteToken=function(a){var b=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("invalid-delete-token")):E(this,a).then(function(a){if(!a)throw A.create("delete-token-not-found");return C(b).then(function(b){return new Promise(function(c,d){var e=b.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").delete(a.swScope);e.onerror=function(a){d(a.target.error)};e.onsuccess=function(b){0===b.target.result?d(A.create("failed-to-delete-token")):
c(a)}})})})};var I=function(a){var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);if(!a.options.messagingSenderId||"string"!==typeof a.options.messagingSenderId)throw this.a.create("bad-sender-id");this.l=a.options.messagingSenderId;this.c=new B;this.app=a;this.INTERNAL={};this.INTERNAL.delete=function(){return b.delete}};
I.prototype.getToken=function(){var a=this,b=Notification.permission;return"granted"!==b?"denied"===b?Promise.reject(this.a.create("notifications-blocked")):Promise.resolve(null):this.f().then(function(b){return a.c.i(a.l,b).then(function(c){return c?c:a.c.h(a.l,b)})})};I.prototype.getToken=I.prototype.getToken;I.prototype.deleteToken=function(a){var b=this;return this.c.deleteToken(a).then(function(){return b.f()}).then(function(a){return a?a.pushManager.getSubscription():null}).then(function(a){if(a)return a.unsubscribe()})};
I.prototype.deleteToken=I.prototype.deleteToken;I.prototype.f=function(){throw this.a.create("should-be-overriden");};I.prototype.requestPermission=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=I.prototype.useServiceWorker;I.prototype.onMessage=function(){throw this.a.create("only-available-in-window");};I.prototype.onMessage=I.prototype.onMessage;
I.prototype.onTokenRefresh=function(){throw this.a.create("only-available-in-window");};I.prototype.onTokenRefresh=I.prototype.onTokenRefresh;I.prototype.setBackgroundMessageHandler=function(){throw this.a.create("only-available-in-sw");};I.prototype.setBackgroundMessageHandler=I.prototype.setBackgroundMessageHandler;I.prototype.delete=function(){D(this.c)};var J=function(a,b){var c={};return c["firebase-messaging-msg-type"]=a,c["firebase-messaging-msg-data"]=b,c};var K=self,P=function(a){I.call(this,a);var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);K.addEventListener("push",function(a){return L(b,a)},!1);K.addEventListener("pushsubscriptionchange",function(a){return N(b,a)},!1);K.addEventListener("notificationclick",function(a){return O(b,a)},!1);this.b=null};f(P,I);
var L=function(a,b){var c;try{c=b.data.json()}catch(e){return}var d=Q().then(function(b){if(b){if(c.notification||a.b)return R(a,c)}else{if((b=c)&&"object"===typeof b.notification){var d=Object.assign({},b.notification),e={};d.data=(e.FCM_MSG=b,e);b=d}else b=void 0;if(b)return K.registration.showNotification(b.title||"",b);if(a.b)return a.b(c)}});b.waitUntil(d)},N=function(a,b){var c=a.getToken().then(function(b){if(!b)throw a.a.create("no-fcm-token-for-resubscribe");var c=a.c;return E(c,b).then(function(b){if(!b)throw a.a.create("invalid-saved-token");
return K.registration.pushManager.subscribe(y).then(function(a){return G(b.A,a,b.w)}).catch(function(d){return c.deleteToken(b.B).then(function(){throw a.a.create("unable-to-resubscribe",{message:d});})})})});b.waitUntil(c)},O=function(a,b){if(b.notification&&b.notification.data&&b.notification.data.FCM_MSG){b.stopImmediatePropagation();b.notification.close();var c=b.notification.data.FCM_MSG,d=c.notification.click_action;if(d){var e=S(d).then(function(a){return a?a:K.clients.openWindow(d)}).then(function(b){if(b)return delete c.notification,
T(a,b,J("notification-clicked",c))});b.waitUntil(e)}}};P.prototype.setBackgroundMessageHandler=function(a){if(a&&"function"!==typeof a)throw this.a.create("bg-handler-function-expected");this.b=a};P.prototype.setBackgroundMessageHandler=P.prototype.setBackgroundMessageHandler;
var S=function(a){var b=(new URL(a)).href;return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){for(var c=null,e=0;e<a.length;e++)if((new URL(a[e].url)).href===b){c=a[e];break}if(c)return c.focus(),c})},T=function(a,b,c){return new Promise(function(d,e){if(!b)return e(a.a.create("no-window-client-to-msg"));b.postMessage(c);d()})},Q=function(){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){return a.some(function(a){return"visible"===
a.visibilityState})})},R=function(a,b){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(c){var d=J("push-msg-received",b);return Promise.all(c.map(function(b){return T(a,b,d)}))})};P.prototype.f=function(){return Promise.resolve(K.registration)};var V=function(a){I.call(this,a);var b=this;this.j=null;this.m=firebase.INTERNAL.createSubscribe(function(a){b.j=a});this.s=null;this.o=firebase.INTERNAL.createSubscribe(function(a){b.s=a});U(this)};f(V,I);
V.prototype.getToken=function(){var a=this;return"serviceWorker"in navigator&&"PushManager"in window&&"Notification"in window&&ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification")&&PushSubscription.prototype.hasOwnProperty("getKey")?W(this).then(function(){return I.prototype.getToken.call(a)}):Promise.reject(this.a.create("unsupported-browser"))};V.prototype.getToken=V.prototype.getToken;
var W=function(a){if(a.g)return a.g;var b=document.querySelector('link[rel="manifest"]');b?a.g=fetch(b.href).then(function(a){return a.json()}).catch(function(){return Promise.resolve()}).then(function(b){if(b&&b.gcm_sender_id&&"103953800507"!==b.gcm_sender_id)throw a.a.create("incorrect-gcm-sender-id");}):a.g=Promise.resolve();return a.g};
V.prototype.requestPermission=function(){var a=this;return"granted"===Notification.permission?Promise.resolve():new Promise(function(b,c){var d=function(d){return"granted"===d?b():"denied"===d?c(a.a.create("permission-blocked")):c(a.a.create("permission-default"))},e=Notification.requestPermission(function(a){e||d(a)});e&&e.then(d)})};V.prototype.requestPermission=V.prototype.requestPermission;
V.prototype.useServiceWorker=function(a){if(!(a instanceof ServiceWorkerRegistration))throw this.a.create("sw-registration-expected");if("undefined"!==typeof this.b)throw this.a.create("use-sw-before-get-token");this.b=a};V.prototype.useServiceWorker=V.prototype.useServiceWorker;V.prototype.onMessage=function(a,b,c){return this.m(a,b,c)};V.prototype.onMessage=V.prototype.onMessage;V.prototype.onTokenRefresh=function(a,b,c){return this.o(a,b,c)};V.prototype.onTokenRefresh=V.prototype.onTokenRefresh;
var X=function(a,b){var c=b.installing||b.waiting||b.active;return new Promise(function(d,e){if(c)if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else{var n=function(){if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else return;c.removeEventListener("statechange",n)};c.addEventListener("statechange",n)}else e(a.a.create("no-sw-in-reg"))})};
V.prototype.f=function(){var a=this;if(this.b)return X(this,this.b);this.b=null;return navigator.serviceWorker.register("/firebase-messaging-sw.js",{scope:"/firebase-cloud-messaging-push-scope"}).catch(function(b){throw a.a.create("failed-serviceworker-registration",{browserErrorMessage:b.message});}).then(function(b){return X(a,b).then(function(){a.b=b;b.update();return b})})};
var U=function(a){"serviceWorker"in navigator&&navigator.serviceWorker.addEventListener("message",function(b){if(b.data&&b.data["firebase-messaging-msg-type"])switch(b=b.data,b["firebase-messaging-msg-type"]){case "push-msg-received":case "notification-clicked":a.j.next(b["firebase-messaging-msg-data"])}},!1)};if(!(firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService))throw Error("Cannot install Firebase Messaging - be sure to load firebase-app.js first.");firebase.INTERNAL.registerService("messaging",function(a){return self&&"ServiceWorkerGlobalScope"in self?new P(a):new V(a)},{Messaging:V});new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.messaging;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDisplayName = setDisplayName;
exports.logout = logout;
exports.signInAnonymously = signInAnonymously;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _root = __webpack_require__(353);

var root = _interopRequireWildcard(_root);

var _types = __webpack_require__(216);

var T = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function setDisplayName(val) {
  return function (dispatch, getState, _ref) {
    var getFirebase = _ref.getFirebase;

    var userId = root.userId(getState(), {});
    var setpath = "/users/" + T.Id.unwrap(userId) + "/username";
    return Util.dispatchPromise("auth/setDisplayName", dispatch, getFirebase().set(setpath, val), { setpath: setpath, val: val });
  };
}
function logout() {
  return function (dispatch, getState, _ref2) {
    var getFirebase = _ref2.getFirebase;

    return Util.dispatchPromise("auth/logout", dispatch, getFirebase().logout());
  };
}

function signInAnonymously() {
  return function (dispatch, getState, _ref3) {
    var getFirebase = _ref3.getFirebase;

    console.log("creating anonymous account");
    return Util.dispatchPromise("auth/signInAnonymously", dispatch, getFirebase().auth().signInAnonymously());
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(768);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});

var _types = __webpack_require__(769);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _actions = __webpack_require__(770);

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvYmV0YS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5leHBvcnQgKiBmcm9tIFwiLi9yb290XCJcbmV4cG9ydCAqIGZyb20gXCIuL3R5cGVzXCJcbmV4cG9ydCAqIGZyb20gXCIuL2FjdGlvbnNcIlxuIl19

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllowed = exports.isBetaAdmin = exports.betaKey = exports.betaKeyUser = exports.betaKeyProp = exports.isBetaEnabled = exports.mode = exports.authBetaUser = undefined;

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _EnvConfig = __webpack_require__(155);

var EnvConfig = _interopRequireWildcard(_EnvConfig);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var authBetaUserPath = (0, _reselect.createSelector)(_lodash2.default.flow(Auth.userId, Auth.Id.unwrap), paths.betaUsers.data);
var authBetaUser = exports.authBetaUser = {
  hasKey: _queryStatus.selectPath.isNotEmpty(authBetaUserPath)
};
var mode = exports.mode = function mode(s, p) {
  return EnvConfig.config.authMode;
};
var isBetaEnabled = exports.isBetaEnabled = (0, _reselect.createSelector)(mode, function (mode) {
  return mode === "closedBeta";
});
var isAuthed = Auth.isNotEmpty;

var betaKeyProp = exports.betaKeyProp = function betaKeyProp(state, props) {
  return props.betaKey;
};
var betaKeyUserPath = (0, _reselect.createSelector)(betaKeyProp, paths.betaKeyToUser.data);
var betaKeyUser = exports.betaKeyUser = {
  isUsed: _queryStatus.selectPath.isNotEmpty(betaKeyUserPath)
};

var betaValidKeyPath = (0, _reselect.createSelector)(betaKeyProp, paths.betaValidKeys.data);
var betaKey = exports.betaKey = {
  isValid: _queryStatus.selectPath.isNotEmpty(betaValidKeyPath)
};
var isBetaAdmin = exports.isBetaAdmin = Auth.roles.betaUsers;

var isAllowed = exports.isAllowed = (0, _reselect.createSelector)(mode, isAuthed, authBetaUser.hasKey, function (mode, authed, keyed) {
  switch (mode) {
    case "open":
      return authed;
    case "closedBeta":
      return authed && keyed;
    default:
      throw new Error("unknown authMode: " + mode);
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJ0eXBlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBetaKeys = exports._generateBetaKeys = undefined;
exports.applyAuthBetaKey = applyAuthBetaKey;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _types = __webpack_require__(91);

var Users = _interopRequireWildcard(_types);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _uuid = __webpack_require__(771);

var _uuid2 = _interopRequireDefault(_uuid);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function applyAuthBetaKey(betaKey) {
  return function (dispatch, getState, _ref) {
    var _getFirebase$update;

    var getFirebase = _ref.getFirebase;

    var userId = Auth.userId(getState(), {});
    // Database rules enforce things like "only one key per user" and "don't reuse keys". Just try to apply the key, knowing it may fail.
    return Util.dispatchPromise("beta/applyKey", dispatch, getFirebase().update("/", (_getFirebase$update = {}, _defineProperty(_getFirebase$update, "betaKeyUsers/" + betaKey, userId), _defineProperty(_getFirebase$update, "betaUsers/" + Users.Id.unwrap(userId), betaKey), _getFirebase$update)), { userId: userId, betaKey: betaKey });
  };
}

// No need to check the role here. View and (more importantly) database enforce it
var _generateBetaKeys = exports._generateBetaKeys = function _generateBetaKeys(firebase, n) {
  return (0, _lodash2.default)(n).range().map(function () {
    return _uuid2.default.v4();
  }).keyBy().mapValues(function () {
    return {
      createdAt: firebase.database.ServerValue.TIMESTAMP
    };
  }).value();
};
var firebaseProp = function firebaseProp(state, props) {
  return props.firebase || (0, _assert.throws)("props.firebase is required. Use firebaseConnect first.");
};
var createBetaKeys = exports.createBetaKeys = (0, _reselect.createSelector)(firebaseProp, function (firebase) {
  return function (n) {
    (0, _assert.assert)(n > 0, "can't generate non-positive keys, silly");
    (0, _assert.assert)(n <= 100, "max 100 keys generated at once. No particular reason, really; go ahead and increase this.");
    var keys = _generateBetaKeys(firebase, n);
    return firebase.update("/betaKeys/", keys).then(function (result) {
      return { keys: Object.keys(keys), result: result };
    });
  };
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvYmV0YS9hY3Rpb25zLmpzIl0sIm5hbWVzIjpbImFwcGx5QXV0aEJldGFLZXkiLCJVdGlsIiwiVXNlcnMiLCJBdXRoIiwiYmV0YUtleSIsImRpc3BhdGNoIiwiZ2V0U3RhdGUiLCJnZXRGaXJlYmFzZSIsInVzZXJJZCIsImRpc3BhdGNoUHJvbWlzZSIsInVwZGF0ZSIsIklkIiwidW53cmFwIiwiX2dlbmVyYXRlQmV0YUtleXMiLCJmaXJlYmFzZSIsIm4iLCJyYW5nZSIsIm1hcCIsInY0Iiwia2V5QnkiLCJtYXBWYWx1ZXMiLCJjcmVhdGVkQXQiLCJkYXRhYmFzZSIsIlNlcnZlclZhbHVlIiwiVElNRVNUQU1QIiwidmFsdWUiLCJmaXJlYmFzZVByb3AiLCJzdGF0ZSIsInByb3BzIiwiY3JlYXRlQmV0YUtleXMiLCJrZXlzIiwidGhlbiIsIk9iamVjdCIsInJlc3VsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O1FBU2dCQSxnQixHQUFBQSxnQjs7QUFSaEI7O0lBQVlDLEk7O0FBQ1o7O0FBQ0E7O0FBQ0E7O0lBQVlDLEs7O0FBQ1o7O0lBQVlDLEk7O0FBQ1o7Ozs7QUFDQTs7Ozs7Ozs7OztBQUVPLFNBQVNILGdCQUFULENBQTBCSSxPQUExQixFQUEyQztBQUNoRCxTQUFRLFVBQUNDLFFBQUQsRUFBV0MsUUFBWCxRQUF1QztBQUFBOztBQUFBLFFBQWpCQyxXQUFpQixRQUFqQkEsV0FBaUI7O0FBQzdDLFFBQU1DLFNBQVNMLEtBQUtLLE1BQUwsQ0FBWUYsVUFBWixFQUF3QixFQUF4QixDQUFmO0FBQ0E7QUFDQSxXQUFPTCxLQUFLUSxlQUFMLENBQ0wsZUFESyxFQUVMSixRQUZLLEVBR0xFLGNBQWNHLE1BQWQsQ0FBcUIsR0FBckIsa0VBRUcsa0JBQWtCTixPQUZyQixFQUUrQkksTUFGL0Isd0NBR0csZUFBZU4sTUFBTVMsRUFBTixDQUFTQyxNQUFULENBQWdCSixNQUFoQixDQUhsQixFQUc0Q0osT0FINUMsd0JBSEssRUFRTCxFQUFDSSxjQUFELEVBQVNKLGdCQUFULEVBUkssQ0FBUDtBQVVELEdBYkQ7QUFjRDs7QUFFRDtBQUNPLElBQU1TLGdEQUFvQixTQUFwQkEsaUJBQW9CLENBQUNDLFFBQUQsRUFBbUJDLENBQW5CO0FBQUEsU0FDL0Isc0JBQUVBLENBQUYsRUFDR0MsS0FESCxHQUVHQyxHQUZILENBRU87QUFBQSxXQUFNLGVBQUtDLEVBQUwsRUFBTjtBQUFBLEdBRlAsRUFHR0MsS0FISCxHQUlHQyxTQUpILENBSWE7QUFBQSxXQUFPO0FBQ2hCQyxpQkFBV1AsU0FBU1EsUUFBVCxDQUFrQkMsV0FBbEIsQ0FBOEJDO0FBRHpCLEtBQVA7QUFBQSxHQUpiLEVBT0dDLEtBUEgsRUFEK0I7QUFBQSxDQUExQjtBQVNQLElBQU1DLGVBQWUsU0FBZkEsWUFBZSxDQUFDQyxLQUFELEVBQWFDLEtBQWI7QUFBQSxTQUNuQkEsTUFBTWQsUUFBTixJQUNBLG9CQUFPLHdEQUFQLENBRm1CO0FBQUEsQ0FBckI7QUFHTyxJQUFNZSwwQ0FBaUIsOEJBQWVILFlBQWYsRUFBNkI7QUFBQSxTQUFZLGFBQUs7QUFDMUUsd0JBQU9YLElBQUksQ0FBWCxFQUFjLHlDQUFkO0FBQ0Esd0JBQ0VBLEtBQUssR0FEUCxFQUVFLDJGQUZGO0FBSUEsUUFBTWUsT0FBT2pCLGtCQUFrQkMsUUFBbEIsRUFBNEJDLENBQTVCLENBQWI7QUFDQSxXQUFPRCxTQUNKSixNQURJLENBQ0csWUFESCxFQUNpQm9CLElBRGpCLEVBRUpDLElBRkksQ0FFQztBQUFBLGFBQVcsRUFBQ0QsTUFBTUUsT0FBT0YsSUFBUCxDQUFZQSxJQUFaLENBQVAsRUFBMEJHLGNBQTFCLEVBQVg7QUFBQSxLQUZELENBQVA7QUFHRCxHQVYwRDtBQUFBLENBQTdCLENBQXZCIiwiZmlsZSI6ImFjdGlvbnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IHthc3NlcnQsIHRocm93c30gZnJvbSBcIkBzd2FybTIvYXNzZXJ0XCJcbmltcG9ydCAqIGFzIFVzZXJzIGZyb20gXCIuLi91c2Vycy90eXBlc1wiXG5pbXBvcnQgKiBhcyBBdXRoIGZyb20gXCIuLi9hdXRoXCJcbmltcG9ydCB1dWlkIGZyb20gXCJ1dWlkXCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuXG5leHBvcnQgZnVuY3Rpb24gYXBwbHlBdXRoQmV0YUtleShiZXRhS2V5OiBzdHJpbmcpIHtcbiAgcmV0dXJuICgoZGlzcGF0Y2gsIGdldFN0YXRlLCB7Z2V0RmlyZWJhc2V9KSA9PiB7XG4gICAgY29uc3QgdXNlcklkID0gQXV0aC51c2VySWQoZ2V0U3RhdGUoKSwge30pXG4gICAgLy8gRGF0YWJhc2UgcnVsZXMgZW5mb3JjZSB0aGluZ3MgbGlrZSBcIm9ubHkgb25lIGtleSBwZXIgdXNlclwiIGFuZCBcImRvbid0IHJldXNlIGtleXNcIi4gSnVzdCB0cnkgdG8gYXBwbHkgdGhlIGtleSwga25vd2luZyBpdCBtYXkgZmFpbC5cbiAgICByZXR1cm4gVXRpbC5kaXNwYXRjaFByb21pc2UoXG4gICAgICBcImJldGEvYXBwbHlLZXlcIixcbiAgICAgIGRpc3BhdGNoLFxuICAgICAgZ2V0RmlyZWJhc2UoKS51cGRhdGUoXCIvXCIsIHtcbiAgICAgICAgLy8gRGF0YWJhc2UgcnVsZXMgcmVxdWlyZSB0aGF0IGJvdGggb2YgdGhlc2UgYXJlIHVwZGFlZCBzaW11bHRhbmVvdXNseS4gT25lLWF0LWEtdGltZSB3aWxsIGZhaWwuXG4gICAgICAgIFtcImJldGFLZXlVc2Vycy9cIiArIGJldGFLZXldOiB1c2VySWQsXG4gICAgICAgIFtcImJldGFVc2Vycy9cIiArIFVzZXJzLklkLnVud3JhcCh1c2VySWQpXTogYmV0YUtleSxcbiAgICAgIH0pLFxuICAgICAge3VzZXJJZCwgYmV0YUtleX0sXG4gICAgKVxuICB9OiBVdGlsLkFjdGlvbkRpc3BhdGNoZXIpXG59XG5cbi8vIE5vIG5lZWQgdG8gY2hlY2sgdGhlIHJvbGUgaGVyZS4gVmlldyBhbmQgKG1vcmUgaW1wb3J0YW50bHkpIGRhdGFiYXNlIGVuZm9yY2UgaXRcbmV4cG9ydCBjb25zdCBfZ2VuZXJhdGVCZXRhS2V5cyA9IChmaXJlYmFzZTogT2JqZWN0LCBuOiBudW1iZXIpID0+XG4gIF8obilcbiAgICAucmFuZ2UoKVxuICAgIC5tYXAoKCkgPT4gdXVpZC52NCgpKVxuICAgIC5rZXlCeSgpXG4gICAgLm1hcFZhbHVlcygoKSA9PiAoe1xuICAgICAgY3JlYXRlZEF0OiBmaXJlYmFzZS5kYXRhYmFzZS5TZXJ2ZXJWYWx1ZS5USU1FU1RBTVAsXG4gICAgfSkpXG4gICAgLnZhbHVlKClcbmNvbnN0IGZpcmViYXNlUHJvcCA9IChzdGF0ZTogYW55LCBwcm9wczogT2JqZWN0KSA9PlxuICBwcm9wcy5maXJlYmFzZSB8fFxuICB0aHJvd3MoXCJwcm9wcy5maXJlYmFzZSBpcyByZXF1aXJlZC4gVXNlIGZpcmViYXNlQ29ubmVjdCBmaXJzdC5cIilcbmV4cG9ydCBjb25zdCBjcmVhdGVCZXRhS2V5cyA9IGNyZWF0ZVNlbGVjdG9yKGZpcmViYXNlUHJvcCwgZmlyZWJhc2UgPT4gbiA9PiB7XG4gIGFzc2VydChuID4gMCwgXCJjYW4ndCBnZW5lcmF0ZSBub24tcG9zaXRpdmUga2V5cywgc2lsbHlcIilcbiAgYXNzZXJ0KFxuICAgIG4gPD0gMTAwLFxuICAgIFwibWF4IDEwMCBrZXlzIGdlbmVyYXRlZCBhdCBvbmNlLiBObyBwYXJ0aWN1bGFyIHJlYXNvbiwgcmVhbGx5OyBnbyBhaGVhZCBhbmQgaW5jcmVhc2UgdGhpcy5cIixcbiAgKVxuICBjb25zdCBrZXlzID0gX2dlbmVyYXRlQmV0YUtleXMoZmlyZWJhc2UsIG4pXG4gIHJldHVybiBmaXJlYmFzZVxuICAgIC51cGRhdGUoXCIvYmV0YUtleXMvXCIsIGtleXMpXG4gICAgLnRoZW4ocmVzdWx0ID0+ICh7a2V5czogT2JqZWN0LmtleXMoa2V5cyksIHJlc3VsdH0pKVxufSlcbiJdfQ==

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(772);
var v4 = __webpack_require__(773);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(356);
var bytesToUuid = __webpack_require__(357);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(356);
var bytesToUuid = __webpack_require__(357);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zones = exports.rankings = exports.prodMultis = exports.units = exports.combatLoot = exports.combat = exports.breakpoints = exports.achievements = exports.pushRename = exports.renameAction = exports.displayName = exports.numPendingActions = exports.user = exports.league = exports.lastActionAt = exports.createdAt = exports.version = exports.isNotEmpty = exports.isEmpty = exports.localState = exports._cacheableLocalState = exports.Decimal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// Build a combined action reducer.
// Run pending-actions before running (action-unaware) selectors.
// Generally prepare all character features for outside consumption.


var _create = __webpack_require__(775);

Object.keys(_create).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _create[key];
    }
  });
});
exports.withBaseAction = withBaseAction;

var _redux = __webpack_require__(59);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _cacheableRoot = __webpack_require__(359);

var _cacheableRoot2 = _interopRequireDefault(_cacheableRoot);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

var _backfill = __webpack_require__(776);

var _backfill2 = _interopRequireDefault(_backfill);

var _achievements = __webpack_require__(373);

var Achievements = _interopRequireWildcard(_achievements);

var _actionBase = __webpack_require__(367);

var Actions = _interopRequireWildcard(_actionBase);

var _actionErrors = __webpack_require__(799);

var ActionErrors = _interopRequireWildcard(_actionErrors);

var _breakpoints = __webpack_require__(800);

var Breakpoints = _interopRequireWildcard(_breakpoints);

var _raw2 = __webpack_require__(45);

var CombatRaw = _interopRequireWildcard(_raw2);

var _init = __webpack_require__(360);

var CombatInit = _interopRequireWildcard(_init);

var _meta = __webpack_require__(801);

var Combat = _interopRequireWildcard(_meta);

var _displayName = __webpack_require__(227);

var DisplayName = _interopRequireWildcard(_displayName);

var _lastActionAt = __webpack_require__(109);

var LastActionAt = _interopRequireWildcard(_lastActionAt);

var _leagues = __webpack_require__(221);

var Leagues = _interopRequireWildcard(_leagues);

var _prodMultis = __webpack_require__(372);

var ProdMultis = _interopRequireWildcard(_prodMultis);

var _rankingsUpdate = __webpack_require__(809);

var RankingsUpdate = _interopRequireWildcard(_rankingsUpdate);

var _user = __webpack_require__(810);

var User = _interopRequireWildcard(_user);

var _units = __webpack_require__(811);

var Units = _interopRequireWildcard(_units);

var _reify = __webpack_require__(110);

var UnitsReify = _interopRequireWildcard(_reify);

var _stats = __webpack_require__(54);

var UnitsStats = _interopRequireWildcard(_stats);

var _updatedAt = __webpack_require__(219);

var UnitsUpdatedAt = _interopRequireWildcard(_updatedAt);

var _visible = __webpack_require__(224);

var UnitsVisible = _interopRequireWildcard(_visible);

var _maxBuyable = __webpack_require__(812);

var UnitsMaxBuyable = _interopRequireWildcard(_maxBuyable);

var _version = __webpack_require__(368);

var Version = _interopRequireWildcard(_version);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Decimal = exports.Decimal = Units.Decimal;

var reducers = (0, _redux.combineReducers)({
  // required on character creation. default values are to satisfy redux rules,
  // but my code - other than combineReducers init - should never use them.
  createdAt: function createdAt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  user: function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  league: function league() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  // achievements are a little special - they must run last, outside of combineReducers.
  achievements: function achievements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  // validate that each action was created correctly, with the expected prev state.
  version: Version.reducer,
  lastActionAt: LastActionAt.reducer,
  // Remove actions as they're processed.
  actions: Actions.reducer,
  actionErrors: ActionErrors.reducer,

  combat: CombatInit.reducer,
  displayName: DisplayName.reducer,
  units: Units.reducer,
  updatedAt: UnitsUpdatedAt.reducer,
  zones: Zones.reducer
});
// if the above reducer fails, run this one instead to discard/log the failed action.
function errorReducer(state, action) {
  return _extends({}, state, {
    actions: Actions.reducer(state.actions, action),
    actionErrors: ActionErrors.errorReducer(state.actionErrors, action)
  });
}
function achievementsReducer(state, action) {
  return _extends({}, state, {
    achievements: Achievements.reducer(state.achievements, action)
  });
}
var fancyActionParams = (0, _reselect.createStructuredSelector)({
  root: _cacheableRoot2.default,
  unsafe: function unsafe(s, p) {
    return !!p.unsafeActions;
  }
});
var fancyActions = (0, _reselect.createSelector)(Actions.actions, fancyActionParams, function (actions, fancy) {
  return _lodash2.default.map(actions, function (a) {
    return _extends({}, a, fancy);
  });
});
var fancyLootAction = (0, _reselect.createSelector)(Combat.lootAction, fancyActionParams, Now.now, function (a, fancy, now) {
  return a ? _extends({}, a, fancy) : null;
});
function _privateReducer(state, action) {
  // most reducers are added to combineReducers() above, and can happily run in
  // any order.
  state = reducers(state, _extends({}, action, { character: state }));
  // special case: achievements operate on everyone else's results -
  // "did this action complete any achievements?" - so they run last.
  state = achievementsReducer(state, _extends({}, action, { character: state }));
  return state;
}
var _safePrivateReducer = withSafeReducer(_privateReducer, errorReducer);
function privateReducer(state, action) {
  var root = action.root,
      fixedNow = action.createdAt,
      unsafe = action.unsafe;
  // before running any actions, do we have loot that needs to be applied first?

  var lootAction = fancyLootAction(root, {
    character: state,
    fixedNow: fixedNow,
    unsafeActions: unsafe
  });
  // If looting fails, the action after it should still run
  if (lootAction) state = _safePrivateReducer(state, lootAction);
  if (action.type === "__NOOP") return state; // minor optimization
  return _privateReducer(state, action);
}
function unsafeReducer(state, action) {
  // private actions are triggered by other actions run here. For example,
  // combat results - once combat ends, we send everyone __COMBAT_RESULTs.
  // The player cannot push these actions directly.
  if (/^__/.test(action.type)) {
    return (0, _assert.throws)("cannot push __private actions", { action: action });
  }
  return privateReducer(state, action);
}
function withSafeReducer(reducer, errorReducer) {
  return function (state, action) {
    if (action.unsafe) return reducer(state, action);
    try {
      return reducer(state, action);
    } catch (e) {
      // TODO how to handle errors? actionErrors field on state?
      console.warn("error reducing action, ignoring", e);
      return errorReducer(state, action);
    }
  };
}
var safeReducer = withSafeReducer(unsafeReducer, errorReducer);
var safePrivateReducer = withSafeReducer(privateReducer, errorReducer);
var noopAction = (0, _reselect.createSelector)(fancyActionParams, Now.now, function (a, createdAt) {
  return _extends({}, a, { type: "__NOOP", createdAt: createdAt });
});
var backfillAction = (0, _reselect.createSelector)(fancyActionParams, LastActionAt.createdAt, // noop, but can't make backfill current-time-aware.
function (a, createdAt) {
  return _extends({}, a, { type: "__BACKFILL", createdAt: createdAt });
});
var _cacheableLocalState = exports._cacheableLocalState = (0, _reselect.createSelector)(backfillAction, fancyActions, Raw.localState, function (backfillAction, actions, state) {
  // First, fix save structure changes from older versions.
  state = (0, _backfill2.default)(state, backfillAction);
  // This is an unusual way to run a redux reducer - usually they're used to
  // modify the state on action-dispatch, but this reducer's called from
  // within a selector. This is the best way to interact with how firebase
  // handles updates - append to a list of actions, process the actions
  // asynchronously on the server, but the client can process them right away
  // for smooth client-side prediction.
  return _lodash2.default.reduce(actions, safeReducer, state);
});
var localState = exports.localState = (0, _reselect.createSelector)(
// Trigger async actions fired by the reducer, like combat loot, by running
// the reducer with an action that does nothing but tell it the *current time*.
// This is not cacheable since current time changes, but all prior steps cache
// nicely.
_cacheableLocalState, noopAction, safePrivateReducer);
var isEmpty = exports.isEmpty = Raw.isEmpty;
var isNotEmpty = exports.isNotEmpty = Raw.isNotEmpty;

//function withLocalState<S, P: {}, O>(selector: (S, P) => O): (S, P) => O {
function withLocalState(selector) {
  return function (state, props) {
    // run the selector *after* running pending actions
    var character = localState(state, props);
    // this is available for selectors that need charId, like rankings - but
    // it's not used to load the raw character.
    var _charId = props.charId;
    return selector(state, _extends({}, _lodash2.default.omit(props, ["charId"]), { character: character, _charId: _charId }));
  };
}

var baseAction = withLocalState(Actions.baseAction);
function withBaseAction(action) {
  return (0, _reselect.createSelector)(baseAction, function (base) {
    return _extends({}, base, action);
  });
}
// short-circuit the next selector if no such character
var withCharNotEmpty = function withCharNotEmpty(selector) {
  return function (s, p) {
    return Raw.isNotEmpty(s, p) ? selector(s, p) : null;
  };
};

///////////////////////////////////////////////////////////////////////
// All the character selectors - all of them - with pending actions run first.
// Selectors defined elsewhere are unaware of pending actions.
//
// (This implementation of it is verbose, but simple, and preserves flow types.
// `_.mapValues()` wizardry would be more concise, but also lose flow types.)
var version = exports.version = withLocalState(Version.get);
var createdAt = exports.createdAt = withLocalState(LastActionAt.createdAt);
var lastActionAt = exports.lastActionAt = withLocalState(LastActionAt.get);

var league = exports.league = _extends({
  names: Leagues.visibleNames,
  status: Leagues.status,
  isOpen: Leagues.isOpen,
  untilOpen: Leagues.untilOpen,

  name: withLocalState(Leagues.name)
}, _lodash2.default.mapValues(Leagues.flags, withLocalState));

var user = exports.user = {
  id: withLocalState(User.get),
  isAuth: withLocalState(User.isAuth),
  displayName: withLocalState(User.displayName)
  // no withLocalState(): that erases the pending actions we're trying to count!
};var numPendingActions = exports.numPendingActions = Actions.numPendingActions;

var displayName = exports.displayName = withLocalState(DisplayName.get);
var renameAction = exports.renameAction = function renameAction(displayName) {
  return withBaseAction(DisplayName.renameAction(displayName));
};
var pushRename = exports.pushRename = function pushRename(charId, displayName) {
  return Actions.push(charId, renameAction(displayName));
};

var achievements = exports.achievements = {
  completedAt: withLocalState(Achievements.completedAt),
  numCompleted: withLocalState(Achievements.numCompleted),
  visibleNames: withLocalState(Achievements.visibleNames),
  status: withLocalState(Achievements.status),
  progress: withLocalState(Achievements.progress),
  isComplete: withLocalState(Achievements.isComplete),
  isVisible: withLocalState(Achievements.isVisible),
  earnedSinceLock: function earnedSinceLock() {
    return withLocalState(Achievements.earnedSinceLock());
  }
};

var breakpoints = exports.breakpoints = {
  isNavCombatVisible: withLocalState(Breakpoints.isNavCombatVisible),
  isZoneSelectVisible: withLocalState(Breakpoints.isZoneSelectVisible)
};

var combatIsEmpty = withCharNotEmpty(withLocalState(CombatRaw.isEmpty));
var combatStartAction = function combatStartAction(zone) {
  return withBaseAction(CombatInit.startAction(zone));
};
var withCombatNotEmpty = function withCombatNotEmpty(selector) {
  return function (s, p) {
    return !combatIsEmpty(s, p) ? selector(s, p) : null;
  };
};
var teamSelectors = function teamSelectors(t) {
  return {
    // This should match combat/meta.js:teamSelectors
    rawCounts: withLocalState(t.rawCounts),
    counts: withLocalState(t.counts),
    visibleNames: withLocalState(t.visibleNames),
    rawCount: withLocalState(t.rawCount),
    count: withLocalState(t.count),
    maxHp: withLocalState(t.maxHp),
    attackPowerEach: withLocalState(t.attackPowerEach),
    hp: withLocalState(t.hp),
    death: withLocalState(t.death),
    isZero: withLocalState(t.isZero),
    isNonzero: withLocalState(t.isNonzero),
    isGameOver: withLocalState(t.isGameOver),
    isNotGameOver: withLocalState(t.isNotGameOver)
  };
};
var combat = exports.combat = {
  startAction: combatStartAction,
  pushStart: function pushStart(charId, zone) {
    return Actions.push(charId, combatStartAction(zone));
  },
  isEmpty: combatIsEmpty,
  isNotEmpty: _lodash2.default.negate(combatIsEmpty),

  createdAt: withLocalState(Combat.createdAt),
  sinceCreated: withLocalState(Combat.sinceCreated),
  zone: withCombatNotEmpty(withLocalState(Combat.zone)),
  updatedAt: withLocalState(Combat.updatedAt),
  sinceUpdated: withLocalState(Combat.sinceUpdated),
  isTimeLimit: withLocalState(Combat.isTimeLimit),
  doneStatus: withLocalState(Combat.doneStatus),
  isDone: withCombatNotEmpty(withLocalState(Combat.isDone)),
  isRunning: withCombatNotEmpty(withLocalState(Combat.isRunning)),
  doneAt: withLocalState(Combat.doneAt),

  Player: teamSelectors(Combat.Player),
  Enemy: teamSelectors(Combat.Enemy),
  Team: teamSelectors(Combat.Team)
};
var combatLoot = exports.combatLoot = {
  isEmpty: combat.isRunning,
  isNotEmpty: combat.isDone,
  //status: combat.doneStatus,
  //at: combat.doneAt,
  //zone: combat.zone,

  looted: withLocalState(Combat.looted),
  spent: withLocalState(Combat.spent),
  isFirstZoneWin: withLocalState(Combat.isFirstZoneWin),
  grindTokenCount: withLocalState(Combat.grindTokenCount),
  hasGrindToken: withLocalState(Combat.hasGrindToken)
};

var unitsIsVisible = withCharNotEmpty(withLocalState(UnitsVisible.isVisible));
var buyUnitAction = function buyUnitAction(unitName, count) {
  return withBaseAction(Units.buyUnitAction(unitName, count));
};
var units = exports.units = {
  buyAction: buyUnitAction,
  pushBuy: function pushBuy(charId, unitName, count) {
    return Actions.push(charId, buyUnitAction(unitName, count));
  },
  isVisible: unitsIsVisible,
  isNotVisible: _lodash2.default.negate(unitsIsVisible),

  updatedAt: withLocalState(UnitsUpdatedAt.get),
  sinceUpdated: withLocalState(UnitsUpdatedAt.sinceUpdated),
  costEach: withLocalState(Units.costEach),

  clicks: withLocalState(UnitsStats.clicks),
  firstAt: withLocalState(UnitsStats.firstAt),
  sinceFirst: withLocalState(UnitsStats.sinceFirst),
  firstElapsed: withLocalState(UnitsStats.firstElapsed),
  bought: withLocalState(UnitsStats.bought),
  spent: withLocalState(UnitsStats.spent),
  looted: withLocalState(UnitsStats.looted),
  rawCount: withLocalState(UnitsStats.rawCount),
  grown: withLocalState(UnitsStats.grown),

  count: withLocalState(UnitsReify.count),
  velocity: withLocalState(UnitsReify.velocity),
  prodEach: withLocalState(UnitsReify.prodEach),
  prodTotal: withLocalState(UnitsReify.prodTotal),

  visibleNames: withLocalState(UnitsVisible.visibleNames),
  visibleMeatNames: withLocalState(UnitsVisible.visibleMeatNames),
  visibleCombatNames: withLocalState(UnitsVisible.visibleCombatNames),
  maxBuyable: withLocalState(UnitsMaxBuyable.maxBuyable)
};
var prodMultis = exports.prodMultis = {
  hatcheryPerZone: withLocalState(ProdMultis.hatcheryPerZone),
  hatchery: withLocalState(ProdMultis.hatchery)
};

var rankings = exports.rankings = {
  names: RankingsUpdate.names, // TODO this is out of place; not dependent on character
  update: withLocalState(RankingsUpdate.update),
  delete_: withLocalState(RankingsUpdate.delete_)
};

var zones = exports.zones = {
  visibleNames: withLocalState(Zones.visibleNames),
  clearedNames: withLocalState(Zones.clearedNames),
  totalWins: withLocalState(Zones.totalWins),
  totalLosses: withLocalState(Zones.totalLosses),
  totalDraws: withLocalState(Zones.totalDraws),
  totalClears: withLocalState(Zones.totalClears),
  totalFights: withLocalState(Zones.totalFights),

  entryWins: withLocalState(Zones.entryWins),
  entryLosses: withLocalState(Zones.entryLosses),
  entryDraws: withLocalState(Zones.entryDraws),
  entryFights: withLocalState(Zones.entryFights),
  isEntryCleared: withLocalState(Zones.isEntryCleared)
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.create = create;
exports.delete_ = delete_;
exports.createWithUser = createWithUser;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _firebase = __webpack_require__(154);

var _firebase2 = _interopRequireDefault(_firebase);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _create(props) {
  var userId = props.userId,
      charId = props.charId,
      _props$displayName = props.displayName,
      displayName = _props$displayName === undefined ? undefined : _props$displayName,
      _props$league = props.league,
      league = _props$league === undefined ? undefined : _props$league;

  var updates = {};
  updates["/characters/" + charId] = _extends({
    user: userId,
    createdAt: _firebase2.default.database.ServerValue.TIMESTAMP
  }, displayName ? { displayName: displayName } : {}, league ? { league: league } : {});
  //updates['/users/'+user+'/characters/'+charId] = true
  return updates;
}
function _createUser(props) {
  var userId = props.userId;

  var updates = {};
  updates["/users/" + userId] = {
    createdAt: _firebase2.default.database.ServerValue.TIMESTAMP
  };
  return updates;
}

function create(props) {
  var displayName = props.displayName,
      league = props.league;

  return function (dispatch, getState, _ref) {
    var getFirebase = _ref.getFirebase;

    var userId = Auth.user.id(getState(), {});
    var firebase = getFirebase();
    var charId = firebase.push("/characters").key;
    var update = _create({ charId: charId, userId: userId, displayName: displayName, league: league });
    return Util.dispatchPromise("characters/create", dispatch, firebase.update("/", update), { charId: charId, update: update });
  };
}

function delete_(charId) {
  return function (dispatch, getState, _ref2) {
    var getFirebase = _ref2.getFirebase;

    var setpath = "/characters/" + charId;
    return Util.dispatchPromise("characters/delete", dispatch, getFirebase().set(setpath, null), { setpath: setpath });
  };
}

function createWithUser() {
  return function (dispatch, getState, _ref3) {
    var getFirebase = _ref3.getFirebase;

    var userId = Auth.user.id(getState(), {});
    var firebase = getFirebase();
    var charId = firebase.push("/characters").key;
    var update = _extends({}, _create({ charId: charId, userId: userId }), _createUser({ userId: userId }));
    return Util.dispatchPromise("characters/createWithUser", dispatch, firebase.update("/", update), { userId: userId, charId: charId, update: update });
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY3JlYXRlLmpzIl0sIm5hbWVzIjpbImNyZWF0ZSIsImRlbGV0ZV8iLCJjcmVhdGVXaXRoVXNlciIsIlV0aWwiLCJBdXRoIiwiX2NyZWF0ZSIsInByb3BzIiwidXNlcklkIiwiY2hhcklkIiwiZGlzcGxheU5hbWUiLCJ1bmRlZmluZWQiLCJsZWFndWUiLCJ1cGRhdGVzIiwidXNlciIsImNyZWF0ZWRBdCIsImRhdGFiYXNlIiwiU2VydmVyVmFsdWUiLCJUSU1FU1RBTVAiLCJfY3JlYXRlVXNlciIsImRpc3BhdGNoIiwiZ2V0U3RhdGUiLCJnZXRGaXJlYmFzZSIsImlkIiwiZmlyZWJhc2UiLCJwdXNoIiwia2V5IiwidXBkYXRlIiwiZGlzcGF0Y2hQcm9taXNlIiwic2V0cGF0aCIsInNldCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7UUErQmdCQSxNLEdBQUFBLE07UUFnQkFDLE8sR0FBQUEsTztRQVlBQyxjLEdBQUFBLGM7O0FBMURoQjs7SUFBWUMsSTs7QUFDWjs7OztBQUNBOztJQUFZQyxJOzs7Ozs7QUFFWixTQUFTQyxPQUFULENBQWlCQyxLQUFqQixFQUtHO0FBQUEsTUFDTUMsTUFETixHQUNxRUQsS0FEckUsQ0FDTUMsTUFETjtBQUFBLE1BQ2NDLE1BRGQsR0FDcUVGLEtBRHJFLENBQ2NFLE1BRGQ7QUFBQSwyQkFDcUVGLEtBRHJFLENBQ3NCRyxXQUR0QjtBQUFBLE1BQ3NCQSxXQUR0QixzQ0FDb0NDLFNBRHBDO0FBQUEsc0JBQ3FFSixLQURyRSxDQUMrQ0ssTUFEL0M7QUFBQSxNQUMrQ0EsTUFEL0MsaUNBQ3dERCxTQUR4RDs7QUFFRCxNQUFNRSxVQUFVLEVBQWhCO0FBQ0FBLFVBQVEsaUJBQWlCSixNQUF6QjtBQUNFSyxVQUFNTixNQURSO0FBRUVPLGVBQVcsbUJBQVNDLFFBQVQsQ0FBa0JDLFdBQWxCLENBQThCQztBQUYzQyxLQUdNUixjQUFjLEVBQUNBLHdCQUFELEVBQWQsR0FBOEIsRUFIcEMsRUFJTUUsU0FBUyxFQUFDQSxjQUFELEVBQVQsR0FBb0IsRUFKMUI7QUFNQTtBQUNBLFNBQU9DLE9BQVA7QUFDRDtBQUNELFNBQVNNLFdBQVQsQ0FBcUJaLEtBQXJCLEVBQThDO0FBQUEsTUFDckNDLE1BRHFDLEdBQzNCRCxLQUQyQixDQUNyQ0MsTUFEcUM7O0FBRTVDLE1BQU1LLFVBQVUsRUFBaEI7QUFDQUEsVUFBUSxZQUFZTCxNQUFwQixJQUE4QjtBQUM1Qk8sZUFBVyxtQkFBU0MsUUFBVCxDQUFrQkMsV0FBbEIsQ0FBOEJDO0FBRGIsR0FBOUI7QUFHQSxTQUFPTCxPQUFQO0FBQ0Q7O0FBRU0sU0FBU1osTUFBVCxDQUFnQk0sS0FBaEIsRUFBOEQ7QUFBQSxNQUM1REcsV0FENEQsR0FDckNILEtBRHFDLENBQzVERyxXQUQ0RDtBQUFBLE1BQy9DRSxNQUQrQyxHQUNyQ0wsS0FEcUMsQ0FDL0NLLE1BRCtDOztBQUVuRSxTQUFRLFVBQUNRLFFBQUQsRUFBV0MsUUFBWCxRQUF1QztBQUFBLFFBQWpCQyxXQUFpQixRQUFqQkEsV0FBaUI7O0FBQzdDLFFBQU1kLFNBQVNILEtBQUtTLElBQUwsQ0FBVVMsRUFBVixDQUFhRixVQUFiLEVBQXlCLEVBQXpCLENBQWY7QUFDQSxRQUFNRyxXQUFXRixhQUFqQjtBQUNBLFFBQU1iLFNBQVNlLFNBQVNDLElBQVQsQ0FBYyxhQUFkLEVBQTZCQyxHQUE1QztBQUNBLFFBQU1DLFNBQVNyQixRQUFRLEVBQUNHLGNBQUQsRUFBU0QsY0FBVCxFQUFpQkUsd0JBQWpCLEVBQThCRSxjQUE5QixFQUFSLENBQWY7QUFDQSxXQUFPUixLQUFLd0IsZUFBTCxDQUNMLG1CQURLLEVBRUxSLFFBRkssRUFHTEksU0FBU0csTUFBVCxDQUFnQixHQUFoQixFQUFxQkEsTUFBckIsQ0FISyxFQUlMLEVBQUNsQixjQUFELEVBQVNrQixjQUFULEVBSkssQ0FBUDtBQU1ELEdBWEQ7QUFZRDs7QUFFTSxTQUFTekIsT0FBVCxDQUFpQk8sTUFBakIsRUFBaUM7QUFDdEMsU0FBUSxVQUFDVyxRQUFELEVBQVdDLFFBQVgsU0FBdUM7QUFBQSxRQUFqQkMsV0FBaUIsU0FBakJBLFdBQWlCOztBQUM3QyxRQUFNTyxVQUFVLGlCQUFpQnBCLE1BQWpDO0FBQ0EsV0FBT0wsS0FBS3dCLGVBQUwsQ0FDTCxtQkFESyxFQUVMUixRQUZLLEVBR0xFLGNBQWNRLEdBQWQsQ0FBa0JELE9BQWxCLEVBQTJCLElBQTNCLENBSEssRUFJTCxFQUFDQSxnQkFBRCxFQUpLLENBQVA7QUFNRCxHQVJEO0FBU0Q7O0FBRU0sU0FBUzFCLGNBQVQsR0FBMEI7QUFDL0IsU0FBUSxVQUFDaUIsUUFBRCxFQUFXQyxRQUFYLFNBQXVDO0FBQUEsUUFBakJDLFdBQWlCLFNBQWpCQSxXQUFpQjs7QUFDN0MsUUFBTWQsU0FBU0gsS0FBS1MsSUFBTCxDQUFVUyxFQUFWLENBQWFGLFVBQWIsRUFBeUIsRUFBekIsQ0FBZjtBQUNBLFFBQU1HLFdBQVdGLGFBQWpCO0FBQ0EsUUFBTWIsU0FBU2UsU0FBU0MsSUFBVCxDQUFjLGFBQWQsRUFBNkJDLEdBQTVDO0FBQ0EsUUFBTUMsc0JBQ0RyQixRQUFRLEVBQUNHLGNBQUQsRUFBU0QsY0FBVCxFQUFSLENBREMsRUFFRFcsWUFBWSxFQUFDWCxjQUFELEVBQVosQ0FGQyxDQUFOO0FBSUEsV0FBT0osS0FBS3dCLGVBQUwsQ0FDTCwyQkFESyxFQUVMUixRQUZLLEVBR0xJLFNBQVNHLE1BQVQsQ0FBZ0IsR0FBaEIsRUFBcUJBLE1BQXJCLENBSEssRUFJTCxFQUFDbkIsY0FBRCxFQUFTQyxjQUFULEVBQWlCa0IsY0FBakIsRUFKSyxDQUFQO0FBTUQsR0FkRDtBQWVEIiwiZmlsZSI6ImNyZWF0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi91dGlsXCJcbmltcG9ydCBmaXJlYmFzZSBmcm9tIFwiZmlyZWJhc2VcIlxuaW1wb3J0ICogYXMgQXV0aCBmcm9tIFwiLi4vYXV0aFwiXG5cbmZ1bmN0aW9uIF9jcmVhdGUocHJvcHM6IHtcbiAgdXNlcklkOiBzdHJpbmcsXG4gIGNoYXJJZDogc3RyaW5nLFxuICBkaXNwbGF5TmFtZT86IHN0cmluZyxcbiAgbGVhZ3VlPzogc3RyaW5nLFxufSkge1xuICBjb25zdCB7dXNlcklkLCBjaGFySWQsIGRpc3BsYXlOYW1lID0gdW5kZWZpbmVkLCBsZWFndWUgPSB1bmRlZmluZWR9ID0gcHJvcHNcbiAgY29uc3QgdXBkYXRlcyA9IHt9XG4gIHVwZGF0ZXNbXCIvY2hhcmFjdGVycy9cIiArIGNoYXJJZF0gPSB7XG4gICAgdXNlcjogdXNlcklkLFxuICAgIGNyZWF0ZWRBdDogZmlyZWJhc2UuZGF0YWJhc2UuU2VydmVyVmFsdWUuVElNRVNUQU1QLFxuICAgIC4uLihkaXNwbGF5TmFtZSA/IHtkaXNwbGF5TmFtZX0gOiB7fSksXG4gICAgLi4uKGxlYWd1ZSA/IHtsZWFndWV9IDoge30pLFxuICB9XG4gIC8vdXBkYXRlc1snL3VzZXJzLycrdXNlcisnL2NoYXJhY3RlcnMvJytjaGFySWRdID0gdHJ1ZVxuICByZXR1cm4gdXBkYXRlc1xufVxuZnVuY3Rpb24gX2NyZWF0ZVVzZXIocHJvcHM6IHt1c2VySWQ6IHN0cmluZ30pIHtcbiAgY29uc3Qge3VzZXJJZH0gPSBwcm9wc1xuICBjb25zdCB1cGRhdGVzID0ge31cbiAgdXBkYXRlc1tcIi91c2Vycy9cIiArIHVzZXJJZF0gPSB7XG4gICAgY3JlYXRlZEF0OiBmaXJlYmFzZS5kYXRhYmFzZS5TZXJ2ZXJWYWx1ZS5USU1FU1RBTVAsXG4gIH1cbiAgcmV0dXJuIHVwZGF0ZXNcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGNyZWF0ZShwcm9wczoge2Rpc3BsYXlOYW1lOiBzdHJpbmcsIGxlYWd1ZTogc3RyaW5nfSkge1xuICBjb25zdCB7ZGlzcGxheU5hbWUsIGxlYWd1ZX0gPSBwcm9wc1xuICByZXR1cm4gKChkaXNwYXRjaCwgZ2V0U3RhdGUsIHtnZXRGaXJlYmFzZX0pID0+IHtcbiAgICBjb25zdCB1c2VySWQgPSBBdXRoLnVzZXIuaWQoZ2V0U3RhdGUoKSwge30pXG4gICAgY29uc3QgZmlyZWJhc2UgPSBnZXRGaXJlYmFzZSgpXG4gICAgY29uc3QgY2hhcklkID0gZmlyZWJhc2UucHVzaChcIi9jaGFyYWN0ZXJzXCIpLmtleVxuICAgIGNvbnN0IHVwZGF0ZSA9IF9jcmVhdGUoe2NoYXJJZCwgdXNlcklkLCBkaXNwbGF5TmFtZSwgbGVhZ3VlfSlcbiAgICByZXR1cm4gVXRpbC5kaXNwYXRjaFByb21pc2UoXG4gICAgICBcImNoYXJhY3RlcnMvY3JlYXRlXCIsXG4gICAgICBkaXNwYXRjaCxcbiAgICAgIGZpcmViYXNlLnVwZGF0ZShcIi9cIiwgdXBkYXRlKSxcbiAgICAgIHtjaGFySWQsIHVwZGF0ZX0sXG4gICAgKVxuICB9OiBVdGlsLkFjdGlvbkRpc3BhdGNoZXIpXG59XG5cbmV4cG9ydCBmdW5jdGlvbiBkZWxldGVfKGNoYXJJZDogc3RyaW5nKSB7XG4gIHJldHVybiAoKGRpc3BhdGNoLCBnZXRTdGF0ZSwge2dldEZpcmViYXNlfSkgPT4ge1xuICAgIGNvbnN0IHNldHBhdGggPSBcIi9jaGFyYWN0ZXJzL1wiICsgY2hhcklkXG4gICAgcmV0dXJuIFV0aWwuZGlzcGF0Y2hQcm9taXNlKFxuICAgICAgXCJjaGFyYWN0ZXJzL2RlbGV0ZVwiLFxuICAgICAgZGlzcGF0Y2gsXG4gICAgICBnZXRGaXJlYmFzZSgpLnNldChzZXRwYXRoLCBudWxsKSxcbiAgICAgIHtzZXRwYXRofSxcbiAgICApXG4gIH06IFV0aWwuQWN0aW9uRGlzcGF0Y2hlcilcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGNyZWF0ZVdpdGhVc2VyKCkge1xuICByZXR1cm4gKChkaXNwYXRjaCwgZ2V0U3RhdGUsIHtnZXRGaXJlYmFzZX0pID0+IHtcbiAgICBjb25zdCB1c2VySWQgPSBBdXRoLnVzZXIuaWQoZ2V0U3RhdGUoKSwge30pXG4gICAgY29uc3QgZmlyZWJhc2UgPSBnZXRGaXJlYmFzZSgpXG4gICAgY29uc3QgY2hhcklkID0gZmlyZWJhc2UucHVzaChcIi9jaGFyYWN0ZXJzXCIpLmtleVxuICAgIGNvbnN0IHVwZGF0ZSA9IHtcbiAgICAgIC4uLl9jcmVhdGUoe2NoYXJJZCwgdXNlcklkfSksXG4gICAgICAuLi5fY3JlYXRlVXNlcih7dXNlcklkfSksXG4gICAgfVxuICAgIHJldHVybiBVdGlsLmRpc3BhdGNoUHJvbWlzZShcbiAgICAgIFwiY2hhcmFjdGVycy9jcmVhdGVXaXRoVXNlclwiLFxuICAgICAgZGlzcGF0Y2gsXG4gICAgICBmaXJlYmFzZS51cGRhdGUoXCIvXCIsIHVwZGF0ZSksXG4gICAgICB7dXNlcklkLCBjaGFySWQsIHVwZGF0ZX0sXG4gICAgKVxuICB9OiBVdGlsLkFjdGlvbkRpc3BhdGNoZXIpXG59XG4iXX0=

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = backfill;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _updatedAt = __webpack_require__(219);

var UnitsUpdatedAt = _interopRequireWildcard(_updatedAt);

var _lastActionAt = __webpack_require__(109);

var LastActionAt = _interopRequireWildcard(_lastActionAt);

var _combat = __webpack_require__(92);

var CombatMain = _interopRequireWildcard(_combat);

var _raw = __webpack_require__(45);

var CombatRaw = _interopRequireWildcard(_raw);

var _init = __webpack_require__(360);

var CombatInit = _interopRequireWildcard(_init);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// combat.init.params is a new field. Fill it in if it's missing.
var backfillCombatInitParams = function backfillCombatInitParams(root, props) {
  var character = props.character;

  if (!character.combat || !!character.combat.init.params) return character;
  // confirmed that combat exists, but combat.init.params doesn't.
  var _character$combat$ini = character.combat.init.event,
      fixedNow = _character$combat$ini.createdAt,
      zone = _character$combat$ini.zone;

  return _extends({}, character, {
    combat: _extends({}, character.combat, {
      init: _extends({}, character.combat.init, {
        params: CombatInit.lootParams(root, _extends({}, props, { fixedNow: fixedNow, zone: zone }))
      })
    })
  });
};

// lastActionAt is a new field. Cobble it together from existing fields.
// This doesn't include rename action timing, or possibly other newer actions.
var combatCreatedAt = function combatCreatedAt(root, props) {
  return CombatRaw.isNotEmpty(root, props) ? CombatMain.createdAt(root, props) : LastActionAt.createdAt(root, props);
};
var legacyLastActionAt = (0, _reselect.createSelector)(UnitsUpdatedAt.get, combatCreatedAt, Util.Timestamp.max);
function backfillLastActionAt(root, props) {
  var character = props.character;
  if (character.lastActionAt) return character;
  var createdAt = LastActionAt.createdAt(root, props);
  var legacy = legacyLastActionAt(root, props);
  return legacy === createdAt ? character : _extends({}, character, { lastActionAt: Util.Timestamp.unwrap(legacy) });
}

// Reducer to update old character structures. Run once, immediately after
// loading, before any other actions.
function backfill(character, action) {
  var root = action.root;

  character = backfillLastActionAt(root, { character: character });
  character = _lodash2.default.omit(character, ["combatResult"]); // no longer used
  character = backfillCombatInitParams(root, { character: character });
  return character;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYmFja2ZpbGwuanMiXSwibmFtZXMiOlsiYmFja2ZpbGwiLCJVdGlsIiwiVW5pdHNVcGRhdGVkQXQiLCJMYXN0QWN0aW9uQXQiLCJDb21iYXRNYWluIiwiQ29tYmF0UmF3IiwiQ29tYmF0SW5pdCIsImJhY2tmaWxsQ29tYmF0SW5pdFBhcmFtcyIsInJvb3QiLCJwcm9wcyIsImNoYXJhY3RlciIsImNvbWJhdCIsImluaXQiLCJwYXJhbXMiLCJldmVudCIsImZpeGVkTm93IiwiY3JlYXRlZEF0Iiwiem9uZSIsImxvb3RQYXJhbXMiLCJjb21iYXRDcmVhdGVkQXQiLCJpc05vdEVtcHR5IiwibGVnYWN5TGFzdEFjdGlvbkF0IiwiZ2V0IiwiVGltZXN0YW1wIiwibWF4IiwiYmFja2ZpbGxMYXN0QWN0aW9uQXQiLCJsYXN0QWN0aW9uQXQiLCJsZWdhY3kiLCJ1bndyYXAiLCJhY3Rpb24iLCJvbWl0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztrQkFxRHdCQSxROztBQXBEeEI7O0FBQ0E7Ozs7QUFHQTs7SUFBWUMsSTs7QUFDWjs7SUFBWUMsYzs7QUFDWjs7SUFBWUMsWTs7QUFDWjs7SUFBWUMsVTs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsVTs7Ozs7O0FBRVo7QUFDQSxJQUFNQywyQkFBMkIsU0FBM0JBLHdCQUEyQixDQUFDQyxJQUFELEVBQU9DLEtBQVAsRUFBaUI7QUFBQSxNQUN6Q0MsU0FEeUMsR0FDNUJELEtBRDRCLENBQ3pDQyxTQUR5Qzs7QUFFaEQsTUFBSSxDQUFDQSxVQUFVQyxNQUFYLElBQXFCLENBQUMsQ0FBQ0QsVUFBVUMsTUFBVixDQUFpQkMsSUFBakIsQ0FBc0JDLE1BQWpELEVBQXlELE9BQU9ILFNBQVA7QUFDekQ7QUFIZ0QsOEJBSVpBLFVBQVVDLE1BQVYsQ0FBaUJDLElBQWpCLENBQXNCRSxLQUpWO0FBQUEsTUFJOUJDLFFBSjhCLHlCQUl6Q0MsU0FKeUM7QUFBQSxNQUlwQkMsSUFKb0IseUJBSXBCQSxJQUpvQjs7QUFLaEQsc0JBQ0tQLFNBREw7QUFFRUMseUJBQ0tELFVBQVVDLE1BRGY7QUFFRUMseUJBQ0tGLFVBQVVDLE1BQVYsQ0FBaUJDLElBRHRCO0FBRUVDLGdCQUFRUCxXQUFXWSxVQUFYLENBQXNCVixJQUF0QixlQUFnQ0MsS0FBaEMsSUFBdUNNLGtCQUF2QyxFQUFpREUsVUFBakQ7QUFGVjtBQUZGO0FBRkY7QUFVRCxDQWZEOztBQWlCQTtBQUNBO0FBQ0EsSUFBTUUsa0JBQWtCLFNBQWxCQSxlQUFrQixDQUFDWCxJQUFELEVBQU9DLEtBQVA7QUFBQSxTQUN0QkosVUFBVWUsVUFBVixDQUFxQlosSUFBckIsRUFBMkJDLEtBQTNCLElBQ0lMLFdBQVdZLFNBQVgsQ0FBcUJSLElBQXJCLEVBQTJCQyxLQUEzQixDQURKLEdBRUlOLGFBQWFhLFNBQWIsQ0FBdUJSLElBQXZCLEVBQTZCQyxLQUE3QixDQUhrQjtBQUFBLENBQXhCO0FBSUEsSUFBTVkscUJBQXFCLDhCQUN6Qm5CLGVBQWVvQixHQURVLEVBRXpCSCxlQUZ5QixFQUd6QmxCLEtBQUtzQixTQUFMLENBQWVDLEdBSFUsQ0FBM0I7QUFLQSxTQUFTQyxvQkFBVCxDQUE4QmpCLElBQTlCLEVBQW9DQyxLQUFwQyxFQUEyQztBQUN6QyxNQUFNQyxZQUFZRCxNQUFNQyxTQUF4QjtBQUNBLE1BQUlBLFVBQVVnQixZQUFkLEVBQTRCLE9BQU9oQixTQUFQO0FBQzVCLE1BQU1NLFlBQVliLGFBQWFhLFNBQWIsQ0FBdUJSLElBQXZCLEVBQTZCQyxLQUE3QixDQUFsQjtBQUNBLE1BQU1rQixTQUFTTixtQkFBbUJiLElBQW5CLEVBQXlCQyxLQUF6QixDQUFmO0FBQ0EsU0FBT2tCLFdBQVdYLFNBQVgsR0FDSE4sU0FERyxnQkFFQ0EsU0FGRCxJQUVZZ0IsY0FBY3pCLEtBQUtzQixTQUFMLENBQWVLLE1BQWYsQ0FBc0JELE1BQXRCLENBRjFCLEdBQVA7QUFHRDs7QUFFRDtBQUNBO0FBQ2UsU0FBUzNCLFFBQVQsQ0FBa0JVLFNBQWxCLEVBQW9DbUIsTUFBcEMsRUFBZ0U7QUFBQSxNQUN0RXJCLElBRHNFLEdBQzlEcUIsTUFEOEQsQ0FDdEVyQixJQURzRTs7QUFFN0VFLGNBQVllLHFCQUFxQmpCLElBQXJCLEVBQTJCLEVBQUNFLG9CQUFELEVBQTNCLENBQVo7QUFDQUEsY0FBWSxpQkFBRW9CLElBQUYsQ0FBT3BCLFNBQVAsRUFBa0IsQ0FBQyxjQUFELENBQWxCLENBQVosQ0FINkUsQ0FHN0I7QUFDaERBLGNBQVlILHlCQUF5QkMsSUFBekIsRUFBK0IsRUFBQ0Usb0JBQUQsRUFBL0IsQ0FBWjtBQUNBLFNBQU9BLFNBQVA7QUFDRCIsImZpbGUiOiJiYWNrZmlsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgdHlwZSB7U3RhdGV9IGZyb20gXCIuL3Jhd1wiXG5pbXBvcnQgdHlwZSB7RmFuY3lBY3Rpb259IGZyb20gXCIuL2FjdGlvbi1iYXNlXCJcbmltcG9ydCAqIGFzIFV0aWwgZnJvbSBcIi4uLy4uL3V0aWxcIlxuaW1wb3J0ICogYXMgVW5pdHNVcGRhdGVkQXQgZnJvbSBcIi4vdW5pdHMvdXBkYXRlZC1hdFwiXG5pbXBvcnQgKiBhcyBMYXN0QWN0aW9uQXQgZnJvbSBcIi4vbGFzdC1hY3Rpb24tYXRcIlxuaW1wb3J0ICogYXMgQ29tYmF0TWFpbiBmcm9tIFwiLi9jb21iYXQvY29tYmF0XCJcbmltcG9ydCAqIGFzIENvbWJhdFJhdyBmcm9tIFwiLi9jb21iYXQvcmF3XCJcbmltcG9ydCAqIGFzIENvbWJhdEluaXQgZnJvbSBcIi4vY29tYmF0L2luaXRcIlxuXG4vLyBjb21iYXQuaW5pdC5wYXJhbXMgaXMgYSBuZXcgZmllbGQuIEZpbGwgaXQgaW4gaWYgaXQncyBtaXNzaW5nLlxuY29uc3QgYmFja2ZpbGxDb21iYXRJbml0UGFyYW1zID0gKHJvb3QsIHByb3BzKSA9PiB7XG4gIGNvbnN0IHtjaGFyYWN0ZXJ9ID0gcHJvcHNcbiAgaWYgKCFjaGFyYWN0ZXIuY29tYmF0IHx8ICEhY2hhcmFjdGVyLmNvbWJhdC5pbml0LnBhcmFtcykgcmV0dXJuIGNoYXJhY3RlclxuICAvLyBjb25maXJtZWQgdGhhdCBjb21iYXQgZXhpc3RzLCBidXQgY29tYmF0LmluaXQucGFyYW1zIGRvZXNuJ3QuXG4gIGNvbnN0IHtjcmVhdGVkQXQ6IGZpeGVkTm93LCB6b25lfSA9IGNoYXJhY3Rlci5jb21iYXQuaW5pdC5ldmVudFxuICByZXR1cm4ge1xuICAgIC4uLmNoYXJhY3RlcixcbiAgICBjb21iYXQ6IHtcbiAgICAgIC4uLmNoYXJhY3Rlci5jb21iYXQsXG4gICAgICBpbml0OiB7XG4gICAgICAgIC4uLmNoYXJhY3Rlci5jb21iYXQuaW5pdCxcbiAgICAgICAgcGFyYW1zOiBDb21iYXRJbml0Lmxvb3RQYXJhbXMocm9vdCwgey4uLnByb3BzLCBmaXhlZE5vdywgem9uZX0pLFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59XG5cbi8vIGxhc3RBY3Rpb25BdCBpcyBhIG5ldyBmaWVsZC4gQ29iYmxlIGl0IHRvZ2V0aGVyIGZyb20gZXhpc3RpbmcgZmllbGRzLlxuLy8gVGhpcyBkb2Vzbid0IGluY2x1ZGUgcmVuYW1lIGFjdGlvbiB0aW1pbmcsIG9yIHBvc3NpYmx5IG90aGVyIG5ld2VyIGFjdGlvbnMuXG5jb25zdCBjb21iYXRDcmVhdGVkQXQgPSAocm9vdCwgcHJvcHMpID0+XG4gIENvbWJhdFJhdy5pc05vdEVtcHR5KHJvb3QsIHByb3BzKVxuICAgID8gQ29tYmF0TWFpbi5jcmVhdGVkQXQocm9vdCwgcHJvcHMpXG4gICAgOiBMYXN0QWN0aW9uQXQuY3JlYXRlZEF0KHJvb3QsIHByb3BzKVxuY29uc3QgbGVnYWN5TGFzdEFjdGlvbkF0ID0gY3JlYXRlU2VsZWN0b3IoXG4gIFVuaXRzVXBkYXRlZEF0LmdldCxcbiAgY29tYmF0Q3JlYXRlZEF0LFxuICBVdGlsLlRpbWVzdGFtcC5tYXgsXG4pXG5mdW5jdGlvbiBiYWNrZmlsbExhc3RBY3Rpb25BdChyb290LCBwcm9wcykge1xuICBjb25zdCBjaGFyYWN0ZXIgPSBwcm9wcy5jaGFyYWN0ZXJcbiAgaWYgKGNoYXJhY3Rlci5sYXN0QWN0aW9uQXQpIHJldHVybiBjaGFyYWN0ZXJcbiAgY29uc3QgY3JlYXRlZEF0ID0gTGFzdEFjdGlvbkF0LmNyZWF0ZWRBdChyb290LCBwcm9wcylcbiAgY29uc3QgbGVnYWN5ID0gbGVnYWN5TGFzdEFjdGlvbkF0KHJvb3QsIHByb3BzKVxuICByZXR1cm4gbGVnYWN5ID09PSBjcmVhdGVkQXRcbiAgICA/IGNoYXJhY3RlclxuICAgIDogey4uLmNoYXJhY3RlciwgbGFzdEFjdGlvbkF0OiBVdGlsLlRpbWVzdGFtcC51bndyYXAobGVnYWN5KX1cbn1cblxuLy8gUmVkdWNlciB0byB1cGRhdGUgb2xkIGNoYXJhY3RlciBzdHJ1Y3R1cmVzLiBSdW4gb25jZSwgaW1tZWRpYXRlbHkgYWZ0ZXJcbi8vIGxvYWRpbmcsIGJlZm9yZSBhbnkgb3RoZXIgYWN0aW9ucy5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGJhY2tmaWxsKGNoYXJhY3RlcjogU3RhdGUsIGFjdGlvbjogRmFuY3lBY3Rpb24pOiBTdGF0ZSB7XG4gIGNvbnN0IHtyb290fSA9IGFjdGlvblxuICBjaGFyYWN0ZXIgPSBiYWNrZmlsbExhc3RBY3Rpb25BdChyb290LCB7Y2hhcmFjdGVyfSlcbiAgY2hhcmFjdGVyID0gXy5vbWl0KGNoYXJhY3RlciwgW1wiY29tYmF0UmVzdWx0XCJdKSAvLyBubyBsb25nZXIgdXNlZFxuICBjaGFyYWN0ZXIgPSBiYWNrZmlsbENvbWJhdEluaXRQYXJhbXMocm9vdCwge2NoYXJhY3Rlcn0pXG4gIHJldHVybiBjaGFyYWN0ZXJcbn1cbiJdfQ==

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupNamesSelector = exports.relatedNames = exports.isProducible = exports.isBuyable = exports.costParents = exports.costChildren = exports.prodParents = exports.prodChildren = exports.cost = exports.prod = exports.initCount = exports.group = exports.isValidName = exports.initCounts = exports.costs = exports.prods = exports.byName = exports.names = exports.localState = exports.Decimal = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

var _json = __webpack_require__(778);

var _json2 = _interopRequireDefault(_json);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.Decimal = _decimal2.default;
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _json2.default;

  return state;
}

var localState = exports.localState = function localState(state) {
  return state.entities2.unitTypes;
};

var names = exports.names = (0, _reselect.createSelector)(localState, _fp2.default.map("name"));
var byName = exports.byName = (0, _reselect.createSelector)(localState, _fp2.default.keyBy("name"));
var prods = exports.prods = (0, _reselect.createSelector)(byName, _fp2.default.flow(_fp2.default.mapValues(function (s) {
  return s.prod || {};
}), _fp2.default.mapValues(_fp2.default.mapValues(_decimal2.default))));
var costs = exports.costs = (0, _reselect.createSelector)(byName, _fp2.default.flow(_fp2.default.mapValues(function (s) {
  return s.cost || {};
}), _fp2.default.mapValues(_fp2.default.mapValues(_decimal2.default))));
var initCounts = exports.initCounts = (0, _reselect.createSelector)(byName, _fp2.default.mapValues(_fp2.default.flow(_fp2.default.getOr(0, "init"), _decimal2.default)));

var name = function name(s, p) {
  return p.unitName;
};
var entry = (0, _reselect.createSelector)(name, byName, _fp2.default.get);
var isValidName = exports.isValidName = (0, _reselect.createSelector)(entry, function (s) {
  return !!s;
});
var group = exports.group = (0, _reselect.createSelector)(entry, function (s) {
  return s.group;
});
var initCount = exports.initCount = (0, _reselect.createSelector)(name, initCounts, _fp2.default.get);
var prod = exports.prod = (0, _reselect.createSelector)(name, prods, _fp2.default.get);
var cost = exports.cost = (0, _reselect.createSelector)(name, costs, _fp2.default.get);

// prod and cost map one unit-type to some other child unit-types. Invert that
// list, so children map back to their parents.
function parentsByChild(childrenByParent) {
  var ret = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _fp2.default.entries(childrenByParent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var _parent = _ref2[0];
      var children = _ref2[1];

      ret[_parent] = ret[_parent] || [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _child = _step2.value;

          ret[_child] = ret[_child] || [];
          ret[_child].push(_parent);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}
var prodChildrenByName = (0, _reselect.createSelector)(prods, _fp2.default.mapValues(_fp2.default.keys));
var prodChildren = exports.prodChildren = (0, _reselect.createSelector)(name, prodChildrenByName, _fp2.default.get);
var prodParentsByName = (0, _reselect.createSelector)(prodChildrenByName, parentsByChild);
var prodParents = exports.prodParents = (0, _reselect.createSelector)(name, prodParentsByName, _fp2.default.get);
var costChildrenByName = (0, _reselect.createSelector)(costs, _fp2.default.mapValues(_fp2.default.keys));
var costChildren = exports.costChildren = (0, _reselect.createSelector)(name, costChildrenByName, _fp2.default.get);
var costParentsByName = (0, _reselect.createSelector)(costChildrenByName, parentsByChild);
var costParents = exports.costParents = (0, _reselect.createSelector)(name, costParentsByName, _fp2.default.get);

var isBuyable = exports.isBuyable = (0, _reselect.createSelector)(cost, _fp2.default.negate(_fp2.default.isEmpty));
var isProducible = exports.isProducible = (0, _reselect.createSelector)(prodParents, _fp2.default.negate(_fp2.default.isEmpty));

var relatedNames = exports.relatedNames = (0, _reselect.createSelector)(prodParents, name, prodChildren, costChildren, function (pp, n, pc, cc) {
  return _fp2.default.uniq([].concat(_toConsumableArray(pp), [n], _toConsumableArray(pc), _toConsumableArray(cc)));
});
var namesByGroup = (0, _reselect.createSelector)(localState, _fp2.default.flow(_fp2.default.groupBy("group"), _fp2.default.mapValues(_fp2.default.map("name"))));
//type SelectGroup<O> = (Util.RootState, {group: string}) => O
//const groupProp: SelectGroup<string> = (s, p) => p.group
//export const groupNames: SelectGroup<string[]> = createSelector(
//  groupProp,
//  namesByGroup,
//  _.get,
//)
var groupNamesSelector = exports.groupNamesSelector = _fp2.default.memoize(function (group) {
  return (0, _reselect.createSelector)(namesByGroup, _fp2.default.get(group));
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "_base",
  group: "_hidden",
  init: "1",
  // 1 per 8 hours
  prod: { _lootGrindToken: "" + 1 / (60 * 60 * 8) }
}, {
  name: "_lootGrindToken",
  group: "_hidden",
  init: "4"
}, {
  name: "nest",
  prod: { queen: "3" },
  cost: { queen: "1e3", larva: "1" },
  group: "meat"
}, {
  name: "queen",
  prod: { drone: "2" },
  cost: { drone: "1e2", larva: "1" },
  group: "meat"
}, {
  name: "drone",
  prod: { meat: "1" },
  cost: { meat: "1e1", larva: "1" },
  group: "meat"
}, {
  name: "meat",
  group: "meat",
  init: "30"
}, {
  name: "larva",
  group: "larva",
  init: "100"
}, {
  name: "hatchery",
  prod: { larva: "1" },
  group: "larva"
}, {
  name: "swarmling-queen",
  group: "combat",
  cost: { meat: "1000" },
  init: "0"
}, {
  name: "overlord-den",
  group: "combat",
  cost: { meat: "1000000" },
  init: "0"
}, {
  name: "tower",
  group: "combat",
  cost: { meat: "1000000" },
  init: "0"
}];
// Why .js, not .json? Because .json files can't have comments, require quoted
// keys, have issues importing in some contexts, and can't be type checked.
//
// order matters here - this is the order of the list on /p/.../units
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.soldierCount = exports.soldierNames = exports.soldiers = exports.level = exports.levelsByName = exports.isValidName = exports.names = exports.localState = undefined;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _json = __webpack_require__(780);

var _json2 = _interopRequireDefault(_json);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _json2.default;

  return state;
}

var localState = exports.localState = function localState(state) {
  return state.entities2.zoneTypes;
};
var names = exports.names = (0, _reselect.createSelector)(localState, _fp2.default.map("name"));

var byName = (0, _reselect.createSelector)(localState, _fp2.default.keyBy("name"));
var nameProp = function nameProp(s, p) {
  return p.zone;
};
var entry = (0, _reselect.createSelector)(byName, nameProp, function (d, k) {
  return d[k];
});
var isValidName = exports.isValidName = (0, _reselect.createSelector)(entry, function (entry) {
  return !!entry;
});
var levelsByName = exports.levelsByName = (0, _reselect.createSelector)(byName, _fp2.default.mapValues("level"));
var level = exports.level = (0, _reselect.createSelector)(entry, function (entry) {
  return entry.level;
});
var soldiers = exports.soldiers = (0, _reselect.createSelector)(entry, function (entry) {
  return entry.soldiers;
});
var soldierNames = exports.soldierNames = (0, _reselect.createSelector)(soldiers, _fp2.default.keys);
var soldierName = function soldierName(s, p) {
  return p.soldierName;
};
var soldierCount = exports.soldierCount = (0, _reselect.createSelector)(soldiers, soldierName, function (ss, n) {
  return ss[n];
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "zone1",
  level: 1,
  soldiers: { "swarmling-queen": 1 }
}, {
  name: "zone2",
  level: 2,
  soldiers: { "swarmling-queen": 1e1 }
}, {
  name: "zone3",
  level: 3,
  soldiers: { "swarmling-queen": 1e3 }
}, {
  name: "zone4",
  level: 4,
  soldiers: { "swarmling-queen": 1e5 }
}, {
  name: "zone5",
  level: 5,
  soldiers: { "swarmling-queen": 1e7 }
}, {
  name: "zone6",
  level: 6,
  soldiers: { "swarmling-queen": 1e7, "overlord-den": 10 }
}, {
  name: "zone7",
  level: 7,
  soldiers: { "swarmling-queen": 1e9, "overlord-den": 1e4 }
}, {
  name: "zone8",
  level: 8,
  soldiers: { "swarmling-queen": 1e11, "overlord-den": 1e6 }
}, {
  name: "zone9",
  level: 9,
  soldiers: { "swarmling-queen": 1e14, "overlord-den": 1e9 }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import * as Overlord from "./overlord"
var TS = Util.Timestamp.wrap;

var TS0 = TS(0);

var ruleset = exports.ruleset = {};
exports.default = [{
  name: "standard",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: TS0,
    openAt: TS0
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3N0YW5kYXJkLmpzIl0sIm5hbWVzIjpbIlV0aWwiLCJUUyIsIlRpbWVzdGFtcCIsIndyYXAiLCJUUzAiLCJydWxlc2V0IiwibmFtZSIsImxpZmVjeWNsZSIsInZpc2libGVBdCIsIm9wZW5BdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxJOzs7O0FBR1o7QUFDQSxJQUFNQyxLQUFLRCxLQUFLRSxTQUFMLENBQWVDLElBQTFCOztBQUNBLElBQU1DLE1BQU1ILEdBQUcsQ0FBSCxDQUFaOztBQUVPLElBQU1JLDRCQUFtQixFQUF6QjtrQkFJUyxDQUNkO0FBQ0VDLFFBQU0sVUFEUjtBQUVFRCxrQkFGRjtBQUdFRSxhQUFXO0FBQ1RDLGVBQVdKLEdBREY7QUFFVEssWUFBUUw7QUFGQztBQUhiLENBRGMsQyIsImZpbGUiOiJzdGFuZGFyZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi8uLi8uLi91dGlsXCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBMZWFndWV9IGZyb20gXCIuLi9yYXdcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIFJ1bGVzZXR9IGZyb20gXCIuLi9ydWxlc2V0c1wiXG4vL2ltcG9ydCAqIGFzIE92ZXJsb3JkIGZyb20gXCIuL292ZXJsb3JkXCJcbmNvbnN0IFRTID0gVXRpbC5UaW1lc3RhbXAud3JhcFxuY29uc3QgVFMwID0gVFMoMClcblxuZXhwb3J0IGNvbnN0IHJ1bGVzZXQ6IFJ1bGVzZXQgPSB7XG4gIC8vdW5sb2NrWm9uZTY6IE92ZXJsb3JkLmNsb3NlZEF0LFxuICAvL3R3aW5NZWF0VXBncmFkZXM6IE92ZXJsb3JkLmNsb3NlZEF0LFxufVxuZXhwb3J0IGRlZmF1bHQgKFtcbiAge1xuICAgIG5hbWU6IFwic3RhbmRhcmRcIixcbiAgICBydWxlc2V0LFxuICAgIGxpZmVjeWNsZToge1xuICAgICAgdmlzaWJsZUF0OiBUUzAsXG4gICAgICBvcGVuQXQ6IFRTMCxcbiAgICB9LFxuICB9LFxuXTogTGVhZ3VlW10pXG4iXX0=

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TS0 = Util.Timestamp.wrap(0);
var ruleset = exports.ruleset = { isVoid: true };
exports.default = [{
  name: "void",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: TS0,
    openAt: TS0
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3ZvaWQuanMiXSwibmFtZXMiOlsiVXRpbCIsIlRTMCIsIlRpbWVzdGFtcCIsIndyYXAiLCJydWxlc2V0IiwiaXNWb2lkIiwibmFtZSIsImxpZmVjeWNsZSIsInZpc2libGVBdCIsIm9wZW5BdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxJOzs7O0FBR1osSUFBTUMsTUFBTUQsS0FBS0UsU0FBTCxDQUFlQyxJQUFmLENBQW9CLENBQXBCLENBQVo7QUFFTyxJQUFNQyw0QkFBbUIsRUFBQ0MsUUFBUSxJQUFULEVBQXpCO2tCQUNTLENBQ2Q7QUFDRUMsUUFBTSxNQURSO0FBRUVGLGtCQUZGO0FBR0VHLGFBQVc7QUFDVEMsZUFBV1AsR0FERjtBQUVUUSxZQUFRUjtBQUZDO0FBSGIsQ0FEYyxDIiwiZmlsZSI6InZvaWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vLi4vLi4vdXRpbFwiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgTGVhZ3VlfSBmcm9tIFwiLi4vcmF3XCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBSdWxlc2V0fSBmcm9tIFwiLi4vcnVsZXNldHNcIlxuY29uc3QgVFMwID0gVXRpbC5UaW1lc3RhbXAud3JhcCgwKVxuXG5leHBvcnQgY29uc3QgcnVsZXNldDogUnVsZXNldCA9IHtpc1ZvaWQ6IHRydWV9XG5leHBvcnQgZGVmYXVsdCAoW1xuICB7XG4gICAgbmFtZTogXCJ2b2lkXCIsXG4gICAgcnVsZXNldCxcbiAgICBsaWZlY3ljbGU6IHtcbiAgICAgIHZpc2libGVBdDogVFMwLFxuICAgICAgb3BlbkF0OiBUUzAsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _overlord = __webpack_require__(362);

var Parent = _interopRequireWildcard(_overlord);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UTC = Util.Timestamp.UTC;
var TS = Util.Timestamp.wrap;
var TS0 = TS(0);

var ruleset = exports.ruleset = Parent.ruleset;
exports.default = [{
  name: "prerelease",
  ruleset: ruleset,
  auth: { role: "prereleaseFlags" },
  lifecycle: {
    //visibleAt: UTC(2017, "dec", 14),
    openAt: UTC(2017, "dec", 14),
    //visibleAt: TS(Date.now() + 5 * 1000),
    //openAt: TS(Date.now() + 500000 * 1000),
    visibleAt: TS0
    //openAt: TS0,
    //closedAt: TS0,
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3ByZXJlbGVhc2UuanMiXSwibmFtZXMiOlsiVXRpbCIsIlBhcmVudCIsIlVUQyIsIlRpbWVzdGFtcCIsIlRTIiwid3JhcCIsIlRTMCIsInJ1bGVzZXQiLCJuYW1lIiwiYXV0aCIsInJvbGUiLCJsaWZlY3ljbGUiLCJvcGVuQXQiLCJ2aXNpYmxlQXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7SUFBWUEsSTs7QUFHWjs7SUFBWUMsTTs7OztBQUNaLElBQU1DLE1BQU1GLEtBQUtHLFNBQUwsQ0FBZUQsR0FBM0I7QUFDQSxJQUFNRSxLQUFLSixLQUFLRyxTQUFMLENBQWVFLElBQTFCO0FBQ0EsSUFBTUMsTUFBTUYsR0FBRyxDQUFILENBQVo7O0FBRU8sSUFBTUcsNEJBQW1CTixPQUFPTSxPQUFoQztrQkFDUyxDQUNkO0FBQ0VDLFFBQU0sWUFEUjtBQUVFRCxrQkFGRjtBQUdFRSxRQUFNLEVBQUNDLE1BQU0saUJBQVAsRUFIUjtBQUlFQyxhQUFXO0FBQ1Q7QUFDQUMsWUFBUVYsSUFBSSxJQUFKLEVBQVUsS0FBVixFQUFpQixFQUFqQixDQUZDO0FBR1Q7QUFDQTtBQUNBVyxlQUFXUDtBQUNYO0FBQ0E7QUFQUztBQUpiLENBRGMsQyIsImZpbGUiOiJwcmVyZWxlYXNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCAqIGFzIFV0aWwgZnJvbSBcIi4uLy4uLy4uLy4uL3V0aWxcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIExlYWd1ZX0gZnJvbSBcIi4uL3Jhd1wiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgUnVsZXNldH0gZnJvbSBcIi4uL3J1bGVzZXRzXCJcbmltcG9ydCAqIGFzIFBhcmVudCBmcm9tIFwiLi9vdmVybG9yZFwiXG5jb25zdCBVVEMgPSBVdGlsLlRpbWVzdGFtcC5VVENcbmNvbnN0IFRTID0gVXRpbC5UaW1lc3RhbXAud3JhcFxuY29uc3QgVFMwID0gVFMoMClcblxuZXhwb3J0IGNvbnN0IHJ1bGVzZXQ6IFJ1bGVzZXQgPSBQYXJlbnQucnVsZXNldFxuZXhwb3J0IGRlZmF1bHQgKFtcbiAge1xuICAgIG5hbWU6IFwicHJlcmVsZWFzZVwiLFxuICAgIHJ1bGVzZXQsXG4gICAgYXV0aDoge3JvbGU6IFwicHJlcmVsZWFzZUZsYWdzXCJ9LFxuICAgIGxpZmVjeWNsZToge1xuICAgICAgLy92aXNpYmxlQXQ6IFVUQygyMDE3LCBcImRlY1wiLCAxNCksXG4gICAgICBvcGVuQXQ6IFVUQygyMDE3LCBcImRlY1wiLCAxNCksXG4gICAgICAvL3Zpc2libGVBdDogVFMoRGF0ZS5ub3coKSArIDUgKiAxMDAwKSxcbiAgICAgIC8vb3BlbkF0OiBUUyhEYXRlLm5vdygpICsgNTAwMDAwICogMTAwMCksXG4gICAgICB2aXNpYmxlQXQ6IFRTMCxcbiAgICAgIC8vb3BlbkF0OiBUUzAsXG4gICAgICAvL2Nsb3NlZEF0OiBUUzAsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.untilOpen = exports.isOpen = exports.migrateToLeague = exports.status = exports.localState = undefined;

var _reselect = __webpack_require__(2);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(157);

var Raw = _interopRequireWildcard(_raw);

var _lifecycle = __webpack_require__(222);

var L = _interopRequireWildcard(_lifecycle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var localState = exports.localState = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.lifecycle;
});
// League visibility, start-date, end-date, and character-migration.
var status = exports.status = (0, _reselect.createSelector)(localState, Now.now, L._status);
var migrateToLeague = exports.migrateToLeague = (0, _reselect.createSelector)((0, _reselect.createSelector)(localState, function (s) {
  return s.migrateToLeague;
}), status, L._migrateToLeague);

var isOpen = exports.isOpen = (0, _reselect.createSelector)(status, function (status) {
  return status === "open";
});
var openAt = (0, _reselect.createSelector)(localState, function (s) {
  return s.openAt;
});
var untilOpen = exports.untilOpen = (0, _reselect.createSelector)(Now.now, openAt, Util.Duration.until);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleNames = undefined;

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _flags = __webpack_require__(363);

var Flags = _interopRequireWildcard(_flags);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _lifecycle = __webpack_require__(222);

var Lifecycle = _interopRequireWildcard(_lifecycle);

var _raw = __webpack_require__(157);

var Raw = _interopRequireWildcard(_raw);

var _list = __webpack_require__(361);

var _list2 = _interopRequireDefault(_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterLifecycleVisible = (0, _reselect.createSelector)(Now.now, function (now) {
  return function (state) {
    var status = Lifecycle._status(state.lifecycle, now);
    return status === "open" || status === "visible";
  };
});
var filterPrerelease = (0, _reselect.createSelector)(Flags.isPrereleaseFlags, function (auth) {
  return function (state) {
    var role = _fp2.default.get("auth.role", state);
    if (!role) return true;
    if (role === "prereleaseFlags") return !!auth;
    return (0, _assert.throws)("unknown league role", role);
  };
});
var filterVoid = function filterVoid(state) {
  return !state.ruleset.isVoid;
};
var filterVisible = (0, _reselect.createSelector)(filterLifecycleVisible, filterPrerelease, function () {
  return filterVoid;
}, function (f1, f2, f3) {
  return function (state) {
    return f1(state) && f2(state) && f3(state);
  };
});

var list = function list() {
  return _list2.default;
};
var filteredList = function filteredList(filter) {
  return (0, _reselect.createSelector)(filter, list, _fp2.default.filter);
};
var visibleList = filteredList(filterVisible);
var visibleNames = exports.visibleNames = (0, _reselect.createSelector)(visibleList, _fp2.default.map("name"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flag = exports.names = exports.byName = exports.releaseCountdown = exports.isPrereleaseFlags = exports.offline = exports.stoptime = exports.freshdesk = exports.logProps = exports.dumpProps = exports.logFirebase = undefined;
exports.branch = branch;

var _criteria = __webpack_require__(364);

var F = _interopRequireWildcard(_criteria);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Client debugging flags, dependent only on the query string.
var logFirebase = exports.logFirebase = F.isQuery("logFirebase", false);
// I know, awful style using a global here, but it's just easier okay

var dumpProps = exports.dumpProps = F.isQuery("dumpProps", !!global.IS_STORYBOOK);
var logProps = exports.logProps = F.isQuery("logProps", false);
var freshdesk = exports.freshdesk = F.isQuery("freshdesk", true);
var stoptime = exports.stoptime = F.isQuery("stoptime", false);
// Unit tests are always offline
var offline = exports.offline =  false ? function (s, p) {
  return true;
} : F.isQuery("offline", false);

// Flags from last release. (all gone)
// Flags for next release.

// Working with groups of flags.
var isPrereleaseFlags = exports.isPrereleaseFlags = F.isPrereleaseFlags;
var releaseCountdown = exports.releaseCountdown = F.releaseCountdown;
var byName = exports.byName = (0, _reselect.createStructuredSelector)({
  logFirebase: logFirebase,
  dumpProps: dumpProps,
  logProps: logProps,
  offline: offline,
  freshdesk: freshdesk,
  stoptime: stoptime,
  releaseCountdown: releaseCountdown,
  isPrereleaseFlags: isPrereleaseFlags
});
var flagName = function flagName(state, props) {
  return props.flagName;
};
// order doesn't matter, this is just debugging
var names = exports.names = (0, _reselect.createSelector)(byName, Object.keys);
var flag = exports.flag = (0, _reselect.createSelector)(byName, flagName, function (flags, name) {
  return name in flags ? flags[name] : (0, _assert.throws)("no such flag", name);
});

function branch(flag, ifTrue, ifFalse) {
  return (0, _reselect.createSelector)(flag, ifTrue, ifFalse, function (flag, ifTrue, ifFalse) {
    return flag == null ? null : flag ? ifTrue : ifFalse;
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prereleaseFlags = exports.isDebug = exports.numberformat = undefined;

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _reselect = __webpack_require__(2);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var path = (0, _reselect.createSelector)(_lodash2.default.flow(Auth.userId, Auth.Id.unwrap), paths.options.data);

var rawState = (0, _queryStatus.selectPath)(path);
var localState = (0, _reselect.createSelector)(rawState, function (state) {
  return state || {};
});

var numberformat = exports.numberformat = (0, _reselect.createSelector)(localState, function (state) {
  return state.numberformat || "standard";
});
var isDebug = exports.isDebug = (0, _reselect.createSelector)(localState, function (state) {
  return state.isDebug || false;
});
var prereleaseFlags = exports.prereleaseFlags = (0, _reselect.createSelector)(localState, function (state) {
  return state.prereleaseFlags != null ? state.prereleaseFlags : true;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPrereleaseFlags = exports.setIsDebug = exports.setNumberformat = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function set(field, val) {
  return function (dispatch, getState, _ref) {
    var getFirebase = _ref.getFirebase;

    var userId = Auth.userId(getState(), {});
    console.log("set", { userId: userId, field: field, val: val });
    return Util.dispatchPromise("auth/setOption/" + field, dispatch, getFirebase().set("/options/" + Auth.Id.unwrap(userId) + "/" + field, val), { userId: userId, field: field, val: val });
  };
}
var setNumberformat = exports.setNumberformat = function setNumberformat(val) {
  return set("numberformat", val);
};
var setIsDebug = exports.setIsDebug = function setIsDebug(val) {
  return set("isDebug", val);
};
var setPrereleaseFlags = exports.setPrereleaseFlags = function setPrereleaseFlags(val) {
  return set("prereleaseFlags", val);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Id = undefined;

var _types = __webpack_require__(91);

exports.Id = _types.Id;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2Uvb3B0aW9ucy90eXBlcy5qcyJdLCJuYW1lcyI6WyJJZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztRQUNRQSxFIiwiZmlsZSI6InR5cGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7SWR9IGZyb20gXCIuLi91c2Vycy90eXBlc1wiXG5leHBvcnQge0lkfVxuXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHtcbiAgK251bWJlcmZvcm1hdD86IHN0cmluZyxcbiAgK2lzRGVidWc/OiBib29sZWFuLFxuICArcHJlcmVsZWFzZUZsYWdzPzogYm9vbGVhbixcbn1cblxuZXhwb3J0IHR5cGUgUHJvcHMgPSB7fVxuZXhwb3J0IHR5cGUgU2VsZWN0PFQ+ID0gKFN0YXRlLCBhbnkpID0+IFRcbiJdfQ==

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.twinMeatUpgrades = exports.unlockZone6 = exports.isVoid = exports.getFlag = exports.flags = exports.localState = undefined;

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _raw = __webpack_require__(157);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Either a simple boolean, or a date when the flag flips from false to true.
var localState = exports.localState = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.ruleset;
});

// Collect flags for easy type-preserving meta-transforms.
// New flags are very common; this is the only file you should have to change to
// create and export one.

var flags = exports.flags = {};
var getFlag = exports.getFlag = function getFlag(name) {
  return function (state, now) {
    var val = state[name];
    if (val === true || val === false || val == null) return !!val;
    return !Util.Timestamp.isBefore(now, val);
  };
};
var flag = _fp2.default.memoize(function (name) {
  return flags[name] = (0, _reselect.createSelector)(localState, Now.now, getFlag(name));
});
var isVoid = exports.isVoid = flag("isVoid");
var unlockZone6 = exports.unlockZone6 = flag("unlockZone6");
var twinMeatUpgrades = exports.twinMeatUpgrades = flag("twinMeatUpgrades");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _growth = __webpack_require__(794);

Object.keys(_growth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _growth[key];
    }
  });
});

var _polynomial = __webpack_require__(371);

Object.defineProperty(exports, "solvePolynomial", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_polynomial).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7Ozs7OzsrQ0FDUUEsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5leHBvcnQgKiBmcm9tIFwiLi9ncm93dGhcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIHNvbHZlUG9seW5vbWlhbH0gZnJvbSBcIi4vcG9seW5vbWlhbFwiXG4iXX0=

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Production = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _decimal = __webpack_require__(370);

var _decimal2 = _interopRequireDefault(_decimal);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _polynomial = __webpack_require__(371);

var _polynomial2 = _interopRequireDefault(_polynomial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProdUnit = function () {
  // TODO
  function ProdUnit(name, count, children) {
    var _this = this;

    _classCallCheck(this, ProdUnit);

    this.name = name;
    this.count = new _decimal2.default(count);
    // children: other units produced by this one
    this.children = {};

    var _loop = function _loop(_name) {
      var p = _this.children[_name] = {
        each: children[_name],
        total: function total() {
          return _this.count.times(p.each);
        }
      };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(children || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _name = _step.value;

        _loop(_name);
      }
      // these are populated by Production
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.parents = {};
    this.polynomial = [this.count];
  } // TODO


  _createClass(ProdUnit, [{
    key: "degreeAt",
    value: function degreeAt(degree0, sec) {
      return (0, _polynomial2.default)(this.polynomial.slice(degree0), sec);
    }
  }, {
    key: "countAt",
    value: function countAt(sec) {
      return this.degreeAt(0, sec);
    }
  }, {
    key: "velocityAt",
    value: function velocityAt(sec) {
      return this.degreeAt(1, sec);
    }
  }, {
    key: "accelerationAt",
    value: function accelerationAt(sec) {
      return this.degreeAt(2, sec);
    }
  }]);

  return ProdUnit;
}();

var PolyPath = function () {
  // TODO

  function PolyPath(path) {
    _classCallCheck(this, PolyPath);

    this.path = path;
  }

  _createClass(PolyPath, [{
    key: "head",
    value: function head() {
      return this.path[0];
    }
  }, {
    key: "tail",
    value: function tail() {
      return this.path[this.path.length - 1];
    }
  }, {
    key: "parent",
    value: function parent() {
      return this.tail().parent;
    }
  }, {
    key: "child",
    value: function child() {
      return this.head().child;
    }
  }, {
    key: "degree",
    value: function degree() {
      return this.path.length;
    }
  }, {
    key: "coefficient",
    value: function coefficient() {
      var coeff = this.parent().count;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.path[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var path = _step2.value;

          coeff = coeff.times(path.each);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return coeff;
    }

    // create PolyPaths for producer's producers

  }, {
    key: "nextDegree",
    value: function nextDegree() {
      var _this2 = this;

      return Object.keys(this.parent().parents).map(function (name) {
        var path = _this2.parent().parents[name];
        return new PolyPath(_this2.path.concat([path]));
      });
    }
  }]);

  return PolyPath;
}();

var Production = exports.Production = function () {
  function Production(types, counts) {
    _classCallCheck(this, Production);

    this.units = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(types)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var name = _step3.value;

        this.units[name] = new ProdUnit(name, counts[name] || 0, types[name]);
      }
      // we know what each unit produces, reverse it to produced-by.
      // Start building the polynomial graph while we're at it.
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var polypath = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = Object.keys(this.units)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var parentName = _step4.value;

        var parent = this.units[parentName];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = Object.keys(parent.children)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var childName = _step5.value;

            var child = this.units[childName];
            var path = child.parents[parentName] = parent.children[childName];
            path.parent = parent;
            path.child = child;
            polypath.push(new PolyPath([path]));
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      // build the production polynomial, starting from first degree (drone->meat) and moving upward.
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    while (polypath.length > 0) {
      var poly = polypath.pop();
      poly.child().polynomial[poly.degree()] = (poly.child().polynomial[poly.degree()] || new _decimal2.default(0)).plus(poly.coefficient());
      Array.prototype.push.apply(polypath, poly.nextDegree());
    }
  }

  _createClass(Production, [{
    key: "countAt",
    value: function countAt(sec) {
      return this.degreeAt(0, sec);
    }
  }, {
    key: "velocityAt",
    value: function velocityAt(sec) {
      return this.degreeAt(1, sec);
    }
  }, {
    key: "accelerationAt",
    value: function accelerationAt(sec) {
      return this.degreeAt(2, sec);
    }
  }, {
    key: "degreeAt",
    value: function degreeAt(degree, sec) {
      return _lodash2.default.mapValues(this.units, function (unit) {
        return unit.degreeAt(degree, sec);
      });
    }
  }]);

  return Production;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = exports.localState = undefined;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _data = __webpack_require__(796);

var _data2 = _interopRequireDefault(_data);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _data2.default;

  return state;
}

var localState = exports.localState = function localState(state) {
  return state.entities2.achievementTypes;
};
var list = exports.list = (0, _reselect.createSelector)(localState, function (s) {
  return s.list;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2FjaGlldmVtZW50LXR5cGVzL3Jvb3QuanMiXSwibmFtZXMiOlsicmVkdWNlciIsIlV0aWwiLCJzdGF0ZSIsImxvY2FsU3RhdGUiLCJlbnRpdGllczIiLCJhY2hpZXZlbWVudFR5cGVzIiwibGlzdCIsInMiXSwibWFwcGluZ3MiOiI7Ozs7OztRQW9CZ0JBLE8sR0FBQUEsTzs7QUFuQmhCOztBQUNBOzs7O0FBQ0E7O0lBQVlDLEk7O0FBQ1o7Ozs7Ozs7O0FBZ0JPLFNBQVNELE9BQVQsR0FBK0M7QUFBQSxNQUE5QkUsS0FBOEI7O0FBQ3BELFNBQU9BLEtBQVA7QUFDRDs7QUFFTSxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhLENBQUNELEtBQUQ7QUFBQSxTQUN4QkEsTUFBTUUsU0FBTixDQUFnQkMsZ0JBRFE7QUFBQSxDQUFuQjtBQUVBLElBQU1DLHNCQUFPLDhCQUFlSCxVQUFmLEVBQTJCO0FBQUEsU0FBS0ksRUFBRUQsSUFBUDtBQUFBLENBQTNCLENBQWIiLCJmaWxlIjoicm9vdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IERlY2ltYWwgZnJvbSBcIi4uLy4uLy4uL2RlY2ltYWxcIlxuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5pbXBvcnQgc3RhdGUwIGZyb20gXCIuL2RhdGFcIlxuXG5leHBvcnQgdHlwZSBUaHJlc2hWYWx1ZSA9IERlY2ltYWwgfCBudW1iZXIgfCBzdHJpbmdcbmV4cG9ydCB0eXBlIFRocmVzaFNwZWMgPSB7W3N0cmluZ106IFRocmVzaFZhbHVlfVxuXG5leHBvcnQgdHlwZSBFbnRyeSA9IHt8XG4gICtuYW1lOiBzdHJpbmcsXG4gICtwb2ludHM6IG51bWJlcixcbiAgK3Zpc2libGU6IFRocmVzaFNwZWMsXG4gICtjb21wbGV0ZTogVGhyZXNoU3BlYyxcbnx9XG5leHBvcnQgdHlwZSBTdGF0ZSA9IHt8XG4gICtsaXN0OiBBcnJheTxFbnRyeT4sXG4gICtzY2hlbWE6ICRGbG93VE9ETywgLy8gVE9ETyByZW1vdmVcbnx9XG5cbmV4cG9ydCBmdW5jdGlvbiByZWR1Y2VyKHN0YXRlOiBTdGF0ZSA9IHN0YXRlMCk6IFN0YXRlIHtcbiAgcmV0dXJuIHN0YXRlXG59XG5cbmV4cG9ydCBjb25zdCBsb2NhbFN0YXRlID0gKHN0YXRlOiBVdGlsLlJvb3RTdGF0ZSkgPT5cbiAgc3RhdGUuZW50aXRpZXMyLmFjaGlldmVtZW50VHlwZXNcbmV4cG9ydCBjb25zdCBsaXN0ID0gY3JlYXRlU2VsZWN0b3IobG9jYWxTdGF0ZSwgcyA9PiBzLmxpc3QpXG4iXX0=

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var list = function () {
  // It's convenient to be able to reference earlier achievements when defining
  // later achievements, so we'll jump through a few hoops to make that possible
  // instead of defining this as a simple inline list. Could postprocess in a
  // selector instead, and/or normalize quotas separately from their
  // achievements, but this works fine for now.
  var ret = [];
  var byName = {};
  var push = function push(val) {
    ret.push(val);
    byName[val.name] = val;
  };
  push({
    name: "named",
    points: 10,
    visible: {},
    complete: { "character.named": true }
  });
  push({
    name: "drone1",
    points: 10,
    visible: {},
    complete: { "units.bought.drone": "1" }
  });
  push({
    name: "drone2",
    points: 20,
    visible: byName.drone1.complete,
    complete: { "units.bought.drone": "201" }
  });
  push({
    name: "drone3",
    points: 30,
    visible: byName.drone2.complete,
    complete: { "units.bought.drone": "10000" }
  });
  push({
    name: "hatchery1",
    points: 10,
    visible: {},
    complete: { "units.looted.hatchery": "1" }
  });
  push({
    name: "hatchery2",
    points: 20,
    visible: byName.hatchery1.complete,
    complete: { "units.looted.hatchery": "300" }
  });
  push({
    name: "hatchery3",
    points: 30,
    visible: byName.hatchery2.complete,
    complete: { "units.looted.hatchery": "3000" }
  });
  push({
    name: "zones1",
    points: 10,
    visible: {},
    complete: { "zones.cleared": 1 }
  });
  push({
    name: "zones2",
    points: 20,
    visible: byName.zones1.complete,
    complete: { "zones.cleared": 5 }
  });
  return ret;
}();

// TODO: groups. Similar to D3's season journey, or achievement categories

exports.default = { list: list, schema: null };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = exports.schema = exports.Decimal = undefined;

var _selectUtils = __webpack_require__(158);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _displayName = __webpack_require__(227);

var DisplayName = _interopRequireWildcard(_displayName);

var _stats = __webpack_require__(54);

var UnitStats = _interopRequireWildcard(_stats);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// When determining if an achievement's done/not-done, it draws from this data,
// and only this data.
var Decimal = exports.Decimal = UnitStats.Decimal;

var type = function type(_type) {
  return function (selector) {
    return { type: _type, selector: selector };
  };
};
var t = {
  bool: function bool(selector) {
    return type("boolean")(selector);
  },
  number: function number(selector) {
    return type("number")(selector);
  },
  decimal: function decimal(selector) {
    return type("decimal")(selector);
  }
};
var selectUnits = function selectUnits(selector) {
  return function (unitName) {
    return t.decimal((0, _selectUtils.createDeepSelector)((0, _selectUtils.withFixedProps)({ unitName: unitName }, selector), _lodash2.default.identity));
  };
};
var unitsBought = selectUnits(UnitStats.bought);
var unitsLooted = selectUnits(UnitStats.looted);
var _schema = {
  default_: t.bool(function () {
    return true;
  }),
  "character.named": t.bool(DisplayName.isNotEmpty),
  "units.bought.drone": unitsBought("drone"),
  "units.bought.queen": unitsBought("queen"),
  "units.bought.nest": unitsBought("nest"),
  "units.looted.hatchery": unitsLooted("hatchery"),
  "zones.cleared": t.number(Zones.totalClears)
};
var schema = exports.schema = (0, _reselect.createStructuredSelector)(_lodash2.default.mapValues(_schema, "selector"));
var types = exports.types = _lodash2.default.mapValues(_schema, "type");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleNames = exports.updatedDates = exports.pendingDates = exports.status = exports.statusByName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _progress = __webpack_require__(374);

var Progress = _interopRequireWildcard(_progress);

var _dates = __webpack_require__(225);

var Dates = _interopRequireWildcard(_dates);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusByName = exports.statusByName = (0, _reselect.createSelector)(Progress.isCompleteByName, Progress.isVisibleByName, Dates.byName, function (completes, visibles, dates) {
  return _lodash2.default.mapValues(completes, function (isComplete, name) {
    if (dates[name]) return "complete";
    if (isComplete) return "pending";
    if (visibles[name]) return "visible";
    return "invisible";
  });
});
var nameProp = function nameProp(s, p) {
  return p.achievementName;
};
var _get = function _get() {
  for (var _len = arguments.length, mess = Array(_len), _key = 0; _key < _len; _key++) {
    mess[_key] = arguments[_key];
  }

  return function (byName, name) {
    return _assert.assertDefined.apply(undefined, [byName[name]].concat(mess, [{ byName: byName, name: name }]));
  };
};
var status = exports.status = (0, _reselect.createSelector)(statusByName, nameProp, _get("status"));

// unordered
var pendingNames = (0, _reselect.createSelector)(statusByName, function (statuses) {
  return _lodash2.default.keys(_lodash2.default.pickBy(statuses, function (status) {
    return status === "pending";
  }));
});
var pendingDates = exports.pendingDates = (0, _reselect.createSelector)(pendingNames, Now.now, function (names, now) {
  return _lodash2.default.fromPairs(_lodash2.default.map(names, function (name) {
    return [name, now];
  }));
});
var updatedDates = exports.updatedDates = (0, _reselect.createSelector)(Dates.byName, pendingDates, function (olds, news) {
  return _extends({}, olds, news);
});

// ordered
var visibleNames = exports.visibleNames = (0, _reselect.createSelector)(Dates.names, statusByName, function (names, statuses) {
  return _lodash2.default.filter(names, function (name) {
    return statuses[name] !== "invisible";
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;
exports.errorReducer = errorReducer;

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_SIZE = 5;
// Log the last error-causing action in a character field.
var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  return state;
};
function errorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  return _fp2.default.concat(_fp2.default.take(MAX_SIZE, state), [
  // jsonifying the action prevents serialization errors. A little wasteful,
  // but rare enough that it's okay.
  _fp2.default.omit(["root", "character"], JSON.parse(JSON.stringify(action)))]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYWN0aW9uLWVycm9ycy5qcyJdLCJuYW1lcyI6WyJlcnJvclJlZHVjZXIiLCJNQVhfU0laRSIsInJlZHVjZXIiLCJzdGF0ZSIsImFjdGlvbiIsImNvbmNhdCIsInRha2UiLCJvbWl0IiwiSlNPTiIsInBhcnNlIiwic3RyaW5naWZ5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7UUFPZ0JBLFksR0FBQUEsWTs7QUFMaEI7Ozs7OztBQUVBLElBQU1DLFdBQVcsQ0FBakI7QUFIQTtBQUtPLElBQU1DLDRCQUFVLFNBQVZBLE9BQVU7QUFBQSxNQUFDQyxLQUFELHVFQUFnQixFQUFoQjtBQUFBLE1BQW9CQyxNQUFwQjtBQUFBLFNBQThDRCxLQUE5QztBQUFBLENBQWhCO0FBQ0EsU0FBU0gsWUFBVCxHQUFnRTtBQUFBLE1BQTFDRyxLQUEwQyx1RUFBM0IsRUFBMkI7QUFBQSxNQUF2QkMsTUFBdUI7O0FBQ3JFLFNBQU8sYUFBRUMsTUFBRixDQUFTLGFBQUVDLElBQUYsQ0FBT0wsUUFBUCxFQUFpQkUsS0FBakIsQ0FBVCxFQUFrQztBQUN2QztBQUNBO0FBQ0EsZUFBRUksSUFBRixDQUFPLENBQUMsTUFBRCxFQUFTLFdBQVQsQ0FBUCxFQUE4QkMsS0FBS0MsS0FBTCxDQUFXRCxLQUFLRSxTQUFMLENBQWVOLE1BQWYsQ0FBWCxDQUE5QixDQUh1QyxDQUFsQyxDQUFQO0FBS0QiLCJmaWxlIjoiYWN0aW9uLWVycm9ycy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyBMb2cgdGhlIGxhc3QgZXJyb3ItY2F1c2luZyBhY3Rpb24gaW4gYSBjaGFyYWN0ZXIgZmllbGQuXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoL2ZwXCJcblxuY29uc3QgTUFYX1NJWkUgPSA1XG5leHBvcnQgdHlwZSBTdGF0ZSA9IE9iamVjdFtdXG5leHBvcnQgY29uc3QgcmVkdWNlciA9IChzdGF0ZTogU3RhdGUgPSBbXSwgYWN0aW9uOiBPYmplY3QpOiBTdGF0ZSA9PiBzdGF0ZVxuZXhwb3J0IGZ1bmN0aW9uIGVycm9yUmVkdWNlcihzdGF0ZTogU3RhdGUgPSBbXSwgYWN0aW9uOiBPYmplY3QpOiBTdGF0ZSB7XG4gIHJldHVybiBfLmNvbmNhdChfLnRha2UoTUFYX1NJWkUsIHN0YXRlKSwgW1xuICAgIC8vIGpzb25pZnlpbmcgdGhlIGFjdGlvbiBwcmV2ZW50cyBzZXJpYWxpemF0aW9uIGVycm9ycy4gQSBsaXR0bGUgd2FzdGVmdWwsXG4gICAgLy8gYnV0IHJhcmUgZW5vdWdoIHRoYXQgaXQncyBva2F5LlxuICAgIF8ub21pdChbXCJyb290XCIsIFwiY2hhcmFjdGVyXCJdLCBKU09OLnBhcnNlKEpTT04uc3RyaW5naWZ5KGFjdGlvbikpKSxcbiAgXSlcbn1cbiJdfQ==

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isZoneSelectVisible = exports.isNavCombatVisible = undefined;

var _reselect = __webpack_require__(2);

var _selectUtils = __webpack_require__(158);

var _stats = __webpack_require__(54);

var Units = _interopRequireWildcard(_stats);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function withUnitName(unitName, selector) {
  return (0, _selectUtils.withFixedProps)({ unitName: unitName }, selector);
}
// Points at which the app's behavior changes.
var isNavCombatVisible = exports.isNavCombatVisible = (0, _reselect.createSelector)(withUnitName("larva", Units.spent), function (c) {
  return c.gte(90);
});
var isZoneSelectVisible = exports.isZoneSelectVisible = (0, _reselect.createSelector)(withUnitName("swarmling-queen", Units.bought), function (c) {
  return c.gt(1);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYnJlYWtwb2ludHMuanMiXSwibmFtZXMiOlsiVW5pdHMiLCJ3aXRoVW5pdE5hbWUiLCJ1bml0TmFtZSIsInNlbGVjdG9yIiwiaXNOYXZDb21iYXRWaXNpYmxlIiwic3BlbnQiLCJjIiwiZ3RlIiwiaXNab25lU2VsZWN0VmlzaWJsZSIsImJvdWdodCIsImd0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7O0FBQ0E7O0FBQ0E7O0lBQVlBLEs7Ozs7QUFFWixTQUFTQyxZQUFULENBQXNCQyxRQUF0QixFQUFnQ0MsUUFBaEMsRUFBMEM7QUFDeEMsU0FBTyxpQ0FBZSxFQUFDRCxrQkFBRCxFQUFmLEVBQTJCQyxRQUEzQixDQUFQO0FBQ0Q7QUFQRDtBQVFPLElBQU1DLGtEQUFxQiw4QkFDaENILGFBQWEsT0FBYixFQUFzQkQsTUFBTUssS0FBNUIsQ0FEZ0MsRUFFaEMsVUFBQ0MsQ0FBRDtBQUFBLFNBQXNCQSxFQUFFQyxHQUFGLENBQU0sRUFBTixDQUF0QjtBQUFBLENBRmdDLENBQTNCO0FBSUEsSUFBTUMsb0RBQXNCLDhCQUNqQ1AsYUFBYSxpQkFBYixFQUFnQ0QsTUFBTVMsTUFBdEMsQ0FEaUMsRUFFakMsVUFBQ0gsQ0FBRDtBQUFBLFNBQXNCQSxFQUFFSSxFQUFGLENBQUssQ0FBTCxDQUF0QjtBQUFBLENBRmlDLENBQTVCIiwiZmlsZSI6ImJyZWFrcG9pbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8vIFBvaW50cyBhdCB3aGljaCB0aGUgYXBwJ3MgYmVoYXZpb3IgY2hhbmdlcy5cbmltcG9ydCB7Y3JlYXRlU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQge3dpdGhGaXhlZFByb3BzfSBmcm9tIFwiLi4vLi4vLi4vc2VsZWN0LXV0aWxzXCJcbmltcG9ydCAqIGFzIFVuaXRzIGZyb20gXCIuL3VuaXRzL3N0YXRzXCJcblxuZnVuY3Rpb24gd2l0aFVuaXROYW1lKHVuaXROYW1lLCBzZWxlY3Rvcikge1xuICByZXR1cm4gd2l0aEZpeGVkUHJvcHMoe3VuaXROYW1lfSwgc2VsZWN0b3IpXG59XG5leHBvcnQgY29uc3QgaXNOYXZDb21iYXRWaXNpYmxlID0gY3JlYXRlU2VsZWN0b3IoXG4gIHdpdGhVbml0TmFtZShcImxhcnZhXCIsIFVuaXRzLnNwZW50KSxcbiAgKGM6IFVuaXRzLkRlY2ltYWwpID0+IGMuZ3RlKDkwKSxcbilcbmV4cG9ydCBjb25zdCBpc1pvbmVTZWxlY3RWaXNpYmxlID0gY3JlYXRlU2VsZWN0b3IoXG4gIHdpdGhVbml0TmFtZShcInN3YXJtbGluZy1xdWVlblwiLCBVbml0cy5ib3VnaHQpLFxuICAoYzogVW5pdHMuRGVjaW1hbCkgPT4gYy5ndCgxKSxcbilcbiJdfQ==

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grindTokenCount = exports.hasGrindToken = exports.isFirstZoneWin = exports.spent = exports.looted = exports.Team = exports.Enemy = exports.Player = exports.lootAction = exports.doneAt = exports.isRunning = exports.isDone = exports.doneStatus = exports.isTimeLimit = exports.sinceUpdated = exports.updatedAt = exports.zone = exports.sinceCreated = exports.createdAt = exports.localState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reducer = reducer;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(2);

var _redux = __webpack_require__(59);

var _cacheableRoot = __webpack_require__(359);

var _cacheableRoot2 = _interopRequireDefault(_cacheableRoot);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _lastActionAt = __webpack_require__(109);

var LastActionAt = _interopRequireWildcard(_lastActionAt);

var _combat = __webpack_require__(369);

var UnitsCombat = _interopRequireWildcard(_combat);

var _events = __webpack_require__(802);

var Events = _interopRequireWildcard(_events);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

var _combat2 = __webpack_require__(92);

var Main = _interopRequireWildcard(_combat2);

var _teams = __webpack_require__(375);

var Teams = _interopRequireWildcard(_teams);

var _teamsBase = __webpack_require__(376);

var TeamsBase = _interopRequireWildcard(_teamsBase);

var _done = __webpack_require__(377);

var Done = _interopRequireWildcard(_done);

var _loot = __webpack_require__(808);

var Loot = _interopRequireWildcard(_loot);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventStateReducers = (0, _redux.combineReducers)({
  player: Teams.Player.reducer,
  enemy: Teams.Enemy.reducer,
  event: function event(state, _event) {
    return _lodash2.default.omit(_event, ["root", "combat"]);
  },
  params: function params() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var event = arguments[1];
    return state;
  }
});
function reduceEventState(state, event) {
  // no updates allowed after combat's done: return with no changes. This is
  // the one time we can possibly return InitEventState - combat ended after
  // zero events. That's not actually possible - everyone starts with a lair,
  // but the type system doesn't know that; and reducer checks for this
  // identical-return special case anyway, so the typecast below is safe.
  var root = event.root,
      combat = event.combat,
      fixedNow = event.createdAt;

  if (Done.isDone(root, { combat: combat, fixedNow: fixedNow })) return state;
  // there's a real update needed
  return eventStateReducers(state, event);
}
function reducer(state, event0) {
  //console.log("combat-meta.reduce-event", event0)
  // TODO: error handling. Throwing an error should kill the combat session, but
  var event = _extends({}, event0, { combat: state });
  var nextState = state.last || state.init;
  var last = reduceEventState(nextState, event);
  return nextState === last ? state : _extends({}, state, { last: last });
}
var fancyEvents = (0, _reselect.createSelector)(Events.events, _cacheableRoot2.default, function (events, root) {
  return _lodash2.default.map(events, function (a) {
    return _extends({}, a, { root: root });
  });
});
var localState = exports.localState = (0, _reselect.createSelector)(fancyEvents, Raw.getFullState, function (events, combat) {
  return (
    // Events - redux actions - are processed similar to character actions.
    // Generate a list of events, and process them within a selector.
    _lodash2.default.reduce(events, reducer, combat)
  );
});
function withLocalState(selector) {
  return function (state, props0) {
    // run the selector *after* running pending events. Just like character2/meta.
    //console.log("combat.meta.withlocalstate", props)
    var combat = localState(state, props0);
    // Once done, combat freezes, full stop - times past doneAt don't exist.
    // Replace the time used in selectors.
    var props = _extends({}, _lodash2.default.omit(props0, ["charId", "character"]), { combat: combat });
    var doneAt = Done.doneAt(state, props);
    props = doneAt ? _extends({}, props, { fixedNow: doneAt }) : props;
    // No character access from combat. Everything from character must be snapshotted at the start of combat.
    return selector(state, props);
  };
}
var withCombatNotEmpty = function withCombatNotEmpty(selector) {
  return function (s, p
  //console.log("combatnotempty?", Raw.isNotEmpty(s, p), p) ||
  ) {
    return Raw.isNotEmpty(s, p) && selector(s, p);
  };
};

///////////////////////////////////////////////////////////////////////
// All the combat selectors - all of them - with pending events run first.
// Selectors defined elsewhere are unaware of pending events.
// Just like characters2/meta.
//
// (This implementation of it is verbose, but simple, and preserves flow types.
// `_.mapValues()` wizardry would be more concise, but also lose flow types.)
var createdAt = exports.createdAt = withLocalState(Main.createdAt);
var sinceCreated = exports.sinceCreated = withLocalState(Main.sinceCreated);
var zone = exports.zone = withLocalState(Main.zone);
var updatedAt = exports.updatedAt = withLocalState(Main.updatedAt);
var sinceUpdated = exports.sinceUpdated = withLocalState(Main.sinceUpdated);
var isTimeLimit = exports.isTimeLimit = withLocalState(Done.isTimeLimit);
var doneStatus = exports.doneStatus = withLocalState(Done.doneStatus);
var isDone = exports.isDone = withCombatNotEmpty(withLocalState(Done.isDone));
var isRunning = exports.isRunning = withCombatNotEmpty(withLocalState(Done.isRunning));
var doneAt = exports.doneAt = withLocalState(Done.doneAt);

var _lootAction = withLocalState(Loot.getAction);
var isNewResult = (0, _reselect.createSelector)(doneAt, LastActionAt.get, Util.Timestamp.isAfter);
var lootAction = exports.lootAction = withCombatNotEmpty(function (s, p) {
  return isNewResult(s, p) ? _lootAction(s, p) : null;
});

var teamSelectors = function teamSelectors(t) {
  return {
    // This should match teams.js:teamSelectors
    rawCounts: withLocalState(t.rawCounts),
    counts: withLocalState(t.counts),
    visibleNames: withLocalState(t.visibleNames),
    rawCount: withLocalState(t.rawCount),
    count: withLocalState(t.count),
    maxHp: withLocalState(t.maxHp),
    attackPowerEach: withLocalState(t.attackPowerEach),
    hp: withLocalState(t.hp),
    death: withLocalState(t.death),
    isZero: withLocalState(t.isZero),
    isNonzero: withLocalState(t.isNonzero),
    isGameOver: withLocalState(t.isGameOver),
    isNotGameOver: withLocalState(t.isNotGameOver)
  };
};
var Player = exports.Player = teamSelectors(Teams.Player);
var Enemy = exports.Enemy = teamSelectors(Teams.Enemy);
var Team = exports.Team = teamSelectors(TeamsBase);

var looted = exports.looted = withLocalState(Loot.looted);
var spent = exports.spent = withLocalState(Loot.spent);
var isFirstZoneWin = exports.isFirstZoneWin = withLocalState(Loot.isFirstZoneWin);

var hasGrindToken = exports.hasGrindToken = UnitsCombat.isGrind;
var grindTokenCount = exports.grindTokenCount = UnitsCombat.grindTokenCount;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports.timeLimit = undefined;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(2);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _now = __webpack_require__(30);

var Now = _interopRequireWildcard(_now);

var _combat = __webpack_require__(92);

var Main = _interopRequireWildcard(_combat);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _sinceStart = Now.since(Main.createdAt);
var roundDuration = function roundDuration() {
  return Util.Duration.seconds.from(5);
};
var timeLimit = exports.timeLimit = function timeLimit() {
  return Util.Duration.minutes.from(3);
};
var sinceStart = (0, _reselect.createSelector)(_sinceStart, timeLimit, Util.Duration.min);
var timeLimitAt = (0, _reselect.createSelector)(Main.createdAt, timeLimit, Util.Timestamp.add);
var isTimeLimit = (0, _reselect.createSelector)(sinceStart, timeLimit, function (since, limit) {
  return Util.Duration.unwrap(since) >= Util.Duration.unwrap(limit);
});
var numRounds = (0, _reselect.createSelector)(sinceStart, roundDuration, function (total, each) {
  return Math.floor(Util.Duration.millis.to(total) / Util.Duration.millis.to(each));
});
var roundDurations = (0, _reselect.createSelector)(roundDuration, numRounds, function (dur, num) {
  return _lodash2.default.range(num).map(function (n) {
    return Util.Duration.times(dur, n + 1);
  });
});
var roundTimestamps = (0, _reselect.createSelector)(Main.createdAt, roundDurations, function (ts, durs) {
  return durs.map(function (dur) {
    return Util.Timestamp.add(ts, dur);
  });
});
var roundEvents = (0, _reselect.createSelector)(roundTimestamps, function (tss) {
  return tss.map(function (createdAt) {
    return { type: "ROUND", createdAt: createdAt };
  });
});
var timeLimitEvent = (0, _reselect.createSelector)(isTimeLimit, timeLimitAt, function (is, createdAt) {
  return is ? [{ type: "TIMELIMIT", createdAt: createdAt }] : [];
});
var eventHistory = (0, _reselect.createSelector)(roundEvents, timeLimitEvent, _lodash2.default.concat);
var events = exports.events = (0, _reselect.createSelector)(eventHistory, Main.updatedAt, function (events, updatedAt) {
  return (
    // strict after, not after-or-equal: equal's already been run, that's where updatedAt came from
    _lodash2.default.filter(events, function (e) {
      return Util.Timestamp.isAfter(e.createdAt, updatedAt);
    })
  );
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Producer = exports.attackPower1 = exports.Attacker = exports.maxHp1 = exports.Targetable = exports.nameProp = undefined;
exports.reducer = reducer;

var _types = __webpack_require__(229);

var T = _interopRequireWildcard(_types);

var _json = __webpack_require__(804);

var _json2 = _interopRequireDefault(_json);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _json2.default;

  return state;
}
var listAll = function listAll(state) {
  return [].concat(_toConsumableArray(state));
};

var nameProp = exports.nameProp = function nameProp(s, props) {
  return props.soldierName;
};
function filteredList(pred, name) {
  var list = (0, _reselect.createSelector)(listAll, function (list) {
    return _lodash2.default.filter(list, pred);
  });
  var names = (0, _reselect.createSelector)(list, function (list) {
    return _lodash2.default.map(list, "name");
  });
  var byName = (0, _reselect.createSelector)(list, function (list) {
    return _lodash2.default.keyBy(list, "name");
  });
  var get = (0, _reselect.createSelector)(byName, nameProp, function (t, n) {
    return t[n] || (0, _assert.throws)("no such soldiertype", name, n, t);
  });
  return { list: list, names: names, byName: byName, get: get };
}

var _filteredList = filteredList(function (item) {
  return true;
}, "all"),
    get = _filteredList.get;

var Targetable = exports.Targetable = function () {
  var _filteredList2 = filteredList(function (item) {
    return "maxHp" in item;
  }, "Targetable"),
      list = _filteredList2.list,
      names = _filteredList2.names,
      get = _filteredList2.get;

  var maxHp1 = (0, _reselect.createSelector)(get, function (type) {
    return type.maxHp;
  });
  return { list: list, names: names, get: get, maxHp1: maxHp1 };
}();
var maxHp1 = exports.maxHp1 = (0, _reselect.createSelector)(get, function (type) {
  return type.maxHp || 0;
});

var Attacker = exports.Attacker = function () {
  var _filteredList3 = filteredList(function (item) {
    return "attack" in item;
  }, "Attacker"),
      list = _filteredList3.list,
      names = _filteredList3.names,
      get = _filteredList3.get;

  var attackPower1 = (0, _reselect.createSelector)(get, function (type) {
    return type.attack;
  });
  return { list: list, names: names, get: get, attackPower1: attackPower1 };
}();
var attackPower1 = exports.attackPower1 = (0, _reselect.createSelector)(get, function (type) {
  return type.attack || 0;
});

var Producer = exports.Producer = function () {
  var _filteredList4 = filteredList(function (item) {
    return "prod" in item;
  }, "Producer"),
      list = _filteredList4.list,
      names = _filteredList4.names,
      get = _filteredList4.get;

  var prodsEach = (0, _reselect.createSelector)(list, function (list) {
    return (0, _lodash2.default)(list).keyBy("name").mapValues("prod").value();
  });
  return { list: list, names: names, get: get, prodsEach: prodsEach };
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = __webpack_require__(229);

var T = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = [{
  name: "swarmling",
  maxHp: 5,
  attack: 5
}, {
  name: "swarmling-queen",
  prod: { swarmling: 2 }
}, {
  name: "tower",
  maxHp: 100000,
  attack: 100000
}, {
  name: "lair",
  maxHp: 3000
}, {
  name: "overlord",
  maxHp: 5
}, {
  name: "overlord-den",
  prod: { overlord: 1 / 3 }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3NvbGRpZXItdHlwZXMvanNvbi5qcyJdLCJuYW1lcyI6WyJUIiwibmFtZSIsIm1heEhwIiwiYXR0YWNrIiwicHJvZCIsInN3YXJtbGluZyIsIm92ZXJsb3JkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQTs7SUFBWUEsQzs7OztrQkFDSSxDQUNkO0FBQ0VDLFFBQU0sV0FEUjtBQUVFQyxTQUFPLENBRlQ7QUFHRUMsVUFBUTtBQUhWLENBRGMsRUFNZDtBQUNFRixRQUFNLGlCQURSO0FBRUVHLFFBQU0sRUFBQ0MsV0FBVyxDQUFaO0FBRlIsQ0FOYyxFQVVkO0FBQ0VKLFFBQU0sT0FEUjtBQUVFQyxTQUFPLE1BRlQ7QUFHRUMsVUFBUTtBQUhWLENBVmMsRUFlZDtBQUNFRixRQUFNLE1BRFI7QUFFRUMsU0FBTztBQUZULENBZmMsRUFtQmQ7QUFDRUQsUUFBTSxVQURSO0FBRUVDLFNBQU87QUFGVCxDQW5CYyxFQXVCZDtBQUNFRCxRQUFNLGNBRFI7QUFFRUcsUUFBTSxFQUFDRSxVQUFVLElBQUksQ0FBZjtBQUZSLENBdkJjLEMiLCJmaWxlIjoianNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBUIGZyb20gXCIuL3R5cGVzXCJcbmV4cG9ydCBkZWZhdWx0IChbXG4gIHtcbiAgICBuYW1lOiBcInN3YXJtbGluZ1wiLFxuICAgIG1heEhwOiA1LFxuICAgIGF0dGFjazogNSxcbiAgfSxcbiAge1xuICAgIG5hbWU6IFwic3dhcm1saW5nLXF1ZWVuXCIsXG4gICAgcHJvZDoge3N3YXJtbGluZzogMn0sXG4gIH0sXG4gIHtcbiAgICBuYW1lOiBcInRvd2VyXCIsXG4gICAgbWF4SHA6IDEwMDAwMCxcbiAgICBhdHRhY2s6IDEwMDAwMCxcbiAgfSxcbiAge1xuICAgIG5hbWU6IFwibGFpclwiLFxuICAgIG1heEhwOiAzMDAwLFxuICB9LFxuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZFwiLFxuICAgIG1heEhwOiA1LFxuICB9LFxuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZC1kZW5cIixcbiAgICBwcm9kOiB7b3ZlcmxvcmQ6IDEgLyAzfSxcbiAgfSxcbl06IFQuU3RhdGUpXG4iXX0=

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localState = undefined;

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var localState = exports.localState = function localState(state) {
  return state.entities2.soldierTypes;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3NvbGRpZXItdHlwZXMvcm9vdC5qcyJdLCJuYW1lcyI6WyJVdGlsIiwibG9jYWxTdGF0ZSIsInN0YXRlIiwiZW50aXRpZXMyIiwic29sZGllclR5cGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7Ozs7QUFDTCxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhLENBQUNDLEtBQUQ7QUFBQSxTQUN4QkEsTUFBTUMsU0FBTixDQUFnQkMsWUFEUTtBQUFBLENBQW5CIiwiZmlsZSI6InJvb3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5leHBvcnQgY29uc3QgbG9jYWxTdGF0ZSA9IChzdGF0ZTogVXRpbC5Sb290U3RhdGUpID0+XG4gIHN0YXRlLmVudGl0aWVzMi5zb2xkaWVyVHlwZXNcbiJdfQ==

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.velocities = velocities;
exports.counts = counts;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = __webpack_require__(12);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Swarm-growth is written for Decimals, but combat uses non-Decimal numbers.
// Combat doesn't have parents-of-parents yet though - drone -> meat, but no
// queen -> drone - so we'll just write our own little growth function here.

function velocities(counts, producedByEach) {
  var ret = _lodash2.default.mapValues(counts, function () {
    return 0;
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(producedByEach)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      var parents = producedByEach[child];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(parents)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var parent = _step2.value;

          var prodEach = parents[parent];
          var parentCount = counts[parent] || 0;
          var prodTotal = prodEach * parentCount;
          // don't add zero-velocities to the result unnecessarily
          if (prodTotal !== 0) ret[child] = (ret[child] || 0) + prodTotal;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}
function counts(counts0, producedByEach, dt) {
  if (_lodash2.default.isNaN(dt)) return (0, _assert.throws)("counts: bogus dt", dt);
  var vs = velocities(counts0, producedByEach);
  return _lodash2.default.mapValues(vs, function (v, name) {
    return Math.floor((counts0[name] || 0) + v * Util.Duration.seconds.to(dt));
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defenderNames = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.soldiersToTotalHps = soldiersToTotalHps;
exports.totalHpsToSoldiers = totalHpsToSoldiers;
exports.reducer = reducer;

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _soldierTypes = __webpack_require__(228);

var SoldierTypes = _interopRequireWildcard(_soldierTypes);

var _reselect = __webpack_require__(2);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defenderNames = exports.defenderNames = (0, _reselect.createSelector)(SoldierTypes.root.localState, function (types) {
  return _lodash2.default.map(_lodash2.default.filter(types, "maxHp"), "name");
});
function totalHpToCountAndHp(maxHp, totalHp) {
  return { count: Math.ceil(totalHp / maxHp), hp: totalHp % maxHp };
}
function soldiersToTotalHps(soldiers, maxHps) {
  return _lodash2.default.pickBy(_lodash2.default.mapValues(maxHps, function (maxHp, name) {
    var s = soldiers[name] || { count: 0, hp: 0, deaths: 0 };
    var hp0 = s.hp || maxHp;
    return (s.count - 1) * maxHp + hp0;
  }));
}
function totalHpsToSoldiers(soldiers0, hps, maxHps) {
  return _lodash2.default.mapValues(soldiers0, function (soldier0, name) {
    var maxHp = maxHps[name];
    if (!maxHp) return soldier0;
    var totalHp = hps[name] || 0; // if missing, they all died

    var _totalHpToCountAndHp = totalHpToCountAndHp(maxHp, totalHp),
        count = _totalHpToCountAndHp.count,
        hp = _totalHpToCountAndHp.hp;

    return { hp: hp, count: count, deaths: soldier0.deaths + (soldier0.count - count) };
  });
}

// A reducer for each attack during combat. One attack-event per attacking soldier-type.
function reducer(defenderHps0, event) {
  var power = event.power,
      root = event.root;
  // copy, so we can safely/privately mutate this to calculate the result.

  var defenderHps = _extends({}, defenderHps0);
  // while the attacker has attack power left;
  var dnames = defenderNames(root);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = dnames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var dname = _step.value;

      if (power <= 0) break;
      // OR while the defender has any non-dead soldiers left;
      var hp0 = defenderHps[dname];
      if (hp0) {
        // attack, and maybe kill (hp===0) each defending soldier;
        var dhp = Math.min(power, hp0);
        defenderHps[dname] -= dhp;
        // and reduce remaining attack power based on defender hp lost.
        power -= dhp;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return defenderHps;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAction = exports.looted = exports.spent = exports.isFirstZoneWin = exports.isEmpty = exports.isNotEmpty = exports.Decimal = undefined;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _zoneTypes = __webpack_require__(156);

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _done = __webpack_require__(377);

var Done = _interopRequireWildcard(_done);

var _combat = __webpack_require__(92);

var Main = _interopRequireWildcard(_combat);

var _raw = __webpack_require__(45);

var Raw = _interopRequireWildcard(_raw);

var _decimal = __webpack_require__(93);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Decimal = _decimal2.default;
var isNotEmpty = exports.isNotEmpty = Done.isDone;
var isEmpty = exports.isEmpty = Done.isRunning;
var assertLootable = (0, _reselect.createSelector)(isNotEmpty, function (ne) {
  return (0, _assert.assert)(ne, "combat is not yet lootable");
});
var params = (0, _reselect.createSelector)(Raw.getInitState, assertLootable, function (s) {
  return (0, _assert.assertDefined)(s.params, "loot params undefined", s);
});
var isZoneCleared = (0, _reselect.createSelector)(params, function (s) {
  return s.isZoneCleared;
});
//const isGrind = createSelector(params, s => s.isGrind)
var isGrind = function isGrind() {
  return false;
};
var zoneLevel = function zoneLevel(state, props) {
  var zone = Main.zone(state, props);
  return ZoneTypes.level(state, { zone: zone });
};
var any = function any() {
  for (var _len = arguments.length, as = Array(_len), _key = 0; _key < _len; _key++) {
    as[_key] = arguments[_key];
  }

  return _lodash2.default.some(as);
};
var all = function all() {
  for (var _len2 = arguments.length, as = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    as[_key2] = arguments[_key2];
  }

  return _lodash2.default.every(as);
};
var isHatcheryLootable = (0, _reselect.createSelector)(isGrind, _lodash2.default.negate(isZoneCleared), any);
var isGrindTokenSpent = (0, _reselect.createSelector)(isGrind, isZoneCleared, all);
var boolToNumber = function boolToNumber(a) {
  return a ? 1 : 0;
};

var branchOnStatus = function branchOnStatus(onWin, onLoss) {
  var onDraw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : onLoss;
  return function (state, props) {
    assertLootable(state, props);
    var status = Done.doneStatus(state, props);
    switch (status) {
      case "win":
        return onWin(state, props);
      case "lose":
        return onLoss(state, props);
      case "draw":
        return onDraw(state, props);
      default:
        return (0, _assert.throws)("invalid loot status", status);
    }
  };
};

var isFirstZoneWin = exports.isFirstZoneWin = branchOnStatus(_lodash2.default.negate(isZoneCleared), function (s, p) {
  return null;
});
var spent = exports.spent = branchOnStatus((0, _reselect.createStructuredSelector)({
  _lootGrindToken: (0, _reselect.createSelector)(isGrindTokenSpent, _lodash2.default.flow(boolToNumber, _decimal2.default))
}), (0, _reselect.createStructuredSelector)({}));

var looted = exports.looted = branchOnStatus((0, _reselect.createStructuredSelector)({
  hatchery: (0, _reselect.createSelector)(isHatcheryLootable, zoneLevel, function (isLootable, level) {
    return (0, _decimal2.default)(isLootable ? level * level : 0);
  })
}), (0, _reselect.createStructuredSelector)({}));

var getAction = exports.getAction = (0, _reselect.createStructuredSelector)({
  type: function type() {
    return "__COMBAT_RESULT";
  },
  createdAt: Done.doneAt,
  status: Done.doneStatus,
  zone: Main.zone,
  isFirstZoneWin: isFirstZoneWin,
  spend: spent,
  loot: looted
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delete_ = exports.update = exports.names = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _stats = __webpack_require__(54);

var UnitStats = _interopRequireWildcard(_stats);

var _zones = __webpack_require__(94);

var Zones = _interopRequireWildcard(_zones);

var _achievements = __webpack_require__(373);

var Achieves = _interopRequireWildcard(_achievements);

var _displayName = __webpack_require__(227);

var DisplayName = _interopRequireWildcard(_displayName);

var _lastActionAt = __webpack_require__(109);

var LastActionAt = _interopRequireWildcard(_lastActionAt);

var _leagues = __webpack_require__(221);

var Leagues = _interopRequireWildcard(_leagues);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Unit-counts can get bigger than most leaderboards can handle, so sort by log.
var unitCountDisplay = function unitCountDisplay(name) {
  return (0, _reselect.createSelector)(UnitStats.rawCountSelector(name), function (count) {
    return count.toString();
  });
};
var unitCountSort = function unitCountSort(name) {
  return (0, _reselect.createSelector)(UnitStats.rawCountSelector(name), function (count) {
    // json doesn't do infinity, but ln(0) === -Infinity
    return count.isZero() ? null : count.ln(10).toNumber();
  });
};
var unitlist = ["meat", "drone", "queen", "nest", "hatchery"].map(function (name) {
  return {
    name: name,
    value: unitCountSort(name),
    displayValue: unitCountDisplay(name)
  };
});
var list = unitlist.concat([{ name: "achievements-count", value: Achieves.numCompleted }, { name: "zones-cleared", value: Zones.totalClears }]);
var names = exports.names = (0, _reselect.createSelector)(function () {
  return list;
}, _fp2.default.map("name"));

var updateEntries = (0, _reselect.createStructuredSelector)(_fp2.default.fromPairs(_fp2.default.map(function (_ref) {
  var name = _ref.name,
      value = _ref.value,
      displayValue = _ref.displayValue;
  return [name, (0, _reselect.createStructuredSelector)(_extends({
    displayName: DisplayName.get,
    updatedAt: LastActionAt.get,
    value: value
  }, displayValue ? { displayValue: displayValue } : {}))];
}, list)));
var charIdProp = function charIdProp(s, p) {
  return p.charId || p._charId || (0, _assert.throws)("no charid found");
};
var keyToPath = (0, _reselect.createSelector)(Leagues.name, charIdProp, function (league, charId) {
  return function (key) {
    return [league, key, charId].join("/");
  };
});
var update = exports.update = (0, _reselect.createSelector)(keyToPath, updateEntries, _fp2.default.mapKeys);

var deleteEntries = _fp2.default.fromPairs(_fp2.default.map(function (_ref2) {
  var name = _ref2.name;
  return [name, null];
}, list));
var delete_ = exports.delete_ = (0, _reselect.createSelector)(keyToPath, function () {
  return deleteEntries;
}, _fp2.default.mapKeys);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayName = exports.isAuth = exports.get = undefined;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _users = __webpack_require__(217);

var Users = _interopRequireWildcard(_users);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _raw = __webpack_require__(31);

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = exports.get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return (0, _assert.assertDefined)(s.user, "characters2.user", s);
});
var isAuth = exports.isAuth = (0, _reselect.createSelector)(get, Auth.userId, function (cu, au) {
  return cu === au;
});
var createUserSelector = function createUserSelector(selector) {
  return (0, _reselect.createSelector)(
  // a cacheable subset of root for the user-selectors below
  (0, _reselect.createStructuredSelector)({
    firebase: (0, _reselect.createStructuredSelector)({
      data: (0, _reselect.createStructuredSelector)({
        users: function users(root) {
          return root.firebase.data.users;
        }
      })
    })
  }), (0, _reselect.createStructuredSelector)({
    userId: get
  }), selector);
};
var displayName = exports.displayName = createUserSelector(Users.displayName);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdXNlci5qcyJdLCJuYW1lcyI6WyJVc2VycyIsIkF1dGgiLCJSYXciLCJnZXQiLCJsb2NhbFN0YXRlIiwicyIsInVzZXIiLCJpc0F1dGgiLCJ1c2VySWQiLCJjdSIsImF1IiwiY3JlYXRlVXNlclNlbGVjdG9yIiwiZmlyZWJhc2UiLCJkYXRhIiwidXNlcnMiLCJyb290Iiwic2VsZWN0b3IiLCJkaXNwbGF5TmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztBQUNBOztBQUNBOztJQUFZQSxLOztBQUNaOztJQUFZQyxJOztBQUNaOztJQUFZQyxHOzs7O0FBRUwsSUFBTUMsb0JBQU0sOEJBQWVELElBQUlFLFVBQW5CLEVBQStCO0FBQUEsU0FDaEQsMkJBQWNDLEVBQUVDLElBQWhCLEVBQXNCLGtCQUF0QixFQUEwQ0QsQ0FBMUMsQ0FEZ0Q7QUFBQSxDQUEvQixDQUFaO0FBSUEsSUFBTUUsMEJBQVMsOEJBQWVKLEdBQWYsRUFBb0JGLEtBQUtPLE1BQXpCLEVBQWlDLFVBQUNDLEVBQUQsRUFBS0MsRUFBTDtBQUFBLFNBQVlELE9BQU9DLEVBQW5CO0FBQUEsQ0FBakMsQ0FBZjtBQUNQLElBQU1DLHFCQUFxQixTQUFyQkEsa0JBQXFCO0FBQUEsU0FDekI7QUFDRTtBQUNBLDBDQUF5QjtBQUN2QkMsY0FBVSx3Q0FBeUI7QUFDakNDLFlBQU0sd0NBQXlCO0FBQzdCQyxlQUFPO0FBQUEsaUJBQVFDLEtBQUtILFFBQUwsQ0FBY0MsSUFBZCxDQUFtQkMsS0FBM0I7QUFBQTtBQURzQixPQUF6QjtBQUQyQixLQUF6QjtBQURhLEdBQXpCLENBRkYsRUFTRSx3Q0FBeUI7QUFDdkJOLFlBQVFMO0FBRGUsR0FBekIsQ0FURixFQVlFYSxRQVpGLENBRHlCO0FBQUEsQ0FBM0I7QUFlTyxJQUFNQyxvQ0FBY04sbUJBQW1CWCxNQUFNaUIsV0FBekIsQ0FBcEIiLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yLCBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQge2Fzc2VydERlZmluZWR9IGZyb20gXCJAc3dhcm0yL2Fzc2VydFwiXG5pbXBvcnQgKiBhcyBVc2VycyBmcm9tIFwiLi4vdXNlcnNcIlxuaW1wb3J0ICogYXMgQXV0aCBmcm9tIFwiLi4vYXV0aFwiXG5pbXBvcnQgKiBhcyBSYXcgZnJvbSBcIi4vcmF3XCJcblxuZXhwb3J0IGNvbnN0IGdldCA9IGNyZWF0ZVNlbGVjdG9yKFJhdy5sb2NhbFN0YXRlLCBzID0+XG4gIGFzc2VydERlZmluZWQocy51c2VyLCBcImNoYXJhY3RlcnMyLnVzZXJcIiwgcyksXG4pXG5cbmV4cG9ydCBjb25zdCBpc0F1dGggPSBjcmVhdGVTZWxlY3RvcihnZXQsIEF1dGgudXNlcklkLCAoY3UsIGF1KSA9PiBjdSA9PT0gYXUpXG5jb25zdCBjcmVhdGVVc2VyU2VsZWN0b3IgPSBzZWxlY3RvciA9PlxuICBjcmVhdGVTZWxlY3RvcihcbiAgICAvLyBhIGNhY2hlYWJsZSBzdWJzZXQgb2Ygcm9vdCBmb3IgdGhlIHVzZXItc2VsZWN0b3JzIGJlbG93XG4gICAgY3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yKHtcbiAgICAgIGZpcmViYXNlOiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICBkYXRhOiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICAgIHVzZXJzOiByb290ID0+IHJvb3QuZmlyZWJhc2UuZGF0YS51c2VycyxcbiAgICAgICAgfSksXG4gICAgICB9KSxcbiAgICB9KSxcbiAgICBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgdXNlcklkOiBnZXQsXG4gICAgfSksXG4gICAgc2VsZWN0b3IsXG4gIClcbmV4cG9ydCBjb25zdCBkaXNwbGF5TmFtZSA9IGNyZWF0ZVVzZXJTZWxlY3RvcihVc2Vycy5kaXNwbGF5TmFtZSlcbiJdfQ==

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.costEach = exports.get = exports.Decimal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buyUnitAction = buyUnitAction;
exports.reducer = reducer;

var _reselect = __webpack_require__(2);

var _assert = __webpack_require__(12);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _raw = __webpack_require__(220);

var RawUnit = _interopRequireWildcard(_raw);

var _raw2 = __webpack_require__(31);

var RawChar = _interopRequireWildcard(_raw2);

var _stats = __webpack_require__(54);

var UnitStats = _interopRequireWildcard(_stats);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _reify = __webpack_require__(110);

var UnitReify = _interopRequireWildcard(_reify);

var _visible = __webpack_require__(224);

var UnitVisible = _interopRequireWildcard(_visible);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Decimal = exports.Decimal = UnitStats.Decimal;
var get = exports.get = RawUnit.get;

function buyUnitAction(unitName, count) {
  return { type: "BUY_UNIT", unitName: unitName, count: count.toString() };
}

var countProp = function countProp(s, p) {
  return p.count;
};
var unitNameProp = function unitNameProp(s, p) {
  return p.unitName;
};
var fixedNowProp = function fixedNowProp(s, p) {
  return p.fixedNow;
};
var statsBoughtAction = (0, _reselect.createSelector)(unitNameProp, countProp, fixedNowProp, function (unitName, count, now) {
  return _defineProperty({}, unitName, UnitStats.buyAction(count, now));
});
// UnitType.Name isn't worth the trouble, but I haven't deleted it yet, so
// this is just doing s/Name/string/ for UnitType's use in this file
var costEach = exports.costEach = function costEach(state, props) {
  var unitName = props.unitName;

  if (!UnitTypes.isValidName(state, props)) return (0, _assert.throws)("no such unit", { unitName: unitName });
  if (!UnitTypes.isBuyable(state, props)) return {};
  return UnitTypes.cost(state, props);
};
var costTotal = (0, _reselect.createSelector)(costEach, countProp, function (eaches, count) {
  return _lodash2.default.mapValues(eaches, function (each) {
    return count.times(each);
  });
});
var statsSpentActions = (0, _reselect.createSelector)(costTotal, function (costs) {
  return _lodash2.default.mapValues(costs, UnitStats.spendAction);
});
var statsBuyActions = (0, _reselect.createSelector)(statsBoughtAction, statsSpentActions, function (buy, spend) {
  return _extends({}, buy, spend);
});

var statsCombatLootActions = (0, _reselect.createSelector)(function (s, p) {
  return p.loot;
}, fixedNowProp, function (us, now) {
  return _lodash2.default.mapValues(us, function (u) {
    return UnitStats.lootAction(u, now);
  });
});
var statsCombatSpendActions = (0, _reselect.createSelector)(function (s, p) {
  return p.spend;
}, fixedNowProp, function (us, now) {
  return _lodash2.default.mapValues(us, function (u) {
    return UnitStats.spendAction(u);
  });
});
var statsCombatResultActions = (0, _reselect.createSelector)(statsCombatLootActions, statsCombatSpendActions, function (loot, spend) {
  return _extends({}, loot, spend);
});
function reifyBeforeAction(state, action) {
  var root = action.root,
      character = action.character,
      fixedNow = action.createdAt;

  (0, _assert.assert)(state === character.units || !character.units, "units.reducer(state) should match action.character.units");
  var units = UnitReify.reify(root, { character: character, fixedNow: fixedNow });
  return _extends({}, character, { units: units });
}
function applyStatsActions(state, actions, root, character) {
  return _extends({}, state, _lodash2.default.mapValues(actions, function (statAction, unitName) {
    return UnitStats.reducer(UnitStats.localState(root, { character: character, unitName: unitName }), statAction);
  }));
}
function reducer(state0, action) {
  var state = state0 || {};
  switch (action.type) {
    case "BUY_UNIT":
      {
        var character = reifyBeforeAction(state, action);
        state = character.units || (0, _assert.throws)("reifyBeforeAction fail", character);
        var root = action.root,
            _fixedNow = action.createdAt,
            _unitName = action.unitName;

        if (!UnitVisible.isVisible(root, { unitName: _unitName, fixedNow: _fixedNow, character: character })) {
          return (0, _assert.throws)("cannot buy invisible unit", {
            unitName: _unitName,
            fixedNow: _fixedNow,
            character: character
          });
        }
        if (!UnitTypes.isBuyable(root, { unitName: _unitName })) {
          return (0, _assert.throws)("cannot buy unbuyable unit", { unitName: _unitName });
        }
        var _count = Decimal(action.count);
        if (!_count.greaterThan(0)) return (0, _assert.throws)("Must buy a positive number", _count);
        var actions = statsBuyActions(root, {
          character: character,
          unitName: _unitName,
          count: _count,
          fixedNow: _fixedNow
        });
        //console.log(JSON.stringify(actions, null, 2))
        return applyStatsActions(state, actions, root, character);
      }
    case "__COMBAT_RESULT":
      {
        var _character = reifyBeforeAction(state, action);
        state = _character.units || (0, _assert.throws)("reifyBeforeAction fail", _character);
        var _root = action.root,
            _fixedNow2 = action.createdAt,
            loot = action.loot,
            spend = action.spend;
        //console.log("combatresult", loot, spend, fixedNow)

        var _actions = statsCombatResultActions(_root, {
          character: _character,
          fixedNow: _fixedNow2,
          loot: loot,
          spend: spend
        });
        return applyStatsActions(state, _actions, _root, _character);
      }
    default:
      return state;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvdW5pdHMuanMiXSwibmFtZXMiOlsiYnV5VW5pdEFjdGlvbiIsInJlZHVjZXIiLCJVdGlsIiwiUmF3VW5pdCIsIlJhd0NoYXIiLCJVbml0U3RhdHMiLCJVbml0VHlwZXMiLCJVbml0UmVpZnkiLCJVbml0VmlzaWJsZSIsIkRlY2ltYWwiLCJnZXQiLCJ1bml0TmFtZSIsImNvdW50IiwidHlwZSIsInRvU3RyaW5nIiwiY291bnRQcm9wIiwicyIsInAiLCJ1bml0TmFtZVByb3AiLCJmaXhlZE5vd1Byb3AiLCJmaXhlZE5vdyIsInN0YXRzQm91Z2h0QWN0aW9uIiwibm93IiwiYnV5QWN0aW9uIiwiY29zdEVhY2giLCJzdGF0ZSIsInByb3BzIiwiaXNWYWxpZE5hbWUiLCJpc0J1eWFibGUiLCJjb3N0IiwiY29zdFRvdGFsIiwiZWFjaGVzIiwibWFwVmFsdWVzIiwidGltZXMiLCJlYWNoIiwic3RhdHNTcGVudEFjdGlvbnMiLCJjb3N0cyIsInNwZW5kQWN0aW9uIiwic3RhdHNCdXlBY3Rpb25zIiwiYnV5Iiwic3BlbmQiLCJzdGF0c0NvbWJhdExvb3RBY3Rpb25zIiwibG9vdCIsInVzIiwibG9vdEFjdGlvbiIsInUiLCJzdGF0c0NvbWJhdFNwZW5kQWN0aW9ucyIsInN0YXRzQ29tYmF0UmVzdWx0QWN0aW9ucyIsInJlaWZ5QmVmb3JlQWN0aW9uIiwiYWN0aW9uIiwicm9vdCIsImNoYXJhY3RlciIsImNyZWF0ZWRBdCIsInVuaXRzIiwicmVpZnkiLCJhcHBseVN0YXRzQWN0aW9ucyIsImFjdGlvbnMiLCJzdGF0QWN0aW9uIiwibG9jYWxTdGF0ZSIsInN0YXRlMCIsImlzVmlzaWJsZSIsImdyZWF0ZXJUaGFuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7UUF3QmdCQSxhLEdBQUFBLGE7UUEyRUFDLE8sR0FBQUEsTzs7QUFsR2hCOztBQUdBOztBQUNBOzs7O0FBQ0E7O0lBQVlDLEk7O0FBQ1o7O0lBQVlDLE87O0FBQ1o7O0lBQVlDLE87O0FBQ1o7O0lBQVlDLFM7O0FBQ1o7O0lBQVlDLFM7O0FBQ1o7O0lBQVlDLFM7O0FBQ1o7O0lBQVlDLFc7Ozs7Ozs7O0FBR0wsSUFBTUMsNEJBQVVKLFVBQVVJLE9BQTFCO0FBQ0EsSUFBTUMsb0JBQU1QLFFBQVFPLEdBQXBCOztBQVFBLFNBQVNWLGFBQVQsQ0FDTFcsUUFESyxFQUVMQyxLQUZLLEVBR1U7QUFDZixTQUFPLEVBQUNDLE1BQU0sVUFBUCxFQUFtQkYsa0JBQW5CLEVBQTZCQyxPQUFPQSxNQUFNRSxRQUFOLEVBQXBDLEVBQVA7QUFDRDs7QUFFRCxJQUFNQyxZQUFZLFNBQVpBLFNBQVksQ0FBQ0MsQ0FBRCxFQUFTQyxDQUFUO0FBQUEsU0FBaUNBLEVBQUVMLEtBQW5DO0FBQUEsQ0FBbEI7QUFDQSxJQUFNTSxlQUFlLFNBQWZBLFlBQWUsQ0FBQ0YsQ0FBRCxFQUFTQyxDQUFUO0FBQUEsU0FBbUNBLEVBQUVOLFFBQXJDO0FBQUEsQ0FBckI7QUFDQSxJQUFNUSxlQUFlLFNBQWZBLFlBQWUsQ0FBQ0gsQ0FBRCxFQUFTQyxDQUFUO0FBQUEsU0FBbUNBLEVBQUVHLFFBQXJDO0FBQUEsQ0FBckI7QUFDQSxJQUFNQyxvQkFBb0IsOEJBQ3hCSCxZQUR3QixFQUV4QkgsU0FGd0IsRUFHeEJJLFlBSHdCLEVBSXhCLFVBQUNSLFFBQUQsRUFBV0MsS0FBWCxFQUFrQlUsR0FBbEI7QUFBQSw2QkFBNkJYLFFBQTdCLEVBQXdDTixVQUFVa0IsU0FBVixDQUFvQlgsS0FBcEIsRUFBMkJVLEdBQTNCLENBQXhDO0FBQUEsQ0FKd0IsQ0FBMUI7QUFNQTtBQUNBO0FBQ08sSUFBTUUsOEJBQVcsU0FBWEEsUUFBVyxDQUN0QkMsS0FEc0IsRUFFdEJDLEtBRnNCLEVBR0U7QUFBQSxNQUNqQmYsUUFEaUIsR0FDTGUsS0FESyxDQUNqQmYsUUFEaUI7O0FBRXhCLE1BQUksQ0FBQ0wsVUFBVXFCLFdBQVYsQ0FBc0JGLEtBQXRCLEVBQTZCQyxLQUE3QixDQUFMLEVBQ0UsT0FBTyxvQkFBTyxjQUFQLEVBQXVCLEVBQUNmLGtCQUFELEVBQXZCLENBQVA7QUFDRixNQUFJLENBQUNMLFVBQVVzQixTQUFWLENBQW9CSCxLQUFwQixFQUEyQkMsS0FBM0IsQ0FBTCxFQUF3QyxPQUFPLEVBQVA7QUFDeEMsU0FBT3BCLFVBQVV1QixJQUFWLENBQWVKLEtBQWYsRUFBc0JDLEtBQXRCLENBQVA7QUFDRCxDQVRNO0FBVVAsSUFBTUksWUFBWSw4QkFBZU4sUUFBZixFQUF5QlQsU0FBekIsRUFBb0MsVUFBQ2dCLE1BQUQsRUFBU25CLEtBQVQ7QUFBQSxTQUNwRCxpQkFBRW9CLFNBQUYsQ0FBWUQsTUFBWixFQUFvQjtBQUFBLFdBQVFuQixNQUFNcUIsS0FBTixDQUFZQyxJQUFaLENBQVI7QUFBQSxHQUFwQixDQURvRDtBQUFBLENBQXBDLENBQWxCO0FBR0EsSUFBTUMsb0JBQW9CLDhCQUFlTCxTQUFmLEVBQTBCO0FBQUEsU0FDbEQsaUJBQUVFLFNBQUYsQ0FBWUksS0FBWixFQUFtQi9CLFVBQVVnQyxXQUE3QixDQURrRDtBQUFBLENBQTFCLENBQTFCO0FBR0EsSUFBTUMsa0JBQWtCLDhCQUN0QmpCLGlCQURzQixFQUV0QmMsaUJBRnNCLEVBR3RCLFVBQUNJLEdBQUQsRUFBTUMsS0FBTjtBQUFBLHNCQUFxQkQsR0FBckIsRUFBNkJDLEtBQTdCO0FBQUEsQ0FIc0IsQ0FBeEI7O0FBTUEsSUFBTUMseUJBQXlCLDhCQUM3QixVQUFDekIsQ0FBRCxFQUFJQyxDQUFKO0FBQUEsU0FBVUEsRUFBRXlCLElBQVo7QUFBQSxDQUQ2QixFQUU3QnZCLFlBRjZCLEVBRzdCLFVBQUN3QixFQUFELEVBQUtyQixHQUFMO0FBQUEsU0FBYSxpQkFBRVUsU0FBRixDQUFZVyxFQUFaLEVBQWdCO0FBQUEsV0FBS3RDLFVBQVV1QyxVQUFWLENBQXFCQyxDQUFyQixFQUF3QnZCLEdBQXhCLENBQUw7QUFBQSxHQUFoQixDQUFiO0FBQUEsQ0FINkIsQ0FBL0I7QUFLQSxJQUFNd0IsMEJBQTBCLDhCQUM5QixVQUFDOUIsQ0FBRCxFQUFJQyxDQUFKO0FBQUEsU0FBVUEsRUFBRXVCLEtBQVo7QUFBQSxDQUQ4QixFQUU5QnJCLFlBRjhCLEVBRzlCLFVBQUN3QixFQUFELEVBQUtyQixHQUFMO0FBQUEsU0FBYSxpQkFBRVUsU0FBRixDQUFZVyxFQUFaLEVBQWdCO0FBQUEsV0FBS3RDLFVBQVVnQyxXQUFWLENBQXNCUSxDQUF0QixDQUFMO0FBQUEsR0FBaEIsQ0FBYjtBQUFBLENBSDhCLENBQWhDO0FBS0EsSUFBTUUsMkJBQTJCLDhCQUMvQk4sc0JBRCtCLEVBRS9CSyx1QkFGK0IsRUFHL0IsVUFBQ0osSUFBRCxFQUFPRixLQUFQO0FBQUEsc0JBQXNCRSxJQUF0QixFQUErQkYsS0FBL0I7QUFBQSxDQUgrQixDQUFqQztBQUtBLFNBQVNRLGlCQUFULENBQTJCdkIsS0FBM0IsRUFBeUN3QixNQUF6QyxFQUE2RTtBQUFBLE1BQ3BFQyxJQURvRSxHQUM1QkQsTUFENEIsQ0FDcEVDLElBRG9FO0FBQUEsTUFDOURDLFNBRDhELEdBQzVCRixNQUQ0QixDQUM5REUsU0FEOEQ7QUFBQSxNQUN4Qy9CLFFBRHdDLEdBQzVCNkIsTUFENEIsQ0FDbkRHLFNBRG1EOztBQUUzRSxzQkFDRTNCLFVBQVUwQixVQUFVRSxLQUFwQixJQUE2QixDQUFDRixVQUFVRSxLQUQxQyxFQUVFLDBEQUZGO0FBSUEsTUFBTUEsUUFBUTlDLFVBQVUrQyxLQUFWLENBQWdCSixJQUFoQixFQUFzQixFQUFDQyxvQkFBRCxFQUFZL0Isa0JBQVosRUFBdEIsQ0FBZDtBQUNBLHNCQUFXK0IsU0FBWCxJQUFzQkUsWUFBdEI7QUFDRDtBQUNELFNBQVNFLGlCQUFULENBQTJCOUIsS0FBM0IsRUFBeUMrQixPQUF6QyxFQUFrRE4sSUFBbEQsRUFBd0RDLFNBQXhELEVBQTBFO0FBQ3hFLHNCQUNLMUIsS0FETCxFQUVLLGlCQUFFTyxTQUFGLENBQVl3QixPQUFaLEVBQXFCLFVBQUNDLFVBQUQsRUFBYTlDLFFBQWI7QUFBQSxXQUN0Qk4sVUFBVUosT0FBVixDQUNFSSxVQUFVcUQsVUFBVixDQUFxQlIsSUFBckIsRUFBMkIsRUFBQ0Msb0JBQUQsRUFBWXhDLGtCQUFaLEVBQTNCLENBREYsRUFFRThDLFVBRkYsQ0FEc0I7QUFBQSxHQUFyQixDQUZMO0FBU0Q7QUFDTSxTQUFTeEQsT0FBVCxDQUNMMEQsTUFESyxFQUVMVixNQUZLLEVBR0U7QUFDUCxNQUFJeEIsUUFBZWtDLFVBQVUsRUFBN0I7QUFDQSxVQUFRVixPQUFPcEMsSUFBZjtBQUNFLFNBQUssVUFBTDtBQUFpQjtBQUNmLFlBQU1zQyxZQUFZSCxrQkFBa0J2QixLQUFsQixFQUF5QndCLE1BQXpCLENBQWxCO0FBQ0F4QixnQkFBUTBCLFVBQVVFLEtBQVYsSUFBbUIsb0JBQU8sd0JBQVAsRUFBaUNGLFNBQWpDLENBQTNCO0FBRmUsWUFHUkQsSUFIUSxHQUcrQkQsTUFIL0IsQ0FHUkMsSUFIUTtBQUFBLFlBR1M5QixTQUhULEdBRytCNkIsTUFIL0IsQ0FHRkcsU0FIRTtBQUFBLFlBR21CekMsU0FIbkIsR0FHK0JzQyxNQUgvQixDQUdtQnRDLFFBSG5COztBQUlmLFlBQUksQ0FBQ0gsWUFBWW9ELFNBQVosQ0FBc0JWLElBQXRCLEVBQTRCLEVBQUN2QyxtQkFBRCxFQUFXUyxtQkFBWCxFQUFxQitCLG9CQUFyQixFQUE1QixDQUFMLEVBQW1FO0FBQ2pFLGlCQUFPLG9CQUFPLDJCQUFQLEVBQW9DO0FBQ3pDeEMsK0JBRHlDO0FBRXpDUywrQkFGeUM7QUFHekMrQjtBQUh5QyxXQUFwQyxDQUFQO0FBS0Q7QUFDRCxZQUFJLENBQUM3QyxVQUFVc0IsU0FBVixDQUFvQnNCLElBQXBCLEVBQTBCLEVBQUN2QyxtQkFBRCxFQUExQixDQUFMLEVBQTRDO0FBQzFDLGlCQUFPLG9CQUFPLDJCQUFQLEVBQW9DLEVBQUNBLG1CQUFELEVBQXBDLENBQVA7QUFDRDtBQUNELFlBQU1DLFNBQVFILFFBQVF3QyxPQUFPckMsS0FBZixDQUFkO0FBQ0EsWUFBSSxDQUFDQSxPQUFNaUQsV0FBTixDQUFrQixDQUFsQixDQUFMLEVBQ0UsT0FBTyxvQkFBTyw0QkFBUCxFQUFxQ2pELE1BQXJDLENBQVA7QUFDRixZQUFNNEMsVUFBVWxCLGdCQUFnQlksSUFBaEIsRUFBc0I7QUFDcENDLDhCQURvQztBQUVwQ3hDLDZCQUZvQztBQUdwQ0MsdUJBSG9DO0FBSXBDUTtBQUpvQyxTQUF0QixDQUFoQjtBQU1BO0FBQ0EsZUFBT21DLGtCQUFrQjlCLEtBQWxCLEVBQXlCK0IsT0FBekIsRUFBa0NOLElBQWxDLEVBQXdDQyxTQUF4QyxDQUFQO0FBQ0Q7QUFDRCxTQUFLLGlCQUFMO0FBQXdCO0FBQ3RCLFlBQU1BLGFBQVlILGtCQUFrQnZCLEtBQWxCLEVBQXlCd0IsTUFBekIsQ0FBbEI7QUFDQXhCLGdCQUFRMEIsV0FBVUUsS0FBVixJQUFtQixvQkFBTyx3QkFBUCxFQUFpQ0YsVUFBakMsQ0FBM0I7QUFGc0IsWUFHZkQsS0FIZSxHQUcyQkQsTUFIM0IsQ0FHZkMsSUFIZTtBQUFBLFlBR0U5QixVQUhGLEdBRzJCNkIsTUFIM0IsQ0FHVEcsU0FIUztBQUFBLFlBR1lWLElBSFosR0FHMkJPLE1BSDNCLENBR1lQLElBSFo7QUFBQSxZQUdrQkYsS0FIbEIsR0FHMkJTLE1BSDNCLENBR2tCVCxLQUhsQjtBQUl0Qjs7QUFDQSxZQUFNZ0IsV0FBVVQseUJBQXlCRyxLQUF6QixFQUErQjtBQUM3Q0MsK0JBRDZDO0FBRTdDL0IsOEJBRjZDO0FBRzdDc0Isb0JBSDZDO0FBSTdDRjtBQUo2QyxTQUEvQixDQUFoQjtBQU1BLGVBQU9lLGtCQUFrQjlCLEtBQWxCLEVBQXlCK0IsUUFBekIsRUFBa0NOLEtBQWxDLEVBQXdDQyxVQUF4QyxDQUFQO0FBQ0Q7QUFDRDtBQUNFLGFBQU8xQixLQUFQO0FBekNKO0FBMkNEIiwiZmlsZSI6InVuaXRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7Y3JlYXRlU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQgdHlwZSB7RmFuY3lBY3Rpb259IGZyb20gXCIuLi9hY3Rpb24tYmFzZVwiXG5pbXBvcnQgdHlwZSB7TG9vdEFjdGlvbn0gZnJvbSBcIi4uL2NvbWJhdC9sb290XCJcbmltcG9ydCB7YXNzZXJ0LCB0aHJvd3N9IGZyb20gXCJAc3dhcm0yL2Fzc2VydFwiXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoXCJcbmltcG9ydCAqIGFzIFV0aWwgZnJvbSBcIi4uLy4uLy4uL3V0aWxcIlxuaW1wb3J0ICogYXMgUmF3VW5pdCBmcm9tIFwiLi9yYXdcIlxuaW1wb3J0ICogYXMgUmF3Q2hhciBmcm9tIFwiLi4vcmF3XCJcbmltcG9ydCAqIGFzIFVuaXRTdGF0cyBmcm9tIFwiLi9zdGF0c1wiXG5pbXBvcnQgKiBhcyBVbml0VHlwZXMgZnJvbSBcIi4uLy4uLy4uL2VudGl0aWVzMi91bml0LXR5cGVzXCJcbmltcG9ydCAqIGFzIFVuaXRSZWlmeSBmcm9tIFwiLi9yZWlmeVwiXG5pbXBvcnQgKiBhcyBVbml0VmlzaWJsZSBmcm9tIFwiLi92aXNpYmxlXCJcblxuZXhwb3J0IHR5cGUgU3RhdGUgPSBSYXdVbml0LlN0YXRlXG5leHBvcnQgY29uc3QgRGVjaW1hbCA9IFVuaXRTdGF0cy5EZWNpbWFsXG5leHBvcnQgY29uc3QgZ2V0ID0gUmF3VW5pdC5nZXRcblxuZXhwb3J0IHR5cGUgQnV5VW5pdEFjdGlvbiA9IHtcbiAgK3R5cGU6IFwiQlVZX1VOSVRcIixcbiAgK3VuaXROYW1lOiBzdHJpbmcsXG4gIC8vIGNvdW50IGlzIGEgc2VyaWFsaXplZCBEZWNpbWFsLCB3aGljaCB3b24ndCBuZWNlc3NhcmlseSBmaXQgaW4gYSBwcmltaXRpdmUgbnVtYmVyIHR5cGVcbiAgK2NvdW50OiBzdHJpbmcsXG59XG5leHBvcnQgZnVuY3Rpb24gYnV5VW5pdEFjdGlvbihcbiAgdW5pdE5hbWU6IHN0cmluZyxcbiAgY291bnQ6IERlY2ltYWwgfCBzdHJpbmcsXG4pOiBCdXlVbml0QWN0aW9uIHtcbiAgcmV0dXJuIHt0eXBlOiBcIkJVWV9VTklUXCIsIHVuaXROYW1lLCBjb3VudDogY291bnQudG9TdHJpbmcoKX1cbn1cblxuY29uc3QgY291bnRQcm9wID0gKHM6IGFueSwgcDoge2NvdW50OiBEZWNpbWFsfSkgPT4gcC5jb3VudFxuY29uc3QgdW5pdE5hbWVQcm9wID0gKHM6IGFueSwgcDoge3VuaXROYW1lOiBzdHJpbmd9KSA9PiBwLnVuaXROYW1lXG5jb25zdCBmaXhlZE5vd1Byb3AgPSAoczogYW55LCBwOiB7Zml4ZWROb3c6IG51bWJlcn0pID0+IHAuZml4ZWROb3dcbmNvbnN0IHN0YXRzQm91Z2h0QWN0aW9uID0gY3JlYXRlU2VsZWN0b3IoXG4gIHVuaXROYW1lUHJvcCxcbiAgY291bnRQcm9wLFxuICBmaXhlZE5vd1Byb3AsXG4gICh1bml0TmFtZSwgY291bnQsIG5vdykgPT4gKHtbdW5pdE5hbWVdOiBVbml0U3RhdHMuYnV5QWN0aW9uKGNvdW50LCBub3cpfSksXG4pXG4vLyBVbml0VHlwZS5OYW1lIGlzbid0IHdvcnRoIHRoZSB0cm91YmxlLCBidXQgSSBoYXZlbid0IGRlbGV0ZWQgaXQgeWV0LCBzb1xuLy8gdGhpcyBpcyBqdXN0IGRvaW5nIHMvTmFtZS9zdHJpbmcvIGZvciBVbml0VHlwZSdzIHVzZSBpbiB0aGlzIGZpbGVcbmV4cG9ydCBjb25zdCBjb3N0RWFjaCA9IChcbiAgc3RhdGU6IFV0aWwuUm9vdFN0YXRlLFxuICBwcm9wczoge3VuaXROYW1lOiBzdHJpbmd9LFxuKToge1tzdHJpbmddOiBEZWNpbWFsfSA9PiB7XG4gIGNvbnN0IHt1bml0TmFtZX0gPSBwcm9wc1xuICBpZiAoIVVuaXRUeXBlcy5pc1ZhbGlkTmFtZShzdGF0ZSwgcHJvcHMpKVxuICAgIHJldHVybiB0aHJvd3MoXCJubyBzdWNoIHVuaXRcIiwge3VuaXROYW1lfSlcbiAgaWYgKCFVbml0VHlwZXMuaXNCdXlhYmxlKHN0YXRlLCBwcm9wcykpIHJldHVybiB7fVxuICByZXR1cm4gVW5pdFR5cGVzLmNvc3Qoc3RhdGUsIHByb3BzKVxufVxuY29uc3QgY29zdFRvdGFsID0gY3JlYXRlU2VsZWN0b3IoY29zdEVhY2gsIGNvdW50UHJvcCwgKGVhY2hlcywgY291bnQpID0+XG4gIF8ubWFwVmFsdWVzKGVhY2hlcywgZWFjaCA9PiBjb3VudC50aW1lcyhlYWNoKSksXG4pXG5jb25zdCBzdGF0c1NwZW50QWN0aW9ucyA9IGNyZWF0ZVNlbGVjdG9yKGNvc3RUb3RhbCwgY29zdHMgPT5cbiAgXy5tYXBWYWx1ZXMoY29zdHMsIFVuaXRTdGF0cy5zcGVuZEFjdGlvbiksXG4pXG5jb25zdCBzdGF0c0J1eUFjdGlvbnMgPSBjcmVhdGVTZWxlY3RvcihcbiAgc3RhdHNCb3VnaHRBY3Rpb24sXG4gIHN0YXRzU3BlbnRBY3Rpb25zLFxuICAoYnV5LCBzcGVuZCkgPT4gKHsuLi5idXksIC4uLnNwZW5kfSksXG4pXG5cbmNvbnN0IHN0YXRzQ29tYmF0TG9vdEFjdGlvbnMgPSBjcmVhdGVTZWxlY3RvcihcbiAgKHMsIHApID0+IHAubG9vdCxcbiAgZml4ZWROb3dQcm9wLFxuICAodXMsIG5vdykgPT4gXy5tYXBWYWx1ZXModXMsIHUgPT4gVW5pdFN0YXRzLmxvb3RBY3Rpb24odSwgbm93KSksXG4pXG5jb25zdCBzdGF0c0NvbWJhdFNwZW5kQWN0aW9ucyA9IGNyZWF0ZVNlbGVjdG9yKFxuICAocywgcCkgPT4gcC5zcGVuZCxcbiAgZml4ZWROb3dQcm9wLFxuICAodXMsIG5vdykgPT4gXy5tYXBWYWx1ZXModXMsIHUgPT4gVW5pdFN0YXRzLnNwZW5kQWN0aW9uKHUpKSxcbilcbmNvbnN0IHN0YXRzQ29tYmF0UmVzdWx0QWN0aW9ucyA9IGNyZWF0ZVNlbGVjdG9yKFxuICBzdGF0c0NvbWJhdExvb3RBY3Rpb25zLFxuICBzdGF0c0NvbWJhdFNwZW5kQWN0aW9ucyxcbiAgKGxvb3QsIHNwZW5kKSA9PiAoey4uLmxvb3QsIC4uLnNwZW5kfSksXG4pXG5mdW5jdGlvbiByZWlmeUJlZm9yZUFjdGlvbihzdGF0ZTogU3RhdGUsIGFjdGlvbjogRmFuY3lBY3Rpb24pOiBSYXdDaGFyLlN0YXRlIHtcbiAgY29uc3Qge3Jvb3QsIGNoYXJhY3RlciwgY3JlYXRlZEF0OiBmaXhlZE5vd30gPSBhY3Rpb25cbiAgYXNzZXJ0KFxuICAgIHN0YXRlID09PSBjaGFyYWN0ZXIudW5pdHMgfHwgIWNoYXJhY3Rlci51bml0cyxcbiAgICBcInVuaXRzLnJlZHVjZXIoc3RhdGUpIHNob3VsZCBtYXRjaCBhY3Rpb24uY2hhcmFjdGVyLnVuaXRzXCIsXG4gIClcbiAgY29uc3QgdW5pdHMgPSBVbml0UmVpZnkucmVpZnkocm9vdCwge2NoYXJhY3RlciwgZml4ZWROb3d9KVxuICByZXR1cm4gey4uLmNoYXJhY3RlciwgdW5pdHN9XG59XG5mdW5jdGlvbiBhcHBseVN0YXRzQWN0aW9ucyhzdGF0ZTogU3RhdGUsIGFjdGlvbnMsIHJvb3QsIGNoYXJhY3Rlcik6IFN0YXRlIHtcbiAgcmV0dXJuIHtcbiAgICAuLi5zdGF0ZSxcbiAgICAuLi5fLm1hcFZhbHVlcyhhY3Rpb25zLCAoc3RhdEFjdGlvbiwgdW5pdE5hbWUpID0+XG4gICAgICBVbml0U3RhdHMucmVkdWNlcihcbiAgICAgICAgVW5pdFN0YXRzLmxvY2FsU3RhdGUocm9vdCwge2NoYXJhY3RlciwgdW5pdE5hbWV9KSxcbiAgICAgICAgc3RhdEFjdGlvbixcbiAgICAgICksXG4gICAgKSxcbiAgfVxufVxuZXhwb3J0IGZ1bmN0aW9uIHJlZHVjZXIoXG4gIHN0YXRlMDogP1N0YXRlLFxuICBhY3Rpb246IChCdXlVbml0QWN0aW9uIHwgTG9vdEFjdGlvbikgJiBGYW5jeUFjdGlvbixcbik6IFN0YXRlIHtcbiAgbGV0IHN0YXRlOiBTdGF0ZSA9IHN0YXRlMCB8fCB7fVxuICBzd2l0Y2ggKGFjdGlvbi50eXBlKSB7XG4gICAgY2FzZSBcIkJVWV9VTklUXCI6IHtcbiAgICAgIGNvbnN0IGNoYXJhY3RlciA9IHJlaWZ5QmVmb3JlQWN0aW9uKHN0YXRlLCBhY3Rpb24pXG4gICAgICBzdGF0ZSA9IGNoYXJhY3Rlci51bml0cyB8fCB0aHJvd3MoXCJyZWlmeUJlZm9yZUFjdGlvbiBmYWlsXCIsIGNoYXJhY3RlcilcbiAgICAgIGNvbnN0IHtyb290LCBjcmVhdGVkQXQ6IGZpeGVkTm93LCB1bml0TmFtZX0gPSBhY3Rpb25cbiAgICAgIGlmICghVW5pdFZpc2libGUuaXNWaXNpYmxlKHJvb3QsIHt1bml0TmFtZSwgZml4ZWROb3csIGNoYXJhY3Rlcn0pKSB7XG4gICAgICAgIHJldHVybiB0aHJvd3MoXCJjYW5ub3QgYnV5IGludmlzaWJsZSB1bml0XCIsIHtcbiAgICAgICAgICB1bml0TmFtZSxcbiAgICAgICAgICBmaXhlZE5vdyxcbiAgICAgICAgICBjaGFyYWN0ZXIsXG4gICAgICAgIH0pXG4gICAgICB9XG4gICAgICBpZiAoIVVuaXRUeXBlcy5pc0J1eWFibGUocm9vdCwge3VuaXROYW1lfSkpIHtcbiAgICAgICAgcmV0dXJuIHRocm93cyhcImNhbm5vdCBidXkgdW5idXlhYmxlIHVuaXRcIiwge3VuaXROYW1lfSlcbiAgICAgIH1cbiAgICAgIGNvbnN0IGNvdW50ID0gRGVjaW1hbChhY3Rpb24uY291bnQpXG4gICAgICBpZiAoIWNvdW50LmdyZWF0ZXJUaGFuKDApKVxuICAgICAgICByZXR1cm4gdGhyb3dzKFwiTXVzdCBidXkgYSBwb3NpdGl2ZSBudW1iZXJcIiwgY291bnQpXG4gICAgICBjb25zdCBhY3Rpb25zID0gc3RhdHNCdXlBY3Rpb25zKHJvb3QsIHtcbiAgICAgICAgY2hhcmFjdGVyLFxuICAgICAgICB1bml0TmFtZSxcbiAgICAgICAgY291bnQsXG4gICAgICAgIGZpeGVkTm93LFxuICAgICAgfSlcbiAgICAgIC8vY29uc29sZS5sb2coSlNPTi5zdHJpbmdpZnkoYWN0aW9ucywgbnVsbCwgMikpXG4gICAgICByZXR1cm4gYXBwbHlTdGF0c0FjdGlvbnMoc3RhdGUsIGFjdGlvbnMsIHJvb3QsIGNoYXJhY3RlcilcbiAgICB9XG4gICAgY2FzZSBcIl9fQ09NQkFUX1JFU1VMVFwiOiB7XG4gICAgICBjb25zdCBjaGFyYWN0ZXIgPSByZWlmeUJlZm9yZUFjdGlvbihzdGF0ZSwgYWN0aW9uKVxuICAgICAgc3RhdGUgPSBjaGFyYWN0ZXIudW5pdHMgfHwgdGhyb3dzKFwicmVpZnlCZWZvcmVBY3Rpb24gZmFpbFwiLCBjaGFyYWN0ZXIpXG4gICAgICBjb25zdCB7cm9vdCwgY3JlYXRlZEF0OiBmaXhlZE5vdywgbG9vdCwgc3BlbmR9ID0gYWN0aW9uXG4gICAgICAvL2NvbnNvbGUubG9nKFwiY29tYmF0cmVzdWx0XCIsIGxvb3QsIHNwZW5kLCBmaXhlZE5vdylcbiAgICAgIGNvbnN0IGFjdGlvbnMgPSBzdGF0c0NvbWJhdFJlc3VsdEFjdGlvbnMocm9vdCwge1xuICAgICAgICBjaGFyYWN0ZXIsXG4gICAgICAgIGZpeGVkTm93LFxuICAgICAgICBsb290LFxuICAgICAgICBzcGVuZCxcbiAgICAgIH0pXG4gICAgICByZXR1cm4gYXBwbHlTdGF0c0FjdGlvbnMoc3RhdGUsIGFjdGlvbnMsIHJvb3QsIGNoYXJhY3RlcilcbiAgICB9XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBzdGF0ZVxuICB9XG59XG4iXX0=

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxBuyable = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reselect = __webpack_require__(2);

var _fp = __webpack_require__(51);

var _fp2 = _interopRequireDefault(_fp);

var _reify = __webpack_require__(110);

var Reify = _interopRequireWildcard(_reify);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Decimal = Reify.Decimal;


var maxBuyableEach = (0, _reselect.createSelector)(Reify.counts, UnitTypes.cost, function (bank, cost) {
  return _fp2.default.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        c = _ref2[1];

    return bank[name].dividedBy(c).floor();
  }, _fp2.default.entries(cost));
});
var maxBuyable = exports.maxBuyable = (0, _reselect.createSelector)(maxBuyableEach, function (maxEach) {
  return maxEach.length ? Decimal.min.apply(Decimal, _toConsumableArray(maxEach)) : Decimal(0);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvbWF4LWJ1eWFibGUuanMiXSwibmFtZXMiOlsiUmVpZnkiLCJVbml0VHlwZXMiLCJEZWNpbWFsIiwibWF4QnV5YWJsZUVhY2giLCJjb3VudHMiLCJjb3N0IiwiYmFuayIsIm1hcCIsIm5hbWUiLCJjIiwiZGl2aWRlZEJ5IiwiZmxvb3IiLCJlbnRyaWVzIiwibWF4QnV5YWJsZSIsIm1heEVhY2giLCJsZW5ndGgiLCJtaW4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0lBQVlBLEs7O0FBQ1o7O0lBQVlDLFM7Ozs7Ozs7O0lBQ0xDLE8sR0FBV0YsSyxDQUFYRSxPOzs7QUFFUCxJQUFNQyxpQkFBaUIsOEJBQ3JCSCxNQUFNSSxNQURlLEVBRXJCSCxVQUFVSSxJQUZXLEVBR3JCLFVBQUNDLElBQUQsRUFBT0QsSUFBUDtBQUFBLFNBQ0UsYUFBRUUsR0FBRixDQUNFO0FBQUE7QUFBQSxRQUFFQyxJQUFGO0FBQUEsUUFBZ0JDLENBQWhCOztBQUFBLFdBQWdDSCxLQUFLRSxJQUFMLEVBQVdFLFNBQVgsQ0FBcUJELENBQXJCLEVBQXdCRSxLQUF4QixFQUFoQztBQUFBLEdBREYsRUFFRSxhQUFFQyxPQUFGLENBQVVQLElBQVYsQ0FGRixDQURGO0FBQUEsQ0FIcUIsQ0FBdkI7QUFTTyxJQUFNUSxrQ0FBYSw4QkFDeEJWLGNBRHdCLEVBRXhCO0FBQUEsU0FBWVcsUUFBUUMsTUFBUixHQUFpQmIsUUFBUWMsR0FBUixtQ0FBZUYsT0FBZixFQUFqQixHQUEyQ1osUUFBUSxDQUFSLENBQXZEO0FBQUEsQ0FGd0IsQ0FBbkIiLCJmaWxlIjoibWF4LWJ1eWFibGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2gvZnBcIlxuaW1wb3J0ICogYXMgUmVpZnkgZnJvbSBcIi4vcmVpZnlcIlxuaW1wb3J0ICogYXMgVW5pdFR5cGVzIGZyb20gXCIuLi8uLi8uLi9lbnRpdGllczIvdW5pdC10eXBlc1wiXG5jb25zdCB7RGVjaW1hbH0gPSBSZWlmeVxuXG5jb25zdCBtYXhCdXlhYmxlRWFjaCA9IGNyZWF0ZVNlbGVjdG9yKFxuICBSZWlmeS5jb3VudHMsXG4gIFVuaXRUeXBlcy5jb3N0LFxuICAoYmFuaywgY29zdCkgPT5cbiAgICBfLm1hcChcbiAgICAgIChbbmFtZTogc3RyaW5nLCBjOiBEZWNpbWFsXSkgPT4gYmFua1tuYW1lXS5kaXZpZGVkQnkoYykuZmxvb3IoKSxcbiAgICAgIF8uZW50cmllcyhjb3N0KSxcbiAgICApLFxuKVxuZXhwb3J0IGNvbnN0IG1heEJ1eWFibGUgPSBjcmVhdGVTZWxlY3RvcihcbiAgbWF4QnV5YWJsZUVhY2gsXG4gIG1heEVhY2ggPT4gKG1heEVhY2gubGVuZ3RoID8gRGVjaW1hbC5taW4oLi4ubWF4RWFjaCkgOiBEZWNpbWFsKDApKSxcbilcbiJdfQ==

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoneTypes = exports.UnitTypes = exports.SoldierTypes = exports.EnvConfig = exports.AchievementTypes = exports.reducer = undefined;

var _achievementTypes = __webpack_require__(226);

var AchievementTypes = _interopRequireWildcard(_achievementTypes);

var _envConfig = __webpack_require__(814);

var EnvConfig = _interopRequireWildcard(_envConfig);

var _soldierTypes = __webpack_require__(228);

var SoldierTypes = _interopRequireWildcard(_soldierTypes);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _zoneTypes = __webpack_require__(156);

var ZoneTypes = _interopRequireWildcard(_zoneTypes);

var _redux = __webpack_require__(59);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = (0, _redux.combineReducers)({
  achievementTypes: AchievementTypes.reducer,
  envConfig: EnvConfig.reducer,
  soldierTypes: SoldierTypes.reducer,
  unitTypes: UnitTypes.reducer,
  zoneTypes: ZoneTypes.reducer
});
exports.AchievementTypes = AchievementTypes;
exports.EnvConfig = EnvConfig;
exports.SoldierTypes = SoldierTypes;
exports.UnitTypes = UnitTypes;
exports.ZoneTypes = ZoneTypes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2luZGV4LmpzIl0sIm5hbWVzIjpbIkFjaGlldmVtZW50VHlwZXMiLCJFbnZDb25maWciLCJTb2xkaWVyVHlwZXMiLCJVbml0VHlwZXMiLCJab25lVHlwZXMiLCJyZWR1Y2VyIiwiYWNoaWV2ZW1lbnRUeXBlcyIsImVudkNvbmZpZyIsInNvbGRpZXJUeXBlcyIsInVuaXRUeXBlcyIsInpvbmVUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxnQjs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsWTs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsUzs7QUFDWjs7OztBQVNPLElBQU1DLDRCQUFVLDRCQUFnQjtBQUNyQ0Msb0JBQWtCTixpQkFBaUJLLE9BREU7QUFFckNFLGFBQVdOLFVBQVVJLE9BRmdCO0FBR3JDRyxnQkFBY04sYUFBYUcsT0FIVTtBQUlyQ0ksYUFBV04sVUFBVUUsT0FKZ0I7QUFLckNLLGFBQVdOLFVBQVVDO0FBTGdCLENBQWhCLENBQWhCO1FBT0NMLGdCLEdBQUFBLGdCO1FBQWtCQyxTLEdBQUFBLFM7UUFBV0MsWSxHQUFBQSxZO1FBQWNDLFMsR0FBQUEsUztRQUFXQyxTLEdBQUFBLFMiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgQWNoaWV2ZW1lbnRUeXBlcyBmcm9tIFwiLi9hY2hpZXZlbWVudC10eXBlc1wiXG5pbXBvcnQgKiBhcyBFbnZDb25maWcgZnJvbSBcIi4vZW52LWNvbmZpZ1wiXG5pbXBvcnQgKiBhcyBTb2xkaWVyVHlwZXMgZnJvbSBcIi4vc29sZGllci10eXBlc1wiXG5pbXBvcnQgKiBhcyBVbml0VHlwZXMgZnJvbSBcIi4vdW5pdC10eXBlc1wiXG5pbXBvcnQgKiBhcyBab25lVHlwZXMgZnJvbSBcIi4vem9uZS10eXBlc1wiXG5pbXBvcnQge2NvbWJpbmVSZWR1Y2Vyc30gZnJvbSBcInJlZHV4XCJcblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7fFxuICArYWNoaWV2ZW1lbnRUeXBlczogQWNoaWV2ZW1lbnRUeXBlcy5TdGF0ZSxcbiAgK2VudkNvbmZpZzogRW52Q29uZmlnLlN0YXRlLFxuICArc29sZGllclR5cGVzOiBTb2xkaWVyVHlwZXMuU3RhdGUsXG4gICt1bml0VHlwZXM6IFVuaXRUeXBlcy5TdGF0ZSxcbiAgK3pvbmVUeXBlczogWm9uZVR5cGVzLlN0YXRlLFxufH1cbmV4cG9ydCBjb25zdCByZWR1Y2VyID0gY29tYmluZVJlZHVjZXJzKHtcbiAgYWNoaWV2ZW1lbnRUeXBlczogQWNoaWV2ZW1lbnRUeXBlcy5yZWR1Y2VyLFxuICBlbnZDb25maWc6IEVudkNvbmZpZy5yZWR1Y2VyLFxuICBzb2xkaWVyVHlwZXM6IFNvbGRpZXJUeXBlcy5yZWR1Y2VyLFxuICB1bml0VHlwZXM6IFVuaXRUeXBlcy5yZWR1Y2VyLFxuICB6b25lVHlwZXM6IFpvbmVUeXBlcy5yZWR1Y2VyLFxufSlcbmV4cG9ydCB7QWNoaWV2ZW1lbnRUeXBlcywgRW52Q29uZmlnLCBTb2xkaWVyVHlwZXMsIFVuaXRUeXBlcywgWm9uZVR5cGVzfVxuIl19

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.envName = exports.reducer = undefined;

var _EnvConfig = __webpack_require__(155);

var EnvConfig = _interopRequireWildcard(_EnvConfig);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = EnvConfig.reduceEntities;
var envName = exports.envName = function envName() {
  return EnvConfig.config.envName;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2Vudi1jb25maWcuanMiXSwibmFtZXMiOlsiRW52Q29uZmlnIiwicmVkdWNlciIsInJlZHVjZUVudGl0aWVzIiwiZW52TmFtZSIsImNvbmZpZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxTOzs7O0FBR0wsSUFBTUMsNEJBQVVELFVBQVVFLGNBQTFCO0FBQ0EsSUFBTUMsNEJBQVUsU0FBVkEsT0FBVTtBQUFBLFNBQU1ILFVBQVVJLE1BQVYsQ0FBaUJELE9BQXZCO0FBQUEsQ0FBaEIiLCJmaWxlIjoiZW52LWNvbmZpZy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBFbnZDb25maWcgZnJvbSBcIi4uLy4uL3JlZHV4L0VudkNvbmZpZ1wiXG5cbmV4cG9ydCB0eXBlIFN0YXRlID0gRW52Q29uZmlnLkNvbmZpZ1xuZXhwb3J0IGNvbnN0IHJlZHVjZXIgPSBFbnZDb25maWcucmVkdWNlRW50aXRpZXNcbmV4cG9ydCBjb25zdCBlbnZOYW1lID0gKCkgPT4gRW52Q29uZmlnLmNvbmZpZy5lbnZOYW1lXG4iXX0=

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyN = exports.reducer = undefined;

var _buyN = __webpack_require__(816);

var BuyN = _interopRequireWildcard(_buyN);

var _redux = __webpack_require__(59);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = (0, _redux.combineReducers)({
  buyN: BuyN.reducer
});
exports.BuyN = BuyN;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvaW5kZXguanMiXSwibmFtZXMiOlsiQnV5TiIsInJlZHVjZXIiLCJidXlOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7O0FBQ1o7Ozs7QUFLTyxJQUFNQyw0QkFBVSw0QkFBZ0I7QUFDckNDLFFBQU1GLEtBQUtDO0FBRDBCLENBQWhCLENBQWhCO1FBR0NELEksR0FBQUEsSSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBCdXlOIGZyb20gXCIuL2J1eS1uXCJcbmltcG9ydCB7Y29tYmluZVJlZHVjZXJzfSBmcm9tIFwicmVkdXhcIlxuXG5leHBvcnQgdHlwZSBTdGF0ZSA9IHt8XG4gICtidXlOOiBCdXlOLlN0YXRlLFxufH1cbmV4cG9ydCBjb25zdCByZWR1Y2VyID0gY29tYmluZVJlZHVjZXJzKHtcbiAgYnV5TjogQnV5Ti5yZWR1Y2VyLFxufSlcbmV4cG9ydCB7QnV5Tn1cbiJdfQ==

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = __webpack_require__(817);

Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _root[key];
    }
  });
});

var _types = __webpack_require__(230);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvYnV5LW4vaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7Ozs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuZXhwb3J0ICogZnJvbSBcIi4vcm9vdFwiXG5leHBvcnQgKiBmcm9tIFwiLi90eXBlc1wiXG4iXX0=

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBuyButtonDisabled = exports.relatedUnitDetailsMode = exports.buyCost1 = exports.buyCost = exports.buyCount = exports.isInputError = exports.parsed = exports.hasInput = exports.input = exports.localState = exports.setBuyN = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reducer = reducer;

var _types = __webpack_require__(230);

var T = _interopRequireWildcard(_types);

var _util = __webpack_require__(13);

var Util = _interopRequireWildcard(_util);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _parse = __webpack_require__(818);

var _parse2 = _interopRequireDefault(_parse);

var _assert = __webpack_require__(12);

var _unitTypes = __webpack_require__(74);

var UnitTypes = _interopRequireWildcard(_unitTypes);

var _characters = __webpack_require__(358);

var C = _interopRequireWildcard(_characters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setBuyN = exports.setBuyN = function setBuyN(input, unitName) {
  return { type: "form/buyN", unitName: unitName, input: input };
};

var state0 = {};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state0;
  var action = arguments[1];

  switch (action && action.type) {
    case "form/buyN":
      {
        var _unitName = action.unitName,
            _input = action.input;

        return _extends({}, state, _defineProperty({}, _unitName, { input: _input }));
      }
    default:
      return state;
  }
}

var localState = exports.localState = function localState(state, props) {
  return props.mockBuyN ? props.mockBuyN : state.forms.buyN;
};
var unitNameProp = function unitNameProp(state, props) {
  return props.unitName;
};
var unitState = (0, _reselect.createSelector)(localState, unitNameProp, function (state, name) {
  return state[name];
});
// This is a form; default empty-string is appropriate.
// No state - we use this with other selectors, but it's usually more
// appropriate to store the state in the UI, component/container-local
var input = exports.input = (0, _reselect.createSelector)(unitState, function (state) {
  return state ? state.input : "";
});

var hasInput = exports.hasInput = (0, _reselect.createSelector)(input, function (input) {
  return !!input;
}); // exported for tests
var parsed = exports.parsed = (0, _reselect.createSelector)(input, _parse2.default); // exported for tests
var isInputError = exports.isInputError = (0, _reselect.createSelector)(parsed, function (p) {
  return p.type === "error";
});

var _buyCount = (0, _reselect.createSelector)(parsed, C.units.count, C.units.maxBuyable, function (parsed, count, max) {
  switch (parsed.type) {
    case "%":
      return max.times(parsed.val).floor();
    case "=":
      // TODO implement twins
      return parsed.val;
    case "@":
      // TODO implement twins
      return parsed.val.minus(count);
    case "val":
    case "empty":
    case "error":
      return parsed.val;
    default:
      return (0, _assert.throws)("invalid buyN", { parsed: parsed, count: count, max: max });
  }
});
// buyCount has strict upper/lower bounds applied to any parsed value.
// Note that when you can't afford a unit, buyCount (1) is greater than max (0).
var buyCount = exports.buyCount = (0, _reselect.createSelector)(C.units.maxBuyable, _buyCount, function (max, count) {
  return T.Decimal.max(1, T.Decimal.min(max, count));
});
var buyCost = exports.buyCost = (0, _reselect.createSelector)(buyCount, C.units.costEach, function (count, costs) {
  return _lodash2.default.mapValues(costs, function (v) {
    return count.times(v);
  });
});
// This is for the right-side unit nav. we're viewing one unit (parentUnitName),
// and showing a list of related units (unitName)
function withParentUnit(selector) {
  return function (state, _ref) {
    var parentUnitName = _ref.parentUnitName,
        props = _objectWithoutProperties(_ref, ["parentUnitName"]);

    return selector(state, _extends({}, props, { unitName: parentUnitName }));
  };
}
var buyCost1 = exports.buyCost1 = (0, _reselect.createSelector)(withParentUnit(buyCost), unitNameProp, function (costs, unitName) {
  return costs[unitName];
});
// Decides what's shown for the second line of UnitNav: cost, velocity, or nothing
var relatedUnitDetailsMode = exports.relatedUnitDetailsMode = withParentUnit((0, _reselect.createSelector)(hasInput, UnitTypes.isProducible, function (hasInput, isProducible) {
  return hasInput ? "cost" : isProducible ? "velocity" : "empty";
}));
var isBuyButtonDisabled = exports.isBuyButtonDisabled = (0, _reselect.createSelector)(buyCount, C.units.maxBuyable, function (count, max) {
  return count.greaterThan(max);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvYnV5LW4vcm9vdC5qcyJdLCJuYW1lcyI6WyJyZWR1Y2VyIiwiVCIsIlV0aWwiLCJVbml0VHlwZXMiLCJDIiwic2V0QnV5TiIsImlucHV0IiwidW5pdE5hbWUiLCJ0eXBlIiwic3RhdGUwIiwic3RhdGUiLCJhY3Rpb24iLCJsb2NhbFN0YXRlIiwicHJvcHMiLCJtb2NrQnV5TiIsImZvcm1zIiwiYnV5TiIsInVuaXROYW1lUHJvcCIsInVuaXRTdGF0ZSIsIm5hbWUiLCJoYXNJbnB1dCIsInBhcnNlZCIsImlzSW5wdXRFcnJvciIsInAiLCJfYnV5Q291bnQiLCJ1bml0cyIsImNvdW50IiwibWF4QnV5YWJsZSIsIm1heCIsInRpbWVzIiwidmFsIiwiZmxvb3IiLCJtaW51cyIsImJ1eUNvdW50IiwiRGVjaW1hbCIsIm1pbiIsImJ1eUNvc3QiLCJjb3N0RWFjaCIsImNvc3RzIiwibWFwVmFsdWVzIiwidiIsIndpdGhQYXJlbnRVbml0Iiwic2VsZWN0b3IiLCJwYXJlbnRVbml0TmFtZSIsImJ1eUNvc3QxIiwicmVsYXRlZFVuaXREZXRhaWxzTW9kZSIsImlzUHJvZHVjaWJsZSIsImlzQnV5QnV0dG9uRGlzYWJsZWQiLCJncmVhdGVyVGhhbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O1FBY2dCQSxPLEdBQUFBLE87O0FBYmhCOztJQUFZQyxDOztBQUNaOztJQUFZQyxJOztBQUNaOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7SUFBWUMsUzs7QUFDWjs7SUFBWUMsQzs7Ozs7Ozs7OztBQUVMLElBQU1DLDRCQUFVLFNBQVZBLE9BQVUsQ0FBQ0MsS0FBRCxFQUFnQkMsUUFBaEI7QUFBQSxTQUNwQixFQUFDQyxNQUFNLFdBQVAsRUFBb0JELGtCQUFwQixFQUE4QkQsWUFBOUIsRUFEb0I7QUFBQSxDQUFoQjs7QUFHUCxJQUFNRyxTQUFTLEVBQWY7QUFDTyxTQUFTVCxPQUFULEdBQXFFO0FBQUEsTUFBcERVLEtBQW9ELHVFQUFuQ0QsTUFBbUM7QUFBQSxNQUEzQkUsTUFBMkI7O0FBQzFFLFVBQVFBLFVBQVVBLE9BQU9ILElBQXpCO0FBQ0UsU0FBSyxXQUFMO0FBQWtCO0FBQUEsWUFDVEQsU0FEUyxHQUNVSSxNQURWLENBQ1RKLFFBRFM7QUFBQSxZQUNDRCxNQURELEdBQ1VLLE1BRFYsQ0FDQ0wsS0FERDs7QUFFaEIsNEJBQVdJLEtBQVgsc0JBQW1CSCxTQUFuQixFQUE4QixFQUFDRCxhQUFELEVBQTlCO0FBQ0Q7QUFDRDtBQUNFLGFBQU9JLEtBQVA7QUFOSjtBQVFEOztBQUVNLElBQU1FLGtDQUFhLFNBQWJBLFVBQWEsQ0FDeEJGLEtBRHdCLEVBRXhCRyxLQUZ3QjtBQUFBLFNBR1hBLE1BQU1DLFFBQU4sR0FBaUJELE1BQU1DLFFBQXZCLEdBQWtDSixNQUFNSyxLQUFOLENBQVlDLElBSG5DO0FBQUEsQ0FBbkI7QUFJUCxJQUFNQyxlQUFlLFNBQWZBLFlBQWUsQ0FBQ1AsS0FBRCxFQUFhRyxLQUFiO0FBQUEsU0FBMkNBLE1BQU1OLFFBQWpEO0FBQUEsQ0FBckI7QUFDQSxJQUFNVyxZQUFZLDhCQUNoQk4sVUFEZ0IsRUFFaEJLLFlBRmdCLEVBR2hCLFVBQUNQLEtBQUQsRUFBUVMsSUFBUjtBQUFBLFNBQWlCVCxNQUFNUyxJQUFOLENBQWpCO0FBQUEsQ0FIZ0IsQ0FBbEI7QUFLQTtBQUNBO0FBQ0E7QUFDTyxJQUFNYix3QkFBUSw4QkFDbkJZLFNBRG1CLEVBRW5CO0FBQUEsU0FBVVIsUUFBUUEsTUFBTUosS0FBZCxHQUFzQixFQUFoQztBQUFBLENBRm1CLENBQWQ7O0FBS0EsSUFBTWMsOEJBQVcsOEJBQWVkLEtBQWYsRUFBc0I7QUFBQSxTQUFTLENBQUMsQ0FBQ0EsS0FBWDtBQUFBLENBQXRCLENBQWpCLEMsQ0FBeUQ7QUFDekQsSUFBTWUsMEJBQVMsOEJBQWVmLEtBQWYsa0JBQWYsQyxDQUE0QztBQUM1QyxJQUFNZ0Isc0NBQWUsOEJBQWVELE1BQWYsRUFBdUI7QUFBQSxTQUFLRSxFQUFFZixJQUFGLEtBQVcsT0FBaEI7QUFBQSxDQUF2QixDQUFyQjs7QUFFUCxJQUFNZ0IsWUFBWSw4QkFDaEJILE1BRGdCLEVBRWhCakIsRUFBRXFCLEtBQUYsQ0FBUUMsS0FGUSxFQUdoQnRCLEVBQUVxQixLQUFGLENBQVFFLFVBSFEsRUFJaEIsVUFBQ04sTUFBRCxFQUFTSyxLQUFULEVBQWdCRSxHQUFoQixFQUF3QjtBQUN0QixVQUFRUCxPQUFPYixJQUFmO0FBQ0UsU0FBSyxHQUFMO0FBQ0UsYUFBT29CLElBQUlDLEtBQUosQ0FBVVIsT0FBT1MsR0FBakIsRUFBc0JDLEtBQXRCLEVBQVA7QUFDRixTQUFLLEdBQUw7QUFDRTtBQUNBLGFBQU9WLE9BQU9TLEdBQWQ7QUFDRixTQUFLLEdBQUw7QUFDRTtBQUNBLGFBQU9ULE9BQU9TLEdBQVAsQ0FBV0UsS0FBWCxDQUFpQk4sS0FBakIsQ0FBUDtBQUNGLFNBQUssS0FBTDtBQUNBLFNBQUssT0FBTDtBQUNBLFNBQUssT0FBTDtBQUNFLGFBQU9MLE9BQU9TLEdBQWQ7QUFDRjtBQUNFLGFBQU8sb0JBQU8sY0FBUCxFQUF1QixFQUFDVCxjQUFELEVBQVNLLFlBQVQsRUFBZ0JFLFFBQWhCLEVBQXZCLENBQVA7QUFkSjtBQWdCRCxDQXJCZSxDQUFsQjtBQXVCQTtBQUNBO0FBQ08sSUFBTUssOEJBQVcsOEJBQ3RCN0IsRUFBRXFCLEtBQUYsQ0FBUUUsVUFEYyxFQUV0QkgsU0FGc0IsRUFHdEIsVUFBQ0ksR0FBRCxFQUFNRixLQUFOO0FBQUEsU0FBZ0J6QixFQUFFaUMsT0FBRixDQUFVTixHQUFWLENBQWMsQ0FBZCxFQUFpQjNCLEVBQUVpQyxPQUFGLENBQVVDLEdBQVYsQ0FBY1AsR0FBZCxFQUFtQkYsS0FBbkIsQ0FBakIsQ0FBaEI7QUFBQSxDQUhzQixDQUFqQjtBQUtBLElBQU1VLDRCQUFVLDhCQUNyQkgsUUFEcUIsRUFFckI3QixFQUFFcUIsS0FBRixDQUFRWSxRQUZhLEVBR3JCLFVBQUNYLEtBQUQsRUFBbUJZLEtBQW5CO0FBQUEsU0FDRSxpQkFBRUMsU0FBRixDQUFZRCxLQUFaLEVBQW1CO0FBQUEsV0FBS1osTUFBTUcsS0FBTixDQUFZVyxDQUFaLENBQUw7QUFBQSxHQUFuQixDQURGO0FBQUEsQ0FIcUIsQ0FBaEI7QUFNUDtBQUNBO0FBQ0EsU0FBU0MsY0FBVCxDQUF3QkMsUUFBeEIsRUFBa0M7QUFDaEMsU0FBTyxVQUNMaEMsS0FESztBQUFBLFFBRUppQyxjQUZJLFFBRUpBLGNBRkk7QUFBQSxRQUVlOUIsS0FGZjs7QUFBQSxXQUdTNkIsU0FBU2hDLEtBQVQsZUFBb0JHLEtBQXBCLElBQTJCTixVQUFVb0MsY0FBckMsSUFIVDtBQUFBLEdBQVA7QUFJRDtBQUNNLElBQU1DLDhCQUFXLDhCQUN0QkgsZUFBZUwsT0FBZixDQURzQixFQUV0Qm5CLFlBRnNCLEVBR3RCLFVBQUNxQixLQUFELEVBQStCL0IsUUFBL0I7QUFBQSxTQUNFK0IsTUFBTS9CLFFBQU4sQ0FERjtBQUFBLENBSHNCLENBQWpCO0FBTVA7QUFDTyxJQUFNc0MsMERBQXlCSixlQUNwQyw4QkFDRXJCLFFBREYsRUFFRWpCLFVBQVUyQyxZQUZaLEVBR0UsVUFBQzFCLFFBQUQsRUFBVzBCLFlBQVg7QUFBQSxTQUNFMUIsV0FBVyxNQUFYLEdBQW9CMEIsZUFBZSxVQUFmLEdBQTRCLE9BRGxEO0FBQUEsQ0FIRixDQURvQyxDQUEvQjtBQVFBLElBQU1DLG9EQUFzQiw4QkFDakNkLFFBRGlDLEVBRWpDN0IsRUFBRXFCLEtBQUYsQ0FBUUUsVUFGeUIsRUFHakMsVUFBQ0QsS0FBRCxFQUFRRSxHQUFSO0FBQUEsU0FBZ0JGLE1BQU1zQixXQUFOLENBQWtCcEIsR0FBbEIsQ0FBaEI7QUFBQSxDQUhpQyxDQUE1QiIsImZpbGUiOiJyb290LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCAqIGFzIFQgZnJvbSBcIi4vdHlwZXNcIlxuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgcGFyc2UgZnJvbSBcIi4vcGFyc2VcIlxuaW1wb3J0IHt0aHJvd3N9IGZyb20gXCJAc3dhcm0yL2Fzc2VydFwiXG5pbXBvcnQgKiBhcyBVbml0VHlwZXMgZnJvbSBcIi4uLy4uL2VudGl0aWVzMi91bml0LXR5cGVzXCJcbmltcG9ydCAqIGFzIEMgZnJvbSBcIi4uLy4uL2ZpcmViYXNlL2NoYXJhY3RlcnMyXCJcblxuZXhwb3J0IGNvbnN0IHNldEJ1eU4gPSAoaW5wdXQ6IHN0cmluZywgdW5pdE5hbWU6IHN0cmluZykgPT5cbiAgKHt0eXBlOiBcImZvcm0vYnV5TlwiLCB1bml0TmFtZSwgaW5wdXR9OiBULkFjdGlvbilcblxuY29uc3Qgc3RhdGUwID0ge31cbmV4cG9ydCBmdW5jdGlvbiByZWR1Y2VyKHN0YXRlOiBULlN0YXRlID0gc3RhdGUwLCBhY3Rpb246IFQuQWN0aW9uKTogVC5TdGF0ZSB7XG4gIHN3aXRjaCAoYWN0aW9uICYmIGFjdGlvbi50eXBlKSB7XG4gICAgY2FzZSBcImZvcm0vYnV5TlwiOiB7XG4gICAgICBjb25zdCB7dW5pdE5hbWUsIGlucHV0fSA9IGFjdGlvblxuICAgICAgcmV0dXJuIHsuLi5zdGF0ZSwgW3VuaXROYW1lXToge2lucHV0fX1cbiAgICB9XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBzdGF0ZVxuICB9XG59XG5cbmV4cG9ydCBjb25zdCBsb2NhbFN0YXRlID0gKFxuICBzdGF0ZTogVXRpbC5Sb290U3RhdGUsXG4gIHByb3BzOiB7bW9ja0J1eU4/OiBULlN0YXRlfSxcbik6IFQuU3RhdGUgPT4gKHByb3BzLm1vY2tCdXlOID8gcHJvcHMubW9ja0J1eU4gOiBzdGF0ZS5mb3Jtcy5idXlOKVxuY29uc3QgdW5pdE5hbWVQcm9wID0gKHN0YXRlOiBhbnksIHByb3BzOiB7dW5pdE5hbWU6IHN0cmluZ30pID0+IHByb3BzLnVuaXROYW1lXG5jb25zdCB1bml0U3RhdGUgPSBjcmVhdGVTZWxlY3RvcihcbiAgbG9jYWxTdGF0ZSxcbiAgdW5pdE5hbWVQcm9wLFxuICAoc3RhdGUsIG5hbWUpID0+IHN0YXRlW25hbWVdLFxuKVxuLy8gVGhpcyBpcyBhIGZvcm07IGRlZmF1bHQgZW1wdHktc3RyaW5nIGlzIGFwcHJvcHJpYXRlLlxuLy8gTm8gc3RhdGUgLSB3ZSB1c2UgdGhpcyB3aXRoIG90aGVyIHNlbGVjdG9ycywgYnV0IGl0J3MgdXN1YWxseSBtb3JlXG4vLyBhcHByb3ByaWF0ZSB0byBzdG9yZSB0aGUgc3RhdGUgaW4gdGhlIFVJLCBjb21wb25lbnQvY29udGFpbmVyLWxvY2FsXG5leHBvcnQgY29uc3QgaW5wdXQgPSBjcmVhdGVTZWxlY3RvcihcbiAgdW5pdFN0YXRlLFxuICBzdGF0ZSA9PiAoc3RhdGUgPyBzdGF0ZS5pbnB1dCA6IFwiXCIpLFxuKVxuXG5leHBvcnQgY29uc3QgaGFzSW5wdXQgPSBjcmVhdGVTZWxlY3RvcihpbnB1dCwgaW5wdXQgPT4gISFpbnB1dCkgLy8gZXhwb3J0ZWQgZm9yIHRlc3RzXG5leHBvcnQgY29uc3QgcGFyc2VkID0gY3JlYXRlU2VsZWN0b3IoaW5wdXQsIHBhcnNlKSAvLyBleHBvcnRlZCBmb3IgdGVzdHNcbmV4cG9ydCBjb25zdCBpc0lucHV0RXJyb3IgPSBjcmVhdGVTZWxlY3RvcihwYXJzZWQsIHAgPT4gcC50eXBlID09PSBcImVycm9yXCIpXG5cbmNvbnN0IF9idXlDb3VudCA9IGNyZWF0ZVNlbGVjdG9yKFxuICBwYXJzZWQsXG4gIEMudW5pdHMuY291bnQsXG4gIEMudW5pdHMubWF4QnV5YWJsZSxcbiAgKHBhcnNlZCwgY291bnQsIG1heCkgPT4ge1xuICAgIHN3aXRjaCAocGFyc2VkLnR5cGUpIHtcbiAgICAgIGNhc2UgXCIlXCI6XG4gICAgICAgIHJldHVybiBtYXgudGltZXMocGFyc2VkLnZhbCkuZmxvb3IoKVxuICAgICAgY2FzZSBcIj1cIjpcbiAgICAgICAgLy8gVE9ETyBpbXBsZW1lbnQgdHdpbnNcbiAgICAgICAgcmV0dXJuIHBhcnNlZC52YWxcbiAgICAgIGNhc2UgXCJAXCI6XG4gICAgICAgIC8vIFRPRE8gaW1wbGVtZW50IHR3aW5zXG4gICAgICAgIHJldHVybiBwYXJzZWQudmFsLm1pbnVzKGNvdW50KVxuICAgICAgY2FzZSBcInZhbFwiOlxuICAgICAgY2FzZSBcImVtcHR5XCI6XG4gICAgICBjYXNlIFwiZXJyb3JcIjpcbiAgICAgICAgcmV0dXJuIHBhcnNlZC52YWxcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIHJldHVybiB0aHJvd3MoXCJpbnZhbGlkIGJ1eU5cIiwge3BhcnNlZCwgY291bnQsIG1heH0pXG4gICAgfVxuICB9LFxuKVxuLy8gYnV5Q291bnQgaGFzIHN0cmljdCB1cHBlci9sb3dlciBib3VuZHMgYXBwbGllZCB0byBhbnkgcGFyc2VkIHZhbHVlLlxuLy8gTm90ZSB0aGF0IHdoZW4geW91IGNhbid0IGFmZm9yZCBhIHVuaXQsIGJ1eUNvdW50ICgxKSBpcyBncmVhdGVyIHRoYW4gbWF4ICgwKS5cbmV4cG9ydCBjb25zdCBidXlDb3VudCA9IGNyZWF0ZVNlbGVjdG9yKFxuICBDLnVuaXRzLm1heEJ1eWFibGUsXG4gIF9idXlDb3VudCxcbiAgKG1heCwgY291bnQpID0+IFQuRGVjaW1hbC5tYXgoMSwgVC5EZWNpbWFsLm1pbihtYXgsIGNvdW50KSksXG4pXG5leHBvcnQgY29uc3QgYnV5Q29zdCA9IGNyZWF0ZVNlbGVjdG9yKFxuICBidXlDb3VudCxcbiAgQy51bml0cy5jb3N0RWFjaCxcbiAgKGNvdW50OiBULkRlY2ltYWwsIGNvc3RzOiB7W3N0cmluZ106IFQuRGVjaW1hbH0pOiB7W3N0cmluZ106IFQuRGVjaW1hbH0gPT5cbiAgICBfLm1hcFZhbHVlcyhjb3N0cywgdiA9PiBjb3VudC50aW1lcyh2KSksXG4pXG4vLyBUaGlzIGlzIGZvciB0aGUgcmlnaHQtc2lkZSB1bml0IG5hdi4gd2UncmUgdmlld2luZyBvbmUgdW5pdCAocGFyZW50VW5pdE5hbWUpLFxuLy8gYW5kIHNob3dpbmcgYSBsaXN0IG9mIHJlbGF0ZWQgdW5pdHMgKHVuaXROYW1lKVxuZnVuY3Rpb24gd2l0aFBhcmVudFVuaXQoc2VsZWN0b3IpIHtcbiAgcmV0dXJuIChcbiAgICBzdGF0ZTogVXRpbC5Sb290U3RhdGUsXG4gICAge3BhcmVudFVuaXROYW1lLCAuLi5wcm9wc306IHtwYXJlbnRVbml0TmFtZTogc3RyaW5nfSxcbiAgKTogJEZsb3dUT0RPID0+IHNlbGVjdG9yKHN0YXRlLCB7Li4ucHJvcHMsIHVuaXROYW1lOiBwYXJlbnRVbml0TmFtZX0pXG59XG5leHBvcnQgY29uc3QgYnV5Q29zdDEgPSBjcmVhdGVTZWxlY3RvcihcbiAgd2l0aFBhcmVudFVuaXQoYnV5Q29zdCksXG4gIHVuaXROYW1lUHJvcCxcbiAgKGNvc3RzOiB7W3N0cmluZ106IFQuRGVjaW1hbH0sIHVuaXROYW1lOiBzdHJpbmcpOiBULkRlY2ltYWwgPT5cbiAgICBjb3N0c1t1bml0TmFtZV0sXG4pXG4vLyBEZWNpZGVzIHdoYXQncyBzaG93biBmb3IgdGhlIHNlY29uZCBsaW5lIG9mIFVuaXROYXY6IGNvc3QsIHZlbG9jaXR5LCBvciBub3RoaW5nXG5leHBvcnQgY29uc3QgcmVsYXRlZFVuaXREZXRhaWxzTW9kZSA9IHdpdGhQYXJlbnRVbml0KFxuICBjcmVhdGVTZWxlY3RvcihcbiAgICBoYXNJbnB1dCxcbiAgICBVbml0VHlwZXMuaXNQcm9kdWNpYmxlLFxuICAgIChoYXNJbnB1dCwgaXNQcm9kdWNpYmxlKSA9PlxuICAgICAgaGFzSW5wdXQgPyBcImNvc3RcIiA6IGlzUHJvZHVjaWJsZSA/IFwidmVsb2NpdHlcIiA6IFwiZW1wdHlcIixcbiAgKSxcbilcbmV4cG9ydCBjb25zdCBpc0J1eUJ1dHRvbkRpc2FibGVkID0gY3JlYXRlU2VsZWN0b3IoXG4gIGJ1eUNvdW50LFxuICBDLnVuaXRzLm1heEJ1eWFibGUsXG4gIChjb3VudCwgbWF4KSA9PiBjb3VudC5ncmVhdGVyVGhhbihtYXgpLFxuKVxuIl19

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// ew... but it gets storybook working without hurting prod.


exports.default = parse;

var _types = __webpack_require__(230);

var T = _interopRequireWildcard(_types);

var _swarmNumberformat = __webpack_require__(378);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var parser = new _swarmNumberformat.Parser({ backend: "decimal.js" });

function parse(text) {
  var result = function result(type, val) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _extends({ text: text, type: type, val: val }, props);
  };
  // optimize a very common case: empty input
  if (!text) {
    return result("empty", T.Decimal(1));
  }
  try {
    if (/%$/.exec(text)) {
      var val = T.Decimal.min(100, T.Decimal.max(0, parser.parse(text.replace("%", "")))).dividedBy(100);
      return result("%", val);
    }
    if (/^=/.exec(text)) {
      return result("=", T.Decimal.max(1, parser.parse(text.replace("=", ""))));
    }
    if (/^@/.exec(text)) {
      return result("@", T.Decimal.max(1, parser.parse(text.replace("@", ""))));
    }
    return result("val", T.Decimal.max(1, parser.parse(text)));
  } catch (error) {
    // bad user input
    return result("error", T.Decimal(1), { error: error });
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.select = select;

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _auth = __webpack_require__(53);

var Auth = _interopRequireWildcard(_auth);

var _queryStatus = __webpack_require__(43);

var Q = _interopRequireWildcard(_queryStatus);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Everything firebase thinks is loading/loaded
var _rawRequesting = function _rawRequesting(root) {
  return root.firebase.requesting;
};
var _rawFirebase = function _rawFirebase(root) {
  return root.firebase;
};
// RRF sometimes flips already-loaded states to loading again for a short moment.
// Unfortunately, this flashes the loading UI for a moment - unacceptable.
// Instead, check if the value exists in firebase.data as a backup loaded-check.
var _rawRequestingExists = (0, _reselect.createSelector)(_rawFirebase, _rawRequesting, function (firebase, requesting) {
  return _lodash2.default.fromPairs(_lodash2.default.map(requesting, function (req, path) {
    return [path, Q.isReqLoaded(firebase, path)];
  }));
});
var _rawRequests = (0, _reselect.createSelector)(_rawRequesting, _rawRequestingExists, function (requesting, exists) {
  return (
    // report each path as pending iff firebase.requesting says it's loading,
    // AND no value already exists at that path.
    _lodash2.default.mergeWith(requesting, exists, function (ing, ex) {
      return ing && !ex;
    })
  );
});
// auth-loaded is a special case
var authRequest = (0, _reselect.createSelector)(Auth.loadStatus, function (status) {
  return status === "pending";
});
var rawRequests = (0, _reselect.createSelector)(_rawRequests, authRequest, function (raw, auth) {
  return _extends({
    auth: auth
  }, raw);
});
// Caller might (or might not) want only a partial list of loaded items. For
// example, the title page should display extra-fast, before everything's loaded.
var filter = function filter(state, props) {
  return props.loadingFilter || null;
};
var lodashFilter = (0, _reselect.createSelector)(filter, function (f) {
  if (!f) return null;
  if (f instanceof RegExp) return function (v, k) {
    return f.test(k);
  };
  return function (v, k) {
    return f(k);
  };
});
// $FlowFixMe
var requests = (0, _reselect.createSelector)(rawRequests, lodashFilter, _lodash2.default.pickBy);
var trueKeys = function trueKeys(obj) {
  return _lodash2.default.keys(_lodash2.default.pickBy(obj));
};
//const falseKeys = obj => _.keys(_.pickBy(obj, v => !v))
var pendingKeys = (0, _reselect.createSelector)(requests, trueKeys);
//const readyKeys = createSelector(requests, falseKeys)
//const keyMap = createSelector(requests, requests =>
//  _.mapValues(requests, val => (val ? "pending" : "ready")),
//)
var isReady = (0, _reselect.createSelector)(pendingKeys, function (keys) {
  return !keys.length;
});
var isPending = _lodash2.default.negate(isReady);
var loading = (0, _reselect.createStructuredSelector)({
  pendingKeys: pendingKeys,
  //readyKeys,
  //keys: keyMap,
  isPending: isPending,
  //isReady,
  isError: function isError() {
    return true;
  }
});
function selectIf(pred, onYes, onNo) {
  return function (state, props) {
    return (
      // $FlowFixMe
      pred(state, props) ? onYes(state, props) : onNo(state, props)
    );
  };
}
function selectUnlessEmpty(empty, onReady) {
  var emptyKeys = (0, _reselect.createSelector)(empty, trueKeys);
  var isEmpty = (0, _reselect.createSelector)(emptyKeys, function (keys) {
    return !!keys.length;
  });
  var onEmpty = (0, _reselect.createStructuredSelector)({
    isEmpty: isEmpty,
    emptyKeys: emptyKeys,
    isError: function isError() {
      return true;
    }
  });
  return selectIf(_lodash2.default.negate(isEmpty), onReady, onEmpty);
}
// The main workhorse.
function select(opts) {
  var loadingFilter = opts.loadingFilter,
      empty = opts.empty,
      onReady = opts.onReady;

  var afterPending = empty ? selectUnlessEmpty(empty, onReady) : onReady;
  var _isReady = loadingFilter ? function (s, p) {
    return isReady(s, _extends({}, p, { loadingFilter: loadingFilter }));
  } : isReady;
  var _loading = loadingFilter ? function (s, p) {
    return loading(s, _extends({}, p, { loadingFilter: loadingFilter }));
  } : loading;
  return selectIf(_isReady, afterPending, _loading);
}
//export function selectOnReady<S: RootState, P: {}, O>(
//  onReady: (S, P) => O,
//): (S, P) => O {
//  return select({onReady})
//}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = exports.isEmpty = exports.localState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _queryStatus = __webpack_require__(43);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var nameProp = function nameProp(state, props) {
  return (0, _assert.assertDefined)(props.rankName, "rankName");
};
var leagueProp = function leagueProp(state, props) {
  return props.league;
};
var path = (0, _reselect.createSelector)((0, _reselect.createStructuredSelector)({
  rankName: nameProp,
  league: leagueProp
}), paths.rankings.data);
var localState = exports.localState = (0, _queryStatus.selectPath)(path);
var isEmpty = exports.isEmpty = _queryStatus.selectPath.isEmpty(path);

var list = exports.list = (0, _reselect.createSelector)(localState, function (state) {
  return (0, _lodash2.default)(state).keys().map(function (charId) {
    return _extends({}, state[charId], { charId: charId });
  })
  // limitToFirst=100 makes this sort safe. It's sorted server-side, but returns unsorted objects
  // If value is missing, it goes to the bottom of the list. This happens for units with zero-count, since we sort on ln(count).
  .sortBy(function (s) {
    return s.value != null ? s.value : -Infinity;
  }).reverse().value();
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getContext = __webpack_require__(822);

var _getContext2 = _interopRequireDefault(_getContext);

var _mapProps = __webpack_require__(159);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _branch = __webpack_require__(111);

var _branch2 = _interopRequireDefault(_branch);

var _reactReduxFirebase = __webpack_require__(130);

var _Offline = __webpack_require__(380);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//export const firebaseConnect = realFirebaseConnect
var FirebaseOffline = function () {
  function FirebaseOffline() {
    _classCallCheck(this, FirebaseOffline);
  }

  _createClass(FirebaseOffline, [{
    key: "auth",
    value: function auth() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "database",
    value: function database() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "ref",
    value: function ref() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "set",
    value: function set() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "push",
    value: function push() {
      throw new Error("firebase is offline");
    }
  }]);

  return FirebaseOffline;
}();

exports.default = function (query) {
  var connectIfOnline = (0, _branch2.default)(function (props) {
    return (0, _Offline.isStateOffline)(props.store.getState());
  }, (0, _withProps2.default)(function (props) {
    return {
      firebase: props.firebase || new FirebaseOffline()
    };
  }), (0, _reactReduxFirebase.firebaseConnect)(query));
  // During tests, we pass the redux store as a prop . In production, we use
  // <Provider> to provide store as context. react-redux.connect() works this
  // way.
  return (0, _branch2.default)(function (props) {
    return props.store;
  }, connectIfOnline, _lodash2.default.flowRight((0, _getContext2.default)({ store: _propTypes2.default.object }), connectIfOnline, (0, _mapProps2.default)(function (props) {
    return _lodash2.default.omit(props, ["store"]);
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

exports.default = getContext;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if ("production" === 'production' && !hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(826);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes);
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
};

exports.default = isClassComponent;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = undefined;

var _EnvConfig = __webpack_require__(155);

var _EnvConfig2 = _interopRequireDefault(_EnvConfig);

var _firebase = __webpack_require__(154);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// don't init firebase if we're on the server, it's done elsewhere. this is for clients.
var config = exports.config = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_FIREBASE_ENV":"swarm2-dev"}).GCLOUD_PROJECT ? null : _EnvConfig2.default.firebase;
if (config) {
  _firebase2.default.initializeApp(config);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1eC9GaXJlYmFzZS5qcyJdLCJuYW1lcyI6WyJjb25maWciLCJwcm9jZXNzIiwiZW52IiwiR0NMT1VEX1BST0pFQ1QiLCJmaXJlYmFzZSIsImluaXRpYWxpemVBcHAiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQTtBQUNPLElBQU1BLDBCQUFTQyxRQUFRQyxHQUFSLENBQVlDLGNBQVosR0FBNkIsSUFBN0IsR0FBb0Msb0JBQVVDLFFBQTdEO0FBQ1AsSUFBSUosTUFBSixFQUFZO0FBQ1YscUJBQVNLLGFBQVQsQ0FBdUJMLE1BQXZCO0FBQ0QiLCJmaWxlIjoiRmlyZWJhc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IGVudkNvbmZpZyBmcm9tIFwiLi9FbnZDb25maWdcIlxuaW1wb3J0IGZpcmViYXNlIGZyb20gXCJmaXJlYmFzZVwiXG5cbi8vIGRvbid0IGluaXQgZmlyZWJhc2UgaWYgd2UncmUgb24gdGhlIHNlcnZlciwgaXQncyBkb25lIGVsc2V3aGVyZS4gdGhpcyBpcyBmb3IgY2xpZW50cy5cbmV4cG9ydCBjb25zdCBjb25maWcgPSBwcm9jZXNzLmVudi5HQ0xPVURfUFJPSkVDVCA/IG51bGwgOiBlbnZDb25maWcuZmlyZWJhc2VcbmlmIChjb25maWcpIHtcbiAgZmlyZWJhc2UuaW5pdGlhbGl6ZUFwcChjb25maWcpXG59XG4iXX0=

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMiddleware = undefined;

var _reactReduxFirebase = __webpack_require__(130);

var _firebase = __webpack_require__(154);

var _firebase2 = _interopRequireDefault(_firebase);

var _reduxThunk = __webpack_require__(829);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = __webpack_require__(59);

var _authLoaded = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/prescottprue/react-redux-firebase
var withFirebase = function withFirebase(opts) {
  if (opts.isOffline) return function (C) {
    return C;
  };
  return (0, _reactReduxFirebase.reactReduxFirebase)(_firebase2.default, {
    userProfile: "/users",
    enableLogging: !!opts.enableLogging
  });
};

var withThunk = function withThunk(opts) {
  return (0, _redux.applyMiddleware)(_reduxThunk2.default.withExtraArgument({ getFirebase: _reactReduxFirebase.getFirebase }));
};
var withMyAuth = function withMyAuth(opts) {
  if (opts.isOffline) return function (C) {
    return C;
  };
  return (0, _redux.applyMiddleware)(_authLoaded.middleware);
};

var withMiddleware = exports.withMiddleware = function withMiddleware(opts) {
  return [withFirebase(opts), withThunk(opts), withMyAuth(opts)];
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.willReceiveProps = exports.users = exports.updateWatcher = exports.units = exports.statistics = exports.rankings = exports.options = exports.nav = exports.debug = exports.common = exports.combat = exports.characters = exports.beta = exports.authSignin = exports.app = exports.achievements = undefined;

var _achievements = __webpack_require__(831);

var achievements = _interopRequireWildcard(_achievements);

var _app = __webpack_require__(381);

var app = _interopRequireWildcard(_app);

var _authSignin = __webpack_require__(832);

var authSignin = _interopRequireWildcard(_authSignin);

var _beta = __webpack_require__(840);

var beta = _interopRequireWildcard(_beta);

var _characters = __webpack_require__(383);

var characters = _interopRequireWildcard(_characters);

var _combat = __webpack_require__(841);

var combat = _interopRequireWildcard(_combat);

var _common = __webpack_require__(842);

var common = _interopRequireWildcard(_common);

var _debug = __webpack_require__(843);

var debug = _interopRequireWildcard(_debug);

var _nav = __webpack_require__(844);

var nav = _interopRequireWildcard(_nav);

var _options = __webpack_require__(846);

var options = _interopRequireWildcard(_options);

var _rankings = __webpack_require__(847);

var rankings = _interopRequireWildcard(_rankings);

var _statistics = __webpack_require__(848);

var statistics = _interopRequireWildcard(_statistics);

var _units = __webpack_require__(849);

var units = _interopRequireWildcard(_units);

var _updateWatcher = __webpack_require__(850);

var updateWatcher = _interopRequireWildcard(_updateWatcher);

var _users = __webpack_require__(851);

var users = _interopRequireWildcard(_users);

var _willReceiveProps = __webpack_require__(852);

var _willReceiveProps2 = _interopRequireDefault(_willReceiveProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.achievements = achievements;
exports.app = app;
exports.authSignin = authSignin;
exports.beta = beta;
exports.characters = characters;
exports.combat = combat;
exports.common = common;
exports.debug = debug;
exports.nav = nav;
exports.options = options;
exports.rankings = rankings;
exports.statistics = statistics;
exports.units = units;
exports.updateWatcher = updateWatcher;
exports.users = users;
exports.willReceiveProps = _willReceiveProps2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AchievementsItem = exports.Achievements = exports.AchievementsToast = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reselect = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// I don't want to modify the global state to deal with a local achievement
// queue, so here's how it works:
// * Get all achievements earned after page load.
// * Skip the first ignored-n.
// * If any are left, show the first one.
// * When the UI closes (either on timeout or click), ignored-n += 1.
var AchievementsToast = exports.AchievementsToast = (0, _compose2.default)(
// the function here is important - earnedSinceLock must have a new instance on rerender
(0, _reactRedux.connect)(function () {
  return _selectors2.default.loading.select({
    empty: (0, _reselect.createStructuredSelector)({ character: _selectors2.default.chars2.isEmpty }),
    onReady: (0, _reselect.createStructuredSelector)({
      queue: _selectors2.default.chars2.achievements.earnedSinceLock()
    })
  });
}), (0, _withState2.default)("numClosed", "setNumClosed", 0), (0, _withProps2.default)(function (props) {
  return {
    onRequestClose: function onRequestClose() {
      return props.setNumClosed(props.numClosed + 1);
    }
  };
}), (0, _withProps2.default)(function (props) {
  return { first: props.queue[props.numClosed] || null };
}));
var Achievements = exports.Achievements = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({ character: _selectors2.default.chars2.isEmpty }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    achieveNames: _selectors2.default.chars2.achievements.visibleNames
  })
})));
var AchievementsItem = exports.AchievementsItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({ character: _selectors2.default.chars2.isEmpty }),
  onReady: (0, _reselect.createStructuredSelector)({
    status: _selectors2.default.chars2.achievements.status,
    progress: _selectors2.default.chars2.achievements.progress,
    completedAt: _selectors2.default.chars2.achievements.completedAt
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _register = __webpack_require__(833);

Object.defineProperty(exports, "Register", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_register).default;
  }
});

var _login = __webpack_require__(834);

Object.defineProperty(exports, "Login", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_login).default;
  }
});

var _updatePassword = __webpack_require__(835);

Object.defineProperty(exports, "UpdatePassword", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_updatePassword).default;
  }
});

var _updateEmail = __webpack_require__(836);

Object.defineProperty(exports, "UpdateEmail", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_updateEmail).default;
  }
});

var _title = __webpack_require__(837);

Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_title).default;
  }
});

var _forgotPassword = __webpack_require__(838);

Object.defineProperty(exports, "ResetPassword", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_forgotPassword).default;
  }
});

var _forgotConfirm = __webpack_require__(839);

Object.defineProperty(exports, "ConfirmResetPassword", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_forgotConfirm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL2F1dGgtc2lnbmluL2luZGV4LmpzIl0sIm5hbWVzIjpbImRlZmF1bHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OzZDQUdRQSxPOzs7Ozs7Ozs7MENBQ0FBLE87Ozs7Ozs7OzttREFDQUEsTzs7Ozs7Ozs7O2dEQUNBQSxPOzs7Ozs7Ozs7MENBQ0FBLE87Ozs7Ozs7OzttREFDQUEsTzs7Ozs7Ozs7O2tEQUNBQSxPIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8vIFNpZ25pbiBwYWdlcyBhcmUgZWFjaCBzaW1wbGUsIGJ1dCB0aGVyZSdzIGEgbG90IG9mIHRoZW0uIEFzIG9uZSBmaWxlIGl0XG4vLyBiYWxsb29uZWQgdG8gb3ZlciAzMDAgbGluZXMuIEJlc3QgdG8gc3BsaXQgaXQgdXAuXG5leHBvcnQge2RlZmF1bHQgYXMgUmVnaXN0ZXJ9IGZyb20gXCIuL3JlZ2lzdGVyXCJcbmV4cG9ydCB7ZGVmYXVsdCBhcyBMb2dpbn0gZnJvbSBcIi4vbG9naW5cIlxuZXhwb3J0IHtkZWZhdWx0IGFzIFVwZGF0ZVBhc3N3b3JkfSBmcm9tIFwiLi91cGRhdGUtcGFzc3dvcmRcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIFVwZGF0ZUVtYWlsfSBmcm9tIFwiLi91cGRhdGUtZW1haWxcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIFRpdGxlfSBmcm9tIFwiLi90aXRsZVwiXG5leHBvcnQge2RlZmF1bHQgYXMgUmVzZXRQYXNzd29yZH0gZnJvbSBcIi4vZm9yZ290LXBhc3N3b3JkXCJcbmV4cG9ydCB7ZGVmYXVsdCBhcyBDb25maXJtUmVzZXRQYXNzd29yZH0gZnJvbSBcIi4vZm9yZ290LWNvbmZpcm1cIlxuIl19

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _util = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$email = _ref.email,
      email = _ref$email === undefined ? "" : _ref$email,
      _ref$password = _ref.password,
      password = _ref$password === undefined ? "" : _ref$password,
      _ref$password2 = _ref.password2,
      password2 = _ref$password2 === undefined ? "" : _ref$password2;

  return (0, _compose2.default)((0, _withState2.default)("email", "setEmail", email), (0, _withState2.default)("password", "setPassword", password), (0, _withState2.default)("password2", "setPassword2", password2), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};

var formErrors = (0, _reselect.createSelector)(_util.anonError, _util.passwordsMatchError, _form.requestError, function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)(_selectors2.default.auth.localState, (0, _form.propname)("firebase"), (0, _form.propname)("email"), (0, _form.propname)("password"), (0, _form.propname)("setRequest"), function (auth, firebase, email, password, setRequest) {
  return (0, _form.handleForm)(setRequest, function () {
    var credential = firebase.auth.EmailAuthProvider.credential(email, password);
    return firebase.auth().currentUser.linkWithCredential(credential)
    // Reauth isn't strictly necessary here, but it returns a new user object
    // so selectors update. Without this, some places still think we're anon.
    //.then(() => firebase.login({email, password}))
    .then(function () {
      return window.location.reload();
    }) // holy shit this is hacky
    ;
  });
});

exports.default = function (initialState) {
  return (0, _compose2.default)(state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.localState,
    input: (0, _form.handleInputs)("setEmail", "setPassword", "setPassword2"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import R from "../../selectors"
var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$email = _ref.email,
      email = _ref$email === undefined ? "" : _ref$email,
      _ref$password = _ref.password,
      password = _ref$password === undefined ? "" : _ref$password;

  return (0, _compose2.default)((0, _withState2.default)("email", "setEmail", email), (0, _withState2.default)("password", "setPassword", password), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};

var formErrors = (0, _reselect.createSelector)(_form.requestError,
// the Load api isn't necessary here, but we'll include it for consistency
// with register and other forms.
function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)((0, _form.propname)("firebase"), (0, _form.propname)("email"), (0, _form.propname)("password"), (0, _form.propname)("setRequest"), function (firebase, email, password, setRequest) {
  return (
    // the Load api isn't necessary here, but we'll include it for consistency
    // with register and other forms.
    (0, _form.handleForm)(setRequest, function () {
      return firebase.login({
        email: email,
        password: password
      });
    })
  );
});

exports.default = function (initialState) {
  return (0, _compose2.default)(state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    input: (0, _form.handleInputs)("setEmail", "setPassword"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _util = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$password = _ref.password,
      password = _ref$password === undefined ? "" : _ref$password,
      _ref$password2 = _ref.password2,
      password2 = _ref$password2 === undefined ? "" : _ref$password2,
      _ref$oldPassword = _ref.oldPassword,
      oldPassword = _ref$oldPassword === undefined ? "" : _ref$oldPassword;

  return (0, _compose2.default)((0, _withState2.default)("password", "setPassword", password), (0, _withState2.default)("password2", "setPassword2", password2), (0, _withState2.default)("oldPassword", "setOldPassword", oldPassword), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};

var formErrors = (0, _reselect.createSelector)(_util.notAnonError, _util.passwordsMatchError, _form.requestError, function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)(_selectors2.default.auth.localState, (0, _form.propname)("firebase"), (0, _form.propname)("password"), (0, _form.propname)("oldPassword"), (0, _form.propname)("setRequest"), function (auth, firebase, password, oldPassword, setRequest) {
  return (0, _form.handleForm)(setRequest, function () {
    return auth.reauthenticateWithCredential(firebase.auth.EmailAuthProvider.credential(auth.email, oldPassword)).then(function () {
      return auth.updatePassword(password);
    });
  });
});

exports.default = function (initialState) {
  return (0, _compose2.default)(state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.localState,
    input: (0, _form.handleInputs)("setPassword", "setPassword2", "setOldPassword"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL2F1dGgtc2lnbmluL3VwZGF0ZS1wYXNzd29yZC5qcyJdLCJuYW1lcyI6WyJzdGF0ZSIsInBhc3N3b3JkIiwicGFzc3dvcmQyIiwib2xkUGFzc3dvcmQiLCJmb3JtRXJyb3JzIiwiZXJyb3JzIiwiZmlsdGVyIiwiY2xpZW50RXJyb3JDb3VudCIsInJlcSIsImxlbmd0aCIsImlzU3VibWl0QWxsb3dlZCIsInJlcXVlc3QiLCJjb3VudCIsInN1Ym1pdCIsImF1dGgiLCJsb2NhbFN0YXRlIiwiZmlyZWJhc2UiLCJzZXRSZXF1ZXN0IiwicmVhdXRoZW50aWNhdGVXaXRoQ3JlZGVudGlhbCIsIkVtYWlsQXV0aFByb3ZpZGVyIiwiY3JlZGVudGlhbCIsImVtYWlsIiwidGhlbiIsInVwZGF0ZVBhc3N3b3JkIiwiaW5pdGlhbFN0YXRlIiwiaW5wdXQiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBOztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFJQSxJQUFNQSxRQUFRLFNBQVJBLEtBQVE7QUFBQSxpRkFBMkQsRUFBM0Q7QUFBQSwyQkFBRUMsUUFBRjtBQUFBLE1BQUVBLFFBQUYsaUNBQWEsRUFBYjtBQUFBLDRCQUFpQkMsU0FBakI7QUFBQSxNQUFpQkEsU0FBakIsa0NBQTZCLEVBQTdCO0FBQUEsOEJBQWlDQyxXQUFqQztBQUFBLE1BQWlDQSxXQUFqQyxvQ0FBK0MsRUFBL0M7O0FBQUEsU0FDWix1QkFDRSx5QkFBVSxVQUFWLEVBQXNCLGFBQXRCLEVBQXFDRixRQUFyQyxDQURGLEVBRUUseUJBQVUsV0FBVixFQUF1QixjQUF2QixFQUF1Q0MsU0FBdkMsQ0FGRixFQUdFLHlCQUFVLGFBQVYsRUFBeUIsZ0JBQXpCLEVBQTJDQyxXQUEzQyxDQUhGLEVBSUUseUJBQVUsU0FBVixFQUFxQixZQUFyQixFQUFtQyxFQUFDSCxPQUFPLE9BQVIsRUFBbkMsQ0FKRixDQURZO0FBQUEsQ0FBZDs7QUFPQSxJQUFNSSxhQUFhLGlHQUlqQjtBQUFBLG9DQUFJQyxNQUFKO0FBQUlBLFVBQUo7QUFBQTs7QUFBQSxTQUFlLGlCQUFFQyxNQUFGLENBQVNELE1BQVQsQ0FBZjtBQUFBLENBSmlCLENBQW5CO0FBTUEsSUFBTUUsbUJBQW1CLDhCQUN2QkgsVUFEdUIsc0JBR3ZCLFVBQUNDLE1BQUQsRUFBU0csR0FBVDtBQUFBLFNBQWlCSCxPQUFPSSxNQUFQLElBQWlCRCxNQUFNLENBQU4sR0FBVSxDQUEzQixDQUFqQjtBQUFBLENBSHVCLENBQXpCO0FBS0EsSUFBTUUsa0JBQWtCLDhCQUN0QixvQkFBUyxTQUFULENBRHNCLEVBRXRCSCxnQkFGc0IsRUFHdEIsVUFBQ0ksT0FBRCxFQUFVQyxLQUFWO0FBQUEsU0FBb0JBLFVBQVUsQ0FBVixJQUFlRCxRQUFRWCxLQUFSLEtBQWtCLFNBQXJEO0FBQUEsQ0FIc0IsQ0FBeEI7QUFLQSxJQUFNYSxTQUFTLDhCQUNiLG9CQUFFQyxJQUFGLENBQU9DLFVBRE0sRUFFYixvQkFBUyxVQUFULENBRmEsRUFHYixvQkFBUyxVQUFULENBSGEsRUFJYixvQkFBUyxhQUFULENBSmEsRUFLYixvQkFBUyxZQUFULENBTGEsRUFNYixVQUFDRCxJQUFELEVBQU9FLFFBQVAsRUFBaUJmLFFBQWpCLEVBQTJCRSxXQUEzQixFQUF3Q2MsVUFBeEM7QUFBQSxTQUNFLHNCQUFXQSxVQUFYLEVBQXVCLFlBQU07QUFDM0IsV0FBT0gsS0FDSkksNEJBREksQ0FFSEYsU0FBU0YsSUFBVCxDQUFjSyxpQkFBZCxDQUFnQ0MsVUFBaEMsQ0FBMkNOLEtBQUtPLEtBQWhELEVBQXVEbEIsV0FBdkQsQ0FGRyxFQUlKbUIsSUFKSSxDQUlDO0FBQUEsYUFBTVIsS0FBS1MsY0FBTCxDQUFvQnRCLFFBQXBCLENBQU47QUFBQSxLQUpELENBQVA7QUFLRCxHQU5ELENBREY7QUFBQSxDQU5hLENBQWY7O2tCQWVlLFVBQUN1QixZQUFEO0FBQUEsU0FDYix1QkFDRXhCLE1BQU13QixZQUFOLENBREYsRUFFRSw2QkFGRixFQUdFLHlCQUNFLHdDQUF5QjtBQUN2QlYsVUFBTSxvQkFBRUEsSUFBRixDQUFPQyxVQURVO0FBRXZCVSxXQUFPLHdCQUFhLGFBQWIsRUFBNEIsY0FBNUIsRUFBNEMsZ0JBQTVDLENBRmdCO0FBR3ZCckIsMEJBSHVCO0FBSXZCTSxvQ0FKdUI7QUFLdkJHO0FBTHVCLEdBQXpCLENBREYsQ0FIRixDQURhO0FBQUEsQyIsImZpbGUiOiJ1cGRhdGUtcGFzc3dvcmQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjb25uZWN0fSBmcm9tIFwicmVhY3QtcmVkdXhcIlxuaW1wb3J0IHtjcmVhdGVTZWxlY3RvciwgY3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgUiBmcm9tIFwiLi4vLi4vc2VsZWN0b3JzXCJcbmltcG9ydCB7cHJvcG5hbWUsIGhhbmRsZUlucHV0cywgcmVxdWVzdEVycm9yLCBoYW5kbGVGb3JtfSBmcm9tIFwiLi4vdXRpbC9mb3JtXCJcbmltcG9ydCB7ZmlyZWJhc2VDb25uZWN0fSBmcm9tIFwiLi4vLi4vcmVkdXhcIlxuaW1wb3J0IHdpdGhTdGF0ZSBmcm9tIFwicmVjb21wb3NlL3dpdGhTdGF0ZVwiXG5pbXBvcnQgY29tcG9zZSBmcm9tIFwicmVjb21wb3NlL2NvbXBvc2VcIlxuaW1wb3J0IHtub3RBbm9uRXJyb3IsIHBhc3N3b3Jkc01hdGNoRXJyb3J9IGZyb20gXCIuL3V0aWxcIlxuXG5leHBvcnQgdHlwZSBGb3JtID0ge3Bhc3N3b3JkPzogc3RyaW5nLCBwYXNzd29yZDI/OiBzdHJpbmcsIG9sZFBhc3N3b3JkPzogc3RyaW5nfVxuXG5jb25zdCBzdGF0ZSA9ICh7cGFzc3dvcmQgPSBcIlwiLCBwYXNzd29yZDIgPSBcIlwiLCBvbGRQYXNzd29yZCA9IFwiXCJ9OiBGb3JtID0ge30pID0+XG4gIGNvbXBvc2UoXG4gICAgd2l0aFN0YXRlKFwicGFzc3dvcmRcIiwgXCJzZXRQYXNzd29yZFwiLCBwYXNzd29yZCksXG4gICAgd2l0aFN0YXRlKFwicGFzc3dvcmQyXCIsIFwic2V0UGFzc3dvcmQyXCIsIHBhc3N3b3JkMiksXG4gICAgd2l0aFN0YXRlKFwib2xkUGFzc3dvcmRcIiwgXCJzZXRPbGRQYXNzd29yZFwiLCBvbGRQYXNzd29yZCksXG4gICAgd2l0aFN0YXRlKFwicmVxdWVzdFwiLCBcInNldFJlcXVlc3RcIiwge3N0YXRlOiBcIkNMRUFSXCJ9KSxcbiAgKVxuY29uc3QgZm9ybUVycm9ycyA9IGNyZWF0ZVNlbGVjdG9yKFxuICBub3RBbm9uRXJyb3IsXG4gIHBhc3N3b3Jkc01hdGNoRXJyb3IsXG4gIHJlcXVlc3RFcnJvcixcbiAgKC4uLmVycm9ycykgPT4gXy5maWx0ZXIoZXJyb3JzKSxcbilcbmNvbnN0IGNsaWVudEVycm9yQ291bnQgPSBjcmVhdGVTZWxlY3RvcihcbiAgZm9ybUVycm9ycyxcbiAgcmVxdWVzdEVycm9yLFxuICAoZXJyb3JzLCByZXEpID0+IGVycm9ycy5sZW5ndGggLSAocmVxID8gMSA6IDApLFxuKVxuY29uc3QgaXNTdWJtaXRBbGxvd2VkID0gY3JlYXRlU2VsZWN0b3IoXG4gIHByb3BuYW1lKFwicmVxdWVzdFwiKSxcbiAgY2xpZW50RXJyb3JDb3VudCxcbiAgKHJlcXVlc3QsIGNvdW50KSA9PiBjb3VudCA9PT0gMCAmJiByZXF1ZXN0LnN0YXRlICE9PSBcIlBFTkRJTkdcIixcbilcbmNvbnN0IHN1Ym1pdCA9IGNyZWF0ZVNlbGVjdG9yKFxuICBSLmF1dGgubG9jYWxTdGF0ZSxcbiAgcHJvcG5hbWUoXCJmaXJlYmFzZVwiKSxcbiAgcHJvcG5hbWUoXCJwYXNzd29yZFwiKSxcbiAgcHJvcG5hbWUoXCJvbGRQYXNzd29yZFwiKSxcbiAgcHJvcG5hbWUoXCJzZXRSZXF1ZXN0XCIpLFxuICAoYXV0aCwgZmlyZWJhc2UsIHBhc3N3b3JkLCBvbGRQYXNzd29yZCwgc2V0UmVxdWVzdCkgPT5cbiAgICBoYW5kbGVGb3JtKHNldFJlcXVlc3QsICgpID0+IHtcbiAgICAgIHJldHVybiBhdXRoXG4gICAgICAgIC5yZWF1dGhlbnRpY2F0ZVdpdGhDcmVkZW50aWFsKFxuICAgICAgICAgIGZpcmViYXNlLmF1dGguRW1haWxBdXRoUHJvdmlkZXIuY3JlZGVudGlhbChhdXRoLmVtYWlsLCBvbGRQYXNzd29yZCksXG4gICAgICAgIClcbiAgICAgICAgLnRoZW4oKCkgPT4gYXV0aC51cGRhdGVQYXNzd29yZChwYXNzd29yZCkpXG4gICAgfSksXG4pXG5leHBvcnQgZGVmYXVsdCAoaW5pdGlhbFN0YXRlOiBGb3JtIHwgdm9pZCkgPT5cbiAgY29tcG9zZShcbiAgICBzdGF0ZShpbml0aWFsU3RhdGUpLFxuICAgIGZpcmViYXNlQ29ubmVjdCgpLFxuICAgIGNvbm5lY3QoXG4gICAgICBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICBhdXRoOiBSLmF1dGgubG9jYWxTdGF0ZSxcbiAgICAgICAgaW5wdXQ6IGhhbmRsZUlucHV0cyhcInNldFBhc3N3b3JkXCIsIFwic2V0UGFzc3dvcmQyXCIsIFwic2V0T2xkUGFzc3dvcmRcIiksXG4gICAgICAgIGZvcm1FcnJvcnMsXG4gICAgICAgIGlzU3VibWl0QWxsb3dlZCxcbiAgICAgICAgc3VibWl0LFxuICAgICAgfSksXG4gICAgKSxcbiAgKVxuIl19

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _util = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$email = _ref.email,
      email = _ref$email === undefined ? "" : _ref$email,
      _ref$oldPassword = _ref.oldPassword,
      oldPassword = _ref$oldPassword === undefined ? "" : _ref$oldPassword;

  return (0, _compose2.default)((0, _withState2.default)("email", "setEmail", email), (0, _withState2.default)("oldPassword", "setOldPassword", oldPassword), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};

var formErrors = (0, _reselect.createSelector)(_util.notAnonError, _form.requestError, function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)(_selectors2.default.auth.localState, (0, _form.propname)("firebase"), (0, _form.propname)("email"), (0, _form.propname)("oldPassword"), (0, _form.propname)("setRequest"), function (auth, firebase, email, oldPassword, setRequest) {
  return (0, _form.handleForm)(setRequest, function () {
    return auth.reauthenticateWithCredential(firebase.auth.EmailAuthProvider.credential(auth.email, oldPassword)).then(function () {
      return auth.updateEmail(email);
    });
  });
});

exports.default = function (initialState) {
  return (0, _compose2.default)(state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.localState,
    input: (0, _form.handleInputs)("setEmail", "setOldPassword"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _branch = __webpack_require__(111);

var _branch2 = _interopRequireDefault(_branch);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We want to show the title screen as fast as possible, even if not everything
// has loaded yet. Multiple connect()s in multiple queries here are tedious, but
// allow rendering more as each prop loads. (This is far less important for
// other pages.)
exports.default = (0, _compose2.default)((0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  clientVersion: _selectors2.default.appInfo.clientLongVersion
})), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?appInfo/,
  onReady: (0, _reselect.createStructuredSelector)({
    serverVersion: _selectors2.default.appInfo.serverLongVersion
  })
})), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|users|betaUsers)/,
  onReady: (0, _reselect.createStructuredSelector)({
    authExists: _lodash2.default.negate(_selectors2.default.auth.isEmpty),
    isAnonymous: _selectors2.default.auth.isAnonymous
  })
}), { onLogout: _selectors2.default.auth.logout }), (0, _branch2.default)(function (props) {
  return props.authExists;
}, (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  userId: _selectors2.default.auth.userId,
  userExists: _selectors2.default.auth.user.isNotEmpty,
  isAllowed: _selectors2.default.beta.isAllowed
}))), (0, _branch2.default)(function (props) {
  return props.userExists;
}, (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  displayName: _selectors2.default.auth.user.displayName
}))));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL2F1dGgtc2lnbmluL3RpdGxlLmpzIl0sIm5hbWVzIjpbImNsaWVudFZlcnNpb24iLCJhcHBJbmZvIiwiY2xpZW50TG9uZ1ZlcnNpb24iLCJsb2FkaW5nIiwic2VsZWN0IiwibG9hZGluZ0ZpbHRlciIsIm9uUmVhZHkiLCJzZXJ2ZXJWZXJzaW9uIiwic2VydmVyTG9uZ1ZlcnNpb24iLCJhdXRoRXhpc3RzIiwibmVnYXRlIiwiYXV0aCIsImlzRW1wdHkiLCJpc0Fub255bW91cyIsIm9uTG9nb3V0IiwibG9nb3V0IiwicHJvcHMiLCJ1c2VySWQiLCJ1c2VyRXhpc3RzIiwidXNlciIsImlzTm90RW1wdHkiLCJpc0FsbG93ZWQiLCJiZXRhIiwiZGlzcGxheU5hbWUiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7Ozs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtrQkFDZSx1QkFDYix5QkFDRSx3Q0FBeUI7QUFDdkJBLGlCQUFlLG9CQUFFQyxPQUFGLENBQVVDO0FBREYsQ0FBekIsQ0FERixDQURhLEVBTWIseUJBQ0Usb0JBQUVDLE9BQUYsQ0FBVUMsTUFBVixDQUFpQjtBQUNmQyxpQkFBZSxhQURBO0FBRWZDLFdBQVMsd0NBQXlCO0FBQ2hDQyxtQkFBZSxvQkFBRU4sT0FBRixDQUFVTztBQURPLEdBQXpCO0FBRk0sQ0FBakIsQ0FERixDQU5hLEVBY2IseUJBQ0Usb0JBQUVMLE9BQUYsQ0FBVUMsTUFBVixDQUFpQjtBQUNmQyxpQkFBZSw0QkFEQTtBQUVmQyxXQUFTLHdDQUF5QjtBQUNoQ0csZ0JBQVksaUJBQUVDLE1BQUYsQ0FBUyxvQkFBRUMsSUFBRixDQUFPQyxPQUFoQixDQURvQjtBQUVoQ0MsaUJBQWEsb0JBQUVGLElBQUYsQ0FBT0U7QUFGWSxHQUF6QjtBQUZNLENBQWpCLENBREYsRUFRRSxFQUFDQyxVQUFVLG9CQUFFSCxJQUFGLENBQU9JLE1BQWxCLEVBUkYsQ0FkYSxFQXdCYixzQkFDRTtBQUFBLFNBQVNDLE1BQU1QLFVBQWY7QUFBQSxDQURGLEVBRUUseUJBQ0Usd0NBQXlCO0FBQ3ZCUSxVQUFRLG9CQUFFTixJQUFGLENBQU9NLE1BRFE7QUFFdkJDLGNBQVksb0JBQUVQLElBQUYsQ0FBT1EsSUFBUCxDQUFZQyxVQUZEO0FBR3ZCQyxhQUFXLG9CQUFFQyxJQUFGLENBQU9EO0FBSEssQ0FBekIsQ0FERixDQUZGLENBeEJhLEVBa0NiLHNCQUNFO0FBQUEsU0FBU0wsTUFBTUUsVUFBZjtBQUFBLENBREYsRUFFRSx5QkFDRSx3Q0FBeUI7QUFDdkJLLGVBQWEsb0JBQUVaLElBQUYsQ0FBT1EsSUFBUCxDQUFZSTtBQURGLENBQXpCLENBREYsQ0FGRixDQWxDYSxDIiwiZmlsZSI6InRpdGxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCB7Y29ubmVjdH0gZnJvbSBcInJlYWN0LXJlZHV4XCJcbmltcG9ydCBSIGZyb20gXCIuLi8uLi9zZWxlY3RvcnNcIlxuaW1wb3J0IGNvbXBvc2UgZnJvbSBcInJlY29tcG9zZS9jb21wb3NlXCJcbmltcG9ydCBicmFuY2ggZnJvbSBcInJlY29tcG9zZS9icmFuY2hcIlxuaW1wb3J0IHtjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoXCJcblxuLy8gV2Ugd2FudCB0byBzaG93IHRoZSB0aXRsZSBzY3JlZW4gYXMgZmFzdCBhcyBwb3NzaWJsZSwgZXZlbiBpZiBub3QgZXZlcnl0aGluZ1xuLy8gaGFzIGxvYWRlZCB5ZXQuIE11bHRpcGxlIGNvbm5lY3QoKXMgaW4gbXVsdGlwbGUgcXVlcmllcyBoZXJlIGFyZSB0ZWRpb3VzLCBidXRcbi8vIGFsbG93IHJlbmRlcmluZyBtb3JlIGFzIGVhY2ggcHJvcCBsb2Fkcy4gKFRoaXMgaXMgZmFyIGxlc3MgaW1wb3J0YW50IGZvclxuLy8gb3RoZXIgcGFnZXMuKVxuZXhwb3J0IGRlZmF1bHQgY29tcG9zZShcbiAgY29ubmVjdChcbiAgICBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgY2xpZW50VmVyc2lvbjogUi5hcHBJbmZvLmNsaWVudExvbmdWZXJzaW9uLFxuICAgIH0pLFxuICApLFxuICBjb25uZWN0KFxuICAgIFIubG9hZGluZy5zZWxlY3Qoe1xuICAgICAgbG9hZGluZ0ZpbHRlcjogL15cXC8/YXBwSW5mby8sXG4gICAgICBvblJlYWR5OiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICBzZXJ2ZXJWZXJzaW9uOiBSLmFwcEluZm8uc2VydmVyTG9uZ1ZlcnNpb24sXG4gICAgICB9KSxcbiAgICB9KSxcbiAgKSxcbiAgY29ubmVjdChcbiAgICBSLmxvYWRpbmcuc2VsZWN0KHtcbiAgICAgIGxvYWRpbmdGaWx0ZXI6IC9eXFwvPyhhdXRofHVzZXJzfGJldGFVc2VycykvLFxuICAgICAgb25SZWFkeTogY3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yKHtcbiAgICAgICAgYXV0aEV4aXN0czogXy5uZWdhdGUoUi5hdXRoLmlzRW1wdHkpLFxuICAgICAgICBpc0Fub255bW91czogUi5hdXRoLmlzQW5vbnltb3VzLFxuICAgICAgfSksXG4gICAgfSksXG4gICAge29uTG9nb3V0OiBSLmF1dGgubG9nb3V0fSxcbiAgKSxcbiAgYnJhbmNoKFxuICAgIHByb3BzID0+IHByb3BzLmF1dGhFeGlzdHMsXG4gICAgY29ubmVjdChcbiAgICAgIGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gICAgICAgIHVzZXJJZDogUi5hdXRoLnVzZXJJZCxcbiAgICAgICAgdXNlckV4aXN0czogUi5hdXRoLnVzZXIuaXNOb3RFbXB0eSxcbiAgICAgICAgaXNBbGxvd2VkOiBSLmJldGEuaXNBbGxvd2VkLFxuICAgICAgfSksXG4gICAgKSxcbiAgKSxcbiAgYnJhbmNoKFxuICAgIHByb3BzID0+IHByb3BzLnVzZXJFeGlzdHMsXG4gICAgY29ubmVjdChcbiAgICAgIGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gICAgICAgIGRpc3BsYXlOYW1lOiBSLmF1dGgudXNlci5kaXNwbGF5TmFtZSxcbiAgICAgIH0pLFxuICAgICksXG4gICksXG4pXG4iXX0=

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$email = _ref.email,
      email = _ref$email === undefined ? "" : _ref$email;

  return (0, _compose2.default)((0, _withState2.default)("email", "setEmail", email), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};

var formErrors = (0, _reselect.createSelector)(_form.requestError, function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)((0, _form.propname)("firebase"), (0, _form.propname)("email"), (0, _form.propname)("setRequest"), function (firebase, email, setRequest) {
  return (0, _form.handleForm)(setRequest, function () {
    return firebase.auth().sendPasswordResetEmail(email);
  });
});

exports.default = function (initialState) {
  return (0, _compose2.default)(state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    input: (0, _form.handleInputs)("setEmail"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _form = __webpack_require__(56);

var _redux = __webpack_require__(46);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _util = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = function state() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$password = _ref.password,
      password = _ref$password === undefined ? "" : _ref$password,
      _ref$password2 = _ref.password2,
      password2 = _ref$password2 === undefined ? "" : _ref$password2;

  return (0, _compose2.default)((0, _withState2.default)("password", "setPassword", password), (0, _withState2.default)("password2", "setPassword2", password2), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }));
};
var formErrors = (0, _reselect.createSelector)(_form.requestError, _util.passwordsMatchError, function () {
  for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  return _lodash2.default.filter(errors);
});
var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
  return errors.length - (req ? 1 : 0);
});
var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
  return count === 0 && request.state !== "PENDING";
});
var submit = (0, _reselect.createSelector)((0, _form.propname)("firebase"), (0, _form.propname)("password"), (0, _form.propname)("oobCode"), (0, _form.propname)("setRequest"), function (firebase, password, oobCode, setRequest) {
  return (0, _form.handleForm)(setRequest, function () {
    return firebase.confirmPasswordReset(oobCode, password);
  });
});
var oobCode = function oobCode(props) {
  return _lodash2.default.get(props, "match.params.oobCode", null);
};

exports.default = function (initialState) {
  return (0, _compose2.default)((0, _withProps2.default)(function (props) {
    return { oobCode: oobCode(props) };
  }), state(initialState), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
    isAuthed: _selectors2.default.auth.isNotEmpty,
    input: (0, _form.handleInputs)("setPassword", "setPassword2"),
    formErrors: formErrors,
    isSubmitAllowed: isSubmitAllowed,
    submit: submit
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BetaKeyApply = exports.BetaKeyCreate = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _redux = __webpack_require__(46);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _form = __webpack_require__(56);

var _app = __webpack_require__(381);

var _actions = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BetaKeyCreate = exports.BetaKeyCreate = function () {
  var formErrors = (0, _reselect.createSelector)(_form.requestError, function () {
    for (var _len = arguments.length, errors = Array(_len), _key = 0; _key < _len; _key++) {
      errors[_key] = arguments[_key];
    }

    return _lodash2.default.filter(errors);
  });
  var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
    return errors.length - (req ? 1 : 0);
  });
  var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
    return count === 0 && request.state !== "PENDING";
  });
  var betaKeys = (0, _reselect.createSelector)((0, _form.propname)("request"), function (request) {
    return request.state === "SUCCESS" ? request.result.keys : [];
  });
  return (0, _compose2.default)((0, _withState2.default)("count", "setCount", 1), (0, _withState2.default)("request", "setRequest", { state: "CLEAR" }), (0, _redux.firebaseConnect)(), (0, _reactRedux.connect)(_selectors2.default.loading.select({
    onReady: (0, _reselect.createStructuredSelector)({
      isVisible: _selectors2.default.beta.isBetaAdmin,
      input: (0, _form.handleInputs)("setCount"),
      formErrors: formErrors,
      isSubmitAllowed: isSubmitAllowed,
      onSubmit: (0, _reselect.createSelector)(_selectors2.default.beta.createBetaKeys, (0, _form.propname)("count"), (0, _form.propname)("setRequest"), function (createBetaKeys, count, setRequest) {
        return (0, _form.handleForm)(setRequest, function () {
          return createBetaKeys(count);
        });
      })
    })
  })), (0, _withProps2.default)(function (props) {
    return { betaKeys: betaKeys(null, props) };
  }));
}();

var BetaKeyApply = exports.BetaKeyApply = function () {
  var userAlreadyAllowedError = (0, _reselect.createSelector)(_selectors2.default.beta.authBetaUser.hasKey, function (is) {
    return is ? "alreadyaccess" : null;
  });
  var keyInvalidError = (0, _reselect.createSelector)(_selectors2.default.beta.betaKey.isValid, function (is) {
    return is ? null : "invalid";
  });
  var keyUsedError = (0, _reselect.createSelector)(_selectors2.default.beta.betaKeyUser.isUsed, function (is) {
    return is ? "used" : null;
  });
  var formErrors = (0, _reselect.createSelector)(userAlreadyAllowedError, keyInvalidError, keyUsedError, _form.requestError, function () {
    for (var _len2 = arguments.length, errors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      errors[_key2] = arguments[_key2];
    }

    return _lodash2.default.filter(errors);
  });
  var clientErrorCount = (0, _reselect.createSelector)(formErrors, _form.requestError, function (errors, req) {
    return errors.length - (req ? 1 : 0);
  });
  var isSubmitAllowed = (0, _reselect.createSelector)((0, _form.propname)("request"), clientErrorCount, function (request, count) {
    return count === 0 && request.state !== "PENDING";
  });
  return (0, _compose2.default)(
  // This creates an anonymous account even when the beta key is invalid.
  // That's okay - account creation can't be secured anyway; we enforce things
  // by beta key.
  _app.CreateAnonymousAccount, Url.betaKey, (0, _reactRedux.connect)(_selectors2.default.loading.select({
    empty: (0, _reselect.createStructuredSelector)({
      auth: _selectors2.default.auth.isEmpty
    }),
    onReady: (0, _reselect.createStructuredSelector)({
      userId: _selectors2.default.auth.userId,
      isVisible: _selectors2.default.beta.betaKey.isValid,
      formErrors: formErrors,
      isSubmitAllowed: isSubmitAllowed
    })
  }), { onSubmit: _selectors2.default.beta.applyAuthBetaKey }), (0, _actions.dispatchLocalPromise)("onSubmit", "request", (0, _reselect.createSelector)(function (s, p) {
    return p.onSubmit;
  }, function (s, p) {
    return p.betaKey;
  }, function (onSubmit, betaKey) {
    return function () {
      return onSubmit(betaKey);
    };
  })));
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombatResult = exports.CombatRun = exports.CombatRunSoldierItem = exports.CombatMain = exports.CombatForm = exports.CombatFormSelectedZone = exports.CombatFormYourArmySoldierItem = exports.CombatFormSelectedZoneSoldierItem = exports.CombatFormSelectZoneItemIcon = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _actions = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CombatFormSelectZoneItemIcon = exports.CombatFormSelectZoneItemIcon = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    isCleared: _selectors2.default.chars2.zones.isEntryCleared
  })
})));

var CombatFormSelectedZoneSoldierItem = exports.CombatFormSelectedZoneSoldierItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.zoneTypes.soldierCount
  })
})));
var CombatFormYourArmySoldierItem = exports.CombatFormYourArmySoldierItem = (0, _compose2.default)((0, _withProps2.default)(function (props) {
  return { unitName: props.soldierName };
}), // for units.count
(0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.units.count
  })
})));
var CombatFormSelectedZone = exports.CombatFormSelectedZone = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    grindCount: _selectors2.default.chars2.combatLoot.grindTokenCount,
    isGrind: _selectors2.default.chars2.combatLoot.hasGrindToken,
    isCleared: _selectors2.default.chars2.zones.isEntryCleared,
    soldierNames: _selectors2.default.zoneTypes.soldierNames
  })
})));
var CombatForm = exports.CombatForm = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    zones: _selectors2.default.chars2.zones.visibleNames,
    zoneClears: _selectors2.default.chars2.zones.totalClears,
    hatcheryProdBonus: _selectors2.default.chars2.prodMultis.hatchery,
    soldierNames: _selectors2.default.chars2.units.visibleCombatNames,
    isZoneSelectVisible: _selectors2.default.chars2.breakpoints.isZoneSelectVisible,
    lastZone: _selectors2.default.chars2.combat.zone,
    isRunning: _selectors2.default.chars2.combat.isRunning
  })
}), { onSubmit: _selectors2.default.chars2.combat.pushStart }), (0, _withState2.default)("selectedZone", "setSelectedZone", function (props) {
  return props.lastZone;
}), (0, _withProps2.default)(function (props) {
  return { isSubmittable: !!props.selectedZone };
}), (0, _actions.dispatchLocalPromise)("onSubmit", "request", (0, _reselect.createSelector)(function (s, p) {
  return p.onSubmit;
}, function (s, p) {
  return p.charId;
}, function (s, p) {
  return p.selectedZone;
}, function (push, charId, zone) {
  return function () {
    return push(charId, zone);
  };
})));

var CombatMain = exports.CombatMain = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    combat: _selectors2.default.chars2.combat.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    isDone: _selectors2.default.chars2.combat.isDone,
    isRunning: _selectors2.default.chars2.combat.isRunning
  })
})));

var CombatRunSoldierItem = exports.CombatRunSoldierItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.combat.Team.count,
    hp: _selectors2.default.chars2.combat.Team.hp,
    attackPower: _selectors2.default.chars2.combat.Team.attackPowerEach,
    maxHp: _selectors2.default.chars2.combat.Team.maxHp,
    deaths: _selectors2.default.chars2.combat.Team.death
  })
})));
var CombatRun = exports.CombatRun = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    combat: _selectors2.default.chars2.combat.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    zone: _selectors2.default.chars2.combat.zone,
    createdAt: _selectors2.default.chars2.combat.createdAt,
    doneAt: _selectors2.default.chars2.combat.doneAt,
    playerSoldiers: _selectors2.default.chars2.combat.Player.visibleNames,
    enemySoldiers: _selectors2.default.chars2.combat.Enemy.visibleNames
  })
})));

var CombatResult = exports.CombatResult = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    combat: _selectors2.default.chars2.combat.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    exists: _selectors2.default.chars2.combatLoot.isNotEmpty,
    status: _selectors2.default.chars2.combat.doneStatus,
    zone: _selectors2.default.chars2.combat.zone,
    at: _selectors2.default.chars2.combat.doneAt,
    hatcheryProdPerZone: _selectors2.default.chars2.prodMultis.hatcheryPerZone,
    loot: _selectors2.default.chars2.combatLoot.looted,
    spend: _selectors2.default.chars2.combatLoot.spent,
    isFirstZoneWin: _selectors2.default.chars2.combatLoot.isFirstZoneWin
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumpProps = exports.FromNow = exports.Number = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _withProps = __webpack_require__(29);

var _withProps2 = _interopRequireDefault(_withProps);

var _assert = __webpack_require__(12);

var _swarmNumberformat = __webpack_require__(378);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Number = exports.Number = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?options/,
  onReady: (0, _reselect.createStructuredSelector)({
    numberformat: _selectors2.default.options.numberformat
  })
})), (0, _withProps2.default)(function (props) {
  return {
    formatNumber: function formatNumber(val) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      (0, _assert.assert)(val != null, "Number.val required");
      opts = Object.assign({}, opts, { format: props.numberformat });
      // temporary(?) workaround for poor formatting of small/decimal numbers
      if (opts.small && Math.abs(val) < 100) return val.toPrecision(2);
      return (0, _swarmNumberformat.format)(val, opts);
    }
  };
}));
// ew... but it gets storybook working without hurting prod.

var FromNow = exports.FromNow = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?\.info\/serverTimeOffset/,
  onReady: (0, _reselect.createStructuredSelector)({
    now: _selectors2.default.now.now
  })
})));

var DumpProps = exports.DumpProps = (0, _compose2.default)((0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  logProps: _selectors2.default.flags.logProps,
  dumpProps: _selectors2.default.flags.dumpProps,
  envName: _selectors2.default.envConfig.envName
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebugIndex = exports.DebugChar = exports.Flag = exports.DebugIndexUnit = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DebugIndexUnit = exports.DebugIndexUnit = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    rawCount: _selectors2.default.chars2.units.rawCount,
    count: _selectors2.default.chars2.units.count,
    velocity: _selectors2.default.chars2.units.velocity
  })
})));
var Flag = exports.Flag = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    flagValue: _selectors2.default.flags.flag
  })
})));
var DebugChar = exports.DebugChar = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    updatedAt: _selectors2.default.chars2.units.updatedAt,
    unitNames: _selectors2.default.unitTypes.names,
    sinceUpdated: _selectors2.default.chars2.units.sinceUpdated
  })
})));
var DebugIndex = exports.DebugIndex = (0, _compose2.default)(Url.maybeCharId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    clientVersion: _selectors2.default.appInfo.clientVersion,
    clientVersionDate: _selectors2.default.appInfo.clientVersionDate,
    clientDeployedAt: _selectors2.default.appInfo.clientDeployedAt,
    clientLongVersion: _selectors2.default.appInfo.clientLongVersion,
    clientLongHash: _selectors2.default.appInfo.clientLongHash,
    clientShortHash: _selectors2.default.appInfo.clientShortHash,
    flagNames: _selectors2.default.flags.names
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLayout = exports.CharNavLinks = exports.UserNavLinks = exports.FreshdeskTicketButton = exports.AuthCharname = exports.AuthUsername = exports.OfflineIcon = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _onlyUpdateForKeys = __webpack_require__(231);

var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _branch = __webpack_require__(111);

var _branch2 = _interopRequireDefault(_branch);

var _drawer = __webpack_require__(386);

var Drawer = _interopRequireWildcard(_drawer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Since nav's always visible, loadingFilter is important in this file
var OfflineIcon = exports.OfflineIcon = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?.info\/connected/,
  onReady: (0, _reselect.createStructuredSelector)({
    isConnected: _selectors2.default.appInfo.isConnected
  })
})));

var AuthUsername = exports.AuthUsername = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|users)/,
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty,
    user: _selectors2.default.auth.user.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.auth.user.displayName
  })
})));

var AuthCharname = exports.AuthCharname = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  // this catches characters-by-user too
  loadingFilter: /^\/?(auth|character)/,
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName
  })
})));

var location = function location() {
  return document && document.location && document.location.href;
};
// For consistent unit tests. Sucks to run test/mock code in prod, but this isn't used in many other places
var userAgent = function userAgent(state, props) {
  return props.mockUserAgent || window && window.navigator && window.navigator.userAgent;
};
var FreshdeskTicketButton = exports.FreshdeskTicketButton = (0, _compose2.default)(Url.maybeCharId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|users|userRoles)/,
  onReady: (0, _reselect.createStructuredSelector)({
    freshdesk: _selectors2.default.flags.freshdesk,
    isDebug: _selectors2.default.options.isDebug,
    debugProps: (0, _reselect.createStructuredSelector)({
      userId: _selectors2.default.auth.userId,
      charId: function charId(s, p) {
        return p.charId;
      },
      clientVersion: _selectors2.default.appInfo.clientLongVersion,
      serverVersion: _selectors2.default.appInfo.serverLongVersion,
      location: location,
      userAgent: userAgent
    })
  })
})), (0, _onlyUpdateForKeys2.default)(["debugProps", "isDebug"]));

var UserNavLinks = exports.UserNavLinks = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|options|userRoles)/,
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    isDebug: _selectors2.default.options.isDebug
  })
})));
var CharNavLinks = exports.CharNavLinks = (0, _compose2.default)(Url.maybeCharId, (0, _branch2.default)(function (props) {
  return !!props.charId;
}, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  // this catches characters-by-user too
  loadingFilter: /^\/?(auth|character|options|userRoles)/,
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty,
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    isDebug: _selectors2.default.options.isDebug,
    charExists: _selectors2.default.chars2.isNotEmpty,
    isCombatVisible: _selectors2.default.chars2.breakpoints.isNavCombatVisible
  })
})), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  loadingFilter: /^\/?(auth|options|userRoles)/,
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    isDebug: _selectors2.default.options.isDebug
  })
}))));

var NavLayout = exports.NavLayout = function NavLayout(config) {
  return (0, _compose2.default)(Drawer.withDrawerState(config), (0, _reactRedux.connect)(_selectors2.default.loading.select({
    loadingFilter: /^\/?(auth|betaUsers|userRoles)/,
    empty: (0, _reselect.createStructuredSelector)({
      auth: _selectors2.default.auth.isEmpty
    }),
    onReady: (0, _reselect.createStructuredSelector)({
      isAllowed: _selectors2.default.beta.isAllowed
    })
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrereleaseFlagsChooser = exports.IsDebugChooser = exports.NumberFormatChooser = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _reactRedux = __webpack_require__(20);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reselect = __webpack_require__(2);

var _actions = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberFormatChooser = exports.NumberFormatChooser = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    numberformat: _selectors2.default.options.numberformat
  })
}), { setNumberformat: _selectors2.default.options.setNumberformat }), (0, _actions.dispatchLocalPromise)("setNumberformat", "request", function (s, p) {
  return p.setNumberformat;
}));
var IsDebugChooser = exports.IsDebugChooser = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    isDebug: _selectors2.default.options.isDebug
  })
}), { setIsDebug: _selectors2.default.options.setIsDebug }), (0, _actions.dispatchLocalPromise)("setIsDebug", "request", function (s, p) {
  return p.setIsDebug;
}));

var PrereleaseFlagsChooser = exports.PrereleaseFlagsChooser = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  onReady: (0, _reselect.createStructuredSelector)({
    prereleaseFlags: _selectors2.default.options.prereleaseFlags,
    isVisible: _selectors2.default.auth.roles.prereleaseFlags
  })
}), { setPrereleaseFlags: _selectors2.default.options.setPrereleaseFlags }), (0, _actions.dispatchLocalPromise)("setPrereleaseFlags", "request", function (s, p) {
  return p.setPrereleaseFlags;
}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb250YWluZXJzL29wdGlvbnMuanMiXSwibmFtZXMiOlsiTnVtYmVyRm9ybWF0Q2hvb3NlciIsImxvYWRpbmciLCJzZWxlY3QiLCJvblJlYWR5IiwibnVtYmVyZm9ybWF0Iiwib3B0aW9ucyIsInNldE51bWJlcmZvcm1hdCIsInMiLCJwIiwiSXNEZWJ1Z0Nob29zZXIiLCJpc0RlYnVnIiwic2V0SXNEZWJ1ZyIsIlByZXJlbGVhc2VGbGFnc0Nob29zZXIiLCJwcmVyZWxlYXNlRmxhZ3MiLCJpc1Zpc2libGUiLCJhdXRoIiwicm9sZXMiLCJzZXRQcmVyZWxlYXNlRmxhZ3MiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7QUFFTyxJQUFNQSxvREFBc0IsdUJBQ2pDLHlCQUNFLG9CQUFFQyxPQUFGLENBQVVDLE1BQVYsQ0FBaUI7QUFDZkMsV0FBUyx3Q0FBeUI7QUFDaENDLGtCQUFjLG9CQUFFQyxPQUFGLENBQVVEO0FBRFEsR0FBekI7QUFETSxDQUFqQixDQURGLEVBTUUsRUFBQ0UsaUJBQWlCLG9CQUFFRCxPQUFGLENBQVVDLGVBQTVCLEVBTkYsQ0FEaUMsRUFTakMsbUNBQ0UsaUJBREYsRUFFRSxTQUZGLEVBR0UsVUFBQ0MsQ0FBRCxFQUFJQyxDQUFKO0FBQUEsU0FBVUEsRUFBRUYsZUFBWjtBQUFBLENBSEYsQ0FUaUMsQ0FBNUI7QUFnQkEsSUFBTUcsMENBQWlCLHVCQUM1Qix5QkFDRSxvQkFBRVIsT0FBRixDQUFVQyxNQUFWLENBQWlCO0FBQ2ZDLFdBQVMsd0NBQXlCO0FBQ2hDTyxhQUFTLG9CQUFFTCxPQUFGLENBQVVLO0FBRGEsR0FBekI7QUFETSxDQUFqQixDQURGLEVBTUUsRUFBQ0MsWUFBWSxvQkFBRU4sT0FBRixDQUFVTSxVQUF2QixFQU5GLENBRDRCLEVBUzVCLG1DQUFxQixZQUFyQixFQUFtQyxTQUFuQyxFQUE4QyxVQUFDSixDQUFELEVBQUlDLENBQUo7QUFBQSxTQUFVQSxFQUFFRyxVQUFaO0FBQUEsQ0FBOUMsQ0FUNEIsQ0FBdkI7O0FBWUEsSUFBTUMsMERBQXlCLHVCQUNwQyx5QkFDRSxvQkFBRVgsT0FBRixDQUFVQyxNQUFWLENBQWlCO0FBQ2ZDLFdBQVMsd0NBQXlCO0FBQ2hDVSxxQkFBaUIsb0JBQUVSLE9BQUYsQ0FBVVEsZUFESztBQUVoQ0MsZUFBVyxvQkFBRUMsSUFBRixDQUFPQyxLQUFQLENBQWFIO0FBRlEsR0FBekI7QUFETSxDQUFqQixDQURGLEVBT0UsRUFBQ0ksb0JBQW9CLG9CQUFFWixPQUFGLENBQVVZLGtCQUEvQixFQVBGLENBRG9DLEVBVXBDLG1DQUNFLG9CQURGLEVBRUUsU0FGRixFQUdFLFVBQUNWLENBQUQsRUFBSUMsQ0FBSjtBQUFBLFNBQVVBLEVBQUVTLGtCQUFaO0FBQUEsQ0FIRixDQVZvQyxDQUEvQiIsImZpbGUiOiJvcHRpb25zLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSIGZyb20gXCIuLi9zZWxlY3RvcnNcIlxuaW1wb3J0IHtjb25uZWN0fSBmcm9tIFwicmVhY3QtcmVkdXhcIlxuaW1wb3J0IGNvbXBvc2UgZnJvbSBcInJlY29tcG9zZS9jb21wb3NlXCJcbmltcG9ydCB7Y3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IHtkaXNwYXRjaExvY2FsUHJvbWlzZX0gZnJvbSBcIi4vdXRpbC9hY3Rpb25zXCJcblxuZXhwb3J0IGNvbnN0IE51bWJlckZvcm1hdENob29zZXIgPSBjb21wb3NlKFxuICBjb25uZWN0KFxuICAgIFIubG9hZGluZy5zZWxlY3Qoe1xuICAgICAgb25SZWFkeTogY3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yKHtcbiAgICAgICAgbnVtYmVyZm9ybWF0OiBSLm9wdGlvbnMubnVtYmVyZm9ybWF0LFxuICAgICAgfSksXG4gICAgfSksXG4gICAge3NldE51bWJlcmZvcm1hdDogUi5vcHRpb25zLnNldE51bWJlcmZvcm1hdH0sXG4gICksXG4gIGRpc3BhdGNoTG9jYWxQcm9taXNlKFxuICAgIFwic2V0TnVtYmVyZm9ybWF0XCIsXG4gICAgXCJyZXF1ZXN0XCIsXG4gICAgKHMsIHApID0+IHAuc2V0TnVtYmVyZm9ybWF0LFxuICApLFxuKVxuXG5leHBvcnQgY29uc3QgSXNEZWJ1Z0Nob29zZXIgPSBjb21wb3NlKFxuICBjb25uZWN0KFxuICAgIFIubG9hZGluZy5zZWxlY3Qoe1xuICAgICAgb25SZWFkeTogY3JlYXRlU3RydWN0dXJlZFNlbGVjdG9yKHtcbiAgICAgICAgaXNEZWJ1ZzogUi5vcHRpb25zLmlzRGVidWcsXG4gICAgICB9KSxcbiAgICB9KSxcbiAgICB7c2V0SXNEZWJ1ZzogUi5vcHRpb25zLnNldElzRGVidWd9LFxuICApLFxuICBkaXNwYXRjaExvY2FsUHJvbWlzZShcInNldElzRGVidWdcIiwgXCJyZXF1ZXN0XCIsIChzLCBwKSA9PiBwLnNldElzRGVidWcpLFxuKVxuXG5leHBvcnQgY29uc3QgUHJlcmVsZWFzZUZsYWdzQ2hvb3NlciA9IGNvbXBvc2UoXG4gIGNvbm5lY3QoXG4gICAgUi5sb2FkaW5nLnNlbGVjdCh7XG4gICAgICBvblJlYWR5OiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgICAgICBwcmVyZWxlYXNlRmxhZ3M6IFIub3B0aW9ucy5wcmVyZWxlYXNlRmxhZ3MsXG4gICAgICAgIGlzVmlzaWJsZTogUi5hdXRoLnJvbGVzLnByZXJlbGVhc2VGbGFncyxcbiAgICAgIH0pLFxuICAgIH0pLFxuICAgIHtzZXRQcmVyZWxlYXNlRmxhZ3M6IFIub3B0aW9ucy5zZXRQcmVyZWxlYXNlRmxhZ3N9LFxuICApLFxuICBkaXNwYXRjaExvY2FsUHJvbWlzZShcbiAgICBcInNldFByZXJlbGVhc2VGbGFnc1wiLFxuICAgIFwicmVxdWVzdFwiLFxuICAgIChzLCBwKSA9PiBwLnNldFByZXJlbGVhc2VGbGFncyxcbiAgKSxcbilcbiJdfQ==

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankingsList = exports.Rankings = exports.RankingsItem = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// RankingsItem is just here for the flow-types
var RankingsItem = exports.RankingsItem = (0, _compose2.default)();
var Rankings = exports.Rankings = (0, _compose2.default)(Url.leagueRank, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    rankings: _selectors2.default.rankings.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    list: _selectors2.default.rankings.list
  })
})));
var RankingsList = exports.RankingsList = (0, _compose2.default)((0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({
  rankNames: _selectors2.default.chars2.rankings.names
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductionStatisticsRow = exports.Statistics = exports.MiscStatistics = exports.StatisticsRouter = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reselect = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticsRouter = exports.StatisticsRouter = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName
  })
})));
var MiscStatistics = exports.MiscStatistics = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    createdAt: _selectors2.default.chars2.createdAt,
    totalWins: _selectors2.default.chars2.zones.totalWins,
    totalFights: _selectors2.default.chars2.zones.totalFights,
    totalClears: _selectors2.default.chars2.zones.totalClears
  })
})));

var Statistics = exports.Statistics = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    unitNames: _selectors2.default.chars2.units.visibleNames
  })
})));

var ProductionStatisticsRow = exports.ProductionStatisticsRow = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.units.rawCount,
    bought: _selectors2.default.chars2.units.bought,
    clicks: _selectors2.default.chars2.units.clicks,
    spent: _selectors2.default.chars2.units.spent,
    looted: _selectors2.default.chars2.units.looted,
    grown: _selectors2.default.chars2.units.grown,
    firstElapsed: _selectors2.default.chars2.units.firstElapsed,
    isVisible: _selectors2.default.chars2.units.isVisible
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitNavItem = exports.UnitNav = exports.Unit = exports.UnitList = exports.UnitListItem = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _drawer = __webpack_require__(386);

var _actions = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnitListItem = exports.UnitListItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.units.count,
    velocity: _selectors2.default.chars2.units.velocity,
    isProducible: _selectors2.default.unitTypes.isProducible
  })
})));
var UnitList = exports.UnitList = (0, _compose2.default)(Url.charId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.chars2.displayName,
    unitNames: _selectors2.default.chars2.units.visibleMeatNames
  })
})));

var Unit = exports.Unit = (0, _compose2.default)(Url.charId, Url.unitName, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    unit: _selectors2.default.chars2.units.isNotVisible
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.units.count,
    velocity: _selectors2.default.chars2.units.velocity,
    input: _selectors2.default.buyN.input,
    isProducible: _selectors2.default.unitTypes.isProducible,
    isBuyable: _selectors2.default.unitTypes.isBuyable,
    // Q.Unit adds/guarantees isUnitVisible
    displayName: _selectors2.default.chars2.displayName,
    prodEach: _selectors2.default.chars2.units.prodEach,
    prodTotal: _selectors2.default.chars2.units.prodTotal,
    costEach: _selectors2.default.chars2.units.costEach,
    navUnits: _selectors2.default.unitTypes.relatedNames,
    buyInputError: _selectors2.default.buyN.isInputError,
    buyCount: _selectors2.default.buyN.buyCount,
    isBuyButtonDisabled: _selectors2.default.buyN.isBuyButtonDisabled
  })
}), { setBuyN: _selectors2.default.buyN.setBuyN, buyUnit: _selectors2.default.chars2.units.pushBuy }), (0, _actions.dispatchLocalPromise)("buyUnit", "request", (0, _reselect.createSelector)(function (s, p) {
  return p.buyUnit;
}, function (s, p) {
  return p.charId;
}, function (s, p) {
  return p.unitName;
}, function (s, p) {
  return p.buyCount;
}, function (push, charId, unitName, buyCount) {
  return function () {
    return push(charId, unitName, buyCount);
  };
})), (0, _drawer.withDrawerState)({}));

var UnitNav = exports.UnitNav = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    unit: _selectors2.default.chars2.units.isNotVisible
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    names: _selectors2.default.unitTypes.relatedNames,
    input: _selectors2.default.buyN.input
  })
})));
var UnitNavItem = exports.UnitNavItem = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    character: _selectors2.default.chars2.isEmpty,
    unit: _selectors2.default.chars2.units.isNotVisible
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    count: _selectors2.default.chars2.units.count,
    velocity: _selectors2.default.chars2.units.velocity,
    input: _selectors2.default.buyN.input,
    isInputError: _selectors2.default.buyN.isInputError,
    cost: _selectors2.default.buyN.buyCost1,
    mode: _selectors2.default.buyN.relatedUnitDetailsMode,
    isVisible: _selectors2.default.chars2.units.isVisible
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReleaseCountdown = exports.UpdateWatcher = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _reactRedux = __webpack_require__(20);

var _withState = __webpack_require__(36);

var _withState2 = _interopRequireDefault(_withState);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reselect = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateWatcher = exports.UpdateWatcher = (0, _compose2.default)((0, _withState2.default)("clientDeployedAt", "setClientDeployedAt", function (props) {
  return props.initClientDeployedAt || null;
}), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    appInfo: _selectors2.default.appInfo.isEmpty,
    now: _selectors2.default.now.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    clientVersion: _selectors2.default.appInfo.clientVersion,
    clientDeployedAt: _selectors2.default.appInfo.clientDeployedAt,
    now: _selectors2.default.now.now,
    sinceClientDeployed: _selectors2.default.appInfo.sinceClientDeployed,
    isClientDeployed: _selectors2.default.appInfo.isClientDeployed,
    serverVersion: _selectors2.default.appInfo.serverVersion,
    serverDeployedAt: _selectors2.default.appInfo.serverDeployedAt,
    sinceServerDeployed: _selectors2.default.appInfo.sinceServerDeployed
  })
})));
var ReleaseCountdown = exports.ReleaseCountdown = (0, _compose2.default)((0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    appInfo: _selectors2.default.appInfo.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    releaseCountdown: _selectors2.default.flags.releaseCountdown,
    isReleased: _selectors2.default.flags.isReleased,
    sinceRelease: _selectors2.default.flags.sinceRelease,
    url: function url() {
      return _selectors2.default.flags.releaseNewsUrl;
    }
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = exports.AuthUser = undefined;

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _reactRedux = __webpack_require__(20);

var _urls = __webpack_require__(48);

var Url = _interopRequireWildcard(_urls);

var _withReducer = __webpack_require__(382);

var _withReducer2 = _interopRequireDefault(_withReducer);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _reselect = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthUser = exports.AuthUser = (0, _compose2.default)((0, _withReducer2.default)("setUsernameRequest", "dispatch", function (s, a) {
  return a;
}, {}), (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    auth: _selectors2.default.auth.isEmpty,
    user: _selectors2.default.auth.user.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    userId: _selectors2.default.auth.userId,
    isAnonymous: _selectors2.default.auth.isAnonymous,
    displayName: _selectors2.default.auth.user.displayName,
    createdAt: _selectors2.default.auth.user.createdAt
  })
}), { setUsername: _selectors2.default.auth.setDisplayName }));

var User = exports.User = (0, _compose2.default)(Url.userId, (0, _reactRedux.connect)(_selectors2.default.loading.select({
  empty: (0, _reselect.createStructuredSelector)({
    user: _selectors2.default.users.isEmpty
  }),
  onReady: (0, _reselect.createStructuredSelector)({
    displayName: _selectors2.default.users.displayName,
    createdAt: _selectors2.default.users.createdAt
  })
})));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lifecycle = __webpack_require__(75);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (willReceiveProps) {
  return (0, _lifecycle2.default)({
    componentWillMount: function componentWillMount() {
      return this.componentWillReceiveProps(this.props);
    },
    componentWillReceiveProps: function componentWillReceiveProps(props) {
      return willReceiveProps(props, this.props);
    }
  });
};
// recompose.withProps, but support redirects without a warning.
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL3V0aWwvd2lsbFJlY2VpdmVQcm9wcy5qcyJdLCJuYW1lcyI6WyJ3aWxsUmVjZWl2ZVByb3BzIiwiY29tcG9uZW50V2lsbE1vdW50IiwiY29tcG9uZW50V2lsbFJlY2VpdmVQcm9wcyIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFQTs7Ozs7O2tCQUVlLFVBQUNBLGdCQUFEO0FBQUEsU0FDYix5QkFBVTtBQUNSQyxzQkFEUSxnQ0FDYTtBQUNuQixhQUFPLEtBQUtDLHlCQUFMLENBQStCLEtBQUtDLEtBQXBDLENBQVA7QUFDRCxLQUhPO0FBSVJELDZCQUpRLHFDQUlrQkMsS0FKbEIsRUFJeUI7QUFDL0IsYUFBT0gsaUJBQWlCRyxLQUFqQixFQUF3QixLQUFLQSxLQUE3QixDQUFQO0FBQ0Q7QUFOTyxHQUFWLENBRGE7QUFBQSxDO0FBSGYiLCJmaWxlIjoid2lsbFJlY2VpdmVQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyByZWNvbXBvc2Uud2l0aFByb3BzLCBidXQgc3VwcG9ydCByZWRpcmVjdHMgd2l0aG91dCBhIHdhcm5pbmcuXG5pbXBvcnQgbGlmZWN5Y2xlIGZyb20gXCJyZWNvbXBvc2UvbGlmZWN5Y2xlXCJcblxuZXhwb3J0IGRlZmF1bHQgKHdpbGxSZWNlaXZlUHJvcHM6IEZ1bmN0aW9uKSA9PlxuICBsaWZlY3ljbGUoe1xuICAgIGNvbXBvbmVudFdpbGxNb3VudCgpIHtcbiAgICAgIHJldHVybiB0aGlzLmNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHModGhpcy5wcm9wcylcbiAgICB9LFxuICAgIGNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHMocHJvcHMpIHtcbiAgICAgIHJldHVybiB3aWxsUmVjZWl2ZVByb3BzKHByb3BzLCB0aGlzLnByb3BzKVxuICAgIH0sXG4gIH0pXG4iXX0=

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = exports.pathStatus = exports.paths = undefined;

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _pathStatus = __webpack_require__(854);

var pathStatus = _interopRequireWildcard(_pathStatus);

var _router = __webpack_require__(855);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.paths = paths;
exports.pathStatus = pathStatus;
exports.router = _router2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9maXJlYmFzZS1jb25uZWN0L2luZGV4LmpzIl0sIm5hbWVzIjpbInBhdGhzIiwicGF0aFN0YXR1cyIsInJvdXRlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztJQUFZQSxLOztBQUNaOztJQUFZQyxVOztBQUNaOzs7Ozs7OztRQUNRRCxLLEdBQUFBLEs7UUFBT0MsVSxHQUFBQSxVO1FBQVlDLE0iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgcGF0aHMgZnJvbSBcIi4vcGF0aHNcIlxuaW1wb3J0ICogYXMgcGF0aFN0YXR1cyBmcm9tIFwiLi9wYXRoLXN0YXR1c1wiXG5pbXBvcnQge2RlZmF1bHQgYXMgcm91dGVyfSBmcm9tIFwiLi9yb3V0ZXJcIlxuZXhwb3J0IHtwYXRocywgcGF0aFN0YXR1cywgcm91dGVyfVxuIl19

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = exports.unit = exports.combat = undefined;

var _paths = __webpack_require__(38);

Object.keys(_paths).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paths[key];
    }
  });
});

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(2);

var paths = _interopRequireWildcard(_paths);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var combat = exports.combat = {
  data: function data(charId) {
    return paths.character.data(charId) + "/combat";
  },
  status: (0, _reselect.createSelector)(function (s) {
    return s.firebase;
  }, function (s, p) {
    return p.charId;
  }, function (firebase, charId) {
    var combat = _lodash2.default.get(firebase, ["data", "characters", charId, "combat"]);
    return combat == null ? "empty" : "done";
  })
};
// backward compatibility

var unit = exports.unit = {
  data: function data(charId, unitName) {
    return paths.character.data(charId) + "/unit/" + unitName;
  },
  status: function status(state, props) {
    var exists = _selectors2.default.unitTypes.isValidName(state, props);
    if (!exists) return "empty";
    var vis = _selectors2.default.chars2.units.isVisible(state, props);
    return vis ? "done" : "empty";
  }
};

var auth = exports.auth = {
  // TODO circular deps. after migrating to new loaders, this will go away
  status: function status(s, p) {
    return _selectors2.default.auth.loadStatus(s, p);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queries = undefined;
exports.parseUrl = parseUrl;

var _redux = __webpack_require__(46);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__(161);

var _pathToRegexp = __webpack_require__(856);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

var _compose = __webpack_require__(16);

var _compose2 = _interopRequireDefault(_compose);

var _lifecycle = __webpack_require__(75);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _onlyUpdateForKeys = __webpack_require__(231);

var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

var _reactRedux = __webpack_require__(20);

var _reselect = __webpack_require__(2);

var _selectUtils = __webpack_require__(158);

var _querysets = __webpack_require__(857);

var querysets = _interopRequireWildcard(_querysets);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// No react-router parsing here. Normally that's how we do URL handling, and I
// tried it here, but kept running into duplicate/unmount issues. It's important
// to have exactly one firebaseConnect that never unmounts, but react-router
// works by mounting/unmounting components based on URL matches.
// path-to-regexp is used by react-router, so at least url-specs are similar.
function createUrlParser(name, spec) {
  var parsedKeys = [];
  var regex = (0, _pathToRegexp2.default)(spec, parsedKeys, { end: false }); // modifies parsedKeys
  var keys = _lodash2.default.map(parsedKeys, "name");
  return function (url) {
    var match = regex.exec(url);
    return match ? { name: name, params: _lodash2.default.zipObject(keys, match.slice(1)) } : null;
  };
}
var urlParsers = [createUrlParser("char", "/[pc]/:charId"), createUrlParser("user", "/u/:userId"), createUrlParser("rankings", "/rankings/:league/:rankName"), createUrlParser("betaKeyCreate", "/beta/create"), createUrlParser("betaKeyApply", "/beta/join/:betaKey")];
function parseUrl(url) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = urlParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var parser = _step.value;

      var parsed = parser(url);
      if (parsed) return parsed;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

// above is the url-to-params logic. now, put it in a selector, map it to a set
// of firebase queries (queryset), and combine it with always-called queries -
// querysets.root - like auth.
var location = function location(state, props) {
  return props.location.pathname;
};
var locationParsed = (0, _reselect.createSelector)(location, parseUrl);
var locationName = (0, _reselect.createSelector)(locationParsed, function (p) {
  return p ? p.name : null;
});
var locationParams = (0, _reselect.createSelector)(locationParsed, function (p) {
  return p ? p.params : null;
});
var locationQueryset = (0, _reselect.createSelector)(locationName, function (n) {
  return n ? querysets[n] : null;
});
var locationQueries = (0, _reselect.createSelector)(function (state) {
  return state;
}, locationQueryset, locationParams, function (state, qs, params) {
  return qs ? qs(state, { match: { params: params } }) : [];
});
var mergeQueries = function mergeQueries() {
  return _lodash2.default.uniqWith(_lodash2.default.concat.apply(_lodash2.default, arguments), _lodash2.default.isEqual);
};
// createDeepSelector: cache when possible, to avoid needless re-querying
var queries = exports.queries = (0, _selectUtils.createDeepSelector)(querysets.root, locationQueries, mergeQueries);

// now, make our selector a react component that actually runs the queries,
// updating on state/props change.
var logQueries = _selectors2.default.flags.logFirebase() ? (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    console.log("firebaseConnectRouter: mount", this.props.queries);
  },
  componentWillUnmount: function componentWillUnmount() {
    console.warn("firebaseConnectRouter: unmount", this.props.queries);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    console.log("firebaseConnectRouter: change", nextProps.queries);
  }
}) : function (C) {
  return C;
};
var withQueries = (0, _compose2.default)(_reactRouter.withRouter, (0, _reactRedux.connect)((0, _reselect.createStructuredSelector)({ queries: queries })), (0, _onlyUpdateForKeys2.default)(["queries"]), logQueries, (0, _redux.firebaseConnect)(function (props) {
  return props.queries;
}));
exports.default = withQueries(function (props) {
  return null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 856 */
/***/ (function(module, exports) {

/**
 * Expose `pathtoRegexp`.
 */

module.exports = pathtoRegexp;

/**
 * Match matching groups in a regular expression.
 */
var MATCHING_GROUP_REGEXP = /\((?!\?)/g;

/**
 * Normalize the given path string,
 * returning a regular expression.
 *
 * An empty array should be passed,
 * which will contain the placeholder
 * key names. For example "/user/:id" will
 * then contain ["id"].
 *
 * @param  {String|RegExp|Array} path
 * @param  {Array} keys
 * @param  {Object} options
 * @return {RegExp}
 * @api private
 */

function pathtoRegexp(path, keys, options) {
  options = options || {};
  keys = keys || [];
  var strict = options.strict;
  var end = options.end !== false;
  var flags = options.sensitive ? '' : 'i';
  var extraOffset = 0;
  var keysOffset = keys.length;
  var i = 0;
  var name = 0;
  var m;

  if (path instanceof RegExp) {
    while (m = MATCHING_GROUP_REGEXP.exec(path.source)) {
      keys.push({
        name: name++,
        optional: false,
        offset: m.index
      });
    }

    return path;
  }

  if (Array.isArray(path)) {
    // Map array parts into regexps and return their source. We also pass
    // the same keys and options instance into every generation to get
    // consistent matching groups before we join the sources together.
    path = path.map(function (value) {
      return pathtoRegexp(value, keys, options).source;
    });

    return new RegExp('(?:' + path.join('|') + ')', flags);
  }

  path = ('^' + path + (strict ? '' : path[path.length - 1] === '/' ? '?' : '/?'))
    .replace(/\/\(/g, '/(?:')
    .replace(/([\/\.])/g, '\\$1')
    .replace(/(\\\/)?(\\\.)?:(\w+)(\(.*?\))?(\*)?(\?)?/g, function (match, slash, format, key, capture, star, optional, offset) {
      slash = slash || '';
      format = format || '';
      capture = capture || '([^\\/' + format + ']+?)';
      optional = optional || '';

      keys.push({
        name: key,
        optional: !!optional,
        offset: offset + extraOffset
      });

      var result = ''
        + (optional ? '' : slash)
        + '(?:'
        + format + (optional ? slash : '') + capture
        + (star ? '((?:[\\/' + format + '].+?)?)' : '')
        + ')'
        + optional;

      extraOffset += result.length - match.length;

      return result;
    })
    .replace(/\*/g, function (star, index) {
      var len = keys.length

      while (len-- > keysOffset && keys[len].offset > index) {
        keys[len].offset += 3; // Replacement length minus asterisk length.
      }

      return '(.*)';
    });

  // This is a workaround for handling unnamed matching groups.
  while (m = MATCHING_GROUP_REGEXP.exec(path)) {
    var escapeCount = 0;
    var index = m.index;

    while (path.charAt(--index) === '\\') {
      escapeCount++;
    }

    // It's possible to escape the bracket.
    if (escapeCount % 2 === 1) {
      continue;
    }

    if (keysOffset + i === keys.length || keys[keysOffset + i].offset > m.index) {
      keys.splice(keysOffset + i, 0, {
        name: name++, // Unnamed matching groups must be consistently linear.
        optional: false,
        offset: m.index
      });
    }

    i++;
  }

  // If the path is non-ending, match until the end or a slash.
  path += (end ? '$' : (path[path.length - 1] === '/' ? '' : '(?=\\/|$)'));

  return new RegExp(path, flags);
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.char = exports.user = exports.root = exports.rankings = exports.betaKeyApply = exports.betaKeyCreate = undefined;

var _assert = __webpack_require__(12);

var _reselect = __webpack_require__(2);

var _paths = __webpack_require__(38);

var paths = _interopRequireWildcard(_paths);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var params = function params(state, props) {
  return props.match.params;
};
var param = function param(name) {
  return (0, _reselect.createSelector)(params, function (ps) {
    return (0, _assert.assertDefined)(ps[name], name);
  });
};

var authUserId = function authUserId(state) {
  return _lodash2.default.get(state, ["firebase", "auth", "uid"]);
};
function characterRefsByUser(state, props) {
  (0, _assert.assertDefined)(props.userId, "userId", props);
  return _lodash2.default.get(state, ["firebase", "data", "characters-by-user", props.userId]);
}
var characterIdsByUser = (0, _reselect.createSelector)(characterRefsByUser, _lodash2.default.keys);
var characterQueriesByUser = (0, _reselect.createSelector)(characterIdsByUser, function (ids) {
  return _lodash2.default.map(ids, function (charId) {
    return paths.character.query(charId);
  });
});

var constQueries = [paths.appInfo, paths.connected, paths.serverTimeOffset].map(function (p) {
  return p.query();
});
var const_ = function const_() {
  return constQueries;
};

var _user = (0, _reselect.createSelector)(param("userId"), function (s, p) {
  return characterQueriesByUser(s, { userId: param("userId")(s, p) });
}, function (userId, charQs) {
  return [paths.user, paths.charactersByUser].map(function (p) {
    return p.query(userId);
  }).concat(charQs);
});
var auth = (0, _reselect.createSelector)(authUserId,
// special care to return consistent object refs when unauthed - no [] in selector-params
function (s) {
  var userId = authUserId(s);
  return userId == null ? null : characterQueriesByUser(s, { userId: userId });
}, function (userId, charQs) {
  return userId == null ? [] : [paths.user, paths.charactersByUser, paths.options, paths.betaUsers, paths.roles.prereleaseFlags].map(function (p) {
    return p.query(userId);
  }).concat(charQs || []);
});
var betaKeyCreate = exports.betaKeyCreate = (0, _reselect.createSelector)(authUserId, function (userId) {
  return userId == null ? [] : [paths.roles.betaUsers].map(function (p) {
    return p.query(userId);
  });
});
var betaKeyValidate = (0, _reselect.createSelector)(param("betaKey"), function (betaKey) {
  return [paths.betaKeyToUser, paths.betaValidKeys].map(function (p) {
    return p.query(betaKey);
  });
});
var betaUsers = (0, _reselect.createSelector)(authUserId, function (userId) {
  return userId == null ? [] : [paths.betaUsers].map(function (p) {
    return p.query(userId);
  });
});
var betaKeyApply = exports.betaKeyApply = (0, _reselect.createSelector)(betaUsers, betaKeyValidate, _lodash2.default.concat);

var _char = (0, _reselect.createSelector)(param("charId"), function (s, p) {
  return _lodash2.default.get(s, ["firebase", "data", "characters", param("charId")(s, p), "user"]);
}, function (charId, userId) {
  return [paths.character].map(function (p) {
    return p.query(charId);
  })
  // deliberately not loading the user's character list. we're viewing
  // one, not all.
  .concat(userId == null ? [] : [paths.user].map(function (p) {
    return p.query(userId);
  }));
});
var rankings = exports.rankings = (0, _reselect.createSelector)(param("league"), param("rankName"), function (league, rankName) {
  return [paths.rankings].map(function (p) {
    return p.query({ league: league, rankName: rankName });
  });
});

var root = exports.root = (0, _reselect.createSelector)(const_, auth, _lodash2.default.concat);
// no duplicate queries. Use _.isEqual to dedupe object queries, like charlist.
var deepDiff = function deepDiff(u, r) {
  return _lodash2.default.differenceWith(u, r, _lodash2.default.isEqual);
};
var user = exports.user = (0, _reselect.createSelector)(_user, root, deepDiff);
var char = exports.char = (0, _reselect.createSelector)(_char, root, deepDiff);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduxStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reducers__ = __webpack_require__(859);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var isOffline=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["selectors"].flags.offline();var enableLogging=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["selectors"].flags.logFirebase();Object(__WEBPACK_IMPORTED_MODULE_0__swarm2_assert__["assert"])(isOffline||__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["redux"]&&__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["redux"].config,"no firebase config?",__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["redux"]);// https://github.com/zalmoxisus/redux-devtools-extension
var withDevtools=!window.__REDUX_DEVTOOLS_EXTENSION__?__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.identity:window.__REDUX_DEVTOOLS_EXTENSION__({actionsBlacklist:["TICK"]});function createReduxStore(){// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4__Reducers__["a" /* reducer */],undefined,__WEBPACK_IMPORTED_MODULE_2_redux__["compose"].apply(undefined,_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["redux"].withMiddleware({isOffline:isOffline,enableLogging:enableLogging})).concat([withDevtools])));}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units__ = __webpack_require__(389);
var isOffline=__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["selectors"].flags.offline();var ui=function ui(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];return state;};//const ui = combineReducers(_.mapValues({
//  //updates,
//}, m => m.reduceUI))
// Legacy reducers.
//export const reduceByKey = combineReducers({
//  ...coreRedux.reducers,
//  ...(isOffline ? coreRedux.offlineReducers : {}),
//  form: units.form, // TODO: this belongs under ui
//  ui,
//})
//
//export function reducer(state = {}, action) {
//  state = reduceByKey(state, action)
//  return state
//}
// New-style reducers.
var reducer=(isOffline?__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["createOfflineReducer"]:__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["createReducer"])({form:__WEBPACK_IMPORTED_MODULE_1__units__["b" /* reduceKeys */].form,// TODO: this belongs under ui
ui:ui});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnitsRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnitView__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnitListView__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
function UnitsRouter(props){var match=props.match,readonly=props.readonly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+"/:unitName",render:__WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()({readonly:readonly})(__WEBPACK_IMPORTED_MODULE_2__UnitView__["a" /* UnitView */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path,render:__WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()({readonly:readonly})(__WEBPACK_IMPORTED_MODULE_3__UnitListView__["a" /* UnitListView */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:__WEBPACK_IMPORTED_MODULE_4__common__["f" /* NotFoundView */]}));}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnitView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withState__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_menu__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_help_outline__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_help_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_help_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Drawer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UnitNavView__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__swarm2_core__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var M=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.UnitView");var UM=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("units");var UnitDescription=__WEBPACK_IMPORTED_MODULE_9__common__["l" /* prefixedDescription */]("units");function ResourceItem(_ref){var name=_ref.name,count=_ref.count;// show decimals for small on-whole numbers.
var maxSmall=count.floor().equals(count)?undefined:10;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"resource.item",values:{count:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:count,maxSmall:maxSmall}),unittype:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:name+".plural",values:{count:count}})}});}function ResourceList(_ref2){var items=_ref2.items;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"resource.list",values:{length:items.length,first:items[0],last:items[items.length-1],// item => "item, " for all but the last item
head:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,items.slice(0,-1).map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{key:i,id:"resource.listitem",values:{item:item}});}))}});}function Resources(_ref3){var items=_ref3.items;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ResourceList,{items:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(items,function(count,name){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ResourceItem,{name:name,count:count});})});}var UnitTextRender=function UnitTextRender(_ref4){var unitName=_ref4.unitName,prodEach=_ref4.prodEach,prodTotal=_ref4.prodTotal,costEach=_ref4.costEach,isProducible=_ref4.isProducible,count=_ref4.count,velocity=_ref4.velocity;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnitDescription,{id:unitName})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"body.count",values:{count:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:count,sigfigs:5}),name:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:count}})}})),Object.keys(prodEach).length?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"body.prodEach",values:{resources:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Resources,{items:prodEach}),name:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:1}})}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"body.prodTotal",values:{resources:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Resources,{items:prodTotal}),name:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:1}})}}))):null,isProducible?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"body.velocity",values:{velocity:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:velocity}),name:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:velocity}})}}))):null,Object.keys(costEach).length?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"body.costeach",values:{unitName:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:1}}),cost:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Resources,{items:costEach})}}))):null);};function BuyNUnitsRender(props){var unitName=props.unitName,input=props.input,setBuyN=props.setBuyN,buyCount=props.buyCount,isBuyButtonDisabled=props.isBuyButtonDisabled,buyUnit=props.buyUnit;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a,{value:input,hintText:"",floatingLabelText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:buyCount}),onChange:function onChange(e){return setBuyN(e.target.value,unitName);}}),isBuyButtonDisabled?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a,{primary:true,disabled:true,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.cantbuy"})}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a,{primary:true,onClick:buyUnit,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.buybutton",values:{name:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:buyCount}})}})}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a,{secondary:true,onClick:function onClick(){return setBuyN("",unitName);},label:"1"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a,{secondary:true,onClick:function onClick(){return setBuyN("25%",unitName);},label:"25%"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a,{secondary:true,onClick:function onClick(){return setBuyN("100%",unitName);},label:"100%"})));}var BuyUnitFormRender=__WEBPACK_IMPORTED_MODULE_3_recompose_withState___default()("open","setOpen",false)(function(_ref5){var open=_ref5.open,setOpen=_ref5.setOpen,props=_objectWithoutProperties(_ref5,["open","setOpen"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,{onClick:function onClick(){return setOpen(!open);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_help_outline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BuyNUnitsRender,props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_material_ui_Card__["Card"],{style:{display:open?"":"none"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_material_ui_Card__["CardTitle"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.help.title"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.help0"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.help1"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.help2"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"BuyN.help3"})))));});function UnitToolbarRender(_ref6){var unitName=_ref6.unitName,displayName=_ref6.displayName,drawerProps=_ref6.drawerProps;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"title",values:{charName:displayName,unitName:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:0}})}})})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["ToolbarGroup"],null,drawerProps.docked?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,{onClick:function onClick(){return drawerProps.setOpen(!drawerProps.open);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_menu___default.a,null))));}function UnitRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});var charId=props.charId,unitName=props.unitName,readonly=props.readonly,isBuyable=props.isBuyable,drawerProps=props.drawerProps,drawerStyle=props.drawerStyle;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnitToolbarRender,{drawerProps:drawerProps,unitName:unitName,displayName:props.displayName}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_material_ui_Card__["CardText"],{style:{paddingRight:drawerProps.docked?"256px":"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_material_ui_Drawer___default.a,Object.assign({},drawerProps,drawerStyle,{openSecondary:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__UnitNavView__["a" /* default */],{charId:charId,unitName:unitName,input:props.input,readonly:readonly})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnitTextRender,Object.assign({unitName:unitName},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(props,["prodEach","prodTotal","costEach","count","velocity","isProducible"]))),isBuyable&&!readonly?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BuyUnitFormRender,Object.assign({unitName:unitName},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(props,["input","setBuyN","buyCount","isBuyButtonDisabled","buyUnit"]))):null));}var UnitView=__WEBPACK_IMPORTED_MODULE_13__swarm2_core__["containers"].units.Unit(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */](UnitRender));

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(82);

var _EnhancedButton = __webpack_require__(112);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      raisedButton = _context$muiTheme.raisedButton,
      borderRadius = _context$muiTheme.borderRadius;
  var disabled = props.disabled,
      disabledBackgroundColor = props.disabledBackgroundColor,
      disabledLabelColor = props.disabledLabelColor,
      fullWidth = props.fullWidth,
      icon = props.icon,
      label = props.label,
      labelPosition = props.labelPosition,
      primary = props.primary,
      secondary = props.secondary,
      style = props.style;


  var amount = primary || secondary ? 0.4 : 0.08;

  var backgroundColor = raisedButton.color;
  var labelColor = raisedButton.textColor;

  if (disabled) {
    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
  } else if (primary) {
    backgroundColor = raisedButton.primaryColor;
    labelColor = raisedButton.primaryTextColor;
  } else if (secondary) {
    backgroundColor = raisedButton.secondaryColor;
    labelColor = raisedButton.secondaryTextColor;
  } else {
    if (props.backgroundColor) {
      backgroundColor = props.backgroundColor;
    }
    if (props.labelColor) {
      labelColor = props.labelColor;
    }
  }

  var buttonHeight = style && style.height || button.height;

  return {
    root: {
      display: 'inline-block',
      transition: _transitions2.default.easeOut(),
      minWidth: fullWidth ? '100%' : button.minWidth
    },
    button: {
      height: buttonHeight,
      lineHeight: buttonHeight + 'px',
      width: '100%',
      padding: 0,
      borderRadius: borderRadius,
      transition: _transitions2.default.easeOut(),
      backgroundColor: backgroundColor,
      // That's the default value for a button but not a link
      textAlign: 'center'
    },
    label: {
      position: 'relative',
      opacity: 1,
      fontSize: raisedButton.fontSize,
      letterSpacing: 0,
      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
      fontWeight: raisedButton.fontWeight,
      margin: 0,
      userSelect: 'none',
      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      color: labelColor
    },
    icon: {
      verticalAlign: 'middle',
      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
      marginRight: label && labelPosition === 'before' ? 12 : 0
    },
    overlay: {
      height: buttonHeight,
      borderRadius: borderRadius,
      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    ripple: {
      color: labelColor,
      opacity: !(primary || secondary) ? 0.1 : 0.16
    }
  };
}

var RaisedButton = function (_Component) {
  (0, _inherits3.default)(RaisedButton, _Component);

  function RaisedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RaisedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      keyboardFocused: false,
      touched: false,
      initialZDepth: 0,
      zDepth: 0
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({
          zDepth: _this.state.initialZDepth + 1
        });
      }
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
    }, _this.handleMouseUp = function (event) {
      _this.setState({
        zDepth: _this.state.initialZDepth
      });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.state.keyboardFocused) {
        _this.setState({
          zDepth: _this.state.initialZDepth,
          hovered: false
        });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.keyboardFocused && !_this.state.touched) {
        _this.setState({
          hovered: true
        });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth + 1
      });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth
      });

      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;

      _this.setState({
        zDepth: zDepth,
        keyboardFocused: keyboardFocused
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RaisedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var zDepth = this.props.disabled ? 0 : 1;
      this.setState({
        zDepth: zDepth,
        initialZDepth: zDepth
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var zDepth = nextProps.disabled ? 0 : 1;
      var nextState = {
        zDepth: zDepth,
        initialZDepth: zDepth
      };

      if (nextProps.disabled) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          buttonStyle = _props.buttonStyle,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          disabledBackgroundColor = _props.disabledBackgroundColor,
          disabledLabelColor = _props.disabledLabelColor,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          label = _props.label,
          labelColor = _props.labelColor,
          labelPosition = _props.labelPosition,
          labelStyle = _props.labelStyle,
          overlayStyle = _props.overlayStyle,
          primary = _props.primary,
          rippleStyle = _props.rippleStyle,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);

      var buttonEventHandlers = disabled ? {} : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      var labelElement = label && _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
        label
      );

      var iconCloned = icon && (0, _react.cloneElement)(icon, {
        color: icon.props.color || styles.label.color,
        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
        key: 'iconCloned'
      });

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: this.state.zDepth
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
            focusRippleColor: mergedRippleStyles.color,
            touchRippleColor: mergedRippleStyles.color,
            focusRippleOpacity: mergedRippleStyles.opacity,
            touchRippleOpacity: mergedRippleStyles.opacity
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
            },
            enhancedButtonChildren
          )
        )
      );
    }
  }]);
  return RaisedButton;
}(_react.Component);

RaisedButton.muiName = 'RaisedButton';
RaisedButton.defaultProps = {
  disabled: false,
  labelPosition: 'after',
  fullWidth: false,
  primary: false,
  secondary: false
};
RaisedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RaisedButton.propTypes =  false ? {
  /**
   * Override the default background color for the button,
   * but not the default disabled background color
   * (use `disabledBackgroundColor` for this).
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The content of the button.
   * If a label is provided via the `label` prop, the text within the label
   * will be displayed in addition to the content provided here.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
    * The element to use as the container for the RaisedButton. Either a string to
    * use a DOM element or a ReactElement. This is useful for wrapping the
    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
    * that it passes all of its given props through to the underlying DOM
    * element and renders its children prop for proper integration.
    */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the default background color for the button
   * when it is disabled.
   */
  disabledBackgroundColor: _propTypes2.default.string,
  /**
   * The color of the button's label when the button is disabled.
   */
  disabledLabelColor: _propTypes2.default.string,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * An icon to be displayed within the button.
   */
  icon: _propTypes2.default.node,
  /**
   * The label to be displayed within the button.
   * If content is provided via the `children` prop, that content will be
   * displayed in addition to the label provided here.
   */
  label: validateLabel,
  /**
   * The color of the button's label.
   */
  labelColor: _propTypes2.default.string,
  /**
   * The position of the button's label relative to the button's `children`.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline style of the button overlay.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's primary color.
   */
  primary: _propTypes2.default.bool,
  /**
   * Override the inline style of the ripple element.
   */
  rippleStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's secondary color.
   * If both `secondary` and `primary` are true, the button will use
   * the theme's primary color.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = RaisedButton;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(864);
module.exports = __webpack_require__(33).Object.assign;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(62);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(865) });


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(179);
var pIE = __webpack_require__(124);
var toObject = __webpack_require__(98);
var IObject = __webpack_require__(261);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(79)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(392);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__(869);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),
/* 867 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(114);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(114);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var rounded = props.rounded,
      circle = props.circle,
      transitionEnabled = props.transitionEnabled,
      zDepth = props.zDepth;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      paper = _context$muiTheme.paper,
      borderRadius = _context$muiTheme.borderRadius;


  return {
    root: {
      color: paper.color,
      backgroundColor: paper.backgroundColor,
      transition: transitionEnabled && _transitions2.default.easeOut(),
      boxSizing: 'border-box',
      fontFamily: baseTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
    }
  };
}

var Paper = function (_Component) {
  (0, _inherits3.default)(Paper, _Component);

  function Paper() {
    (0, _classCallCheck3.default)(this, Paper);
    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Paper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          circle = _props.circle,
          rounded = _props.rounded,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return Paper;
}(_react.Component);

Paper.defaultProps = {
  circle: false,
  rounded: true,
  transitionEnabled: true,
  zDepth: 1
};
Paper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Paper.propTypes =  false ? {
  /**
   * Children passed into the paper element.
   */
  children: _propTypes2.default.node,
  /**
   * Set to true to generate a circular paper container.
   */
  circle: _propTypes2.default.bool,
  /**
   * By default, the paper container will have a border radius.
   * Set this to false to generate a container with sharp corners.
   */
  rounded: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Set to false to disable CSS transitions for the paper element.
   */
  transitionEnabled: _propTypes2.default.bool,
  /**
   * This number represents the zDepth of the paper shadow.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Paper;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(76);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedTextarea = __webpack_require__(873);

var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);

var _TextFieldHint = __webpack_require__(876);

var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);

var _TextFieldLabel = __webpack_require__(877);

var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);

var _TextFieldUnderline = __webpack_require__(878);

var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      _context$muiTheme$tex = _context$muiTheme.textField,
      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
      focusColor = _context$muiTheme$tex.focusColor,
      textColor = _context$muiTheme$tex.textColor,
      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
      backgroundColor = _context$muiTheme$tex.backgroundColor,
      errorColor = _context$muiTheme$tex.errorColor;


  var styles = {
    root: {
      fontSize: 16,
      lineHeight: '24px',
      width: props.fullWidth ? '100%' : 256,
      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
      display: 'inline-block',
      position: 'relative',
      backgroundColor: backgroundColor,
      fontFamily: baseTheme.fontFamily,
      transition: _transitions2.default.easeOut('200ms', 'height'),
      cursor: props.disabled ? 'not-allowed' : 'auto'
    },
    error: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: errorColor,
      transition: _transitions2.default.easeOut()
    },
    floatingLabel: {
      color: props.disabled ? disabledTextColor : floatingLabelColor,
      pointerEvents: 'none'
    },
    input: {
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      color: props.disabled ? disabledTextColor : textColor,
      cursor: 'inherit',
      font: 'inherit',
      WebkitOpacity: 1,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
    },
    inputNative: {
      appearance: 'textfield' // Improve type search style.
    }
  };

  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
    marginTop: props.floatingLabelText ? 36 : 12,
    marginBottom: props.floatingLabelText ? -36 : -12,
    boxSizing: 'border-box',
    font: 'inherit'
  });

  // Do not assign a height to the textarea as he handles it on his own.
  styles.input.height = '100%';

  if (state.isFocused) {
    styles.floatingLabel.color = focusColor;
  }

  if (props.floatingLabelText) {
    styles.input.boxSizing = 'border-box';

    if (!props.multiLine) {
      styles.input.marginTop = 14;
    }

    if (state.errorText) {
      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
    }
  }

  if (state.errorText) {
    if (state.isFocused) {
      styles.floatingLabel.color = styles.error.color;
    }
  }

  return styles;
};

/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}

var TextField = function (_Component) {
  (0, _inherits3.default)(TextField, _Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false,
      errorText: undefined,
      hasValue: false
    }, _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleInputChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.setState({ hasValue: isValid(event.target.value) });
      }
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _this.handleInputFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({ isFocused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleHeightChange = function (event, height) {
      var newHeight = height + 24;
      if (_this.props.floatingLabelText) {
        newHeight += 24;
      }
      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextField, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          hintText = _props.hintText,
          floatingLabelText = _props.floatingLabelText,
          id = _props.id;


      var propsLeaf = children ? children.props : this.props;

      this.setState({
        errorText: this.props.errorText,
        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
      });

       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;

      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled && !this.props.disabled) {
        this.setState({
          isFocused: false
        });
      }

      if (nextProps.errorText !== this.props.errorText) {
        this.setState({
          errorText: nextProps.errorText
        });
      }

      if (nextProps.children && nextProps.children.props) {
        nextProps = nextProps.children.props;
      }

      if (nextProps.hasOwnProperty('value')) {
        var hasValue = isValid(nextProps.value);

        this.setState({
          hasValue: hasValue
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'blur',
    value: function blur() {
      if (this.input) {
        this.getInputNode().blur();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.input) {
        this.getInputNode().focus();
      }
    }
  }, {
    key: 'select',
    value: function select() {
      if (this.input) {
        this.getInputNode().select();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input ? this.getInputNode().value : undefined;
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
    }
  }, {
    key: '_isControlled',
    value: function _isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          errorStyle = _props2.errorStyle,
          errorText = _props2.errorText,
          floatingLabelFixed = _props2.floatingLabelFixed,
          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
          floatingLabelStyle = _props2.floatingLabelStyle,
          floatingLabelText = _props2.floatingLabelText,
          fullWidth = _props2.fullWidth,
          hintText = _props2.hintText,
          hintStyle = _props2.hintStyle,
          id = _props2.id,
          inputStyle = _props2.inputStyle,
          multiLine = _props2.multiLine,
          onBlur = _props2.onBlur,
          onChange = _props2.onChange,
          onFocus = _props2.onFocus,
          style = _props2.style,
          type = _props2.type,
          underlineDisabledStyle = _props2.underlineDisabledStyle,
          underlineFocusStyle = _props2.underlineFocusStyle,
          underlineShow = _props2.underlineShow,
          underlineStyle = _props2.underlineStyle,
          rows = _props2.rows,
          rowsMax = _props2.rowsMax,
          textareaStyle = _props2.textareaStyle,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var inputId = id || this.uniqueId;

      var errorTextElement = this.state.errorText && _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
        this.state.errorText
      );

      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
        _TextFieldLabel2.default,
        {
          muiTheme: this.context.muiTheme,
          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
          shrinkStyle: floatingLabelShrinkStyle,
          htmlFor: inputId,
          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
          disabled: disabled
        },
        floatingLabelText
      );

      var inputProps = {
        id: inputId,
        ref: function ref(elem) {
          return _this2.input = elem;
        },
        disabled: this.props.disabled,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus
      };

      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);

      var inputElement = void 0;
      if (children) {
        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
        }));
      } else {
        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
          style: childStyleMerged,
          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
          rows: rows,
          rowsMax: rowsMax,
          hintText: hintText
        }, other, inputProps, {
          onHeightChange: this.handleHeightChange
        })) : _react2.default.createElement('input', (0, _extends3.default)({
          type: type,
          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
        }, other, inputProps));
      }

      var rootProps = {};

      if (children) {
        rootProps = other;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rootProps, {
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }),
        floatingLabelTextElement,
        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
          muiTheme: this.context.muiTheme,
          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
          style: hintStyle,
          text: hintText
        }) : null,
        inputElement,
        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
          disabled: disabled,
          disabledStyle: underlineDisabledStyle,
          error: !!this.state.errorText,
          errorStyle: errorStyle,
          focus: this.state.isFocused,
          focusStyle: underlineFocusStyle,
          muiTheme: this.context.muiTheme,
          style: underlineStyle
        }) : null,
        errorTextElement
      );
    }
  }]);
  return TextField;
}(_react.Component);

TextField.defaultProps = {
  disabled: false,
  floatingLabelFixed: false,
  multiLine: false,
  fullWidth: false,
  type: 'text',
  underlineShow: true,
  rows: 1
};
TextField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TextField.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The text string to use for the default value.
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Disables the text field if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The style object to use to override error styles.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when there is no value.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * The style object to use to override floating label styles when focused.
   */
  floatingLabelFocusStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles when shrunk.
   */
  floatingLabelShrinkStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content to use for the floating label element.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the field receives the property width 100%.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's hint text element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the inline-styles of the TextField's input element.
   * When multiLine is false: define the style of the input element.
   * When multiLine is true: define the style of the container of the textarea.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * If true, a textarea element will be rendered.
   * The textarea also grows and shrinks according to the number of lines.
   */
  multiLine: _propTypes2.default.bool,
  /**
   * Name applied to the input.
   */
  name: _propTypes2.default.string,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired when the textfield's value changes.
   *
   * @param {object} event Change event targeting the text field.
   * @param {string} newValue The new value of the text field.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Number of rows to display when multiLine option is set to true.
   */
  rows: _propTypes2.default.number,
  /**
   * Maximum number of rows to display when
   * multiLine option is set to true.
   */
  rowsMax: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's textarea element.
   * The TextField use either a textarea or an input,
   * this property has effects only when multiLine is true.
   */
  textareaStyle: _propTypes2.default.object,
  /**
   * Specifies the type of input to display
   * such as "password" or "text".
   */
  type: _propTypes2.default.string,
  /**
   * Override the inline-styles of the
   * TextField's underline element when disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's
   * underline element when focussed.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * If true, shows the underline for the text field.
   */
  underlineShow: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * The value of the text field.
   */
  value: _propTypes2.default.any
} : {};
exports.default = TextField;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(115);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowsHeight = 24;

function getStyles(props, context, state) {
  return {
    root: {
      position: 'relative' // because the shadow has position: 'absolute'
    },
    textarea: {
      height: state.height,
      width: '100%',
      resize: 'none',
      font: 'inherit',
      padding: 0,
      cursor: 'inherit'
    },
    shadow: {
      resize: 'none',
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      height: 'auto'
    }
  };
}

var EnhancedTextarea = function (_Component) {
  (0, _inherits3.default)(EnhancedTextarea, _Component);

  function EnhancedTextarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedTextarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.handleResize = function (event) {
      _this.syncHeightWithShadow(_this.props.value, event);
    }, _this.handleChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.syncHeightWithShadow(event.target.value);
      }

      if (_this.props.hasOwnProperty('valueLink')) {
        _this.props.valueLink.requestChange(event.target.value);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedTextarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        height: this.props.rows * rowsHeight
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow(this.props.value);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
        this.syncHeightWithShadow(nextProps.value, null, nextProps);
      }
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.refs.input;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getInputNode().value = value;
      this.syncHeightWithShadow(value);
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(newValue, event, props) {
      var shadow = this.refs.shadow;
      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;

      if (displayText !== undefined) {
        shadow.value = displayText;
      }

      var newHeight = shadow.scrollHeight;

      // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013
      if (newHeight === undefined) return;

      props = props || this.props;

      if (props.rowsMax >= props.rows) {
        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
      }

      newHeight = Math.max(newHeight, rowsHeight);

      if (this.state.height !== newHeight) {
        var input = this.refs.input;
        var cursorPosition = input.selectionStart;
        this.setState({
          height: newHeight
        }, function () {
          input.setSelectionRange(cursorPosition, cursorPosition);
        });

        if (props.onHeightChange) {
          props.onHeightChange(event, newHeight);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          onHeightChange = _props.onHeightChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          shadowStyle = _props.shadowStyle,
          style = _props.style,
          hintText = _props.hintText,
          textareaStyle = _props.textareaStyle,
          valueLink = _props.valueLink,
          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
      var props = {};

      if (this.props.hasOwnProperty('valueLink')) {
        other.value = valueLink.value;
        props.valueLink = valueLink;
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(rootStyles) },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          ref: 'shadow',
          style: prepareStyles(shadowStyles),
          tabIndex: '-1',
          rows: this.props.rows,
          defaultValue: this.props.defaultValue,
          readOnly: true,
          value: this.props.value
        }, props)),
        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
          ref: 'input',
          rows: this.props.rows,
          style: prepareStyles(textareaStyles),
          onChange: this.handleChange
        }))
      );
    }
  }]);
  return EnhancedTextarea;
}(_react.Component);

EnhancedTextarea.defaultProps = {
  rows: 1
};
EnhancedTextarea.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedTextarea.propTypes =  false ? {
  defaultValue: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  hintText: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  onHeightChange: _propTypes2.default.func,
  rows: _propTypes2.default.number,
  rowsMax: _propTypes2.default.number,
  shadowStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  textareaStyle: _propTypes2.default.object,
  value: _propTypes2.default.string,
  valueLink: _propTypes2.default.object
} : {};
exports.default = EnhancedTextarea;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;

var _defineProperty = __webpack_require__(875);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;

// IE8+ Support
var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;

// Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
var passiveOption = exports.passiveOption = function () {
  var cache = null;

  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (e) {} // eslint-disable-line no-empty

    cache = supportsPassiveOption;

    return supportsPassiveOption;
  }();
}();

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(257);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

exports.default = defineProperty;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function defineProperty(o, p, attr) {
  return (0, _defineProperty2.default)(o, p, attr);
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var hintColor = props.muiTheme.textField.hintColor,
      show = props.show;


  return {
    root: {
      position: 'absolute',
      opacity: show ? 1 : 0,
      color: hintColor,
      transition: _transitions2.default.easeOut(),
      bottom: 12
    }
  };
}

var TextFieldHint = function TextFieldHint(props) {
  var prepareStyles = props.muiTheme.prepareStyles,
      style = props.style,
      text = props.text;


  var styles = getStyles(props);

  return _react2.default.createElement(
    'div',
    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
    text
  );
};

TextFieldHint.propTypes =  false ? {
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * True if the hint text should be visible.
   */
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The hint text displayed.
   */
  text: _propTypes2.default.node
} : {};

TextFieldHint.defaultProps = {
  show: true
};

exports.default = TextFieldHint;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var defaultStyles = {
    position: 'absolute',
    lineHeight: '22px',
    top: 38,
    transition: _transitions2.default.easeOut(),
    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
    transform: 'scale(1) translate(0, 0)',
    transformOrigin: 'left top',
    pointerEvents: 'auto',
    userSelect: 'none'
  };

  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
    transform: 'scale(0.75) translate(0, -28px)',
    pointerEvents: 'none'
  }, props.shrinkStyle) : null;

  return {
    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
  };
}

var TextFieldLabel = function TextFieldLabel(props) {
  var muiTheme = props.muiTheme,
      className = props.className,
      children = props.children,
      htmlFor = props.htmlFor,
      onClick = props.onClick;
  var prepareStyles = muiTheme.prepareStyles;

  var styles = getStyles(props);

  return _react2.default.createElement(
    'label',
    {
      className: className,
      style: prepareStyles(styles.root),
      htmlFor: htmlFor,
      onClick: onClick
    },
    children
  );
};

TextFieldLabel.propTypes =  false ? {
  /**
   * The label contents.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the label if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The id of the target element that this label should refer to.
   */
  htmlFor: _propTypes2.default.string,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Callback function for when the label is selected via a touch tap.
   *
   * @param {object} event TouchTap event targeting the text field label.
   */
  onClick: _propTypes2.default.func,
  /**
   * True if the floating label should shrink.
   */
  shrink: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when shrunk.
   */
  shrinkStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

TextFieldLabel.defaultProps = {
  disabled: false,
  shrink: false
};

exports.default = TextFieldLabel;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * True if the parent `TextField` is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is disabled.
   */
  disabledStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` has an error.
   */
  error: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` has an error.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` is focused.
   */
  focus: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is focused.
   */
  focusStyle: _propTypes2.default.object,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
};

var defaultProps = {
  disabled: false,
  disabledStyle: {},
  error: false,
  errorStyle: {},
  focus: false,
  focusStyle: {},
  style: {}
};

var TextFieldUnderline = function TextFieldUnderline(props) {
  var disabled = props.disabled,
      disabledStyle = props.disabledStyle,
      error = props.error,
      errorStyle = props.errorStyle,
      focus = props.focus,
      focusStyle = props.focusStyle,
      muiTheme = props.muiTheme,
      style = props.style;
  var errorStyleColor = errorStyle.color;
  var prepareStyles = muiTheme.prepareStyles,
      _muiTheme$textField = muiTheme.textField,
      borderColor = _muiTheme$textField.borderColor,
      disabledTextColor = _muiTheme$textField.disabledTextColor,
      errorColor = _muiTheme$textField.errorColor,
      focusColor = _muiTheme$textField.focusColor;


  var styles = {
    root: {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderColor: borderColor,
      bottom: 8,
      boxSizing: 'content-box',
      margin: 0,
      position: 'absolute',
      width: '100%'
    },
    disabled: {
      borderBottomStyle: 'dotted',
      borderBottomWidth: 2,
      borderColor: disabledTextColor
    },
    focus: {
      borderBottomStyle: 'solid',
      borderBottomWidth: 2,
      borderColor: focusColor,
      transform: 'scaleX(0)',
      transition: _transitions2.default.easeOut()
    },
    error: {
      borderColor: errorStyleColor ? errorStyleColor : errorColor,
      transform: 'scaleX(1)'
    }
  };

  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);

  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
  );
};

TextFieldUnderline.propTypes =  false ? propTypes : {};
TextFieldUnderline.defaultProps = defaultProps;

exports.default = TextFieldUnderline;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var noGutter = props.noGutter;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      backgroundColor: toolbar.backgroundColor,
      height: toolbar.height,
      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
}

var Toolbar = function (_Component) {
  (0, _inherits3.default)(Toolbar, _Component);

  function Toolbar() {
    (0, _classCallCheck3.default)(this, Toolbar);
    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Toolbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          noGutter = _props.noGutter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children
      );
    }
  }]);
  return Toolbar;
}(_react.Component);

Toolbar.defaultProps = {
  noGutter: false
};
Toolbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Toolbar.propTypes =  false ? {
  /**
   * Can be a `ToolbarGroup` to render a group of related items.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Do not apply `desktopGutter` to the `Toolbar`.
   */
  noGutter: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Toolbar;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var firstChild = props.firstChild,
      lastChild = props.lastChild;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      toolbar = _context$muiTheme.toolbar;


  var marginHorizontal = baseTheme.spacing.desktopGutter;
  var marginVertical = (toolbar.height - button.height) / 2;

  var styles = {
    root: {
      position: 'relative',
      marginLeft: firstChild ? -marginHorizontal : undefined,
      marginRight: lastChild ? -marginHorizontal : undefined,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    dropDownMenu: {
      root: {
        color: toolbar.color, // removes hover color change, we want to keep it
        marginRight: baseTheme.spacing.desktopGutter,
        flex: 1,
        whiteSpace: 'nowrap'
      },
      controlBg: {
        backgroundColor: toolbar.menuHoverColor,
        borderRadius: 0
      },
      underline: {
        display: 'none'
      }
    },
    button: {
      margin: marginVertical + 'px ' + marginHorizontal + 'px',
      position: 'relative'
    },
    icon: {
      root: {
        cursor: 'pointer',
        lineHeight: toolbar.height + 'px',
        paddingLeft: baseTheme.spacing.desktopGutter
      }
    },
    span: {
      color: toolbar.iconColor,
      lineHeight: toolbar.height + 'px'
    }
  };

  return styles;
}

var ToolbarGroup = function (_Component) {
  (0, _inherits3.default)(ToolbarGroup, _Component);

  function ToolbarGroup() {
    (0, _classCallCheck3.default)(this, ToolbarGroup);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarGroup, [{
    key: 'handleMouseLeaveFontIcon',
    value: function handleMouseLeaveFontIcon(style) {
      return function (event) {
        event.target.style.zIndex = 'auto';
        event.target.style.color = style.root.color;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          firstChild = _props.firstChild,
          lastChild = _props.lastChild,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        if (!currentChild) {
          return null;
        }
        if (!currentChild.type) {
          return currentChild;
        }
        switch (currentChild.type.muiName) {
          case 'DropDownMenu':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
              underlineStyle: styles.dropDownMenu.underline
            });
          case 'RaisedButton':
          case 'FlatButton':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
            });
          case 'FontIcon':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
            });
          case 'ToolbarSeparator':
          case 'ToolbarTitle':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
            });
          default:
            return currentChild;
        }
      }, this);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        newChildren
      );
    }
  }]);
  return ToolbarGroup;
}(_react.Component);

ToolbarGroup.defaultProps = {
  firstChild: false,
  lastChild: false
};
ToolbarGroup.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarGroup.propTypes =  false ? {
  /**
   * Can be any node or number of nodes.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
   * to prevent setting the left gap.
   */
  firstChild: _propTypes2.default.bool,
  /**
   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
   * to prevent setting the right gap.
   */
  lastChild: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarGroup;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      backgroundColor: toolbar.separatorColor,
      display: 'block',
      height: baseTheme.spacing.desktopGutterMore,
      marginLeft: baseTheme.spacing.desktopGutter,
      width: 1
    }
  };
}

var ToolbarSeparator = function (_Component) {
  (0, _inherits3.default)(ToolbarSeparator, _Component);

  function ToolbarSeparator() {
    (0, _classCallCheck3.default)(this, ToolbarSeparator);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarSeparator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
    }
  }]);
  return ToolbarSeparator;
}(_react.Component);

ToolbarSeparator.muiName = 'ToolbarSeparator';
ToolbarSeparator.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarSeparator.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarSeparator;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      paddingRight: baseTheme.spacing.desktopGutterLess,
      lineHeight: toolbar.height + 'px',
      fontSize: toolbar.titleFontSize,
      fontFamily: baseTheme.fontFamily,
      position: 'relative',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  };
}

var ToolbarTitle = function (_Component) {
  (0, _inherits3.default)(ToolbarTitle, _Component);

  function ToolbarTitle() {
    (0, _classCallCheck3.default)(this, ToolbarTitle);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          text = _props.text,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
        }, other),
        text
      );
    }
  }]);
  return ToolbarTitle;
}(_react.Component);

ToolbarTitle.muiName = 'ToolbarTitle';
ToolbarTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarTitle.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to be displayed.
   */
  text: _propTypes2.default.node
} : {};
exports.default = ToolbarTitle;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _EnhancedButton = __webpack_require__(112);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(884);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Tooltip = __webpack_require__(396);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _childUtils = __webpack_require__(886);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      boxSizing: 'border-box',
      overflow: 'visible',
      transition: _transitions2.default.easeOut(),
      padding: baseTheme.spacing.iconSize / 2,
      width: baseTheme.spacing.iconSize * 2,
      height: baseTheme.spacing.iconSize * 2,
      fontSize: 0
    },
    tooltip: {
      boxSizing: 'border-box'
    },
    disabled: {
      color: baseTheme.palette.disabledColor,
      fill: baseTheme.palette.disabledColor,
      cursor: 'default'
    }
  };
}

var IconButton = function (_Component) {
  (0, _inherits3.default)(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      // Not to be confonded with the touch property.
      // This state is to determined if it's a mobile device.
      touch: false,
      tooltipShown: false
    }, _this.handleBlur = function (event) {
      _this.hideTooltip();
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      _this.showTooltip();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.button.isKeyboardFocused()) {
        _this.hideTooltip();
      }
      _this.setState({ hovered: false });
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseOut = function (event) {
      if (_this.props.disabled) _this.hideTooltip();
      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
    }, _this.handleMouseEnter = function (event) {
      _this.showTooltip();

      // Cancel hover styles for touch devices
      if (!_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onKeyboardFocus = _this$props.onKeyboardFocus;

      if (isKeyboardFocused && !disabled) {
        _this.showTooltip();
        if (onFocus) {
          onFocus(event);
        }
      } else {
        _this.hideTooltip();
        if (onBlur) {
          onBlur(event);
        }
      }

      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      if (onKeyboardFocus) {
        onKeyboardFocus(event, isKeyboardFocused);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hovered: false });
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus() {
      this.button.setKeyboardFocus();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      if (this.props.tooltip) {
        this.setState({ tooltipShown: true });
      }
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      if (this.props.tooltip) this.setState({ tooltipShown: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          hoveredStyle = _props.hoveredStyle,
          disableTouchRipple = _props.disableTouchRipple,
          children = _props.children,
          iconClassName = _props.iconClassName,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipPositionProp = _props.tooltipPosition,
          tooltipStyles = _props.tooltipStyles,
          touch = _props.touch,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);

      var fonticon = void 0;

      var styles = getStyles(this.props, this.context);
      var tooltipPosition = tooltipPositionProp.split('-');

      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});

      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
        label: tooltip,
        show: this.state.tooltipShown,
        touch: touch,
        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
        verticalPosition: tooltipPosition[0],
        horizontalPosition: tooltipPosition[1]
      }) : null;

      if (iconClassName) {
        var iconHoverColor = iconStyle.iconHoverColor,
            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);


        fonticon = _react2.default.createElement(
          _FontIcon2.default,
          {
            className: iconClassName,
            hoverColor: disabled ? null : iconHoverColor,
            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
            color: this.context.muiTheme.baseTheme.palette.textColor
          },
          children
        );
      }

      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({
          ref: function ref(_ref2) {
            return _this2.button = _ref2;
          }
        }, other, {
          centerRipple: true,
          disabled: disabled,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          disableTouchRipple: disableTouchRipple,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onMouseOut: this.handleMouseOut,
          onKeyboardFocus: this.handleKeyboardFocus
        }),
        tooltipElement,
        fonticon,
        (0, _childUtils.extendChildren)(children, {
          style: childrenStyle
        })
      );
    }
  }]);
  return IconButton;
}(_react.Component);

IconButton.muiName = 'IconButton';
IconButton.defaultProps = {
  disabled: false,
  disableTouchRipple: false,
  iconStyle: {},
  tooltipPosition: 'bottom-center',
  touch: false
};
IconButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconButton.propTypes =  false ? {
  /**
   * Can be used to pass a `FontIcon` element as the icon for the button.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the element will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when the component is hovered.
   */
  hoveredStyle: _propTypes2.default.object,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the icon element.
   * Note: you can specify iconHoverColor as a String inside this object.
   */
  iconStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the button is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} keyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseOut: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to supply to the element's tooltip.
   */
  tooltip: _propTypes2.default.node,
  /**
   * The vertical and horizontal positions, respectively, of the element's tooltip.
   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
   * "bottom-left", and "top-left".
   */
  tooltipPosition: _propTypes4.default.cornersAndCenter,
  /**
   * Override the inline-styles of the tooltip element.
   */
  tooltipStyles: _propTypes2.default.object,
  /**
   * If true, increase the tooltip element's size. Useful for increasing tooltip
   * readability on mobile devices.
   */
  touch: _propTypes2.default.bool
} : {};
exports.default = IconButton;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = __webpack_require__(885);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var color = props.color,
      hoverColor = props.hoverColor;
  var baseTheme = context.muiTheme.baseTheme;

  var offColor = color || baseTheme.palette.textColor;
  var onColor = hoverColor || offColor;

  return {
    root: {
      color: state.hovered ? onColor : offColor,
      position: 'relative',
      fontSize: baseTheme.spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: _transitions2.default.easeOut()
    }
  };
}

var FontIcon = function (_Component) {
  (0, _inherits3.default)(FontIcon, _Component);

  function FontIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FontIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FontIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hoverColor = _props.hoverColor,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
      }));
    }
  }]);
  return FontIcon;
}(_react.Component);

FontIcon.muiName = 'FontIcon';
FontIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
FontIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FontIcon.propTypes =  false ? {
  /**
   * This is the font color of the font icon. If not specified,
   * this component will default to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FontIcon;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendChildren = extendChildren;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendChildren(children, extendedProps, extendedChildren) {
  return _react2.default.Children.map(children, function (child) {
    if (!_react2.default.isValidElement(child)) {
      return child;
    }

    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

    return _react2.default.cloneElement(child, newProps, newChildren);
  });
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(398);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(399);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function (_Component) {
  (0, _inherits3.default)(SvgIcon, _Component);

  function SvgIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          hoverColor = _props.hoverColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          style = _props.style,
          viewBox = _props.viewBox,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
      var _context$muiTheme = this.context.muiTheme,
          svgIcon = _context$muiTheme.svgIcon,
          prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);
  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};
exports.default = SvgIcon;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RefreshIndicator = __webpack_require__(892);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RefreshIndicator2.default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _slicedToArray2 = __webpack_require__(893);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoPrefix = __webpack_require__(114);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWBOX_SIZE = 32;

function getStyles(props) {
  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
  return {
    root: {
      position: 'absolute',
      zIndex: 2,
      width: props.size,
      height: props.size,
      padding: padding,
      top: -10000,
      left: -10000,
      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
      opacity: props.status === 'hide' ? 0 : 1,
      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
    }
  };
}

var RefreshIndicator = function (_Component) {
  (0, _inherits3.default)(RefreshIndicator, _Component);

  function RefreshIndicator() {
    (0, _classCallCheck3.default)(this, RefreshIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefreshIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);

      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var paperSize = this.getPaperSize();

      var childrenCmp = null;
      if (this.props.status !== 'ready') {
        var circleStyle = this.getCircleStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'div',
          {
            ref: 'wrapper',
            style: prepareStyles({
              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
              width: '100%',
              height: '100%'
            })
          },
          _react2.default.createElement(
            'svg',
            {
              style: {
                width: paperSize,
                height: paperSize
              },
              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
            },
            _react2.default.createElement('circle', (0, _extends3.default)({
              ref: 'path',
              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
              }))
            }, circleStyle.attr))
          )
        );
      } else {
        var _circleStyle = this.getCircleStyle(paperSize);
        var polygonStyle = this.getPolygonStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'svg',
          {
            style: {
              width: paperSize,
              height: paperSize
            },
            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
          },
          _react2.default.createElement('circle', (0, _extends3.default)({
            style: prepareStyles(_circleStyle.style)
          }, _circleStyle.attr)),
          _react2.default.createElement('polygon', (0, _extends3.default)({
            style: prepareStyles(polygonStyle.style)
          }, polygonStyle.attr))
        );
      }

      return childrenCmp;
    }
  }, {
    key: 'getTheme',
    value: function getTheme() {
      return this.context.muiTheme.refreshIndicator;
    }
  }, {
    key: 'getPaddingSize',
    value: function getPaddingSize() {
      var padding = this.props.size * 0.1;
      return padding;
    }
  }, {
    key: 'getPaperSize',
    value: function getPaperSize() {
      return this.props.size - this.getPaddingSize() * 2;
    }
  }, {
    key: 'getCircleAttr',
    value: function getCircleAttr() {
      return {
        radiu: VIEWBOX_SIZE / 2 - 5,
        originX: VIEWBOX_SIZE / 2,
        originY: VIEWBOX_SIZE / 2,
        strokeWidth: 3
      };
    }
  }, {
    key: 'getArcDeg',
    value: function getArcDeg() {
      var p = this.props.percentage / 100;

      var beginDeg = p * 120;
      var endDeg = p * 410;
      return [beginDeg, endDeg];
    }
  }, {
    key: 'getFactor',
    value: function getFactor() {
      var p = this.props.percentage / 100;
      var p1 = Math.min(1, p / 0.4);

      return p1;
    }
  }, {
    key: 'getCircleStyle',
    value: function getCircleStyle() {
      var isLoading = this.props.status === 'loading';
      var p1 = isLoading ? 1 : this.getFactor();
      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;

      var _getArcDeg = this.getArcDeg(),
          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
          beginDeg = _getArcDeg2[0],
          endDeg = _getArcDeg2[1];

      var arcLen = (endDeg - beginDeg) * perimeter / 360;
      var dashOffset = -beginDeg * perimeter / 360;

      var theme = this.getTheme();
      return {
        style: {
          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
          strokeDashoffset: dashOffset,
          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          strokeLinecap: 'round',
          opacity: p1,
          strokeWidth: circle.strokeWidth * p1,
          fill: 'none'
        },
        attr: {
          cx: circle.originX,
          cy: circle.originY,
          r: circle.radiu
        }
      };
    }
  }, {
    key: 'getPolygonStyle',
    value: function getPolygonStyle() {
      var p1 = this.getFactor();
      var circle = this.getCircleAttr();

      var triangleCx = circle.originX + circle.radiu;
      var triangleCy = circle.originY;
      var dx = circle.strokeWidth * 7 / 4 * p1;
      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);

      var _getArcDeg3 = this.getArcDeg(),
          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
          endDeg = _getArcDeg4[1];

      var theme = this.getTheme();
      return {
        style: {
          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          transform: 'rotate(' + endDeg + 'deg)',
          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
          opacity: p1
        },
        attr: {
          points: trianglePath
        }
      };
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path, step) {
      var _this2 = this;

      if (this.props.status !== 'loading') return;

      var currStep = (step || 0) % 3;

      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;
      var arcLen = perimeter * 0.64;

      var strokeDasharray = void 0;
      var strokeDashoffset = void 0;
      var transitionDuration = void 0;

      if (currStep === 0) {
        strokeDasharray = '1, 200';
        strokeDashoffset = 0;
        transitionDuration = '0ms';
      } else if (currStep === 1) {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -15;
        transitionDuration = '750ms';
      } else {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -(perimeter - 1);
        transitionDuration = '850ms';
      }

      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, currStep + 1);
      }, currStep ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.status !== 'loading') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', null);
      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      this.rotateWrapperSecondTimer = setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          top = _props.top,
          left = _props.left,
          percentage = _props.percentage,
          status = _props.status,
          loadingColor = _props.loadingColor,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);


      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          circle: true,
          style: (0, _simpleAssign2.default)(styles.root, style)
        }, other),
        this.renderChildren()
      );
    }
  }]);
  return RefreshIndicator;
}(_react.Component);

RefreshIndicator.defaultProps = {
  percentage: 0,
  size: 40,
  status: 'hide'
};
RefreshIndicator.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RefreshIndicator.propTypes =  false ? {
  /**
   * Override the theme's color of the indicator while it's status is
   * "ready" and it's percentage is less than 100.
   */
  color: _propTypes2.default.string,
  /**
   * The absolute left position of the indicator in pixels.
   */
  left: _propTypes2.default.number.isRequired,
  /**
   * Override the theme's color of the indicator while
   * it's status is "loading" or when it's percentage is 100.
   */
  loadingColor: _propTypes2.default.string,
  /**
   * The confirmation progress to fetch data. Max value is 100.
   */
  percentage: _propTypes2.default.number,
  /**
   * Size in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * The display status of the indicator. If the status is
   * "ready", the indicator will display the ready state
   * arrow. If the status is "loading", it will display
   * the loading progress indicator. If the status is "hide",
   * the indicator will be hidden.
   */
  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The absolute top position of the indicator in pixels.
   */
  top: _propTypes2.default.number.isRequired
} : {};
exports.default = RefreshIndicator;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(894);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(897);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(895), __esModule: true };

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
__webpack_require__(123);
module.exports = __webpack_require__(896);


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(268);
var ITERATOR = __webpack_require__(40)('iterator');
var Iterators = __webpack_require__(80);
module.exports = __webpack_require__(33).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(898), __esModule: true };

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
__webpack_require__(123);
module.exports = __webpack_require__(899);


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(69);
var get = __webpack_require__(267);
module.exports = __webpack_require__(33).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderComponent = function renderComponent(Component) {
  return function (_) {
    var factory = (0, _createEagerFactory2.default)(Component);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = (0, _wrapDisplayName2.default)(Component, 'renderComponent');
    }
    return RenderComponent;
  };
};

exports.default = renderComponent;

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duration */
/* unused harmony export fromNow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FromNow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Duration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_duration_format__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_duration_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
// https://github.com/swarmsim/swarm/blob/master/app/scripts/filters/moment.coffee
var formats={default_:function default_(duration){// copied from swarmsim 1
if(duration.asYears()>=1)return"y [years] M [months]";if(duration.asMonths()>=1)return"M [months] d [days]";if(duration.asDays()>=1)return"d [days] h [hours]";if(duration.asMinutes()>=1)return"h:mm:ss";else return{template:"00:ss",trim:false};},countdown:function countdown(duration){if(duration.asYears()>=1)return"y:MM:dd:hh:mm:ss";if(duration.asMonths()>=1)return"M:dd:hh:mm:ss";if(duration.asDays()>=1)return"d:hh:mm:ss";if(duration.asMinutes()>=1)return"h:mm:ss";else return{template:"00:ss",trim:false};}};// TODO millis type
function duration(millis,noSuffix){return _duration(millis,{noSuffix:noSuffix});}function _duration(millis){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _props$noSuffix=props.noSuffix,noSuffix=_props$noSuffix===undefined?false:_props$noSuffix,_props$format=props.format,format=_props$format===undefined?"default_":_props$format;var diff=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(Math.abs(millis));var tmpl=formats[format](diff);var suffix=millis<0&&!noSuffix?" ago":"";return diff.format(tmpl)+suffix;}function fromNow(since,now,noSuffix){return duration(since-now,noSuffix);}var FromNow=__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].common.FromNow(function(props){if(props.isError){// no LoadingSpinner, <div>-in-<p> warnings
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{title:JSON.stringify(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pick(props,["isError","isPending","pendingKeys","isEmpty","emptyKeys"]))},"...");}var since=props.since,now=props.now,noSuffix=props.noSuffix;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,fromNow(since,now,noSuffix));});function Duration(props){var millis=props.millis,noSuffix=props.noSuffix,format=props.format;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,_duration(millis,{noSuffix:noSuffix,format:format}));}// ripped from swarm1/util.coffee
// http://stackoverflow.com/questions/13262621
//export function utcdoy(ms) {
//  //const t = moment.utc(ms)
//  const t = moment.duration(ms)
//  const days = parseInt(t.format('DDD'))-1
//  const daystr = days > 0 ? days+'d ' : ''
//  console.log('!', daystr + t.format('H\\h mm:ss.SSS'))
//  return daystr + t.format('H\\h mm:ss.SSS')
//}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

/*! Moment Duration Format v1.3.0
 *  https://github.com/jsmreese/moment-duration-format 
 *  Date: 2014-07-15
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2014 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, undefined) {

	// repeatZero(qty)
	// returns "0" repeated qty times
	function repeatZero(qty) {
		var result = "";
		
		// exit early
		// if qty is 0 or a negative number
		// or doesn't coerce to an integer
		qty = parseInt(qty, 10);
		if (!qty || qty < 1) { return result; }
		
		while (qty) {
			result += "0";
			qty -= 1;
		}
		
		return result;
	}
	
	// padZero(str, len [, isRight])
	// pads a string with zeros up to a specified length
	// will not pad a string if its length is aready
	// greater than or equal to the specified length
	// default output pads with zeros on the left
	// set isRight to `true` to pad with zeros on the right
	function padZero(str, len, isRight) {
		if (str == null) { str = ""; }
		str = "" + str;
		
		return (isRight ? str : "") + repeatZero(len - str.length) + (isRight ? "" : str);
	}
	
	// isArray
	function isArray(array) {
		return Object.prototype.toString.call(array) === "[object Array]";
	}
	
	// isObject
	function isObject(obj) {
		return Object.prototype.toString.call(obj) === "[object Object]";
	}
	
	// findLast
	function findLast(array, callback) {
		var index = array.length;

		while (index -= 1) {
			if (callback(array[index])) { return array[index]; }
		}
	}

	// find
	function find(array, callback) {
		var index = 0,
			max = array.length,
			match;
			
		if (typeof callback !== "function") {
			match = callback;
			callback = function (item) {
				return item === match;
			};
		}

		while (index < max) {
			if (callback(array[index])) { return array[index]; }
			index += 1;
		}
	}
	
	// each
	function each(array, callback) {
		var index = 0,
			max = array.length;
			
		if (!array || !max) { return; }

		while (index < max) {
			if (callback(array[index], index) === false) { return; }
			index += 1;
		}
	}
	
	// map
	function map(array, callback) {
		var index = 0,
			max = array.length,
			ret = [];

		if (!array || !max) { return ret; }
				
		while (index < max) {
			ret[index] = callback(array[index], index);
			index += 1;
		}
		
		return ret;
	}
	
	// pluck
	function pluck(array, prop) {
		return map(array, function (item) {
			return item[prop];
		});
	}
	
	// compact
	function compact(array) {
		var ret = [];
		
		each(array, function (item) {
			if (item) { ret.push(item); }
		});
		
		return ret;
	}
	
	// unique
	function unique(array) {
		var ret = [];
		
		each(array, function (_a) {
			if (!find(ret, _a)) { ret.push(_a); }
		});
		
		return ret;
	}
	
	// intersection
	function intersection(a, b) {
		var ret = [];
		
		each(a, function (_a) {
			each(b, function (_b) {
				if (_a === _b) { ret.push(_a); }
			});
		});
		
		return unique(ret);
	}
	
	// rest
	function rest(array, callback) {
		var ret = [];
		
		each(array, function (item, index) {
			if (!callback(item)) {
				ret = array.slice(index);
				return false;
			}
		});
		
		return ret;
	}

	// initial
	function initial(array, callback) {
		var reversed = array.slice().reverse();
		
		return rest(reversed, callback).reverse();
	}
	
	// extend
	function extend(a, b) {
		for (var key in b) {
			if (b.hasOwnProperty(key)) { a[key] = b[key]; }
		}
		
		return a;
	}
			
	// define internal moment reference
	var moment;

	if (true) {
		try { moment = __webpack_require__(401); } 
		catch (e) {}
	} 
	
	if (!moment && root.moment) {
		moment = root.moment;
	}
	
	if (!moment) {
		throw "Moment Duration Format cannot find Moment.js";
	}
	
	// moment.duration.format([template] [, precision] [, settings])
	moment.duration.fn.format = function () {

		var tokenizer, tokens, types, typeMap, momentTypes, foundFirst, trimIndex,
			args = [].slice.call(arguments),
			settings = extend({}, this.format.defaults),
			// keep a shadow copy of this moment for calculating remainders
			remainder = moment.duration(this);

		// add a reference to this duration object to the settings for use
		// in a template function
		settings.duration = this;

		// parse arguments
		each(args, function (arg) {
			if (typeof arg === "string" || typeof arg === "function") {
				settings.template = arg;
				return;
			}

			if (typeof arg === "number") {
				settings.precision = arg;
				return;
			}

			if (isObject(arg)) {
				extend(settings, arg);
			}
		});

		// types
		types = settings.types = (isArray(settings.types) ? settings.types : settings.types.split(" "));

		// template
		if (typeof settings.template === "function") {
			settings.template = settings.template.apply(settings);
		}

		// tokenizer regexp
		tokenizer = new RegExp(map(types, function (type) {
			return settings[type].source;
		}).join("|"), "g");

		// token type map function
		typeMap = function (token) {
			return find(types, function (type) {
				return settings[type].test(token);
			});
		};

		// tokens array
		tokens = map(settings.template.match(tokenizer), function (token, index) {
			var type = typeMap(token),
				length = token.length;

			return {
				index: index,
				length: length,

				// replace escaped tokens with the non-escaped token text
				token: (type === "escape" ? token.replace(settings.escape, "$1") : token),

				// ignore type on non-moment tokens
				type: ((type === "escape" || type === "general") ? null : type)

				// calculate base value for all moment tokens
				//baseValue: ((type === "escape" || type === "general") ? null : this.as(type))
			};
		}, this);

		// unique moment token types in the template (in order of descending magnitude)
		momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

		// exit early if there are no momentTypes
		if (!momentTypes.length) {
			return pluck(tokens, "token").join("");
		}

		// calculate values for each token type in the template
		each(momentTypes, function (momentType, index) {
			var value, wholeValue, decimalValue, isLeast, isMost;

			// calculate integer and decimal value portions
			value = remainder.as(momentType);
			wholeValue = (value > 0 ? Math.floor(value) : Math.ceil(value));
			decimalValue = value - wholeValue;

			// is this the least-significant moment token found?
			isLeast = ((index + 1) === momentTypes.length);

			// is this the most-significant moment token found?
			isMost = (!index);

			// update tokens array
			// using this algorithm to not assume anything about
			// the order or frequency of any tokens
			each(tokens, function (token) {
				if (token.type === momentType) {
					extend(token, {
						value: value,
						wholeValue: wholeValue,
						decimalValue: decimalValue,
						isLeast: isLeast,
						isMost: isMost
					});

					if (isMost) {
						// note the length of the most-significant moment token:
						// if it is greater than one and forceLength is not set, default forceLength to `true`
						if (settings.forceLength == null && token.length > 1) {
							settings.forceLength = true;
						}

						// rationale is this:
						// if the template is "h:mm:ss" and the moment value is 5 minutes, the user-friendly output is "5:00", not "05:00"
						// shouldn't pad the `minutes` token even though it has length of two
						// if the template is "hh:mm:ss", the user clearly wanted everything padded so we should output "05:00"
						// if the user wanted the full padded output, they can set `{ trim: false }` to get "00:05:00"
					}
				}
			});

			// update remainder
			remainder.subtract(wholeValue, momentType);
		});
	
		// trim tokens array
		if (settings.trim) {
			tokens = (settings.trim === "left" ? rest : initial)(tokens, function (token) {
				// return `true` if:
				// the token is not the least moment token (don't trim the least moment token)
				// the token is a moment token that does not have a value (don't trim moment tokens that have a whole value)
				return !(token.isLeast || (token.type != null && token.wholeValue));
			});
		}
		
		
		// build output

		// the first moment token can have special handling
		foundFirst = false;

		// run the map in reverse order if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		tokens = map(tokens, function (token) {
			var val,
				decVal;

			if (!token.type) {
				// if it is not a moment token, use the token as its own value
				return token.token;
			}

			// apply negative precision formatting to the least-significant moment token
			if (token.isLeast && (settings.precision < 0)) {
				val = (Math.floor(token.wholeValue * Math.pow(10, settings.precision)) * Math.pow(10, -settings.precision)).toString();
			} else {
				val = token.wholeValue.toString();
			}
			
			// remove negative sign from the beginning
			val = val.replace(/^\-/, "");

			// apply token length formatting
			// special handling for the first moment token that is not the most significant in a trimmed template
			if (token.length > 1 && (foundFirst || token.isMost || settings.forceLength)) {
				val = padZero(val, token.length);
			}

			// add decimal value if precision > 0
			if (token.isLeast && (settings.precision > 0)) {
				decVal = token.decimalValue.toString().replace(/^\-/, "").split(/\.|e\-/);
				switch (decVal.length) {
					case 1:
						val += "." + padZero(decVal[0], settings.precision, true).slice(0, settings.precision);
						break;
						
					case 2:
						val += "." + padZero(decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
						
					case 3:
						val += "." + padZero(repeatZero((+decVal[2]) - 1) + (decVal[0] || "0") + decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
					
					default:
						throw "Moment Duration Format: unable to parse token decimal value.";
				}
			}
			
			// add a negative sign if the value is negative and token is most significant
			if (token.isMost && token.value < 0) {
				val = "-" + val;
			}

			foundFirst = true;

			return val;
		});

		// undo the reverse if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		return tokens.join("");
	};

	moment.duration.fn.format.defaults = {
		// token definitions
		escape: /\[(.+?)\]/,
		years: /[Yy]+/,
		months: /M+/,
		weeks: /[Ww]+/,
		days: /[Dd]+/,
		hours: /[Hh]+/,
		minutes: /m+/,
		seconds: /s+/,
		milliseconds: /S+/,
		general: /.+?/,

		// token type names
		// in order of descending magnitude
		// can be a space-separated token name list or an array of token names
		types: "escape years months weeks days hours minutes seconds milliseconds general",

		// format options

		// trim
		// "left" - template tokens are trimmed from the left until the first moment token that has a value >= 1
		// "right" - template tokens are trimmed from the right until the first moment token that has a value >= 1
		// (the final moment token is not trimmed, regardless of value)
		// `false` - template tokens are not trimmed
		trim: "left",

		// precision
		// number of decimal digits to include after (to the right of) the decimal point (positive integer)
		// or the number of digits to truncate to 0 before (to the left of) the decimal point (negative integer)
		precision: 0,

		// force first moment token with a value to render at full length even when template is trimmed and first moment token has length of 1
		forceLength: null,

		// template used to format duration
		// may be a function or a string
		// template functions are executed with the `this` binding of the settings object
		// so that template strings may be dynamically generated based on the duration object
		// (accessible via `this.duration`)
		// or any of the other settings
		template: function () {
			var types = this.types,
				dur = this.duration,
				lastType = findLast(types, function (type) {
					return dur._data[type];
				});

			// default template strings for each duration dimension type
			switch (lastType) {
				case "seconds":
					return "h:mm:ss";
				case "minutes":
					return "d[d] h:mm";
				case "hours":
					return "d[d] h[h]";
				case "days":
					return "M[m] d[d]";
				case "weeks":
					return "y[y] w[w]";
				case "months":
					return "y[y] M[m]";
				case "years":
					return "y[y]";
				default:
					return "y[y] M[m] d[d] h:mm:ss";
			}
		}
	};

})(this);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlainLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
var PlainLink=function PlainLink(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],Object.assign({},props,{style:Object.assign({color:"inherit",textDecoration:"none"},props.style)}));};

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withFormatNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Num; });
/* unused harmony export Short */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Percent; });
/* unused harmony export DPercent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Error__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var NumRender=function NumRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Error__["a" /* default */],{inline:true,error:props});var val=props.val,hideblank=props.hideblank,formatNumber=props.formatNumber,error=props.error,opts=_objectWithoutProperties(props,["val","hideblank","formatNumber","error"]);if(hideblank&&val===undefined)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,formatNumber(val,opts));};var withFormatNumber=__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].common.Number;var Num=withFormatNumber(NumRender);var Short=function Short(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Num,Object.assign({},props,{flavor:"short"}));};//Num.propTypes = {
//  val: React.PropTypes.oneOfType([  // no isRequired, because hideblank allows undefined
//    React.PropTypes.object, // decimal.js
//    React.PropTypes.number,
//    React.PropTypes.string,
//  ]),
//  small: React.PropTypes.bool,
//  sigfigs: React.PropTypes.number,
//  hideblank: React.PropTypes.bool,
//  format: React.PropTypes.string,
//}
var Percent=function Percent(props){var hideblank=props.hideblank,val=props.val,minusone=props.minusone;if(hideblank&&val===undefined)return null;if(minusone)val-=1;// Not sure why <Num> is freezing up here...
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,Math.round(val*100),"%");//return <span><Num val={val * 100} />%</span>
};var DPercent=function DPercent(props){return Percent(Object.assign({},props,{val:props.val.toNumber()}));};

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intlMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(77);
function intlMessages(prefix){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],Object.assign({},props,{id:prefix+"."+props.id}));};}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* unused harmony export Description */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixedDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(77);
var Tooltip=Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* injectIntl */])(function(props){var intl=props.intl,id=props.id,_props$required=props.required,required=_props$required===undefined?false:_props$required,children=props.children;return!!intl.messages[id]||required?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{title:intl.formatMessage({id:id})},children):children;});var Description=Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* injectIntl */])(function(_ref){var intl=_ref.intl,id=_ref.id;id+=".description";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tooltip,{id:id+".lol"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:id}));//return !!intl.messages[id]
//  ? <Tooltip id={id + ".lol"}><FormattedMessage id={id} /></Tooltip>
//  : null
});var prefixedDescription=function prefixedDescription(prefix){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Description,Object.assign({},props,{id:prefix+"."+props.id}));};};

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_getDisplayName__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_getDisplayName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
// Implements the dumpProps flag.
var passwordKeys=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.keyBy(["password","password2","auth"]);function DumpPropsRender(props){var wrappedElem=props.wrappedElem,wrappedProps=props.wrappedProps,wrapperClassName=props.wrapperClassName,envName=props.envName,logProps=props.logProps,dumpProps=props.dumpProps;var displayName=__WEBPACK_IMPORTED_MODULE_2_recompose_getDisplayName___default()(wrappedElem);if(logProps)console.log(displayName,wrappedProps);if(!dumpProps)return null;// don't display passwords and other secrets!
var dumpedProps=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.mapValues(wrappedProps,function(val,key){if(key in passwordKeys)return"********";if(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](val))return"<ReactElement>";//if (_.get(val, ["prototype", "isReactComponent"])) return "<component>"
return val;});var rootUrl="https://console.firebase.google.com/project/"+envName;var dataUrl=rootUrl+"/database/data";var userUrl=rootUrl+"/authentication/users?search=";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__["CardText"],{className:wrapperClassName||""},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr",null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4",null,"Props dump: ",displayName),wrappedProps.charId?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{target:"_blank",href:dataUrl+"/characters/"+wrappedProps.charId},"character: ",wrappedProps.charId)):null,wrappedProps.userId?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{target:"_blank",href:dataUrl+"/users/"+wrappedProps.userId},"user: ",wrappedProps.userId)," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{target:"_blank",href:userUrl+wrappedProps.userId},"(auth)")):null,wrappedProps.league&&wrappedProps.rankName?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{target:"_blank",href:dataUrl+"/rankings/"+wrappedProps.league+"/"+wrappedProps.rankName},"rankings: ",wrappedProps.league,"/",wrappedProps.rankName)," "):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("pre",null,JSON.stringify(dumpedProps,null,2)));}var DumpProps=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].common.DumpProps(DumpPropsRender);/* harmony default export */ __webpack_exports__["a"] = (function(Wrapped){var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()()(function(props){return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapped,Object.assign({key:"wrapped"},props)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DumpProps,Object.assign({key:"dump",wrappedElem:Wrapped,wrappedProps:props},opts))];});});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _CardExpandable = __webpack_require__(404);

var _CardExpandable2 = _interopRequireDefault(_CardExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function (_Component) {
  (0, _inherits3.default)(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: null
    }, _this.handleExpanding = function (event) {
      event.preventDefault();
      var newExpandedState = !_this.state.expanded;
      // no automatic state update when the component is controlled
      if (_this.props.expanded === null) {
        _this.setState({ expanded: newExpandedState });
      }
      if (_this.props.onExpandChange) {
        _this.props.onExpandChange(newExpandedState);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Card, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          containerStyle = _props.containerStyle,
          children = _props.children,
          expandable = _props.expandable,
          expandedProp = _props.expanded,
          initiallyExpanded = _props.initiallyExpanded,
          onExpandChange = _props.onExpandChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);


      var lastElement = void 0;
      var expanded = this.state.expanded;
      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        var doClone = false;
        var newChild = undefined;
        var newProps = {};
        var element = currentChild;
        if (!currentChild || !currentChild.props) {
          return null;
        }
        if (expanded === false && currentChild.props.expandable === true) return;
        if (currentChild.props.actAsExpander === true) {
          doClone = true;
          newProps.onClick = _this2.handleExpanding;
          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
        }
        if (currentChild.props.showExpandableButton === true) {
          doClone = true;
          newChild = _react2.default.createElement(_CardExpandable2.default, {
            closeIcon: currentChild.props.closeIcon,
            expanded: expanded,
            onExpanding: _this2.handleExpanding,
            openIcon: currentChild.props.openIcon,
            iconStyle: currentChild.props.iconStyle
          });
        }
        if (doClone) {
          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
        }
        lastElement = element;
        return element;
      }, this);

      // If the last element is text or a title we should add
      // 8px padding to the bottom of the card
      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');

      var mergedStyles = (0, _simpleAssign2.default)({
        zIndex: 1
      }, style);
      var containerMergedStyles = (0, _simpleAssign2.default)({
        paddingBottom: addBottomPadding ? 8 : 0
      }, containerStyle);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, { style: mergedStyles }),
        _react2.default.createElement(
          'div',
          { style: containerMergedStyles },
          newChildren
        )
      );
    }
  }]);
  return Card;
}(_react.Component);

Card.defaultProps = {
  expandable: false,
  expanded: null,
  initiallyExpanded: false
};
Card.propTypes =  false ? {
  /**
   * Can be used to render elements inside the Card.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, this card component is expandable. Can be set on any child of the `Card` component.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Whether this card is expanded.
   * If `true` or `false` the component is controlled.
   * if `null` the component is uncontrolled.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Whether this card is initially expanded.
   */
  initiallyExpanded: _propTypes2.default.bool,
  /**
   * Callback function fired when the `expandable` state of the card has changed.
   *
   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
   */
  onExpandChange: _propTypes2.default.func,
  /**
   * If true, this card component will include a button to expand the card. `CardTitle`,
   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
   * of `Card` can implements `showExpandableButton` or forwards the property to a child
   * component supporting it.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Card;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
  );
};
HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
HardwareKeyboardArrowUp.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
  );
};
HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
HardwareKeyboardArrowDown.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Avatar = __webpack_require__(912);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      fontWeight: card.fontWeight,
      boxSizing: 'border-box',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    text: {
      display: 'inline-block',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      paddingRight: '90px'
    },
    avatar: {
      marginRight: 16
    },
    title: {
      color: props.titleColor || card.titleColor,
      display: 'block',
      fontSize: 15
    },
    subtitle: {
      color: props.subtitleColor || card.subtitleColor,
      display: 'block',
      fontSize: 14
    }
  };
}

var CardHeader = function (_Component) {
  (0, _inherits3.default)(CardHeader, _Component);

  function CardHeader() {
    (0, _classCallCheck3.default)(this, CardHeader);
    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          avatarProp = _props.avatar,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          openIcon = _props.openIcon,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          textStyle = _props.textStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var avatar = avatarProp;

      if ((0, _react.isValidElement)(avatarProp)) {
        avatar = _react2.default.cloneElement(avatar, {
          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
        });
      } else if (avatar !== null) {
        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        avatar,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
            title
          ),
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
            subtitle
          )
        ),
        children
      );
    }
  }]);
  return CardHeader;
}(_react.Component);

CardHeader.muiName = 'CardHeader';
CardHeader.defaultProps = {
  avatar: null
};
CardHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardHeader.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
   * If `avatar` is an `Avatar` or other element, it will be rendered.
   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
   */
  avatar: _propTypes2.default.node,
  /**
   * Can be used to render elements inside the Card Header.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the iconStyle of the Icon Button.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
   */
  openIcon: _propTypes2.default.node,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in Card Header.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the text.
   */
  textStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in Card Header.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardHeader;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = __webpack_require__(913);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var backgroundColor = props.backgroundColor,
      color = props.color,
      size = props.size;
  var avatar = context.muiTheme.avatar;


  var styles = {
    root: {
      color: color || avatar.color,
      backgroundColor: backgroundColor || avatar.backgroundColor,
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size / 2,
      borderRadius: '50%',
      height: size,
      width: size
    },
    icon: {
      color: color || avatar.color,
      width: size * 0.6,
      height: size * 0.6,
      fontSize: size * 0.6,
      margin: size * 0.2
    }
  };

  return styles;
}

var Avatar = function (_Component) {
  (0, _inherits3.default)(Avatar, _Component);

  function Avatar() {
    (0, _classCallCheck3.default)(this, Avatar);
    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          icon = _props.icon,
          src = _props.src,
          style = _props.style,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      if (src) {
        return _react2.default.createElement('img', (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other, {
          src: src,
          className: className
        }));
      } else {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, {
            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
            className: className
          }),
          icon && _react2.default.cloneElement(icon, {
            color: styles.icon.color,
            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
          }),
          this.props.children
        );
      }
    }
  }]);
  return Avatar;
}(_react.Component);

Avatar.muiName = 'Avatar';
Avatar.defaultProps = {
  size: 40
};
Avatar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Avatar.propTypes =  false ? {
  /**
   * The backgroundColor of the avatar. Does not apply to image avatars.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root `div` or `img` element.
   */
  className: _propTypes2.default.string,
  /**
   * The icon or letter's color.
   */
  color: _propTypes2.default.string,
  /**
   * This is the SvgIcon or FontIcon to be used inside the avatar.
   */
  icon: _propTypes2.default.element,
  /**
   * This is the size of the avatar in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
   */
  src: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Avatar;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      position: 'relative'
    },
    title: {
      fontSize: 24,
      color: props.titleColor || card.titleColor,
      display: 'block',
      lineHeight: '36px'
    },
    subtitle: {
      fontSize: 14,
      color: props.subtitleColor || card.subtitleColor,
      display: 'block'
    }
  };
}

var CardTitle = function (_Component) {
  (0, _inherits3.default)(CardTitle, _Component);

  function CardTitle() {
    (0, _classCallCheck3.default)(this, CardTitle);
    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedTitleStyle) },
          title
        ),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedSubtitleStyle) },
          subtitle
        ),
        children
      );
    }
  }]);
  return CardTitle;
}(_react.Component);

CardTitle.muiName = 'CardTitle';
CardTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardTitle.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Title.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in the Card Title.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in the Card Title.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardTitle;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardMedia = context.muiTheme.cardMedia;


  return {
    root: {
      position: 'relative'
    },
    overlayContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    overlay: {
      height: '100%',
      position: 'relative'
    },
    overlayContent: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      paddingTop: 8,
      background: cardMedia.overlayContentBackground
    },
    media: {},
    mediaChild: {
      verticalAlign: 'top',
      maxWidth: '100%',
      minWidth: '100%',
      width: '100%'
    }
  };
}

var CardMedia = function (_Component) {
  (0, _inherits3.default)(CardMedia, _Component);

  function CardMedia() {
    (0, _classCallCheck3.default)(this, CardMedia);
    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          mediaStyle = _props.mediaStyle,
          overlay = _props.overlay,
          overlayContainerStyle = _props.overlayContainerStyle,
          overlayContentStyle = _props.overlayContentStyle,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      var titleColor = this.context.muiTheme.cardMedia.titleColor;
      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
      var color = this.context.muiTheme.cardMedia.color;

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (!child) {
          return child;
        }

        return _react2.default.cloneElement(child, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
        });
      });

      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
        var childMuiName = child && child.type ? child.type.muiName : null;

        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
          return _react2.default.cloneElement(child, {
            titleColor: titleColor,
            subtitleColor: subtitleColor
          });
        } else if (childMuiName === 'CardText') {
          return _react2.default.cloneElement(child, {
            color: color
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedMediaStyle) },
          styledChildren
        ),
        overlay ? _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedOverlayContainerStyle) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(extendedOverlayStyle) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles(extendedOverlayContentStyle) },
              overlayChildren
            )
          )
        ) : ''
      );
    }
  }]);
  return CardMedia;
}(_react.Component);

CardMedia.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardMedia.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Media.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the Card Media.
   */
  mediaStyle: _propTypes2.default.object,
  /**
   * Can be used to render overlay element in Card Media.
   */
  overlay: _propTypes2.default.node,
  /**
   * Override the inline-styles of the overlay container.
   */
  overlayContainerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay content.
   */
  overlayContentStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay element.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardMedia;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardText = context.muiTheme.cardText;


  return {
    root: {
      padding: 16,
      fontSize: 14,
      color: props.color || cardText.textColor
    }
  };
}

var CardText = function (_Component) {
  (0, _inherits3.default)(CardText, _Component);

  function CardText() {
    (0, _classCallCheck3.default)(this, CardText);
    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          color = _props.color,
          expandable = _props.expandable,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        children
      );
    }
  }]);
  return CardText;
}(_react.Component);

CardText.muiName = 'CardText';
CardText.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardText.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Text.
   */
  children: _propTypes2.default.node,
  /**
   * Override the CardText color.
   */
  color: _propTypes2.default.string,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardText;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      padding: 8,
      position: 'relative'
    },
    action: {
      marginRight: 8
    }
  };
}

var CardActions = function (_Component) {
  (0, _inherits3.default)(CardActions, _Component);

  function CardActions() {
    (0, _classCallCheck3.default)(this, CardActions);
    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        styledChildren
      );
    }
  }]);
  return CardActions;
}(_react.Component);

CardActions.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardActions.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Action.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardActions;

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].app.withAuth,__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].willReceiveProps(function(props){var isAuthed=props.isAuthed,isAllowed=props.isAllowed,location=props.location,history=props.history;if(props.isError)return{};var error=!isAuthed?401:!isAllowed?403:null;if(error){console.log(error+" unauthorized. redirect to root",{location:location,isAuthed:isAuthed,isAllowed:isAllowed});Object(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__["assert"])(location.pathname!=="/","route `/` has no permission? but thats where we redirect!");history.push("/");return{};}return{};})));

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(115);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(113);

var _keycode2 = _interopRequireDefault(_keycode);

var _autoPrefix = __webpack_require__(114);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(920);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openNavEventHandler = null;

var Drawer = function (_Component) {
  (0, _inherits3.default)(Drawer, _Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
      event.preventDefault();
      _this.close('clickaway');
    }, _this.handleKeyUp = function (event) {
      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
        _this.close('escape');
      }
    }, _this.onBodyTouchStart = function (event) {
      var swipeAreaWidth = _this.props.swipeAreaWidth;

      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var touchStartY = event.touches[0].pageY;

      // Open only if swiping from far left (or right) while closed
      if (swipeAreaWidth !== null && !_this.state.open) {
        if (_this.props.openSecondary) {
          // If openSecondary is true calculate from the far right
          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
        } else {
          // If openSecondary is false calculate from the far left
          if (touchStartX > swipeAreaWidth) return;
        }
      }

      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
        return;
      }

      _this.maybeSwiping = true;
      _this.touchStartX = touchStartX;
      _this.touchStartY = touchStartY;

      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
    }, _this.onBodyTouchMove = function (event) {
      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = event.touches[0].pageY;

      if (_this.state.swiping) {
        event.preventDefault();
        _this.setPosition(_this.getTranslateX(currentX));
      } else if (_this.maybeSwiping) {
        var dXAbs = Math.abs(currentX - _this.touchStartX);
        var dYAbs = Math.abs(currentY - _this.touchStartY);
        // If the user has moved his thumb ten pixels in either direction,
        // we can safely make an assumption about whether he was intending
        // to swipe or scroll.
        var threshold = 10;

        if (dXAbs > threshold && dYAbs <= threshold) {
          _this.swipeStartX = currentX;
          _this.setState({
            swiping: _this.state.open ? 'closing' : 'opening'
          });
          _this.setPosition(_this.getTranslateX(currentX));
        } else if (dXAbs <= threshold && dYAbs > threshold) {
          _this.onBodyTouchEnd();
        }
      }
    }, _this.onBodyTouchEnd = function (event) {
      if (_this.state.swiping) {
        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();

        _this.maybeSwiping = false;
        var swiping = _this.state.swiping;
        _this.setState({
          swiping: null
        });

        // We have to open or close after setting swiping to null,
        // because only then CSS transition is enabled.
        if (translateRatio > 0.5) {
          if (swiping === 'opening') {
            _this.setPosition(_this.getMaxTranslateX());
          } else {
            _this.close('swipe');
          }
        } else {
          if (swiping === 'opening') {
            _this.open('swipe');
          } else {
            _this.setPosition(0);
          }
        }
      } else {
        _this.maybeSwiping = false;
      }

      _this.removeBodyTouchListeners();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.maybeSwiping = false;
      this.touchStartX = null;
      this.touchStartY = null;
      this.swipeStartX = null;

      this.setState({
        open: this.props.open !== null ? this.props.open : this.props.docked,
        swiping: null
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If controlled then the open prop takes precedence.
      if (nextProps.open !== null) {
        this.setState({
          open: nextProps.open
        });
        // Otherwise, if docked is changed, change the open state for when uncontrolled.
      } else if (this.props.docked !== nextProps.docked) {
        this.setState({
          open: nextProps.docked
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disableSwipeHandling();
      this.removeBodyTouchListeners();
    }
  }, {
    key: 'getStyles',
    value: function getStyles() {
      var muiTheme = this.context.muiTheme;
      var theme = muiTheme.drawer;

      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());

      var styles = {
        root: {
          height: '100%',
          width: this.getTranslatedWidth() || theme.width,
          position: 'fixed',
          zIndex: muiTheme.zIndex.drawer,
          left: 0,
          top: 0,
          transform: 'translate(' + x + 'px, 0)',
          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
          backgroundColor: theme.color,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
        },
        overlay: {
          zIndex: muiTheme.zIndex.drawerOverlay,
          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
        },
        rootWhenOpenRight: {
          left: 'auto',
          right: 0
        }
      };

      return styles;
    }
  }, {
    key: 'shouldShow',
    value: function shouldShow() {
      return this.state.open || !!this.state.swiping; // component is swiping
    }
  }, {
    key: 'close',
    value: function close(reason) {
      if (this.props.open === null) this.setState({ open: false });
      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
      return this;
    }
  }, {
    key: 'open',
    value: function open(reason) {
      if (this.props.open === null) this.setState({ open: true });
      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
      return this;
    }
  }, {
    key: 'getTranslatedWidth',
    value: function getTranslatedWidth() {
      if (typeof this.props.width === 'string') {
        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
          throw new Error('Not a valid percentage format.');
        }
        var width = parseFloat(this.props.width) / 100.0;
        // We are doing our best on the Server to render a consistent UI, hence the
        // default value of 10000
        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
      } else {
        return this.props.width;
      }
    }
  }, {
    key: 'getMaxTranslateX',
    value: function getMaxTranslateX() {
      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
      return width + 10;
    }
  }, {
    key: 'getTranslateMultiplier',
    value: function getTranslateMultiplier() {
      return this.props.openSecondary ? 1 : -1;
    }
  }, {
    key: 'enableSwipeHandling',
    value: function enableSwipeHandling() {
      if (!this.props.docked) {
        document.body.addEventListener('touchstart', this.onBodyTouchStart);
        if (!openNavEventHandler) {
          openNavEventHandler = this.onBodyTouchStart;
        }
      } else {
        this.disableSwipeHandling();
      }
    }
  }, {
    key: 'disableSwipeHandling',
    value: function disableSwipeHandling() {
      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
      if (openNavEventHandler === this.onBodyTouchStart) {
        openNavEventHandler = null;
      }
    }
  }, {
    key: 'removeBodyTouchListeners',
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
    }
  }, {
    key: 'setPosition',
    value: function setPosition(translateX) {
      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
    }
  }, {
    key: 'getTranslateX',
    value: function getTranslateX(currentX) {
      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          containerClassName = _props.containerClassName,
          containerStyle = _props.containerStyle,
          docked = _props.docked,
          openSecondary = _props.openSecondary,
          overlayClassName = _props.overlayClassName,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = this.getStyles();

      var overlay = void 0;
      if (!docked) {
        overlay = _react2.default.createElement(_Overlay2.default, {
          ref: 'overlay',
          show: this.shouldShow(),
          className: overlayClassName,
          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
          transitionEnabled: !this.state.swiping,
          onClick: this.handleTouchTapOverlay
        });
      }

      return _react2.default.createElement(
        'div',
        {
          className: className,
          style: style
        },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
        overlay,
        _react2.default.createElement(
          _Paper2.default,
          {
            ref: 'clickAwayableElement',
            zDepth: zDepth,
            rounded: false,
            transitionEnabled: !this.state.swiping,
            className: containerClassName,
            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
          },
          children
        )
      );
    }
  }]);
  return Drawer;
}(_react.Component);

Drawer.defaultProps = {
  disableSwipeToOpen: false,
  docked: true,
  open: null,
  openSecondary: false,
  swipeAreaWidth: 30,
  width: null,
  zDepth: 2
};
Drawer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Drawer.propTypes =  false ? {
  /**
   * The contents of the `Drawer`
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The CSS class name of the container element.
   */
  containerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, swiping sideways when the `Drawer` is closed will not open it.
   */
  disableSwipeToOpen: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
   * clicking on a menu item will not close the `Drawer`.
   */
  docked: _propTypes2.default.bool,
  /**
   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
   *
   * @param {boolean} open If true, the `Drawer` was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
   * 'escape' (on escape key press), and 'swipe' for close requests.
   */
  onRequestChange: _propTypes2.default.func,
  /**
   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
   * into a controlled component.
   */
  open: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` is positioned to open from the opposite side.
   */
  openSecondary: _propTypes2.default.bool,
  /**
   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The width of the left most (or right most) area in pixels where the `Drawer` can be
   * swiped open from. Setting this to `null` spans that area to the entire page
   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
   * swipeable `Tabs`: use at your own risk).
   */
  swipeAreaWidth: _propTypes2.default.number,
  /**
   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
   * half of the window or `100%` and so on. Defaults to using the values from theme.
   */
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * The zDepth of the `Drawer`.
   */
  zDepth: _propTypes4.default.zDepth

} : {};
exports.default = Drawer;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _AutoLockScrolling = __webpack_require__(921);

var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var overlay = context.muiTheme.overlay;


  var style = {
    root: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: 0,
      left: '-100%',
      opacity: 0,
      backgroundColor: overlay.backgroundColor,
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)

      // Two ways to promote overlay to its own render layer
      willChange: 'opacity',
      transform: 'translateZ(0)',

      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    }
  };

  if (props.show) {
    (0, _simpleAssign2.default)(style.root, {
      left: 0,
      opacity: 1,
      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    });
  }

  return style;
}

var Overlay = function (_Component) {
  (0, _inherits3.default)(Overlay, _Component);

  function Overlay() {
    (0, _classCallCheck3.default)(this, Overlay);
    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(Overlay, [{
    key: 'setOpacity',
    value: function setOpacity(opacity) {
      this.refs.overlay.style.opacity = opacity;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoLockScrolling = _props.autoLockScrolling,
          show = _props.show,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
      );
    }
  }]);
  return Overlay;
}(_react.Component);

Overlay.defaultProps = {
  autoLockScrolling: true,
  style: {},
  transitionEnabled: true
};
Overlay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Overlay.propTypes =  false ? {
  autoLockScrolling: _propTypes2.default.bool,
  show: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  transitionEnabled: _propTypes2.default.bool
} : {};
exports.default = Overlay;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalBodyOverflow = null;
var lockingCounter = 0;

var AutoLockScrolling = function (_Component) {
  (0, _inherits3.default)(AutoLockScrolling, _Component);

  function AutoLockScrolling() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AutoLockScrolling);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AutoLockScrolling, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.lock === true) {
        this.preventScrolling();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.lock !== nextProps.lock) {
        if (nextProps.lock) {
          this.preventScrolling();
        } else {
          this.allowScrolling();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.allowScrolling();
    }

    // force to only lock/unlock once

  }, {
    key: 'preventScrolling',
    value: function preventScrolling() {
      if (this.locked === true) {
        return;
      }

      lockingCounter = lockingCounter + 1;
      this.locked = true;

      // only lock the first time the component is mounted.
      if (lockingCounter === 1) {
        var body = document.getElementsByTagName('body')[0];
        originalBodyOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'allowScrolling',
    value: function allowScrolling() {
      if (this.locked === true) {
        lockingCounter = lockingCounter - 1;
        this.locked = false;
      }

      if (lockingCounter === 0 && originalBodyOverflow !== null) {
        var body = document.getElementsByTagName('body')[0];
        body.style.overflow = originalBodyOverflow || '';
        originalBodyOverflow = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return AutoLockScrolling;
}(_react.Component);

AutoLockScrolling.propTypes =  false ? {
  lock: _propTypes2.default.bool.isRequired
} : {};
exports.default = AutoLockScrolling;

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UnitNavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swarm2_core__);
var M=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("view.UnitNav");var UM=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("units");function UnitNavItemRender(props){if(props.isEmpty)return null;// don't show 404 for invisible items
if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["c" /* Error */],{inline:true,error:props});var unitName=props.unitName,url=props.url,count=props.count,velocity=props.velocity,cost=props.cost,mode=props.mode,isVisible=props.isVisible;if(!isVisible)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{className:"navMenuItem",style:{textTransform:"capitalize"},containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{activeClassName:"navLinkActive",to:url}),primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UM,{id:unitName+".plural",values:{count:0}})),secondaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:count}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),mode==="velocity"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"+",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:velocity}),"/sec"):null,mode==="cost"&&cost?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"-",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:cost})," (",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["h" /* Percent */],{val:Math.min(999.99,count.isZero()?Number.POSITIVE_INFINITY:cost.dividedBy(count).toNumber())}),")"):null),secondaryTextLines:2});}var UnitNavItem=__WEBPACK_IMPORTED_MODULE_6__swarm2_core__["containers"].units.UnitNavItem(UnitNavItemRender);function UnitNavRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["c" /* Error */],{error:props});var charId=props.charId,readonly=props.readonly,unitName=props.unitName,buyN=props.buyN,names=props.names;var url=(readonly?"/c/":"/p/")+charId+"/units";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["List"],null,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(names,function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnitNavItem,{key:name,charId:charId,parentUnitName:unitName,unitName:name,buyN:buyN,url:url+"/"+name});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{className:"navMenuItem",style:{textTransform:"capitalize"},containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{exact:true,activeClassName:"navLinkActive",to:url}),primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"allunits"})}));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__swarm2_core__["containers"].units.UnitNav(UnitNavRender));

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Subheader = __webpack_require__(924);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheader = function Subheader(props, context) {
  var children = props.children,
      inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      prepareStyles = _context$muiTheme.prepareStyles,
      subheader = _context$muiTheme.subheader;


  var styles = {
    root: {
      boxSizing: 'border-box',
      color: subheader.color,
      fontSize: 14,
      fontWeight: subheader.fontWeight,
      lineHeight: '48px',
      paddingLeft: inset ? 72 : 16,
      width: '100%'
    }
  };

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    children
  );
};

Subheader.muiName = 'Subheader';

Subheader.propTypes =  false ? {
  /**
   * Node that will be placed inside the `Subheader`.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the `Subheader` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Subheader.defaultProps = {
  inset: false
};

Subheader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Subheader;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandLess = function NavigationExpandLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
  );
};
NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
NavigationExpandLess.displayName = 'NavigationExpandLess';
NavigationExpandLess.muiName = 'SvgIcon';

exports.default = NavigationExpandLess;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandMore = function NavigationExpandMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
  );
};
NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
NavigationExpandMore.displayName = 'NavigationExpandMore';
NavigationExpandMore.muiName = 'SvgIcon';

exports.default = NavigationExpandMore;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(233);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedList = function NestedList(props) {
  var children = props.children,
      open = props.open,
      nestedLevel = props.nestedLevel,
      style = props.style;


  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    _List2.default,
    { style: style },
    _react.Children.map(children, function (child) {
      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
        nestedLevel: nestedLevel + 1
      }) : child;
    })
  );
};

NestedList.propTypes =  false ? {
  children: _propTypes2.default.node,
  nestedLevel: _propTypes2.default.number.isRequired,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = NestedList;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectable = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colorManipulator = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeSelectable = function makeSelectable(MyComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    (0, _inherits3.default)(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
        }
        return previousValue || _this.isChildSelected(child, _this.props);
      }, _this.handleItemTouchTap = function (event, item) {
        var itemValue = item.props.value;

        if (itemValue !== _this.props.value) {
          if (_this.props.onChange) {
            _this.props.onChange(event, itemValue);
          }
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_class, [{
      key: 'extendChild',
      value: function extendChild(child, styles, selectedItemStyle) {
        var _this2 = this;

        if (child && child.type && child.type.muiName === 'ListItem') {
          var selected = this.isChildSelected(child, this.props);
          var selectedChildrenStyles = void 0;
          if (selected) {
            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
          }

          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);

          this.keyIndex += 1;

          return _react2.default.cloneElement(child, {
            onClick: function onClick(event) {
              _this2.handleItemTouchTap(event, child);
              if (child.props.onClick) {
                child.props.onClick(event);
              }
            },
            key: this.keyIndex,
            style: mergedChildrenStyles,
            nestedItems: child.props.nestedItems.map(function (child) {
              return _this2.extendChild(child, styles, selectedItemStyle);
            }),
            initiallyOpen: this.isInitiallyOpen(child)
          });
        } else {
          return child;
        }
      }
    }, {
      key: 'isInitiallyOpen',
      value: function isInitiallyOpen(child) {
        if (child.props.initiallyOpen) {
          return child.props.initiallyOpen;
        }
        return this.hasSelectedDescendant(false, child);
      }
    }, {
      key: 'isChildSelected',
      value: function isChildSelected(child, props) {
        return props.value === child.props.value;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            children = _props.children,
            selectedItemStyle = _props.selectedItemStyle,
            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);


        this.keyIndex = 0;
        var styles = {};

        if (!selectedItemStyle) {
          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
        }

        return _react2.default.createElement(
          MyComponent,
          (0, _extends3.default)({}, other, this.state),
          _react.Children.map(children, function (child) {
            return _this3.extendChild(child, styles, selectedItemStyle);
          })
        );
      }
    }]);
    return _class;
  }(_react.Component), _class.propTypes = {
    children: _propTypes2.default.node,
    onChange: _propTypes2.default.func,
    selectedItemStyle: _propTypes2.default.object,
    value: _propTypes2.default.any
  }, _class.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
  }, _temp2;
};

exports.makeSelectable = makeSelectable;
exports.default = makeSelectable;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function Divider(props, context) {
  var inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      prepareStyles = _context$muiTheme.prepareStyles;


  var styles = {
    root: {
      margin: 0,
      marginTop: -1,
      marginLeft: inset ? 72 : 0,
      height: 1,
      border: 'none',
      backgroundColor: baseTheme.palette.borderColor
    }
  };

  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
};

Divider.muiName = 'Divider';

Divider.propTypes =  false ? {
  /**
   * If true, the `Divider` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Divider.defaultProps = {
  inset: false
};

Divider.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Divider;

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UnitListItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnitListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_css__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__units_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("view.UnitsList");var UM=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("units");function UnitListItemRender(props){var unitName=props.unitName,url=props.url,count=props.count,velocity=props.velocity,isProducible=props.isProducible;if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["ListItem"],{className:"navMenuItem",containerElement:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url+"/"+unitName}),primaryText:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",{style:{display:"inline-block",textAlign:"right",width:"10em"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:count}))," ",__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UM,{id:unitName+".plural",values:{count:count}})),secondaryText:isProducible?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",{style:{color:"inherit",display:"inline-block",textAlign:"right",width:"14em"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"velocity",values:{value:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["g" /* Num */],{val:velocity})}})):null});}var UnitListItem=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].units.UnitListItem(UnitListItemRender);function UnitListRender(props){var displayName=props.displayName,unitNames=props.unitNames,charId=props.charId,readonly=props.readonly;if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});var url=(readonly?"/c/":"/p/")+charId+"/units";return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"title",values:{displayName:displayName}})}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["List"],null,unitNames.map(function(name){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UnitListItem,{key:name,unitName:name,charId:charId,url:url});})));}var UnitListView=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].units.UnitList(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* DumpProps */](UnitListRender));

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduceKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reduceKeys={form:function form(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"FORM_SET":return Object.assign({},state,_defineProperty({},action.name,action.value));case"FORM_CLEAR":return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(state,action.name);default:return state;}}};

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return theme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme__);
// import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme'
//import * as c from "material-ui/utils/colorManipulator"
// http://www.material-ui.com/#/customization/themes
// https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js
var theme=__WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme___default()({toolbar:{// this is also the text/title color
iconColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["blue100"]},snackbar:{textColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["white"],backgroundColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["purple800"]},raisedButton:{disabledColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["grey800"],disabledTextColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["grey600"]},palette:{primary1Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["purple900"],primary2Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["purple800"],primary3Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["purple800"],accent1Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["blue700"],accent2Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["blue800"],accent3Color:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["blue500"],canvasColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["grey900"],disabledColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["grey500"],textColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["white"],alternateTextColor:__WEBPACK_IMPORTED_MODULE_0_material_ui_styles_colors__["grey100"]}});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__characters__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__debug__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__options__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rankings__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_signin__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__beta__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TitleView__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PrivacyView__ = __webpack_require__(1047);
var ROCharacterRouter=__WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()({readonly:true})(__WEBPACK_IMPORTED_MODULE_4__characters__["c" /* CharacterRouter */]);var RWCharacterRouter=__WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()({readonly:false})(__WEBPACK_IMPORTED_MODULE_4__characters__["c" /* CharacterRouter */]);var AuthedRoute=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].app.withAuth(function AuthedRoute(props){var isPending=props.isPending,isAllowed=props.isAllowed,path=props.path;// don't ever interrupt the loading process
if(isPending)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],props);if(!isAllowed)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["d" /* Redirect */],{to:"/",from:path});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],props);});var AppRoutes=function AppRoutes(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{exact:true,path:"/",component:__WEBPACK_IMPORTED_MODULE_13__TitleView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:"/auth",component:__WEBPACK_IMPORTED_MODULE_11__auth_signin__["b" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:"/beta",component:__WEBPACK_IMPORTED_MODULE_12__beta__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:"/privacy",component:__WEBPACK_IMPORTED_MODULE_14__PrivacyView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:"/__/auth/action",component:__WEBPACK_IMPORTED_MODULE_11__auth_signin__["a" /* AuthEmailActionRedirect */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{exact:true,path:"/start",component:__WEBPACK_IMPORTED_MODULE_4__characters__["e" /* Start */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/u/:userId/characters",component:__WEBPACK_IMPORTED_MODULE_4__characters__["b" /* CharacterListView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/u/:userId",component:__WEBPACK_IMPORTED_MODULE_5__users__["b" /* UserView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/c/:charId",component:ROCharacterRouter}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{exact:true,path:"/me/characters/new",component:__WEBPACK_IMPORTED_MODULE_4__characters__["d" /* NewCharacter */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/me/characters",component:__WEBPACK_IMPORTED_MODULE_4__characters__["a" /* AuthCharacterListView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/me",component:__WEBPACK_IMPORTED_MODULE_5__users__["a" /* AuthUserView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/options",component:__WEBPACK_IMPORTED_MODULE_9__options__["a" /* OptionsView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/p/:charId/options",component:__WEBPACK_IMPORTED_MODULE_9__options__["a" /* OptionsView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/debug",component:__WEBPACK_IMPORTED_MODULE_6__debug__["a" /* DebugView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/p/:charId/debug",component:__WEBPACK_IMPORTED_MODULE_6__debug__["a" /* DebugView */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/p/:charId",component:RWCharacterRouter}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{path:"/rankings",component:__WEBPACK_IMPORTED_MODULE_10__rankings__["a" /* RankingsRouter */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthedRoute,{component:__WEBPACK_IMPORTED_MODULE_8__common__["f" /* NotFoundView */]}));};/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout__["a" /* Layout */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AppRoutes,null));});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CharacterListView__ = __webpack_require__(936);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CharacterListView__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CharacterListView__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CharacterRouter__ = __webpack_require__(940);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__CharacterRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RedirectLastCharacter__ = __webpack_require__(987);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__RedirectLastCharacter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewCharacter__ = __webpack_require__(988);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__NewCharacter__["a"]; });
//export * from './CharacterView'
//export * from './ActionErrorsView'

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DeleteCharacterListRender */
/* unused harmony export DeleteCharacterList */
/* unused harmony export AuthCharacterListRender */
/* unused harmony export AuthCharacterList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthCharacterListView; });
/* unused harmony export CharacterListEntry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CharacterListView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_10__common__["k" /* intlMessages */]("view.CharacterList");var LM=__WEBPACK_IMPORTED_MODULE_10__common__["k" /* intlMessages */]("leagues");function DeleteCharacterListEntryRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{inline:true,error:props});var displayName=props.displayName,updatedAt=props.updatedAt,league=props.league,deleteCharacter=props.delete;var onDeleteConfirm=function onDeleteConfirm(){window.confirm(// TODO i18n
"Are you sure you want to delete this character? No undo. No reset-rewards.")&&deleteCharacter();};return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["ListItem"],{primaryText:displayName,secondaryText:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,"Played ",__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["d" /* FromNow */],{since:updatedAt})),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](LM,{id:league.split("-")[0]}))),leftIcon:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default.a,null),onClick:onDeleteConfirm});}var DeleteCharacterListEntry=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.CharacterListItem(DeleteCharacterListEntryRender);function DeleteCharacterListRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{error:props});var chars=props.chars,user=props.user;var displayName=user.displayName;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"title",values:{displayName:displayName}})})),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["i" /* PlainLink */],{to:"/me/characters"},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default.a,null))))),chars&&chars.length?__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["List"],null,chars.map(function(charId){return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](DeleteCharacterListEntry,{key:charId,charId:charId});})):__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"auth.nocharacters",values:{icon:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add___default.a,null)}})));}var DeleteCharacterList=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.AuthCharacterList(DeleteCharacterListRender);function AuthCharacterListEntryRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{inline:true,error:props});var charId=props.charId,displayName=props.displayName,updatedAt=props.updatedAt,league=props.league;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["i" /* PlainLink */],{to:"/p/"+charId},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["ListItem"],{primaryText:displayName,secondaryText:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"since",values:{since:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["d" /* FromNow */],{since:updatedAt})}})),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](LM,{id:league.split("-")[0]})))}));}var AuthCharacterListEntry=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.CharacterListItem(AuthCharacterListEntryRender);function AuthCharacterListRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{error:props});var chars=props.chars,limit=props.limit,user=props.user;var displayName=user.displayName;var disabled=!(!chars||chars.length<limit);return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"title",values:{displayName:displayName}})}),disabled?__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,{disabled:disabled},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add___default.a,null)):__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/me/characters/new"},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,{disabled:disabled},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add___default.a,null)))),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["i" /* PlainLink */],{to:"/me/characters/delete"},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default.a,null))))),chars&&chars.length?__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["List"],null,chars.map(function(charId){return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](AuthCharacterListEntry,{key:charId,charId:charId});})):__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"auth.nocharacters",values:{icon:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add___default.a,null)}})));}var AuthCharacterList=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.AuthCharacterList(AuthCharacterListRender);var AuthCharacterListView=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(function(props){// Delete-mode gets a separate URL.
// TODO: dropdown with 'delete' button next to each char; remove delete mode.
return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:props.match.path,component:AuthCharacterList}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:props.match.path+"/delete",component:DeleteCharacterList}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{render:__WEBPACK_IMPORTED_MODULE_10__common__["f" /* NotFoundView */]}));});function CharacterListEntryRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{error:props});var charId=props.charId,displayName=props.displayName,updatedAt=props.updatedAt,league=props.league;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["i" /* PlainLink */],{to:"/c/"+charId},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["ListItem"],{primaryText:displayName,secondaryText:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"since",values:{since:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["d" /* FromNow */],{since:updatedAt})}})),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](LM,{id:league.split("-")[0]})))}));}var CharacterListEntry=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.CharacterListItem(CharacterListEntryRender);function CharacterListRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{error:props});var chars=props.chars,user=props.user;var displayName=user.displayName;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"title",values:{displayName:displayName}})}))),chars&&chars.length?__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_List__["List"],null,chars.map(function(charId){return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](CharacterListEntry,{key:charId,charId:charId});})):__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](M,{id:"noauth.nocharacters",values:{displayName:displayName}})));}var CharacterListView=__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].characters.CharacterList(__WEBPACK_IMPORTED_MODULE_10__common__["a" /* DumpProps */](CharacterListRender));

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationClose = function NavigationClose(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
NavigationClose = (0, _pure2.default)(NavigationClose);
NavigationClose.displayName = 'NavigationClose';
NavigationClose.muiName = 'SvgIcon';

exports.default = NavigationClose;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAdd = function ContentAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
  );
};
ContentAdd = (0, _pure2.default)(ContentAdd);
ContentAdd.displayName = 'ContentAdd';
ContentAdd.muiName = 'SvgIcon';

exports.default = ContentAdd;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDelete = function ActionDelete(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDelete = (0, _pure2.default)(ActionDelete);
ActionDelete.displayName = 'ActionDelete';
ActionDelete.muiName = 'SvgIcon';

exports.default = ActionDelete;

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__achievements__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CharacterView__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__statistics__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__units__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__combat__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__swarm2_assert__);
var M=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("view.CharacterRouter");function NotYoursView(props){var charId=props.charId,location=props.location;var url=location&&location.pathname?location.pathname.replace(/^\/p\//,"/c/"):"/c/"+charId;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](M,{id:"notyours",values:{link:__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["b" /* Link */],{to:url},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](M,{id:"notyours.link"}))}}));}var CharacterRouter=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].characters.CharacterRouter(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common__["c" /* Error */],{error:props});var charId=props.charId,isAuthChar=props.isAuthChar,readonly=props.readonly,match=props.match,location=props.location;Object(__WEBPACK_IMPORTED_MODULE_9__swarm2_assert__["assert"])(readonly!=null,"CharacterRouter.readonly is required");var route=function route(Wrapped){return function(props){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Wrapped,Object.assign({},props,{readonly:readonly}));};};if(!readonly&&!isAuthChar){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](NotYoursView,{charId:charId,location:location});}//  <ActionErrorsView />
return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__achievements__["b" /* AchievementsToast */],{charId:charId}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:match.path,exact:true,component:readonly?__WEBPACK_IMPORTED_MODULE_4__CharacterView__["a" /* CharacterRO */]:__WEBPACK_IMPORTED_MODULE_4__CharacterView__["b" /* CharacterRW */]}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:match.path+"/units",render:route(__WEBPACK_IMPORTED_MODULE_7__units__["a" /* UnitsRouter */])}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:match.path+"/achievements",component:__WEBPACK_IMPORTED_MODULE_3__achievements__["a" /* Achievements */],render:route(__WEBPACK_IMPORTED_MODULE_3__achievements__["a" /* Achievements */])}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{exact:true,path:match.path+"/statistics",render:route(__WEBPACK_IMPORTED_MODULE_6__statistics__["a" /* StatisticsView */])}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:match.path+"/statistics/:tabName",render:route(__WEBPACK_IMPORTED_MODULE_6__statistics__["a" /* StatisticsView */])}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:match.path+"/combat",render:route(__WEBPACK_IMPORTED_MODULE_8__combat__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_5__common__["f" /* NotFoundView */]})));});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AchievementsView__ = __webpack_require__(942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AchievementsView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AchievementsToastView__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AchievementsToastView__["a"]; });


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AchievementsItemRender */
/* unused harmony export AchievementsItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_question_circle__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_question_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_question_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_circle__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_check_circle__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_check_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_check_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_exclamation_triangle__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_exclamation_triangle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_exclamation_triangle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__);
var M=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("view.Achievements");var AM=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("achievements");var icon={hidden:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_question_circle___default.a,null),visible:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_circle___default.a,null),complete:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_check_circle___default.a,null),pending:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_exclamation_triangle___default.a,null)};function DescText(props){var achievementName=props.achievementName,progress=props.progress;// react-intl doesn't allow dots in prop names, boo
var quotas=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(// all non-empty quotas. Booleans are empty, for example.
__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pickBy(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapValues(progress,"quota")),// No dots allowed in react-intl value-names.
function(val,key){return key.replace(/\./g,"_");});var values=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(quotas,function(val,key){return key+"_count";}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapValues(quotas,function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:v});}),function(val,key){return key+"_text";}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AM,{id:achievementName+".desc",values:values}));}var desc={hidden:function hidden(props){return null;},visible:function visible(_ref){var achievementName=_ref.achievementName,progress=_ref.progress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescText,{achievementName:achievementName,progress:progress}),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(progress,function(p,statname){return p.percent==null?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:statname},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:p.value})," / ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["g" /* Num */],{val:p.quota}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_LinearProgress___default.a,{mode:"determinate",value:p.percent,max:1}));}));},complete:function complete(_ref2){var achievementName=_ref2.achievementName,progress=_ref2.progress,completedAt=_ref2.completedAt;Object(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__["assertDefined"])(completedAt,"complete status with no date",completedAt);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescText,{achievementName:achievementName,progress:progress}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Completed ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["d" /* FromNow */],{since:completedAt})));},pending:function pending(_ref3){var achievementName=_ref3.achievementName,progress=_ref3.progress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescText,{achievementName:achievementName,progress:progress}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"status.pending"}))));}};function AchievementsItemRender(props){var achievementName=props.achievementName,status=props.status,progress=props.progress,completedAt=props.completedAt,error=props.error;switch(error&&error.status){case"empty":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:error.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* NotFoundView */],null));case"pending":case"notrequested":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:error.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["e" /* LoadingSpinner */],null));default:}var entryDesc=Object(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__["assertDefined"])(desc[status],"invalid status",status);var icon_=Object(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__["assertDefined"])(icon[status],"invalid status: icon",status);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItem"],{leftIcon:icon_,primaryText:status==="hidden"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"hidden"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AM,{id:achievementName}),secondaryText:entryDesc({achievementName:achievementName,status:status,progress:progress,completedAt:completedAt})});}var AchievementsItem=__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].achievements.AchievementsItem(AchievementsItemRender);function AchievementsRender(props){var displayName=props.displayName,achieveNames=props.achieveNames,charId=props.charId,error=props.error;switch(error&&error.status){case"empty":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:error.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* NotFoundView */],null));case"pending":case"notrequested":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:error.path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["e" /* LoadingSpinner */],null));default:}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"title",values:{displayName:displayName}})}))),achieveNames?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__["List"],null,achieveNames.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AchievementsItem,{key:name,charId:charId,achievementName:name});})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common__["e" /* LoadingSpinner */],null));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].achievements.Achievements(__WEBPACK_IMPORTED_MODULE_5__common__["a" /* DumpProps */](AchievementsRender)));

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props, context) {
  var max = props.max,
      min = props.min,
      value = props.value;
  var _context$muiTheme = context.muiTheme,
      palette = _context$muiTheme.baseTheme.palette,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'relative',
      height: 4,
      display: 'block',
      width: '100%',
      backgroundColor: palette.primary3Color,
      borderRadius: borderRadius,
      margin: 0,
      overflow: 'hidden'
    },
    bar: {
      height: '100%'
    },
    barFragment1: {},
    barFragment2: {}
  };

  if (props.mode === 'indeterminate') {
    styles.barFragment1 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
    };

    styles.barFragment2 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
    };
  } else {
    styles.bar.backgroundColor = props.color || palette.primary1Color;
    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
    styles.bar.width = getRelativeValue(value, min, max) + '%';
  }

  return styles;
}

var LinearProgress = function (_Component) {
  (0, _inherits3.default)(LinearProgress, _Component);

  function LinearProgress() {
    (0, _classCallCheck3.default)(this, LinearProgress);
    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinearProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timers = {};

      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);

      this.timers.bar2 = setTimeout(function () {
        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
      }, 850);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timers.bar1);
      clearTimeout(this.timers.bar2);
    }
  }, {
    key: 'barUpdate',
    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      timeToNextStep = timeToNextStep || 420;
      step = step || 0;
      step %= 4;

      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
      var left = this.context.muiTheme.isRtl ? 'right' : 'left';

      if (step === 0) {
        barElement.style[left] = stepValues[0][0] + '%';
        barElement.style[right] = stepValues[0][1] + '%';
      } else if (step === 1) {
        barElement.style.transitionDuration = '840ms';
      } else if (step === 2) {
        barElement.style[left] = stepValues[1][0] + '%';
        barElement.style[right] = stepValues[1][1] + '%';
      } else if (step === 3) {
        barElement.style.transitionDuration = '0ms';
      }
      this.timers[id] = setTimeout(function () {
        return _this3.barUpdate(id, step + 1, barElement, stepValues);
      }, timeToNextStep);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.bar) },
          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
        )
      );
    }
  }]);
  return LinearProgress;
}(_react.Component);

LinearProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100
};
LinearProgress.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
LinearProgress.propTypes =  false ? {
  /**
   * The color of the progress bar, defaults to
   * primary color of theme.
   */
  color: _propTypes2.default.string,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes2.default.number,
  /**
   * The mode of show your progress, indeterminate for when
   * there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes2.default.number
} : {};
exports.default = LinearProgress;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaQuestionCircle = function FaQuestionCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23 30.7v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m5.7-15q0-2-1.2-3.6t-3.1-2.6-3.8-0.9q-5.4 0-8.3 4.7-0.3 0.6 0.2 1l2.9 2.2q0.2 0.1 0.5 0.1 0.3 0 0.5-0.2 1.2-1.6 1.9-2.1 0.8-0.5 2-0.5 1 0 1.9 0.6t0.8 1.3q0 0.8-0.4 1.3t-1.6 1q-1.4 0.7-2.5 2t-1.2 2.8v0.8q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5q0-0.5 0.5-1.1t1.2-1.1q0.7-0.4 1.1-0.7t1-0.8 1-1 0.6-1.4 0.3-1.8z m8.6 4.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaQuestionCircle;
module.exports = exports['default'];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(946)();
}


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(96);
var invariant = __webpack_require__(119);

module.exports = function() {
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  function shim() {
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaExclamationTriangle = function FaExclamationTriangle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.9 30.7v-4.2q0-0.4-0.3-0.6t-0.5-0.2h-4.2q-0.3 0-0.5 0.2t-0.3 0.6v4.2q0 0.3 0.3 0.5t0.5 0.2h4.2q0.3 0 0.5-0.2t0.3-0.5z m-0.1-8.4l0.4-10.2q0-0.3-0.2-0.4-0.3-0.3-0.5-0.3h-5q-0.2 0-0.5 0.3-0.2 0.1-0.2 0.4l0.4 10.2q0 0.3 0.2 0.4t0.5 0.2h4.2q0.3 0 0.5-0.2t0.2-0.4z m-0.3-20.8l17.1 31.4q0.8 1.4 0 2.8-0.4 0.7-1 1.1t-1.5 0.3h-34.2q-0.8 0-1.5-0.3t-1-1.1q-0.8-1.4 0-2.8l17.1-31.4q0.4-0.7 1.1-1.1t1.4-0.4 1.4 0.4 1.1 1.1z' })
        )
    );
};

exports.default = FaExclamationTriangle;
module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AchievementsToastRender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Snackbar__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_onlyUpdateForKeys__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_onlyUpdateForKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_onlyUpdateForKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_compose__);
var M=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("view.AchievementsToast");var AM=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("achievements");var AchievementsToastRender=function AchievementsToastRender(props){var first=props.first,onRequestClose=props.onRequestClose,_props$autoHideDurati=props.autoHideDuration,autoHideDuration=_props$autoHideDurati===undefined?6000:_props$autoHideDurati,error=props.error;//console.log("toast", {first, onRequestClose, autoHideDuration, error})
if(error)return null;if(!first)return null;//  action='view' onActionClick={history.push('/p/')}
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Snackbar___default.a,Object.assign({open:!!first,autoHideDuration:autoHideDuration,onRequestClose:onRequestClose},{message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"title",values:{displayName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AM,{id:first})}}))}));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].achievements.AchievementsToast,__WEBPACK_IMPORTED_MODULE_4_recompose_onlyUpdateForKeys___default()(["first","autoHideDuration","error"]),__WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function(props){return!props.error&&{onRequestClose:function onRequestClose(reason){if(reason!=="clickaway")return props.onRequestClose();}};}))(AchievementsToastRender));

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _ClickAwayListener = __webpack_require__(235);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _SnackbarBody = __webpack_require__(950);

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
      zIndex = _context$muiTheme.zIndex;
  var open = state.open;


  var styles = {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: zIndex.snackbar,
      visibility: open ? 'visible' : 'hidden',
      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
    }
  };

  return styles;
}

var Snackbar = function (_Component) {
  (0, _inherits3.default)(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose('clickaway');
      } else {
        _this.setState({ open: false });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open,
        message: this.props.message,
        action: this.props.action
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.open) {
        this.setAutoHideTimer();
        this.setTransitionTimer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
        this.setState({
          open: false
        });

        clearTimeout(this.timerOneAtTheTimeId);
        this.timerOneAtTheTimeId = setTimeout(function () {
          _this2.setState({
            message: nextProps.message,
            action: nextProps.action,
            open: true
          });
        }, 400);
      } else {
        var open = nextProps.open;

        this.setState({
          open: open !== null ? open : this.state.open,
          message: nextProps.message,
          action: nextProps.action
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open !== this.state.open) {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        } else {
          clearTimeout(this.timerAutoHideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHideId);
      clearTimeout(this.timerTransitionId);
      clearTimeout(this.timerOneAtTheTimeId);
    }
  }, {
    key: 'setAutoHideTimer',


    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer() {
      var _this3 = this;

      var autoHideDuration = this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        clearTimeout(this.timerAutoHideId);
        this.timerAutoHideId = setTimeout(function () {
          if (_this3.props.open !== null && _this3.props.onRequestClose) {
            _this3.props.onRequestClose('timeout');
          } else {
            _this3.setState({ open: false });
          }
        }, autoHideDuration);
      }
    }

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function setTransitionTimer() {
      var _this4 = this;

      this.timerTransitionId = setTimeout(function () {
        _this4.timerTransitionId = undefined;
      }, 400);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          contentStyle = _props.contentStyle,
          bodyStyle = _props.bodyStyle,
          messageProp = _props.message,
          onRequestClose = _props.onRequestClose,
          onActionTouchTap = _props.onActionTouchTap,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
      var _state = this.state,
          action = _state.action,
          message = _state.message,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: open ? this.componentClickAway : null },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
          _react2.default.createElement(_SnackbarBody2.default, {
            action: action,
            contentStyle: contentStyle,
            message: message,
            open: open,
            onActionTouchTap: onActionTouchTap,
            style: bodyStyle
          })
        )
      );
    }
  }]);
  return Snackbar;
}(_react.Component);

Snackbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Snackbar.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * Override the inline-styles of the body element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is touchtapped.
   *
   * @param {object} event Action button event.
   */
  onActionTouchTap: _propTypes2.default.func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Snackbar;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarBody = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _withWidth = __webpack_require__(951);

var _withWidth2 = _interopRequireDefault(_withWidth);

var _FlatButton = __webpack_require__(236);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var open = props.open,
      width = props.width;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
      desktopGutter = _context$muiTheme$bas2.desktopGutter,
      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
      fontFamily = _context$muiTheme$bas.fontFamily,
      _context$muiTheme$sna = _context$muiTheme.snackbar,
      backgroundColor = _context$muiTheme$sna.backgroundColor,
      textColor = _context$muiTheme$sna.textColor,
      actionColor = _context$muiTheme$sna.actionColor,
      borderRadius = _context$muiTheme.borderRadius;


  var isSmall = width === _withWidth.SMALL;

  var styles = {
    root: {
      fontFamily: fontFamily,
      backgroundColor: backgroundColor,
      padding: '0 ' + desktopGutter + 'px',
      height: desktopSubheaderHeight,
      lineHeight: desktopSubheaderHeight + 'px',
      borderRadius: isSmall ? 0 : borderRadius,
      maxWidth: isSmall ? 'inherit' : 568,
      minWidth: isSmall ? 'inherit' : 288,
      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
      flexGrow: isSmall ? 1 : 0
    },
    content: {
      fontSize: 14,
      color: textColor,
      opacity: open ? 1 : 0,
      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
    },
    action: {
      color: actionColor,
      float: 'right',
      marginTop: 6,
      marginRight: -16,
      marginLeft: desktopGutter,
      backgroundColor: 'transparent'
    }
  };

  return styles;
}

var SnackbarBody = function SnackbarBody(props, context) {
  var action = props.action,
      contentStyle = props.contentStyle,
      message = props.message,
      open = props.open,
      onActionTouchTap = props.onActionTouchTap,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
    style: styles.action,
    label: action,
    onClick: onActionTouchTap
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    _react2.default.createElement(
      'div',
      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
      _react2.default.createElement(
        'span',
        null,
        message
      ),
      actionButton
    )
  );
};

exports.SnackbarBody = SnackbarBody;
SnackbarBody.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is touchtapped.
   *
   * @param {object} event Action button event.
   */
  onActionTouchTap: _propTypes2.default.func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   * Width of the screen.
   */
  width: _propTypes2.default.number.isRequired
} : {};

SnackbarBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withWidth;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(115);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SMALL = exports.SMALL = 1;
var MEDIUM = exports.MEDIUM = 2;
var LARGE = exports.LARGE = 3;

function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$largeWidth = options.largeWidth,
      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
      _options$mediumWidth = options.mediumWidth,
      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
      _options$resizeInterv = options.resizeInterval,
      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;


  return function (MyComponent) {
    return function (_Component) {
      (0, _inherits3.default)(WithWidth, _Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: null
        }, _this.handleResize = function () {
          clearTimeout(_this.deferTimer);
          _this.deferTimer = setTimeout(function () {
            _this.updateWidth();
          }, resizeInterval);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.deferTimer);
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth() {
          var innerWidth = window.innerWidth;
          var width = void 0;

          if (innerWidth >= largeWidth) {
            width = LARGE;
          } else if (innerWidth >= mediumWidth) {
            width = MEDIUM;
          } else {
            // innerWidth < 768
            width = SMALL;
          }

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var width = this.state.width;

          /**
           * When rendering the component on the server,
           * we have no idea about the screen width.
           * In order to prevent blinks and help the reconciliation
           * we are not rendering the component.
           *
           * A better alternative would be to send client hints.
           * But the browser support of this API is low:
           * http://caniuse.com/#search=client%20hint
           */
          if (width === null) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            _react2.default.createElement(MyComponent, (0, _extends3.default)({
              width: width
            }, this.props))
          );
        }
      }]);
      return WithWidth;
    }(_react.Component);
  };
}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(82);

var _EnhancedButton = __webpack_require__(112);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__(953);

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  (0, _inherits3.default)(FlatButton, _Component);

  function FlatButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          children = _props.children,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          hoverColor = _props.hoverColor,
          icon = _props.icon,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          primary = _props.primary,
          rippleColor = _props.rippleColor,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
      var _context$muiTheme = this.context.muiTheme,
          borderRadius = _context$muiTheme.borderRadius,
          _context$muiTheme$but = _context$muiTheme.button,
          buttonHeight = _context$muiTheme$but.height,
          buttonMinWidth = _context$muiTheme$but.minWidth,
          buttonTextTransform = _context$muiTheme$but.textTransform,
          _context$muiTheme$fla = _context$muiTheme.flatButton,
          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
          buttonColor = _context$muiTheme$fla.color,
          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
          fontSize = _context$muiTheme$fla.fontSize,
          fontWeight = _context$muiTheme$fla.fontWeight,
          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
          textColor = _context$muiTheme$fla.textColor,
          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: fullWidth ? '100%' : buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: borderRadius,
        userSelect: 'none',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        var iconStyles = (0, _simpleAssign2.default)({
          verticalAlign: 'middle',
          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
          marginRight: label && labelPosition === 'before' ? 12 : 0
        }, icon.props.style);
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: iconStyles,
          key: 'iconCloned'
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          focusRippleColor: buttonRippleColor,
          focusRippleOpacity: 0.3,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          touchRippleColor: buttonRippleColor,
          touchRippleOpacity: 0.3
        }),
        enhancedButtonChildren
      );
    }
  }]);
  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButton.propTypes =  false ? {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The element to use as the container for the FlatButton. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * FlatButton in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * Use this property to display an icon.
   */
  icon: _propTypes2.default.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is touch-tapped.
   *
   * @param {object} event TouchTap event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _propTypes2.default.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _propTypes2.default.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FlatButton;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  (0, _inherits3.default)(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    (0, _classCallCheck3.default)(this, FlatButtonLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        label
      );
    }
  }]);
  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButtonLabel.propTypes =  false ? {
  label: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = FlatButtonLabel;

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StuckActionsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CharacterRW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_editor_mode_edit__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_editor_mode_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_editor_mode_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_8__common__["k" /* intlMessages */]("view.CharacterView");var StuckActionsError=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].characters.StuckActionsError(function(props){var numPendingActions=props.numPendingActions,open=props.open,onClose=props.onClose,error=props.error;if(error)return null;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar___default.a,{open:open,message:__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"stuckactions",values:{num:__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:numPendingActions})}}),onRequestClose:onClose});});function CharacterRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var charId=props.charId,displayName=props.displayName,ownerName=props.ownerName,userId=props.userId,createdAt=props.createdAt,readonly=props.readonly,setDisplayName=props.setDisplayName,isCombatVisible=props.isCombatVisible;var url=(readonly?"/c/":"/p/")+charId;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:displayName}),readonly?null:__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,{onClick:function onClick(){return setDisplayName(prompt("Your swarm's new name: "));}},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_editor_mode_edit___default.a,null)))),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,readonly?__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"owner",values:{name:__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/u/"+userId},ownerName)}})):null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"created",values:{time:__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["d" /* FromNow */],{since:createdAt})}})),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url+"/units"},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"units"}))),isCombatVisible?__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url+"/combat"},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"combat"}))):null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url+"/achievements"},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"achievements"}))),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url+"/statistics"},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](M,{id:"statistics"}))),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](StuckActionsError,{charId:charId})));}var CharacterRO=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].characters.CharacterRO(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* DumpProps */](CharacterRender));var CharacterRW=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].characters.CharacterRW(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* DumpProps */](CharacterRender));

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsView__ = __webpack_require__(956);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StatisticsView__["a"]; });


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductionStatisticsRow */
/* unused harmony export MiscStatistics */
/* unused harmony export StatisticsRender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatisticsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flow_static_land_lib_Maybe__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flow_static_land_lib_Maybe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_flow_static_land_lib_Maybe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_8__common__["k" /* intlMessages */]("view.StatisticsView");var UM=__WEBPACK_IMPORTED_MODULE_8__common__["k" /* intlMessages */]("units");function ProductionStatisticsNumTD(_ref){var val=_ref.val;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],{style:{textAlign:"right"}},val===undefined?null:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:val}));}function ProductionStatisticsRowRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var unitName=props.unitName,bought=props.bought,clicks=props.clicks,spent=props.spent,looted=props.looted,grown=props.grown,firstElapsed=props.firstElapsed,isVisible=props.isVisible;if(!isVisible)return null;//console.log(unitName, {bought, clicks, spent, looted, grown, firstSince})
return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],{key:unitName},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](UM,{id:unitName+".plural",values:{count:1}})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_6_flow_static_land_lib_Maybe__["maybe"]("-",function(ms){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["b" /* Duration */],{millis:ms});},firstElapsed)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsNumTD,{val:bought}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsNumTD,{val:clicks}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsNumTD,{val:spent}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsNumTD,{val:looted}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsNumTD,{val:grown}));}var ProductionStatisticsRow=__WEBPACK_IMPORTED_MODULE_7__swarm2_core__["containers"].statistics.ProductionStatisticsRow(ProductionStatisticsRowRender);function ProductionStatistics(props){var unitNames=props.unitNames,charId=props.charId;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],{selectable:false},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],{adjustForCheckbox:false,displaySelectAll:false},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.name"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.first"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.bought"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.clicks"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.spent"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.looted"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.col.grown"})))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableBody"],{displayRowCheckbox:false},unitNames.map(function(name){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatisticsRow,{key:name,unitName:name,charId:charId});})));}function CombatStatistics(props){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,"Coming soon.");}function MiscStatisticsRender(props){var createdAt=props.createdAt,totalClears=props.totalClears,totalWins=props.totalWins,totalFights=props.totalFights;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"other.created",values:{val:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["d" /* FromNow */],{since:createdAt})}})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"other.totalclears",values:{val:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:totalClears})}})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"other.totalwins",values:{val:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:totalWins})}})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"other.totalfights",values:{val:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["g" /* Num */],{val:totalFights})}})));}var MiscStatistics=__WEBPACK_IMPORTED_MODULE_7__swarm2_core__["containers"].statistics.MiscStatistics(MiscStatisticsRender);// "Table sorting?" - it's in the next material-ui release. Tried using it a
// while back (material-ui@next ; 2017 April-ish), but it's missing some other
// elements I needed. Give it more time.
// https://github.com/callemall/material-ui/issues/1352
function StatisticsRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common__["c" /* Error */],{error:props});var displayName=props.displayName,charId=props.charId,unitNames=props.unitNames,tabName=props.match.params.tabName,readonly=props.readonly;//console.log({displayName, createdAt, charId, unitNames, match, error})
var url=(readonly?"/c/":"/p/")+charId+"/statistics";return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"title",values:{displayName:displayName}})}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tabs"],{value:tabName},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tab"],{label:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"production.title"}),value:"production",containerElement:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:url+"/production"})},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ProductionStatistics,{unitNames:unitNames,charId:charId}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tab"],{label:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"combat.title"}),value:"combat",containerElement:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:url+"/combat"})},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](CombatStatistics,{charId:charId}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Tabs__["Tab"],{label:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"other.title"}),value:"other",containerElement:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:url+"/other"})},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](MiscStatistics,{charId:charId})))));}var StatisticsView=__WEBPACK_IMPORTED_MODULE_7__swarm2_core__["containers"].statistics.Statistics(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* DumpProps */](StatisticsRender));

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;

var _Table2 = __webpack_require__(958);

var _Table3 = _interopRequireDefault(_Table2);

var _TableBody2 = __webpack_require__(959);

var _TableBody3 = _interopRequireDefault(_TableBody2);

var _TableFooter2 = __webpack_require__(963);

var _TableFooter3 = _interopRequireDefault(_TableFooter2);

var _TableHeader2 = __webpack_require__(964);

var _TableHeader3 = _interopRequireDefault(_TableHeader2);

var _TableHeaderColumn2 = __webpack_require__(414);

var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);

var _TableRow2 = __webpack_require__(965);

var _TableRow3 = _interopRequireDefault(_TableRow2);

var _TableRowColumn2 = __webpack_require__(237);

var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Table = _Table3.default;
exports.TableBody = _TableBody3.default;
exports.TableFooter = _TableFooter3.default;
exports.TableHeader = _TableHeader3.default;
exports.TableHeaderColumn = _TableHeaderColumn3.default;
exports.TableRow = _TableRow3.default;
exports.TableRowColumn = _TableRowColumn3.default;
exports.default = _Table3.default;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      table = _context$muiTheme.table;


  return {
    root: {
      backgroundColor: table.backgroundColor,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      tableLayout: 'fixed',
      fontFamily: baseTheme.fontFamily
    },
    bodyTable: {
      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    },
    tableWrapper: {
      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
      overflow: 'auto'
    }
  };
}

var Table = function (_Component) {
  (0, _inherits3.default)(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      allRowsSelected: false
    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
    }, _this.onRowHover = function (rowNumber) {
      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
    }, _this.onRowHoverExit = function (rowNumber) {
      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
    }, _this.onRowSelection = function (selectedRows) {
      if (_this.state.allRowsSelected) {
        _this.setState({ allRowsSelected: false });
      }

      if (_this.props.onRowSelection) {
        _this.props.onRowSelection(selectedRows);
      }
    }, _this.onSelectAll = function () {
      if (_this.props.onRowSelection) {
        if (!_this.state.allRowsSelected) {
          _this.props.onRowSelection('all');
        } else {
          _this.props.onRowSelection('none');
        }
      }

      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Table, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.allRowsSelected) {
        this.setState({ allRowsSelected: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
        this.setState({ allRowsSelected: nextProps.allRowsSelected });
      }
    }
  }, {
    key: 'isScrollbarVisible',
    value: function isScrollbarVisible() {
      var tableDivHeight = this.refs.tableDiv.clientHeight;
      var tableBodyHeight = this.refs.tableBody.clientHeight;

      return tableBodyHeight > tableDivHeight;
    }
  }, {
    key: 'createTableHeader',
    value: function createTableHeader(base) {
      return _react2.default.cloneElement(base, {
        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
        onSelectAll: this.onSelectAll,
        selectAllSelected: this.state.allRowsSelected
      });
    }
  }, {
    key: 'createTableBody',
    value: function createTableBody(base) {
      return _react2.default.cloneElement(base, {
        allRowsSelected: this.state.allRowsSelected,
        multiSelectable: this.props.multiSelectable,
        onCellClick: this.onCellClick,
        onCellHover: this.onCellHover,
        onCellHoverExit: this.onCellHoverExit,
        onRowHover: this.onRowHover,
        onRowHoverExit: this.onRowHoverExit,
        onRowSelection: this.onRowSelection,
        selectable: this.props.selectable
      });
    }
  }, {
    key: 'createTableFooter',
    value: function createTableFooter(base) {
      return base;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          fixedFooter = _props.fixedFooter,
          fixedHeader = _props.fixedHeader,
          style = _props.style,
          wrapperStyle = _props.wrapperStyle,
          headerStyle = _props.headerStyle,
          bodyStyle = _props.bodyStyle,
          footerStyle = _props.footerStyle;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var tHead = void 0;
      var tFoot = void 0;
      var tBody = void 0;

      _react2.default.Children.forEach(children, function (child) {
        if (!_react2.default.isValidElement(child)) return;

        var muiName = child.type.muiName;

        if (muiName === 'TableBody') {
          tBody = _this2.createTableBody(child);
        } else if (muiName === 'TableHeader') {
          tHead = _this2.createTableHeader(child);
        } else if (muiName === 'TableFooter') {
          tFoot = _this2.createTableFooter(child);
        } else {
           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
        }
      });

      // If we could not find a table-header and a table-body, do not attempt to display anything.
      if (!tBody && !tHead) return null;

      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
      var headerTable = void 0;
      var footerTable = void 0;
      var inlineHeader = void 0;
      var inlineFooter = void 0;

      if (fixedHeader) {
        headerTable = _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
          _react2.default.createElement(
            'table',
            { className: className, style: mergedTableStyle },
            tHead
          )
        );
      } else {
        inlineHeader = tHead;
      }

      if (tFoot !== undefined) {
        if (fixedFooter) {
          footerTable = _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
            _react2.default.createElement(
              'table',
              { className: className, style: prepareStyles(mergedTableStyle) },
              tFoot
            )
          );
        } else {
          inlineFooter = tFoot;
        }
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
        headerTable,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
          _react2.default.createElement(
            'table',
            { className: className, style: mergedTableStyle, ref: 'tableBody' },
            inlineHeader,
            inlineFooter,
            tBody
          )
        ),
        footerTable
      );
    }
  }]);
  return Table;
}(_react.Component);

Table.defaultProps = {
  allRowsSelected: false,
  fixedFooter: true,
  fixedHeader: true,
  height: 'inherit',
  multiSelectable: false,
  selectable: true
};
Table.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Table.propTypes =  false ? {
  /**
   * Set to true to indicate that all rows should be selected.
   */
  allRowsSelected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the body's table element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * Children passed to table.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the footer will appear fixed below the table.
   * The default value is true.
   */
  fixedFooter: _propTypes2.default.bool,
  /**
   * If true, the header will appear fixed above the table.
   * The default value is true.
   */
  fixedHeader: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the footer's table element.
   */
  footerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the header's table element.
   */
  headerStyle: _propTypes2.default.object,
  /**
   * The height of the table.
   */
  height: _propTypes2.default.string,
  /**
   * If true, multiple table rows can be selected.
   * CTRL/CMD+Click and SHIFT+Click are valid actions.
   * The default value is false.
   */
  multiSelectable: _propTypes2.default.bool,
  /**
   * Called when a row cell is clicked.
   * rowNumber is the row number and columnId is
   * the column number or the column key.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * Called when a table cell is hovered.
   * rowNumber is the row number of the hovered row
   * and columnId is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * Called when a table row is no longer hovered.
   * rowNumber is the row number of the row that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * Called when a row is selected.
   * selectedRows is an array of all row selections.
   * IF all rows have been selected, the string "all"
   * will be returned instead to indicate that all rows have been selected.
   */
  onRowSelection: _propTypes2.default.func,
  /**
   * If true, table rows can be selected.
   * If multiple row selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the table's wrapper element.
   */
  wrapperStyle: _propTypes2.default.object
} : {};
exports.default = Table;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__(122);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(412);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableRowColumn = __webpack_require__(237);

var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);

var _ClickAwayListener = __webpack_require__(235);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableBody = function (_Component) {
  (0, _inherits3.default)(TableBody, _Component);

  function TableBody() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedRows: []
    }, _this.isControlled = false, _this.handleClickAway = function () {
      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length > 0) {
        var selectedRows = [];
        _this.setState({ selectedRows: selectedRows });
        if (_this.props.onRowSelection) {
          _this.props.onRowSelection(selectedRows);
        }
      }
    }, _this.onRowClick = function (event, rowNumber) {
      event.stopPropagation();

      if (_this.props.selectable) {
        // Prevent text selection while selecting rows.
        if (window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects.length > 0) {
          window.getSelection().removeAllRanges();
        }
        _this.processRowSelection(event, rowNumber);
      }
    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
      event.stopPropagation();
      if (_this.props.onCellClick) {
        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
      }
    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
      if (_this.props.onCellHover) {
        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
      }
      _this.onRowHover(event, rowNumber);
    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
      if (_this.props.onCellHoverExit) {
        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
      }
      _this.onRowHoverExit(event, rowNumber);
    }, _this.onRowHover = function (event, rowNumber) {
      if (_this.props.onRowHover) {
        _this.props.onRowHover(rowNumber);
      }
    }, _this.onRowHoverExit = function (event, rowNumber) {
      if (_this.props.onRowHoverExit) {
        _this.props.onRowHoverExit(rowNumber);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableBody, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.preScanRows) {
        this.setState({
          selectedRows: this.getSelectedRows(this.props)
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.preScanRows) {
        this.setState({ // eslint-disable-line react/no-did-mount-set-state
          selectedRows: this.getSelectedRows(this.props)
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
        if (!nextProps.allRowsSelected) {
          this.setState({
            selectedRows: []
          });
          return;
        }
      }

      this.setState({
        selectedRows: this.getSelectedRows(nextProps)
      });
    }
  }, {
    key: 'createRows',
    value: function createRows() {
      var _this2 = this;

      var numChildren = _react2.default.Children.count(this.props.children);
      var rowNumber = 0;
      var handlers = {
        onCellClick: this.onCellClick,
        onCellHover: this.onCellHover,
        onCellHoverExit: this.onCellHoverExit,
        onRowHover: this.onRowHover,
        onRowHoverExit: this.onRowHoverExit,
        onRowClick: this.onRowClick
      };

      return _react2.default.Children.map(this.props.children, function (child) {
        if (_react2.default.isValidElement(child)) {
          var props = {
            hoverable: _this2.props.showRowHover,
            selected: _this2.isRowSelected(rowNumber),
            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
            rowNumber: rowNumber++
          };

          if (rowNumber === numChildren) {
            props.displayBorder = false;
          }

          var children = [_this2.createRowCheckboxColumn(props)];

          _react2.default.Children.forEach(child.props.children, function (child) {
            children.push(child);
          });

          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
        }
      });
    }
  }, {
    key: 'createRowCheckboxColumn',
    value: function createRowCheckboxColumn(rowProps) {
      if (!this.props.displayRowCheckbox) {
        return null;
      }

      var name = rowProps.rowNumber + '-cb';
      var disabled = !this.props.selectable;

      return _react2.default.createElement(
        _TableRowColumn2.default,
        {
          key: name,
          columnNumber: 0,
          style: {
            width: 24,
            cursor: disabled ? 'default' : 'inherit'
          }
        },
        _react2.default.createElement(_Checkbox2.default, {
          name: name,
          value: 'selected',
          disabled: disabled,
          checked: rowProps.selected
        })
      );
    }
  }, {
    key: 'getSelectedRows',
    value: function getSelectedRows(props) {
      var _this3 = this;

      var selectedRows = [];

      if (props.selectable) {
        var index = 0;
        _react2.default.Children.forEach(props.children, function (child) {
          if (_react2.default.isValidElement(child)) {
            if (child.props.selected !== undefined) {
              _this3.isControlled = true;
            }

            if (child.props.selected && (selectedRows.length === 0 || props.multiSelectable)) {
              selectedRows.push(index);
            }

            index++;
          }
        });
      }

      return selectedRows;
    }
  }, {
    key: 'isRowSelected',
    value: function isRowSelected(rowNumber) {
      var _this4 = this;

      if (this.props.allRowsSelected) {
        return true;
      }

      return this.state.selectedRows.some(function (row) {
        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
          if (_this4.isValueInRange(rowNumber, row)) {
            return true;
          }
        } else {
          if (row === rowNumber) {
            return true;
          }
        }

        return false;
      });
    }
  }, {
    key: 'isValueInRange',
    value: function isValueInRange(value, range) {
      if (!range) return false;

      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
        return true;
      }

      return false;
    }
  }, {
    key: 'processRowSelection',
    value: function processRowSelection(event, rowNumber) {
      var selectedRows = [].concat((0, _toConsumableArray3.default)(this.state.selectedRows));

      if (event.shiftKey && this.props.multiSelectable && selectedRows.length > 0) {
        var lastIndex = selectedRows.length - 1;
        var lastSelection = selectedRows[lastIndex];

        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
          lastSelection.end = rowNumber;
        } else {
          selectedRows.splice(lastIndex, 1, {
            start: lastSelection,
            end: rowNumber
          });
        }
      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
        var idx = selectedRows.indexOf(rowNumber);
        if (idx < 0) {
          var foundRange = false;
          for (var i = 0; i < selectedRows.length; i++) {
            var range = selectedRows[i];
            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;

            if (this.isValueInRange(rowNumber, range)) {
              var _selectedRows;

              foundRange = true;
              var values = this.splitRange(range, rowNumber);
              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
            }
          }

          if (!foundRange) selectedRows.push(rowNumber);
        } else {
          selectedRows.splice(idx, 1);
        }
      } else {
        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
          selectedRows = [];
        } else {
          selectedRows = [rowNumber];
        }
      }

      if (!this.isControlled) {
        this.setState({ selectedRows: selectedRows });
      }

      if (this.props.onRowSelection) {
        this.props.onRowSelection(this.flattenRanges(selectedRows));
      }
    }
  }, {
    key: 'splitRange',
    value: function splitRange(range, splitPoint) {
      var splitValues = [];
      var startOffset = range.start - splitPoint;
      var endOffset = range.end - splitPoint;

      // Process start half
      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));

      // Process end half
      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));

      return splitValues;
    }
  }, {
    key: 'genRangeOfValues',
    value: function genRangeOfValues(start, offset) {
      var values = [];
      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
      while (offset !== 0) {
        values.push(start + offset);
        offset += dir;
      }

      return values;
    }
  }, {
    key: 'flattenRanges',
    value: function flattenRanges(selectedRows) {
      var _this5 = this;

      return selectedRows.reduce(function (rows, row) {
        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
          var values = _this5.genRangeOfValues(row.end, row.start - row.end);
          rows.push.apply(rows, [row.end].concat((0, _toConsumableArray3.default)(values)));
        } else {
          rows.push(row);
        }

        return rows;
      }, []).sort();
    }
  }, {
    key: 'getColumnId',
    value: function getColumnId(columnNumber) {
      return columnNumber - 1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          allRowsSelected = _props.allRowsSelected,
          multiSelectable = _props.multiSelectable,
          onCellClick = _props.onCellClick,
          onCellHover = _props.onCellHover,
          onCellHoverExit = _props.onCellHoverExit,
          onRowHover = _props.onRowHover,
          onRowHoverExit = _props.onRowHoverExit,
          onRowSelection = _props.onRowSelection,
          selectable = _props.selectable,
          deselectOnClickaway = _props.deselectOnClickaway,
          showRowHover = _props.showRowHover,
          stripedRows = _props.stripedRows,
          displayRowCheckbox = _props.displayRowCheckbox,
          preScanRows = _props.preScanRows,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'allRowsSelected', 'multiSelectable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowHover', 'onRowHoverExit', 'onRowSelection', 'selectable', 'deselectOnClickaway', 'showRowHover', 'stripedRows', 'displayRowCheckbox', 'preScanRows']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'tbody',
          (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
          this.createRows()
        )
      );
    }
  }]);
  return TableBody;
}(_react.Component);

TableBody.muiName = 'TableBody';
TableBody.defaultProps = {
  allRowsSelected: false,
  deselectOnClickaway: true,
  displayRowCheckbox: true,
  multiSelectable: false,
  preScanRows: true,
  selectable: true,
  style: {}
};
TableBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableBody.propTypes =  false ? {
  /**
   * @ignore
   * Set to true to indicate that all rows should be selected.
   */
  allRowsSelected: _propTypes2.default.bool,
  /**
   * Children passed to table body.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Controls whether or not to deselect all selected
   * rows after clicking outside the table.
   */
  deselectOnClickaway: _propTypes2.default.bool,
  /**
   * Controls the display of the row checkbox. The default value is true.
   */
  displayRowCheckbox: _propTypes2.default.bool,
  /**
   * @ignore
   * If true, multiple table rows can be selected.
   * CTRL/CMD+Click and SHIFT+Click are valid actions.
   * The default value is false.
   */
  multiSelectable: _propTypes2.default.bool,
  /**
   * @ignore
   * Callback function for when a cell is clicked.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is hovered. rowNumber
   * is the row number of the hovered row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is no longer
   * hovered. rowNumber is the row number of the row
   * that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a row is selected. selectedRows is an
   * array of all row selections. If all rows have been selected,
   * the string "all" will be returned instead to indicate that
   * all rows have been selected.
   */
  onRowSelection: _propTypes2.default.func,
  /**
   * Controls whether or not the rows are pre-scanned to determine
   * initial state. If your table has a large number of rows and
   * you are experiencing a delay in rendering, turn off this property.
   */
  preScanRows: _propTypes2.default.bool,
  /**
   * @ignore
   * If true, table rows can be selected. If multiple
   * row selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * If true, table rows will be highlighted when
   * the cursor is hovering over the row. The default
   * value is false.
   */
  showRowHover: _propTypes2.default.bool,
  /**
   * If true, every other table row starting
   * with the first row will be striped. The default value is false.
   */
  stripedRows: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableBody;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedSwitch = __webpack_require__(413);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _checkBoxOutlineBlank = __webpack_require__(961);

var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);

var _checkBox = __webpack_require__(962);

var _checkBox2 = _interopRequireDefault(_checkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var checkbox = context.muiTheme.checkbox;

  var checkboxSize = 24;

  return {
    icon: {
      height: checkboxSize,
      width: checkboxSize
    },
    check: {
      position: 'absolute',
      opacity: 0,
      transform: 'scale(0)',
      transitionOrigin: '50% 50%',
      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
      fill: checkbox.checkedColor
    },
    checkWhenSwitched: {
      opacity: 1,
      transform: 'scale(1)',
      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
    },
    checkWhenDisabled: {
      fill: checkbox.disabledColor
    },
    box: {
      position: 'absolute',
      opacity: 1,
      fill: checkbox.boxColor,
      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
    },
    boxWhenSwitched: {
      opacity: 0,
      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
      fill: checkbox.checkedColor
    },
    boxWhenDisabled: {
      fill: props.checked ? 'transparent' : checkbox.disabledColor
    },
    label: {
      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
    }
  };
}

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switched: false
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({
        switched: newSwitched
      });
    }, _this.handleCheck = function (event, isInputChecked) {
      if (_this.props.onCheck) {
        _this.props.onCheck(event, isInputChecked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          checked = _props.checked,
          defaultChecked = _props.defaultChecked,
          valueLink = _props.valueLink;


      if (checked || defaultChecked || valueLink && valueLink.value) {
        this.setState({
          switched: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.checked !== nextProps.checked) {
        this.setState({
          switched: nextProps.checked
        });
      }
    }
  }, {
    key: 'isChecked',
    value: function isChecked() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setChecked',
    value: function setChecked(newCheckedValue) {
      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          iconStyle = _props2.iconStyle,
          onCheck = _props2.onCheck,
          checkedIcon = _props2.checkedIcon,
          uncheckedIcon = _props2.uncheckedIcon,
          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);

      var styles = getStyles(this.props, this.context);
      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);

      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
      }) : _react2.default.createElement(_checkBox2.default, {
        style: checkStyles
      });

      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
        style: boxStyles
      });

      var checkboxElement = _react2.default.createElement(
        'div',
        null,
        unCheckedElement,
        checkedElement
      );

      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);

      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switched: this.state.switched,
        switchElement: checkboxElement,
        rippleColor: rippleColor,
        iconStyle: mergedIconStyle,
        onSwitch: this.handleCheck,
        labelStyle: labelStyle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.defaultProps = {
  labelPosition: 'right',
  disabled: false
};
Checkbox.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Checkbox.propTypes =  false ? {
  /**
   * Checkbox is checked if true.
   */
  checked: _propTypes2.default.bool,
  /**
   * The SvgIcon to use for the checked state.
   * This is useful to create icon toggles.
   */
  checkedIcon: _propTypes2.default.element,
  /**
   * The default state of our checkbox component.
   * **Warning:** This cannot be used in conjunction with `checked`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * Disabled if true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * Where the label will be placed next to the checkbox.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Checkbox element label.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function that is fired when the checkbox is checked.
   *
   * @param {object} event `change` event targeting the underlying checkbox `input`.
   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
   */
  onCheck: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The SvgIcon to use for the unchecked state.
   * This is useful to create icon toggles.
   */
  uncheckedIcon: _propTypes2.default.element,
  /**
   * ValueLink for when using controlled checkbox.
   */
  valueLink: _propTypes2.default.object
} : {};
exports.default = Checkbox;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBox = function ToggleCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
ToggleCheckBox.displayName = 'ToggleCheckBox';
ToggleCheckBox.muiName = 'SvgIcon';

exports.default = ToggleCheckBox;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TableRowColumn = __webpack_require__(237);

var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableFooter = context.muiTheme.tableFooter;


  return {
    cell: {
      borderTop: '1px solid ' + tableFooter.borderColor,
      verticalAlign: 'bottom',
      padding: 20,
      textAlign: 'left',
      whiteSpace: 'nowrap'
    }
  };
}

var TableFooter = function (_Component) {
  (0, _inherits3.default)(TableFooter, _Component);

  function TableFooter() {
    (0, _classCallCheck3.default)(this, TableFooter);
    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          adjustForCheckbox = _props.adjustForCheckbox,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
        var newChildProps = {
          displayBorder: false,
          key: 'f-' + rowNumber,
          rowNumber: rowNumber,
          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
        };

        var newDescendants = void 0;

        if (adjustForCheckbox) {
          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
        } else {
          newDescendants = child.props.children;
        }

        return _react2.default.cloneElement(child, newChildProps, newDescendants);
      });

      return _react2.default.createElement(
        'tfoot',
        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
        footerRows
      );
    }
  }]);
  return TableFooter;
}(_react.Component);

TableFooter.muiName = 'TableFooter';
TableFooter.defaultProps = {
  adjustForCheckbox: true,
  style: {}
};
TableFooter.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableFooter.propTypes =  false ? {
  /**
   * @ignore
   * Controls whether or not header rows should be adjusted
   * for a checkbox column. If the select all checkbox is true,
   * this property will not influence the number of columns.
   * This is mainly useful for "super header" rows so that
   * the checkbox column does not create an offset that needs
   * to be accounted for manually.
   */
  adjustForCheckbox: _propTypes2.default.bool,
  /**
   * Children passed to table footer.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableFooter;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(412);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableHeaderColumn = __webpack_require__(414);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableHeader = context.muiTheme.tableHeader;


  return {
    root: {
      borderBottom: '1px solid ' + tableHeader.borderColor
    }
  };
}

var TableHeader = function (_Component) {
  (0, _inherits3.default)(TableHeader, _Component);

  function TableHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
      if (_this.props.onSelectAll) {
        _this.props.onSelectAll(checked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeader, [{
    key: 'createSuperHeaderRows',
    value: function createSuperHeaderRows() {
      var numChildren = _react2.default.Children.count(this.props.children);
      if (numChildren === 1) return undefined;

      var superHeaders = [];
      for (var index = 0; index < numChildren - 1; index++) {
        var child = this.props.children[index];

        if (!_react2.default.isValidElement(child)) continue;

        var props = {
          key: 'sh' + index,
          rowNumber: index
        };
        superHeaders.push(this.createSuperHeaderRow(child, props));
      }

      if (superHeaders.length) return superHeaders;
    }
  }, {
    key: 'createSuperHeaderRow',
    value: function createSuperHeaderRow(child, props) {
      var children = [];
      if (this.props.adjustForCheckbox) {
        children.push(this.getCheckboxPlaceholder(props));
      }
      _react2.default.Children.forEach(child.props.children, function (child) {
        children.push(child);
      });

      return _react2.default.cloneElement(child, props, children);
    }
  }, {
    key: 'createBaseHeaderRow',
    value: function createBaseHeaderRow() {
      var childrenArray = _react2.default.Children.toArray(this.props.children);
      var numChildren = childrenArray.length;
      if (numChildren < 1) {
        return null;
      }

      var child = childrenArray[numChildren - 1];

      var props = {
        key: 'h' + numChildren,
        rowNumber: numChildren
      };

      var children = [this.getSelectAllCheckboxColumn(props)];
      _react2.default.Children.forEach(child.props.children, function (child) {
        children.push(child);
      });

      return _react2.default.cloneElement(child, props, children);
    }
  }, {
    key: 'getCheckboxPlaceholder',
    value: function getCheckboxPlaceholder(props) {
      if (!this.props.adjustForCheckbox) return null;

      var disabled = !this.props.enableSelectAll;
      var key = 'hpcb' + props.rowNumber;
      return _react2.default.createElement(_TableHeaderColumn2.default, {
        key: key,
        style: {
          width: 24,
          cursor: disabled ? 'default' : 'inherit'
        }
      });
    }
  }, {
    key: 'getSelectAllCheckboxColumn',
    value: function getSelectAllCheckboxColumn(props) {
      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);

      var disabled = !this.props.enableSelectAll;
      var checkbox = _react2.default.createElement(_Checkbox2.default, {
        key: 'selectallcb',
        name: 'selectallcb',
        value: 'selected',
        disabled: disabled,
        checked: this.props.selectAllSelected,
        onCheck: this.handleCheckAll
      });

      var key = 'hpcb' + props.rowNumber;
      return _react2.default.createElement(
        _TableHeaderColumn2.default,
        {
          key: key,
          style: {
            width: 24,
            cursor: disabled ? 'not-allowed' : 'inherit'
          }
        },
        checkbox
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var superHeaderRows = this.createSuperHeaderRows();
      var baseHeaderRow = this.createBaseHeaderRow();

      return _react2.default.createElement(
        'thead',
        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        superHeaderRows,
        baseHeaderRow
      );
    }
  }]);
  return TableHeader;
}(_react.Component);

TableHeader.muiName = 'TableHeader';
TableHeader.defaultProps = {
  adjustForCheckbox: true,
  displaySelectAll: true,
  enableSelectAll: true,
  selectAllSelected: false
};
TableHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableHeader.propTypes =  false ? {
  /**
   * Controls whether or not header rows should be
   * adjusted for a checkbox column. If the select all
   * checkbox is true, this property will not influence
   * the number of columns. This is mainly useful for
   * "super header" rows so that the checkbox column
   * does not create an offset that needs to be accounted
   * for manually.
   */
  adjustForCheckbox: _propTypes2.default.bool,
  /**
   * Children passed to table header.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Controls whether or not the select all checkbox is displayed.
   */
  displaySelectAll: _propTypes2.default.bool,
  /**
   * If set to true, the select all button will be interactable.
   * If set to false, the button will not be interactable.
   * To hide the checkbox, set displaySelectAll to false.
   */
  enableSelectAll: _propTypes2.default.bool,
  /**
   * @ignore
   * Callback when select all has been checked.
   */
  onSelectAll: _propTypes2.default.func,
  /**
   * @ignore
   * True when select all has been checked.
   */
  selectAllSelected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableHeader;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var tableRow = context.muiTheme.tableRow;


  var cellBgColor = 'inherit';
  if (props.hovered || state.hovered) {
    cellBgColor = tableRow.hoverColor;
  } else if (props.selected) {
    cellBgColor = tableRow.selectedColor;
  } else if (props.striped) {
    cellBgColor = tableRow.stripeColor;
  }

  return {
    root: {
      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
      color: tableRow.textColor,
      height: tableRow.height
    },
    cell: {
      backgroundColor: cellBgColor
    }
  };
}

var TableRow = function (_Component) {
  (0, _inherits3.default)(TableRow, _Component);

  function TableRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onCellClick = function (event, columnIndex) {
      if (_this.props.selectable && _this.props.onCellClick) {
        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
      }
      event.ctrlKey = true;
      _this.onRowClick(event);
    }, _this.onCellHover = function (event, columnIndex) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: true });
        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
        _this.onRowHover(event);
      }
    }, _this.onCellHoverExit = function (event, columnIndex) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: false });
        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
        _this.onRowHoverExit(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableRow, [{
    key: 'onRowClick',
    value: function onRowClick(event) {
      if (this.props.selectable && this.props.onRowClick) {
        this.props.onRowClick(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'onRowHover',
    value: function onRowHover(event) {
      if (this.props.onRowHover) {
        this.props.onRowHover(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'onRowHoverExit',
    value: function onRowHoverExit(event) {
      if (this.props.onRowHoverExit) {
        this.props.onRowHoverExit(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          displayBorder = _props.displayBorder,
          hoverable = _props.hoverable,
          hovered = _props.hovered,
          onCellClick = _props.onCellClick,
          onCellHover = _props.onCellHover,
          onCellHoverExit = _props.onCellHoverExit,
          onRowClick = _props.onRowClick,
          onRowHover = _props.onRowHover,
          onRowHoverExit = _props.onRowHoverExit,
          rowNumber = _props.rowNumber,
          selectable = _props.selectable,
          selected = _props.selected,
          striped = _props.striped,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            columnNumber: columnNumber,
            hoverable: _this2.props.hoverable,
            key: _this2.props.rowNumber + '-' + columnNumber,
            onClick: _this2.onCellClick,
            onHover: _this2.onCellHover,
            onHoverExit: _this2.onCellHoverExit,
            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'tr',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other),
        rowColumns
      );
    }
  }]);
  return TableRow;
}(_react.Component);

TableRow.defaultProps = {
  displayBorder: true,
  hoverable: false,
  hovered: false,
  selectable: true,
  striped: false
};
TableRow.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableRow.propTypes =  false ? {
  /**
   * Children passed to table row.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, row border will be displayed for the row.
   * If false, no border will be drawn.
   */
  displayBorder: _propTypes2.default.bool,
  /**
   * Controls whether or not the row responds to hover events.
   */
  hoverable: _propTypes2.default.bool,
  /**
   * Controls whether or not the row should be rendered as being
   * hovered. This property is evaluated in addition to this.state.hovered
   * and can be used to synchronize the hovered state with some other
   * external events.
   */
  hovered: _propTypes2.default.bool,
  /**
   * @ignore
   * Called when a row cell is clicked.
   * rowNumber is the row number and columnId is
   * the column number or the column key.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is hovered.
   * rowNumber is the row number of the hovered row
   * and columnId is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when row is clicked.
   */
  onRowClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is no longer hovered.
   * rowNumber is the row number of the row that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * Number to identify the row. This property is
   * automatically populated when used with the TableBody component.
   */
  rowNumber: _propTypes2.default.number,
  /**
   * If true, table rows can be selected. If multiple row
   * selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * Indicates that a particular row is selected.
   * This property can be used to programmatically select rows.
   */
  selected: _propTypes2.default.bool,
  /**
   * Indicates whether or not the row is striped.
   */
  striped: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableRow;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(112);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    root: {
      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
      fontWeight: 500,
      fontSize: 14,
      width: props.width,
      textTransform: 'uppercase',
      padding: 0
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: props.label && props.icon ? 72 : 48
    }
  };
}

var Tab = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.value, event, _this);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          index = _props.index,
          onActive = _props.onActive,
          onClick = _props.onClick,
          selected = _props.selected,
          label = _props.label,
          buttonStyle = _props.buttonStyle,
          style = _props.style,
          value = _props.value,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);


      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (icon && _react2.default.isValidElement(icon)) {
        iconElement = _react2.default.cloneElement(icon, {
          style: {
            fontSize: 24,
            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
            marginBottom: label ? 5 : 0
          }
        });
      }

      var rippleOpacity = 0.3;
      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style),
          focusRippleColor: rippleColor,
          touchRippleColor: rippleColor,
          focusRippleOpacity: rippleOpacity,
          touchRippleOpacity: rippleOpacity,
          onClick: this.handleTouchTap
        }),
        _react2.default.createElement(
          'div',
          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
          iconElement,
          label
        )
      );
    }
  }]);
  return Tab;
}(_react.Component);

Tab.muiName = 'Tab';
Tab.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tab.propTypes =  false ? {
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  index: _propTypes2.default.any,
  /**
   * Sets the text value of the tab item to the string specified.
   */
  label: _propTypes2.default.node,
  /**
   * Fired when the active tab changes by touch or tap.
   * Use this event to specify any functionality when an active tab changes.
   * For example - we are using this to route to home when the third tab becomes active.
   * This function will always recieve the active tab as it\'s first argument.
   */
  onActive: _propTypes2.default.func,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   * Defines if the current tab is selected or not.
   * The Tabs component is responsible for setting this property.
   */
  selected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If value prop passed to Tabs component, this value prop is also required.
   * It assigns a value to the tab so that it can be selected by the Tabs.
   */
  value: _propTypes2.default.any,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  width: _propTypes2.default.string
} : {};
exports.default = Tab;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _TabTemplate = __webpack_require__(968);

var _TabTemplate2 = _interopRequireDefault(_TabTemplate);

var _InkBar = __webpack_require__(969);

var _InkBar2 = _interopRequireDefault(_InkBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    tabItemContainer: {
      width: '100%',
      backgroundColor: tabs.backgroundColor,
      whiteSpace: 'nowrap',
      display: 'flex'
    }
  };
}

var Tabs = function (_Component) {
  (0, _inherits3.default)(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
      var valueLink = _this.getValueLink(_this.props);
      var index = tab.props.index;

      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
        valueLink.requestChange(value, event, tab);
      }

      _this.setState({ selectedIndex: index });

      if (tab.props.onActive) {
        tab.props.onActive(tab);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var valueLink = this.getValueLink(this.props);
      var initialIndex = this.props.initialSelectedIndex;

      this.setState({
        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps, nextContext) {
      var valueLink = this.getValueLink(newProps);
      var newState = {
        muiTheme: nextContext.muiTheme || this.context.muiTheme
      };

      if (valueLink.value !== undefined) {
        newState.selectedIndex = this.getSelectedIndex(newProps);
      }

      this.setState(newState);
    }
  }, {
    key: 'getTabs',
    value: function getTabs() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var tabs = [];

      _react.Children.forEach(props.children, function (tab) {
        if ((0, _react.isValidElement)(tab)) {
          tabs.push(tab);
        }
      });

      return tabs;
    }
  }, {
    key: 'getTabCount',
    value: function getTabCount() {
      return this.getTabs().length;
    }

    // Do not use outside of this component, it will be removed once valueLink is deprecated

  }, {
    key: 'getValueLink',
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'getSelectedIndex',
    value: function getSelectedIndex(props) {
      var valueLink = this.getValueLink(props);
      var selectedIndex = -1;

      this.getTabs(props).forEach(function (tab, index) {
        if (valueLink.value === tab.props.value) {
          selectedIndex = index;
        }
      });

      return selectedIndex;
    }
  }, {
    key: 'getSelected',
    value: function getSelected(tab, index) {
      var valueLink = this.getValueLink(this.props);
      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contentContainerClassName = _props.contentContainerClassName,
          contentContainerStyle = _props.contentContainerStyle,
          initialSelectedIndex = _props.initialSelectedIndex,
          inkBarStyle = _props.inkBarStyle,
          onChange = _props.onChange,
          style = _props.style,
          tabItemContainerStyle = _props.tabItemContainerStyle,
          tabTemplate = _props.tabTemplate,
          tabTemplateStyle = _props.tabTemplateStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var valueLink = this.getValueLink(this.props);
      var tabValue = valueLink.value;
      var tabContent = [];
      var width = 100 / this.getTabCount();

      var tabs = this.getTabs().map(function (tab, index) {
         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;

         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;

        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
          key: index,
          selected: _this2.getSelected(tab, index),
          style: tabTemplateStyle
        }, tab.props.children) : undefined);

        return (0, _react.cloneElement)(tab, {
          key: index,
          index: index,
          selected: _this2.getSelected(tab, index),
          width: width + '%',
          onClick: _this2.handleTabTouchTap
        });
      });

      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;

      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
        left: width * realSelectedIndex + '%',
        width: width + '%',
        style: inkBarStyle
      }) : null;

      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
          tabs
        ),
        _react2.default.createElement(
          'div',
          { style: { width: inkBarContainerWidth } },
          inkBar
        ),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
            className: contentContainerClassName
          },
          tabContent
        )
      );
    }
  }]);
  return Tabs;
}(_react.Component);

Tabs.defaultProps = {
  initialSelectedIndex: 0,
  onChange: function onChange() {}
};
Tabs.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tabs.propTypes =  false ? {
  /**
   * Should be used to pass `Tab` components.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The css class name of the content's container.
   */
  contentContainerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content's container.
   */
  contentContainerStyle: _propTypes2.default.object,
  /**
   * Specify initial visible tab index.
   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
   * `initialSelectedIndex` will revert back to default.
   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
   */
  initialSelectedIndex: _propTypes2.default.number,
  /**
   * Override the inline-styles of the InkBar.
   */
  inkBarStyle: _propTypes2.default.object,
  /**
   * Called when the selected value change.
   */
  onChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the tab-labels container.
   */
  tabItemContainerStyle: _propTypes2.default.object,
  /**
   * Override the default tab template used to wrap the content of each tab element.
   */
  tabTemplate: _propTypes2.default.func,
  /**
   * Override the inline-styles of the tab template.
   */
  tabTemplateStyle: _propTypes2.default.object,
  /**
   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
   */
  value: _propTypes2.default.any
} : {};
exports.default = Tabs;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  width: '100%',
  position: 'relative',
  textAlign: 'initial'
};

var TabTemplate = function TabTemplate(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      style = _ref.style;

  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
  if (!selected) {
    templateStyle.height = 0;
    templateStyle.overflow = 'hidden';
  }

  return _react2.default.createElement(
    'div',
    { style: templateStyle },
    children
  );
};

TabTemplate.propTypes =  false ? {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};

exports.default = TabTemplate;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      inkBar = _context$muiTheme.inkBar,
      isRtl = _context$muiTheme.isRtl;


  return {
    root: {
      left: props.left,
      width: props.width,
      bottom: 0,
      display: 'block',
      backgroundColor: props.color || inkBar.backgroundColor,
      height: 2,
      marginTop: -2,
      position: 'relative',
      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
    }
  };
}

var InkBar = function (_Component) {
  (0, _inherits3.default)(InkBar, _Component);

  function InkBar() {
    (0, _classCallCheck3.default)(this, InkBar);
    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(InkBar, [{
    key: 'render',
    value: function render() {
      var style = this.props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
    }
  }]);
  return InkBar;
}(_react.Component);

InkBar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
InkBar.propTypes =  false ? {
  color: _propTypes2.default.string,
  left: _propTypes2.default.string.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  width: _propTypes2.default.string.isRequired
} : {};
exports.default = InkBar;

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CombatRouter__ = __webpack_require__(971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CombatRouter__["a"]; });


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CombatRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CombatForm__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CombatMain__ = __webpack_require__(985);
function CombatRouter(_ref){var readonly=_ref.readonly,match=_ref.match;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+"",render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CombatForm__["a" /* default */],{props:props,readonly:readonly,match:match});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path+"/run",component:__WEBPACK_IMPORTED_MODULE_4__CombatMain__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2__common__["f" /* NotFoundView */]}));}

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectZoneItemIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_circle__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_check_circle__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_check_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_check_circle__);
var M=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("view.CombatForm");var ZM=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("zone");var UM=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("units");var Description=__WEBPACK_IMPORTED_MODULE_3__common__["l" /* prefixedDescription */]("zone");function SelectZoneItemIconRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{inline:true,error:props});var isCleared=props.isCleared;// The style crap comes from how icons are styled when there's no connect()
// wrapper. Wish the material-ui CSS tolerated wrappers; sigh.
var Icon=isCleared?__WEBPACK_IMPORTED_MODULE_13_react_icons_lib_fa_check_circle___default.a:__WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_circle___default.a;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{width:"1.6em",height:"1.6em",style:{color:"rgb(117,117,117)",position:"absolute",margin:"0",top:"4px",left:"24px"}});}var SelectZoneItemIcon=__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].combat.CombatFormSelectZoneItemIcon(SelectZoneItemIconRender);function CombatSelectZoneRender(props){var zones=props.zones,selectedZone=props.selectedZone,selectZone=props.selectZone,charId=props.charId;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,{floatingLabelText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"zone"}),value:selectedZone,maxHeight:200,onChange:selectZone},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a,{key:null,value:null,primaryText:""}),zones.map(function(zone){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a,{key:zone,value:zone,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectZoneItemIcon,{zone:zone,charId:charId}),primaryText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ZM,{id:zone})});}))//leftIcon={<CompleteIcon />}
//leftIcon={<ZoneMenuItemIcon zone={zone} charId={charId} />}
;}var CombatSelectZone=__WEBPACK_IMPORTED_MODULE_9_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_10_recompose_withProps___default()(function(props){return{selectZone:function selectZone(event,index,value){return props.setSelectedZone(value);}};})//injectIntl,
)(CombatSelectZoneRender);function YourArmySoldierItemRender(props){var charId=props.charId,readonly=props.readonly,soldierName=props.soldierName,count=props.count,error=props.error;if(error)return"...";var url=(readonly?"/c/":"/p/")+charId+"/units";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:url+"/"+soldierName},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["g" /* Num */],{val:count})," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:soldierName+".plural",values:{count:count}})));}var YourArmySoldierItem=__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].combat.CombatFormYourArmySoldierItem(YourArmySoldierItemRender);function YourArmy(props){var readonly=props.readonly,charId=props.charId,soldierNames=props.soldierNames;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"yourarmy"})),soldierNames.map(function(soldierName){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](YourArmySoldierItem,{key:soldierName,charId:charId,soldierName:soldierName,readonly:readonly});}));}function SelectedZoneSoldierItemRender(props){var soldierName=props.soldierName,count=props.count,error=props.error;if(error)return"...";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["g" /* Num */],{val:count})," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:soldierName+".plural",values:{count:count}}));}var SelectedZoneSoldierItem=__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].combat.CombatFormSelectedZoneSoldierItem(SelectedZoneSoldierItemRender);function CombatFormSelectedZoneRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{error:props});var charId=props.charId,zone=props.zone,isCleared=props.isCleared,soldierNames=props.soldierNames,grindCount=props.grindCount,isGrind=props.isGrind;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Description,{id:zone})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul",null,soldierNames.map(function(soldierName){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectedZoneSoldierItem,{key:soldierName,charId:charId,zone:zone,soldierName:soldierName});})),isCleared?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["j" /* Tooltip */],{id:"view.CombatForm.grinding.lol"},isGrind?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"grinding",values:{grindCount:grindCount.floor().toNumber(),grindCountText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["g" /* Num */],{val:grindCount})}}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"nogrind"})):null);}var CombatFormSelectedZone=__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].combat.CombatFormSelectedZone(CombatFormSelectedZoneRender);function CombatFormRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{error:props});var readonly=props.readonly,charId=props.charId,onSubmit=props.onSubmit,isSubmittable=props.isSubmittable,soldierNames=props.soldierNames,request=props.request,zoneClears=props.zoneClears,isRunning=props.isRunning,nextUrl=props.nextUrl,hatcheryProdBonus=props.hatcheryProdBonus,isZoneSelectVisible=props.isZoneSelectVisible;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"expansion",values:{zoneClearText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["g" /* Num */],{val:zoneClears}),zoneClears:zoneClears,hatcheryProdBonus:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["h" /* Percent */],{minusone:true,val:hatcheryProdBonus})}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](YourArmy,{charId:charId,soldierNames:soldierNames,readonly:readonly}),isZoneSelectVisible?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatSelectZone,__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(props,"zones","selectedZone","setSelectedZone","charId")),props.selectedZone?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatFormSelectedZone,{zone:props.selectedZone,charId:charId}):null,readonly?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a,{primary:true,disabled:!isSubmittable||isRunning,onClick:onSubmit,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"submit"})}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"nounits"}),request.status==="pending"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["e" /* LoadingSpinner */],null)):null,!request.status&&isRunning?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:nextUrl},"You're already in combat!")):null));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].combat.CombatForm,__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_10_recompose_withProps___default()(function(props){return!props.error&&{nextUrl:"/p/"+props.charId+"/combat/run"};}),__WEBPACK_IMPORTED_MODULE_11__swarm2_core__["containers"].willReceiveProps(function(props){if(props.request&&props.request.status==="success"){props.history.push(props.nextUrl);}}),__WEBPACK_IMPORTED_MODULE_3__common__["a" /* DumpProps */])(CombatFormRender));

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(57);

var _TextField2 = _interopRequireDefault(_TextField);

var _DropDownMenu = __webpack_require__(974);

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  return {
    label: {
      paddingLeft: 0,
      top: props.floatingLabelText ? 6 : -4
    },
    icon: {
      right: 0,
      top: props.floatingLabelText ? 8 : 0
    },
    hideDropDownUnderline: {
      borderTop: 'none'
    },
    dropDownMenu: {
      display: 'block'
    }
  };
}

var SelectField = function (_Component) {
  (0, _inherits3.default)(SelectField, _Component);

  function SelectField() {
    (0, _classCallCheck3.default)(this, SelectField);
    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          style = _props.style,
          labelStyle = _props.labelStyle,
          iconStyle = _props.iconStyle,
          id = _props.id,
          underlineDisabledStyle = _props.underlineDisabledStyle,
          underlineFocusStyle = _props.underlineFocusStyle,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          underlineStyle = _props.underlineStyle,
          dropDownMenuProps = _props.dropDownMenuProps,
          errorStyle = _props.errorStyle,
          disabled = _props.disabled,
          floatingLabelFixed = _props.floatingLabelFixed,
          floatingLabelText = _props.floatingLabelText,
          floatingLabelStyle = _props.floatingLabelStyle,
          hintStyle = _props.hintStyle,
          hintText = _props.hintText,
          fullWidth = _props.fullWidth,
          errorText = _props.errorText,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyle = _props.menuStyle,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          selectionRenderer = _props.selectionRenderer,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);


      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _TextField2.default,
        (0, _extends3.default)({}, other, {
          style: style,
          disabled: disabled,
          floatingLabelFixed: floatingLabelFixed,
          floatingLabelText: floatingLabelText,
          floatingLabelStyle: floatingLabelStyle,
          hintStyle: hintStyle,
          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
          fullWidth: fullWidth,
          errorText: errorText,
          underlineStyle: underlineStyle,
          errorStyle: errorStyle,
          onFocus: onFocus,
          onBlur: onBlur,
          id: id,
          underlineDisabledStyle: underlineDisabledStyle,
          underlineFocusStyle: underlineFocusStyle
        }),
        _react2.default.createElement(
          _DropDownMenu2.default,
          (0, _extends3.default)({
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
            menuItemStyle: menuItemStyle,
            selectedMenuItemStyle: selectedMenuItemStyle,
            underlineStyle: styles.hideDropDownUnderline,
            listStyle: listStyle,
            autoWidth: autoWidth,
            value: value,
            onChange: onChange,
            maxHeight: maxHeight,
            multiple: multiple,
            selectionRenderer: selectionRenderer
          }, dropDownMenuProps),
          children
        )
      );
    }
  }]);
  return SelectField;
}(_react.Component);

SelectField.defaultProps = {
  autoWidth: false,
  disabled: false,
  fullWidth: false,
  multiple: false
};
SelectField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SelectField.propTypes =  false ? {
  /**
   * If true, the width will automatically be set according to the
   * items inside the menu.
   * To control the width in CSS instead, leave this prop set to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem` elements to populate the select field with.
   * If the menu items have a `label` prop, that value will
   * represent the selected menu item in the rendered select field.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the select field will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Object that can handle and override any property of component DropDownMenu.
   */
  dropDownMenuProps: _propTypes2.default.object,
  /**
   * Override the inline-styles of the error element.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when no value is selected.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the floating label.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content of the floating label.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the select field will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the hint element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the label style when the select field is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * Override the default max-height of the underlying `DropDownMenu` element.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `DropDownMenu` element.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event TouchTap event targeting the menu item
   * that was selected.
   * @param {number} key The index of the selected menu item, or undefined
   * if `multiple` is true.
   * @param {any} payload If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Customize the rendering of the selected item.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select
   * field is disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select field
   * is focused.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = SelectField;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.DropDownMenu = undefined;

var _DropDownMenu2 = __webpack_require__(975);

var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);

var _MenuItem2 = __webpack_require__(419);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownMenu = _DropDownMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _DropDownMenu3.default;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _arrowDropDown = __webpack_require__(976);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Menu = __webpack_require__(417);

var _Menu2 = _interopRequireDefault(_Menu);

var _ClearFix = __webpack_require__(978);

var _ClearFix2 = _interopRequireDefault(_ClearFix);

var _Popover = __webpack_require__(418);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(983);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _keycode = __webpack_require__(113);

var _keycode2 = _interopRequireDefault(_keycode);

var _events = __webpack_require__(232);

var _events2 = _interopRequireDefault(_events);

var _IconButton = __webpack_require__(67);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var disabled = props.disabled;

  var spacing = context.muiTheme.baseTheme.spacing;
  var palette = context.muiTheme.baseTheme.palette;
  var accentColor = context.muiTheme.dropDownMenu.accentColor;
  return {
    control: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: '100%',
      position: 'relative',
      width: '100%'
    },
    icon: {
      fill: accentColor,
      position: 'absolute',
      right: spacing.desktopGutterLess,
      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
    },
    iconChildren: {
      fill: 'inherit'
    },
    label: {
      color: disabled ? palette.disabledColor : palette.textColor,
      height: spacing.desktopToolbarHeight + 'px',
      lineHeight: spacing.desktopToolbarHeight + 'px',
      overflow: 'hidden',
      opacity: 1,
      position: 'relative',
      paddingLeft: spacing.desktopGutter,
      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
      textOverflow: 'ellipsis',
      top: 0,
      whiteSpace: 'nowrap'
    },
    labelWhenOpen: {
      opacity: 0,
      top: spacing.desktopToolbarHeight / 8
    },
    root: {
      display: 'inline-block',
      fontSize: spacing.desktopDropDownMenuFontSize,
      height: spacing.desktopSubheaderHeight,
      fontFamily: context.muiTheme.baseTheme.fontFamily,
      outline: 'none',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },
    rootWhenOpen: {
      opacity: 1
    },
    underline: {
      borderTop: 'solid 1px ' + accentColor,
      bottom: 1,
      left: 0,
      margin: '-1px ' + spacing.desktopGutter + 'px',
      right: 0,
      position: 'absolute'
    }
  };
}

var DropDownMenu = function (_Component) {
  (0, _inherits3.default)(DropDownMenu, _Component);

  function DropDownMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropDownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
      event.preventDefault();
      if (!_this.props.disabled) {
        _this.setState({
          open: !_this.state.open,
          anchorEl: _this.rootNode
        });
      }
    }, _this.handleRequestCloseMenu = function () {
      _this.close(false);
    }, _this.handleEscKeyDownMenu = function () {
      _this.close(true);
    }, _this.handleKeyDown = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'up':
        case 'down':
        case 'space':
        case 'enter':
          event.preventDefault();
          _this.setState({
            open: true,
            anchorEl: _this.rootNode
          });
          break;
      }
    }, _this.handleItemTouchTap = function (event, child, index) {
      if (_this.props.multiple) {
        if (!_this.state.open) {
          _this.setState({ open: true });
        }
      } else {
        event.persist();
        _this.setState({
          open: false
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(event, index, child.props.value);
          }

          _this.close(_events2.default.isKeyboard(event));
        });
      }
    }, _this.handleChange = function (event, value) {
      if (_this.props.multiple && _this.props.onChange) {
        _this.props.onChange(event, undefined, value);
      }
    }, _this.close = function (isKeyboard) {
      _this.setState({
        open: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }

        if (isKeyboard) {
          var dropArrow = _this.arrowNode;
          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
          dropNode.focus();
          dropArrow.setKeyboardFocus(true);
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.


  (0, _createClass3.default)(DropDownMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (this.props.openImmediately) {
        // TODO: Temporary fix to make openImmediately work with popover.
        /* eslint-disable react/no-did-mount-set-state */
        setTimeout(function () {
          return _this2.setState({
            open: true,
            anchorEl: _this2.rootNode
          });
        }, 0);
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
    }
  }, {
    key: 'getInputNode',


    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    value: function getInputNode() {
      var _this3 = this;

      var rootNode = this.rootNode;

      rootNode.focus = function () {
        if (!_this3.props.disabled) {
          _this3.setState({
            open: !_this3.state.open,
            anchorEl: _this3.rootNode
          });
        }
      };

      return rootNode;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = this.rootNode;
      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
        el.style.width = 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          animated = _props.animated,
          animation = _props.animation,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyleProp = _props.menuStyle,
          selectionRenderer = _props.selectionRenderer,
          onClose = _props.onClose,
          openImmediately = _props.openImmediately,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          style = _props.style,
          underlineStyle = _props.underlineStyle,
          value = _props.value,
          iconButton = _props.iconButton,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
      var _state = this.state,
          anchorEl = _state.anchorEl,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var displayValue = '';
      if (!multiple) {
        _react2.default.Children.forEach(children, function (child) {
          if (child && value === child.props.value) {
            if (selectionRenderer) {
              displayValue = selectionRenderer(value, child);
            } else {
              // This will need to be improved (in case primaryText is a node)
              displayValue = child.props.label || child.props.primaryText;
            }
          }
        });
      } else {
        var values = [];
        var selectionRendererChildren = [];
        _react2.default.Children.forEach(children, function (child) {
          if (child && value && value.indexOf(child.props.value) > -1) {
            if (selectionRenderer) {
              values.push(child.props.value);
              selectionRendererChildren.push(child);
            } else {
              values.push(child.props.label || child.props.primaryText);
            }
          }
        });

        displayValue = [];
        if (selectionRenderer) {
          displayValue = selectionRenderer(values, selectionRendererChildren);
        } else {
          displayValue = values.join(', ');
        }
      }

      var menuStyle = void 0;
      if (anchorEl && !autoWidth) {
        menuStyle = (0, _simpleAssign2.default)({
          width: anchorEl.clientWidth
        }, menuStyleProp);
      } else {
        menuStyle = menuStyleProp;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
        }),
        _react2.default.createElement(
          _ClearFix2.default,
          { style: styles.control, onClick: this.handleTouchTapControl },
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
            displayValue
          ),
          _react2.default.createElement(
            _IconButton2.default,
            {
              disabled: disabled,
              onKeyDown: this.handleKeyDown,
              ref: function ref(node) {
                _this4.arrowNode = node;
              },
              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
              iconStyle: styles.iconChildren
            },
            iconButton
          ),
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            anchorEl: anchorEl,
            animation: animation || _PopoverAnimationVertical2.default,
            open: open,
            animated: animated,
            onRequestClose: this.handleRequestCloseMenu
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              multiple: multiple,
              maxHeight: maxHeight,
              desktop: true,
              value: value,
              onEscKeyDown: this.handleEscKeyDownMenu,
              style: menuStyle,
              listStyle: listStyle,
              onItemTouchTap: this.handleItemTouchTap,
              onChange: this.handleChange,
              menuItemStyle: menuItemStyle,
              selectedMenuItemStyle: selectedMenuItemStyle,
              autoWidth: autoWidth,
              width: !autoWidth && menuStyle ? menuStyle.width : null
            },
            children
          )
        )
      );
    }
  }]);
  return DropDownMenu;
}(_react.Component);

DropDownMenu.muiName = 'DropDownMenu';
DropDownMenu.defaultProps = {
  animated: true,
  autoWidth: true,
  disabled: false,
  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
  openImmediately: false,
  maxHeight: 500,
  multiple: false,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
DropDownMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DropDownMenu.propTypes =  false ? {
  /**
   * This is the point on the anchor that the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * The width will automatically be set according to the items inside the menu.
   * To control this width in css instead, set this prop to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
   * prop `label` that value will be used to render the representation of that
   * item within the field.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the menu.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides default `SvgIcon` dropdown arrow component.
   */
  iconButton: _propTypes2.default.node,
  /**
   * Overrides the styles of icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of label when the `DropDownMenu` is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * The style object to use to override underlying list style.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the `Menu` when it is displayed.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {object} event TouchTap event targeting the menu item that was clicked.
   * @param {number} key The index of the clicked menu item in the `children` collection.
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is closed.
   */
  onClose: _propTypes2.default.func,
  /**
   * Set to true to have the `DropDownMenu` automatically open on mount.
   */
  openImmediately: _propTypes2.default.bool,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * Overrides the inline-styles of the underline.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = DropDownMenu;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
  );
};
NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
NavigationArrowDropDown.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDown;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotKeyHolder = undefined;

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotKeyHolder = exports.HotKeyHolder = function () {
  function HotKeyHolder() {
    var _this = this;

    (0, _classCallCheck3.default)(this, HotKeyHolder);

    this.clear = function () {
      _this.timerId = null;
      _this.lastKeys = null;
    };
  }

  (0, _createClass3.default)(HotKeyHolder, [{
    key: 'append',
    value: function append(key) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(this.clear, 500);
      return this.lastKeys = (this.lastKeys || '') + key;
    }
  }]);
  return HotKeyHolder;
}();

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BeforeAfterWrapper = __webpack_require__(979);

var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  before: {
    content: "' '",
    display: 'table'
  },
  after: {
    content: "' '",
    clear: 'both',
    display: 'table'
  }
};

var ClearFix = function ClearFix(_ref) {
  var style = _ref.style,
      children = _ref.children,
      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
  return _react2.default.createElement(
    _BeforeAfterWrapper2.default,
    (0, _extends3.default)({}, other, {
      beforeStyle: styles.before,
      afterStyle: styles.after,
      style: style
    }),
    children
  );
};

ClearFix.muiName = 'ClearFix';

ClearFix.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = ClearFix;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var styles = {
  box: {
    boxSizing: 'border-box'
  }
};

var BeforeAfterWrapper = function (_Component) {
  (0, _inherits3.default)(BeforeAfterWrapper, _Component);

  function BeforeAfterWrapper() {
    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(BeforeAfterWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          beforeStyle = _props.beforeStyle,
          afterStyle = _props.afterStyle,
          beforeElementType = _props.beforeElementType,
          afterElementType = _props.afterElementType,
          elementType = _props.elementType,
          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var beforeElement = void 0;
      var afterElement = void 0;

      if (beforeStyle) {
        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
          key: '::before'
        });
      }

      if (afterStyle) {
        afterElement = _react2.default.createElement(this.props.afterElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
          key: '::after'
        });
      }

      var children = [beforeElement, this.props.children, afterElement];

      var props = other;
      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));

      return _react2.default.createElement(this.props.elementType, props, children);
    }
  }]);
  return BeforeAfterWrapper;
}(_react.Component);

BeforeAfterWrapper.defaultProps = {
  beforeElementType: 'div',
  afterElementType: 'div',
  elementType: 'div'
};
BeforeAfterWrapper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
BeforeAfterWrapper.propTypes =  false ? {
  afterElementType: _propTypes2.default.string,
  afterStyle: _propTypes2.default.object,
  beforeElementType: _propTypes2.default.string,
  beforeStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  elementType: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = BeforeAfterWrapper;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _dom = __webpack_require__(395);

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
var RenderToLayer = function (_Component) {
  (0, _inherits3.default)(RenderToLayer, _Component);

  function RenderToLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RenderToLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (!_this.props.componentClickAway) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      var el = _this.layer;
      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
        _this.props.componentClickAway(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RenderToLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unrenderLayer();
    }
  }, {
    key: 'getLayer',
    value: function getLayer() {
      return this.layer;
    }
  }, {
    key: 'unrenderLayer',
    value: function unrenderLayer() {
      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('touchstart', this.onClickAway);
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('touchstart', this.onClickAway);
        window.removeEventListener('click', this.onClickAway);
      }

      (0, _reactDom.unmountComponentAtNode)(this.layer);
      document.body.removeChild(this.layer);
      this.layer = null;
    }

    /**
     * By calling this method in componentDidMount() and
     * componentDidUpdate(), you're effectively creating a "wormhole" that
     * funnels React's hierarchical updates through to a DOM node on an
     * entirely different part of the page.
     */

  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          render = _props.render;


      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          document.body.appendChild(this.layer);

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('touchstart', this.onClickAway);
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
          } else {
            setTimeout(function () {
              window.addEventListener('touchstart', _this2.onClickAway);
              window.addEventListener('click', _this2.onClickAway);
            }, 0);
          }
        }

        var layerElement = render();
        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return RenderToLayer;
}(_react.Component);

RenderToLayer.defaultProps = {
  useLayerForClickAway: true
};
RenderToLayer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RenderToLayer.propTypes =  false ? {
  componentClickAway: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  render: _propTypes2.default.func.isRequired,
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = RenderToLayer;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
      maxHeight: '100%'
    },
    horizontal: {
      maxHeight: '100%',
      overflowY: 'auto',
      transform: open ? 'scaleX(1)' : 'scaleX(0)',
      opacity: open ? 1 : 0,
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
    },
    vertical: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
    }
  };
}

var PopoverAnimationDefault = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationDefault, _Component);

  function PopoverAnimationDefault() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationDefault, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.horizontal) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.vertical) },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopoverAnimationDefault;
}(_react.Component);

PopoverAnimationDefault.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationDefault.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationDefault.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationDefault;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'center');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
      maxHeight: '100%'
    }
  };
}

var PopoverAnimationVertical = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationVertical, _Component);

  function PopoverAnimationVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationVertical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        this.props.children
      );
    }
  }]);
  return PopoverAnimationVertical;
}(_react.Component);

PopoverAnimationVertical.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationVertical.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationVertical.propTypes =  false ? {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationVertical;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCheck = function NavigationCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
  );
};
NavigationCheck = (0, _pure2.default)(NavigationCheck);
NavigationCheck.displayName = 'NavigationCheck';
NavigationCheck.muiName = 'SvgIcon';

exports.default = NavigationCheck;

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CombatRun__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CombatResult__ = __webpack_require__(986);
function CombatMainRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Error */],{error:props});var isEmpty=props.isEmpty,isRunning=props.isRunning,isDone=props.isDone,charId=props.charId,clientNow=props.clientNow;if(isEmpty)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common__["f" /* NotFoundView */],{title:"no-combat"});if(isRunning){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CombatRun__["b" /* default */],{charId:charId,clientNow:clientNow});}if(isDone){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CombatResult__["a" /* default */],{charId:charId,clientNow:clientNow});}return Object(__WEBPACK_IMPORTED_MODULE_3__swarm2_assert__["throws"])("CombatMain: invalid combat state: not empty, running, or done",props);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].combat.CombatMain(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* DumpProps */](CombatMainRender)));

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CombatRun__ = __webpack_require__(420);
var M=__WEBPACK_IMPORTED_MODULE_1__common__["k" /* intlMessages */]("view.CombatResult");var ZM=__WEBPACK_IMPORTED_MODULE_1__common__["k" /* intlMessages */]("zone");var UM=__WEBPACK_IMPORTED_MODULE_1__common__["k" /* intlMessages */]("units");function CombatLootItem(props){var unitName=props.unitName,count=props.count;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"win.lootitem",values:{count:count,unitName:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UM,{id:unitName+".plural",values:{count:count.toNumber()}})}}));}function CombatLoot(props){var loot=props.loot;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,Object.keys(loot).map(function(unitName){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatLootItem,{key:unitName,unitName:unitName,count:loot[unitName]});}));}function CombatResultRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Error */],{error:props});var charId=props.charId,clientNow=props.clientNow,exists=props.exists,status=props.status,zone=props.zone,loot=props.loot,spend=props.spend,isFirstZoneWin=props.isFirstZoneWin,hatcheryProdPerZone=props.hatcheryProdPerZone;var RM=__WEBPACK_IMPORTED_MODULE_1__common__["k" /* intlMessages */]("view.CombatResult."+status);//console.log("combatresult", {error, exists})
if(!exists)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common__["f" /* NotFoundView */],null);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RM,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,isFirstZoneWin?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RM,{id:"firststatus",values:{zone:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ZM,{id:zone}),hatcheryProdPerZone:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common__["h" /* Percent */],{val:hatcheryProdPerZone,minusone:true})}}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RM,{id:"status",values:{zone:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ZM,{id:zone})}})),status==="win"&&loot?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CombatLoot,{loot:loot,spend:spend}):null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CombatRun__["a" /* CombatRunContent */],{charId:charId,clientNow:clientNow}));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].combat.CombatResult(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* DumpProps */](CombatResultRender)));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RedirectLastCharacter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Start; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
function RedirectCharacter(props){var isEmpty=props.isEmpty,isError=props.isError,charId=props.charId;if(isEmpty)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["Redirect"],{to:"/me/characters"});if(isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{error:props});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router__["Redirect"],{to:"/p/"+charId});}var RedirectLastCharacter=__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].characters.LastCharacter(RedirectCharacter);var Start=__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].app.Start(RedirectCharacter);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_file_folder_shared__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_file_folder_shared___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_file_folder_shared__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(161);
var M=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("view.NewCharacter");var LM=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("leagues");var leagueDescriptions={standard:function standard(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.standard.description"}));},overlord:function overlord(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.overlord.description"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.overlord.bullet1"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.overlord.bullet2"}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.templeagues.description"}));},prerelease:function prerelease(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.prerelease.description"}));}};function LeagueDescRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{error:props});var descName=props.descName,isOpen=props.isOpen,untilOpen=props.untilOpen;var E=leagueDescriptions[descName];if(!E)return Object(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__["throws"])("no such league-description",descName);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](E,null),isOpen?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.countdown",values:{countdown:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["b" /* Duration */],{millis:untilOpen})}}))));}var LeagueDesc=__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].characters.NewCharacterLeague(LeagueDescRender);function NewCharacterRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{error:props});var input=props.input,isCharLimit=props.isCharLimit,isLeagueOpen=props.isLeagueOpen,displayName=props.displayName,league=props.league,leagues=props.leagues,request=props.request;if(request.status==="success")return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_router__["Redirect"],{push:true,to:"/p/"+request.result.params.charId});var isSubmitAllowed=isLeagueOpen;var submit=function submit(e){if(isSubmitAllowed)props.create(e,{displayName:displayName,league:league});e.preventDefault();return false;};if(isCharLimit)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"error.isCharLimit"});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form",{onSubmit:submit},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a,{name:"displayName",floatingLabelText:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.displayName"}),type:"text",value:props.displayName,onChange:input.setDisplayName})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs__["Tabs"],{value:props.league,onChange:function onChange(league){return league&&props.setLeague(league);}},leagues.map(function(league){// leagues named prerelease-XXX all have the same description
var descName=league.split("-")[0];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs__["Tab"],{key:league,value:league,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LM,{id:descName})},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LeagueDesc,{league:league,descName:descName}));}),leagues.length<2?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_Tabs__["Tab"],{value:null,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"field.league.comingsoon"})}):null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_file_folder_shared___default.a,null),disabled:!isSubmitAllowed}))));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].characters.NewCharacter(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* DumpProps */](NewCharacterRender)));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserView__ = __webpack_require__(990);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UserView__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__UserView__["b"]; });


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthUserView; });
/* unused harmony export UserRender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_editor_mode_edit__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_editor_mode_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_editor_mode_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.UserView");function BaseUserRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});var displayName=props.displayName,createdAt=props.createdAt,toolbarActions=props.toolbarActions,header=props.header,_props$preferYou=props.preferYou,preferYou=_props$preferYou===undefined?false:_props$preferYou;var yousername=preferYou?"You":displayName;var toolbar=__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:displayName}),toolbarActions));return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,toolbar,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,header,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"created",values:{username:yousername,ago:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["d" /* FromNow */],{since:createdAt})}}))));}var AuthUserRender=function AuthUserRender(props){var promptUsername=props.promptUsername;return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](BaseUserRender,Object.assign({},props,{preferYou:true,toolbarActions:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,{onClick:promptUsername},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_editor_mode_edit___default.a,null)),header:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/u/"+props.userId},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"publicprofile"}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/me/characters"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"mycharacters"}))))}));};var AuthUserView=__WEBPACK_IMPORTED_MODULE_5_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].users.AuthUser,__WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function(props){return{promptUsername:function promptUsername(event){var name=prompt("Your new name: ");// name is null on prompt cancel
if(name!==null)props.setUsername(name);}};}),__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */])(AuthUserRender);var UserRender=function UserRender(props){return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](BaseUserRender,Object.assign({},props,{header:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/u/"+props.userId+"/characters"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"characterlist"}))))}));};var UserView=__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].users.User(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */](UserRender));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dump__ = __webpack_require__(992);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DebugView__ = __webpack_require__(993);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__DebugView__["a"]; });


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dump */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var Dump=__WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle___default()({componentWillMount:function componentWillMount(){// Stay quiet during automated tests; but this is convenient in UIs for debugging
if(true){console.log("debug.Dump",this.props);}}})(function(props){// js object's easier to read than an immutable map
props=Object.assign({},props,{firebaseState:props.firebaseState&&props.firebaseState.toJS()});// remove keys with circular references
props=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(props,["children"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("pre",null,JSON.stringify(props,null,2));});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DebugView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__swarm2_core__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var FM=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("flags");function DebugIndexUnitRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td",null,props.unitName),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td",{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:props.rawCount})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td",{style:{textAlign:"right"}},"+",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{small:true,val:props.velocity}),"/sec ="),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td",{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["g" /* Num */],{val:props.count})));}var DebugIndexUnit=__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].debug.DebugIndexUnit(DebugIndexUnitRender);function DebugCharRender(props){var displayName=props.displayName,updatedAt=props.updatedAt,sinceUpdated=props.sinceUpdated,unitNames=props.unitNames,charId=props.charId;var sinceUpdatedSec=Math.floor(props.sinceUpdated/1000);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4",null,"Character: ",displayName),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p",null,"units reified: ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["d" /* FromNow */],{since:updatedAt})," (",sinceUpdatedSec,"s,"," ",sinceUpdated,"ms)"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody",null,unitNames.map(function(unitName){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DebugIndexUnit,{key:unitName,unitName:unitName,charId:charId});}))));}var DebugChar=__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].debug.DebugChar(DebugCharRender);function alterLocationQS(qs){var location=window.document.location;var search=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(qs);var a=document.createElement("a");a.href=location.href;a.search=search;return a.href;}function toggleHref(name,value){var toggleValue=!value;var location=window.document.location;var qs0=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(location.search);// The line below produces prettier urls, but less correct when setting false
//const qs = toggleValue ? {...qs0, [name]: true} : _.omit(qs0, [name])
var qs=Object.assign({},qs0,_defineProperty({},name,toggleValue));return alterLocationQS(qs);}function FlagRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{inline:true,error:props});var flagName=props.flagName,flagValue=props.flagValue;if(typeof flagValue==="boolean"){var href=toggleHref(flagName,flagValue);//console.log(flagName, href)
return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["ListItem"],{primaryText:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{type:"checkbox",checked:flagValue,onChange:function onChange(){return document.location.href=href;}})," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a",{href:href},flagName)),": ",JSON.stringify(flagValue)),secondaryText:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FM,{id:flagName}))});}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["ListItem"],{primaryText:flagName+": "+JSON.stringify(flagValue),secondaryText:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FM,{id:flagName})});}var Flag=__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].debug.Flag(FlagRender);function DebugIndexRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});//console.log("DebugIndex", props)
var versions=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.pick(props,["clientVersionDate","clientVersion","clientLongVersion","clientLongHash","clientShortHash"]);var clearHref=alterLocationQS({});return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_Toolbar__["ToolbarTitle"],{text:"Debug"}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p",null,"Unlike swarmsim, this debug page won't let you edit your character. That means I can leave it on in production!"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4",null,"Version"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("pre",null,JSON.stringify(versions,null,2)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p",null,"Client deployed ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["d" /* FromNow */],{since:props.clientVersionDate}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("h4",null,"Flags"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,clearHref===document.location.href?null:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a",{href:alterLocationQS({})},"clear URL flags")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["List"],null,props.flagNames.map(function(flag){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Flag,{key:flag,flagName:flag,charId:props.charId});}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TestErrorButton,null)),props.charId?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DebugChar,props):null));}var DebugIndex=__WEBPACK_IMPORTED_MODULE_10__swarm2_core__["containers"].debug.DebugIndex(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */](DebugIndexRender));var TestErrorButton=__WEBPACK_IMPORTED_MODULE_8_recompose_withState___default()("throwUp","setThrowUp",false)(function(props){if(props.throwUp){throw new Error("test error please ignore");}// Throwing from onClick isn't caught by componentDidCatch()! It only catches
// errors in the component lifecycle.
return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{onClick:props.setThrowUp,label:"Throw test lifecycle error",secondary:true});});function DebugView(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{exact:true,path:match.path+"/",component:DebugIndex}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_9__common__["f" /* NotFoundView */]})));}

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Layout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentTitle__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Analytics__ = __webpack_require__(1023);
function Layout(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__nav__["a" /* NavLayout */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DocumentTitle__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Analytics__["a" /* default */],null),children);}

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavLayout__ = __webpack_require__(996);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NavLayout__["a"]; });


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavLink */
/* unused harmony export AuthUsername */
/* unused harmony export UserNavLinks */
/* unused harmony export AuthCharname */
/* unused harmony export CharNavLinks */
/* harmony export (immutable) */ __webpack_exports__["a"] = NavLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_account_circle__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_account_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_account_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_folder_shared__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_folder_shared___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_folder_shared__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_bug__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_bug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_bug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_cog__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_cog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_cog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_flag_checkered__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_flag_checkered___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_flag_checkered__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_folder_open__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_folder_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_folder_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_database__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_database__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_crosshairs__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_crosshairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_crosshairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_trophy__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_trophy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_trophy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_line_chart__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_line_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_line_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MaterialNavLayout__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ErrorHandler__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FreshdeskTicketButton__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// below could also be fa/sort-amount-asc
var M=__WEBPACK_IMPORTED_MODULE_14__common__["k" /* intlMessages */]("view.NavLayout");var NavLink=function NavLink(props){var name=props.name,_props$to=props.to,to=_props$to===undefined?"/"+props.name:_props$to,_props$exact=props.exact,exact=_props$exact===undefined?true:_props$exact,attrs=_objectWithoutProperties(props,["name","to","exact"]);return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__FreshdeskTicketButton__["a" /* NavItem */],Object.assign({name:name,containerElement:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["c" /* NavLink */],{activeClassName:"navLinkActive",exact:exact,to:to})},attrs));};var AuthUsername=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].nav.AuthUsername(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common__["c" /* Error */],{inline:true,error:props});return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"]("span",null,props.displayName);});var AuthUserLink=function AuthUserLink(){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"user",to:"/me",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_account_circle___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthUsername,null));};var AuthCharsLink=function AuthCharsLink(){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"characters",to:"/me/characters",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_icons_lib_fa_folder_open___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"characters"}));};var UserNavLinks=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].nav.UserNavLinks(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common__["c" /* Error */],{inline:true,error:props});var isDebug=props.isDebug;return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"]("div",null,isDebug?[__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{key:"debug",name:"debug",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_bug___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"debug"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,{key:"div"})]:null,__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthUserLink,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthCharsLink,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"options",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_cog___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"options"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"rankings",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_flag_checkered___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"rankings"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__FreshdeskTicketButton__["b" /* default */],null));});var AuthCharname=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].nav.AuthCharname(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common__["c" /* Error */],{inline:true,error:props});var displayName=props.displayName;return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"]("span",null,displayName);});var CharNavLinks=__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].nav.CharNavLinks(function(props){// special-case error: fallback to UserNavLinks if the character's missing
if(props.isEmpty&&__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.isEqual(props.emptyKeys,["character"])){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](UserNavLinks,null);}// handle other errors normally; loading spinner
if(props.isError)return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common__["c" /* Error */],{inline:true,error:props});var isDebug=props.isDebug,charId=props.charId,match=props.match,charExists=props.charExists;if(!charExists)return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](UserNavLinks,props);var root="/p/"+charId;return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"]("div",null,isDebug?[__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{key:"debug",name:"debug",to:root+"/debug",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_bug___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"debug"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,{key:"div"})]:null,__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthUserLink,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthCharsLink,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"options",to:root+"/options",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_cog___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"options"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"character",to:root,icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_folder_shared___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](AuthCharname,{match:match})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"units",to:root+"/units",exact:false,icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_icons_lib_fa_database___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"meat"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{hidden:!props.isCombatVisible,name:"combat",to:root+"/combat",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_icons_lib_fa_crosshairs___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"combat"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"achievements",to:root+"/achievements",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_icons_lib_fa_trophy___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"achievements"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](NavLink,{name:"statistics",to:root+"/statistics",icon:__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_icons_lib_fa_line_chart___default.a,null)},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](M,{id:"statistics"})),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__FreshdeskTicketButton__["b" /* default */],null));});// Awkward component= functions pass along router and parent props
var NavLinks=function NavLinks(props){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{path:"/p/:charId",render:function render(ps){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](CharNavLinks,Object.assign({},ps,props));}}),__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["e" /* Route */],{render:function render(ps){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](UserNavLinks,Object.assign({},ps,props));}}));};function NavLayout(props){return __WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorHandler__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__MaterialNavLayout__["a" /* default */],{menuItems:NavLinks},__WEBPACK_IMPORTED_MODULE_13_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorHandler__["a" /* default */],null,props.children)));}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBug = function FaBug(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.9 21.4q0 0.6-0.4 1t-1 0.5h-5q0 3.8-1.5 6.4l4.6 4.7q0.5 0.4 0.5 1t-0.5 1q-0.4 0.4-1 0.4t-1-0.4l-4.4-4.4q-0.1 0.1-0.3 0.3t-1 0.6-1.4 0.8-1.8 0.7-2.2 0.3v-20h-2.9v20q-1.1 0-2.2-0.3t-2-0.8-1.4-0.8-1-0.8l-0.3-0.3-4.1 4.7q-0.5 0.4-1.1 0.4-0.5 0-1-0.3-0.4-0.4-0.4-1t0.3-1.1l4.5-5q-1.3-2.6-1.3-6.1h-5q-0.5 0-1-0.5t-0.4-1 0.4-1 1-0.4h5v-6.6l-3.8-3.8q-0.4-0.4-0.4-1t0.4-1 1-0.5 1 0.5l3.8 3.8h18.9l3.9-3.8q0.4-0.5 1-0.5t1 0.5 0.4 1-0.4 1l-3.9 3.8v6.6h5q0.6 0 1 0.4t0.4 1z m-10.7-12.8h-14.3q0-3 2.1-5.1t5.1-2.1 5 2.1 2.1 5.1z' })
        )
    );
};

exports.default = FaBug;
module.exports = exports['default'];

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCog = function FaCog(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 20q0-2.4-1.7-4t-4.1-1.7-4 1.7-1.7 4 1.7 4 4 1.7 4.1-1.7 1.7-4z m11.4-2.4v4.9q0 0.3-0.2 0.5t-0.4 0.3l-4.2 0.6q-0.4 1.3-0.8 2.1 0.7 1.1 2.3 3.1 0.3 0.2 0.3 0.5t-0.2 0.5q-0.6 0.9-2.2 2.4t-2.1 1.6q-0.3 0-0.6-0.2l-3.1-2.4q-1 0.5-2 0.9-0.4 3-0.7 4.1-0.1 0.6-0.8 0.6h-4.9q-0.3 0-0.6-0.1t-0.2-0.5l-0.7-4.1q-1.1-0.4-2-0.9l-3.1 2.4q-0.2 0.2-0.6 0.2-0.3 0-0.5-0.2-2.8-2.6-3.7-3.8-0.2-0.2-0.2-0.5 0-0.2 0.2-0.5 0.3-0.5 1.1-1.5t1.2-1.5q-0.6-1.2-0.9-2.3l-4.1-0.6q-0.2 0-0.4-0.2t-0.2-0.6v-4.9q0-0.3 0.2-0.5t0.4-0.3l4.2-0.7q0.3-1 0.8-2-0.9-1.3-2.4-3.1-0.2-0.3-0.2-0.5 0-0.2 0.2-0.5 0.6-0.8 2.2-2.4t2.1-1.6q0.3 0 0.6 0.2l3.1 2.4q1-0.5 2-0.9 0.4-3 0.7-4.1 0.1-0.6 0.8-0.6h4.9q0.3 0 0.6 0.1t0.2 0.5l0.7 4.1q1 0.4 2 0.9l3.1-2.4q0.2-0.2 0.6-0.2 0.3 0 0.5 0.2 2.9 2.6 3.7 3.8 0.2 0.2 0.2 0.5 0 0.2-0.2 0.5-0.4 0.5-1.2 1.5t-1.2 1.5q0.6 1.2 1 2.2l4 0.7q0.3 0 0.5 0.2t0.2 0.6z' })
        )
    );
};

exports.default = FaCog;
module.exports = exports['default'];

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFlagCheckered = function FaFlagCheckered(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.1 22.3v-4.2q-3.9 0.3-8.3 2.5v4.1q4.4-2.1 8.3-2.4z m0-9.1v-4.3q-3.7 0.1-8.3 2.7v4.1q4.6-2.4 8.3-2.5z m18.1 10v-4q-5.1 2.6-8.3 1.6v-4.9q-0.5-0.1-0.9-0.3-0.1-0.1-0.7-0.4t-0.7-0.4-0.7-0.3-0.8-0.3-0.7-0.3-0.8-0.3-0.7-0.2-0.9-0.1-0.9-0.1-0.9-0.1q-0.5 0-1.1 0.1v4.8h0.4q2.3 0 4.2 0.7t4.3 1.8q0.4 0.2 0.9 0.3v4.1q0.9 0.3 2 0.3 2.6 0 6.3-2z m0-9.3v-4.1q-3.6 2-6.6 2-1 0-1.7-0.2v4.3q3.2 0.9 8.3-2z m-29.2-7.8q0 0.7-0.4 1.4t-1 1v27.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-27.5q-0.6-0.4-1-1t-0.4-1.4q0-1.2 0.8-2t2-0.8 2 0.8 0.8 2z m32 1.4v16.6q0 0.8-0.7 1.2-0.3 0.1-0.4 0.2-4.8 2.5-8 2.5-2 0-3.5-0.7l-0.6-0.3q-1.4-0.8-2.2-1.1t-1.9-0.6-2.5-0.3q-2.2 0-5.1 0.9t-5 2.3q-0.3 0.2-0.7 0.2-0.4 0-0.7-0.2-0.7-0.4-0.7-1.2v-16.2q0-0.8 0.6-1.2 0.8-0.4 1.8-0.9t2.4-1.1 3.4-1.1 3.3-0.4q2.5 0 4.6 0.6t4.5 1.9q0.9 0.4 2 0.4 2.6 0 6.7-2.4l0.7-0.4q0.7-0.3 1.4 0.1 0.6 0.4 0.6 1.2z' })
        )
    );
};

exports.default = FaFlagCheckered;
module.exports = exports['default'];

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFolderOpen = function FaFolderOpen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.9 21.2q0 0.6-0.6 1.4l-7.2 8.4q-0.9 1.1-2.5 1.9t-3.1 0.7h-23.1q-0.7 0-1.3-0.3t-0.5-0.9q0-0.6 0.6-1.4l7.2-8.4q0.9-1.1 2.5-1.8t3.1-0.8h23.1q0.7 0 1.3 0.3t0.5 0.9z m-7.2-7.3v3.4h-17.7q-2 0-4.2 1t-3.5 2.5l-7.3 8.6q0-0.1 0-0.3t0-0.3v-20.4q0-1.9 1.4-3.3t3.4-1.4h6.8q1.9 0 3.3 1.4t1.4 3.3v0.7h11.6q1.9 0 3.4 1.4t1.4 3.4z' })
        )
    );
};

exports.default = FaFolderOpen;
module.exports = exports['default'];

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaDatabase = function FaDatabase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 17.1q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0 17.2q5.3 0 9.9-1t7.3-2.8v3.8q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-3.8q2.7 1.9 7.3 2.8t9.8 1z m0-8.6q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.7-8.6-0.7-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0-25.7q4.7 0 8.6 0.8t6.3 2.1 2.3 2.8v2.9q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-2.9q0-1.5 2.3-2.8t6.3-2.1 8.5-0.8z' })
        )
    );
};

exports.default = FaDatabase;
module.exports = exports['default'];

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCrosshairs = function FaCrosshairs(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 22.9h-2.4q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h2.4q-0.7-2.4-2.5-4.2t-4.2-2.5v2.5q0 0.5-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-2.5q-2.4 0.7-4.2 2.5t-2.5 4.2h2.4q0.6 0 1 0.5t0.4 1v2.8q0 0.6-0.4 1t-1 0.5h-2.4q0.7 2.4 2.5 4.2t4.2 2.5v-2.5q0-0.5 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v2.5q2.4-0.7 4.2-2.5t2.5-4.2z m7.6-4.3v2.8q0 0.6-0.4 1t-1 0.5h-3.2q-0.9 3.6-3.5 6.2t-6.2 3.4v3.2q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-3.2q-3.6-0.8-6.2-3.4t-3.5-6.2h-3.2q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h3.2q0.8-3.6 3.5-6.2t6.2-3.4v-3.2q0-0.6 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v3.2q3.6 0.8 6.2 3.4t3.5 6.2h3.2q0.5 0 1 0.5t0.4 1z' })
        )
    );
};

exports.default = FaCrosshairs;
module.exports = exports['default'];

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaTrophy = function FaTrophy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.7 19.7q-1.6-3.6-1.6-8.3h-5.7v2.2q0 1.7 2.1 3.6t5.2 2.5z m24.1-6.1v-2.2h-5.7q0 4.7-1.7 8.3 3.2-0.6 5.3-2.5t2.1-3.6z m2.8-2.9v2.9q0 1.6-0.9 3.2t-2.5 2.9-3.8 2.1-4.9 1q-0.9 1.2-2.1 2.2-0.8 0.7-1.1 1.6t-0.4 2q0 1.2 0.7 2t2.2 0.8q1.7 0 3 1t1.3 2.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-18.6q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-1.5 1.3-2.6t3-1q1.5 0 2.1-0.8t0.7-2q0-1.2-0.3-2t-1.2-1.6q-1.2-1-2.1-2.2-2.5-0.1-4.8-1t-3.9-2.1-2.5-2.9-0.9-3.2v-2.9q0-0.9 0.6-1.5t1.5-0.6h6.5v-2.2q0-1.4 1-2.5t2.5-1h12.9q1.5 0 2.5 1t1.1 2.5v2.2h6.4q0.9 0 1.5 0.6t0.6 1.5z' })
        )
    );
};

exports.default = FaTrophy;
module.exports = exports['default'];

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaLineChart = function FaLineChart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.8 32.4v2.5h-39.8v-29.8h2.5v27.3h37.3z m-2.5-24.2v8.4q0 0.5-0.4 0.6t-0.7-0.1l-2.3-2.4-12.3 12.3q-0.2 0.2-0.5 0.2t-0.4-0.2l-4.5-4.5-8.1 8.1-3.8-3.8 11.4-11.3q0.2-0.2 0.4-0.2t0.5 0.2l4.5 4.5 9-9-2.3-2.4q-0.3-0.3-0.2-0.6t0.6-0.4h8.4q0.3 0 0.5 0.2t0.2 0.4z' })
        )
    );
};

exports.default = FaLineChart;
module.exports = exports['default'];

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavlessLayout */
/* unused harmony export NavLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_layout_css__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AppBar__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Drawer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OfflineIcon__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__updates__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.NavLayout");function Themed(_ref){var children=_ref.children,_ref$titleProps=_ref.titleProps,titleProps=_ref$titleProps===undefined?{showMenuIconButton:false}:_ref$titleProps;// The top-level card isn't really a material-design "card"; it's simply applying style/theme to the whole app.
// The first <Card> has height=100% for pages less high than the user's screen,
// but fails when the page needs to scroll (white bar after scrolling).
// The second <Card> has no set height, and applies style to only part of a
// small page (white bar at the bottom), but covers everything when scrolling.
// The two together are enough to style the whole app.
// (I wonder why body-styling isn't covered more clearly in material-ui's docs,
// or did I miss it?)
return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Card__["Card"],{className:"material-nav-layout"},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Card__["Card"],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_AppBar___default.a,Object.assign({className:"appBar",title:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common__["i" /* PlainLink */],{to:"/"},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](M,{id:"title"})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__updates__["a" /* ReleaseCountdown */],null),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__updates__["b" /* UpdateButton */],null),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__OfflineIcon__["a" /* default */],null))},titleProps)),children));}function NavlessLayout(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](Themed,null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()("appContent",{docked:false})},children));}var _NavLayout=function _NavLayout(){return null;};// for the react/dumped displayName
var NavLayoutDump=__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */](_NavLayout);function NavLayout(props){var drawerProps=props.drawerProps,drawerStyle=props.drawerStyle,isAllowed=props.isAllowed,toggleOpen=props.toggleOpen,MenuItems=props.menuItems,isError=props.isError,children=props.children;// No loading-spinner: this is the very top level, and it's important to show
// the UI ASAP, even if it's incomplete, for the sake of the user experience.
// Watch out for nulls below, while loading.
var docked=drawerProps.docked;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](Themed,{titleProps:{showMenuIconButton:!docked,onLeftIconButtonTouchTap:toggleOpen}},!isError&&isAllowed?__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_Drawer___default.a,Object.assign({},drawerProps,drawerStyle),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](MenuItems,null)):null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div",{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()("appContent",{docked:isAllowed&&docked})},children,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](NavLayoutDump,props)));}// 600px is the 'small' breakpoint:
// https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-breakpoints
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].nav.NavLayout({dockedPx:600})(NavLayout));//export default (props: Object) => props.children

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AppBar = __webpack_require__(1008);

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppBar2.default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(182);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getStyles = getStyles;

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(67);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _menu = __webpack_require__(397);

var _menu2 = _interopRequireDefault(_menu);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _propTypes3 = __webpack_require__(50);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      appBar = _context$muiTheme.appBar,
      iconButtonSize = _context$muiTheme.button.iconButtonSize,
      zIndex = _context$muiTheme.zIndex;


  var flatButtonSize = 36;

  var styles = {
    root: {
      position: 'relative',
      zIndex: zIndex.appBar,
      width: '100%',
      display: 'flex',
      backgroundColor: appBar.color,
      paddingLeft: appBar.padding,
      paddingRight: appBar.padding
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: 0,
      paddingTop: 0,
      letterSpacing: 0,
      fontSize: 24,
      fontWeight: appBar.titleFontWeight,
      color: appBar.textColor,
      height: appBar.height,
      lineHeight: appBar.height + 'px'
    },
    mainElement: {
      boxFlex: 1,
      flex: '1'
    },
    iconButtonStyle: {
      marginTop: (appBar.height - iconButtonSize) / 2,
      marginRight: 8,
      marginLeft: -16
    },
    iconButtonIconStyle: {
      fill: appBar.textColor,
      color: appBar.textColor
    },
    flatButton: {
      color: appBar.textColor,
      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
    }
  };

  return styles;
}

var AppBar = function (_Component) {
  (0, _inherits3.default)(AppBar, _Component);

  function AppBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
      if (_this.props.onLeftIconButtonTouchTap) {
        _this.props.onLeftIconButtonTouchTap(event);
      }
    }, _this.handleTouchTapRightIconButton = function (event) {
      if (_this.props.onRightIconButtonTouchTap) {
        _this.props.onRightIconButtonTouchTap(event);
      }
    }, _this.handleTitleTouchTap = function (event) {
      if (_this.props.onTitleTouchTap) {
        _this.props.onTitleTouchTap(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;

       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          titleStyle = _props.titleStyle,
          iconStyleLeft = _props.iconStyleLeft,
          iconStyleRight = _props.iconStyleRight,
          onTitleTouchTap = _props.onTitleTouchTap,
          showMenuIconButton = _props.showMenuIconButton,
          iconElementLeft = _props.iconElementLeft,
          iconElementRight = _props.iconElementRight,
          iconClassNameLeft = _props.iconClassNameLeft,
          iconClassNameRight = _props.iconClassNameRight,
          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth,
          children = _props.children,
          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var menuElementLeft = void 0;
      var menuElementRight = void 0;

      // If the title is a string, wrap in an h1 tag.
      // If not, wrap in a div tag.
      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';

      var titleElement = _react2.default.createElement(titleComponent, {
        onClick: this.handleTitleTouchTap,
        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
      }, title);

      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);

      if (showMenuIconButton) {
        if (iconElementLeft) {
          var iconElementLeftProps = {};

          if (iconElementLeft.type.muiName === 'IconButton') {
            var iconElemLeftChildren = iconElementLeft.props.children;
            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;

            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
          }

          if (!iconElementLeft.props.onClick && this.props.onLeftIconButtonTouchTap) {
            iconElementLeftProps.onClick = this.handleTouchTapLeftIconButton;
          }

          menuElementLeft = _react2.default.createElement(
            'div',
            { style: prepareStyles(iconLeftStyle) },
            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
          );
        } else {
          menuElementLeft = _react2.default.createElement(
            _IconButton2.default,
            {
              style: iconLeftStyle,
              iconStyle: styles.iconButtonIconStyle,
              iconClassName: iconClassNameLeft,
              onClick: this.handleTouchTapLeftIconButton
            },
            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
          );
        }
      }

      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
        marginRight: -16,
        marginLeft: 'auto'
      }, iconStyleRight);

      if (iconElementRight) {
        var iconElementRightProps = {};

        switch (iconElementRight.type.muiName) {
          case 'IconMenu':
          case 'IconButton':
            var iconElemRightChildren = iconElementRight.props.children;
            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;

            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
            break;

          case 'FlatButton':
            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
            break;

          default:
        }

        if (!iconElementRight.props.onClick && this.props.onRightIconButtonTouchTap) {
          iconElementRightProps.onClick = this.handleTouchTapRightIconButton;
        }

        menuElementRight = _react2.default.createElement(
          'div',
          { style: prepareStyles(iconRightStyle) },
          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
        );
      } else if (iconClassNameRight) {
        menuElementRight = _react2.default.createElement(_IconButton2.default, {
          style: iconRightStyle,
          iconStyle: styles.iconButtonIconStyle,
          iconClassName: iconClassNameRight,
          onClick: this.handleTouchTapRightIconButton
        });
      }

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, {
          rounded: false,
          className: className,
          style: (0, _simpleAssign2.default)({}, styles.root, style),
          zDepth: zDepth
        }),
        menuElementLeft,
        titleElement,
        menuElementRight,
        children
      );
    }
  }]);
  return AppBar;
}(_react.Component);

AppBar.muiName = 'AppBar';
AppBar.defaultProps = {
  showMenuIconButton: true,
  title: '',
  zDepth: 1
};
AppBar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
AppBar.propTypes =  false ? {
  /**
   * Can be used to render a tab inside an app bar for instance.
   */
  children: _propTypes2.default.node,
  /**
   * Applied to the app bar's root element.
   */
  className: _propTypes2.default.string,
  /**
   * The classname of the icon on the left of the app bar.
   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
   */
  iconClassNameLeft: _propTypes2.default.string,
  /**
   * Similiar to the iconClassNameLeft prop except that
   * it applies to the icon displayed on the right of the app bar.
   */
  iconClassNameRight: _propTypes2.default.string,
  /**
   * The custom element to be displayed on the left side of the
   * app bar such as an SvgIcon.
   */
  iconElementLeft: _propTypes2.default.element,
  /**
   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
   */
  iconElementRight: _propTypes2.default.element,
  /**
   * Override the inline-styles of the element displayed on the left side of the app bar.
   */
  iconStyleLeft: _propTypes2.default.object,
  /**
   * Override the inline-styles of the element displayed on the right side of the app bar.
   */
  iconStyleRight: _propTypes2.default.object,
  /**
   * Callback function for when the left icon is selected via a touch tap.
   *
   * @param {object} event TouchTap event targeting the left `IconButton`.
   */
  onLeftIconButtonTouchTap: _propTypes2.default.func,
  /**
   * Callback function for when the right icon is selected via a touch tap.
   *
   * @param {object} event TouchTap event targeting the right `IconButton`.
   */
  onRightIconButtonTouchTap: _propTypes2.default.func,
  /**
   * Callback function for when the title text is selected via a touch tap.
   *
   * @param {object} event TouchTap event targeting the `title` node.
   */
  onTitleTouchTap: _propTypes2.default.func,
  /**
   * Determines whether or not to display the Menu icon next to the title.
   * Setting this prop to false will hide the icon.
   */
  showMenuIconButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The title to display on the app bar.
   */
  title: _propTypes2.default.node,
  /**
   * Override the inline-styles of the app bar's title element.
   */
  titleStyle: _propTypes2.default.object,
  /**
   * The zDepth of the component.
   * The shadow of the app bar is also dependent on this property.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = AppBar;

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_device_signal_wifi_off__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_device_signal_wifi_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_device_signal_wifi_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["containers"].nav.OfflineIcon(function(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{inline:true,error:props});var isConnected=props.isConnected;return isConnected?null:__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_device_signal_wifi_off___default.a,null);}));

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifiOff = function DeviceSignalWifiOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
  );
};
DeviceSignalWifiOff = (0, _pure2.default)(DeviceSignalWifiOff);
DeviceSignalWifiOff.displayName = 'DeviceSignalWifiOff';
DeviceSignalWifiOff.muiName = 'SvgIcon';

exports.default = DeviceSignalWifiOff;

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UpdateButton__ = __webpack_require__(1012);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__UpdateButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReleaseCountdown__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ReleaseCountdown__["a"]; });


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_FlatButton__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_refresh__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withPropsOnChange__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withPropsOnChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_withPropsOnChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reselect__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__registerServiceWorker__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__swarm2_core__);
// how long before we window.location.reload() if the user ignores the button
var FORCE_UPDATE_AFTER_MILLIS=300*1000;// show a countdown shortly before forcing an update, so the user isn't surprised
var COUNTDOWN_AT_MILLIS=FORCE_UPDATE_AFTER_MILLIS-120*1000;// How often we'll check the server for updates. There's an automatic update-check
// on load, but people often leave swarmsim tabs open for a very long time.
var POLL_UPDATE_MILLIS=20*60*1000;var sinceClientDeployed=function sinceClientDeployed(s,p){return p.sinceClientDeployed;};var untilReloadMillis=Object(__WEBPACK_IMPORTED_MODULE_8_reselect__["createSelector"])(sinceClientDeployed,function(since){return since===undefined?undefined:FORCE_UPDATE_AFTER_MILLIS-since;});var isReloadReady=Object(__WEBPACK_IMPORTED_MODULE_8_reselect__["createSelector"])(untilReloadMillis,function(until){return until===undefined?undefined:until<=0;});var untilCountdownMillis=Object(__WEBPACK_IMPORTED_MODULE_8_reselect__["createSelector"])(sinceClientDeployed,function(since){return since===undefined?undefined:COUNTDOWN_AT_MILLIS-since;});var isCountdownReady=Object(__WEBPACK_IMPORTED_MODULE_8_reselect__["createSelector"])(untilCountdownMillis,function(until){return until===undefined?undefined:until<=0;});var HOT_RELOAD_ENABLED=module.hot&&Object(__WEBPACK_IMPORTED_MODULE_11__swarm2_assert__["assert"])("production"!=="production","Hot-reloading in production???");var container=HOT_RELOAD_ENABLED?function(C){return console.warn("UpdateButton disabled: hot reloading works here")||C;}:__WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_12__swarm2_core__["containers"].updateWatcher.UpdateWatcher,// Lots of stuff here is www-specific and can't fit in core or mobile, sadly.
__WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()({reload:function reload(){window.location.reload();}}),__WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default()({componentWillMount:function componentWillMount(){var _this=this;//window.setTimeout(setClientDeployedAt, 2000)
// Careful not to reload instantly - remember that bug from swarm1, where
// the service worker didn't have time to update itself?
//
// I'll leave logging in even in production, because service workers are
// otherwise pretty silent, not unit testable, ugly when things go
// wrong, and notoriously difficult to debug.
if("production"==="production"&&"serviceWorker"in navigator){console.log("attempting service worker registration");window.addEventListener("load",function(){navigator.serviceWorker.register(__WEBPACK_IMPORTED_MODULE_9__registerServiceWorker__["b" /* url */]).then(function(registration){console.log("service worker registered");registration.onupdatefound=function(){console.log("client update found");var installingWorker=registration.installing;installingWorker.onstatechange=function(){console.log("client update state changed",installingWorker.state);if(installingWorker.state==="installed"){if(navigator.serviceWorker.controller){_this.props.setClientDeployedAt(_this.props.now);console.info("client updated; please refresh.",_this.props);}else{_this.setState({offlineCacheSetAt:_this.props.now});console.info("client cached for offline use.",_this.props);}}};};var checkUpdate=function checkUpdate(source){return function(){console.log("checking for client update:",source);registration.update();};};_this.setState({checkUpdate:checkUpdate});// Poll for updates periodically.
window.setInterval(checkUpdate("periodic"),POLL_UPDATE_MILLIS);// Check for updates on load.
checkUpdate("initial")();// And one more way, a bit below: we watch serverDeployedAt for updates.
// Firebase server and client deployment is atomic, but server version
// update is a separate step afterward.
}).catch(function(error){console.error("service worker registration attempted but failed",error);});});}else{//console.log(
//  "service workers not supported. I'll refresh when the server's updated, hoping that there's a corresponding client update.",
//)
var checkUpdate=function checkUpdate(source){return function(){if(!_this.props.serverDeployedAt)return;//console.log(
//  "someone called checkClientUpdate with service workers disabled. " +
//    "I'll trust that there's a client update, since we only do server update " +
//    "checks without service workers.",
//  source,
//)
_this.props.setClientDeployedAt(_this.props.now);};};this.setState({checkUpdate:checkUpdate});}},componentWillUnmount:function componentWillUnmount(){console.warn("UpdateWatcher unmounted. That's not good (but not disastrous).");}}),// In addition to periodic polling, check for updates when the server's updated.
// The "should I update" function is pretty complex - don't update on load
// (serverDeployedAt from null to notnull), but on a real change (notnull to notnull).
__WEBPACK_IMPORTED_MODULE_7_recompose_withPropsOnChange___default()(function(oldProps,newProps){return newProps.checkUpdate&&oldProps.serverDeployedAt&&newProps.serverDeployedAt&&oldProps.serverDeployedAt!==newProps.serverDeployedAt&&(console.log("server updated",oldProps.serverDeployedAt,newProps.serverDeployedAt)||true);},// withPropsOnChange runs on load too, but I don't want this to do so, hence
// the empty-check. Only on change.
function(props){return props.checkUpdate&&props.serverDeployedAt&&props.checkUpdate("server update")();}),// We're done detecting updates; these are for the countdown timer until forced-reload.
Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(Object(__WEBPACK_IMPORTED_MODULE_8_reselect__["createStructuredSelector"])({untilReloadMillis:untilReloadMillis,isReloadReady:isReloadReady,isCountdownReady:isCountdownReady})),__WEBPACK_IMPORTED_MODULE_7_recompose_withPropsOnChange___default()(["isReloadReady"],function(props){if(props.isReloadReady){return props.reload();}}));var UpdateButtonRender=function UpdateButtonRender(_ref){var untilReloadMillis=_ref.untilReloadMillis,isClientDeployed=_ref.isClientDeployed,isCountdownReady=_ref.isCountdownReady,isReloadReady=_ref.isReloadReady,reload=_ref.reload,clientVersion=_ref.clientVersion;//if (!isClientDeployed) return <small>v{clientVersion}</small>
if(!isClientDeployed)return null;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_FlatButton___default.a,{icon:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_refresh___default.a,null),label:isReloadReady?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",null,"Reloading, one moment..."):isCountdownReady?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",null,"Updating in ",__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common__["b" /* Duration */],{millis:untilReloadMillis}),"..."):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",null,"New version ready"),onClick:reload});};/* harmony default export */ __webpack_exports__["a"] = (container(UpdateButtonRender));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1013)(module)))

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationRefresh = function NavigationRefresh(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
  );
};
NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
NavigationRefresh.displayName = 'NavigationRefresh';
NavigationRefresh.muiName = 'SvgIcon';

exports.default = NavigationRefresh;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _pick = __webpack_require__(385);

var _pick2 = _interopRequireDefault(_pick);

var _shallowEqual = __webpack_require__(384);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(47);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(42);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(55);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      _inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

exports.default = withPropsOnChange;

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_FlatButton__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_system_update_alt__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_system_update_alt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_system_update_alt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
var M=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("view.ReleaseCountdown");function ReleaseCountdownRender(props){var url=props.url,releaseCountdown=props.releaseCountdown,sinceRelease=props.sinceRelease,isReleased=props.isReleased,error=props.error;if(error||!releaseCountdown)return null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_FlatButton___default.a,{icon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_system_update_alt___default.a,null),target:"_blank",href:url,label:isReleased?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(M,{id:"over"}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(M,{id:"counting",values:{countdown:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* Duration */],{millis:sinceRelease,noSuffix:true,format:"countdown"})}})});}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].updateWatcher.ReleaseCountdown(ReleaseCountdownRender));

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
  );
};
ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
ActionSystemUpdateAlt.muiName = 'SvgIcon';

exports.default = ActionSystemUpdateAlt;

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Top-level error handler.
// https://facebook.github.io/react/blog/2017/07/26/error-handling-in-react-16.html
// hell if I know the correct types here
var ErrorHandler=function(_React$Component){_inherits(ErrorHandler,_React$Component);function ErrorHandler(props){_classCallCheck(this,ErrorHandler);// can't reuse onClear() here. Ctor requires `this.state = x` to avoid
// logged warnings; all other places require `this.setState(x)`.
var _this=_possibleConstructorReturn(this,(ErrorHandler.__proto__||Object.getPrototypeOf(ErrorHandler)).call(this,props));_this.onClear=function(){_this.setState({error:null,errorInfo:null});};_this.report=function(){window.FreshWidget.show();return false;};_this.state={error:null,errorInfo:null};return _this;}_createClass(ErrorHandler,[{key:"componentDidCatch",value:function componentDidCatch(error,errorInfo){this.setState({error:error,errorInfo:errorInfo});console.error("ErrorHandler",{error:error,errorInfo:errorInfo});}},{key:"render",value:function render(){if(this.state&&this.state.error){var reportButton=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a,{primary:true,label:"report error",onClick:this.report});var clearButton=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a,{secondary:true,label:"clear error",onClick:this.onClear});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{background:"darkred",color:"white",padding:20,margin:0}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{title:"My face is as red as this screen."},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1",null,"It broke."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"Sorry about this. Please ",reportButton," and I'll have it fixed soon."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"You can also refresh the page, or ",clearButton)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("pre",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2",null,this.state.error.toString()),this.state.errorInfo&&this.state.errorInfo.componentStack),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,reportButton,clearButton));}return this.props.children;}}]);return ErrorHandler;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorHandler);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NavItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_comment__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__freshdesk_ticket_button_css__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__freshdesk_ticket_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__freshdesk_ticket_button_css__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var M=__WEBPACK_IMPORTED_MODULE_3__common__["k" /* intlMessages */]("view.NavLayout");function NavItem(props){var name=props.name,children=props.children,icon=props.icon,attrs=_objectWithoutProperties(props,["name","children","icon"]);var hidden=props.hidden||false;// no destructuring because flow is obnoxious
// Picky formatting here. <MenuItem disabled> breaks the fade-in, but
// <MenuItem style:hidden> shows the wrong cursor while hidden. Wrapper div
// gets both the cursor and fade-in right.
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{visibility:hidden?"hidden":""}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a,Object.assign({style:{opacity:hidden?0:1,transition:"opacity 500ms ease-in"},className:"navMenuItem",leftIcon:icon},attrs),children));}function FreshdeskTicketButtonRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["c" /* Error */],{inline:true,error:props});var debugProps=props.debugProps,isDebug=props.isDebug,freshdesk=props.freshdesk;// flag to disable this button
if(!freshdesk)return null;// loading, or in unit tests
if(!(window&&window.FreshWidget)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{title:"window.FreshWidget"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common__["e" /* LoadingSpinner */],null));}// This is all formatting specific to freshdesk. No point in moving it to core - not going to unittest it.
// Be careful, freshdesk fields evaluate HTML and have potential for XSS.
if(isDebug){debugProps.debug_xssTest="<script>alert(/ohno/)</script>";}// `val` is user data - escape to guard against XSS.
var debugText=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(debugProps,function(val,key){return"<li>"+key+": "+__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.escape(val);}).join("");var body="Enter your message here.<br><br><br><br>---<br>Debug information (don't touch):<br><ul>"+debugText+"</ul>";window.FreshWidget.init("",{// Prepopulate the body. https://support.freshdesk.com/support/articles/154064-pre-populating-feedback-widget-form
queryString:"&widgetType=popup&formTitle=Feedback+and+Bug+Reports&submitThanks=Thank+you!"+"&helpdesk_ticket[description]="+encodeURIComponent(body),loadOnEvent:"immediate",// everything below is copypasted from their create-a-widget form
// https://swarmsim.freshdesk.com/admin/widget_config
utf8:"✓",widgetType:"popup",buttonType:"text",buttonText:"Send feedback",buttonColor:"white",buttonBg:"#4A148C",alignment:"3",offset:"50px",submitThanks:"Thank you!",formHeight:"500px",url:"https://swarmsim.freshdesk.com"});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NavItem,{name:"contact",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_comment___default.a,null),onClick:window.FreshWidget.show},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"contact"}));}/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1__swarm2_core__["containers"].nav.FreshdeskTicketButton(FreshdeskTicketButtonRender));

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(37);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaComment = function FaComment(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40 20q0 3.9-2.7 7.2t-7.3 5.2-10 1.9q-1.6 0-3.2-0.2-4.5 3.9-10.3 5.4-1.1 0.3-2.6 0.5-0.3 0-0.6-0.2t-0.4-0.6v-0.1q-0.1-0.1 0-0.2t0-0.3 0.1-0.2l0.1-0.2 0.2-0.2 0.2-0.2q0.1-0.1 0.7-0.7t0.7-0.9 0.7-0.9 0.8-1.1 0.6-1.3 0.5-1.7q-3.5-2-5.5-4.9t-2-6.3q0-2.9 1.6-5.5t4.2-4.6 6.4-3.1 7.8-1.1q5.4 0 10 1.9t7.3 5.2 2.7 7.2z' })
        )
    );
};

exports.default = FaComment;
module.exports = exports['default'];

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* injectIntl */])(function(_React$Component){_inherits(DocumentTitle,_React$Component);function DocumentTitle(){_classCallCheck(this,DocumentTitle);return _possibleConstructorReturn(this,(DocumentTitle.__proto__||Object.getPrototypeOf(DocumentTitle)).apply(this,arguments));}_createClass(DocumentTitle,[{key:"componentWillMount",value:function componentWillMount(){document.title=this.props.intl.formatMessage({id:"view.document.title"});}},{key:"render",value:function render(){return null;}}]);return DocumentTitle;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component)));

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swarm2_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(161);
// sadly, ReactGA needs a global, not context
if(true){__WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.initialize(Object(__WEBPACK_IMPORTED_MODULE_1__swarm2_assert__["assert"])(__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["redux"].envConfig.googleAnalyticsId,"googleAnalyticsId",__WEBPACK_IMPORTED_MODULE_0__swarm2_core__["redux"].envConfig));}var ANALytics=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flowRight(// apparently my sense of humor hasn't changed since I was 12
__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"],__WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle___default()({componentWillMount:function componentWillMount(){this.props.history.listen(function(location){__WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.set({page:location.pathname});__WEBPACK_IMPORTED_MODULE_2_react_ga___default.a.pageview(location.pathname);});}}))(function(props){return null;});/* harmony default export */ __webpack_exports__["a"] = (ANALytics);

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(6);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(8);

var warning = __webpack_require__(2);
var canDefineProperty = __webpack_require__(7);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(17);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (process.env.NODE_ENV !== 'production') {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (process.env.NODE_ENV !== 'production') {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (process.env.NODE_ENV !== 'production') {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (process.env.NODE_ENV !== 'production') {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (process.env.NODE_ENV !== 'production') {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(8);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(2);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4),
    _assign = __webpack_require__(5);

var ReactNoopUpdateQueue = __webpack_require__(15);

var canDefineProperty = __webpack_require__(7);
var emptyObject = __webpack_require__(16);
var invariant = __webpack_require__(1);
var lowPriorityWarning = __webpack_require__(10);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (process.env.NODE_ENV !== 'production') {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(2);

function warnNoop(publicInstance, callerName) {
  if (process.env.NODE_ENV !== 'production') {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */



var ReactCurrentOwner = __webpack_require__(8);
var ReactComponentTreeHook = __webpack_require__(11);
var ReactElement = __webpack_require__(3);

var checkReactTypeSpec = __webpack_require__(36);

var canDefineProperty = __webpack_require__(7);
var getIteratorFn = __webpack_require__(18);
var warning = __webpack_require__(2);
var lowPriorityWarning = __webpack_require__(10);

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = ReactCurrentOwner.current.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

function getSourceInfoErrorAddendum(elementProps) {
  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
    var source = elementProps.__source;
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      info = ' Check the top-level render call using <' + parentName + '>.';
    }
  }
  return info;
}

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});

  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
  if (memoizer[currentComponentErrorInfo]) {
    return;
  }
  memoizer[currentComponentErrorInfo] = true;

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  var childOwner = '';
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
  }

  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (ReactElement.isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (ReactElement.isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    // Entry iterators provide implicit keys.
    if (iteratorFn) {
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;
        while (!(step = iterator.next()).done) {
          if (ReactElement.isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  if (componentClass.propTypes) {
    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
  }
  if (typeof componentClass.getDefaultProps === 'function') {
    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
  }
}

var ReactElementValidator = {
  createElement: function (type, props, children) {
    var validType = typeof type === 'string' || typeof type === 'function';
    // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.
    if (!validType) {
      if (typeof type !== 'function' && typeof type !== 'string') {
        var info = '';
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }

        var sourceInfo = getSourceInfoErrorAddendum(props);
        if (sourceInfo) {
          info += sourceInfo;
        } else {
          info += getDeclarationErrorAddendum();
        }

        info += ReactComponentTreeHook.getCurrentStackAddendum();

        var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
        ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
        ReactComponentTreeHook.popNonStandardWarningStack();
      }
    }

    var element = ReactElement.createElement.apply(this, arguments);

    // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.
    if (element == null) {
      return element;
    }

    // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)
    if (validType) {
      for (var i = 2; i < arguments.length; i++) {
        validateChildKeys(arguments[i], type);
      }
    }

    validatePropTypes(element);

    return element;
  },

  createFactory: function (type) {
    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
    // Legacy hook TODO: Warn if this is accessed
    validatedFactory.type = type;

    if (process.env.NODE_ENV !== 'production') {
      if (canDefineProperty) {
        Object.defineProperty(validatedFactory, 'type', {
          enumerable: false,
          get: function () {
            lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
            Object.defineProperty(this, 'type', {
              value: type
            });
            return type;
          }
        });
      }
    }

    return validatedFactory;
  },

  cloneElement: function (element, props, children) {
    var newElement = ReactElement.cloneElement.apply(this, arguments);
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], newElement.type);
    }
    validatePropTypes(newElement);
    return newElement;
  }
};

module.exports = ReactElementValidator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(12);
var checkPropTypes = __webpack_require__(41);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _format2 = __webpack_require__(22);

var _format3 = _interopRequireDefault(_format2);

var _removeLeadingSlash = __webpack_require__(25);

var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

var _trim = __webpack_require__(13);

var _trim2 = _interopRequireDefault(_trim);

var _loadGA = __webpack_require__(26);

var _loadGA2 = _interopRequireDefault(_loadGA);

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

var _log = __webpack_require__(27);

var _log2 = _interopRequireDefault(_log);

var _OutboundLink = __webpack_require__(28);

var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * React Google Analytics Module
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @package react-ga
                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
                                                                                                                                                                                                     */

/**
 * Utilities
 */


var _debug = false;
var _titleCase = true;

var _ga = function ga() {
  (0, _warn2.default)('ReactGA.initialize must be called first');
};

function _format(s) {
  return (0, _format3.default)(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];
  if (typeof _ga === 'function') {
    if (typeof command !== 'string') {
      (0, _warn2.default)('ga command must be a string');
      return;
    }

    _ga.apply(undefined, args);
    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        _ga.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    (0, _warn2.default)('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    _ga('create', gaTrackingID, options.gaOptions);
  } else {
    _ga('create', gaTrackingID, 'auto');
  }
}

var ReactGA = {
  initialize: function initialize(configs, options) {
    if (typeof window === 'undefined') {
      return false;
    }

    _ga = (0, _loadGA2.default)();

    if (Array.isArray(configs)) {
      configs.forEach(function (config) {
        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
          (0, _warn2.default)('All configs must be an object');
          return;
        }
        _initialize(config.trackingId, config);
      });
    } else {
      _initialize(configs, options);
    }
    return true;
  },

  /**
   * ga:
   * Returns the original GA object.
   */
  ga: function ga() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args.length > 0) {
      _ga.apply(undefined, args);
      if (_debug) {
        (0, _log2.default)('called ga(\'arguments\');');
        (0, _log2.default)('with arguments: ' + JSON.stringify(args));
      }
    }

    return _ga;
  },

  /**
   * set:
   * GA tracker set method
   * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  set: function set(fieldsObject, trackerNames) {
    if (!fieldsObject) {
      (0, _warn2.default)('`fieldsObject` is required in .set()');
      return;
    }

    if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
      (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
      return;
    }

    if (Object.keys(fieldsObject).length === 0) {
      (0, _warn2.default)('empty `fieldsObject` given to .set()');
    }

    _gaCommand(trackerNames, 'set', fieldsObject);

    if (_debug) {
      (0, _log2.default)('called ga(\'set\', fieldsObject);');
      (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
    }
  },

  /**
   * send:
   * Clone of the low level `ga.send` method
   * WARNING: No validations will be applied to this
   * @param  {Object} fieldObject - field object for tracking different analytics
   * @param  {Array} trackerNames - trackers to send the command to
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  send: function send(fieldObject, trackerNames) {
    _gaCommand(trackerNames, 'send', fieldObject);
    if (_debug) {
      (0, _log2.default)('called ga(\'send\', fieldObject);');
      (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
      (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
    }
  },

  /**
   * pageview:
   * Basic GA pageview tracking
   * @param  {String} path - the current page page e.g. '/about'
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  pageview: function pageview(rawPath, trackerNames) {
    if (!rawPath) {
      (0, _warn2.default)('path is required in .pageview()');
      return;
    }

    var path = (0, _trim2.default)(rawPath);
    if (path === '') {
      (0, _warn2.default)('path cannot be an empty string in .pageview()');
      return;
    }

    if (typeof _ga === 'function') {
      _gaCommand(trackerNames, 'send', 'pageview', path);

      if (_debug) {
        (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
        (0, _log2.default)('with path: ' + path);
      }
    }
  },

  /**
   * modalview:
   * a proxy to basic GA pageview tracking to consistently track
   * modal views that are an equivalent UX to a traditional pageview
   * @param  {String} modalName e.g. 'add-or-edit-club'
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  modalview: function modalview(rawModalName, trackerNames) {
    if (!rawModalName) {
      (0, _warn2.default)('modalName is required in .modalview(modalName)');
      return;
    }

    var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

    if (modalName === '') {
      (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
      return;
    }

    if (typeof _ga === 'function') {
      var path = '/modal/' + modalName;
      _gaCommand(trackerNames, 'send', 'pageview', path);

      if (_debug) {
        (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
        (0, _log2.default)('with path: ' + path);
      }
    }
  },

  /**
   * timing:
   * GA timing
   * @param args.category {String} required
   * @param args.variable {String} required
   * @param args.value  {Int}  required
   * @param args.label  {String} required
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  timing: function timing() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        category = _ref.category,
        variable = _ref.variable,
        value = _ref.value,
        label = _ref.label;

    var trackerNames = arguments[1];

    if (typeof _ga === 'function') {
      if (!category || !variable || !value || typeof value !== 'number') {
        (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
        return;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'timing',
        timingCategory: _format(category),
        timingVar: _format(variable),
        timingValue: value
      };

      if (label) {
        fieldObject.timingLabel = _format(label);
      }

      ReactGA.send(fieldObject, trackerNames);
    }
  },

  /**
   * event:
   * GA event tracking
   * @param args.category {String} required
   * @param args.action {String} required
   * @param args.label {String} optional
   * @param args.value {Int} optional
   * @param args.nonInteraction {boolean} optional
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  event: function event() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var trackerNames = arguments[1];

    var category = _ref2.category,
        action = _ref2.action,
        label = _ref2.label,
        value = _ref2.value,
        nonInteraction = _ref2.nonInteraction,
        transport = _ref2.transport,
        args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

    if (typeof _ga === 'function') {
      // Simple Validation
      if (!category || !action) {
        (0, _warn2.default)('args.category AND args.action are required in event()');
        return;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'event',
        eventCategory: _format(category),
        eventAction: _format(action)
      };

      // Optional Fields
      if (label) {
        fieldObject.eventLabel = _format(label);
      }

      if (typeof value !== 'undefined') {
        if (typeof value !== 'number') {
          (0, _warn2.default)('Expected `args.value` arg to be a Number.');
        } else {
          fieldObject.eventValue = value;
        }
      }

      if (typeof nonInteraction !== 'undefined') {
        if (typeof nonInteraction !== 'boolean') {
          (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
        } else {
          fieldObject.nonInteraction = nonInteraction;
        }
      }

      if (typeof transport !== 'undefined') {
        if (typeof transport !== 'string') {
          (0, _warn2.default)('`args.transport` must be a string.');
        } else {
          if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
            (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
          }

          fieldObject.transport = transport;
        }
      }

      Object.keys(args).filter(function (key) {
        return key.substr(0, 'dimension'.length) === 'dimension';
      }).forEach(function (key) {
        fieldObject[key] = args[key];
      });

      Object.keys(args).filter(function (key) {
        return key.substr(0, 'metric'.length) === 'metric';
      }).forEach(function (key) {
        fieldObject[key] = args[key];
      });

      // Send to GA
      ReactGA.send(fieldObject, trackerNames);
    }
  },

  /**
   * exception:
   * GA exception tracking
   * @param args.description {String} optional
   * @param args.fatal {boolean} optional
   * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
   */
  exception: function exception(_ref3, trackerNames) {
    var description = _ref3.description,
        fatal = _ref3.fatal;

    if (typeof _ga === 'function') {
      // Required Fields
      var fieldObject = {
        hitType: 'exception'
      };

      // Optional Fields
      if (description) {
        fieldObject.exDescription = _format(description);
      }

      if (typeof fatal !== 'undefined') {
        if (typeof fatal !== 'boolean') {
          (0, _warn2.default)('`args.fatal` must be a boolean.');
        } else {
          fieldObject.exFatal = fatal;
        }
      }

      // Send to GA
      ReactGA.send(fieldObject, trackerNames);
    }
  },

  plugin: {
    /**
     * require:
     * GA requires a plugin
     * @param name {String} e.g. 'ecommerce' or 'myplugin'
     * @param options {Object} optional e.g {path: '/log', debug: true}
     */
    require: function require(rawName, options) {
      if (typeof _ga === 'function') {
        // Required Fields
        if (!rawName) {
          (0, _warn2.default)('`name` is required in .require()');
          return;
        }

        var name = (0, _trim2.default)(rawName);
        if (name === '') {
          (0, _warn2.default)('`name` cannot be an empty string in .require()');
          return;
        }

        // Optional Fields
        if (options) {
          if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
            (0, _warn2.default)('Expected `options` arg to be an Object');
            return;
          }

          if (Object.keys(options).length === 0) {
            (0, _warn2.default)('Empty `options` given to .require()');
          }

          _ga('require', name, options);

          if (_debug) {
            (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
          }
        } else {
          _ga('require', name);

          if (_debug) {
            (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
          }
        }
      }
    },

    /**
     * execute:
     * GA execute action for plugin
     * Takes variable number of arguments
     * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
     * @param action {String} e.g. 'addItem' or 'myCustomAction'
     * @param actionType {String} optional e.g. 'detail'
     * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
     */
    execute: function execute(pluginName, action) {
      var payload = void 0;
      var actionType = void 0;

      if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
        payload = arguments.length <= 2 ? undefined : arguments[2];
      } else {
        actionType = arguments.length <= 2 ? undefined : arguments[2];
        payload = arguments.length <= 3 ? undefined : arguments[3];
      }

      if (typeof _ga === 'function') {
        if (typeof pluginName !== 'string') {
          (0, _warn2.default)('Expected `pluginName` arg to be a String.');
        } else if (typeof action !== 'string') {
          (0, _warn2.default)('Expected `action` arg to be a String.');
        } else {
          var command = pluginName + ':' + action;
          payload = payload || null;
          if (actionType && payload) {
            _ga(command, actionType, payload);
            if (_debug) {
              (0, _log2.default)('called ga(\'' + command + '\');');
              (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
            }
          } else if (payload) {
            _ga(command, payload);
            if (_debug) {
              (0, _log2.default)('called ga(\'' + command + '\');');
              (0, _log2.default)('with payload: ' + JSON.stringify(payload));
            }
          } else {
            _ga(command);
            if (_debug) {
              (0, _log2.default)('called ga(\'' + command + '\');');
            }
          }
        }
      }
    }
  },

  /**
   * outboundLink:
   * GA outboundLink tracking
   * @param args.label {String} e.g. url, or 'Create an Account'
   * @param {function} hitCallback - Called after processing a hit.
   */
  outboundLink: function outboundLink(args, hitCallback, trackerNames) {
    if (typeof hitCallback !== 'function') {
      (0, _warn2.default)('hitCallback function is required');
      return;
    }

    if (typeof _ga === 'function') {
      // Simple Validation
      if (!args || !args.label) {
        (0, _warn2.default)('args.label is required in outboundLink()');
        return;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'event',
        eventCategory: 'Outbound',
        eventAction: 'Click',
        eventLabel: _format(args.label)
      };

      var safetyCallbackCalled = false;
      var safetyCallback = function safetyCallback() {
        // This prevents a delayed response from GA
        // causing hitCallback from being fired twice
        safetyCallbackCalled = true;

        hitCallback();
      };

      // Using a timeout to ensure the execution of critical application code
      // in the case when the GA server might be down
      // or an ad blocker prevents sending the data

      // register safety net timeout:
      var t = setTimeout(safetyCallback, 250);

      var clearableCallbackForGA = function clearableCallbackForGA() {
        clearTimeout(t);
        if (!safetyCallbackCalled) {
          hitCallback();
        }
      };

      fieldObject.hitCallback = clearableCallbackForGA;

      // Send to GA
      ReactGA.send(fieldObject, trackerNames);
    } else {
      // if ga is not defined, return the callback so the application
      // continues to work as expected
      setTimeout(hitCallback, 0);
    }
  }
};

_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
_OutboundLink2.default.trackLink = ReactGA.outboundLink.bind(ReactGA);
ReactGA.OutboundLink = _OutboundLink2.default;

exports.default = ReactGA;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _mightBeEmail = __webpack_require__(23);

var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

var _toTitleCase = __webpack_require__(24);

var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if ((0, _mightBeEmail2.default)(s)) {
    (0, _warn2.default)('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return (0, _toTitleCase2.default)(s);
  }

  return s;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTitleCase;

var _trim = __webpack_require__(13);

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                * https://github.com/gouch/to-title-case
                                                                                                */

function toTitleCase(string) {
  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */

  return window.ga;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(29);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(46);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(5);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;

      var eventMeta = { label: eventLabel };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundLink, [{
    key: 'render',
    value: function render() {
      var props = (0, _objectAssign2.default)({}, this.props, {
        href: this.props.to,
        onClick: this.handleClick
      });
      delete props.eventLabel;
      return _react2.default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(_react.Component);

OutboundLink.propTypes = {
  eventLabel: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null
};

OutboundLink.trackLink = function () {
  (0, _warn2.default)('ga tracking not enabled');
};

exports.default = OutboundLink;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(30);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(5);

var ReactBaseClasses = __webpack_require__(14);
var ReactChildren = __webpack_require__(31);
var ReactDOMFactories = __webpack_require__(35);
var ReactElement = __webpack_require__(3);
var ReactPropTypes = __webpack_require__(39);
var ReactVersion = __webpack_require__(42);

var createReactClass = __webpack_require__(43);
var onlyChild = __webpack_require__(45);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (process.env.NODE_ENV !== 'production') {
  var lowPriorityWarning = __webpack_require__(10);
  var canDefineProperty = __webpack_require__(7);
  var ReactElementValidator = __webpack_require__(19);
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (process.env.NODE_ENV !== 'production') {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (process.env.NODE_ENV !== 'production') {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(32);
var ReactElement = __webpack_require__(3);

var emptyFunction = __webpack_require__(6);
var traverseAllChildren = __webpack_require__(33);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(4);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactCurrentOwner = __webpack_require__(8);
var REACT_ELEMENT_TYPE = __webpack_require__(17);

var getIteratorFn = __webpack_require__(18);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(34);
var warning = __webpack_require__(2);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (process.env.NODE_ENV !== 'production') {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (process.env.NODE_ENV !== 'production') {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(3);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (process.env.NODE_ENV !== 'production') {
  var ReactElementValidator = __webpack_require__(19);
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(4);

var ReactPropTypeLocationNames = __webpack_require__(37);
var ReactPropTypesSecret = __webpack_require__(38);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(2);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(11);
}

var loggedTypeFailures = {};

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?object} element The React element that is being type-checked
 * @param {?number} debugID The React component instance that is being type-checked
 * @private
 */
function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
  for (var typeSpecName in typeSpecs) {
    if (typeSpecs.hasOwnProperty(typeSpecName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
      } catch (ex) {
        error = ex;
      }
      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var componentStackInfo = '';

        if (process.env.NODE_ENV !== 'production') {
          if (!ReactComponentTreeHook) {
            ReactComponentTreeHook = __webpack_require__(11);
          }
          if (debugID !== null) {
            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
          } else if (element !== null) {
            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
          }
        }

        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
      }
    }
  }
}

module.exports = checkReactTypeSpec;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(3),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(40);

module.exports = factory(isValidElement);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(20);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(1);
  var warning = __webpack_require__(2);
  var ReactPropTypesSecret = __webpack_require__(12);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(14),
    Component = _require.Component;

var _require2 = __webpack_require__(3),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(15);
var factory = __webpack_require__(44);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(5);

var emptyObject = __webpack_require__(16);
var _invariant = __webpack_require__(1);

if (process.env.NODE_ENV !== 'production') {
  var warning = __webpack_require__(2);
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (process.env.NODE_ENV !== 'production') {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (process.env.NODE_ENV !== 'production') {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (process.env.NODE_ENV !== 'production') {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (process.env.NODE_ENV !== 'production') {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (process.env.NODE_ENV !== 'production') {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (process.env.NODE_ENV !== 'production') {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (process.env.NODE_ENV !== 'production') {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (process.env.NODE_ENV !== 'production') {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (process.env.NODE_ENV !== 'production') {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(4);

var ReactElement = __webpack_require__(3);

var invariant = __webpack_require__(1);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(20)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(47)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(1);
var ReactPropTypesSecret = __webpack_require__(12);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ })
/******/ ]);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OptionsView__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OptionsView__["a"]; });
/* unused harmony namespace reexport */


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Toggle = __webpack_require__(1027);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(10);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(7);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(6);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(17);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(49);

var _Paper2 = _interopRequireDefault(_Paper);

var _EnhancedSwitch = __webpack_require__(413);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var disabled = props.disabled,
      elementStyle = props.elementStyle,
      trackSwitchedStyle = props.trackSwitchedStyle,
      thumbSwitchedStyle = props.thumbSwitchedStyle,
      trackStyle = props.trackStyle,
      thumbStyle = props.thumbStyle,
      iconStyle = props.iconStyle,
      rippleStyle = props.rippleStyle,
      labelStyle = props.labelStyle;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toggle = _context$muiTheme.toggle;


  var toggleSize = 20;
  var toggleTrackWidth = 36;
  var styles = {
    icon: {
      width: 36,
      padding: '4px 0px 6px 2px'
    },
    ripple: {
      top: -10,
      left: -10,
      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
    },
    toggleElement: {
      width: toggleTrackWidth
    },
    track: {
      transition: _transitions2.default.easeOut(),
      width: '100%',
      height: 14,
      borderRadius: 30,
      backgroundColor: toggle.trackOffColor
    },
    thumb: {
      transition: _transitions2.default.easeOut(),
      position: 'absolute',
      top: 1,
      left: 0,
      width: toggleSize,
      height: toggleSize,
      lineHeight: '24px',
      borderRadius: '50%',
      backgroundColor: toggle.thumbOffColor
    },
    trackWhenSwitched: {
      backgroundColor: toggle.trackOnColor
    },
    thumbWhenSwitched: {
      backgroundColor: toggle.thumbOnColor,
      left: '100%'
    },
    trackWhenDisabled: {
      backgroundColor: toggle.trackDisabledColor
    },
    thumbWhenDisabled: {
      backgroundColor: toggle.thumbDisabledColor
    },
    label: {
      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
    }
  };

  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);

  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);

  if (state.switched) {
    styles.thumb.marginLeft = 0 - styles.thumb.width;
  }

  (0, _simpleAssign2.default)(styles.icon, iconStyle);

  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

  (0, _simpleAssign2.default)(styles.label, labelStyle);

  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);

  return styles;
}

var Toggle = function (_Component) {
  (0, _inherits3.default)(Toggle, _Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switched: false
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({
        switched: newSwitched
      });
    }, _this.handleToggle = function (event, isInputChecked) {
      if (_this.props.onToggle) {
        _this.props.onToggle(event, isInputChecked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Toggle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          toggled = _props.toggled,
          defaultToggled = _props.defaultToggled,
          valueLink = _props.valueLink;


      if (toggled || defaultToggled || valueLink && valueLink.value) {
        this.setState({
          switched: true
        });
      }
    }
  }, {
    key: 'isToggled',
    value: function isToggled() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setToggled',
    value: function setToggled(newToggledValue) {
      this.refs.enhancedSwitch.setSwitched(newToggledValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          defaultToggled = _props2.defaultToggled,
          elementStyle = _props2.elementStyle,
          onToggle = _props2.onToggle,
          trackSwitchedStyle = _props2.trackSwitchedStyle,
          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
          toggled = _props2.toggled,
          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var toggleElement = _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
      );

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switchElement: toggleElement,
        rippleStyle: styles.ripple,
        rippleColor: styles.ripple.color,
        iconStyle: styles.icon,
        trackStyle: styles.track,
        thumbStyle: styles.thumb,
        labelStyle: styles.label,
        switched: this.state.switched,
        onSwitch: this.handleToggle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      if (this.props.hasOwnProperty('toggled')) {
        enhancedSwitchProps.checked = toggled;
      } else if (this.props.hasOwnProperty('defaultToggled')) {
        enhancedSwitchProps.defaultChecked = defaultToggled;
      }

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
    }
  }]);
  return Toggle;
}(_react.Component);

Toggle.defaultProps = {
  defaultToggled: false,
  disabled: false,
  labelPosition: 'left'
};
Toggle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Toggle.propTypes =  false ? {
  /**
   * Determines whether the Toggle is initially turned on.
   * **Warning:** This cannot be used in conjunction with `toggled`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultToggled: _propTypes2.default.bool,
  /**
   * Will disable the toggle if true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides the inline-styles of the Toggle element.
   */
  elementStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the Icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * Label for toggle.
   */
  label: _propTypes2.default.node,
  /**
   * Where the label will be placed next to the toggle.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Toggle element label.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function that is fired when the toggle switch is toggled.
   *
   * @param {object} event Change event targeting the toggle.
   * @param {bool} isInputChecked The new value of the toggle.
   */
  onToggle: _propTypes2.default.func,
  /**
   * Override style of ripple.
   */
  rippleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override style for thumb.
   */
  thumbStyle: _propTypes2.default.object,
  /**
  * Override the inline styles for thumb when the toggle switch is toggled on.
  */
  thumbSwitchedStyle: _propTypes2.default.object,
  /**
   * Toggled if set to true.
   */
  toggled: _propTypes2.default.bool,
  /**
   * Override style for track.
   */
  trackStyle: _propTypes2.default.object,
  /**
  * Override the inline styles for track when the toggle switch is toggled on.
  */
  trackSwitchedStyle: _propTypes2.default.object,
  /**
   * ValueLink prop for when using controlled toggle.
   */
  valueLink: _propTypes2.default.object
} : {};
exports.default = Toggle;

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RankingsRouter__ = __webpack_require__(1029);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RankingsRouter__["a"]; });


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RankingsList__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Rankings__ = __webpack_require__(1031);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var match=props.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:match.path,component:__WEBPACK_IMPORTED_MODULE_3__RankingsList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/:league/:rankName",component:__WEBPACK_IMPORTED_MODULE_4__Rankings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/:league/:rankName/:page",component:__WEBPACK_IMPORTED_MODULE_4__Rankings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2__common__["f" /* NotFoundView */]}));});

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RankingsListRender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(15);
var RM=__WEBPACK_IMPORTED_MODULE_5__common__["k" /* intlMessages */]("rankings");function RankingsListRender(_ref){var rankNames=_ref.rankNames;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:"Rankings"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["List"],null,rankNames.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["ListItem"],{key:name,primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RM,{id:name}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/rankings/standard/"+name})});})));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].rankings.RankingsList(__WEBPACK_IMPORTED_MODULE_5__common__["a" /* DumpProps */](RankingsListRender)));

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RankingsItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swarm2_core__);
var M=__WEBPACK_IMPORTED_MODULE_4__common__["k" /* intlMessages */]("view.Rankings");var RM=__WEBPACK_IMPORTED_MODULE_4__common__["k" /* intlMessages */]("rankings");function RankingsItemRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* Error */],{inline:true,error:props});var charId=props.charId,displayName=props.displayName,rank=props.rank,value=props.value,displayValue=props.displayValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["ListItem"],{containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/c/"+charId}),primaryText:rank+") "+displayName,secondaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{color:"inherit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["g" /* Num */],{val:displayValue!=null?displayValue:value}))});}var RankingsItem=__WEBPACK_IMPORTED_MODULE_5__swarm2_core__["containers"].rankings.RankingsItem(RankingsItemRender);function RankingsBody(props){var list=props.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_List__["List"],null,list.map(function(ranking,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RankingsItem,Object.assign({key:ranking.charId,rank:index+1},ranking));}));}function RankingsRender(props){// Don't quit here if pending - show the title bar while loading, cuz it's pretty.
if(props.isEmpty)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* Error */],{error:props});var rankName=props.rankName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(M,{id:"title",values:{rankName:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RM,{id:rankName})}})}))),props.isError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* Error */],{error:props}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RankingsBody,props));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__swarm2_core__["containers"].rankings.Rankings(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* DumpProps */](RankingsRender)));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthRouter__ = __webpack_require__(1033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthEmailActionRedirect__ = __webpack_require__(1038);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AuthEmailActionRedirect__["a"]; });


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AuthRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegisterView__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoginView__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResetPasswordView__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmResetPasswordView__ = __webpack_require__(1037);
// 'Registration' requires an anonymous account with a beta key. Unlike lots of
// other account systems, it's not the first step - you must start playing
// anonymously; step 2 is registration, connect an email to the anon account.
//
// Other pages here are unauthed.
var RegisterView=__WEBPACK_IMPORTED_MODULE_2__common__["m" /* withAllowed */](__WEBPACK_IMPORTED_MODULE_3__RegisterView__["a" /* default */]);function AuthRouter(_ref){var match=_ref.match;//  <Route exact path={match.path} component={RankingsList} />
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/register",component:RegisterView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/login",component:__WEBPACK_IMPORTED_MODULE_4__LoginView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/forgot",component:__WEBPACK_IMPORTED_MODULE_5__ResetPasswordView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/reset/:oobCode",component:__WEBPACK_IMPORTED_MODULE_6__ConfirmResetPasswordView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2__common__["f" /* NotFoundView */]}));}

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_verified_user__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_verified_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_verified_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Error__ = __webpack_require__(116);
var M=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.RegisterView");var EM=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.RegisterView.error");var Error=Object(__WEBPACK_IMPORTED_MODULE_10__Error__["a" /* default */])(EM);function RegisterRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});var input=props.input,formErrors=props.formErrors;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("form",{onSubmit:props.isSubmitAllowed?props.submit:function(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"description"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a,{name:"email",floatingLabelText:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"field.email"}),value:props.email,onChange:input.setEmail})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a,{name:"password",floatingLabelText:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"field.password"}),type:"password",value:props.password,onChange:input.setPassword})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a,{name:"password2",floatingLabelText:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"field.password2"}),type:"password",value:props.password2,onChange:input.setPassword2})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a,{name:"errors",underlineShow:false,disabled:true,errorText:(formErrors||[]).map(function(error,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Error,{key:i,error:error});})}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_verified_user___default.a,null),disabled:!props.isSubmitAllowed,onClick:props.submit})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{style:{color:"inherit"},to:"/privacy"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"privacy"})))," "),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,props.request.state==="SUCCESS"?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"success"}):null)));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].authSignin.Register(),__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].willReceiveProps(function(props){if(props.request.state==="SUCCESS"){props.history.push("/");}// done loading, account doesn't exist (visit /start for an anon account first) OR account has an email/already registered
if(props.auth!==undefined&&(!props.auth||props.auth.email)){props.history.replace("/");}}),__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */])(RegisterRender));

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_account_circle__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_account_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_account_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Error__ = __webpack_require__(116);
var M=__WEBPACK_IMPORTED_MODULE_10__common__["k" /* intlMessages */]("view.LoginView");var EM=__WEBPACK_IMPORTED_MODULE_10__common__["k" /* intlMessages */]("view.LoginView.error");var Error=Object(__WEBPACK_IMPORTED_MODULE_11__Error__["a" /* default */])(EM);function LoginRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common__["c" /* Error */],{error:props});var input=props.input,formErrors=props.formErrors;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("form",{onSubmit:props.isSubmitAllowed?props.submit:function(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"description"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a,{name:"email",floatingLabelText:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"field.email"}),value:props.email,onChange:input.setEmail})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a,{name:"password",floatingLabelText:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"field.password"}),type:"password",value:props.password,onChange:input.setPassword})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a,{name:"errors",underlineShow:false,disabled:true,errorText:formErrors.map(function(error,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Error,{key:i,error:error});})})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_account_circle___default.a,null),disabled:!props.isSubmitAllowed,onClick:props.submit}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:"/auth/forgot"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a,{secondary:true,label:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"forgot"}),icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline___default.a,null)}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{style:{color:"inherit"},to:"/privacy"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"privacy"})))," "),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,props.request.state==="SUCCESS"?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(M,{id:"success"}):null)));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.flowRight(__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].authSignin.Login(),__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_4__swarm2_core__["containers"].willReceiveProps(function(props){if(props.request.state==="SUCCESS"){props.history.push("/");}if(props.auth&&props.isAllowed){props.history.replace("/");}}),__WEBPACK_IMPORTED_MODULE_10__common__["a" /* DumpProps */])(LoginRender));

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Error__ = __webpack_require__(116);
var M=__WEBPACK_IMPORTED_MODULE_7__common__["k" /* intlMessages */]("view.ResetPasswordView");var EM=__WEBPACK_IMPORTED_MODULE_7__common__["k" /* intlMessages */]("view.ResetPasswordView.error");var Error=Object(__WEBPACK_IMPORTED_MODULE_8__Error__["a" /* default */])(EM);function ResetPasswordRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common__["c" /* Error */],{error:props});var input=props.input,formErrors=props.formErrors;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("form",{onSubmit:props.isSubmitAllowed?props.submit:function(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"description"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a,{name:"email",floatingLabelText:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"field.email"}),value:props.email,onChange:input.setEmail})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a,{name:"errors",underlineShow:false,disabled:true,errorText:formErrors.map(function(error,i){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Error,{key:i,error:error});})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_help_outline___default.a,null),disabled:!props.isSubmitAllowed,onClick:props.submit})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,props.request.state==="SUCCESS"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"success"}):null)));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].authSignin.ResetPassword()(__WEBPACK_IMPORTED_MODULE_7__common__["a" /* DumpProps */](ResetPasswordRender)));

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_help_outline__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_help_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_help_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Error__ = __webpack_require__(116);
var M=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.ConfirmResetPasswordView");var EM=__WEBPACK_IMPORTED_MODULE_9__common__["k" /* intlMessages */]("view.ConfirmResetPasswordView.error");var Error=Object(__WEBPACK_IMPORTED_MODULE_10__Error__["a" /* default */])(EM);function ConfirmResetPasswordRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common__["c" /* Error */],{error:props});var input=props.input,formErrors=props.formErrors;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("form",{onSubmit:props.isSubmitAllowed?props.submit:function(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"description"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a,{name:"password",floatingLabelText:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"field.password"}),type:"password",value:props.password,onChange:input.setPassword})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a,{name:"password2",floatingLabelText:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"field.password2"}),type:"password",value:props.password2,onChange:input.setPassword2})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a,{name:"errors",underlineShow:false,disabled:true,errorText:formErrors.map(function(error,i){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Error,{key:i,error:error});})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_help_outline___default.a,null),disabled:!props.isSubmitAllowed,onClick:props.submit})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,props.request.state==="SUCCESS"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"success"}):null)));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.flowRight(__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].authSignin.ConfirmResetPassword(),__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["g" /* withRouter */],__WEBPACK_IMPORTED_MODULE_2__swarm2_core__["containers"].willReceiveProps(function(props){if(props.request.state==="SUCCESS"){props.history.push("/auth/login");}}),__WEBPACK_IMPORTED_MODULE_9__common__["a" /* DumpProps */])(ConfirmResetPasswordRender));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function(_ref){var location=_ref.location,history=_ref.history;var query=__WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search);switch(query.mode){case"resetPassword":history.replace("/auth/reset/"+query.oobCode);break;default:break;}return null;})(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* NotFoundView */]));

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BetaRouter__ = __webpack_require__(1040);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BetaRouter__["a"]; });


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BetaRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BetaKeyApplyView__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BetaKeyCreateView__ = __webpack_require__(1043);
function BetaRouter(props){var match=props.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/create",component:__WEBPACK_IMPORTED_MODULE_4__BetaKeyCreateView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:match.path+"/join/:betaKey",component:__WEBPACK_IMPORTED_MODULE_3__BetaKeyApplyView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2__common__["f" /* NotFoundView */]}));}

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_communication_vpn_key__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_communication_vpn_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_communication_vpn_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_signin_Error__ = __webpack_require__(116);
var M=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("view.BetaKeyApplyView");var EM=__WEBPACK_IMPORTED_MODULE_6__common__["k" /* intlMessages */]("view.BetaKeyApplyView.error");var Error=Object(__WEBPACK_IMPORTED_MODULE_9__auth_signin_Error__["a" /* default */])(EM);function BetaKeyApplyRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});var isSubmitAllowed=props.isSubmitAllowed,onSubmit=props.onSubmit,formErrors=props.formErrors,request=props.request,userId=props.userId,betaKey=props.betaKey;if(request.status==="success"){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{to:"/auth/register"});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"description",values:{userId:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("code",null,userId),betaKey:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("code",null,betaKey)}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default.a,{name:"errors",underlineShow:false,disabled:true,errorText:request.status==="pending"?null:formErrors.map(function(error,i){return(// quick hack - redirect to success when done
error==="alreadyaccess"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{key:i,to:"/auth/register"}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{key:i},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Error,{error:error})));})})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(M,{id:"submit"}),type:"submit",icon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_communication_vpn_key___default.a,null),disabled:!isSubmitAllowed,onClick:onSubmit})),request.status==="pending"?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["e" /* LoadingSpinner */],null)):null));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7__swarm2_core__["containers"].beta.BetaKeyApply(BetaKeyApplyRender));

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationVpnKey = function CommunicationVpnKey(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
CommunicationVpnKey.displayName = 'CommunicationVpnKey';
CommunicationVpnKey.muiName = 'SvgIcon';

exports.default = CommunicationVpnKey;

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swarm2_core__);
var M=function M(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],Object.assign({},props,{id:"view.BetaKeyCreateView."+props.id}));};// To grant access to this page: /userRoles/betaKeys/$userId
//
// To bootstrap a new environment with no accounts:
// * Visit /beta/join/x. Invalid key, but it'll create an anonymous account.
//   (/start is blocked during beta.) Tells you the account id too, no need to
//   dig into cookies.)
// * Firebase console > create: key: /userRoles/betaKeys/$userId , value: true
// * visit /beta/create, create a beta key, use it on self
function BetaKeyCreateRender(props){if(props.isError)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* Error */],{error:props});var count=props.count,input=props.input,isSubmitAllowed=props.isSubmitAllowed,onSubmit=props.onSubmit,formErrors=props.formErrors,betaKeys=props.betaKeys;//const keyUrls = betaKeys.map(key => location.host + )
var keyUrls=betaKeys.map(function(key){return window.location.origin+"/#/beta/join/"+key;});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("form",{onSubmit:isSubmitAllowed?onSubmit:undefined},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a,{name:"count",type:"number",value:count,onChange:input.setCount})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{primary:true,disabled:!isSubmitAllowed,label:"Create "+count,onClick:onSubmit})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,formErrors.map(function(error){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("pre",{key:error},JSON.stringify(error));})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,keyUrls.map(function(url){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{key:url},url);})))));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7__swarm2_core__["containers"].beta.BetaKeyCreate(BetaKeyCreateRender));

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VersionRender */
/* unused harmony export TitleRender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__swarm2_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__swarm2_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_account_circle__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_account_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_account_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_power_settings_new__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_power_settings_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_power_settings_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_verified_user__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_verified_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_verified_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common__ = __webpack_require__(15);
var M=__WEBPACK_IMPORTED_MODULE_10__common__["k" /* intlMessages */]("view.TitleView");function VersionRender(_ref){var clientVersion=_ref.clientVersion,serverVersion=_ref.serverVersion;return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("small",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("a",{style:{color:"inherit"},target:"_blank",rel:"noopener noreferrer",href:"https://news.warswarms.com/tags/changelog"},!serverVersion?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"version",values:{version:clientVersion+"..."}}):clientVersion===serverVersion?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"version",values:{version:clientVersion}}):__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"versions",values:{clientVersion:clientVersion,serverVersion:serverVersion}})));}function TitleRender(props){var userExists=props.userExists,isAllowed=props.isAllowed,displayName=props.displayName,isAnonymous=props.isAnonymous,onPlayAuthed=props.onPlayAuthed,onPlayUnauthed=props.onPlayUnauthed,onLogout=props.onLogout,clientVersion=props.clientVersion,serverVersion=props.serverVersion;// No error-check here - check for field presence instead. Title is tricky; we
// want the opening screen to load fast, and the usual error-check is too
// coarse for that.
var pending=props.isPending?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common__["e" /* LoadingSpinner */],{title:"Pending: "+JSON.stringify(props.pendingKeys)})):null;return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Toolbar__["ToolbarTitle"],{text:pending?pending:isAllowed&&userExists?// isAllowed && !userExists is theoretically possible while
// loading, before a user's created, but normally this'll be
// created while applying their beta key.
__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"welcomeback",values:{displayName:displayName}}):__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"welcome"})}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("b",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"betawarn"}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("hr",null),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"desc1"})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"desc2"})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"desc3"}))),pending?pending:// Signed in, has a beta-key, and already email-connected
isAllowed&&!isAnonymous?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/start"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"authed.play"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow___default.a,null),onClick:onPlayAuthed})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{secondary:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"authed.logout"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_power_settings_new___default.a,null),onClick:onLogout}))):// Anonymous user; no email connected, but has a beta key
isAllowed?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/start"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{primary:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"authed.play"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow___default.a,null),onClick:onPlayAuthed})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/auth/register"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{secondary:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"authed.register"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_verified_user___default.a,null)}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"authed.register.help"})))):// suckers without beta keys
__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardActions"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{primary:true,disabled:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"unauthed.play"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_av_play_arrow___default.a,null),onClick:onPlayUnauthed}),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/auth/login"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a,{secondary:true,label:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"unauthed.login"}),icon:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_account_circle___default.a,null)}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"betadesc",values:{link:__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("a",{target:"_blank",rel:"noopener noreferrer",href:"https://www.reddit.com/r/warswarms"},"/r/warswarms")}})))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("small",null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{style:{color:"inherit"},to:"/privacy"},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](M,{id:"privacy"})))," ","| ",__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](VersionRender,{clientVersion:clientVersion,serverVersion:serverVersion})));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__swarm2_core__["containers"].authSignin.Title(__WEBPACK_IMPORTED_MODULE_10__common__["a" /* DumpProps */](TitleRender)));

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPowerSettingsNew = function ActionPowerSettingsNew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
  );
};
ActionPowerSettingsNew = (0, _pure2.default)(ActionPowerSettingsNew);
ActionPowerSettingsNew.displayName = 'ActionPowerSettingsNew';
ActionPowerSettingsNew.muiName = 'SvgIcon';

exports.default = ActionPowerSettingsNew;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(24);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(25);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayArrow = function AvPlayArrow(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
  );
};
AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
AvPlayArrow.displayName = 'AvPlayArrow';
AvPlayArrow.muiName = 'SvgIcon';

exports.default = AvPlayArrow;

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrivacyView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__);
var M=__WEBPACK_IMPORTED_MODULE_1__common__["k" /* intlMessages */]("view.Privacy");function PrivacyView(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("article",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_Toolbar__["ToolbarTitle"],{text:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](M,{id:"title"})}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_Card__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"We collect your email address during registration. We'll send you mail only when you ask us to recover a lost password. We share your email address only with the"," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://firebase.google.com/docs/auth/",target:"_blank",rel:"noopener noreferrer"},"Firebase Authentication service")," ","to register and sign in to your account; no other third-parties."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"We collect your password during registration. Please don't reuse a password you've used for any other websites/apps/games. (",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://www.lastpass.com/",target:"_blank",rel:"noopener noreferrer"},"Lastpass")," ","is a good way to avoid reusing passwords.)"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"You can play without sharing your email address with us! Feel free to do that, or to use a fake email like"," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://www.spamgourmet.com/",target:"_blank",rel:"noopener noreferrer"},"Spamgourmet"),", or to ask us to delete your email/password from our records."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"We store cookies to remember which account and characters you're playing when you visit our site. Click \"log out\" on the title screen to remove these cookies."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"We use"," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://www.google.com/analytics/",target:"_blank",rel:"noopener noreferrer"},"Google Analytics")," ","to collect information about actions you take on our website, like links you've clicked, in order to improve gameplay. Feel free to"," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://tools.google.com/dlpage/gaoptout",target:"_blank",rel:"noopener noreferrer"},"opt out of Google Analytics")," ","for War Swarms and for all other websites."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"We use Google's"," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"https://firebase.google.com/",target:"_blank",rel:"noopener noreferrer"},"Firebase")," ","to store your saved progress and to run gameplay processes."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a",{href:"http://www.google.com/policies/privacy/partners/",target:"_blank",rel:"noopener noreferrer"},"How Google uses data when you use our partners' sites or apps")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"I'm generally happy to talk through any privacy issues you might have. Feel free to reach out."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"War Swarms is not a wealthy target. Please don't sue."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,"Thanks for reading!"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("small",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("time",{dateTime:"2017-09-29",itemProp:"datePublished"},"2017-09-29"))));}

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Normally, react-intl likes json files as input. I like having newlines for
// long strings, comments, and the occasional variable substitution; and these
// don't really mix. If we need JSON later, like for lazy-loading translation
// files, we'll change this thing to output it.
//
// Translators: I edit this file in a text editor. If you have a better program
// for translating text, but it requires a different file format (.po file?
// .json file? Google doc?), talk to me - maybe I can help.
var m={};/* harmony default export */ __webpack_exports__["a"] = (m);var name="War Swarms";m["view.document.title"]=name;m["view.NavLayout.title"]=name;m["view.NavLayout.debug"]="Debug";m["view.NavLayout.meat"]="Meat";m["view.NavLayout.combat"]="Combat";m["view.NavLayout.mutations"]="Mutations";m["view.NavLayout.achievements"]="Achievements";m["view.NavLayout.options"]="Settings";m["view.NavLayout.characters"]="Characters";m["view.NavLayout.statistics"]="Statistics";m["view.NavLayout.rankings"]="Rankings";m["view.NavLayout.contact"]="Send Feedback";m["view.Options.title"]="Settings";m["view.Options.github.rss"]="RSS feed";m["view.Options.ClearSave.button"]="Erase saved progress";m["view.Options.NumberFormatChooser.title"]="Number Format";m["view.Options.NumberFormatChooser.standard"]="Standard";m["view.Options.NumberFormatChooser.engineering"]="Engineering";m["view.Options.NumberFormatChooser.scientific"]="Scientific";m["view.Options.NumberFormatChooser.hybrid"]="Hybrid";m["view.Options.NumberFormatChooser.longScale"]="Long scale";m["view.Options.NumberFormatChooser.examples"]="Examples: {ex1}, {ex2}, {ex3}";m["view.Options.IsDebug.title"]="Show debugging information";m["view.Options.PrereleaseFlags.title"]="Enable secret prerelease features";m["view.Privacy.title"]="War Swarms and Your Privacy";m["view.UserView.pleaseregister"]="Register this account";m["view.UserView.characterlist"]="Character list";m["view.UserView.login"]="Login to another account";m["view.UserView.createcharacter"]="create character";m["view.UserView.unnameduser"]="Unnamed player";m["view.UserView.publicprofile"]="Your public profile";m["view.UserView.mycharacters"]="Your characters";m["view.UserView.characters"]="Character list";m["view.UserView.created"]="{username} started playing {ago}.";m["view.CharacterRouter.notyours"]="You can't play this character. {link}";m["view.CharacterRouter.notyours.link"]="View this character instead.";m["view.CharacterView.owner"]="Owner: {name}";m["view.CharacterView.created"]="Created: {time}";m["view.CharacterView.units"]="Meat";m["view.CharacterView.combat"]="Combat";m["view.CharacterView.achievements"]="Achievements";m["view.CharacterView.statistics"]="Statistics";m["view.CharacterView.stuckactions"]="{num} stuck actions. This bug may be causing your gameplay to lag.";m["view.CharacterList.title"]="{displayName}'s characters";m["view.CharacterList.since"]="Played {since}";m["view.CharacterList.noauth.nocharacters"]="{displayName} has no characters.";m["view.CharacterList.auth.nocharacters"]="To create your first character, press {icon} above.";m["leagues.standard"]="Standard league";m["leagues.overlord"]="Overlord league";m["leagues.prerelease"]="Prerelease league";m["view.NewCharacter.title"]="Create a new character";m["view.NewCharacter.field.displayName"]="Name";m["view.NewCharacter.field.league.standard.description"]="Play using the normal War Swarms rules. More leagues with different rules are coming soon.";m["view.NewCharacter.field.league.overlord.description"]="The first War Swarms temporary league.";m["view.NewCharacter.field.league.overlord.bullet1"]="Conquer zones 6 to 9.";m["view.NewCharacter.field.league.overlord.bullet2"]="Unlock the new Overlord unit, increasing the power of your other soldiers.";m["view.NewCharacter.field.league.templeagues.description"]="Once this temporary league ends, your swarm will be playable in standard league.";m["view.NewCharacter.field.league.prerelease.description"]="Play using the War Swarms rules used in the next release. Beta-test quality. Secret. Voided after the next release.";m["view.NewCharacter.field.league.comingsoon"]="New leagues coming soon";m["view.NewCharacter.field.league.countdown"]="This league begins in {countdown}.";m["view.NewCharacter.submit"]="Create character";m["view.NewCharacter.error.isCharLimit"]="Too many characters!";m["view.UnitsList.title"]="{displayName}'s units";m["view.UnitsList.velocity"]="+{value}/sec";m["units.larva.plural"]="{count, plural, one{larva} other{larvae}}";m["units.larva.description"]="Expansions now come from combat too.";m["units.larva.description.lol"]="So much violence.";m["units.hatchery.plural"]="{count, plural, one{hatchery} other{hatcheries}}";m["units.hatchery.description"]="You can't build hatcheries anymore! They come from combat now.";m["units.hatchery.description.lol"]="Also, they're a real unit now, not an abomination of an upgrade";m["units.meat.plural"]="meat";m["units.meat.description"]="Aw man, I have to rewrite all these descriptions?";m["units.meat.description.lol"]="And all these tooltips?";m["units.drone.plural"]="{count, plural, one{drone} other{drones}}";m["units.drone.description"]="It'd be awfully lazy to reuse descriptions from the first game.";m["units.drone.description.lol"]="That's not necessarily bad. I am nothing if not lazy.";m["units.queen.plural"]="{count, plural, one{queen} other{queens}}";m["units.queen.description"]="We don't have to write them right now, though. Let's put it off a while longer.";m["units.queen.description.lol"]="Procrastination wins again!";m["units.nest.plural"]="{count, plural, one{nest} other{nests}}";m["units.nest.description"]="Maybe later I'll be in the mood to write new unit descriptions.";m["units.nest.description.lol"]="Or maybe I'll just copy them all from swarm1 in the end anyway. We'll see.";m["units.swarmling-queen.plural"]="{count, plural, one{swarmling queen} other{swarmling queens}}";m["units.swarmling-queen.description"]="Spawn 2 swarmlings per second during combat. "+"This is a temporary unit. It'll be replaced later in the beta, once "+"combat's fleshed out a bit more. Don't get too attached.";m["units.tower.plural"]="{count, plural, one{tower} other{towers}}";m["units.tower.description"]="Defensive combat structures.";m["units.overlord-den.plural"]="{count, plural, one{overlord den} other{overlord dens}}";m["units.overlord-den.description"]="Spawn 1 overlord every 3 seconds during combat. "+"Overlords increase the attack power of all other troops.";m["soldiers.swarmling-queen"]=m["units.swarmling-queen.plural"];m["soldiers.swarmling"]="{count, plural, one{swarmling} other{swarmlings}}";m["soldiers.tower"]="{count, plural, one{tower} other{towers}}";m["soldiers.overlord-den"]=m["units.overlord-den.plural"];m["soldiers.overlord"]="{count, plural, one{overlord} other{overlords}}";m["soldiers.lair"]="{count, plural, one{lair} other{lairs}}";m["view.Achievements.title"]="{displayName}'s achievements";m["view.Achievements.status.pending"]="No completion date recorded";m["view.Achievements.hidden"]="???";m["view.AchievementsToast.title"]="Achievement unlocked: {displayName}";m["achievements.named"]="All the good names were taken";// This is "Build 1 drone". {units_drone_bought} is the number of drones required, and m[units.drone.plural] pluralizes based on that.
m["achievements.named.desc"]="Name this character. Different characters may have the same name.";m["achievements.drone1"]="It begins";// This is "Build 1 drone". {units_drone_bought} is the number of drones required, and m[units.drone.plural] pluralizes based on that.
m["achievements.drone1.desc"]="Build {units_bought_drone_text} "+m["units.drone.plural"].replace("count","units_bought_drone_count");m["achievements.drone2"]="Supply limit exceeded";m["achievements.drone2.desc"]=m["achievements.drone1.desc"];m["achievements.drone3"]="Banned near airports";m["achievements.drone3.desc"]=m["achievements.drone1.desc"];m["achievements.hatchery1"]="Hatch Hatch Infinity";m["achievements.hatchery1.desc"]="Loot {units_looted_hatchery_text} "+m["units.hatchery.plural"].replace("count","units_looted_hatchery_count");m["achievements.hatchery2"]="Path of Eggsire";m["achievements.hatchery2.desc"]=m["achievements.hatchery1.desc"];m["achievements.hatchery3"]="AdVenture Hatchitallist";m["achievements.hatchery3.desc"]=m["achievements.hatchery1.desc"];m["achievements.zones1"]="First blood";m["achievements.zones1.desc"]="Clear {zones_cleared_text} {zones_cleared_count, plural, one{zone} other{zones}}";m["achievements.zones2"]="Better than beta";m["achievements.zones2.desc"]=m["achievements.zones1.desc"];m["view.UnitView.title"]="{charName}'s {unitName}";m["view.UnitView.resource.list"]="{length, plural, zero{nothing} one{{first}} =2{{first} and {last}} other{{head} and {last}}}";m["view.UnitView.resource.listitem"]="{item}, ";m["view.UnitView.resource.item"]="{count} {unittype}";m["view.UnitView.BuyN.help.title"]="Purchasing Units";m["view.UnitView.BuyN.help0"]='"10%" buys 10% of the maximum you can afford.';m["view.UnitView.BuyN.help1"]='"=1000" buys exactly 1,000 after accounting for twins, rounded up.';m["view.UnitView.BuyN.help2"]='"@1000" buys the number needed to have at least 1,000 after the purchase. If you already have 200, this will buy at least 800.';m["view.UnitView.BuyN.help3"]='Numbers with suffixes or commas will work: "23 billion", "23b", "23,000,000,000", "23e9".';m["view.UnitView.BuyN.cantbuy"]="Can't buy";m["view.UnitView.BuyN.buybutton"]="Buy {name}";m["view.UnitView.body.count"]="You own {count} {name}.";m["view.UnitView.body.prodEach"]="Each {name} produces {resources} per second.";m["view.UnitView.body.prodTotal"]="In total, they produce {resources} per second.";m["view.UnitView.body.costeach"]="Each {unitName} costs {cost}.";m["view.UnitView.body.velocity"]="You generate {velocity} {name} per second.";m["view.UnitNav.allunits"]="All units";m["view.StatisticsView.title"]="{displayName}'s statistics";m["view.StatisticsView.production.title"]="Production";m["view.StatisticsView.production.col.name"]="Worker";m["view.StatisticsView.production.col.first"]="First";m["view.StatisticsView.production.col.bought"]="Bought";m["view.StatisticsView.production.col.clicks"]="Buy-Clicks";m["view.StatisticsView.production.col.spent"]="Spent";m["view.StatisticsView.production.col.looted"]="Looted";m["view.StatisticsView.production.col.grown"]="Grown";m["view.StatisticsView.combat.title"]="Combat";m["view.StatisticsView.combat.col.name"]="Soldier";m["view.StatisticsView.combat.col.first"]="First";m["view.StatisticsView.combat.col.produced"]="Produced";m["view.StatisticsView.combat.col.lost"]="Casualties";m["view.StatisticsView.combat.col.killed"]="Kills";m["view.StatisticsView.other.title"]="Other";m["view.StatisticsView.other.created"]="Started at: {val}";m["view.StatisticsView.other.totalclears"]="Zones cleared: {val}";m["view.StatisticsView.other.totalwins"]="Battles won: {val}";m["view.StatisticsView.other.totalfights"]="Battles fought: {val}";m["view.RegisterView.title"]="Register";m["view.RegisterView.description"]="Attach an email and password to the account and characters you're playing now. Registration is strictly optional - feel free to skip this! - but it's the best way to avoid accidental loss of your account and beta code.";m["view.RegisterView.field.email"]="Email address";m["view.RegisterView.field.password"]="Password";m["view.RegisterView.field.password2"]="Confirm password";m["view.RegisterView.submit"]="Register account";m["view.RegisterView.error.anonymous"]="Your account already has an email address.";m["view.RegisterView.error.passwordmatch"]="Passwords must match.";m["view.RegisterView.success"]="Registered successfully.";m["view.RegisterView.privacy"]="Privacy";m["view.LoginView.title"]="Login";//m['view.LoginView.description'] = "Log in to another account."
m["view.LoginView.description"]="Played before? Log in.";m["view.LoginView.field.email"]="Email address";m["view.LoginView.field.password"]="Password";m["view.LoginView.submit"]="Log in";m["view.LoginView.forgot"]="Forgot your password?";m["view.LoginView.success"]="Logged in successfully.";m["view.LoginView.privacy"]="Privacy";m["view.ResetPasswordView.title"]="Reset your password";m["view.ResetPasswordView.description"]="We'll email you a link to set a new password.";m["view.ResetPasswordView.field.email"]="Email address";m["view.ResetPasswordView.submit"]="Reset password";m["view.ResetPasswordView.error.passwordmatch"]="Passwords must match.";m["view.ResetPasswordView.success"]="Password reset email sent.";m["view.ConfirmResetPasswordView.title"]="Reset your password";m["view.ConfirmResetPasswordView.description"]="Enter your new password.";m["view.ConfirmResetPasswordView.field.password"]="Password";m["view.ConfirmResetPasswordView.field.password2"]="Confirm password";m["view.ConfirmResetPasswordView.error.passwordmatch"]="Passwords must match.";m["view.ConfirmResetPasswordView.submit"]="Update password";m["view.ConfirmResetPasswordView.success"]="Your password has been updated.";m["view.BetaKeyCreateView.title"]="Create beta keys";m["view.BetaKeyApplyView.title"]="Join the "+name+" beta";m["view.BetaKeyApplyView.description"]="Applying beta code {betaKey} to your account {userId}.";m["view.BetaKeyApplyView.error.invalid"]="That's not a beta key. Good try!";m["view.BetaKeyApplyView.error.used"]="Too slow! That beta key's taken.";m["view.BetaKeyApplyView.error.alreadyaccess"]="You already have beta access. Shoo.";m["view.BetaKeyApplyView.submit"]="Join the beta";m["view.BetaKeyApplyView.success"]="Welcome to the "+name+" closed beta test!";m["view.TitleView.welcome"]=name+" - closed beta";m["view.TitleView.welcomeback"]="Welcome back, {displayName}.";m["view.TitleView.betawarn"]="War Swarms is in very early beta testing. Things aren't done yet - we'll be adding a lot in the coming weeks, and your feedback is welcome. Thanks for being patient with us.";// TODO support xlations with <p>aragraphs, and rich text in general. That could
// mean a new translation package that allows jsx syntax, but markdown with
// linebreaks would also be sufficient.
m["view.TitleView.desc1"]="The swarm, a race of bug-like aliens, prospered under the rule of the ancient Overminds.";m["view.TitleView.desc2"]="Without warning, the Overminds vanished. Their disappearance shattered the unity of their underlings, and left many smaller, fractured swarms behind. Some swarms now wander leaderless and confused, some let their bloodthirsty instincts run wild, and some vie for power and control over the others.";m["view.TitleView.desc3"]="Grow your fledgling swarm, fight your way back to dominance, and discover what fate befell the Overminds - all with no graphics.";m["view.TitleView.unauthed.play"]="Begin playing";m["view.TitleView.unauthed.login"]="Log in";m["view.TitleView.authed.play"]="Continue playing";m["view.TitleView.authed.logout"]="Log out";m["view.TitleView.authed.register"]="Register an email address";m["view.TitleView.authed.register.help"]="Register now to play from other devices and protect your progress! 100% optional.";m["view.TitleView.betadesc"]=name+" is currently in closed beta testing. You must have a beta invitation code to begin playing. Visit {link} for updates.";m["view.TitleView.version"]="Version: {version}";m["view.TitleView.versions"]="Version: client {clientVersion}, server {serverVersion}";m["view.TitleView.privacy"]="Privacy";m["view.Rankings.title"]="Rankings: {rankName}";m["view.Combat.comingsoon"]="Coming soon";m["flags.logFirebase"]="Show firebase/react-redux-firebase console logs. http://react-redux-firebase.com/docs/api/compose.html#reactreduxfirebase";m["flags.dumpProps"]="Show the props passed to the current view at the bottom of the page. Passwords are masked.";m["flags.logProps"]="Show the props passed to the current view in the console logs. One console.log() per render. Passwords are NOT masked.";m["flags.offline"]="Instead of real Firebase data, use a fixed set of offline data. Most things won't work, but it's good enough for unittests and occasional Internet-free development.";m["flags.stoptime"]="Disable client-side time updates (TICK actions) after reload. Useful for reducing noise while debugging non-time things. Server-side time marches on, so most server interaction will fail.";m["flags.freshdesk"]='Show the Freshdesk "send feedback" widget. Disable while running Lighthouse: they don\'t like each other.';m["flags.isPrereleaseFlags"]="Top-secret unreleased features. Shh.";m["flags.multiSoldierCombat"]="So many more kinds of things to kill.";m["flags.unlockZone6"]="Show new zones.";m["flags.releaseCountdown"]="Show a countdown timer until the next release. Link to a relevant news post.";m["rankings.meat"]="Meat produced";m["rankings.drone"]="Drones produced";m["rankings.queen"]="Queens produced";m["rankings.nest"]="Nests produced";m["rankings.hatchery"]="Hatcheries captured";m["rankings.achievements-count"]="Achievements earned";m["rankings.zones-cleared"]="Zones cleared";m["zone.zone1"]="Zone 1";m["zone.zone1.description"]="This is the first zone! Defeat the foes here to get your first hatchery and expansion.";m["zone.zone1.description.lol"]="You always remember your first";m["zone.zone2"]="Zone two";m["zone.zone2.description"]="You can grind the same zone a few times in a row for a few more hatcheries (there is a limit), but a zone only awards an expansion for your first win.";m["zone.zone2.description.lol"]="No cost for trying new zones, though!";m["zone.zone3"]="Zone three";m["zone.zone3.description"]="Zones aren't infinite. They'll have names and a plot soon. Clearing zones will advance the plot, among other things.";m["zone.zone3.description.lol"]="They'll have real descriptions and real mouseovers too.";m["zone.zone4"]="Zone 4";m["zone.zone4.description"]="You'll get the infinitely-scaling zones you expect from your incremental games later. We're not there quite yet.";m["zone.zone4.description.lol"]="I'm not sure what we'll call them just yet. Greater Rifts is already taken.";m["zone.zone5"]="Zone 5";m["zone.zone5.description"]="This is a fairly short beta right now. There'll be more soon.";m["zone.zone5.description.lol"]="ZOMG, HURRY UP DEV";m["zone.zone6"]="Zone 6";m["zone.zone6.description"]="Look, a shiny new unit!";m["zone.zone6.description.lol"]="shiny shiny shiny";m["zone.zone7"]="Zone 7";m["zone.zone7.description"]="Overlords unlocked! Try building some. They're pretty powerful.";m["zone.zone7.description.lol"]="";m["zone.zone8"]="Zone 8";m["zone.zone8.description"]="Overlord dens and swarmling queens will be going away in a future update, though.";m["zone.zone8.description.lol"]="";m["zone.zone9"]="Zone 9";m["zone.zone9.description"]="There'll be a different way to upgrade your armies pretty soon.";m["zone.zone9.description.lol"]="";m["view.CombatForm.title"]="Combat";m["view.CombatForm.feeding"]="Spending {meat} meat. Your soldiers will be {buff} stronger in this battle.";m["view.CombatForm.zone"]="Zone";m["view.CombatForm.submit"]="Attack";m["view.CombatForm.yourarmy"]="Your army";m["view.CombatForm.nounits"]="Build some swarmling queens before beginning combat.";m["view.CombatForm.expansion"]="You've expanded into {zoneClearText} {zoneClears, plural, one{zone} other{zones}}. Your hatcheries are {hatcheryProdBonus} more productive.";m["view.CombatForm.grinding"]="You've beaten this zone before. Your next {grindCount, plural, one{attack} other{{grindCountText} attacks}} will award loot.";m["view.CombatForm.nogrind"]="You've been attacking a lot recently - your next attack will award no loot. Try attacking a zone you haven't beaten yet!";m["view.CombatForm.grinding.lol"]="Because an idle game that benefits from nonstop clicking would be silly.";m["view.CombatRun.title"]="Combat: {zone}";m["view.CombatRun.soldier.name"]="{count, plural, one{{soldier}} other {{countText} {soldier}}}";m["view.CombatRun.soldier.hp"]="{count, plural, one{{hpText} hp} other{{maxHpText} hp}}{attack, plural, =0{} other{/{attackText} attack}} {count, plural, one{} other{each}}";m["view.CombatResult.win.title"]="Victory!";m["view.CombatResult.win.firststatus"]="Cleared {zone} for the first time! Your hatcheries now produce "+"{hatcheryProdPerZone} more larvae.";m["view.CombatResult.win.status"]="Cleared {zone}";m["view.CombatResult.win.lootitem"]="You gain {count} {unitName}.";m["view.CombatResult.lose.title"]="Defeat!";m["view.CombatResult.lose.status"]="Failed to clear {zone}";m["view.CombatResult.draw.title"]="Draw!";m["view.CombatResult.draw.status"]="Failed to clear {zone}";m["view.ReleaseCountdown.over"]="New release!";m["view.ReleaseCountdown.counting"]="New release in {countdown}";

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.ec3baa39.js